export const tt_grid = [
	[[	/* 661:312 */
		[2259143.19, 8274124.13],
		[2257164.96, 8293662.97],
		[2276701.34, 8295625.29],
		[2278628.85, 8276074.37],
		[2259143.19, 8274124.13],
	]], [[	/* 663:318 */
		[2372873.92, 8324327.69],
		[2371180.58, 8344037.37],
		[2390887.73, 8345712.82],
		[2392529.14, 8325992.73],
		[2372873.92, 8324327.69],
	]], [[	/* 663:319 */
		[2392529.14, 8325992.73],
		[2390887.73, 8345712.82],
		[2410605.18, 8347336.05],
		[2412194.57, 8327605.87],
		[2392529.14, 8325992.73],
	]], [[	/* 663:320 */
		[2412194.57, 8327605.87],
		[2410605.18, 8347336.05],
		[2430332.60, 8348906.95],
		[2431869.87, 8329167.01],
		[2412194.57, 8327605.87],
	]], [[	/* 663:321 */
		[2431869.87, 8329167.01],
		[2430332.60, 8348906.95],
		[2450069.66, 8350425.45],
		[2451554.73, 8330676.07],
		[2431869.87, 8329167.01],
	]], [[	/* 663:322 */
		[2451554.73, 8330676.07],
		[2450069.66, 8350425.45],
		[2469816.04, 8351891.46],
		[2471248.84, 8332132.96],
		[2451554.73, 8330676.07],
	]], [[	/* 663:323 */
		[2471248.84, 8332132.96],
		[2469816.04, 8351891.46],
		[2489571.42, 8353304.91],
		[2490951.86, 8333537.60],
		[2471248.84, 8332132.96],
	]], [[	/* 663:324 */
		[2490951.86, 8333537.60],
		[2489571.42, 8353304.91],
		[2509335.47, 8354665.71],
		[2510663.49, 8334889.93],
		[2490951.86, 8333537.60],
	]], [[	/* 663:325 */
		[2510663.49, 8334889.93],
		[2509335.47, 8354665.71],
		[2529107.87, 8355973.79],
		[2530383.38, 8336189.85],
		[2510663.49, 8334889.93],
	]], [[	/* 663:326 */
		[2530383.38, 8336189.85],
		[2529107.87, 8355973.79],
		[2548888.29, 8357229.07],
		[2550111.23, 8337437.31],
		[2530383.38, 8336189.85],
	]], [[	/* 663:327 */
		[2550111.23, 8337437.31],
		[2548888.29, 8357229.07],
		[2568676.40, 8358431.49],
		[2569846.70, 8338632.24],
		[2550111.23, 8337437.31],
	]], [[	/* 663:328 */
		[2569846.70, 8338632.24],
		[2568676.40, 8358431.49],
		[2588471.88, 8359580.99],
		[2589589.47, 8339774.56],
		[2569846.70, 8338632.24],
	]], [[	/* 663:329 */
		[2589589.47, 8339774.56],
		[2588471.88, 8359580.99],
		[2608274.39, 8360677.49],
		[2609339.22, 8340864.23],
		[2589589.47, 8339774.56],
	]], [[	/* 663:330 */
		[2609339.22, 8340864.23],
		[2608274.39, 8360677.49],
		[2628083.61, 8361720.94],
		[2629095.61, 8341901.16],
		[2609339.22, 8340864.23],
	]], [[	/* 663:331 */
		[2629095.61, 8341901.16],
		[2628083.61, 8361720.94],
		[2647899.20, 8362711.28],
		[2648858.32, 8342885.32],
		[2629095.61, 8341901.16],
	]], [[	/* 664:314 */
		[2292461.21, 8336815.13],
		[2290549.20, 8356531.58],
		[2310263.88, 8358426.79],
		[2312124.02, 8338698.56],
		[2292461.21, 8336815.13],
	]], [[	/* 664:316 */
		[2331798.40, 8340530.14],
		[2329990.22, 8360269.83],
		[2349727.91, 8362060.60],
		[2351484.02, 8342309.78],
		[2331798.40, 8340530.14],
	]], [[	/* 664:317 */
		[2351484.02, 8342309.78],
		[2349727.91, 8362060.60],
		[2369476.62, 8363799.01],
		[2371180.58, 8344037.37],
		[2351484.02, 8342309.78],
	]], [[	/* 664:318 */
		[2371180.58, 8344037.37],
		[2369476.62, 8363799.01],
		[2389236.04, 8365484.96],
		[2390887.73, 8345712.82],
		[2371180.58, 8344037.37],
	]], [[	/* 664:319 */
		[2390887.73, 8345712.82],
		[2389236.04, 8365484.96],
		[2409005.83, 8367118.36],
		[2410605.18, 8347336.05],
		[2390887.73, 8345712.82],
	]], [[	/* 664:320 */
		[2410605.18, 8347336.05],
		[2409005.83, 8367118.36],
		[2428785.68, 8368699.12],
		[2430332.60, 8348906.95],
		[2410605.18, 8347336.05],
	]], [[	/* 664:321 */
		[2430332.60, 8348906.95],
		[2428785.68, 8368699.12],
		[2448575.25, 8370227.14],
		[2450069.66, 8350425.45],
		[2430332.60, 8348906.95],
	]], [[	/* 664:322 */
		[2450069.66, 8350425.45],
		[2448575.25, 8370227.14],
		[2468374.24, 8371702.36],
		[2469816.04, 8351891.46],
		[2450069.66, 8350425.45],
	]], [[	/* 664:323 */
		[2469816.04, 8351891.46],
		[2468374.24, 8371702.36],
		[2488182.30, 8373124.68],
		[2489571.42, 8353304.91],
		[2469816.04, 8351891.46],
	]], [[	/* 664:324 */
		[2489571.42, 8353304.91],
		[2488182.30, 8373124.68],
		[2507999.11, 8374494.03],
		[2509335.47, 8354665.71],
		[2489571.42, 8353304.91],
	]], [[	/* 664:325 */
		[2509335.47, 8354665.71],
		[2507999.11, 8374494.03],
		[2527824.34, 8375810.33],
		[2529107.87, 8355973.79],
		[2509335.47, 8354665.71],
	]], [[	/* 664:326 */
		[2529107.87, 8355973.79],
		[2527824.34, 8375810.33],
		[2547657.66, 8377073.51],
		[2548888.29, 8357229.07],
		[2529107.87, 8355973.79],
	]], [[	/* 664:327 */
		[2548888.29, 8357229.07],
		[2547657.66, 8377073.51],
		[2567498.74, 8378283.49],
		[2568676.40, 8358431.49],
		[2548888.29, 8357229.07],
	]], [[	/* 664:328 */
		[2568676.40, 8358431.49],
		[2567498.74, 8378283.49],
		[2587347.25, 8379440.22],
		[2588471.88, 8359580.99],
		[2568676.40, 8358431.49],
	]], [[	/* 664:329 */
		[2588471.88, 8359580.99],
		[2587347.25, 8379440.22],
		[2607202.86, 8380543.63],
		[2608274.39, 8360677.49],
		[2588471.88, 8359580.99],
	]], [[	/* 664:330 */
		[2608274.39, 8360677.49],
		[2607202.86, 8380543.63],
		[2627065.24, 8381593.65],
		[2628083.61, 8361720.94],
		[2608274.39, 8360677.49],
	]], [[	/* 664:331 */
		[2628083.61, 8361720.94],
		[2627065.24, 8381593.65],
		[2646934.04, 8382590.23],
		[2647899.20, 8362711.28],
		[2628083.61, 8361720.94],
	]], [[	/* 664:332 */
		[2647899.20, 8362711.28],
		[2646934.04, 8382590.23],
		[2666808.94, 8383533.31],
		[2667720.84, 8363648.46],
		[2647899.20, 8362711.28],
	]], [[	/* 664:333 */
		[2667720.84, 8363648.46],
		[2666808.94, 8383533.31],
		[2686689.61, 8384422.84],
		[2687548.18, 8364532.42],
		[2667720.84, 8363648.46],
	]], [[	/* 664:334 */
		[2687548.18, 8364532.42],
		[2686689.61, 8384422.84],
		[2706575.70, 8385258.77],
		[2707380.91, 8365363.11],
		[2687548.18, 8364532.42],
	]], [[	/* 664:335 */
		[2707380.91, 8365363.11],
		[2706575.70, 8385258.77],
		[2726466.88, 8386041.05],
		[2727218.68, 8366140.49],
		[2707380.91, 8365363.11],
	]], [[	/* 665:309 */
		[2192161.84, 8346276.81],
		[2189978.57, 8365981.00],
		[2209681.82, 8368148.88],
		[2211813.46, 8348431.23],
		[2192161.84, 8346276.81],
	]], [[	/* 665:310 */
		[2211813.46, 8348431.23],
		[2209681.82, 8368148.88],
		[2229398.42, 8370264.82],
		[2231478.31, 8350534.03],
		[2211813.46, 8348431.23],
	]], [[	/* 665:311 */
		[2231478.31, 8350534.03],
		[2229398.42, 8370264.82],
		[2249128.06, 8372328.72],
		[2251156.10, 8352585.10],
		[2231478.31, 8350534.03],
	]], [[	/* 665:312 */
		[2251156.10, 8352585.10],
		[2249128.06, 8372328.72],
		[2268870.43, 8374340.46],
		[2270846.50, 8354584.32],
		[2251156.10, 8352585.10],
	]], [[	/* 665:313 */
		[2270846.50, 8354584.32],
		[2268870.43, 8374340.46],
		[2288625.21, 8376299.92],
		[2290549.20, 8356531.58],
		[2270846.50, 8354584.32],
	]], [[	/* 665:314 */
		[2290549.20, 8356531.58],
		[2288625.21, 8376299.92],
		[2308392.07, 8378207.00],
		[2310263.88, 8358426.79],
		[2290549.20, 8356531.58],
	]], [[	/* 665:315 */
		[2310263.88, 8358426.79],
		[2308392.07, 8378207.00],
		[2328170.70, 8380061.59],
		[2329990.22, 8360269.83],
		[2310263.88, 8358426.79],
	]], [[	/* 665:316 */
		[2329990.22, 8360269.83],
		[2328170.70, 8380061.59],
		[2347960.77, 8381863.60],
		[2349727.91, 8362060.60],
		[2329990.22, 8360269.83],
	]], [[	/* 665:317 */
		[2349727.91, 8362060.60],
		[2347960.77, 8381863.60],
		[2367761.97, 8383612.93],
		[2369476.62, 8363799.01],
		[2349727.91, 8362060.60],
	]], [[	/* 665:318 */
		[2369476.62, 8363799.01],
		[2367761.97, 8383612.93],
		[2387573.96, 8385309.47],
		[2389236.04, 8365484.96],
		[2369476.62, 8363799.01],
	]], [[	/* 665:319 */
		[2389236.04, 8365484.96],
		[2387573.96, 8385309.47],
		[2407396.42, 8386953.13],
		[2409005.83, 8367118.36],
		[2389236.04, 8365484.96],
	]], [[	/* 665:320 */
		[2409005.83, 8367118.36],
		[2407396.42, 8386953.13],
		[2427229.03, 8388543.83],
		[2428785.68, 8368699.12],
		[2409005.83, 8367118.36],
	]], [[	/* 665:321 */
		[2428785.68, 8368699.12],
		[2427229.03, 8388543.83],
		[2447071.45, 8390081.47],
		[2448575.25, 8370227.14],
		[2428785.68, 8368699.12],
	]], [[	/* 665:322 */
		[2448575.25, 8370227.14],
		[2447071.45, 8390081.47],
		[2466923.36, 8391565.97],
		[2468374.24, 8371702.36],
		[2448575.25, 8370227.14],
	]], [[	/* 665:323 */
		[2468374.24, 8371702.36],
		[2466923.36, 8391565.97],
		[2486784.43, 8392997.24],
		[2488182.30, 8373124.68],
		[2468374.24, 8371702.36],
	]], [[	/* 665:324 */
		[2488182.30, 8373124.68],
		[2486784.43, 8392997.24],
		[2506654.32, 8394375.22],
		[2507999.11, 8374494.03],
		[2488182.30, 8373124.68],
	]], [[	/* 665:325 */
		[2507999.11, 8374494.03],
		[2506654.32, 8394375.22],
		[2526532.71, 8395699.81],
		[2527824.34, 8375810.33],
		[2507999.11, 8374494.03],
	]], [[	/* 665:326 */
		[2527824.34, 8375810.33],
		[2526532.71, 8395699.81],
		[2546419.26, 8396970.95],
		[2547657.66, 8377073.51],
		[2527824.34, 8375810.33],
	]], [[	/* 665:327 */
		[2547657.66, 8377073.51],
		[2546419.26, 8396970.95],
		[2566313.65, 8398188.57],
		[2567498.74, 8378283.49],
		[2547657.66, 8377073.51],
	]], [[	/* 665:328 */
		[2567498.74, 8378283.49],
		[2566313.65, 8398188.57],
		[2586215.53, 8399352.60],
		[2587347.25, 8379440.22],
		[2567498.74, 8378283.49],
	]], [[	/* 665:329 */
		[2587347.25, 8379440.22],
		[2586215.53, 8399352.60],
		[2606124.57, 8400462.97],
		[2607202.86, 8380543.63],
		[2587347.25, 8379440.22],
	]], [[	/* 665:330 */
		[2607202.86, 8380543.63],
		[2606124.57, 8400462.97],
		[2626040.43, 8401519.62],
		[2627065.24, 8381593.65],
		[2607202.86, 8380543.63],
	]], [[	/* 665:331 */
		[2627065.24, 8381593.65],
		[2626040.43, 8401519.62],
		[2645962.78, 8402522.49],
		[2646934.04, 8382590.23],
		[2627065.24, 8381593.65],
	]], [[	/* 665:332 */
		[2646934.04, 8382590.23],
		[2645962.78, 8402522.49],
		[2665891.29, 8403471.53],
		[2666808.94, 8383533.31],
		[2646934.04, 8382590.23],
	]], [[	/* 665:333 */
		[2666808.94, 8383533.31],
		[2665891.29, 8403471.53],
		[2685825.60, 8404366.68],
		[2686689.61, 8384422.84],
		[2666808.94, 8383533.31],
	]], [[	/* 665:334 */
		[2686689.61, 8384422.84],
		[2685825.60, 8404366.68],
		[2705765.40, 8405207.89],
		[2706575.70, 8385258.77],
		[2686689.61, 8384422.84],
	]], [[	/* 665:335 */
		[2706575.70, 8385258.77],
		[2705765.40, 8405207.89],
		[2725710.32, 8405995.12],
		[2726466.88, 8386041.05],
		[2706575.70, 8385258.77],
	]], [[	/* 665:336 */
		[2726466.88, 8386041.05],
		[2725710.32, 8405995.12],
		[2745660.05, 8406728.32],
		[2746362.81, 8386769.65],
		[2726466.88, 8386041.05],
	]], [[	/* 665:337 */
		[2746362.81, 8386769.65],
		[2745660.05, 8406728.32],
		[2765614.23, 8407407.45],
		[2766263.17, 8387444.51],
		[2746362.81, 8386769.65],
	]], [[	/* 665:338 */
		[2766263.17, 8387444.51],
		[2765614.23, 8407407.45],
		[2785572.53, 8408032.47],
		[2786167.60, 8388065.60],
		[2766263.17, 8387444.51],
	]], [[	/* 665:343 */
		[2865819.36, 8390011.64],
		[2865440.05, 8409990.83],
		[2885413.80, 8410344.84],
		[2885739.11, 8390363.43],
		[2865819.36, 8390011.64],
	]], [[	/* 666:310 */
		[2209681.82, 8368148.88],
		[2207536.82, 8387918.28],
		[2227305.48, 8390047.48],
		[2229398.42, 8370264.82],
		[2209681.82, 8368148.88],
	]], [[	/* 666:311 */
		[2229398.42, 8370264.82],
		[2227305.48, 8390047.48],
		[2247087.30, 8392124.33],
		[2249128.06, 8372328.72],
		[2229398.42, 8370264.82],
	]], [[	/* 666:312 */
		[2249128.06, 8372328.72],
		[2247087.30, 8392124.33],
		[2266881.96, 8394148.68],
		[2268870.43, 8374340.46],
		[2249128.06, 8372328.72],
	]], [[	/* 666:313 */
		[2268870.43, 8374340.46],
		[2266881.96, 8394148.68],
		[2286689.13, 8396120.45],
		[2288625.21, 8376299.92],
		[2268870.43, 8374340.46],
	]], [[	/* 666:314 */
		[2288625.21, 8376299.92],
		[2286689.13, 8396120.45],
		[2306508.50, 8398039.51],
		[2308392.07, 8378207.00],
		[2288625.21, 8376299.92],
	]], [[	/* 666:315 */
		[2308392.07, 8378207.00],
		[2306508.50, 8398039.51],
		[2326339.73, 8399905.77],
		[2328170.70, 8380061.59],
		[2308392.07, 8378207.00],
	]], [[	/* 666:316 */
		[2328170.70, 8380061.59],
		[2326339.73, 8399905.77],
		[2346182.52, 8401719.11],
		[2347960.77, 8381863.60],
		[2328170.70, 8380061.59],
	]], [[	/* 666:317 */
		[2347960.77, 8381863.60],
		[2346182.52, 8401719.11],
		[2366036.52, 8403479.45],
		[2367761.97, 8383612.93],
		[2347960.77, 8381863.60],
	]], [[	/* 666:318 */
		[2367761.97, 8383612.93],
		[2366036.52, 8403479.45],
		[2385901.41, 8405186.67],
		[2387573.96, 8385309.47],
		[2367761.97, 8383612.93],
	]], [[	/* 666:319 */
		[2387573.96, 8385309.47],
		[2385901.41, 8405186.67],
		[2405776.87, 8406840.69],
		[2407396.42, 8386953.13],
		[2387573.96, 8385309.47],
	]], [[	/* 666:320 */
		[2407396.42, 8386953.13],
		[2405776.87, 8406840.69],
		[2425662.56, 8408441.41],
		[2427229.03, 8388543.83],
		[2407396.42, 8386953.13],
	]], [[	/* 666:321 */
		[2427229.03, 8388543.83],
		[2425662.56, 8408441.41],
		[2445558.15, 8409988.75],
		[2447071.45, 8390081.47],
		[2427229.03, 8388543.83],
	]], [[	/* 666:322 */
		[2447071.45, 8390081.47],
		[2445558.15, 8409988.75],
		[2465463.32, 8411482.62],
		[2466923.36, 8391565.97],
		[2447071.45, 8390081.47],
	]], [[	/* 666:323 */
		[2466923.36, 8391565.97],
		[2465463.32, 8411482.62],
		[2485377.73, 8412922.93],
		[2486784.43, 8392997.24],
		[2466923.36, 8391565.97],
	]], [[	/* 666:324 */
		[2486784.43, 8392997.24],
		[2485377.73, 8412922.93],
		[2505301.04, 8414309.60],
		[2506654.32, 8394375.22],
		[2486784.43, 8392997.24],
	]], [[	/* 666:325 */
		[2506654.32, 8394375.22],
		[2505301.04, 8414309.60],
		[2525232.92, 8415642.57],
		[2526532.71, 8395699.81],
		[2506654.32, 8394375.22],
	]], [[	/* 666:326 */
		[2526532.71, 8395699.81],
		[2525232.92, 8415642.57],
		[2545173.04, 8416921.74],
		[2546419.26, 8396970.95],
		[2526532.71, 8395699.81],
	]], [[	/* 666:327 */
		[2546419.26, 8396970.95],
		[2545173.04, 8416921.74],
		[2565121.06, 8418147.06],
		[2566313.65, 8398188.57],
		[2546419.26, 8396970.95],
	]], [[	/* 666:328 */
		[2566313.65, 8398188.57],
		[2565121.06, 8418147.06],
		[2585076.64, 8419318.45],
		[2586215.53, 8399352.60],
		[2566313.65, 8398188.57],
	]], [[	/* 666:329 */
		[2586215.53, 8399352.60],
		[2585076.64, 8419318.45],
		[2605039.45, 8420435.84],
		[2606124.57, 8400462.97],
		[2586215.53, 8399352.60],
	]], [[	/* 666:330 */
		[2606124.57, 8400462.97],
		[2605039.45, 8420435.84],
		[2625009.14, 8421499.18],
		[2626040.43, 8401519.62],
		[2606124.57, 8400462.97],
	]], [[	/* 666:331 */
		[2626040.43, 8401519.62],
		[2625009.14, 8421499.18],
		[2644985.37, 8422508.40],
		[2645962.78, 8402522.49],
		[2626040.43, 8401519.62],
	]], [[	/* 666:332 */
		[2645962.78, 8402522.49],
		[2644985.37, 8422508.40],
		[2664967.82, 8423463.45],
		[2665891.29, 8403471.53],
		[2645962.78, 8402522.49],
	]], [[	/* 666:333 */
		[2665891.29, 8403471.53],
		[2664967.82, 8423463.45],
		[2684956.13, 8424364.27],
		[2685825.60, 8404366.68],
		[2665891.29, 8403471.53],
	]], [[	/* 666:334 */
		[2685825.60, 8404366.68],
		[2684956.13, 8424364.27],
		[2704949.96, 8425210.82],
		[2705765.40, 8405207.89],
		[2685825.60, 8404366.68],
	]], [[	/* 666:335 */
		[2705765.40, 8405207.89],
		[2704949.96, 8425210.82],
		[2724948.97, 8426003.04],
		[2725710.32, 8405995.12],
		[2705765.40, 8405207.89],
	]], [[	/* 666:336 */
		[2725710.32, 8405995.12],
		[2724948.97, 8426003.04],
		[2744952.83, 8426740.88],
		[2745660.05, 8406728.32],
		[2725710.32, 8405995.12],
	]], [[	/* 666:337 */
		[2745660.05, 8406728.32],
		[2744952.83, 8426740.88],
		[2764961.18, 8427424.32],
		[2765614.23, 8407407.45],
		[2745660.05, 8406728.32],
	]], [[	/* 666:338 */
		[2765614.23, 8407407.45],
		[2764961.18, 8427424.32],
		[2784973.68, 8428053.31],
		[2785572.53, 8408032.47],
		[2765614.23, 8407407.45],
	]], [[	/* 666:339 */
		[2785572.53, 8408032.47],
		[2784973.68, 8428053.31],
		[2804989.99, 8428627.81],
		[2805534.60, 8408603.35],
		[2785572.53, 8408032.47],
	]], [[	/* 666:340 */
		[2805534.60, 8408603.35],
		[2804989.99, 8428627.81],
		[2825009.77, 8429147.79],
		[2825500.11, 8409120.06],
		[2805534.60, 8408603.35],
	]], [[	/* 666:341 */
		[2825500.11, 8409120.06],
		[2825009.77, 8429147.79],
		[2845032.67, 8429613.22],
		[2845468.70, 8409582.56],
		[2825500.11, 8409120.06],
	]], [[	/* 666:342 */
		[2845468.70, 8409582.56],
		[2845032.67, 8429613.22],
		[2865058.34, 8430024.08],
		[2865440.05, 8409990.83],
		[2845468.70, 8409582.56],
	]], [[	/* 666:343 */
		[2865440.05, 8409990.83],
		[2865058.34, 8430024.08],
		[2885086.43, 8430380.35],
		[2885413.80, 8410344.84],
		[2865440.05, 8409990.83],
	]], [[	/* 667:310 */
		[2207536.82, 8387918.28],
		[2205378.34, 8407739.75],
		[2225199.39, 8409882.33],
		[2227305.48, 8390047.48],
		[2207536.82, 8387918.28],
	]], [[	/* 667:311 */
		[2227305.48, 8390047.48],
		[2225199.39, 8409882.33],
		[2245033.70, 8411972.23],
		[2247087.30, 8392124.33],
		[2227305.48, 8390047.48],
	]], [[	/* 667:312 */
		[2247087.30, 8392124.33],
		[2245033.70, 8411972.23],
		[2264880.97, 8414009.33],
		[2266881.96, 8394148.68],
		[2247087.30, 8392124.33],
	]], [[	/* 667:313 */
		[2266881.96, 8394148.68],
		[2264880.97, 8414009.33],
		[2284740.86, 8415993.50],
		[2286689.13, 8396120.45],
		[2266881.96, 8394148.68],
	]], [[	/* 667:314 */
		[2286689.13, 8396120.45],
		[2284740.86, 8415993.50],
		[2304613.05, 8417924.66],
		[2306508.50, 8398039.51],
		[2286689.13, 8396120.45],
	]], [[	/* 667:315 */
		[2306508.50, 8398039.51],
		[2304613.05, 8417924.66],
		[2324497.22, 8419802.67],
		[2326339.73, 8399905.77],
		[2306508.50, 8398039.51],
	]], [[	/* 667:316 */
		[2326339.73, 8399905.77],
		[2324497.22, 8419802.67],
		[2344393.04, 8421627.45],
		[2346182.52, 8401719.11],
		[2326339.73, 8399905.77],
	]], [[	/* 667:317 */
		[2346182.52, 8401719.11],
		[2344393.04, 8421627.45],
		[2364300.18, 8423398.89],
		[2366036.52, 8403479.45],
		[2346182.52, 8401719.11],
	]], [[	/* 667:318 */
		[2366036.52, 8403479.45],
		[2364300.18, 8423398.89],
		[2384218.30, 8425116.90],
		[2385901.41, 8405186.67],
		[2366036.52, 8403479.45],
	]], [[	/* 667:319 */
		[2385901.41, 8405186.67],
		[2384218.30, 8425116.90],
		[2404147.08, 8426781.36],
		[2405776.87, 8406840.69],
		[2385901.41, 8405186.67],
	]], [[	/* 667:320 */
		[2405776.87, 8406840.69],
		[2404147.08, 8426781.36],
		[2424086.19, 8428392.20],
		[2425662.56, 8408441.41],
		[2405776.87, 8406840.69],
	]], [[	/* 667:321 */
		[2425662.56, 8408441.41],
		[2424086.19, 8428392.20],
		[2444035.29, 8429949.32],
		[2445558.15, 8409988.75],
		[2425662.56, 8408441.41],
	]], [[	/* 667:322 */
		[2445558.15, 8409988.75],
		[2444035.29, 8429949.32],
		[2463994.05, 8431452.64],
		[2465463.32, 8411482.62],
		[2445558.15, 8409988.75],
	]], [[	/* 667:323 */
		[2465463.32, 8411482.62],
		[2463994.05, 8431452.64],
		[2483962.12, 8432902.07],
		[2485377.73, 8412922.93],
		[2465463.32, 8411482.62],
	]], [[	/* 667:324 */
		[2485377.73, 8412922.93],
		[2483962.12, 8432902.07],
		[2503939.19, 8434297.52],
		[2505301.04, 8414309.60],
		[2485377.73, 8412922.93],
	]], [[	/* 667:325 */
		[2505301.04, 8414309.60],
		[2503939.19, 8434297.52],
		[2523924.90, 8435638.93],
		[2525232.92, 8415642.57],
		[2505301.04, 8414309.60],
	]], [[	/* 667:326 */
		[2525232.92, 8415642.57],
		[2523924.90, 8435638.93],
		[2543918.92, 8436926.21],
		[2545173.04, 8416921.74],
		[2525232.92, 8415642.57],
	]], [[	/* 667:327 */
		[2545173.04, 8416921.74],
		[2543918.92, 8436926.21],
		[2563920.91, 8438159.29],
		[2565121.06, 8418147.06],
		[2545173.04, 8416921.74],
	]], [[	/* 667:328 */
		[2565121.06, 8418147.06],
		[2563920.91, 8438159.29],
		[2583930.53, 8439338.11],
		[2585076.64, 8419318.45],
		[2565121.06, 8418147.06],
	]], [[	/* 667:329 */
		[2585076.64, 8419318.45],
		[2583930.53, 8439338.11],
		[2603947.44, 8440462.59],
		[2605039.45, 8420435.84],
		[2585076.64, 8419318.45],
	]], [[	/* 667:330 */
		[2605039.45, 8420435.84],
		[2603947.44, 8440462.59],
		[2623971.30, 8441532.68],
		[2625009.14, 8421499.18],
		[2605039.45, 8420435.84],
	]], [[	/* 667:331 */
		[2625009.14, 8421499.18],
		[2623971.30, 8441532.68],
		[2644001.76, 8442548.31],
		[2644985.37, 8422508.40],
		[2625009.14, 8421499.18],
	]], [[	/* 667:332 */
		[2644985.37, 8422508.40],
		[2644001.76, 8442548.31],
		[2664038.48, 8443509.42],
		[2664967.82, 8423463.45],
		[2644985.37, 8422508.40],
	]], [[	/* 667:333 */
		[2664967.82, 8423463.45],
		[2664038.48, 8443509.42],
		[2684081.12, 8444415.96],
		[2684956.13, 8424364.27],
		[2664967.82, 8423463.45],
	]], [[	/* 667:334 */
		[2684956.13, 8424364.27],
		[2684081.12, 8444415.96],
		[2704129.34, 8445267.89],
		[2704949.96, 8425210.82],
		[2684956.13, 8424364.27],
	]], [[	/* 667:335 */
		[2704949.96, 8425210.82],
		[2704129.34, 8445267.89],
		[2724182.78, 8446065.14],
		[2724948.97, 8426003.04],
		[2704949.96, 8425210.82],
	]], [[	/* 667:336 */
		[2724948.97, 8426003.04],
		[2724182.78, 8446065.14],
		[2744241.11, 8446807.68],
		[2744952.83, 8426740.88],
		[2724948.97, 8426003.04],
	]], [[	/* 667:337 */
		[2744952.83, 8426740.88],
		[2744241.11, 8446807.68],
		[2764303.97, 8447495.46],
		[2764961.18, 8427424.32],
		[2744952.83, 8426740.88],
	]], [[	/* 667:338 */
		[2764961.18, 8427424.32],
		[2764303.97, 8447495.46],
		[2784371.03, 8448128.44],
		[2784973.68, 8428053.31],
		[2764961.18, 8427424.32],
	]], [[	/* 667:339 */
		[2784973.68, 8428053.31],
		[2784371.03, 8448128.44],
		[2804441.92, 8448706.60],
		[2804989.99, 8428627.81],
		[2784973.68, 8428053.31],
	]], [[	/* 667:340 */
		[2804989.99, 8428627.81],
		[2804441.92, 8448706.60],
		[2824516.32, 8449229.89],
		[2825009.77, 8429147.79],
		[2804989.99, 8428627.81],
	]], [[	/* 667:341 */
		[2825009.77, 8429147.79],
		[2824516.32, 8449229.89],
		[2844593.85, 8449698.28],
		[2845032.67, 8429613.22],
		[2825009.77, 8429147.79],
	]], [[	/* 667:342 */
		[2845032.67, 8429613.22],
		[2844593.85, 8449698.28],
		[2864674.19, 8450111.76],
		[2865058.34, 8430024.08],
		[2845032.67, 8429613.22],
	]], [[	/* 667:343 */
		[2865058.34, 8430024.08],
		[2864674.19, 8450111.76],
		[2884756.98, 8450470.29],
		[2885086.43, 8430380.35],
		[2865058.34, 8430024.08],
	]], [[	/* 667:344 */
		[2885086.43, 8430380.35],
		[2884756.98, 8450470.29],
		[2904841.87, 8450773.85],
		[2905116.62, 8430681.99],
		[2885086.43, 8430380.35],
	]], [[	/* 667:345 */
		[2905116.62, 8430681.99],
		[2904841.87, 8450773.85],
		[2924928.52, 8451022.43],
		[2925148.54, 8430929.00],
		[2905116.62, 8430681.99],
	]], [[	/* 667:346 */
		[2925148.54, 8430929.00],
		[2924928.52, 8451022.43],
		[2945016.57, 8451216.02],
		[2945181.85, 8431121.36],
		[2925148.54, 8430929.00],
	]], [[	/* 668:309 */
		[2185570.90, 8405544.59],
		[2183346.25, 8425404.63],
		[2203206.27, 8427613.60],
		[2205378.34, 8407739.75],
		[2185570.90, 8405544.59],
	]], [[	/* 668:310 */
		[2205378.34, 8407739.75],
		[2203206.27, 8427613.60],
		[2223080.02, 8429769.69],
		[2225199.39, 8409882.33],
		[2205378.34, 8407739.75],
	]], [[	/* 668:311 */
		[2225199.39, 8409882.33],
		[2223080.02, 8429769.69],
		[2242967.15, 8431872.76],
		[2245033.70, 8411972.23],
		[2225199.39, 8409882.33],
	]], [[	/* 668:312 */
		[2245033.70, 8411972.23],
		[2242967.15, 8431872.76],
		[2262867.35, 8433922.70],
		[2264880.97, 8414009.33],
		[2245033.70, 8411972.23],
	]], [[	/* 668:313 */
		[2264880.97, 8414009.33],
		[2262867.35, 8433922.70],
		[2282780.28, 8435919.40],
		[2284740.86, 8415993.50],
		[2264880.97, 8414009.33],
	]], [[	/* 668:314 */
		[2284740.86, 8415993.50],
		[2282780.28, 8435919.40],
		[2302705.63, 8437862.75],
		[2304613.05, 8417924.66],
		[2284740.86, 8415993.50],
	]], [[	/* 668:315 */
		[2304613.05, 8417924.66],
		[2302705.63, 8437862.75],
		[2322643.06, 8439752.63],
		[2324497.22, 8419802.67],
		[2304613.05, 8417924.66],
	]], [[	/* 668:316 */
		[2324497.22, 8419802.67],
		[2322643.06, 8439752.63],
		[2342592.24, 8441588.95],
		[2344393.04, 8421627.45],
		[2324497.22, 8419802.67],
	]], [[	/* 668:317 */
		[2344393.04, 8421627.45],
		[2342592.24, 8441588.95],
		[2362552.84, 8443371.60],
		[2364300.18, 8423398.89],
		[2344393.04, 8421627.45],
	]], [[	/* 668:318 */
		[2364300.18, 8423398.89],
		[2362552.84, 8443371.60],
		[2382524.53, 8445100.47],
		[2384218.30, 8425116.90],
		[2364300.18, 8423398.89],
	]], [[	/* 668:319 */
		[2384218.30, 8425116.90],
		[2382524.53, 8445100.47],
		[2402506.97, 8446775.48],
		[2404147.08, 8426781.36],
		[2384218.30, 8425116.90],
	]], [[	/* 668:320 */
		[2404147.08, 8426781.36],
		[2402506.97, 8446775.48],
		[2422499.83, 8448396.53],
		[2424086.19, 8428392.20],
		[2404147.08, 8426781.36],
	]], [[	/* 668:321 */
		[2424086.19, 8428392.20],
		[2422499.83, 8448396.53],
		[2442502.77, 8449963.52],
		[2444035.29, 8429949.32],
		[2424086.19, 8428392.20],
	]], [[	/* 668:322 */
		[2444035.29, 8429949.32],
		[2442502.77, 8449963.52],
		[2462515.45, 8451476.37],
		[2463994.05, 8431452.64],
		[2444035.29, 8429949.32],
	]], [[	/* 668:323 */
		[2463994.05, 8431452.64],
		[2462515.45, 8451476.37],
		[2482537.53, 8452934.99],
		[2483962.12, 8432902.07],
		[2463994.05, 8431452.64],
	]], [[	/* 668:324 */
		[2483962.12, 8432902.07],
		[2482537.53, 8452934.99],
		[2502568.69, 8454339.31],
		[2503939.19, 8434297.52],
		[2483962.12, 8432902.07],
	]], [[	/* 668:325 */
		[2503939.19, 8434297.52],
		[2502568.69, 8454339.31],
		[2522608.56, 8455689.23],
		[2523924.90, 8435638.93],
		[2503939.19, 8434297.52],
	]], [[	/* 668:326 */
		[2523924.90, 8435638.93],
		[2522608.56, 8455689.23],
		[2542656.83, 8456984.69],
		[2543918.92, 8436926.21],
		[2523924.90, 8435638.93],
	]], [[	/* 668:327 */
		[2543918.92, 8436926.21],
		[2542656.83, 8456984.69],
		[2562713.13, 8458225.61],
		[2563920.91, 8438159.29],
		[2543918.92, 8436926.21],
	]], [[	/* 668:328 */
		[2563920.91, 8438159.29],
		[2562713.13, 8458225.61],
		[2582777.13, 8459411.92],
		[2583930.53, 8439338.11],
		[2563920.91, 8438159.29],
	]], [[	/* 668:329 */
		[2583930.53, 8439338.11],
		[2582777.13, 8459411.92],
		[2602848.49, 8460543.56],
		[2603947.44, 8440462.59],
		[2583930.53, 8439338.11],
	]], [[	/* 668:330 */
		[2603947.44, 8440462.59],
		[2602848.49, 8460543.56],
		[2622926.85, 8461620.45],
		[2623971.30, 8441532.68],
		[2603947.44, 8440462.59],
	]], [[	/* 668:331 */
		[2623971.30, 8441532.68],
		[2622926.85, 8461620.45],
		[2643011.88, 8462642.54],
		[2644001.76, 8442548.31],
		[2623971.30, 8441532.68],
	]], [[	/* 668:332 */
		[2644001.76, 8442548.31],
		[2643011.88, 8462642.54],
		[2663103.23, 8463609.78],
		[2664038.48, 8443509.42],
		[2644001.76, 8442548.31],
	]], [[	/* 668:333 */
		[2664038.48, 8443509.42],
		[2663103.23, 8463609.78],
		[2683200.55, 8464522.09],
		[2684081.12, 8444415.96],
		[2664038.48, 8443509.42],
	]], [[	/* 668:334 */
		[2684081.12, 8444415.96],
		[2683200.55, 8464522.09],
		[2703303.49, 8465379.44],
		[2704129.34, 8445267.89],
		[2684081.12, 8444415.96],
	]], [[	/* 668:335 */
		[2704129.34, 8445267.89],
		[2703303.49, 8465379.44],
		[2723411.71, 8466181.77],
		[2724182.78, 8446065.14],
		[2704129.34, 8445267.89],
	]], [[	/* 668:336 */
		[2724182.78, 8446065.14],
		[2723411.71, 8466181.77],
		[2743524.86, 8466929.04],
		[2744241.11, 8446807.68],
		[2724182.78, 8446065.14],
	]], [[	/* 668:337 */
		[2744241.11, 8446807.68],
		[2743524.86, 8466929.04],
		[2763642.58, 8467621.21],
		[2764303.97, 8447495.46],
		[2744241.11, 8446807.68],
	]], [[	/* 668:338 */
		[2764303.97, 8447495.46],
		[2763642.58, 8467621.21],
		[2783764.53, 8468258.23],
		[2784371.03, 8448128.44],
		[2764303.97, 8447495.46],
	]], [[	/* 668:339 */
		[2784371.03, 8448128.44],
		[2783764.53, 8468258.23],
		[2803890.36, 8468840.07],
		[2804441.92, 8448706.60],
		[2784371.03, 8448128.44],
	]], [[	/* 668:340 */
		[2804441.92, 8448706.60],
		[2803890.36, 8468840.07],
		[2824019.71, 8469366.70],
		[2824516.32, 8449229.89],
		[2804441.92, 8448706.60],
	]], [[	/* 668:341 */
		[2824516.32, 8449229.89],
		[2824019.71, 8469366.70],
		[2844152.24, 8469838.08],
		[2844593.85, 8449698.28],
		[2824516.32, 8449229.89],
	]], [[	/* 668:342 */
		[2844593.85, 8449698.28],
		[2844152.24, 8469838.08],
		[2864287.60, 8470254.19],
		[2864674.19, 8450111.76],
		[2844593.85, 8449698.28],
	]], [[	/* 668:343 */
		[2864674.19, 8450111.76],
		[2864287.60, 8470254.19],
		[2884425.43, 8470615.01],
		[2884756.98, 8450470.29],
		[2864674.19, 8450111.76],
	]], [[	/* 668:344 */
		[2884756.98, 8450470.29],
		[2884425.43, 8470615.01],
		[2904565.38, 8470920.51],
		[2904841.87, 8450773.85],
		[2884756.98, 8450470.29],
	]], [[	/* 668:345 */
		[2904841.87, 8450773.85],
		[2904565.38, 8470920.51],
		[2924707.09, 8471170.68],
		[2924928.52, 8451022.43],
		[2904841.87, 8450773.85],
	]], [[	/* 668:346 */
		[2924928.52, 8451022.43],
		[2924707.09, 8471170.68],
		[2944850.23, 8471365.50],
		[2945016.57, 8451216.02],
		[2924928.52, 8451022.43],
	]], [[	/* 668:347 */
		[2945016.57, 8451216.02],
		[2944850.23, 8471365.50],
		[2964994.43, 8471504.96],
		[2965105.67, 8451354.59],
		[2945016.57, 8451216.02],
	]], [[	/* 668:348 */
		[2965105.67, 8451354.59],
		[2964994.43, 8471504.96],
		[2985139.34, 8471589.05],
		[2985195.47, 8451438.16],
		[2965105.67, 8451354.59],
	]], [[	/* 668:349 */
		[2985195.47, 8451438.16],
		[2985139.34, 8471589.05],
		[3005284.60, 8471617.78],
		[3005285.64, 8451466.70],
		[2985195.47, 8451438.16],
	]], [[	/* 668:350 */
		[3005285.64, 8451466.70],
		[3005284.60, 8471617.78],
		[3025429.88, 8471591.13],
		[3025375.81, 8451440.22],
		[3005285.64, 8451466.70],
	]], [[	/* 668:351 */
		[3025375.81, 8451440.22],
		[3025429.88, 8471591.13],
		[3045574.81, 8471509.11],
		[3045465.63, 8451358.72],
		[3025375.81, 8451440.22],
	]], [[	/* 668:352 */
		[3045465.63, 8451358.72],
		[3045574.81, 8471509.11],
		[3065719.03, 8471371.72],
		[3065554.76, 8451222.20],
		[3045465.63, 8451358.72],
	]], [[	/* 668:353 */
		[3065554.76, 8451222.20],
		[3065719.03, 8471371.72],
		[3085862.21, 8471178.97],
		[3085642.85, 8451030.68],
		[3065554.76, 8451222.20],
	]], [[	/* 669:307 */
		[2143668.62, 8420828.50],
		[2141324.51, 8440712.28],
		[2161208.79, 8443041.25],
		[2163500.26, 8423142.89],
		[2143668.62, 8420828.50],
	]], [[	/* 669:308 */
		[2163500.26, 8423142.89],
		[2161208.79, 8443041.25],
		[2181107.56, 8445317.26],
		[2183346.25, 8425404.63],
		[2163500.26, 8423142.89],
	]], [[	/* 669:309 */
		[2183346.25, 8425404.63],
		[2181107.56, 8445317.26],
		[2201020.49, 8447540.17],
		[2203206.27, 8427613.60],
		[2183346.25, 8425404.63],
	]], [[	/* 669:310 */
		[2203206.27, 8427613.60],
		[2201020.49, 8447540.17],
		[2220947.26, 8449709.87],
		[2223080.02, 8429769.69],
		[2203206.27, 8427613.60],
	]], [[	/* 669:311 */
		[2223080.02, 8429769.69],
		[2220947.26, 8449709.87],
		[2240887.53, 8451826.23],
		[2242967.15, 8431872.76],
		[2223080.02, 8429769.69],
	]], [[	/* 669:312 */
		[2242967.15, 8431872.76],
		[2240887.53, 8451826.23],
		[2260840.99, 8453889.14],
		[2262867.35, 8433922.70],
		[2242967.15, 8431872.76],
	]], [[	/* 669:313 */
		[2262867.35, 8433922.70],
		[2260840.99, 8453889.14],
		[2280807.30, 8455898.47],
		[2282780.28, 8435919.40],
		[2262867.35, 8433922.70],
	]], [[	/* 669:314 */
		[2282780.28, 8435919.40],
		[2280807.30, 8455898.47],
		[2300786.13, 8457854.12],
		[2302705.63, 8437862.75],
		[2282780.28, 8435919.40],
	]], [[	/* 669:315 */
		[2302705.63, 8437862.75],
		[2300786.13, 8457854.12],
		[2320777.15, 8459755.98],
		[2322643.06, 8439752.63],
		[2302705.63, 8437862.75],
	]], [[	/* 669:316 */
		[2322643.06, 8439752.63],
		[2320777.15, 8459755.98],
		[2340780.03, 8461603.94],
		[2342592.24, 8441588.95],
		[2322643.06, 8439752.63],
	]], [[	/* 669:317 */
		[2342592.24, 8441588.95],
		[2340780.03, 8461603.94],
		[2360794.42, 8463397.89],
		[2362552.84, 8443371.60],
		[2342592.24, 8441588.95],
	]], [[	/* 669:318 */
		[2362552.84, 8443371.60],
		[2360794.42, 8463397.89],
		[2380820.01, 8465137.74],
		[2382524.53, 8445100.47],
		[2362552.84, 8443371.60],
	]], [[	/* 669:319 */
		[2382524.53, 8445100.47],
		[2380820.01, 8465137.74],
		[2400856.44, 8466823.38],
		[2402506.97, 8446775.48],
		[2382524.53, 8445100.47],
	]], [[	/* 669:320 */
		[2402506.97, 8446775.48],
		[2400856.44, 8466823.38],
		[2420903.38, 8468454.72],
		[2422499.83, 8448396.53],
		[2402506.97, 8446775.48],
	]], [[	/* 669:321 */
		[2422499.83, 8448396.53],
		[2420903.38, 8468454.72],
		[2440960.50, 8470031.67],
		[2442502.77, 8449963.52],
		[2422499.83, 8448396.53],
	]], [[	/* 669:322 */
		[2442502.77, 8449963.52],
		[2440960.50, 8470031.67],
		[2461027.44, 8471554.14],
		[2462515.45, 8451476.37],
		[2442502.77, 8449963.52],
	]], [[	/* 669:323 */
		[2462515.45, 8451476.37],
		[2461027.44, 8471554.14],
		[2481103.88, 8473022.05],
		[2482537.53, 8452934.99],
		[2462515.45, 8451476.37],
	]], [[	/* 669:324 */
		[2482537.53, 8452934.99],
		[2481103.88, 8473022.05],
		[2501189.46, 8474435.30],
		[2502568.69, 8454339.31],
		[2482537.53, 8452934.99],
	]], [[	/* 669:325 */
		[2502568.69, 8454339.31],
		[2501189.46, 8474435.30],
		[2521283.85, 8475793.82],
		[2522608.56, 8455689.23],
		[2502568.69, 8454339.31],
	]], [[	/* 669:326 */
		[2522608.56, 8455689.23],
		[2521283.85, 8475793.82],
		[2541386.69, 8477097.53],
		[2542656.83, 8456984.69],
		[2522608.56, 8455689.23],
	]], [[	/* 669:327 */
		[2542656.83, 8456984.69],
		[2541386.69, 8477097.53],
		[2561497.65, 8478346.36],
		[2562713.13, 8458225.61],
		[2542656.83, 8456984.69],
	]], [[	/* 669:328 */
		[2562713.13, 8458225.61],
		[2561497.65, 8478346.36],
		[2581616.38, 8479540.23],
		[2582777.13, 8459411.92],
		[2562713.13, 8458225.61],
	]], [[	/* 669:329 */
		[2582777.13, 8459411.92],
		[2581616.38, 8479540.23],
		[2601742.52, 8480679.08],
		[2602848.49, 8460543.56],
		[2582777.13, 8459411.92],
	]], [[	/* 669:330 */
		[2602848.49, 8460543.56],
		[2601742.52, 8480679.08],
		[2621875.74, 8481762.85],
		[2622926.85, 8461620.45],
		[2602848.49, 8460543.56],
	]], [[	/* 669:331 */
		[2622926.85, 8461620.45],
		[2621875.74, 8481762.85],
		[2642015.69, 8482791.46],
		[2643011.88, 8462642.54],
		[2622926.85, 8461620.45],
	]], [[	/* 669:332 */
		[2643011.88, 8462642.54],
		[2642015.69, 8482791.46],
		[2662162.01, 8483764.87],
		[2663103.23, 8463609.78],
		[2643011.88, 8462642.54],
	]], [[	/* 669:333 */
		[2663103.23, 8463609.78],
		[2662162.01, 8483764.87],
		[2682314.35, 8484683.01],
		[2683200.55, 8464522.09],
		[2663103.23, 8463609.78],
	]], [[	/* 669:334 */
		[2683200.55, 8464522.09],
		[2682314.35, 8484683.01],
		[2702472.37, 8485545.83],
		[2703303.49, 8465379.44],
		[2683200.55, 8464522.09],
	]], [[	/* 669:335 */
		[2703303.49, 8465379.44],
		[2702472.37, 8485545.83],
		[2722635.71, 8486353.29],
		[2723411.71, 8466181.77],
		[2703303.49, 8465379.44],
	]], [[	/* 669:336 */
		[2723411.71, 8466181.77],
		[2722635.71, 8486353.29],
		[2742804.02, 8487105.33],
		[2743524.86, 8466929.04],
		[2723411.71, 8466181.77],
	]], [[	/* 669:337 */
		[2743524.86, 8466929.04],
		[2742804.02, 8487105.33],
		[2762976.96, 8487801.92],
		[2763642.58, 8467621.21],
		[2743524.86, 8466929.04],
	]], [[	/* 669:338 */
		[2763642.58, 8467621.21],
		[2762976.96, 8487801.92],
		[2783154.15, 8488443.02],
		[2783764.53, 8468258.23],
		[2763642.58, 8467621.21],
	]], [[	/* 669:339 */
		[2783764.53, 8468258.23],
		[2783154.15, 8488443.02],
		[2803335.26, 8489028.58],
		[2803890.36, 8468840.07],
		[2783764.53, 8468258.23],
	]], [[	/* 669:340 */
		[2803890.36, 8468840.07],
		[2803335.26, 8489028.58],
		[2823519.93, 8489558.57],
		[2824019.71, 8469366.70],
		[2803890.36, 8468840.07],
	]], [[	/* 669:341 */
		[2824019.71, 8469366.70],
		[2823519.93, 8489558.57],
		[2843707.81, 8490032.97],
		[2844152.24, 8469838.08],
		[2824019.71, 8469366.70],
	]], [[	/* 669:342 */
		[2844152.24, 8469838.08],
		[2843707.81, 8490032.97],
		[2863898.53, 8490451.74],
		[2864287.60, 8470254.19],
		[2844152.24, 8469838.08],
	]], [[	/* 669:343 */
		[2864287.60, 8470254.19],
		[2863898.53, 8490451.74],
		[2884091.75, 8490814.87],
		[2884425.43, 8470615.01],
		[2864287.60, 8470254.19],
	]], [[	/* 669:344 */
		[2884425.43, 8470615.01],
		[2884091.75, 8490814.87],
		[2904287.11, 8491122.32],
		[2904565.38, 8470920.51],
		[2884425.43, 8470615.01],
	]], [[	/* 669:345 */
		[2904565.38, 8470920.51],
		[2904287.11, 8491122.32],
		[2924484.26, 8491374.09],
		[2924707.09, 8471170.68],
		[2904565.38, 8470920.51],
	]], [[	/* 669:346 */
		[2924707.09, 8471170.68],
		[2924484.26, 8491374.09],
		[2944682.83, 8491570.15],
		[2944850.23, 8471365.50],
		[2924707.09, 8471170.68],
	]], [[	/* 669:347 */
		[2944850.23, 8471365.50],
		[2944682.83, 8491570.15],
		[2964882.48, 8491710.51],
		[2964994.43, 8471504.96],
		[2944850.23, 8471365.50],
	]], [[	/* 669:348 */
		[2964994.43, 8471504.96],
		[2964882.48, 8491710.51],
		[2985082.84, 8491795.14],
		[2985139.34, 8471589.05],
		[2964994.43, 8471504.96],
	]], [[	/* 669:349 */
		[2985139.34, 8471589.05],
		[2985082.84, 8491795.14],
		[3005283.57, 8491824.05],
		[3005284.60, 8471617.78],
		[2985139.34, 8471589.05],
	]], [[	/* 669:350 */
		[3005284.60, 8471617.78],
		[3005283.57, 8491824.05],
		[3025484.30, 8491797.23],
		[3025429.88, 8471591.13],
		[3005284.60, 8471617.78],
	]], [[	/* 669:351 */
		[3025429.88, 8471591.13],
		[3025484.30, 8491797.23],
		[3045684.68, 8491714.68],
		[3045574.81, 8471509.11],
		[3025429.88, 8471591.13],
	]], [[	/* 669:352 */
		[3045574.81, 8471509.11],
		[3045684.68, 8491714.68],
		[3065884.36, 8491576.41],
		[3065719.03, 8471371.72],
		[3045574.81, 8471509.11],
	]], [[	/* 669:353 */
		[3065719.03, 8471371.72],
		[3065884.36, 8491576.41],
		[3086082.97, 8491382.43],
		[3085862.21, 8471178.97],
		[3065719.03, 8471371.72],
	]], [[	/* 670:307 */
		[2141324.51, 8440712.28],
		[2138965.59, 8460648.71],
		[2158902.85, 8462992.40],
		[2161208.79, 8443041.25],
		[2141324.51, 8440712.28],
	]], [[	/* 670:308 */
		[2161208.79, 8443041.25],
		[2158902.85, 8462992.40],
		[2178854.72, 8465282.80],
		[2181107.56, 8445317.26],
		[2161208.79, 8443041.25],
	]], [[	/* 670:309 */
		[2181107.56, 8445317.26],
		[2178854.72, 8465282.80],
		[2198820.87, 8467519.77],
		[2201020.49, 8447540.17],
		[2181107.56, 8445317.26],
	]], [[	/* 670:310 */
		[2201020.49, 8447540.17],
		[2198820.87, 8467519.77],
		[2218800.99, 8469703.21],
		[2220947.26, 8449709.87],
		[2201020.49, 8447540.17],
	]], [[	/* 670:311 */
		[2220947.26, 8449709.87],
		[2218800.99, 8469703.21],
		[2238794.73, 8471832.98],
		[2240887.53, 8451826.23],
		[2220947.26, 8449709.87],
	]], [[	/* 670:312 */
		[2240887.53, 8451826.23],
		[2238794.73, 8471832.98],
		[2258801.78, 8473908.96],
		[2260840.99, 8453889.14],
		[2240887.53, 8451826.23],
	]], [[	/* 670:313 */
		[2260840.99, 8453889.14],
		[2258801.78, 8473908.96],
		[2278821.79, 8475931.05],
		[2280807.30, 8455898.47],
		[2260840.99, 8453889.14],
	]], [[	/* 670:314 */
		[2280807.30, 8455898.47],
		[2278821.79, 8475931.05],
		[2298854.44, 8477899.11],
		[2300786.13, 8457854.12],
		[2280807.30, 8455898.47],
	]], [[	/* 670:315 */
		[2300786.13, 8457854.12],
		[2298854.44, 8477899.11],
		[2318899.38, 8479813.05],
		[2320777.15, 8459755.98],
		[2300786.13, 8457854.12],
	]], [[	/* 670:316 */
		[2320777.15, 8459755.98],
		[2318899.38, 8479813.05],
		[2338956.29, 8481672.75],
		[2340780.03, 8461603.94],
		[2320777.15, 8459755.98],
	]], [[	/* 670:317 */
		[2340780.03, 8461603.94],
		[2338956.29, 8481672.75],
		[2359024.82, 8483478.11],
		[2360794.42, 8463397.89],
		[2340780.03, 8461603.94],
	]], [[	/* 670:318 */
		[2360794.42, 8463397.89],
		[2359024.82, 8483478.11],
		[2379104.64, 8485229.02],
		[2380820.01, 8465137.74],
		[2360794.42, 8463397.89],
	]], [[	/* 670:319 */
		[2380820.01, 8465137.74],
		[2379104.64, 8485229.02],
		[2399195.40, 8486925.40],
		[2400856.44, 8466823.38],
		[2380820.01, 8465137.74],
	]], [[	/* 670:320 */
		[2400856.44, 8466823.38],
		[2399195.40, 8486925.40],
		[2419296.77, 8488567.13],
		[2420903.38, 8468454.72],
		[2400856.44, 8466823.38],
	]], [[	/* 670:321 */
		[2420903.38, 8468454.72],
		[2419296.77, 8488567.13],
		[2439408.40, 8490154.13],
		[2440960.50, 8470031.67],
		[2420903.38, 8468454.72],
	]], [[	/* 670:322 */
		[2440960.50, 8470031.67],
		[2439408.40, 8490154.13],
		[2459529.95, 8491686.31],
		[2461027.44, 8471554.14],
		[2440960.50, 8470031.67],
	]], [[	/* 670:323 */
		[2461027.44, 8471554.14],
		[2459529.95, 8491686.31],
		[2479661.08, 8493163.57],
		[2481103.88, 8473022.05],
		[2461027.44, 8471554.14],
	]], [[	/* 670:324 */
		[2481103.88, 8473022.05],
		[2479661.08, 8493163.57],
		[2499801.43, 8494585.84],
		[2501189.46, 8474435.30],
		[2481103.88, 8473022.05],
	]], [[	/* 670:325 */
		[2501189.46, 8474435.30],
		[2499801.43, 8494585.84],
		[2519950.67, 8495953.03],
		[2521283.85, 8475793.82],
		[2501189.46, 8474435.30],
	]], [[	/* 670:326 */
		[2521283.85, 8475793.82],
		[2519950.67, 8495953.03],
		[2540108.44, 8497265.07],
		[2541386.69, 8477097.53],
		[2521283.85, 8475793.82],
	]], [[	/* 670:327 */
		[2541386.69, 8477097.53],
		[2540108.44, 8497265.07],
		[2560274.40, 8498521.88],
		[2561497.65, 8478346.36],
		[2541386.69, 8477097.53],
	]], [[	/* 670:328 */
		[2561497.65, 8478346.36],
		[2560274.40, 8498521.88],
		[2580448.20, 8499723.38],
		[2581616.38, 8479540.23],
		[2561497.65, 8478346.36],
	]], [[	/* 670:329 */
		[2581616.38, 8479540.23],
		[2580448.20, 8499723.38],
		[2600629.49, 8500869.51],
		[2601742.52, 8480679.08],
		[2581616.38, 8479540.23],
	]], [[	/* 670:330 */
		[2601742.52, 8480679.08],
		[2600629.49, 8500869.51],
		[2620817.91, 8501960.21],
		[2621875.74, 8481762.85],
		[2601742.52, 8480679.08],
	]], [[	/* 670:331 */
		[2621875.74, 8481762.85],
		[2620817.91, 8501960.21],
		[2641013.12, 8502995.40],
		[2642015.69, 8482791.46],
		[2621875.74, 8481762.85],
	]], [[	/* 670:332 */
		[2642015.69, 8482791.46],
		[2641013.12, 8502995.40],
		[2661214.76, 8503975.04],
		[2662162.01, 8483764.87],
		[2642015.69, 8482791.46],
	]], [[	/* 670:333 */
		[2662162.01, 8483764.87],
		[2661214.76, 8503975.04],
		[2681422.48, 8504899.06],
		[2682314.35, 8484683.01],
		[2662162.01, 8483764.87],
	]], [[	/* 670:334 */
		[2682314.35, 8484683.01],
		[2681422.48, 8504899.06],
		[2701635.92, 8505767.41],
		[2702472.37, 8485545.83],
		[2682314.35, 8484683.01],
	]], [[	/* 670:335 */
		[2702472.37, 8485545.83],
		[2701635.92, 8505767.41],
		[2721854.74, 8506580.03],
		[2722635.71, 8486353.29],
		[2702472.37, 8485545.83],
	]], [[	/* 670:336 */
		[2722635.71, 8486353.29],
		[2721854.74, 8506580.03],
		[2742078.57, 8507336.90],
		[2742804.02, 8487105.33],
		[2722635.71, 8486353.29],
	]], [[	/* 670:337 */
		[2742804.02, 8487105.33],
		[2742078.57, 8507336.90],
		[2762307.07, 8508037.95],
		[2762976.96, 8487801.92],
		[2742804.02, 8487105.33],
	]], [[	/* 670:338 */
		[2762976.96, 8487801.92],
		[2762307.07, 8508037.95],
		[2782539.87, 8508683.15],
		[2783154.15, 8488443.02],
		[2762976.96, 8487801.92],
	]], [[	/* 670:339 */
		[2783154.15, 8488443.02],
		[2782539.87, 8508683.15],
		[2802776.61, 8509272.47],
		[2803335.26, 8489028.58],
		[2783154.15, 8488443.02],
	]], [[	/* 670:340 */
		[2803335.26, 8489028.58],
		[2802776.61, 8509272.47],
		[2823016.95, 8509805.86],
		[2823519.93, 8489558.57],
		[2803335.26, 8489028.58],
	]], [[	/* 670:341 */
		[2823519.93, 8489558.57],
		[2823016.95, 8509805.86],
		[2843260.52, 8510283.30],
		[2843707.81, 8490032.97],
		[2823519.93, 8489558.57],
	]], [[	/* 670:342 */
		[2843707.81, 8490032.97],
		[2843260.52, 8510283.30],
		[2863506.97, 8510704.76],
		[2863898.53, 8490451.74],
		[2843707.81, 8490032.97],
	]], [[	/* 670:343 */
		[2863898.53, 8490451.74],
		[2863506.97, 8510704.76],
		[2883755.94, 8511070.21],
		[2884091.75, 8490814.87],
		[2863898.53, 8490451.74],
	]], [[	/* 670:344 */
		[2884091.75, 8490814.87],
		[2883755.94, 8511070.21],
		[2904007.06, 8511379.64],
		[2904287.11, 8491122.32],
		[2884091.75, 8490814.87],
	]], [[	/* 670:345 */
		[2904287.11, 8491122.32],
		[2904007.06, 8511379.64],
		[2924259.99, 8511633.02],
		[2924484.26, 8491374.09],
		[2904287.11, 8491122.32],
	]], [[	/* 670:346 */
		[2924484.26, 8491374.09],
		[2924259.99, 8511633.02],
		[2944514.35, 8511830.34],
		[2944682.83, 8491570.15],
		[2924484.26, 8491374.09],
	]], [[	/* 670:347 */
		[2944682.83, 8491570.15],
		[2944514.35, 8511830.34],
		[2964769.81, 8511971.59],
		[2964882.48, 8491710.51],
		[2944682.83, 8491570.15],
	]], [[	/* 670:348 */
		[2964882.48, 8491710.51],
		[2964769.81, 8511971.59],
		[2985025.98, 8512056.77],
		[2985082.84, 8491795.14],
		[2964882.48, 8491710.51],
	]], [[	/* 670:349 */
		[2985082.84, 8491795.14],
		[2985025.98, 8512056.77],
		[3005282.52, 8512085.86],
		[3005283.57, 8491824.05],
		[2985082.84, 8491795.14],
	]], [[	/* 670:350 */
		[3005283.57, 8491824.05],
		[3005282.52, 8512085.86],
		[3025539.07, 8512058.87],
		[3025484.30, 8491797.23],
		[3005283.57, 8491824.05],
	]], [[	/* 670:351 */
		[3025484.30, 8491797.23],
		[3025539.07, 8512058.87],
		[3045795.26, 8511975.79],
		[3045684.68, 8491714.68],
		[3025484.30, 8491797.23],
	]], [[	/* 670:352 */
		[3045684.68, 8491714.68],
		[3045795.26, 8511975.79],
		[3066050.74, 8511836.63],
		[3065884.36, 8491576.41],
		[3045684.68, 8491714.68],
	]], [[	/* 670:353 */
		[3065884.36, 8491576.41],
		[3066050.74, 8511836.63],
		[3086305.15, 8511641.41],
		[3086082.97, 8491382.43],
		[3065884.36, 8491576.41],
	]], [[	/* 670:354 */
		[3086082.97, 8491382.43],
		[3086305.15, 8511641.41],
		[3106558.13, 8511390.12],
		[3106280.17, 8491132.75],
		[3086082.97, 8491382.43],
	]], [[	/* 671:306 */
		[2119043.27, 8458251.86],
		[2116616.25, 8478226.10],
		[2136591.73, 8480638.12],
		[2138965.59, 8460648.71],
		[2119043.27, 8458251.86],
	]], [[	/* 671:307 */
		[2138965.59, 8460648.71],
		[2136591.73, 8480638.12],
		[2156582.28, 8482996.65],
		[2158902.85, 8462992.40],
		[2138965.59, 8460648.71],
	]], [[	/* 671:308 */
		[2158902.85, 8462992.40],
		[2156582.28, 8482996.65],
		[2176587.58, 8485301.57],
		[2178854.72, 8465282.80],
		[2158902.85, 8462992.40],
	]], [[	/* 671:309 */
		[2178854.72, 8465282.80],
		[2176587.58, 8485301.57],
		[2196607.29, 8487552.74],
		[2198820.87, 8467519.77],
		[2178854.72, 8465282.80],
	]], [[	/* 671:310 */
		[2198820.87, 8467519.77],
		[2196607.29, 8487552.74],
		[2216641.09, 8489750.03],
		[2218800.99, 8469703.21],
		[2198820.87, 8467519.77],
	]], [[	/* 671:311 */
		[2218800.99, 8469703.21],
		[2216641.09, 8489750.03],
		[2236688.64, 8491893.33],
		[2238794.73, 8471832.98],
		[2218800.99, 8469703.21],
	]], [[	/* 671:312 */
		[2238794.73, 8471832.98],
		[2236688.64, 8491893.33],
		[2256749.60, 8493982.51],
		[2258801.78, 8473908.96],
		[2238794.73, 8471832.98],
	]], [[	/* 671:313 */
		[2258801.78, 8473908.96],
		[2256749.60, 8493982.51],
		[2276823.65, 8496017.45],
		[2278821.79, 8475931.05],
		[2258801.78, 8473908.96],
	]], [[	/* 671:314 */
		[2278821.79, 8475931.05],
		[2276823.65, 8496017.45],
		[2296910.45, 8497998.04],
		[2298854.44, 8477899.11],
		[2278821.79, 8475931.05],
	]], [[	/* 671:315 */
		[2298854.44, 8477899.11],
		[2296910.45, 8497998.04],
		[2317009.65, 8499924.17],
		[2318899.38, 8479813.05],
		[2298854.44, 8477899.11],
	]], [[	/* 671:316 */
		[2318899.38, 8479813.05],
		[2317009.65, 8499924.17],
		[2337120.93, 8501795.72],
		[2338956.29, 8481672.75],
		[2318899.38, 8479813.05],
	]], [[	/* 671:317 */
		[2338956.29, 8481672.75],
		[2337120.93, 8501795.72],
		[2357243.93, 8503612.59],
		[2359024.82, 8483478.11],
		[2338956.29, 8481672.75],
	]], [[	/* 671:318 */
		[2359024.82, 8483478.11],
		[2357243.93, 8503612.59],
		[2377378.32, 8505374.67],
		[2379104.64, 8485229.02],
		[2359024.82, 8483478.11],
	]], [[	/* 671:319 */
		[2379104.64, 8485229.02],
		[2377378.32, 8505374.67],
		[2397523.76, 8507081.87],
		[2399195.40, 8486925.40],
		[2379104.64, 8485229.02],
	]], [[	/* 671:320 */
		[2399195.40, 8486925.40],
		[2397523.76, 8507081.87],
		[2417679.89, 8508734.09],
		[2419296.77, 8488567.13],
		[2399195.40, 8486925.40],
	]], [[	/* 671:321 */
		[2419296.77, 8488567.13],
		[2417679.89, 8508734.09],
		[2437846.38, 8510331.23],
		[2439408.40, 8490154.13],
		[2419296.77, 8488567.13],
	]], [[	/* 671:322 */
		[2439408.40, 8490154.13],
		[2437846.38, 8510331.23],
		[2458022.88, 8511873.19],
		[2459529.95, 8491686.31],
		[2439408.40, 8490154.13],
	]], [[	/* 671:323 */
		[2459529.95, 8491686.31],
		[2458022.88, 8511873.19],
		[2478209.04, 8513359.91],
		[2479661.08, 8493163.57],
		[2459529.95, 8491686.31],
	]], [[	/* 671:324 */
		[2479661.08, 8493163.57],
		[2478209.04, 8513359.91],
		[2498404.52, 8514791.27],
		[2499801.43, 8494585.84],
		[2479661.08, 8493163.57],
	]], [[	/* 671:325 */
		[2499801.43, 8494585.84],
		[2498404.52, 8514791.27],
		[2518608.96, 8516167.22],
		[2519950.67, 8495953.03],
		[2499801.43, 8494585.84],
	]], [[	/* 671:326 */
		[2519950.67, 8495953.03],
		[2518608.96, 8516167.22],
		[2538822.01, 8517487.66],
		[2540108.44, 8497265.07],
		[2519950.67, 8495953.03],
	]], [[	/* 671:327 */
		[2540108.44, 8497265.07],
		[2538822.01, 8517487.66],
		[2559043.32, 8518752.51],
		[2560274.40, 8498521.88],
		[2540108.44, 8497265.07],
	]], [[	/* 671:328 */
		[2560274.40, 8498521.88],
		[2559043.32, 8518752.51],
		[2579272.54, 8519961.72],
		[2580448.20, 8499723.38],
		[2560274.40, 8498521.88],
	]], [[	/* 671:329 */
		[2580448.20, 8499723.38],
		[2579272.54, 8519961.72],
		[2599509.31, 8521115.20],
		[2600629.49, 8500869.51],
		[2580448.20, 8499723.38],
	]], [[	/* 671:330 */
		[2600629.49, 8500869.51],
		[2599509.31, 8521115.20],
		[2619753.29, 8522212.89],
		[2620817.91, 8501960.21],
		[2600629.49, 8500869.51],
	]], [[	/* 671:331 */
		[2620817.91, 8501960.21],
		[2619753.29, 8522212.89],
		[2640004.11, 8523254.72],
		[2641013.12, 8502995.40],
		[2620817.91, 8501960.21],
	]], [[	/* 671:332 */
		[2641013.12, 8502995.40],
		[2640004.11, 8523254.72],
		[2660261.43, 8524240.64],
		[2661214.76, 8503975.04],
		[2641013.12, 8502995.40],
	]], [[	/* 671:333 */
		[2661214.76, 8503975.04],
		[2660261.43, 8524240.64],
		[2680524.88, 8525170.59],
		[2681422.48, 8504899.06],
		[2661214.76, 8503975.04],
	]], [[	/* 671:334 */
		[2681422.48, 8504899.06],
		[2680524.88, 8525170.59],
		[2700794.11, 8526044.52],
		[2701635.92, 8505767.41],
		[2681422.48, 8504899.06],
	]], [[	/* 671:335 */
		[2701635.92, 8505767.41],
		[2700794.11, 8526044.52],
		[2721068.75, 8526862.36],
		[2721854.74, 8506580.03],
		[2701635.92, 8505767.41],
	]], [[	/* 671:336 */
		[2721854.74, 8506580.03],
		[2721068.75, 8526862.36],
		[2741348.46, 8527624.09],
		[2742078.57, 8507336.90],
		[2721854.74, 8506580.03],
	]], [[	/* 671:337 */
		[2742078.57, 8507336.90],
		[2741348.46, 8527624.09],
		[2761632.87, 8528329.65],
		[2762307.07, 8508037.95],
		[2742078.57, 8507336.90],
	]], [[	/* 671:338 */
		[2762307.07, 8508037.95],
		[2761632.87, 8528329.65],
		[2781921.63, 8528978.99],
		[2782539.87, 8508683.15],
		[2762307.07, 8508037.95],
	]], [[	/* 671:339 */
		[2782539.87, 8508683.15],
		[2781921.63, 8528978.99],
		[2802214.37, 8529572.10],
		[2802776.61, 8509272.47],
		[2782539.87, 8508683.15],
	]], [[	/* 671:340 */
		[2802776.61, 8509272.47],
		[2802214.37, 8529572.10],
		[2822510.73, 8530108.92],
		[2823016.95, 8509805.86],
		[2802776.61, 8509272.47],
	]], [[	/* 671:341 */
		[2823016.95, 8509805.86],
		[2822510.73, 8530108.92],
		[2842810.36, 8530589.42],
		[2843260.52, 8510283.30],
		[2823016.95, 8509805.86],
	]], [[	/* 671:342 */
		[2843260.52, 8510283.30],
		[2842810.36, 8530589.42],
		[2863112.89, 8531013.59],
		[2863506.97, 8510704.76],
		[2843260.52, 8510283.30],
	]], [[	/* 671:343 */
		[2863506.97, 8510704.76],
		[2863112.89, 8531013.59],
		[2883417.96, 8531381.40],
		[2883755.94, 8511070.21],
		[2863506.97, 8510704.76],
	]], [[	/* 671:344 */
		[2883755.94, 8511070.21],
		[2883417.96, 8531381.40],
		[2903725.21, 8531692.81],
		[2904007.06, 8511379.64],
		[2883755.94, 8511070.21],
	]], [[	/* 671:345 */
		[2904007.06, 8511379.64],
		[2903725.21, 8531692.81],
		[2924034.28, 8531947.82],
		[2924259.99, 8511633.02],
		[2904007.06, 8511379.64],
	]], [[	/* 671:346 */
		[2924259.99, 8511633.02],
		[2924034.28, 8531947.82],
		[2944344.80, 8532146.42],
		[2944514.35, 8511830.34],
		[2924259.99, 8511633.02],
	]], [[	/* 671:347 */
		[2944514.35, 8511830.34],
		[2944344.80, 8532146.42],
		[2964656.41, 8532288.58],
		[2964769.81, 8511971.59],
		[2944514.35, 8511830.34],
	]], [[	/* 671:348 */
		[2964769.81, 8511971.59],
		[2964656.41, 8532288.58],
		[2984968.76, 8532374.30],
		[2985025.98, 8512056.77],
		[2964769.81, 8511971.59],
	]], [[	/* 671:349 */
		[2985025.98, 8512056.77],
		[2984968.76, 8532374.30],
		[3005281.47, 8532403.58],
		[3005282.52, 8512085.86],
		[2985025.98, 8512056.77],
	]], [[	/* 671:350 */
		[3005282.52, 8512085.86],
		[3005281.47, 8532403.58],
		[3025594.19, 8532376.41],
		[3025539.07, 8512058.87],
		[3005282.52, 8512085.86],
	]], [[	/* 671:351 */
		[3025539.07, 8512058.87],
		[3025594.19, 8532376.41],
		[3045906.56, 8532292.80],
		[3045795.26, 8511975.79],
		[3025539.07, 8512058.87],
	]], [[	/* 671:352 */
		[3045795.26, 8511975.79],
		[3045906.56, 8532292.80],
		[3066218.20, 8532152.74],
		[3066050.74, 8511836.63],
		[3045795.26, 8511975.79],
	]], [[	/* 671:353 */
		[3066050.74, 8511836.63],
		[3066218.20, 8532152.74],
		[3086528.77, 8531956.26],
		[3086305.15, 8511641.41],
		[3066050.74, 8511836.63],
	]], [[	/* 671:354 */
		[3086305.15, 8511641.41],
		[3086528.77, 8531956.26],
		[3106837.89, 8531703.36],
		[3106558.13, 8511390.12],
		[3086305.15, 8511641.41],
	]], [[	/* 672:308 */
		[2156582.28, 8482996.65],
		[2154246.98, 8503054.35],
		[2174306.03, 8505373.91],
		[2176587.58, 8485301.57],
		[2156582.28, 8482996.65],
	]], [[	/* 672:309 */
		[2176587.58, 8485301.57],
		[2174306.03, 8505373.91],
		[2194379.63, 8507639.39],
		[2196607.29, 8487552.74],
		[2176587.58, 8485301.57],
	]], [[	/* 672:310 */
		[2196607.29, 8487552.74],
		[2194379.63, 8507639.39],
		[2214467.44, 8509850.67],
		[2216641.09, 8489750.03],
		[2196607.29, 8487552.74],
	]], [[	/* 672:311 */
		[2216641.09, 8489750.03],
		[2214467.44, 8509850.67],
		[2234569.12, 8512007.62],
		[2236688.64, 8491893.33],
		[2216641.09, 8489750.03],
	]], [[	/* 672:312 */
		[2236688.64, 8491893.33],
		[2234569.12, 8512007.62],
		[2254684.34, 8514110.11],
		[2256749.60, 8493982.51],
		[2236688.64, 8491893.33],
	]], [[	/* 672:313 */
		[2256749.60, 8493982.51],
		[2254684.34, 8514110.11],
		[2274812.76, 8516158.03],
		[2276823.65, 8496017.45],
		[2256749.60, 8493982.51],
	]], [[	/* 672:314 */
		[2276823.65, 8496017.45],
		[2274812.76, 8516158.03],
		[2294954.05, 8518151.26],
		[2296910.45, 8497998.04],
		[2276823.65, 8496017.45],
	]], [[	/* 672:315 */
		[2296910.45, 8497998.04],
		[2294954.05, 8518151.26],
		[2315107.85, 8520089.68],
		[2317009.65, 8499924.17],
		[2296910.45, 8497998.04],
	]], [[	/* 672:316 */
		[2317009.65, 8499924.17],
		[2315107.85, 8520089.68],
		[2335273.83, 8521973.19],
		[2337120.93, 8501795.72],
		[2317009.65, 8499924.17],
	]], [[	/* 672:317 */
		[2337120.93, 8501795.72],
		[2335273.83, 8521973.19],
		[2355451.65, 8523801.67],
		[2357243.93, 8503612.59],
		[2337120.93, 8501795.72],
	]], [[	/* 672:318 */
		[2357243.93, 8503612.59],
		[2355451.65, 8523801.67],
		[2375640.96, 8525575.02],
		[2377378.32, 8505374.67],
		[2357243.93, 8503612.59],
	]], [[	/* 672:319 */
		[2377378.32, 8505374.67],
		[2375640.96, 8525575.02],
		[2395841.41, 8527293.15],
		[2397523.76, 8507081.87],
		[2377378.32, 8505374.67],
	]], [[	/* 672:320 */
		[2397523.76, 8507081.87],
		[2395841.41, 8527293.15],
		[2416052.66, 8528955.94],
		[2417679.89, 8508734.09],
		[2397523.76, 8507081.87],
	]], [[	/* 672:321 */
		[2417679.89, 8508734.09],
		[2416052.66, 8528955.94],
		[2436274.36, 8530563.31],
		[2437846.38, 8510331.23],
		[2417679.89, 8508734.09],
	]], [[	/* 672:322 */
		[2437846.38, 8510331.23],
		[2436274.36, 8530563.31],
		[2456506.15, 8532115.16],
		[2458022.88, 8511873.19],
		[2437846.38, 8510331.23],
	]], [[	/* 672:323 */
		[2458022.88, 8511873.19],
		[2456506.15, 8532115.16],
		[2476747.70, 8533611.40],
		[2478209.04, 8513359.91],
		[2458022.88, 8511873.19],
	]], [[	/* 672:324 */
		[2478209.04, 8513359.91],
		[2476747.70, 8533611.40],
		[2496998.64, 8535051.95],
		[2498404.52, 8514791.27],
		[2478209.04, 8513359.91],
	]], [[	/* 672:325 */
		[2498404.52, 8514791.27],
		[2496998.64, 8535051.95],
		[2517258.63, 8536436.73],
		[2518608.96, 8516167.22],
		[2498404.52, 8514791.27],
	]], [[	/* 672:326 */
		[2518608.96, 8516167.22],
		[2517258.63, 8536436.73],
		[2537527.31, 8537765.64],
		[2538822.01, 8517487.66],
		[2518608.96, 8516167.22],
	]], [[	/* 672:327 */
		[2538822.01, 8517487.66],
		[2537527.31, 8537765.64],
		[2557804.32, 8539038.62],
		[2559043.32, 8518752.51],
		[2538822.01, 8517487.66],
	]], [[	/* 672:328 */
		[2559043.32, 8518752.51],
		[2557804.32, 8539038.62],
		[2578089.32, 8540255.59],
		[2579272.54, 8519961.72],
		[2559043.32, 8518752.51],
	]], [[	/* 672:329 */
		[2579272.54, 8519961.72],
		[2578089.32, 8540255.59],
		[2598381.94, 8541416.49],
		[2599509.31, 8521115.20],
		[2579272.54, 8519961.72],
	]], [[	/* 672:330 */
		[2599509.31, 8521115.20],
		[2598381.94, 8541416.49],
		[2618681.82, 8542521.24],
		[2619753.29, 8522212.89],
		[2599509.31, 8521115.20],
	]], [[	/* 672:331 */
		[2619753.29, 8522212.89],
		[2618681.82, 8542521.24],
		[2638988.62, 8543569.77],
		[2640004.11, 8523254.72],
		[2619753.29, 8522212.89],
	]], [[	/* 672:332 */
		[2640004.11, 8523254.72],
		[2638988.62, 8543569.77],
		[2659301.96, 8544562.04],
		[2660261.43, 8524240.64],
		[2640004.11, 8523254.72],
	]], [[	/* 672:333 */
		[2660261.43, 8524240.64],
		[2659301.96, 8544562.04],
		[2679621.50, 8545497.97],
		[2680524.88, 8525170.59],
		[2660261.43, 8524240.64],
	]], [[	/* 672:334 */
		[2680524.88, 8525170.59],
		[2679621.50, 8545497.97],
		[2699946.87, 8546377.52],
		[2700794.11, 8526044.52],
		[2680524.88, 8525170.59],
	]], [[	/* 672:335 */
		[2700794.11, 8526044.52],
		[2699946.87, 8546377.52],
		[2720277.70, 8547200.63],
		[2721068.75, 8526862.36],
		[2700794.11, 8526044.52],
	]], [[	/* 672:336 */
		[2721068.75, 8526862.36],
		[2720277.70, 8547200.63],
		[2740613.65, 8547967.26],
		[2741348.46, 8527624.09],
		[2721068.75, 8526862.36],
	]], [[	/* 672:337 */
		[2741348.46, 8527624.09],
		[2740613.65, 8547967.26],
		[2760954.34, 8548677.37],
		[2761632.87, 8528329.65],
		[2741348.46, 8527624.09],
	]], [[	/* 672:338 */
		[2761632.87, 8528329.65],
		[2760954.34, 8548677.37],
		[2781299.41, 8549330.90],
		[2781921.63, 8528978.99],
		[2761632.87, 8528329.65],
	]], [[	/* 672:339 */
		[2781921.63, 8528978.99],
		[2781299.41, 8549330.90],
		[2801648.50, 8549927.82],
		[2802214.37, 8529572.10],
		[2781921.63, 8528978.99],
	]], [[	/* 672:340 */
		[2802214.37, 8529572.10],
		[2801648.50, 8549927.82],
		[2822001.25, 8550468.10],
		[2822510.73, 8530108.92],
		[2802214.37, 8529572.10],
	]], [[	/* 672:341 */
		[2822510.73, 8530108.92],
		[2822001.25, 8550468.10],
		[2842357.30, 8550951.71],
		[2842810.36, 8530589.42],
		[2822510.73, 8530108.92],
	]], [[	/* 672:342 */
		[2842810.36, 8530589.42],
		[2842357.30, 8550951.71],
		[2862716.27, 8551378.61],
		[2863112.89, 8531013.59],
		[2842810.36, 8530589.42],
	]], [[	/* 672:343 */
		[2863112.89, 8531013.59],
		[2862716.27, 8551378.61],
		[2883077.81, 8551748.79],
		[2883417.96, 8531381.40],
		[2863112.89, 8531013.59],
	]], [[	/* 672:344 */
		[2883417.96, 8531381.40],
		[2883077.81, 8551748.79],
		[2903441.54, 8552062.21],
		[2903725.21, 8531692.81],
		[2883417.96, 8531381.40],
	]], [[	/* 672:345 */
		[2903725.21, 8531692.81],
		[2903441.54, 8552062.21],
		[2923807.11, 8552318.87],
		[2924034.28, 8531947.82],
		[2903725.21, 8531692.81],
	]], [[	/* 672:346 */
		[2924034.28, 8531947.82],
		[2923807.11, 8552318.87],
		[2944174.15, 8552518.74],
		[2944344.80, 8532146.42],
		[2924034.28, 8531947.82],
	]], [[	/* 672:347 */
		[2944344.80, 8532146.42],
		[2944174.15, 8552518.74],
		[2964542.29, 8552661.82],
		[2964656.41, 8532288.58],
		[2944344.80, 8532146.42],
	]], [[	/* 672:348 */
		[2964656.41, 8532288.58],
		[2964542.29, 8552661.82],
		[2984911.17, 8552748.09],
		[2984968.76, 8532374.30],
		[2964656.41, 8532288.58],
	]], [[	/* 672:349 */
		[2984968.76, 8532374.30],
		[2984911.17, 8552748.09],
		[3005280.42, 8552777.56],
		[3005281.47, 8532403.58],
		[2984968.76, 8532374.30],
	]], [[	/* 672:350 */
		[3005281.47, 8532403.58],
		[3005280.42, 8552777.56],
		[3025649.67, 8552750.21],
		[3025594.19, 8532376.41],
		[3005281.47, 8532403.58],
	]], [[	/* 672:351 */
		[3025594.19, 8532376.41],
		[3025649.67, 8552750.21],
		[3046018.57, 8552666.06],
		[3045906.56, 8532292.80],
		[3025594.19, 8532376.41],
	]], [[	/* 672:352 */
		[3045906.56, 8532292.80],
		[3046018.57, 8552666.06],
		[3066386.74, 8552525.10],
		[3066218.20, 8532152.74],
		[3045906.56, 8532292.80],
	]], [[	/* 672:353 */
		[3066218.20, 8532152.74],
		[3066386.74, 8552525.10],
		[3086753.82, 8552327.35],
		[3086528.77, 8531956.26],
		[3066218.20, 8532152.74],
	]], [[	/* 672:354 */
		[3086528.77, 8531956.26],
		[3086753.82, 8552327.35],
		[3107119.44, 8552072.81],
		[3106837.89, 8531703.36],
		[3086528.77, 8531956.26],
	]], [[	/* 672:355 */
		[3106837.89, 8531703.36],
		[3107119.44, 8552072.81],
		[3127483.25, 8551761.51],
		[3127145.20, 8531394.05],
		[3106837.89, 8531703.36],
	]], [[	/* 673:309 */
		[2174306.03, 8505373.91],
		[2172009.94, 8525500.14],
		[2192137.76, 8527780.07],
		[2194379.63, 8507639.39],
		[2174306.03, 8505373.91],
	]], [[	/* 673:310 */
		[2194379.63, 8507639.39],
		[2192137.76, 8527780.07],
		[2212279.91, 8530005.46],
		[2214467.44, 8509850.67],
		[2194379.63, 8507639.39],
	]], [[	/* 673:312 */
		[2234569.12, 8512007.62],
		[2232436.07, 8532176.18],
		[2252605.88, 8534292.11],
		[2254684.34, 8514110.11],
		[2234569.12, 8512007.62],
	]], [[	/* 673:314 */
		[2274812.76, 8516158.03],
		[2272789.02, 8536353.12],
		[2292985.13, 8538359.10],
		[2294954.05, 8518151.26],
		[2274812.76, 8516158.03],
	]], [[	/* 673:315 */
		[2294954.05, 8518151.26],
		[2292985.13, 8538359.10],
		[2313193.87, 8540309.93],
		[2315107.85, 8520089.68],
		[2294954.05, 8518151.26],
	]], [[	/* 673:316 */
		[2315107.85, 8520089.68],
		[2313193.87, 8540309.93],
		[2333414.91, 8542205.50],
		[2335273.83, 8521973.19],
		[2315107.85, 8520089.68],
	]], [[	/* 673:317 */
		[2335273.83, 8521973.19],
		[2333414.91, 8542205.50],
		[2353647.88, 8544045.70],
		[2355451.65, 8523801.67],
		[2335273.83, 8521973.19],
	]], [[	/* 673:318 */
		[2355451.65, 8523801.67],
		[2353647.88, 8544045.70],
		[2373892.45, 8545830.42],
		[2375640.96, 8525575.02],
		[2355451.65, 8523801.67],
	]], [[	/* 673:319 */
		[2375640.96, 8525575.02],
		[2373892.45, 8545830.42],
		[2394148.27, 8547559.57],
		[2395841.41, 8527293.15],
		[2375640.96, 8525575.02],
	]], [[	/* 673:320 */
		[2395841.41, 8527293.15],
		[2394148.27, 8547559.57],
		[2414414.98, 8549233.04],
		[2416052.66, 8528955.94],
		[2395841.41, 8527293.15],
	]], [[	/* 673:321 */
		[2416052.66, 8528955.94],
		[2414414.98, 8549233.04],
		[2434692.23, 8550850.73],
		[2436274.36, 8530563.31],
		[2416052.66, 8528955.94],
	]], [[	/* 673:322 */
		[2436274.36, 8530563.31],
		[2434692.23, 8550850.73],
		[2454979.68, 8552412.55],
		[2456506.15, 8532115.16],
		[2436274.36, 8530563.31],
	]], [[	/* 673:323 */
		[2456506.15, 8532115.16],
		[2454979.68, 8552412.55],
		[2475276.96, 8553918.41],
		[2476747.70, 8533611.40],
		[2456506.15, 8532115.16],
	]], [[	/* 673:324 */
		[2476747.70, 8533611.40],
		[2475276.96, 8553918.41],
		[2495583.72, 8555368.23],
		[2496998.64, 8535051.95],
		[2476747.70, 8533611.40],
	]], [[	/* 673:325 */
		[2496998.64, 8535051.95],
		[2495583.72, 8555368.23],
		[2515899.61, 8556761.91],
		[2517258.63, 8536436.73],
		[2496998.64, 8535051.95],
	]], [[	/* 673:326 */
		[2517258.63, 8536436.73],
		[2515899.61, 8556761.91],
		[2536224.27, 8558099.38],
		[2537527.31, 8537765.64],
		[2517258.63, 8536436.73],
	]], [[	/* 673:327 */
		[2537527.31, 8537765.64],
		[2536224.27, 8558099.38],
		[2556557.35, 8559380.56],
		[2557804.32, 8539038.62],
		[2537527.31, 8537765.64],
	]], [[	/* 673:328 */
		[2557804.32, 8539038.62],
		[2556557.35, 8559380.56],
		[2576898.47, 8560605.37],
		[2578089.32, 8540255.59],
		[2557804.32, 8539038.62],
	]], [[	/* 673:329 */
		[2578089.32, 8540255.59],
		[2576898.47, 8560605.37],
		[2597247.30, 8561773.74],
		[2598381.94, 8541416.49],
		[2578089.32, 8540255.59],
	]], [[	/* 673:330 */
		[2598381.94, 8541416.49],
		[2597247.30, 8561773.74],
		[2617603.45, 8562885.61],
		[2618681.82, 8542521.24],
		[2598381.94, 8541416.49],
	]], [[	/* 673:331 */
		[2618681.82, 8542521.24],
		[2617603.45, 8562885.61],
		[2637966.57, 8563940.91],
		[2638988.62, 8543569.77],
		[2618681.82, 8542521.24],
	]], [[	/* 673:332 */
		[2638988.62, 8543569.77],
		[2637966.57, 8563940.91],
		[2658336.31, 8564939.58],
		[2659301.96, 8544562.04],
		[2638988.62, 8543569.77],
	]], [[	/* 673:333 */
		[2659301.96, 8544562.04],
		[2658336.31, 8564939.58],
		[2678712.29, 8565881.55],
		[2679621.50, 8545497.97],
		[2659301.96, 8544562.04],
	]], [[	/* 673:334 */
		[2679621.50, 8545497.97],
		[2678712.29, 8565881.55],
		[2699094.16, 8566766.78],
		[2699946.87, 8546377.52],
		[2679621.50, 8545497.97],
	]], [[	/* 673:335 */
		[2699946.87, 8546377.52],
		[2699094.16, 8566766.78],
		[2719481.55, 8567595.21],
		[2720277.70, 8547200.63],
		[2699946.87, 8546377.52],
	]], [[	/* 673:336 */
		[2720277.70, 8547200.63],
		[2719481.55, 8567595.21],
		[2739874.09, 8568366.79],
		[2740613.65, 8547967.26],
		[2720277.70, 8547200.63],
	]], [[	/* 673:337 */
		[2740613.65, 8547967.26],
		[2739874.09, 8568366.79],
		[2760271.42, 8569081.48],
		[2760954.34, 8548677.37],
		[2740613.65, 8547967.26],
	]], [[	/* 673:338 */
		[2760954.34, 8548677.37],
		[2760271.42, 8569081.48],
		[2780673.17, 8569739.23],
		[2781299.41, 8549330.90],
		[2760954.34, 8548677.37],
	]], [[	/* 673:339 */
		[2781299.41, 8549330.90],
		[2780673.17, 8569739.23],
		[2801078.98, 8570340.01],
		[2801648.50, 8549927.82],
		[2781299.41, 8549330.90],
	]], [[	/* 673:340 */
		[2801648.50, 8549927.82],
		[2801078.98, 8570340.01],
		[2821488.48, 8570883.78],
		[2822001.25, 8550468.10],
		[2801648.50, 8549927.82],
	]], [[	/* 673:341 */
		[2822001.25, 8550468.10],
		[2821488.48, 8570883.78],
		[2841901.31, 8571370.51],
		[2842357.30, 8550951.71],
		[2822001.25, 8550468.10],
	]], [[	/* 673:342 */
		[2842357.30, 8550951.71],
		[2841901.31, 8571370.51],
		[2862317.08, 8571800.18],
		[2862716.27, 8551378.61],
		[2842357.30, 8550951.71],
	]], [[	/* 673:343 */
		[2862716.27, 8551378.61],
		[2862317.08, 8571800.18],
		[2882735.45, 8572172.74],
		[2883077.81, 8551748.79],
		[2862716.27, 8551378.61],
	]], [[	/* 673:344 */
		[2883077.81, 8551748.79],
		[2882735.45, 8572172.74],
		[2903156.04, 8572488.19],
		[2903441.54, 8552062.21],
		[2883077.81, 8551748.79],
	]], [[	/* 673:345 */
		[2903441.54, 8552062.21],
		[2903156.04, 8572488.19],
		[2923578.47, 8572746.51],
		[2923807.11, 8552318.87],
		[2903441.54, 8552062.21],
	]], [[	/* 673:346 */
		[2923807.11, 8552318.87],
		[2923578.47, 8572746.51],
		[2944002.39, 8572947.67],
		[2944174.15, 8552518.74],
		[2923807.11, 8552318.87],
	]], [[	/* 673:347 */
		[2944174.15, 8552518.74],
		[2944002.39, 8572947.67],
		[2964427.43, 8573091.68],
		[2964542.29, 8552661.82],
		[2944174.15, 8552518.74],
	]], [[	/* 673:348 */
		[2964542.29, 8552661.82],
		[2964427.43, 8573091.68],
		[2984853.20, 8573178.51],
		[2984911.17, 8552748.09],
		[2964542.29, 8552661.82],
	]], [[	/* 673:349 */
		[2984911.17, 8552748.09],
		[2984853.20, 8573178.51],
		[3005279.35, 8573208.16],
		[3005280.42, 8552777.56],
		[2984911.17, 8552748.09],
	]], [[	/* 673:350 */
		[3005280.42, 8552777.56],
		[3005279.35, 8573208.16],
		[3025705.51, 8573180.64],
		[3025649.67, 8552750.21],
		[3005280.42, 8552777.56],
	]], [[	/* 673:351 */
		[3025649.67, 8552750.21],
		[3025705.51, 8573180.64],
		[3046131.31, 8573095.94],
		[3046018.57, 8552666.06],
		[3025649.67, 8552750.21],
	]], [[	/* 673:352 */
		[3046018.57, 8552666.06],
		[3046131.31, 8573095.94],
		[3066556.37, 8572954.07],
		[3066386.74, 8552525.10],
		[3046018.57, 8552666.06],
	]], [[	/* 673:353 */
		[3066386.74, 8552525.10],
		[3066556.37, 8572954.07],
		[3086980.33, 8572755.04],
		[3086753.82, 8552327.35],
		[3066386.74, 8552525.10],
	]], [[	/* 673:354 */
		[3086753.82, 8552327.35],
		[3086980.33, 8572755.04],
		[3107402.82, 8572498.86],
		[3107119.44, 8552072.81],
		[3086753.82, 8552327.35],
	]], [[	/* 673:355 */
		[3107119.44, 8552072.81],
		[3107402.82, 8572498.86],
		[3127823.48, 8572185.54],
		[3127483.25, 8551761.51],
		[3107119.44, 8552072.81],
	]], [[	/* 673:356 */
		[3127483.25, 8551761.51],
		[3127823.48, 8572185.54],
		[3148241.92, 8571815.10],
		[3147844.86, 8551393.45],
		[3127483.25, 8551761.51],
	]], [[	/* 674:316 */
		[2313193.87, 8540309.93],
		[2311267.60, 8560585.25],
		[2331544.04, 8562492.99],
		[2333414.91, 8542205.50],
		[2313193.87, 8540309.93],
	]], [[	/* 674:317 */
		[2333414.91, 8542205.50],
		[2331544.04, 8562492.99],
		[2351832.52, 8564345.02],
		[2353647.88, 8544045.70],
		[2333414.91, 8542205.50],
	]], [[	/* 674:318 */
		[2353647.88, 8544045.70],
		[2351832.52, 8564345.02],
		[2372132.70, 8566141.22],
		[2373892.45, 8545830.42],
		[2353647.88, 8544045.70],
	]], [[	/* 674:319 */
		[2373892.45, 8545830.42],
		[2372132.70, 8566141.22],
		[2392444.23, 8567881.49],
		[2394148.27, 8547559.57],
		[2373892.45, 8545830.42],
	]], [[	/* 674:320 */
		[2394148.27, 8547559.57],
		[2392444.23, 8567881.49],
		[2412766.75, 8569565.72],
		[2414414.98, 8549233.04],
		[2394148.27, 8547559.57],
	]], [[	/* 674:321 */
		[2414414.98, 8549233.04],
		[2412766.75, 8569565.72],
		[2433099.91, 8571193.83],
		[2434692.23, 8550850.73],
		[2414414.98, 8549233.04],
	]], [[	/* 674:322 */
		[2434692.23, 8550850.73],
		[2433099.91, 8571193.83],
		[2453443.36, 8572765.72],
		[2454979.68, 8552412.55],
		[2434692.23, 8550850.73],
	]], [[	/* 674:323 */
		[2454979.68, 8552412.55],
		[2453443.36, 8572765.72],
		[2473796.73, 8574281.29],
		[2475276.96, 8553918.41],
		[2454979.68, 8552412.55],
	]], [[	/* 674:324 */
		[2475276.96, 8553918.41],
		[2473796.73, 8574281.29],
		[2494159.67, 8575740.45],
		[2495583.72, 8555368.23],
		[2475276.96, 8553918.41],
	]], [[	/* 674:325 */
		[2495583.72, 8555368.23],
		[2494159.67, 8575740.45],
		[2514531.83, 8577143.12],
		[2515899.61, 8556761.91],
		[2495583.72, 8555368.23],
	]], [[	/* 674:326 */
		[2515899.61, 8556761.91],
		[2514531.83, 8577143.12],
		[2534912.83, 8578489.22],
		[2536224.27, 8558099.38],
		[2515899.61, 8556761.91],
	]], [[	/* 674:327 */
		[2536224.27, 8558099.38],
		[2534912.83, 8578489.22],
		[2555302.32, 8579778.68],
		[2556557.35, 8559380.56],
		[2536224.27, 8558099.38],
	]], [[	/* 674:328 */
		[2556557.35, 8559380.56],
		[2555302.32, 8579778.68],
		[2575699.94, 8581011.40],
		[2576898.47, 8560605.37],
		[2556557.35, 8559380.56],
	]], [[	/* 674:329 */
		[2576898.47, 8560605.37],
		[2575699.94, 8581011.40],
		[2596105.32, 8582187.32],
		[2597247.30, 8561773.74],
		[2576898.47, 8560605.37],
	]], [[	/* 674:330 */
		[2597247.30, 8561773.74],
		[2596105.32, 8582187.32],
		[2616518.10, 8583306.38],
		[2617603.45, 8562885.61],
		[2597247.30, 8561773.74],
	]], [[	/* 674:331 */
		[2617603.45, 8562885.61],
		[2616518.10, 8583306.38],
		[2636937.92, 8584368.50],
		[2637966.57, 8563940.91],
		[2617603.45, 8562885.61],
	]], [[	/* 674:332 */
		[2637966.57, 8563940.91],
		[2636937.92, 8584368.50],
		[2657364.41, 8585373.62],
		[2658336.31, 8564939.58],
		[2637966.57, 8563940.91],
	]], [[	/* 674:333 */
		[2658336.31, 8564939.58],
		[2657364.41, 8585373.62],
		[2677797.20, 8586321.69],
		[2678712.29, 8565881.55],
		[2658336.31, 8564939.58],
	]], [[	/* 674:334 */
		[2678712.29, 8565881.55],
		[2677797.20, 8586321.69],
		[2698235.93, 8587212.65],
		[2699094.16, 8566766.78],
		[2678712.29, 8565881.55],
	]], [[	/* 674:335 */
		[2699094.16, 8566766.78],
		[2698235.93, 8587212.65],
		[2718680.23, 8588046.44],
		[2719481.55, 8567595.21],
		[2699094.16, 8566766.78],
	]], [[	/* 674:336 */
		[2719481.55, 8567595.21],
		[2718680.23, 8588046.44],
		[2739129.74, 8588823.02],
		[2739874.09, 8568366.79],
		[2719481.55, 8567595.21],
	]], [[	/* 674:337 */
		[2739874.09, 8568366.79],
		[2739129.74, 8588823.02],
		[2759584.07, 8589542.33],
		[2760271.42, 8569081.48],
		[2739874.09, 8568366.79],
	]], [[	/* 674:338 */
		[2760271.42, 8569081.48],
		[2759584.07, 8589542.33],
		[2780042.87, 8590204.35],
		[2780673.17, 8569739.23],
		[2760271.42, 8569081.48],
	]], [[	/* 674:339 */
		[2780673.17, 8569739.23],
		[2780042.87, 8590204.35],
		[2800505.77, 8590809.02],
		[2801078.98, 8570340.01],
		[2780673.17, 8569739.23],
	]], [[	/* 674:340 */
		[2801078.98, 8570340.01],
		[2800505.77, 8590809.02],
		[2820972.39, 8591356.32],
		[2821488.48, 8570883.78],
		[2801078.98, 8570340.01],
	]], [[	/* 674:341 */
		[2821488.48, 8570883.78],
		[2820972.39, 8591356.32],
		[2841442.36, 8591846.20],
		[2841901.31, 8571370.51],
		[2821488.48, 8570883.78],
	]], [[	/* 674:342 */
		[2841901.31, 8571370.51],
		[2841442.36, 8591846.20],
		[2861915.31, 8592278.65],
		[2862317.08, 8571800.18],
		[2841901.31, 8571370.51],
	]], [[	/* 674:343 */
		[2862317.08, 8571800.18],
		[2861915.31, 8592278.65],
		[2882390.88, 8592653.63],
		[2882735.45, 8572172.74],
		[2862317.08, 8571800.18],
	]], [[	/* 674:344 */
		[2882735.45, 8572172.74],
		[2882390.88, 8592653.63],
		[2902868.68, 8592971.13],
		[2903156.04, 8572488.19],
		[2882735.45, 8572172.74],
	]], [[	/* 674:345 */
		[2903156.04, 8572488.19],
		[2902868.68, 8592971.13],
		[2923348.36, 8593231.12],
		[2923578.47, 8572746.51],
		[2903156.04, 8572488.19],
	]], [[	/* 674:346 */
		[2923578.47, 8572746.51],
		[2923348.36, 8593231.12],
		[2943829.53, 8593433.59],
		[2944002.39, 8572947.67],
		[2923578.47, 8572746.51],
	]], [[	/* 674:347 */
		[2944002.39, 8572947.67],
		[2943829.53, 8593433.59],
		[2964311.82, 8593578.52],
		[2964427.43, 8573091.68],
		[2944002.39, 8572947.67],
	]], [[	/* 674:348 */
		[2964427.43, 8573091.68],
		[2964311.82, 8593578.52],
		[2984794.86, 8593665.92],
		[2984853.20, 8573178.51],
		[2964427.43, 8573091.68],
	]], [[	/* 674:349 */
		[2984853.20, 8573178.51],
		[2984794.86, 8593665.92],
		[3005278.29, 8593695.76],
		[3005279.35, 8573208.16],
		[2984853.20, 8573178.51],
	]], [[	/* 674:350 */
		[3005279.35, 8573208.16],
		[3005278.29, 8593695.76],
		[3025761.72, 8593668.06],
		[3025705.51, 8573180.64],
		[3005279.35, 8573208.16],
	]], [[	/* 674:351 */
		[3025705.51, 8573180.64],
		[3025761.72, 8593668.06],
		[3046244.78, 8593582.81],
		[3046131.31, 8573095.94],
		[3025705.51, 8573180.64],
	]], [[	/* 674:352 */
		[3046131.31, 8573095.94],
		[3046244.78, 8593582.81],
		[3066727.10, 8593440.02],
		[3066556.37, 8572954.07],
		[3046131.31, 8573095.94],
	]], [[	/* 674:353 */
		[3066556.37, 8572954.07],
		[3066727.10, 8593440.02],
		[3087208.31, 8593239.70],
		[3086980.33, 8572755.04],
		[3066556.37, 8572954.07],
	]], [[	/* 674:354 */
		[3086980.33, 8572755.04],
		[3087208.31, 8593239.70],
		[3107688.04, 8592981.85],
		[3107402.82, 8572498.86],
		[3086980.33, 8572755.04],
	]], [[	/* 674:355 */
		[3107402.82, 8572498.86],
		[3107688.04, 8592981.85],
		[3128165.92, 8592666.50],
		[3127823.48, 8572185.54],
		[3107402.82, 8572498.86],
	]], [[	/* 674:356 */
		[3127823.48, 8572185.54],
		[3128165.92, 8592666.50],
		[3148641.56, 8592293.66],
		[3148241.92, 8571815.10],
		[3127823.48, 8572185.54],
	]], [[	/* 674:357 */
		[3148241.92, 8571815.10],
		[3148641.56, 8592293.66],
		[3169114.61, 8591863.36],
		[3168657.79, 8571387.57],
		[3148241.92, 8571815.10],
	]], [[	/* 675:317 */
		[2331544.04, 8562492.99],
		[2329661.12, 8582836.02],
		[2350005.46, 8584699.98],
		[2351832.52, 8564345.02],
		[2331544.04, 8562492.99],
	]], [[	/* 675:318 */
		[2351832.52, 8564345.02],
		[2350005.46, 8584699.98],
		[2370361.60, 8586507.76],
		[2372132.70, 8566141.22],
		[2351832.52, 8564345.02],
	]], [[	/* 675:319 */
		[2372132.70, 8566141.22],
		[2370361.60, 8586507.76],
		[2390729.20, 8588259.25],
		[2392444.23, 8567881.49],
		[2372132.70, 8566141.22],
	]], [[	/* 675:320 */
		[2392444.23, 8567881.49],
		[2390729.20, 8588259.25],
		[2411107.89, 8589954.36],
		[2412766.75, 8569565.72],
		[2392444.23, 8567881.49],
	]], [[	/* 675:321 */
		[2412766.75, 8569565.72],
		[2411107.89, 8589954.36],
		[2431497.31, 8591592.98],
		[2433099.91, 8571193.83],
		[2412766.75, 8569565.72],
	]], [[	/* 675:322 */
		[2433099.91, 8571193.83],
		[2431497.31, 8591592.98],
		[2451897.12, 8593175.02],
		[2453443.36, 8572765.72],
		[2433099.91, 8571193.83],
	]], [[	/* 675:323 */
		[2453443.36, 8572765.72],
		[2451897.12, 8593175.02],
		[2472306.94, 8594700.38],
		[2473796.73, 8574281.29],
		[2453443.36, 8572765.72],
	]], [[	/* 675:324 */
		[2473796.73, 8574281.29],
		[2472306.94, 8594700.38],
		[2492726.42, 8596168.98],
		[2494159.67, 8575740.45],
		[2473796.73, 8574281.29],
	]], [[	/* 675:325 */
		[2494159.67, 8575740.45],
		[2492726.42, 8596168.98],
		[2513155.19, 8597580.73],
		[2514531.83, 8577143.12],
		[2494159.67, 8575740.45],
	]], [[	/* 675:326 */
		[2514531.83, 8577143.12],
		[2513155.19, 8597580.73],
		[2533592.89, 8598935.54],
		[2534912.83, 8578489.22],
		[2514531.83, 8577143.12],
	]], [[	/* 675:327 */
		[2534912.83, 8578489.22],
		[2533592.89, 8598935.54],
		[2554039.16, 8600233.34],
		[2555302.32, 8579778.68],
		[2534912.83, 8578489.22],
	]], [[	/* 675:328 */
		[2555302.32, 8579778.68],
		[2554039.16, 8600233.34],
		[2574493.64, 8601474.04],
		[2575699.94, 8581011.40],
		[2555302.32, 8579778.68],
	]], [[	/* 675:329 */
		[2575699.94, 8581011.40],
		[2574493.64, 8601474.04],
		[2594955.94, 8602657.59],
		[2596105.32, 8582187.32],
		[2575699.94, 8581011.40],
	]], [[	/* 675:330 */
		[2596105.32, 8582187.32],
		[2594955.94, 8602657.59],
		[2615425.72, 8603783.90],
		[2616518.10, 8583306.38],
		[2596105.32, 8582187.32],
	]], [[	/* 675:331 */
		[2616518.10, 8583306.38],
		[2615425.72, 8603783.90],
		[2635902.60, 8604852.90],
		[2636937.92, 8584368.50],
		[2616518.10, 8583306.38],
	]], [[	/* 675:332 */
		[2636937.92, 8584368.50],
		[2635902.60, 8604852.90],
		[2656386.20, 8605864.55],
		[2657364.41, 8585373.62],
		[2636937.92, 8584368.50],
	]], [[	/* 675:333 */
		[2657364.41, 8585373.62],
		[2656386.20, 8605864.55],
		[2676876.17, 8606818.77],
		[2677797.20, 8586321.69],
		[2657364.41, 8585373.62],
	]], [[	/* 675:334 */
		[2677797.20, 8586321.69],
		[2676876.17, 8606818.77],
		[2697372.14, 8607715.50],
		[2698235.93, 8587212.65],
		[2677797.20, 8586321.69],
	]], [[	/* 675:335 */
		[2698235.93, 8587212.65],
		[2697372.14, 8607715.50],
		[2717873.72, 8608554.71],
		[2718680.23, 8588046.44],
		[2698235.93, 8587212.65],
	]], [[	/* 675:336 */
		[2718680.23, 8588046.44],
		[2717873.72, 8608554.71],
		[2738380.55, 8609336.33],
		[2739129.74, 8588823.02],
		[2718680.23, 8588046.44],
	]], [[	/* 675:337 */
		[2739129.74, 8588823.02],
		[2738380.55, 8609336.33],
		[2758892.26, 8610060.31],
		[2759584.07, 8589542.33],
		[2739129.74, 8588823.02],
	]], [[	/* 675:338 */
		[2759584.07, 8589542.33],
		[2758892.26, 8610060.31],
		[2779408.48, 8610726.63],
		[2780042.87, 8590204.35],
		[2759584.07, 8589542.33],
	]], [[	/* 675:339 */
		[2780042.87, 8590204.35],
		[2779408.48, 8610726.63],
		[2799928.83, 8611335.23],
		[2800505.77, 8590809.02],
		[2780042.87, 8590204.35],
	]], [[	/* 675:340 */
		[2800505.77, 8590809.02],
		[2799928.83, 8611335.23],
		[2820452.94, 8611886.08],
		[2820972.39, 8591356.32],
		[2800505.77, 8590809.02],
	]], [[	/* 675:341 */
		[2820972.39, 8591356.32],
		[2820452.94, 8611886.08],
		[2840980.43, 8612379.15],
		[2841442.36, 8591846.20],
		[2820972.39, 8591356.32],
	]], [[	/* 675:342 */
		[2841442.36, 8591846.20],
		[2840980.43, 8612379.15],
		[2861510.93, 8612814.41],
		[2861915.31, 8592278.65],
		[2841442.36, 8591846.20],
	]], [[	/* 675:343 */
		[2861915.31, 8592278.65],
		[2861510.93, 8612814.41],
		[2882044.07, 8613191.83],
		[2882390.88, 8592653.63],
		[2861915.31, 8592278.65],
	]], [[	/* 675:344 */
		[2882390.88, 8592653.63],
		[2882044.07, 8613191.83],
		[2902579.46, 8613511.39],
		[2902868.68, 8592971.13],
		[2882390.88, 8592653.63],
	]], [[	/* 675:345 */
		[2902868.68, 8592971.13],
		[2902579.46, 8613511.39],
		[2923116.75, 8613773.07],
		[2923348.36, 8593231.12],
		[2902868.68, 8592971.13],
	]], [[	/* 675:346 */
		[2923348.36, 8593231.12],
		[2923116.75, 8613773.07],
		[2943655.54, 8613976.85],
		[2943829.53, 8593433.59],
		[2923348.36, 8593231.12],
	]], [[	/* 675:347 */
		[2943829.53, 8593433.59],
		[2943655.54, 8613976.85],
		[2964195.46, 8614122.73],
		[2964311.82, 8593578.52],
		[2943829.53, 8593433.59],
	]], [[	/* 675:348 */
		[2964311.82, 8593578.52],
		[2964195.46, 8614122.73],
		[2984736.15, 8614210.69],
		[2984794.86, 8593665.92],
		[2964311.82, 8593578.52],
	]], [[	/* 675:349 */
		[2984794.86, 8593665.92],
		[2984736.15, 8614210.69],
		[3005277.21, 8614240.73],
		[3005278.29, 8593695.76],
		[2984794.86, 8593665.92],
	]], [[	/* 675:350 */
		[3005278.29, 8593695.76],
		[3005277.21, 8614240.73],
		[3025818.28, 8614212.85],
		[3025761.72, 8593668.06],
		[3005278.29, 8593695.76],
	]], [[	/* 675:351 */
		[3025761.72, 8593668.06],
		[3025818.28, 8614212.85],
		[3046358.99, 8614127.04],
		[3046244.78, 8593582.81],
		[3025761.72, 8593668.06],
	]], [[	/* 675:352 */
		[3046244.78, 8593582.81],
		[3046358.99, 8614127.04],
		[3066898.94, 8613983.32],
		[3066727.10, 8593440.02],
		[3046244.78, 8593582.81],
	]], [[	/* 675:353 */
		[3066727.10, 8593440.02],
		[3066898.94, 8613983.32],
		[3087437.78, 8613781.70],
		[3087208.31, 8593239.70],
		[3066727.10, 8593440.02],
	]], [[	/* 675:354 */
		[3087208.31, 8593239.70],
		[3087437.78, 8613781.70],
		[3107975.12, 8613522.17],
		[3107688.04, 8592981.85],
		[3087208.31, 8593239.70],
	]], [[	/* 675:355 */
		[3107688.04, 8592981.85],
		[3107975.12, 8613522.17],
		[3128510.58, 8613204.77],
		[3128165.92, 8592666.50],
		[3107688.04, 8592981.85],
	]], [[	/* 675:356 */
		[3128165.92, 8592666.50],
		[3128510.58, 8613204.77],
		[3149043.80, 8612829.51],
		[3148641.56, 8592293.66],
		[3128165.92, 8592666.50],
	]], [[	/* 675:357 */
		[3148641.56, 8592293.66],
		[3149043.80, 8612829.51],
		[3169574.40, 8612396.40],
		[3169114.61, 8591863.36],
		[3148641.56, 8592293.66],
	]], [[	/* 675:358 */
		[3169114.61, 8591863.36],
		[3169574.40, 8612396.40],
		[3190101.99, 8611905.49],
		[3189584.69, 8591375.62],
		[3169114.61, 8591863.36],
	]], [[	/* 676:317 */
		[2329661.12, 8582836.02],
		[2327766.04, 8603234.94],
		[2348166.59, 8605110.94],
		[2350005.46, 8584699.98],
		[2329661.12, 8582836.02],
	]], [[	/* 676:318 */
		[2350005.46, 8584699.98],
		[2348166.59, 8605110.94],
		[2368579.05, 8606930.40],
		[2370361.60, 8586507.76],
		[2350005.46, 8584699.98],
	]], [[	/* 676:319 */
		[2370361.60, 8586507.76],
		[2368579.05, 8606930.40],
		[2389003.07, 8608693.22],
		[2390729.20, 8588259.25],
		[2370361.60, 8586507.76],
	]], [[	/* 676:320 */
		[2390729.20, 8588259.25],
		[2389003.07, 8608693.22],
		[2409438.28, 8610399.30],
		[2411107.89, 8589954.36],
		[2390729.20, 8588259.25],
	]], [[	/* 676:321 */
		[2411107.89, 8589954.36],
		[2409438.28, 8610399.30],
		[2429884.33, 8612048.52],
		[2431497.31, 8591592.98],
		[2411107.89, 8589954.36],
	]], [[	/* 676:322 */
		[2431497.31, 8591592.98],
		[2429884.33, 8612048.52],
		[2450340.86, 8613640.81],
		[2451897.12, 8593175.02],
		[2431497.31, 8591592.98],
	]], [[	/* 676:323 */
		[2451897.12, 8593175.02],
		[2450340.86, 8613640.81],
		[2470807.49, 8615176.06],
		[2472306.94, 8594700.38],
		[2451897.12, 8593175.02],
	]], [[	/* 676:324 */
		[2472306.94, 8594700.38],
		[2470807.49, 8615176.06],
		[2491283.86, 8616654.18],
		[2492726.42, 8596168.98],
		[2472306.94, 8594700.38],
	]], [[	/* 676:325 */
		[2492726.42, 8596168.98],
		[2491283.86, 8616654.18],
		[2511769.62, 8618075.08],
		[2513155.19, 8597580.73],
		[2492726.42, 8596168.98],
	]], [[	/* 676:326 */
		[2513155.19, 8597580.73],
		[2511769.62, 8618075.08],
		[2532264.39, 8619438.68],
		[2533592.89, 8598935.54],
		[2513155.19, 8597580.73],
	]], [[	/* 676:327 */
		[2533592.89, 8598935.54],
		[2532264.39, 8619438.68],
		[2552767.81, 8620744.91],
		[2554039.16, 8600233.34],
		[2533592.89, 8598935.54],
	]], [[	/* 676:328 */
		[2554039.16, 8600233.34],
		[2552767.81, 8620744.91],
		[2573279.50, 8621993.67],
		[2574493.64, 8601474.04],
		[2554039.16, 8600233.34],
	]], [[	/* 676:329 */
		[2574493.64, 8601474.04],
		[2573279.50, 8621993.67],
		[2593799.10, 8623184.90],
		[2594955.94, 8602657.59],
		[2574493.64, 8601474.04],
	]], [[	/* 676:330 */
		[2594955.94, 8602657.59],
		[2593799.10, 8623184.90],
		[2614326.24, 8624318.53],
		[2615425.72, 8603783.90],
		[2594955.94, 8602657.59],
	]], [[	/* 676:331 */
		[2615425.72, 8603783.90],
		[2614326.24, 8624318.53],
		[2634860.54, 8625394.49],
		[2635902.60, 8604852.90],
		[2615425.72, 8603783.90],
	]], [[	/* 676:332 */
		[2635902.60, 8604852.90],
		[2634860.54, 8625394.49],
		[2655401.63, 8626412.71],
		[2656386.20, 8605864.55],
		[2635902.60, 8604852.90],
	]], [[	/* 676:333 */
		[2656386.20, 8605864.55],
		[2655401.63, 8626412.71],
		[2675949.15, 8627373.14],
		[2676876.17, 8606818.77],
		[2656386.20, 8605864.55],
	]], [[	/* 676:334 */
		[2676876.17, 8606818.77],
		[2675949.15, 8627373.14],
		[2696502.72, 8628275.71],
		[2697372.14, 8607715.50],
		[2676876.17, 8606818.77],
	]], [[	/* 676:335 */
		[2697372.14, 8607715.50],
		[2696502.72, 8628275.71],
		[2717061.95, 8629120.37],
		[2717873.72, 8608554.71],
		[2697372.14, 8607715.50],
	]], [[	/* 676:336 */
		[2717873.72, 8608554.71],
		[2717061.95, 8629120.37],
		[2737626.49, 8629907.08],
		[2738380.55, 8609336.33],
		[2717873.72, 8608554.71],
	]], [[	/* 676:337 */
		[2738380.55, 8609336.33],
		[2737626.49, 8629907.08],
		[2758195.95, 8630635.78],
		[2758892.26, 8610060.31],
		[2738380.55, 8609336.33],
	]], [[	/* 676:338 */
		[2758892.26, 8610060.31],
		[2758195.95, 8630635.78],
		[2778769.96, 8631306.44],
		[2779408.48, 8610726.63],
		[2758892.26, 8610060.31],
	]], [[	/* 676:339 */
		[2779408.48, 8610726.63],
		[2778769.96, 8631306.44],
		[2799348.13, 8631919.00],
		[2799928.83, 8611335.23],
		[2779408.48, 8610726.63],
	]], [[	/* 676:340 */
		[2799928.83, 8611335.23],
		[2799348.13, 8631919.00],
		[2819930.10, 8632473.44],
		[2820452.94, 8611886.08],
		[2799928.83, 8611335.23],
	]], [[	/* 676:341 */
		[2820452.94, 8611886.08],
		[2819930.10, 8632473.44],
		[2840515.49, 8632969.72],
		[2840980.43, 8612379.15],
		[2820452.94, 8611886.08],
	]], [[	/* 676:342 */
		[2840980.43, 8612379.15],
		[2840515.49, 8632969.72],
		[2861103.91, 8633407.82],
		[2861510.93, 8612814.41],
		[2840980.43, 8612379.15],
	]], [[	/* 676:343 */
		[2861510.93, 8612814.41],
		[2861103.91, 8633407.82],
		[2881694.99, 8633787.70],
		[2882044.07, 8613191.83],
		[2861510.93, 8612814.41],
	]], [[	/* 676:344 */
		[2882044.07, 8613191.83],
		[2881694.99, 8633787.70],
		[2902288.36, 8634109.34],
		[2902579.46, 8613511.39],
		[2882044.07, 8613191.83],
	]], [[	/* 676:345 */
		[2902579.46, 8613511.39],
		[2902288.36, 8634109.34],
		[2922883.62, 8634372.72],
		[2923116.75, 8613773.07],
		[2902579.46, 8613511.39],
	]], [[	/* 676:346 */
		[2923116.75, 8613773.07],
		[2922883.62, 8634372.72],
		[2943480.41, 8634577.84],
		[2943655.54, 8613976.85],
		[2923116.75, 8613773.07],
	]], [[	/* 676:347 */
		[2943655.54, 8613976.85],
		[2943480.41, 8634577.84],
		[2964078.35, 8634724.67],
		[2964195.46, 8614122.73],
		[2943655.54, 8613976.85],
	]], [[	/* 676:348 */
		[2964195.46, 8614122.73],
		[2964078.35, 8634724.67],
		[2984677.05, 8634813.20],
		[2984736.15, 8614210.69],
		[2964195.46, 8614122.73],
	]], [[	/* 676:349 */
		[2984736.15, 8614210.69],
		[2984677.05, 8634813.20],
		[3005276.13, 8634843.44],
		[3005277.21, 8614240.73],
		[2984736.15, 8614210.69],
	]], [[	/* 676:350 */
		[3005277.21, 8614240.73],
		[3005276.13, 8634843.44],
		[3025875.22, 8634815.37],
		[3025818.28, 8614212.85],
		[3005277.21, 8614240.73],
	]], [[	/* 676:351 */
		[3025818.28, 8614212.85],
		[3025875.22, 8634815.37],
		[3046473.94, 8634729.01],
		[3046358.99, 8614127.04],
		[3025818.28, 8614212.85],
	]], [[	/* 676:352 */
		[3046358.99, 8614127.04],
		[3046473.94, 8634729.01],
		[3067071.91, 8634584.35],
		[3066898.94, 8613983.32],
		[3046358.99, 8614127.04],
	]], [[	/* 676:353 */
		[3066898.94, 8613983.32],
		[3067071.91, 8634584.35],
		[3087668.74, 8634381.41],
		[3087437.78, 8613781.70],
		[3066898.94, 8613983.32],
	]], [[	/* 676:354 */
		[3087437.78, 8613781.70],
		[3087668.74, 8634381.41],
		[3108264.06, 8634120.19],
		[3107975.12, 8613522.17],
		[3087437.78, 8613781.70],
	]], [[	/* 676:355 */
		[3107975.12, 8613522.17],
		[3108264.06, 8634120.19],
		[3128857.50, 8633800.72],
		[3128510.58, 8613204.77],
		[3107975.12, 8613522.17],
	]], [[	/* 676:356 */
		[3128510.58, 8613204.77],
		[3128857.50, 8633800.72],
		[3149448.66, 8633423.01],
		[3149043.80, 8612829.51],
		[3128510.58, 8613204.77],
	]], [[	/* 676:357 */
		[3149043.80, 8612829.51],
		[3149448.66, 8633423.01],
		[3170037.18, 8632987.08],
		[3169574.40, 8612396.40],
		[3149043.80, 8612829.51],
	]], [[	/* 676:358 */
		[3169574.40, 8612396.40],
		[3170037.18, 8632987.08],
		[3190622.67, 8632492.96],
		[3190101.99, 8611905.49],
		[3169574.40, 8612396.40],
	]], [[	/* 676:359 */
		[3190101.99, 8611905.49],
		[3190622.67, 8632492.96],
		[3211204.76, 8631940.69],
		[3210626.22, 8611356.79],
		[3190101.99, 8611905.49],
	]], [[	/* 677:317 */
		[2327766.04, 8603234.94],
		[2325858.68, 8623690.10],
		[2346315.80, 8625578.25],
		[2348166.59, 8605110.94],
		[2327766.04, 8603234.94],
	]], [[	/* 677:318 */
		[2348166.59, 8605110.94],
		[2346315.80, 8625578.25],
		[2366784.94, 8627409.50],
		[2368579.05, 8606930.40],
		[2348166.59, 8605110.94],
	]], [[	/* 677:319 */
		[2368579.05, 8606930.40],
		[2366784.94, 8627409.50],
		[2387265.75, 8629183.75],
		[2389003.07, 8608693.22],
		[2368579.05, 8606930.40],
	]], [[	/* 677:320 */
		[2389003.07, 8608693.22],
		[2387265.75, 8629183.75],
		[2407757.85, 8630900.90],
		[2409438.28, 8610399.30],
		[2389003.07, 8608693.22],
	]], [[	/* 677:321 */
		[2409438.28, 8610399.30],
		[2407757.85, 8630900.90],
		[2428260.88, 8632560.83],
		[2429884.33, 8612048.52],
		[2409438.28, 8610399.30],
	]], [[	/* 677:322 */
		[2429884.33, 8612048.52],
		[2428260.88, 8632560.83],
		[2448774.48, 8634163.46],
		[2450340.86, 8613640.81],
		[2429884.33, 8612048.52],
	]], [[	/* 677:323 */
		[2450340.86, 8613640.81],
		[2448774.48, 8634163.46],
		[2469298.29, 8635708.68],
		[2470807.49, 8615176.06],
		[2450340.86, 8613640.81],
	]], [[	/* 677:324 */
		[2470807.49, 8615176.06],
		[2469298.29, 8635708.68],
		[2489831.93, 8637196.41],
		[2491283.86, 8616654.18],
		[2470807.49, 8615176.06],
	]], [[	/* 677:325 */
		[2491283.86, 8616654.18],
		[2489831.93, 8637196.41],
		[2510375.04, 8638626.55],
		[2511769.62, 8618075.08],
		[2491283.86, 8616654.18],
	]], [[	/* 677:326 */
		[2511769.62, 8618075.08],
		[2510375.04, 8638626.55],
		[2530927.24, 8639999.03],
		[2532264.39, 8619438.68],
		[2511769.62, 8618075.08],
	]], [[	/* 677:327 */
		[2532264.39, 8619438.68],
		[2530927.24, 8639999.03],
		[2551488.17, 8641313.75],
		[2552767.81, 8620744.91],
		[2532264.39, 8619438.68],
	]], [[	/* 677:328 */
		[2552767.81, 8620744.91],
		[2551488.17, 8641313.75],
		[2572057.45, 8642570.65],
		[2573279.50, 8621993.67],
		[2552767.81, 8620744.91],
	]], [[	/* 677:329 */
		[2573279.50, 8621993.67],
		[2572057.45, 8642570.65],
		[2592634.72, 8643769.64],
		[2593799.10, 8623184.90],
		[2573279.50, 8621993.67],
	]], [[	/* 677:330 */
		[2593799.10, 8623184.90],
		[2592634.72, 8643769.64],
		[2613219.59, 8644910.65],
		[2614326.24, 8624318.53],
		[2593799.10, 8623184.90],
	]], [[	/* 677:331 */
		[2614326.24, 8624318.53],
		[2613219.59, 8644910.65],
		[2633811.69, 8645993.62],
		[2634860.54, 8625394.49],
		[2614326.24, 8624318.53],
	]], [[	/* 677:332 */
		[2634860.54, 8625394.49],
		[2633811.69, 8645993.62],
		[2654410.64, 8647018.48],
		[2655401.63, 8626412.71],
		[2634860.54, 8625394.49],
	]], [[	/* 677:333 */
		[2655401.63, 8626412.71],
		[2654410.64, 8647018.48],
		[2675016.08, 8647985.17],
		[2675949.15, 8627373.14],
		[2655401.63, 8626412.71],
	]], [[	/* 677:334 */
		[2675949.15, 8627373.14],
		[2675016.08, 8647985.17],
		[2695627.62, 8648893.64],
		[2696502.72, 8628275.71],
		[2675949.15, 8627373.14],
	]], [[	/* 677:335 */
		[2696502.72, 8628275.71],
		[2695627.62, 8648893.64],
		[2716244.89, 8649743.81],
		[2717061.95, 8629120.37],
		[2696502.72, 8628275.71],
	]], [[	/* 677:336 */
		[2717061.95, 8629120.37],
		[2716244.89, 8649743.81],
		[2736867.51, 8650535.66],
		[2737626.49, 8629907.08],
		[2717061.95, 8629120.37],
	]], [[	/* 677:337 */
		[2737626.49, 8629907.08],
		[2736867.51, 8650535.66],
		[2757495.09, 8651269.12],
		[2758195.95, 8630635.78],
		[2737626.49, 8629907.08],
	]], [[	/* 677:338 */
		[2758195.95, 8630635.78],
		[2757495.09, 8651269.12],
		[2778127.26, 8651944.15],
		[2778769.96, 8631306.44],
		[2758195.95, 8630635.78],
	]], [[	/* 677:339 */
		[2778769.96, 8631306.44],
		[2778127.26, 8651944.15],
		[2798763.64, 8652560.72],
		[2799348.13, 8631919.00],
		[2778769.96, 8631306.44],
	]], [[	/* 677:340 */
		[2799348.13, 8631919.00],
		[2798763.64, 8652560.72],
		[2819403.85, 8653118.78],
		[2819930.10, 8632473.44],
		[2799348.13, 8631919.00],
	]], [[	/* 677:341 */
		[2819930.10, 8632473.44],
		[2819403.85, 8653118.78],
		[2840047.51, 8653618.30],
		[2840515.49, 8632969.72],
		[2819930.10, 8632473.44],
	]], [[	/* 677:342 */
		[2840515.49, 8632969.72],
		[2840047.51, 8653618.30],
		[2860694.23, 8654059.26],
		[2861103.91, 8633407.82],
		[2840515.49, 8632969.72],
	]], [[	/* 677:343 */
		[2861103.91, 8633407.82],
		[2860694.23, 8654059.26],
		[2881343.64, 8654441.62],
		[2881694.99, 8633787.70],
		[2861103.91, 8633407.82],
	]], [[	/* 677:344 */
		[2881694.99, 8633787.70],
		[2881343.64, 8654441.62],
		[2901995.35, 8654765.37],
		[2902288.36, 8634109.34],
		[2881694.99, 8633787.70],
	]], [[	/* 677:345 */
		[2902288.36, 8634109.34],
		[2901995.35, 8654765.37],
		[2922648.98, 8655030.47],
		[2922883.62, 8634372.72],
		[2902288.36, 8634109.34],
	]], [[	/* 677:346 */
		[2922883.62, 8634372.72],
		[2922648.98, 8655030.47],
		[2943304.14, 8655236.93],
		[2943480.41, 8634577.84],
		[2922883.62, 8634372.72],
	]], [[	/* 677:347 */
		[2943480.41, 8634577.84],
		[2943304.14, 8655236.93],
		[2963960.47, 8655384.71],
		[2964078.35, 8634724.67],
		[2943480.41, 8634577.84],
	]], [[	/* 677:348 */
		[2964078.35, 8634724.67],
		[2963960.47, 8655384.71],
		[2984617.56, 8655473.83],
		[2984677.05, 8634813.20],
		[2964078.35, 8634724.67],
	]], [[	/* 677:349 */
		[2984677.05, 8634813.20],
		[2984617.56, 8655473.83],
		[3005275.05, 8655504.26],
		[3005276.13, 8634843.44],
		[2984677.05, 8634813.20],
	]], [[	/* 677:350 */
		[3005276.13, 8634843.44],
		[3005275.05, 8655504.26],
		[3025932.54, 8655476.01],
		[3025875.22, 8634815.37],
		[3005276.13, 8634843.44],
	]], [[	/* 677:351 */
		[3025875.22, 8634815.37],
		[3025932.54, 8655476.01],
		[3046589.65, 8655389.08],
		[3046473.94, 8634729.01],
		[3025875.22, 8634815.37],
	]], [[	/* 677:352 */
		[3046473.94, 8634729.01],
		[3046589.65, 8655389.08],
		[3067246.00, 8655243.47],
		[3067071.91, 8634584.35],
		[3046473.94, 8634729.01],
	]], [[	/* 677:353 */
		[3067071.91, 8634584.35],
		[3067246.00, 8655243.47],
		[3087901.21, 8655039.20],
		[3087668.74, 8634381.41],
		[3067071.91, 8634584.35],
	]], [[	/* 677:354 */
		[3087668.74, 8634381.41],
		[3087901.21, 8655039.20],
		[3108554.90, 8654776.28],
		[3108264.06, 8634120.19],
		[3087668.74, 8634381.41],
	]], [[	/* 677:355 */
		[3108264.06, 8634120.19],
		[3108554.90, 8654776.28],
		[3129206.68, 8654454.72],
		[3128857.50, 8633800.72],
		[3108264.06, 8634120.19],
	]], [[	/* 677:356 */
		[3128857.50, 8633800.72],
		[3129206.68, 8654454.72],
		[3149856.17, 8654074.54],
		[3149448.66, 8633423.01],
		[3128857.50, 8633800.72],
	]], [[	/* 677:357 */
		[3149448.66, 8633423.01],
		[3149856.17, 8654074.54],
		[3170502.99, 8653635.76],
		[3170037.18, 8632987.08],
		[3149448.66, 8633423.01],
	]], [[	/* 677:358 */
		[3170037.18, 8632987.08],
		[3170502.99, 8653635.76],
		[3191146.75, 8653138.41],
		[3190622.67, 8632492.96],
		[3170037.18, 8632987.08],
	]], [[	/* 677:359 */
		[3190622.67, 8632492.96],
		[3191146.75, 8653138.41],
		[3211787.08, 8652582.53],
		[3211204.76, 8631940.69],
		[3190622.67, 8632492.96],
	]], [[	/* 678:318 */
		[2346315.80, 8625578.25],
		[2344453.00, 8646102.27],
		[2364979.17, 8647945.42],
		[2366784.94, 8627409.50],
		[2346315.80, 8625578.25],
	]], [[	/* 678:319 */
		[2366784.94, 8627409.50],
		[2364979.17, 8647945.42],
		[2385517.12, 8649731.21],
		[2387265.75, 8629183.75],
		[2366784.94, 8627409.50],
	]], [[	/* 678:320 */
		[2387265.75, 8629183.75],
		[2385517.12, 8649731.21],
		[2406066.47, 8651459.52],
		[2407757.85, 8630900.90],
		[2387265.75, 8629183.75],
	]], [[	/* 678:321 */
		[2407757.85, 8630900.90],
		[2406066.47, 8651459.52],
		[2426626.86, 8653130.26],
		[2428260.88, 8632560.83],
		[2407757.85, 8630900.90],
	]], [[	/* 678:322 */
		[2428260.88, 8632560.83],
		[2426626.86, 8653130.26],
		[2447197.91, 8654743.32],
		[2448774.48, 8634163.46],
		[2428260.88, 8632560.83],
	]], [[	/* 678:323 */
		[2448774.48, 8634163.46],
		[2447197.91, 8654743.32],
		[2467779.26, 8656298.61],
		[2469298.29, 8635708.68],
		[2448774.48, 8634163.46],
	]], [[	/* 678:324 */
		[2469298.29, 8635708.68],
		[2467779.26, 8656298.61],
		[2488370.54, 8657796.04],
		[2489831.93, 8637196.41],
		[2469298.29, 8635708.68],
	]], [[	/* 678:325 */
		[2489831.93, 8637196.41],
		[2488370.54, 8657796.04],
		[2508971.36, 8659235.51],
		[2510375.04, 8638626.55],
		[2489831.93, 8637196.41],
	]], [[	/* 678:326 */
		[2510375.04, 8638626.55],
		[2508971.36, 8659235.51],
		[2529581.37, 8660616.94],
		[2530927.24, 8639999.03],
		[2510375.04, 8638626.55],
	]], [[	/* 678:327 */
		[2530927.24, 8639999.03],
		[2529581.37, 8660616.94],
		[2550200.19, 8661940.24],
		[2551488.17, 8641313.75],
		[2530927.24, 8639999.03],
	]], [[	/* 678:328 */
		[2551488.17, 8641313.75],
		[2550200.19, 8661940.24],
		[2570827.43, 8663205.34],
		[2572057.45, 8642570.65],
		[2551488.17, 8641313.75],
	]], [[	/* 678:329 */
		[2572057.45, 8642570.65],
		[2570827.43, 8663205.34],
		[2591462.73, 8664412.17],
		[2592634.72, 8643769.64],
		[2572057.45, 8642570.65],
	]], [[	/* 678:330 */
		[2592634.72, 8643769.64],
		[2591462.73, 8664412.17],
		[2612105.70, 8665560.64],
		[2613219.59, 8644910.65],
		[2592634.72, 8643769.64],
	]], [[	/* 678:331 */
		[2613219.59, 8644910.65],
		[2612105.70, 8665560.64],
		[2632755.98, 8666650.69],
		[2633811.69, 8645993.62],
		[2613219.59, 8644910.65],
	]], [[	/* 678:332 */
		[2633811.69, 8645993.62],
		[2632755.98, 8666650.69],
		[2653413.17, 8667682.25],
		[2654410.64, 8647018.48],
		[2633811.69, 8645993.62],
	]], [[	/* 678:333 */
		[2654410.64, 8647018.48],
		[2653413.17, 8667682.25],
		[2674076.91, 8668655.26],
		[2675016.08, 8647985.17],
		[2654410.64, 8647018.48],
	]], [[	/* 678:334 */
		[2675016.08, 8647985.17],
		[2674076.91, 8668655.26],
		[2694746.81, 8669569.66],
		[2695627.62, 8648893.64],
		[2675016.08, 8647985.17],
	]], [[	/* 678:335 */
		[2695627.62, 8648893.64],
		[2694746.81, 8669569.66],
		[2715422.48, 8670425.41],
		[2716244.89, 8649743.81],
		[2695627.62, 8648893.64],
	]], [[	/* 678:336 */
		[2716244.89, 8649743.81],
		[2715422.48, 8670425.41],
		[2736103.55, 8671222.43],
		[2736867.51, 8650535.66],
		[2716244.89, 8649743.81],
	]], [[	/* 678:337 */
		[2736867.51, 8650535.66],
		[2736103.55, 8671222.43],
		[2756789.64, 8671960.69],
		[2757495.09, 8651269.12],
		[2736867.51, 8650535.66],
	]], [[	/* 678:338 */
		[2757495.09, 8651269.12],
		[2756789.64, 8671960.69],
		[2777480.36, 8672640.15],
		[2778127.26, 8651944.15],
		[2757495.09, 8651269.12],
	]], [[	/* 678:339 */
		[2778127.26, 8651944.15],
		[2777480.36, 8672640.15],
		[2798175.32, 8673260.75],
		[2798763.64, 8652560.72],
		[2778127.26, 8651944.15],
	]], [[	/* 678:340 */
		[2798763.64, 8652560.72],
		[2798175.32, 8673260.75],
		[2818874.15, 8673822.47],
		[2819403.85, 8653118.78],
		[2798763.64, 8652560.72],
	]], [[	/* 678:341 */
		[2819403.85, 8653118.78],
		[2818874.15, 8673822.47],
		[2839576.46, 8674325.27],
		[2840047.51, 8653618.30],
		[2819403.85, 8653118.78],
	]], [[	/* 678:342 */
		[2840047.51, 8653618.30],
		[2839576.46, 8674325.27],
		[2860281.87, 8674769.11],
		[2860694.23, 8654059.26],
		[2840047.51, 8653618.30],
	]], [[	/* 678:343 */
		[2860694.23, 8654059.26],
		[2860281.87, 8674769.11],
		[2880989.98, 8675153.98],
		[2881343.64, 8654441.62],
		[2860694.23, 8654059.26],
	]], [[	/* 678:344 */
		[2881343.64, 8654441.62],
		[2880989.98, 8675153.98],
		[2901700.42, 8675479.85],
		[2901995.35, 8654765.37],
		[2881343.64, 8654441.62],
	]], [[	/* 678:345 */
		[2901995.35, 8654765.37],
		[2901700.42, 8675479.85],
		[2922412.79, 8675746.69],
		[2922648.98, 8655030.47],
		[2901995.35, 8654765.37],
	]], [[	/* 678:346 */
		[2922648.98, 8655030.47],
		[2922412.79, 8675746.69],
		[2943126.72, 8675954.50],
		[2943304.14, 8655236.93],
		[2922648.98, 8655030.47],
	]], [[	/* 678:347 */
		[2943304.14, 8655236.93],
		[2943126.72, 8675954.50],
		[2963841.81, 8676103.25],
		[2963960.47, 8655384.71],
		[2943304.14, 8655236.93],
	]], [[	/* 678:348 */
		[2963960.47, 8655384.71],
		[2963841.81, 8676103.25],
		[2984557.69, 8676192.95],
		[2984617.56, 8655473.83],
		[2963960.47, 8655384.71],
	]], [[	/* 678:349 */
		[2984617.56, 8655473.83],
		[2984557.69, 8676192.95],
		[3005273.95, 8676223.58],
		[3005275.05, 8655504.26],
		[2984617.56, 8655473.83],
	]], [[	/* 678:350 */
		[3005275.05, 8655504.26],
		[3005273.95, 8676223.58],
		[3025990.22, 8676195.14],
		[3025932.54, 8655476.01],
		[3005275.05, 8655504.26],
	]], [[	/* 678:351 */
		[3025932.54, 8655476.01],
		[3025990.22, 8676195.14],
		[3046706.12, 8676107.64],
		[3046589.65, 8655389.08],
		[3025932.54, 8655476.01],
	]], [[	/* 678:352 */
		[3046589.65, 8655389.08],
		[3046706.12, 8676107.64],
		[3067421.24, 8675961.08],
		[3067246.00, 8655243.47],
		[3046589.65, 8655389.08],
	]], [[	/* 678:353 */
		[3067246.00, 8655243.47],
		[3067421.24, 8675961.08],
		[3088135.21, 8675755.47],
		[3087901.21, 8655039.20],
		[3067246.00, 8655243.47],
	]], [[	/* 678:354 */
		[3087901.21, 8655039.20],
		[3088135.21, 8675755.47],
		[3108847.65, 8675490.82],
		[3108554.90, 8654776.28],
		[3087901.21, 8655039.20],
	]], [[	/* 678:355 */
		[3108554.90, 8654776.28],
		[3108847.65, 8675490.82],
		[3129558.15, 8675167.15],
		[3129206.68, 8654454.72],
		[3108554.90, 8654776.28],
	]], [[	/* 678:356 */
		[3129206.68, 8654454.72],
		[3129558.15, 8675167.15],
		[3150266.35, 8674784.48],
		[3149856.17, 8654074.54],
		[3129206.68, 8654454.72],
	]], [[	/* 678:357 */
		[3149856.17, 8654074.54],
		[3150266.35, 8674784.48],
		[3170971.85, 8674342.82],
		[3170502.99, 8653635.76],
		[3149856.17, 8654074.54],
	]], [[	/* 678:358 */
		[3170502.99, 8653635.76],
		[3170971.85, 8674342.82],
		[3191674.27, 8673842.22],
		[3191146.75, 8653138.41],
		[3170502.99, 8653635.76],
	]], [[	/* 678:359 */
		[3191146.75, 8653138.41],
		[3191674.27, 8673842.22],
		[3212373.22, 8673282.69],
		[3211787.08, 8652582.53],
		[3191146.75, 8653138.41],
	]], [[	/* 678:360 */
		[3211787.08, 8652582.53],
		[3212373.22, 8673282.69],
		[3233068.32, 8672664.28],
		[3232423.59, 8651968.14],
		[3211787.08, 8652582.53],
	]], [[	/* 678:361 */
		[3232423.59, 8651968.14],
		[3233068.32, 8672664.28],
		[3253759.18, 8671987.01],
		[3253055.91, 8651295.28],
		[3232423.59, 8651968.14],
	]], [[	/* 679:319 */
		[2364979.17, 8647945.42],
		[2363161.64, 8668538.53],
		[2383757.10, 8670335.96],
		[2385517.12, 8649731.21],
		[2364979.17, 8647945.42],
	]], [[	/* 679:320 */
		[2385517.12, 8649731.21],
		[2383757.10, 8670335.96],
		[2404364.07, 8672075.54],
		[2406066.47, 8651459.52],
		[2385517.12, 8649731.21],
	]], [[	/* 679:321 */
		[2406066.47, 8651459.52],
		[2404364.07, 8672075.54],
		[2424982.17, 8673757.18],
		[2426626.86, 8653130.26],
		[2406066.47, 8651459.52],
	]], [[	/* 679:322 */
		[2426626.86, 8653130.26],
		[2424982.17, 8673757.18],
		[2445611.04, 8675380.78],
		[2447197.91, 8654743.32],
		[2426626.86, 8653130.26],
	]], [[	/* 679:323 */
		[2447197.91, 8654743.32],
		[2445611.04, 8675380.78],
		[2466250.30, 8676946.23],
		[2467779.26, 8656298.61],
		[2447197.91, 8654743.32],
	]], [[	/* 679:324 */
		[2467779.26, 8656298.61],
		[2466250.30, 8676946.23],
		[2486899.58, 8678453.44],
		[2488370.54, 8657796.04],
		[2467779.26, 8656298.61],
	]], [[	/* 679:325 */
		[2488370.54, 8657796.04],
		[2486899.58, 8678453.44],
		[2507558.51, 8679902.32],
		[2508971.36, 8659235.51],
		[2488370.54, 8657796.04],
	]], [[	/* 679:326 */
		[2508971.36, 8659235.51],
		[2507558.51, 8679902.32],
		[2528226.69, 8681292.79],
		[2529581.37, 8660616.94],
		[2508971.36, 8659235.51],
	]], [[	/* 679:327 */
		[2529581.37, 8660616.94],
		[2528226.69, 8681292.79],
		[2548903.77, 8682624.75],
		[2550200.19, 8661940.24],
		[2529581.37, 8660616.94],
	]], [[	/* 679:328 */
		[2550200.19, 8661940.24],
		[2548903.77, 8682624.75],
		[2569589.35, 8683898.14],
		[2570827.43, 8663205.34],
		[2550200.19, 8661940.24],
	]], [[	/* 679:329 */
		[2570827.43, 8663205.34],
		[2569589.35, 8683898.14],
		[2590283.06, 8685112.86],
		[2591462.73, 8664412.17],
		[2570827.43, 8663205.34],
	]], [[	/* 679:330 */
		[2591462.73, 8664412.17],
		[2590283.06, 8685112.86],
		[2610984.52, 8686268.86],
		[2612105.70, 8665560.64],
		[2591462.73, 8664412.17],
	]], [[	/* 679:331 */
		[2612105.70, 8665560.64],
		[2610984.52, 8686268.86],
		[2631693.35, 8687366.05],
		[2632755.98, 8666650.69],
		[2612105.70, 8665560.64],
	]], [[	/* 679:332 */
		[2632755.98, 8666650.69],
		[2631693.35, 8687366.05],
		[2652409.16, 8688404.38],
		[2653413.17, 8667682.25],
		[2632755.98, 8666650.69],
	]], [[	/* 679:333 */
		[2653413.17, 8667682.25],
		[2652409.16, 8688404.38],
		[2673131.58, 8689383.77],
		[2674076.91, 8668655.26],
		[2653413.17, 8667682.25],
	]], [[	/* 679:334 */
		[2674076.91, 8668655.26],
		[2673131.58, 8689383.77],
		[2693860.21, 8690304.17],
		[2694746.81, 8669569.66],
		[2674076.91, 8668655.26],
	]], [[	/* 679:335 */
		[2694746.81, 8669569.66],
		[2693860.21, 8690304.17],
		[2714594.67, 8691165.53],
		[2715422.48, 8670425.41],
		[2694746.81, 8669569.66],
	]], [[	/* 679:336 */
		[2715422.48, 8670425.41],
		[2714594.67, 8691165.53],
		[2735334.58, 8691967.79],
		[2736103.55, 8671222.43],
		[2715422.48, 8670425.41],
	]], [[	/* 679:337 */
		[2736103.55, 8671222.43],
		[2735334.58, 8691967.79],
		[2756079.56, 8692710.89],
		[2756789.64, 8671960.69],
		[2736103.55, 8671222.43],
	]], [[	/* 679:338 */
		[2756789.64, 8671960.69],
		[2756079.56, 8692710.89],
		[2776829.21, 8693394.81],
		[2777480.36, 8672640.15],
		[2756789.64, 8671960.69],
	]], [[	/* 679:339 */
		[2777480.36, 8672640.15],
		[2776829.21, 8693394.81],
		[2797583.14, 8694019.49],
		[2798175.32, 8673260.75],
		[2777480.36, 8672640.15],
	]], [[	/* 679:340 */
		[2798175.32, 8673260.75],
		[2797583.14, 8694019.49],
		[2818340.98, 8694584.90],
		[2818874.15, 8673822.47],
		[2798175.32, 8673260.75],
	]], [[	/* 679:341 */
		[2818874.15, 8673822.47],
		[2818340.98, 8694584.90],
		[2839102.32, 8695091.00],
		[2839576.46, 8674325.27],
		[2818874.15, 8673822.47],
	]], [[	/* 679:342 */
		[2839576.46, 8674325.27],
		[2839102.32, 8695091.00],
		[2859866.79, 8695537.76],
		[2860281.87, 8674769.11],
		[2839576.46, 8674325.27],
	]], [[	/* 679:343 */
		[2860281.87, 8674769.11],
		[2859866.79, 8695537.76],
		[2880634.00, 8695925.16],
		[2880989.98, 8675153.98],
		[2860281.87, 8674769.11],
	]], [[	/* 679:344 */
		[2880989.98, 8675153.98],
		[2880634.00, 8695925.16],
		[2901403.55, 8696253.16],
		[2901700.42, 8675479.85],
		[2880989.98, 8675153.98],
	]], [[	/* 679:345 */
		[2901700.42, 8675479.85],
		[2901403.55, 8696253.16],
		[2922175.06, 8696521.76],
		[2922412.79, 8675746.69],
		[2901700.42, 8675479.85],
	]], [[	/* 679:346 */
		[2922412.79, 8675746.69],
		[2922175.06, 8696521.76],
		[2942948.13, 8696730.93],
		[2943126.72, 8675954.50],
		[2922412.79, 8675746.69],
	]], [[	/* 679:347 */
		[2943126.72, 8675954.50],
		[2942948.13, 8696730.93],
		[2963722.38, 8696880.67],
		[2963841.81, 8676103.25],
		[2943126.72, 8675954.50],
	]], [[	/* 679:348 */
		[2963841.81, 8676103.25],
		[2963722.38, 8696880.67],
		[2984497.42, 8696970.95],
		[2984557.69, 8676192.95],
		[2963841.81, 8676103.25],
	]], [[	/* 679:349 */
		[2984557.69, 8676192.95],
		[2984497.42, 8696970.95],
		[3005272.85, 8697001.78],
		[3005273.95, 8676223.58],
		[2984557.69, 8676192.95],
	]], [[	/* 679:350 */
		[3005273.95, 8676223.58],
		[3005272.85, 8697001.78],
		[3026048.29, 8696973.16],
		[3025990.22, 8676195.14],
		[3005273.95, 8676223.58],
	]], [[	/* 679:351 */
		[3025990.22, 8676195.14],
		[3026048.29, 8696973.16],
		[3046823.35, 8696885.08],
		[3046706.12, 8676107.64],
		[3025990.22, 8676195.14],
	]], [[	/* 679:352 */
		[3046706.12, 8676107.64],
		[3046823.35, 8696885.08],
		[3067597.63, 8696737.56],
		[3067421.24, 8675961.08],
		[3046706.12, 8676107.64],
	]], [[	/* 679:353 */
		[3067421.24, 8675961.08],
		[3067597.63, 8696737.56],
		[3088370.75, 8696530.59],
		[3088135.21, 8675755.47],
		[3067421.24, 8675961.08],
	]], [[	/* 679:354 */
		[3088135.21, 8675755.47],
		[3088370.75, 8696530.59],
		[3109142.32, 8696264.20],
		[3108847.65, 8675490.82],
		[3088135.21, 8675755.47],
	]], [[	/* 679:355 */
		[3108847.65, 8675490.82],
		[3109142.32, 8696264.20],
		[3129911.94, 8695938.40],
		[3129558.15, 8675167.15],
		[3108847.65, 8675490.82],
	]], [[	/* 679:356 */
		[3129558.15, 8675167.15],
		[3129911.94, 8695938.40],
		[3150679.23, 8695553.21],
		[3150266.35, 8674784.48],
		[3129558.15, 8675167.15],
	]], [[	/* 679:357 */
		[3150266.35, 8674784.48],
		[3150679.23, 8695553.21],
		[3171443.80, 8695108.66],
		[3170971.85, 8674342.82],
		[3150266.35, 8674784.48],
	]], [[	/* 679:358 */
		[3170971.85, 8674342.82],
		[3171443.80, 8695108.66],
		[3192205.25, 8694604.76],
		[3191674.27, 8673842.22],
		[3170971.85, 8674342.82],
	]], [[	/* 679:359 */
		[3191674.27, 8673842.22],
		[3192205.25, 8694604.76],
		[3212963.21, 8694041.56],
		[3212373.22, 8673282.69],
		[3191674.27, 8673842.22],
	]], [[	/* 679:360 */
		[3212373.22, 8673282.69],
		[3212963.21, 8694041.56],
		[3233717.28, 8693419.08],
		[3233068.32, 8672664.28],
		[3212373.22, 8673282.69],
	]], [[	/* 679:361 */
		[3233068.32, 8672664.28],
		[3233717.28, 8693419.08],
		[3254467.08, 8692737.36],
		[3253759.18, 8671987.01],
		[3233068.32, 8672664.28],
	]], [[	/* 679:362 */
		[3253759.18, 8671987.01],
		[3254467.08, 8692737.36],
		[3275212.21, 8691996.45],
		[3274445.43, 8671250.93],
		[3253759.18, 8671987.01],
	]], [[	/* 680:319 */
		[2363161.64, 8668538.53],
		[2361332.22, 8689189.18],
		[2381985.57, 8690998.36],
		[2383757.10, 8670335.96],
		[2363161.64, 8668538.53],
	]], [[	/* 680:320 */
		[2383757.10, 8670335.96],
		[2381985.57, 8690998.36],
		[2402650.52, 8692749.32],
		[2404364.07, 8672075.54],
		[2383757.10, 8670335.96],
	]], [[	/* 680:321 */
		[2404364.07, 8672075.54],
		[2402650.52, 8692749.32],
		[2423326.72, 8694441.97],
		[2424982.17, 8673757.18],
		[2404364.07, 8672075.54],
	]], [[	/* 680:322 */
		[2424982.17, 8673757.18],
		[2423326.72, 8694441.97],
		[2444013.78, 8696076.19],
		[2445611.04, 8675380.78],
		[2424982.17, 8673757.18],
	]], [[	/* 680:323 */
		[2445611.04, 8675380.78],
		[2444013.78, 8696076.19],
		[2464711.33, 8697651.89],
		[2466250.30, 8676946.23],
		[2445611.04, 8675380.78],
	]], [[	/* 680:324 */
		[2466250.30, 8676946.23],
		[2464711.33, 8697651.89],
		[2485418.99, 8699168.98],
		[2486899.58, 8678453.44],
		[2466250.30, 8676946.23],
	]], [[	/* 680:325 */
		[2486899.58, 8678453.44],
		[2485418.99, 8699168.98],
		[2506136.38, 8700627.37],
		[2507558.51, 8679902.32],
		[2486899.58, 8678453.44],
	]], [[	/* 680:326 */
		[2507558.51, 8679902.32],
		[2506136.38, 8700627.37],
		[2526863.13, 8702026.95],
		[2528226.69, 8681292.79],
		[2507558.51, 8679902.32],
	]], [[	/* 680:327 */
		[2528226.69, 8681292.79],
		[2526863.13, 8702026.95],
		[2547598.84, 8703367.66],
		[2548903.77, 8682624.75],
		[2528226.69, 8681292.79],
	]], [[	/* 680:328 */
		[2548903.77, 8682624.75],
		[2547598.84, 8703367.66],
		[2568343.14, 8704649.40],
		[2569589.35, 8683898.14],
		[2548903.77, 8682624.75],
	]], [[	/* 680:329 */
		[2569589.35, 8683898.14],
		[2568343.14, 8704649.40],
		[2589095.65, 8705872.11],
		[2590283.06, 8685112.86],
		[2569589.35, 8683898.14],
	]], [[	/* 680:330 */
		[2590283.06, 8685112.86],
		[2589095.65, 8705872.11],
		[2609855.98, 8707035.70],
		[2610984.52, 8686268.86],
		[2590283.06, 8685112.86],
	]], [[	/* 680:331 */
		[2610984.52, 8686268.86],
		[2609855.98, 8707035.70],
		[2630623.74, 8708140.10],
		[2631693.35, 8687366.05],
		[2610984.52, 8686268.86],
	]], [[	/* 680:332 */
		[2631693.35, 8687366.05],
		[2630623.74, 8708140.10],
		[2651398.55, 8709185.25],
		[2652409.16, 8688404.38],
		[2631693.35, 8687366.05],
	]], [[	/* 680:333 */
		[2652409.16, 8688404.38],
		[2651398.55, 8709185.25],
		[2672180.03, 8710171.09],
		[2673131.58, 8689383.77],
		[2652409.16, 8688404.38],
	]], [[	/* 680:334 */
		[2673131.58, 8689383.77],
		[2672180.03, 8710171.09],
		[2692967.78, 8711097.54],
		[2693860.21, 8690304.17],
		[2673131.58, 8689383.77],
	]], [[	/* 680:335 */
		[2693860.21, 8690304.17],
		[2692967.78, 8711097.54],
		[2713761.42, 8711964.57],
		[2714594.67, 8691165.53],
		[2693860.21, 8690304.17],
	]], [[	/* 680:336 */
		[2714594.67, 8691165.53],
		[2713761.42, 8711964.57],
		[2734560.56, 8712772.10],
		[2735334.58, 8691967.79],
		[2714594.67, 8691165.53],
	]], [[	/* 680:337 */
		[2735334.58, 8691967.79],
		[2734560.56, 8712772.10],
		[2755364.80, 8713520.11],
		[2756079.56, 8692710.89],
		[2735334.58, 8691967.79],
	]], [[	/* 680:338 */
		[2756079.56, 8692710.89],
		[2755364.80, 8713520.11],
		[2776173.77, 8714208.52],
		[2776829.21, 8693394.81],
		[2756079.56, 8692710.89],
	]], [[	/* 680:339 */
		[2776829.21, 8693394.81],
		[2776173.77, 8714208.52],
		[2796987.06, 8714837.32],
		[2797583.14, 8694019.49],
		[2776829.21, 8693394.81],
	]], [[	/* 680:340 */
		[2797583.14, 8694019.49],
		[2796987.06, 8714837.32],
		[2817804.29, 8715406.45],
		[2818340.98, 8694584.90],
		[2797583.14, 8694019.49],
	]], [[	/* 680:341 */
		[2818340.98, 8694584.90],
		[2817804.29, 8715406.45],
		[2838625.06, 8715915.88],
		[2839102.32, 8695091.00],
		[2818340.98, 8694584.90],
	]], [[	/* 680:342 */
		[2839102.32, 8695091.00],
		[2838625.06, 8715915.88],
		[2859448.99, 8716365.59],
		[2859866.79, 8695537.76],
		[2839102.32, 8695091.00],
	]], [[	/* 680:343 */
		[2859866.79, 8695537.76],
		[2859448.99, 8716365.59],
		[2880275.67, 8716755.54],
		[2880634.00, 8695925.16],
		[2859866.79, 8695537.76],
	]], [[	/* 680:344 */
		[2880634.00, 8695925.16],
		[2880275.67, 8716755.54],
		[2901104.73, 8717085.71],
		[2901403.55, 8696253.16],
		[2880634.00, 8695925.16],
	]], [[	/* 680:345 */
		[2901403.55, 8696253.16],
		[2901104.73, 8717085.71],
		[2921935.76, 8717356.07],
		[2922175.06, 8696521.76],
		[2901403.55, 8696253.16],
	]], [[	/* 680:346 */
		[2922175.06, 8696521.76],
		[2921935.76, 8717356.07],
		[2942768.37, 8717566.62],
		[2942948.13, 8696730.93],
		[2922175.06, 8696521.76],
	]], [[	/* 680:347 */
		[2942948.13, 8696730.93],
		[2942768.37, 8717566.62],
		[2963602.16, 8717717.34],
		[2963722.38, 8696880.67],
		[2942948.13, 8696730.93],
	]], [[	/* 680:348 */
		[2963722.38, 8696880.67],
		[2963602.16, 8717717.34],
		[2984436.76, 8717808.22],
		[2984497.42, 8696970.95],
		[2963722.38, 8696880.67],
	]], [[	/* 680:349 */
		[2984497.42, 8696970.95],
		[2984436.76, 8717808.22],
		[3005271.75, 8717839.26],
		[3005272.85, 8697001.78],
		[2984497.42, 8696970.95],
	]], [[	/* 680:350 */
		[3005272.85, 8697001.78],
		[3005271.75, 8717839.26],
		[3026106.75, 8717810.44],
		[3026048.29, 8696973.16],
		[3005272.85, 8697001.78],
	]], [[	/* 680:351 */
		[3026048.29, 8696973.16],
		[3026106.75, 8717810.44],
		[3046941.36, 8717721.79],
		[3046823.35, 8696885.08],
		[3026048.29, 8696973.16],
	]], [[	/* 680:352 */
		[3046823.35, 8696885.08],
		[3046941.36, 8717721.79],
		[3067775.19, 8717573.29],
		[3067597.63, 8696737.56],
		[3046823.35, 8696885.08],
	]], [[	/* 680:353 */
		[3067597.63, 8696737.56],
		[3067775.19, 8717573.29],
		[3088607.84, 8717364.96],
		[3088370.75, 8696530.59],
		[3067597.63, 8696737.56],
	]], [[	/* 680:354 */
		[3088370.75, 8696530.59],
		[3088607.84, 8717364.96],
		[3109438.93, 8717096.81],
		[3109142.32, 8696264.20],
		[3088370.75, 8696530.59],
	]], [[	/* 680:355 */
		[3109142.32, 8696264.20],
		[3109438.93, 8717096.81],
		[3130268.06, 8716768.86],
		[3129911.94, 8695938.40],
		[3109142.32, 8696264.20],
	]], [[	/* 680:356 */
		[3129911.94, 8695938.40],
		[3130268.06, 8716768.86],
		[3151094.83, 8716381.13],
		[3150679.23, 8695553.21],
		[3129911.94, 8695938.40],
	]], [[	/* 680:357 */
		[3150679.23, 8695553.21],
		[3151094.83, 8716381.13],
		[3171918.85, 8715933.65],
		[3171443.80, 8695108.66],
		[3150679.23, 8695553.21],
	]], [[	/* 680:358 */
		[3171443.80, 8695108.66],
		[3171918.85, 8715933.65],
		[3192739.73, 8715426.43],
		[3192205.25, 8694604.76],
		[3171443.80, 8695108.66],
	]], [[	/* 680:359 */
		[3192205.25, 8694604.76],
		[3192739.73, 8715426.43],
		[3213557.09, 8714859.51],
		[3212963.21, 8694041.56],
		[3192205.25, 8694604.76],
	]], [[	/* 680:360 */
		[3212963.21, 8694041.56],
		[3213557.09, 8714859.51],
		[3234370.52, 8714232.94],
		[3233717.28, 8693419.08],
		[3212963.21, 8694041.56],
	]], [[	/* 680:361 */
		[3233717.28, 8693419.08],
		[3234370.52, 8714232.94],
		[3255179.63, 8713546.73],
		[3254467.08, 8692737.36],
		[3233717.28, 8693419.08],
	]], [[	/* 680:362 */
		[3254467.08, 8692737.36],
		[3255179.63, 8713546.73],
		[3275984.04, 8712800.94],
		[3275212.21, 8691996.45],
		[3254467.08, 8692737.36],
	]], [[	/* 681:319 */
		[2361332.22, 8689189.18],
		[2359490.82, 8709897.76],
		[2380202.42, 8711718.79],
		[2381985.57, 8690998.36],
		[2361332.22, 8689189.18],
	]], [[	/* 681:320 */
		[2381985.57, 8690998.36],
		[2380202.42, 8711718.79],
		[2400925.74, 8713481.24],
		[2402650.52, 8692749.32],
		[2381985.57, 8690998.36],
	]], [[	/* 681:321 */
		[2402650.52, 8692749.32],
		[2400925.74, 8713481.24],
		[2421660.40, 8715184.99],
		[2423326.72, 8694441.97],
		[2402650.52, 8692749.32],
	]], [[	/* 681:322 */
		[2423326.72, 8694441.97],
		[2421660.40, 8715184.99],
		[2442406.03, 8716829.94],
		[2444013.78, 8696076.19],
		[2423326.72, 8694441.97],
	]], [[	/* 681:323 */
		[2444013.78, 8696076.19],
		[2442406.03, 8716829.94],
		[2463162.24, 8718415.99],
		[2464711.33, 8697651.89],
		[2444013.78, 8696076.19],
	]], [[	/* 681:324 */
		[2464711.33, 8697651.89],
		[2463162.24, 8718415.99],
		[2483928.66, 8719943.05],
		[2485418.99, 8699168.98],
		[2464711.33, 8697651.89],
	]], [[	/* 681:325 */
		[2485418.99, 8699168.98],
		[2483928.66, 8719943.05],
		[2504704.91, 8721411.02],
		[2506136.38, 8700627.37],
		[2485418.99, 8699168.98],
	]], [[	/* 681:326 */
		[2506136.38, 8700627.37],
		[2504704.91, 8721411.02],
		[2525490.59, 8722819.82],
		[2526863.13, 8702026.95],
		[2506136.38, 8700627.37],
	]], [[	/* 681:327 */
		[2526863.13, 8702026.95],
		[2525490.59, 8722819.82],
		[2546285.32, 8724169.34],
		[2547598.84, 8703367.66],
		[2526863.13, 8702026.95],
	]], [[	/* 681:328 */
		[2547598.84, 8703367.66],
		[2546285.32, 8724169.34],
		[2567088.73, 8725459.53],
		[2568343.14, 8704649.40],
		[2547598.84, 8703367.66],
	]], [[	/* 681:329 */
		[2568343.14, 8704649.40],
		[2567088.73, 8725459.53],
		[2587900.41, 8726690.28],
		[2589095.65, 8705872.11],
		[2568343.14, 8704649.40],
	]], [[	/* 681:330 */
		[2589095.65, 8705872.11],
		[2587900.41, 8726690.28],
		[2608719.99, 8727861.54],
		[2609855.98, 8707035.70],
		[2589095.65, 8705872.11],
	]], [[	/* 681:331 */
		[2609855.98, 8707035.70],
		[2608719.99, 8727861.54],
		[2629547.08, 8728973.22],
		[2630623.74, 8708140.10],
		[2609855.98, 8707035.70],
	]], [[	/* 681:332 */
		[2630623.74, 8708140.10],
		[2629547.08, 8728973.22],
		[2650381.28, 8730025.26],
		[2651398.55, 8709185.25],
		[2630623.74, 8708140.10],
	]], [[	/* 681:333 */
		[2651398.55, 8709185.25],
		[2650381.28, 8730025.26],
		[2671222.20, 8731017.60],
		[2672180.03, 8710171.09],
		[2651398.55, 8709185.25],
	]], [[	/* 681:334 */
		[2672180.03, 8710171.09],
		[2671222.20, 8731017.60],
		[2692069.46, 8731950.16],
		[2692967.78, 8711097.54],
		[2672180.03, 8710171.09],
	]], [[	/* 681:335 */
		[2692967.78, 8711097.54],
		[2692069.46, 8731950.16],
		[2712922.66, 8732822.91],
		[2713761.42, 8711964.57],
		[2692967.78, 8711097.54],
	]], [[	/* 681:336 */
		[2713761.42, 8711964.57],
		[2712922.66, 8732822.91],
		[2733781.42, 8733635.77],
		[2734560.56, 8712772.10],
		[2713761.42, 8711964.57],
	]], [[	/* 681:337 */
		[2734560.56, 8712772.10],
		[2733781.42, 8733635.77],
		[2754645.33, 8734388.71],
		[2755364.80, 8713520.11],
		[2734560.56, 8712772.10],
	]], [[	/* 681:338 */
		[2755364.80, 8713520.11],
		[2754645.33, 8734388.71],
		[2775514.00, 8735081.68],
		[2776173.77, 8714208.52],
		[2755364.80, 8713520.11],
	]], [[	/* 681:339 */
		[2776173.77, 8714208.52],
		[2775514.00, 8735081.68],
		[2796387.04, 8735714.62],
		[2796987.06, 8714837.32],
		[2776173.77, 8714208.52],
	]], [[	/* 681:340 */
		[2796987.06, 8714837.32],
		[2796387.04, 8735714.62],
		[2817264.05, 8736287.52],
		[2817804.29, 8715406.45],
		[2796987.06, 8714837.32],
	]], [[	/* 681:341 */
		[2817804.29, 8715406.45],
		[2817264.05, 8736287.52],
		[2838144.64, 8736800.32],
		[2838625.06, 8715915.88],
		[2817804.29, 8715406.45],
	]], [[	/* 681:342 */
		[2838625.06, 8715915.88],
		[2838144.64, 8736800.32],
		[2859028.42, 8737252.99],
		[2859448.99, 8716365.59],
		[2838625.06, 8715915.88],
	]], [[	/* 681:343 */
		[2859448.99, 8716365.59],
		[2859028.42, 8737252.99],
		[2879914.98, 8737645.52],
		[2880275.67, 8716755.54],
		[2859448.99, 8716365.59],
	]], [[	/* 681:344 */
		[2880275.67, 8716755.54],
		[2879914.98, 8737645.52],
		[2900803.93, 8737977.87],
		[2901104.73, 8717085.71],
		[2880275.67, 8716755.54],
	]], [[	/* 681:345 */
		[2901104.73, 8717085.71],
		[2900803.93, 8737977.87],
		[2921694.87, 8738250.02],
		[2921935.76, 8717356.07],
		[2901104.73, 8717085.71],
	]], [[	/* 681:346 */
		[2921935.76, 8717356.07],
		[2921694.87, 8738250.02],
		[2942587.41, 8738461.96],
		[2942768.37, 8717566.62],
		[2921935.76, 8717356.07],
	]], [[	/* 681:347 */
		[2942768.37, 8717566.62],
		[2942587.41, 8738461.96],
		[2963481.15, 8738613.68],
		[2963602.16, 8717717.34],
		[2942768.37, 8717566.62],
	]], [[	/* 681:348 */
		[2963602.16, 8717717.34],
		[2963481.15, 8738613.68],
		[2984375.69, 8738705.16],
		[2984436.76, 8717808.22],
		[2963602.16, 8717717.34],
	]], [[	/* 681:349 */
		[2984436.76, 8717808.22],
		[2984375.69, 8738705.16],
		[3005270.63, 8738736.39],
		[3005271.75, 8717839.26],
		[2984436.76, 8717808.22],
	]], [[	/* 681:350 */
		[3005271.75, 8717839.26],
		[3005270.63, 8738736.39],
		[3026165.59, 8738707.39],
		[3026106.75, 8717810.44],
		[3005271.75, 8717839.26],
	]], [[	/* 681:351 */
		[3026106.75, 8717810.44],
		[3026165.59, 8738707.39],
		[3047060.14, 8738618.15],
		[3046941.36, 8717721.79],
		[3026106.75, 8717810.44],
	]], [[	/* 681:352 */
		[3046941.36, 8717721.79],
		[3047060.14, 8738618.15],
		[3067953.92, 8738468.66],
		[3067775.19, 8717573.29],
		[3046941.36, 8717721.79],
	]], [[	/* 681:353 */
		[3067775.19, 8717573.29],
		[3067953.92, 8738468.66],
		[3088846.50, 8738258.96],
		[3088607.84, 8717364.96],
		[3067775.19, 8717573.29],
	]], [[	/* 681:354 */
		[3088607.84, 8717364.96],
		[3088846.50, 8738258.96],
		[3109737.50, 8737989.04],
		[3109438.93, 8717096.81],
		[3088607.84, 8717364.96],
	]], [[	/* 681:355 */
		[3109438.93, 8717096.81],
		[3109737.50, 8737989.04],
		[3130626.53, 8737658.92],
		[3130268.06, 8716768.86],
		[3109438.93, 8717096.81],
	]], [[	/* 681:356 */
		[3130268.06, 8716768.86],
		[3130626.53, 8737658.92],
		[3151513.17, 8737268.63],
		[3151094.83, 8716381.13],
		[3130268.06, 8716768.86],
	]], [[	/* 681:357 */
		[3151094.83, 8716381.13],
		[3151513.17, 8737268.63],
		[3172397.05, 8736818.18],
		[3171918.85, 8715933.65],
		[3151094.83, 8716381.13],
	]], [[	/* 681:358 */
		[3171918.85, 8715933.65],
		[3172397.05, 8736818.18],
		[3193277.75, 8736307.61],
		[3192739.73, 8715426.43],
		[3171918.85, 8715933.65],
	]], [[	/* 681:359 */
		[3192739.73, 8715426.43],
		[3193277.75, 8736307.61],
		[3214154.89, 8735736.95],
		[3213557.09, 8714859.51],
		[3192739.73, 8715426.43],
	]], [[	/* 681:360 */
		[3213557.09, 8714859.51],
		[3214154.89, 8735736.95],
		[3235028.07, 8735106.23],
		[3234370.52, 8714232.94],
		[3213557.09, 8714859.51],
	]], [[	/* 681:361 */
		[3234370.52, 8714232.94],
		[3235028.07, 8735106.23],
		[3255896.89, 8734415.49],
		[3255179.63, 8713546.73],
		[3234370.52, 8714232.94],
	]], [[	/* 681:362 */
		[3255179.63, 8713546.73],
		[3255896.89, 8734415.49],
		[3276760.96, 8733664.78],
		[3275984.04, 8712800.94],
		[3255179.63, 8713546.73],
	]], [[	/* 681:363 */
		[3275984.04, 8712800.94],
		[3276760.96, 8733664.78],
		[3297619.89, 8732854.14],
		[3296783.35, 8711995.61],
		[3275984.04, 8712800.94],
	]], [[	/* 682:319 */
		[2359490.82, 8709897.76],
		[2357637.32, 8730664.63],
		[2378407.55, 8732497.63],
		[2380202.42, 8711718.79],
		[2359490.82, 8709897.76],
	]], [[	/* 682:320 */
		[2380202.42, 8711718.79],
		[2378407.55, 8732497.63],
		[2399189.61, 8734271.66],
		[2400925.74, 8713481.24],
		[2380202.42, 8711718.79],
	]], [[	/* 682:321 */
		[2400925.74, 8713481.24],
		[2399189.61, 8734271.66],
		[2419983.11, 8735986.63],
		[2421660.40, 8715184.99],
		[2400925.74, 8713481.24],
	]], [[	/* 682:322 */
		[2421660.40, 8715184.99],
		[2419983.11, 8735986.63],
		[2440787.69, 8737642.41],
		[2442406.03, 8716829.94],
		[2421660.40, 8715184.99],
	]], [[	/* 682:323 */
		[2442406.03, 8716829.94],
		[2440787.69, 8737642.41],
		[2461602.95, 8739238.91],
		[2463162.24, 8718415.99],
		[2442406.03, 8716829.94],
	]], [[	/* 682:324 */
		[2463162.24, 8718415.99],
		[2461602.95, 8739238.91],
		[2482428.52, 8740776.03],
		[2483928.66, 8719943.05],
		[2463162.24, 8718415.99],
	]], [[	/* 682:325 */
		[2483928.66, 8719943.05],
		[2482428.52, 8740776.03],
		[2503263.99, 8742253.68],
		[2504704.91, 8721411.02],
		[2483928.66, 8719943.05],
	]], [[	/* 682:326 */
		[2504704.91, 8721411.02],
		[2503263.99, 8742253.68],
		[2524109.00, 8743671.76],
		[2525490.59, 8722819.82],
		[2504704.91, 8721411.02],
	]], [[	/* 682:327 */
		[2525490.59, 8722819.82],
		[2524109.00, 8743671.76],
		[2544963.14, 8745030.19],
		[2546285.32, 8724169.34],
		[2525490.59, 8722819.82],
	]], [[	/* 682:328 */
		[2546285.32, 8724169.34],
		[2544963.14, 8745030.19],
		[2565826.03, 8746328.89],
		[2567088.73, 8725459.53],
		[2546285.32, 8724169.34],
	]], [[	/* 682:329 */
		[2567088.73, 8725459.53],
		[2565826.03, 8746328.89],
		[2586697.28, 8747567.77],
		[2587900.41, 8726690.28],
		[2567088.73, 8725459.53],
	]], [[	/* 682:330 */
		[2587900.41, 8726690.28],
		[2586697.28, 8747567.77],
		[2607576.50, 8748746.77],
		[2608719.99, 8727861.54],
		[2587900.41, 8726690.28],
	]], [[	/* 682:331 */
		[2608719.99, 8727861.54],
		[2607576.50, 8748746.77],
		[2628463.30, 8749865.79],
		[2629547.08, 8728973.22],
		[2608719.99, 8727861.54],
	]], [[	/* 682:332 */
		[2629547.08, 8728973.22],
		[2628463.30, 8749865.79],
		[2649357.28, 8750924.79],
		[2650381.28, 8730025.26],
		[2629547.08, 8728973.22],
	]], [[	/* 682:333 */
		[2650381.28, 8730025.26],
		[2649357.28, 8750924.79],
		[2670258.04, 8751923.69],
		[2671222.20, 8731017.60],
		[2650381.28, 8730025.26],
	]], [[	/* 682:334 */
		[2671222.20, 8731017.60],
		[2670258.04, 8751923.69],
		[2691165.20, 8752862.42],
		[2692069.46, 8731950.16],
		[2671222.20, 8731017.60],
	]], [[	/* 682:335 */
		[2692069.46, 8731950.16],
		[2691165.20, 8752862.42],
		[2712078.36, 8753740.94],
		[2712922.66, 8732822.91],
		[2692069.46, 8731950.16],
	]], [[	/* 682:336 */
		[2712922.66, 8732822.91],
		[2712078.36, 8753740.94],
		[2732997.12, 8754559.19],
		[2733781.42, 8733635.77],
		[2712922.66, 8732822.91],
	]], [[	/* 682:337 */
		[2733781.42, 8733635.77],
		[2732997.12, 8754559.19],
		[2753921.09, 8755317.11],
		[2754645.33, 8734388.71],
		[2733781.42, 8733635.77],
	]], [[	/* 682:338 */
		[2754645.33, 8734388.71],
		[2753921.09, 8755317.11],
		[2774849.86, 8756014.66],
		[2775514.00, 8735081.68],
		[2754645.33, 8734388.71],
	]], [[	/* 682:339 */
		[2775514.00, 8735081.68],
		[2774849.86, 8756014.66],
		[2795783.05, 8756651.80],
		[2796387.04, 8735714.62],
		[2775514.00, 8735081.68],
	]], [[	/* 682:340 */
		[2796387.04, 8735714.62],
		[2795783.05, 8756651.80],
		[2816720.24, 8757228.49],
		[2817264.05, 8736287.52],
		[2796387.04, 8735714.62],
	]], [[	/* 682:341 */
		[2817264.05, 8736287.52],
		[2816720.24, 8757228.49],
		[2837661.05, 8757744.68],
		[2838144.64, 8736800.32],
		[2817264.05, 8736287.52],
	]], [[	/* 682:342 */
		[2838144.64, 8736800.32],
		[2837661.05, 8757744.68],
		[2858605.06, 8758200.36],
		[2859028.42, 8737252.99],
		[2838144.64, 8736800.32],
	]], [[	/* 682:343 */
		[2859028.42, 8737252.99],
		[2858605.06, 8758200.36],
		[2879551.90, 8758595.49],
		[2879914.98, 8737645.52],
		[2859028.42, 8737252.99],
	]], [[	/* 682:344 */
		[2879914.98, 8737645.52],
		[2879551.90, 8758595.49],
		[2900501.14, 8758930.04],
		[2900803.93, 8737977.87],
		[2879914.98, 8737645.52],
	]], [[	/* 682:345 */
		[2900803.93, 8737977.87],
		[2900501.14, 8758930.04],
		[2921452.39, 8759203.99],
		[2921694.87, 8738250.02],
		[2900803.93, 8737977.87],
	]], [[	/* 682:346 */
		[2921694.87, 8738250.02],
		[2921452.39, 8759203.99],
		[2942405.26, 8759417.34],
		[2942587.41, 8738461.96],
		[2921694.87, 8738250.02],
	]], [[	/* 682:347 */
		[2942587.41, 8738461.96],
		[2942405.26, 8759417.34],
		[2963359.34, 8759570.06],
		[2963481.15, 8738613.68],
		[2942587.41, 8738461.96],
	]], [[	/* 682:348 */
		[2963481.15, 8738613.68],
		[2963359.34, 8759570.06],
		[2984314.22, 8759662.15],
		[2984375.69, 8738705.16],
		[2963481.15, 8738613.68],
	]], [[	/* 682:349 */
		[2984375.69, 8738705.16],
		[2984314.22, 8759662.15],
		[3005269.52, 8759693.59],
		[3005270.63, 8738736.39],
		[2984375.69, 8738705.16],
	]], [[	/* 682:350 */
		[3005270.63, 8738736.39],
		[3005269.52, 8759693.59],
		[3026224.82, 8759664.39],
		[3026165.59, 8738707.39],
		[3005270.63, 8738736.39],
	]], [[	/* 682:351 */
		[3026165.59, 8738707.39],
		[3026224.82, 8759664.39],
		[3047179.72, 8759574.56],
		[3047060.14, 8738618.15],
		[3026165.59, 8738707.39],
	]], [[	/* 682:352 */
		[3047060.14, 8738618.15],
		[3047179.72, 8759574.56],
		[3068133.83, 8759424.08],
		[3067953.92, 8738468.66],
		[3047060.14, 8738618.15],
	]], [[	/* 682:353 */
		[3067953.92, 8738468.66],
		[3068133.83, 8759424.08],
		[3089086.74, 8759212.98],
		[3088846.50, 8738258.96],
		[3067953.92, 8738468.66],
	]], [[	/* 682:354 */
		[3088846.50, 8738258.96],
		[3089086.74, 8759212.98],
		[3110038.06, 8758941.27],
		[3109737.50, 8737989.04],
		[3088846.50, 8738258.96],
	]], [[	/* 682:355 */
		[3109737.50, 8737989.04],
		[3110038.06, 8758941.27],
		[3130987.37, 8758608.97],
		[3130626.53, 8737658.92],
		[3109737.50, 8737989.04],
	]], [[	/* 682:356 */
		[3130626.53, 8737658.92],
		[3130987.37, 8758608.97],
		[3151934.29, 8758216.09],
		[3151513.17, 8737268.63],
		[3130626.53, 8737658.92],
	]], [[	/* 682:357 */
		[3151513.17, 8737268.63],
		[3151934.29, 8758216.09],
		[3172878.41, 8757762.66],
		[3172397.05, 8736818.18],
		[3151513.17, 8737268.63],
	]], [[	/* 682:358 */
		[3172397.05, 8736818.18],
		[3172878.41, 8757762.66],
		[3193819.33, 8757248.70],
		[3193277.75, 8736307.61],
		[3172397.05, 8736818.18],
	]], [[	/* 682:359 */
		[3193277.75, 8736307.61],
		[3193819.33, 8757248.70],
		[3214756.65, 8756674.26],
		[3214154.89, 8735736.95],
		[3193277.75, 8736307.61],
	]], [[	/* 682:360 */
		[3214154.89, 8735736.95],
		[3214756.65, 8756674.26],
		[3235689.97, 8756039.36],
		[3235028.07, 8735106.23],
		[3214154.89, 8735736.95],
	]], [[	/* 682:361 */
		[3235028.07, 8735106.23],
		[3235689.97, 8756039.36],
		[3256618.90, 8755344.05],
		[3255896.89, 8734415.49],
		[3235028.07, 8735106.23],
	]], [[	/* 682:362 */
		[3255896.89, 8734415.49],
		[3256618.90, 8755344.05],
		[3277543.03, 8754588.37],
		[3276760.96, 8733664.78],
		[3255896.89, 8734415.49],
	]], [[	/* 682:363 */
		[3276760.96, 8733664.78],
		[3277543.03, 8754588.37],
		[3298461.97, 8753772.36],
		[3297619.89, 8732854.14],
		[3276760.96, 8733664.78],
	]], [[	/* 682:364 */
		[3297619.89, 8732854.14],
		[3298461.97, 8753772.36],
		[3319375.32, 8752896.07],
		[3318473.28, 8731983.62],
		[3297619.89, 8732854.14],
	]], [[	/* 683:319 */
		[2357637.32, 8730664.63],
		[2355771.61, 8751490.16],
		[2376600.85, 8753335.25],
		[2378407.55, 8732497.63],
		[2357637.32, 8730664.63],
	]], [[	/* 683:320 */
		[2378407.55, 8732497.63],
		[2376600.85, 8753335.25],
		[2397442.02, 8755120.98],
		[2399189.61, 8734271.66],
		[2378407.55, 8732497.63],
	]], [[	/* 683:321 */
		[2399189.61, 8734271.66],
		[2397442.02, 8755120.98],
		[2418294.76, 8756847.26],
		[2419983.11, 8735986.63],
		[2399189.61, 8734271.66],
	]], [[	/* 683:322 */
		[2419983.11, 8735986.63],
		[2418294.76, 8756847.26],
		[2439158.67, 8758513.97],
		[2440787.69, 8737642.41],
		[2419983.11, 8735986.63],
	]], [[	/* 683:323 */
		[2440787.69, 8737642.41],
		[2439158.67, 8758513.97],
		[2460033.36, 8760121.01],
		[2461602.95, 8739238.91],
		[2440787.69, 8737642.41],
	]], [[	/* 683:324 */
		[2461602.95, 8739238.91],
		[2460033.36, 8760121.01],
		[2480918.45, 8761668.29],
		[2482428.52, 8740776.03],
		[2461602.95, 8739238.91],
	]], [[	/* 683:325 */
		[2482428.52, 8740776.03],
		[2480918.45, 8761668.29],
		[2501813.55, 8763155.71],
		[2503263.99, 8742253.68],
		[2482428.52, 8740776.03],
	]], [[	/* 683:326 */
		[2503263.99, 8742253.68],
		[2501813.55, 8763155.71],
		[2522718.27, 8764583.17],
		[2524109.00, 8743671.76],
		[2503263.99, 8742253.68],
	]], [[	/* 683:327 */
		[2524109.00, 8743671.76],
		[2522718.27, 8764583.17],
		[2543632.21, 8765950.59],
		[2544963.14, 8745030.19],
		[2524109.00, 8743671.76],
	]], [[	/* 683:328 */
		[2544963.14, 8745030.19],
		[2543632.21, 8765950.59],
		[2564554.98, 8767257.88],
		[2565826.03, 8746328.89],
		[2544963.14, 8745030.19],
	]], [[	/* 683:329 */
		[2565826.03, 8746328.89],
		[2564554.98, 8767257.88],
		[2585486.19, 8768504.97],
		[2586697.28, 8747567.77],
		[2565826.03, 8746328.89],
	]], [[	/* 683:330 */
		[2586697.28, 8747567.77],
		[2585486.19, 8768504.97],
		[2606425.44, 8769691.77],
		[2607576.50, 8748746.77],
		[2586697.28, 8747567.77],
	]], [[	/* 683:331 */
		[2607576.50, 8748746.77],
		[2606425.44, 8769691.77],
		[2627372.34, 8770818.22],
		[2628463.30, 8749865.79],
		[2607576.50, 8748746.77],
	]], [[	/* 683:332 */
		[2628463.30, 8749865.79],
		[2627372.34, 8770818.22],
		[2648326.49, 8771884.23],
		[2649357.28, 8750924.79],
		[2628463.30, 8749865.79],
	]], [[	/* 683:333 */
		[2649357.28, 8750924.79],
		[2648326.49, 8771884.23],
		[2669287.49, 8772889.75],
		[2670258.04, 8751923.69],
		[2649357.28, 8750924.79],
	]], [[	/* 683:334 */
		[2670258.04, 8751923.69],
		[2669287.49, 8772889.75],
		[2690254.94, 8773834.72],
		[2691165.20, 8752862.42],
		[2670258.04, 8751923.69],
	]], [[	/* 683:335 */
		[2691165.20, 8752862.42],
		[2690254.94, 8773834.72],
		[2711228.46, 8774719.07],
		[2712078.36, 8753740.94],
		[2691165.20, 8752862.42],
	]], [[	/* 683:336 */
		[2712078.36, 8753740.94],
		[2711228.46, 8774719.07],
		[2732207.62, 8775542.74],
		[2732997.12, 8754559.19],
		[2712078.36, 8753740.94],
	]], [[	/* 683:337 */
		[2732997.12, 8754559.19],
		[2732207.62, 8775542.74],
		[2753192.04, 8776305.70],
		[2753921.09, 8755317.11],
		[2732997.12, 8754559.19],
	]], [[	/* 683:338 */
		[2753921.09, 8755317.11],
		[2753192.04, 8776305.70],
		[2774181.32, 8777007.88],
		[2774849.86, 8756014.66],
		[2753921.09, 8755317.11],
	]], [[	/* 683:339 */
		[2774849.86, 8756014.66],
		[2774181.32, 8777007.88],
		[2795175.04, 8777649.25],
		[2795783.05, 8756651.80],
		[2774849.86, 8756014.66],
	]], [[	/* 683:340 */
		[2795783.05, 8756651.80],
		[2795175.04, 8777649.25],
		[2816172.81, 8778229.77],
		[2816720.24, 8757228.49],
		[2795783.05, 8756651.80],
	]], [[	/* 683:341 */
		[2816720.24, 8757228.49],
		[2816172.81, 8778229.77],
		[2837174.23, 8778749.39],
		[2837661.05, 8757744.68],
		[2816720.24, 8757228.49],
	]], [[	/* 683:342 */
		[2837661.05, 8757744.68],
		[2837174.23, 8778749.39],
		[2858178.90, 8779208.09],
		[2858605.06, 8758200.36],
		[2837661.05, 8757744.68],
	]], [[	/* 683:343 */
		[2858605.06, 8758200.36],
		[2858178.90, 8779208.09],
		[2879186.40, 8779605.84],
		[2879551.90, 8758595.49],
		[2858605.06, 8758200.36],
	]], [[	/* 683:344 */
		[2879551.90, 8758595.49],
		[2879186.40, 8779605.84],
		[2900196.34, 8779942.62],
		[2900501.14, 8758930.04],
		[2879551.90, 8758595.49],
	]], [[	/* 683:345 */
		[2900501.14, 8758930.04],
		[2900196.34, 8779942.62],
		[2921208.30, 8780218.40],
		[2921452.39, 8759203.99],
		[2900501.14, 8758930.04],
	]], [[	/* 683:346 */
		[2921452.39, 8759203.99],
		[2921208.30, 8780218.40],
		[2942221.90, 8780433.16],
		[2942405.26, 8759417.34],
		[2921452.39, 8759203.99],
	]], [[	/* 683:347 */
		[2942405.26, 8759417.34],
		[2942221.90, 8780433.16],
		[2963236.71, 8780586.89],
		[2963359.34, 8759570.06],
		[2942405.26, 8759417.34],
	]], [[	/* 683:348 */
		[2963359.34, 8759570.06],
		[2963236.71, 8780586.89],
		[2984252.35, 8780679.59],
		[2984314.22, 8759662.15],
		[2963359.34, 8759570.06],
	]], [[	/* 683:349 */
		[2984314.22, 8759662.15],
		[2984252.35, 8780679.59],
		[3005268.39, 8780711.24],
		[3005269.52, 8759693.59],
		[2984314.22, 8759662.15],
	]], [[	/* 683:350 */
		[3005269.52, 8759693.59],
		[3005268.39, 8780711.24],
		[3026284.44, 8780681.85],
		[3026224.82, 8759664.39],
		[3005269.52, 8759693.59],
	]], [[	/* 683:351 */
		[3026224.82, 8759664.39],
		[3026284.44, 8780681.85],
		[3047300.09, 8780591.42],
		[3047179.72, 8759574.56],
		[3026224.82, 8759664.39],
	]], [[	/* 683:352 */
		[3047179.72, 8759574.56],
		[3047300.09, 8780591.42],
		[3068314.94, 8780439.94],
		[3068133.83, 8759424.08],
		[3047179.72, 8759574.56],
	]], [[	/* 683:353 */
		[3068133.83, 8759424.08],
		[3068314.94, 8780439.94],
		[3089328.58, 8780227.44],
		[3089086.74, 8759212.98],
		[3068133.83, 8759424.08],
	]], [[	/* 683:354 */
		[3089086.74, 8759212.98],
		[3089328.58, 8780227.44],
		[3110340.61, 8779953.92],
		[3110038.06, 8758941.27],
		[3089086.74, 8759212.98],
	]], [[	/* 683:355 */
		[3110038.06, 8758941.27],
		[3110340.61, 8779953.92],
		[3131350.62, 8779619.41],
		[3130987.37, 8758608.97],
		[3110038.06, 8758941.27],
	]], [[	/* 683:356 */
		[3130987.37, 8758608.97],
		[3131350.62, 8779619.41],
		[3152358.21, 8779223.91],
		[3151934.29, 8758216.09],
		[3130987.37, 8758608.97],
	]], [[	/* 683:357 */
		[3151934.29, 8758216.09],
		[3152358.21, 8779223.91],
		[3173362.97, 8778767.47],
		[3172878.41, 8757762.66],
		[3151934.29, 8758216.09],
	]], [[	/* 683:358 */
		[3172878.41, 8757762.66],
		[3173362.97, 8778767.47],
		[3194364.51, 8778250.10],
		[3193819.33, 8757248.70],
		[3172878.41, 8757762.66],
	]], [[	/* 683:359 */
		[3193819.33, 8757248.70],
		[3194364.51, 8778250.10],
		[3215362.41, 8777671.84],
		[3214756.65, 8756674.26],
		[3193819.33, 8757248.70],
	]], [[	/* 683:360 */
		[3214756.65, 8756674.26],
		[3215362.41, 8777671.84],
		[3236356.27, 8777032.73],
		[3235689.97, 8756039.36],
		[3214756.65, 8756674.26],
	]], [[	/* 683:361 */
		[3235689.97, 8756039.36],
		[3236356.27, 8777032.73],
		[3257345.70, 8776332.79],
		[3256618.90, 8755344.05],
		[3235689.97, 8756039.36],
	]], [[	/* 683:362 */
		[3256618.90, 8755344.05],
		[3257345.70, 8776332.79],
		[3278330.29, 8775572.09],
		[3277543.03, 8754588.37],
		[3256618.90, 8755344.05],
	]], [[	/* 683:363 */
		[3277543.03, 8754588.37],
		[3278330.29, 8775572.09],
		[3299309.63, 8774750.67],
		[3298461.97, 8753772.36],
		[3277543.03, 8754588.37],
	]], [[	/* 683:364 */
		[3298461.97, 8753772.36],
		[3299309.63, 8774750.67],
		[3320283.34, 8773868.57],
		[3319375.32, 8752896.07],
		[3298461.97, 8753772.36],
	]], [[	/* 684:320 */
		[2376600.85, 8753335.25],
		[2374782.20, 8774232.03],
		[2395682.88, 8776029.57],
		[2397442.02, 8755120.98],
		[2376600.85, 8753335.25],
	]], [[	/* 684:321 */
		[2397442.02, 8755120.98],
		[2395682.88, 8776029.57],
		[2416595.23, 8777767.27],
		[2418294.76, 8756847.26],
		[2397442.02, 8755120.98],
	]], [[	/* 684:322 */
		[2418294.76, 8756847.26],
		[2416595.23, 8777767.27],
		[2437518.86, 8779445.01],
		[2439158.67, 8758513.97],
		[2418294.76, 8756847.26],
	]], [[	/* 684:323 */
		[2439158.67, 8758513.97],
		[2437518.86, 8779445.01],
		[2458453.38, 8781062.70],
		[2460033.36, 8760121.01],
		[2439158.67, 8758513.97],
	]], [[	/* 684:324 */
		[2460033.36, 8760121.01],
		[2458453.38, 8781062.70],
		[2479398.38, 8782620.23],
		[2480918.45, 8761668.29],
		[2460033.36, 8760121.01],
	]], [[	/* 684:325 */
		[2480918.45, 8761668.29],
		[2479398.38, 8782620.23],
		[2500353.49, 8784117.51],
		[2501813.55, 8763155.71],
		[2480918.45, 8761668.29],
	]], [[	/* 684:326 */
		[2501813.55, 8763155.71],
		[2500353.49, 8784117.51],
		[2521318.31, 8785554.44],
		[2522718.27, 8764583.17],
		[2501813.55, 8763155.71],
	]], [[	/* 684:327 */
		[2522718.27, 8764583.17],
		[2521318.31, 8785554.44],
		[2542292.44, 8786930.93],
		[2543632.21, 8765950.59],
		[2522718.27, 8764583.17],
	]], [[	/* 684:328 */
		[2543632.21, 8765950.59],
		[2542292.44, 8786930.93],
		[2563275.48, 8788246.90],
		[2564554.98, 8767257.88],
		[2543632.21, 8765950.59],
	]], [[	/* 684:329 */
		[2564554.98, 8767257.88],
		[2563275.48, 8788246.90],
		[2584267.04, 8789502.27],
		[2585486.19, 8768504.97],
		[2564554.98, 8767257.88],
	]], [[	/* 684:330 */
		[2585486.19, 8768504.97],
		[2584267.04, 8789502.27],
		[2605266.73, 8790696.96],
		[2606425.44, 8769691.77],
		[2585486.19, 8768504.97],
	]], [[	/* 684:331 */
		[2606425.44, 8769691.77],
		[2605266.73, 8790696.96],
		[2626274.13, 8791830.89],
		[2627372.34, 8770818.22],
		[2606425.44, 8769691.77],
	]], [[	/* 684:332 */
		[2627372.34, 8770818.22],
		[2626274.13, 8791830.89],
		[2647288.84, 8792903.99],
		[2648326.49, 8771884.23],
		[2627372.34, 8770818.22],
	]], [[	/* 684:333 */
		[2648326.49, 8771884.23],
		[2647288.84, 8792903.99],
		[2668310.48, 8793916.19],
		[2669287.49, 8772889.75],
		[2648326.49, 8771884.23],
	]], [[	/* 684:334 */
		[2669287.49, 8772889.75],
		[2668310.48, 8793916.19],
		[2689338.63, 8794867.44],
		[2690254.94, 8773834.72],
		[2669287.49, 8772889.75],
	]], [[	/* 684:335 */
		[2690254.94, 8773834.72],
		[2689338.63, 8794867.44],
		[2710372.90, 8795757.68],
		[2711228.46, 8774719.07],
		[2690254.94, 8773834.72],
	]], [[	/* 684:336 */
		[2711228.46, 8774719.07],
		[2710372.90, 8795757.68],
		[2731412.87, 8796586.83],
		[2732207.62, 8775542.74],
		[2711228.46, 8774719.07],
	]], [[	/* 684:337 */
		[2732207.62, 8775542.74],
		[2731412.87, 8796586.83],
		[2752458.14, 8797354.87],
		[2753192.04, 8776305.70],
		[2732207.62, 8775542.74],
	]], [[	/* 684:338 */
		[2753192.04, 8776305.70],
		[2752458.14, 8797354.87],
		[2773508.32, 8798061.72],
		[2774181.32, 8777007.88],
		[2753192.04, 8776305.70],
	]], [[	/* 684:339 */
		[2774181.32, 8777007.88],
		[2773508.32, 8798061.72],
		[2794562.99, 8798707.37],
		[2795175.04, 8777649.25],
		[2774181.32, 8777007.88],
	]], [[	/* 684:340 */
		[2795175.04, 8777649.25],
		[2794562.99, 8798707.37],
		[2815621.74, 8799291.75],
		[2816172.81, 8778229.77],
		[2795175.04, 8777649.25],
	]], [[	/* 684:341 */
		[2816172.81, 8778229.77],
		[2815621.74, 8799291.75],
		[2836684.18, 8799814.83],
		[2837174.23, 8778749.39],
		[2816172.81, 8778229.77],
	]], [[	/* 684:342 */
		[2837174.23, 8778749.39],
		[2836684.18, 8799814.83],
		[2857749.89, 8800276.59],
		[2858178.90, 8779208.09],
		[2837174.23, 8778749.39],
	]], [[	/* 684:343 */
		[2858178.90, 8779208.09],
		[2857749.89, 8800276.59],
		[2878818.47, 8800676.99],
		[2879186.40, 8779605.84],
		[2858178.90, 8779208.09],
	]], [[	/* 684:344 */
		[2879186.40, 8779605.84],
		[2878818.47, 8800676.99],
		[2899889.50, 8801016.01],
		[2900196.34, 8779942.62],
		[2879186.40, 8779605.84],
	]], [[	/* 684:345 */
		[2900196.34, 8779942.62],
		[2899889.50, 8801016.01],
		[2920962.59, 8801293.63],
		[2921208.30, 8780218.40],
		[2900196.34, 8779942.62],
	]], [[	/* 684:346 */
		[2921208.30, 8780218.40],
		[2920962.59, 8801293.63],
		[2942037.31, 8801509.82],
		[2942221.90, 8780433.16],
		[2921208.30, 8780218.40],
	]], [[	/* 684:347 */
		[2942221.90, 8780433.16],
		[2942037.31, 8801509.82],
		[2963113.27, 8801664.58],
		[2963236.71, 8780586.89],
		[2942221.90, 8780433.16],
	]], [[	/* 684:348 */
		[2963236.71, 8780586.89],
		[2963113.27, 8801664.58],
		[2984190.06, 8801757.89],
		[2984252.35, 8780679.59],
		[2963236.71, 8780586.89],
	]], [[	/* 684:349 */
		[2984252.35, 8780679.59],
		[2984190.06, 8801757.89],
		[3005267.26, 8801789.76],
		[3005268.39, 8780711.24],
		[2984252.35, 8780679.59],
	]], [[	/* 684:350 */
		[3005268.39, 8780711.24],
		[3005267.26, 8801789.76],
		[3026344.46, 8801760.17],
		[3026284.44, 8780681.85],
		[3005268.39, 8780711.24],
	]], [[	/* 684:351 */
		[3026284.44, 8780681.85],
		[3026344.46, 8801760.17],
		[3047421.27, 8801669.13],
		[3047300.09, 8780591.42],
		[3026284.44, 8780681.85],
	]], [[	/* 684:352 */
		[3047300.09, 8780591.42],
		[3047421.27, 8801669.13],
		[3068497.26, 8801516.65],
		[3068314.94, 8780439.94],
		[3047300.09, 8780591.42],
	]], [[	/* 684:353 */
		[3068314.94, 8780439.94],
		[3068497.26, 8801516.65],
		[3089572.04, 8801302.73],
		[3089328.58, 8780227.44],
		[3068314.94, 8780439.94],
	]], [[	/* 684:354 */
		[3089328.58, 8780227.44],
		[3089572.04, 8801302.73],
		[3110645.18, 8801027.38],
		[3110340.61, 8779953.92],
		[3089328.58, 8780227.44],
	]], [[	/* 684:355 */
		[3110340.61, 8779953.92],
		[3110645.18, 8801027.38],
		[3131716.29, 8800690.64],
		[3131350.62, 8779619.41],
		[3110340.61, 8779953.92],
	]], [[	/* 684:356 */
		[3131350.62, 8779619.41],
		[3131716.29, 8800690.64],
		[3152784.96, 8800292.51],
		[3152358.21, 8779223.91],
		[3131350.62, 8779619.41],
	]], [[	/* 684:357 */
		[3152358.21, 8779223.91],
		[3152784.96, 8800292.51],
		[3173850.77, 8799833.02],
		[3173362.97, 8778767.47],
		[3152358.21, 8779223.91],
	]], [[	/* 684:358 */
		[3173362.97, 8778767.47],
		[3173850.77, 8799833.02],
		[3194913.32, 8799312.20],
		[3194364.51, 8778250.10],
		[3173362.97, 8778767.47],
	]], [[	/* 684:359 */
		[3194364.51, 8778250.10],
		[3194913.32, 8799312.20],
		[3215972.20, 8798730.09],
		[3215362.41, 8777671.84],
		[3194364.51, 8778250.10],
	]], [[	/* 684:360 */
		[3215362.41, 8777671.84],
		[3215972.20, 8798730.09],
		[3237027.01, 8798086.72],
		[3236356.27, 8777032.73],
		[3215362.41, 8777671.84],
	]], [[	/* 684:361 */
		[3236356.27, 8777032.73],
		[3237027.01, 8798086.72],
		[3258077.34, 8797382.13],
		[3257345.70, 8776332.79],
		[3236356.27, 8777032.73],
	]], [[	/* 684:362 */
		[3257345.70, 8776332.79],
		[3258077.34, 8797382.13],
		[3279122.79, 8796616.36],
		[3278330.29, 8775572.09],
		[3257345.70, 8776332.79],
	]], [[	/* 684:363 */
		[3278330.29, 8775572.09],
		[3279122.79, 8796616.36],
		[3300162.94, 8795789.46],
		[3299309.63, 8774750.67],
		[3278330.29, 8775572.09],
	]], [[	/* 684:364 */
		[3299309.63, 8774750.67],
		[3300162.94, 8795789.46],
		[3321197.40, 8794901.49],
		[3320283.34, 8773868.57],
		[3299309.63, 8774750.67],
	]], [[	/* 684:365 */
		[3320283.34, 8773868.57],
		[3321197.40, 8794901.49],
		[3342225.76, 8793952.50],
		[3341251.00, 8772925.85],
		[3320283.34, 8773868.57],
	]], [[	/* 685:319 */
		[2353893.57, 8772374.76],
		[2352003.09, 8793318.78],
		[2372951.50, 8795188.37],
		[2374782.20, 8774232.03],
		[2353893.57, 8772374.76],
	]], [[	/* 685:320 */
		[2374782.20, 8774232.03],
		[2372951.50, 8795188.37],
		[2393912.08, 8796997.83],
		[2395682.88, 8776029.57],
		[2374782.20, 8774232.03],
	]], [[	/* 685:321 */
		[2395682.88, 8776029.57],
		[2393912.08, 8796997.83],
		[2414884.43, 8798747.05],
		[2416595.23, 8777767.27],
		[2395682.88, 8776029.57],
	]], [[	/* 685:322 */
		[2416595.23, 8777767.27],
		[2414884.43, 8798747.05],
		[2435868.17, 8800435.93],
		[2437518.86, 8779445.01],
		[2416595.23, 8777767.27],
	]], [[	/* 685:323 */
		[2437518.86, 8779445.01],
		[2435868.17, 8800435.93],
		[2456862.89, 8802064.36],
		[2458453.38, 8781062.70],
		[2437518.86, 8779445.01],
	]], [[	/* 685:324 */
		[2458453.38, 8781062.70],
		[2456862.89, 8802064.36],
		[2477868.21, 8803632.24],
		[2479398.38, 8782620.23],
		[2458453.38, 8781062.70],
	]], [[	/* 685:325 */
		[2479398.38, 8782620.23],
		[2477868.21, 8803632.24],
		[2498883.73, 8805139.47],
		[2500353.49, 8784117.51],
		[2479398.38, 8782620.23],
	]], [[	/* 685:326 */
		[2500353.49, 8784117.51],
		[2498883.73, 8805139.47],
		[2519909.04, 8806585.96],
		[2521318.31, 8785554.44],
		[2500353.49, 8784117.51],
	]], [[	/* 685:327 */
		[2521318.31, 8785554.44],
		[2519909.04, 8806585.96],
		[2540943.76, 8807971.61],
		[2542292.44, 8786930.93],
		[2521318.31, 8785554.44],
	]], [[	/* 685:328 */
		[2542292.44, 8786930.93],
		[2540943.76, 8807971.61],
		[2561987.47, 8809296.34],
		[2563275.48, 8788246.90],
		[2542292.44, 8786930.93],
	]], [[	/* 685:329 */
		[2563275.48, 8788246.90],
		[2561987.47, 8809296.34],
		[2583039.78, 8810560.07],
		[2584267.04, 8789502.27],
		[2563275.48, 8788246.90],
	]], [[	/* 685:330 */
		[2584267.04, 8789502.27],
		[2583039.78, 8810560.07],
		[2604100.29, 8811762.71],
		[2605266.73, 8790696.96],
		[2584267.04, 8789502.27],
	]], [[	/* 685:331 */
		[2605266.73, 8790696.96],
		[2604100.29, 8811762.71],
		[2625168.59, 8812904.20],
		[2626274.13, 8791830.89],
		[2605266.73, 8790696.96],
	]], [[	/* 685:332 */
		[2626274.13, 8791830.89],
		[2625168.59, 8812904.20],
		[2646244.28, 8813984.45],
		[2647288.84, 8792903.99],
		[2626274.13, 8791830.89],
	]], [[	/* 685:333 */
		[2647288.84, 8792903.99],
		[2646244.28, 8813984.45],
		[2667326.96, 8815003.41],
		[2668310.48, 8793916.19],
		[2647288.84, 8792903.99],
	]], [[	/* 685:334 */
		[2668310.48, 8793916.19],
		[2667326.96, 8815003.41],
		[2688416.21, 8815961.00],
		[2689338.63, 8794867.44],
		[2668310.48, 8793916.19],
	]], [[	/* 685:335 */
		[2689338.63, 8794867.44],
		[2688416.21, 8815961.00],
		[2709511.63, 8816857.17],
		[2710372.90, 8795757.68],
		[2689338.63, 8794867.44],
	]], [[	/* 685:336 */
		[2710372.90, 8795757.68],
		[2709511.63, 8816857.17],
		[2730612.81, 8817691.86],
		[2731412.87, 8796586.83],
		[2710372.90, 8795757.68],
	]], [[	/* 685:337 */
		[2731412.87, 8796586.83],
		[2730612.81, 8817691.86],
		[2751719.35, 8818465.02],
		[2752458.14, 8797354.87],
		[2731412.87, 8796586.83],
	]], [[	/* 685:338 */
		[2752458.14, 8797354.87],
		[2751719.35, 8818465.02],
		[2772830.83, 8819176.60],
		[2773508.32, 8798061.72],
		[2752458.14, 8797354.87],
	]], [[	/* 685:339 */
		[2773508.32, 8798061.72],
		[2772830.83, 8819176.60],
		[2793946.85, 8819826.56],
		[2794562.99, 8798707.37],
		[2773508.32, 8798061.72],
	]], [[	/* 685:340 */
		[2794562.99, 8798707.37],
		[2793946.85, 8819826.56],
		[2815066.99, 8820414.84],
		[2815621.74, 8799291.75],
		[2794562.99, 8798707.37],
	]], [[	/* 685:341 */
		[2815621.74, 8799291.75],
		[2815066.99, 8820414.84],
		[2836190.85, 8820941.42],
		[2836684.18, 8799814.83],
		[2815621.74, 8799291.75],
	]], [[	/* 685:342 */
		[2836684.18, 8799814.83],
		[2836190.85, 8820941.42],
		[2857318.02, 8821406.27],
		[2857749.89, 8800276.59],
		[2836684.18, 8799814.83],
	]], [[	/* 685:343 */
		[2857749.89, 8800276.59],
		[2857318.02, 8821406.27],
		[2878448.08, 8821809.34],
		[2878818.47, 8800676.99],
		[2857749.89, 8800276.59],
	]], [[	/* 685:344 */
		[2878818.47, 8800676.99],
		[2878448.08, 8821809.34],
		[2899580.62, 8822150.63],
		[2899889.50, 8801016.01],
		[2878818.47, 8800676.99],
	]], [[	/* 685:345 */
		[2899889.50, 8801016.01],
		[2899580.62, 8822150.63],
		[2920715.23, 8822430.10],
		[2920962.59, 8801293.63],
		[2899889.50, 8801016.01],
	]], [[	/* 685:346 */
		[2920962.59, 8801293.63],
		[2920715.23, 8822430.10],
		[2941851.50, 8822647.73],
		[2942037.31, 8801509.82],
		[2920962.59, 8801293.63],
	]], [[	/* 685:347 */
		[2942037.31, 8801509.82],
		[2941851.50, 8822647.73],
		[2962989.01, 8822803.53],
		[2963113.27, 8801664.58],
		[2942037.31, 8801509.82],
	]], [[	/* 685:348 */
		[2963113.27, 8801664.58],
		[2962989.01, 8822803.53],
		[2984127.35, 8822897.46],
		[2984190.06, 8801757.89],
		[2963113.27, 8801664.58],
	]], [[	/* 685:349 */
		[2984190.06, 8801757.89],
		[2984127.35, 8822897.46],
		[3005266.12, 8822929.54],
		[3005267.26, 8801789.76],
		[2984190.06, 8801757.89],
	]], [[	/* 685:350 */
		[3005267.26, 8801789.76],
		[3005266.12, 8822929.54],
		[3026404.89, 8822899.75],
		[3026344.46, 8801760.17],
		[3005267.26, 8801789.76],
	]], [[	/* 685:351 */
		[3026344.46, 8801760.17],
		[3026404.89, 8822899.75],
		[3047543.26, 8822808.10],
		[3047421.27, 8801669.13],
		[3026344.46, 8801760.17],
	]], [[	/* 685:352 */
		[3047421.27, 8801669.13],
		[3047543.26, 8822808.10],
		[3068680.80, 8822654.60],
		[3068497.26, 8801516.65],
		[3047421.27, 8801669.13],
	]], [[	/* 685:353 */
		[3068497.26, 8801516.65],
		[3068680.80, 8822654.60],
		[3089817.12, 8822439.25],
		[3089572.04, 8801302.73],
		[3068497.26, 8801516.65],
	]], [[	/* 685:354 */
		[3089572.04, 8801302.73],
		[3089817.12, 8822439.25],
		[3110951.79, 8822162.07],
		[3110645.18, 8801027.38],
		[3089572.04, 8801302.73],
	]], [[	/* 685:355 */
		[3110645.18, 8801027.38],
		[3110951.79, 8822162.07],
		[3132084.41, 8821823.07],
		[3131716.29, 8800690.64],
		[3110645.18, 8801027.38],
	]], [[	/* 685:356 */
		[3131716.29, 8800690.64],
		[3132084.41, 8821823.07],
		[3153214.55, 8821422.28],
		[3152784.96, 8800292.51],
		[3131716.29, 8800690.64],
	]], [[	/* 685:357 */
		[3152784.96, 8800292.51],
		[3153214.55, 8821422.28],
		[3174341.82, 8820959.72],
		[3173850.77, 8799833.02],
		[3152784.96, 8800292.51],
	]], [[	/* 685:358 */
		[3173850.77, 8799833.02],
		[3174341.82, 8820959.72],
		[3195465.80, 8820435.42],
		[3194913.32, 8799312.20],
		[3173850.77, 8799833.02],
	]], [[	/* 685:359 */
		[3194913.32, 8799312.20],
		[3195465.80, 8820435.42],
		[3216586.07, 8819849.42],
		[3215972.20, 8798730.09],
		[3194913.32, 8799312.20],
	]], [[	/* 685:360 */
		[3215972.20, 8798730.09],
		[3216586.07, 8819849.42],
		[3237702.23, 8819201.75],
		[3237027.01, 8798086.72],
		[3215972.20, 8798730.09],
	]], [[	/* 685:361 */
		[3237027.01, 8798086.72],
		[3237702.23, 8819201.75],
		[3258813.87, 8818492.45],
		[3258077.34, 8797382.13],
		[3237027.01, 8798086.72],
	]], [[	/* 685:362 */
		[3258077.34, 8797382.13],
		[3258813.87, 8818492.45],
		[3279920.58, 8817721.57],
		[3279122.79, 8796616.36],
		[3258077.34, 8797382.13],
	]], [[	/* 685:363 */
		[3279122.79, 8796616.36],
		[3279920.58, 8817721.57],
		[3301021.95, 8816889.15],
		[3300162.94, 8795789.46],
		[3279122.79, 8796616.36],
	]], [[	/* 685:364 */
		[3300162.94, 8795789.46],
		[3301021.95, 8816889.15],
		[3322117.56, 8815995.25],
		[3321197.40, 8794901.49],
		[3300162.94, 8795789.46],
	]], [[	/* 685:365 */
		[3321197.40, 8794901.49],
		[3322117.56, 8815995.25],
		[3343207.02, 8815039.93],
		[3342225.76, 8793952.50],
		[3321197.40, 8794901.49],
	]], [[	/* 685:366 */
		[3342225.76, 8793952.50],
		[3343207.02, 8815039.93],
		[3364289.92, 8814023.25],
		[3363247.62, 8792942.55],
		[3342225.76, 8793952.50],
	]], [[	/* 686:320 */
		[2372951.50, 8795188.37],
		[2371108.63, 8816204.64],
		[2392129.50, 8818026.13],
		[2393912.08, 8796997.83],
		[2372951.50, 8795188.37],
	]], [[	/* 686:321 */
		[2393912.08, 8796997.83],
		[2392129.50, 8818026.13],
		[2413162.24, 8819786.99],
		[2414884.43, 8798747.05],
		[2393912.08, 8796997.83],
	]], [[	/* 686:322 */
		[2414884.43, 8798747.05],
		[2413162.24, 8819786.99],
		[2434206.48, 8821487.11],
		[2435868.17, 8800435.93],
		[2414884.43, 8798747.05],
	]], [[	/* 686:323 */
		[2435868.17, 8800435.93],
		[2434206.48, 8821487.11],
		[2455261.82, 8823126.39],
		[2456862.89, 8802064.36],
		[2435868.17, 8800435.93],
	]], [[	/* 686:324 */
		[2456862.89, 8802064.36],
		[2455261.82, 8823126.39],
		[2476327.84, 8824704.71],
		[2477868.21, 8803632.24],
		[2456862.89, 8802064.36],
	]], [[	/* 686:325 */
		[2477868.21, 8803632.24],
		[2476327.84, 8824704.71],
		[2497404.16, 8826221.99],
		[2498883.73, 8805139.47],
		[2477868.21, 8803632.24],
	]], [[	/* 686:326 */
		[2498883.73, 8805139.47],
		[2497404.16, 8826221.99],
		[2518490.38, 8827678.12],
		[2519909.04, 8806585.96],
		[2498883.73, 8805139.47],
	]], [[	/* 686:327 */
		[2519909.04, 8806585.96],
		[2518490.38, 8827678.12],
		[2539586.08, 8829073.02],
		[2540943.76, 8807971.61],
		[2519909.04, 8806585.96],
	]], [[	/* 686:328 */
		[2540943.76, 8807971.61],
		[2539586.08, 8829073.02],
		[2560690.86, 8830406.60],
		[2561987.47, 8809296.34],
		[2540943.76, 8807971.61],
	]], [[	/* 686:329 */
		[2561987.47, 8809296.34],
		[2560690.86, 8830406.60],
		[2581804.33, 8831678.76],
		[2583039.78, 8810560.07],
		[2561987.47, 8809296.34],
	]], [[	/* 686:330 */
		[2583039.78, 8810560.07],
		[2581804.33, 8831678.76],
		[2602926.07, 8832889.44],
		[2604100.29, 8811762.71],
		[2583039.78, 8810560.07],
	]], [[	/* 686:331 */
		[2604100.29, 8811762.71],
		[2602926.07, 8832889.44],
		[2624055.68, 8834038.55],
		[2625168.59, 8812904.20],
		[2604100.29, 8811762.71],
	]], [[	/* 686:332 */
		[2625168.59, 8812904.20],
		[2624055.68, 8834038.55],
		[2645192.74, 8835126.03],
		[2646244.28, 8813984.45],
		[2625168.59, 8812904.20],
	]], [[	/* 686:333 */
		[2646244.28, 8813984.45],
		[2645192.74, 8835126.03],
		[2666336.86, 8836151.80],
		[2667326.96, 8815003.41],
		[2646244.28, 8813984.45],
	]], [[	/* 686:334 */
		[2667326.96, 8815003.41],
		[2666336.86, 8836151.80],
		[2687487.61, 8837115.80],
		[2688416.21, 8815961.00],
		[2667326.96, 8815003.41],
	]], [[	/* 686:335 */
		[2688416.21, 8815961.00],
		[2687487.61, 8837115.80],
		[2708644.59, 8838017.97],
		[2709511.63, 8816857.17],
		[2688416.21, 8815961.00],
	]], [[	/* 686:336 */
		[2709511.63, 8816857.17],
		[2708644.59, 8838017.97],
		[2729807.39, 8838858.24],
		[2730612.81, 8817691.86],
		[2709511.63, 8816857.17],
	]], [[	/* 686:337 */
		[2730612.81, 8817691.86],
		[2729807.39, 8838858.24],
		[2750975.60, 8839636.58],
		[2751719.35, 8818465.02],
		[2730612.81, 8817691.86],
	]], [[	/* 686:338 */
		[2751719.35, 8818465.02],
		[2750975.60, 8839636.58],
		[2772148.80, 8840352.92],
		[2772830.83, 8819176.60],
		[2751719.35, 8818465.02],
	]], [[	/* 686:339 */
		[2772830.83, 8819176.60],
		[2772148.80, 8840352.92],
		[2793326.58, 8841007.23],
		[2793946.85, 8819826.56],
		[2772830.83, 8819176.60],
	]], [[	/* 686:340 */
		[2793946.85, 8819826.56],
		[2793326.58, 8841007.23],
		[2814508.53, 8841599.45],
		[2815066.99, 8820414.84],
		[2793946.85, 8819826.56],
	]], [[	/* 686:341 */
		[2815066.99, 8820414.84],
		[2814508.53, 8841599.45],
		[2835694.22, 8842129.56],
		[2836190.85, 8820941.42],
		[2815066.99, 8820414.84],
	]], [[	/* 686:342 */
		[2836190.85, 8820941.42],
		[2835694.22, 8842129.56],
		[2856883.25, 8842597.52],
		[2857318.02, 8821406.27],
		[2836190.85, 8820941.42],
	]], [[	/* 686:343 */
		[2857318.02, 8821406.27],
		[2856883.25, 8842597.52],
		[2878075.21, 8843003.30],
		[2878448.08, 8821809.34],
		[2857318.02, 8821406.27],
	]], [[	/* 686:344 */
		[2878448.08, 8821809.34],
		[2878075.21, 8843003.30],
		[2899269.67, 8843346.87],
		[2899580.62, 8822150.63],
		[2878448.08, 8821809.34],
	]], [[	/* 686:345 */
		[2899580.62, 8822150.63],
		[2899269.67, 8843346.87],
		[2920466.21, 8843628.21],
		[2920715.23, 8822430.10],
		[2899580.62, 8822150.63],
	]], [[	/* 686:346 */
		[2920715.23, 8822430.10],
		[2920466.21, 8843628.21],
		[2941664.43, 8843847.31],
		[2941851.50, 8822647.73],
		[2920715.23, 8822430.10],
	]], [[	/* 686:347 */
		[2941851.50, 8822647.73],
		[2941664.43, 8843847.31],
		[2962863.91, 8844004.14],
		[2962989.01, 8822803.53],
		[2941851.50, 8822647.73],
	]], [[	/* 686:348 */
		[2962989.01, 8822803.53],
		[2962863.91, 8844004.14],
		[2984064.23, 8844098.71],
		[2984127.35, 8822897.46],
		[2962989.01, 8822803.53],
	]], [[	/* 686:349 */
		[2984127.35, 8822897.46],
		[2984064.23, 8844098.71],
		[3005264.97, 8844131.00],
		[3005266.12, 8822929.54],
		[2984127.35, 8822897.46],
	]], [[	/* 686:350 */
		[3005266.12, 8822929.54],
		[3005264.97, 8844131.00],
		[3026465.72, 8844101.01],
		[3026404.89, 8822899.75],
		[3005266.12, 8822929.54],
	]], [[	/* 686:351 */
		[3026404.89, 8822899.75],
		[3026465.72, 8844101.01],
		[3047666.06, 8844008.75],
		[3047543.26, 8822808.10],
		[3026404.89, 8822899.75],
	]], [[	/* 686:352 */
		[3047543.26, 8822808.10],
		[3047666.06, 8844008.75],
		[3068865.57, 8843854.21],
		[3068680.80, 8822654.60],
		[3047543.26, 8822808.10],
	]], [[	/* 686:353 */
		[3068680.80, 8822654.60],
		[3068865.57, 8843854.21],
		[3090063.84, 8843637.42],
		[3089817.12, 8822439.25],
		[3068680.80, 8822654.60],
	]], [[	/* 686:354 */
		[3089817.12, 8822439.25],
		[3090063.84, 8843637.42],
		[3111260.45, 8843358.38],
		[3110951.79, 8822162.07],
		[3089817.12, 8822439.25],
	]], [[	/* 686:355 */
		[3110951.79, 8822162.07],
		[3111260.45, 8843358.38],
		[3132454.99, 8843017.11],
		[3132084.41, 8821823.07],
		[3110951.79, 8822162.07],
	]], [[	/* 686:356 */
		[3132084.41, 8821823.07],
		[3132454.99, 8843017.11],
		[3153647.03, 8842613.63],
		[3153214.55, 8821422.28],
		[3132084.41, 8821823.07],
	]], [[	/* 686:357 */
		[3153214.55, 8821422.28],
		[3153647.03, 8842613.63],
		[3174836.17, 8842147.97],
		[3174341.82, 8820959.72],
		[3153214.55, 8821422.28],
	]], [[	/* 686:358 */
		[3174341.82, 8820959.72],
		[3174836.17, 8842147.97],
		[3196021.98, 8841620.16],
		[3195465.80, 8820435.42],
		[3174341.82, 8820959.72],
	]], [[	/* 686:359 */
		[3195465.80, 8820435.42],
		[3196021.98, 8841620.16],
		[3217204.05, 8841030.23],
		[3216586.07, 8819849.42],
		[3195465.80, 8820435.42],
	]], [[	/* 686:360 */
		[3216586.07, 8819849.42],
		[3217204.05, 8841030.23],
		[3238381.98, 8840378.22],
		[3237702.23, 8819201.75],
		[3216586.07, 8819849.42],
	]], [[	/* 686:361 */
		[3237702.23, 8819201.75],
		[3238381.98, 8840378.22],
		[3259555.34, 8839664.17],
		[3258813.87, 8818492.45],
		[3237702.23, 8819201.75],
	]], [[	/* 686:362 */
		[3258813.87, 8818492.45],
		[3259555.34, 8839664.17],
		[3280723.71, 8838888.12],
		[3279920.58, 8817721.57],
		[3258813.87, 8818492.45],
	]], [[	/* 686:363 */
		[3279920.58, 8817721.57],
		[3280723.71, 8838888.12],
		[3301886.70, 8838050.13],
		[3301021.95, 8816889.15],
		[3279920.58, 8817721.57],
	]], [[	/* 686:364 */
		[3301021.95, 8816889.15],
		[3301886.70, 8838050.13],
		[3323043.88, 8837150.26],
		[3322117.56, 8815995.25],
		[3301021.95, 8816889.15],
	]], [[	/* 686:365 */
		[3322117.56, 8815995.25],
		[3323043.88, 8837150.26],
		[3344194.85, 8836188.54],
		[3343207.02, 8815039.93],
		[3322117.56, 8815995.25],
	]], [[	/* 686:366 */
		[3343207.02, 8815039.93],
		[3344194.85, 8836188.54],
		[3365339.19, 8835165.06],
		[3364289.92, 8814023.25],
		[3343207.02, 8815039.93],
	]], [[	/* 687:320 */
		[2371108.63, 8816204.64],
		[2369253.48, 8837281.25],
		[2390335.03, 8839114.88],
		[2392129.50, 8818026.13],
		[2371108.63, 8816204.64],
	]], [[	/* 687:321 */
		[2392129.50, 8818026.13],
		[2390335.03, 8839114.88],
		[2411428.57, 8840887.49],
		[2413162.24, 8819786.99],
		[2392129.50, 8818026.13],
	]], [[	/* 687:322 */
		[2413162.24, 8819786.99],
		[2411428.57, 8840887.49],
		[2432533.71, 8842598.96],
		[2434206.48, 8821487.11],
		[2413162.24, 8819786.99],
	]], [[	/* 687:323 */
		[2434206.48, 8821487.11],
		[2432533.71, 8842598.96],
		[2453650.05, 8844249.18],
		[2455261.82, 8823126.39],
		[2434206.48, 8821487.11],
	]], [[	/* 687:324 */
		[2455261.82, 8823126.39],
		[2453650.05, 8844249.18],
		[2474777.18, 8845838.05],
		[2476327.84, 8824704.71],
		[2455261.82, 8823126.39],
	]], [[	/* 687:325 */
		[2476327.84, 8824704.71],
		[2474777.18, 8845838.05],
		[2495914.71, 8847365.47],
		[2497404.16, 8826221.99],
		[2476327.84, 8824704.71],
	]], [[	/* 687:326 */
		[2497404.16, 8826221.99],
		[2495914.71, 8847365.47],
		[2517062.22, 8848831.34],
		[2518490.38, 8827678.12],
		[2497404.16, 8826221.99],
	]], [[	/* 687:327 */
		[2518490.38, 8827678.12],
		[2517062.22, 8848831.34],
		[2538219.31, 8850235.57],
		[2539586.08, 8829073.02],
		[2518490.38, 8827678.12],
	]], [[	/* 687:328 */
		[2539586.08, 8829073.02],
		[2538219.31, 8850235.57],
		[2559385.57, 8851578.07],
		[2560690.86, 8830406.60],
		[2539586.08, 8829073.02],
	]], [[	/* 687:329 */
		[2560690.86, 8830406.60],
		[2559385.57, 8851578.07],
		[2580560.60, 8852858.76],
		[2581804.33, 8831678.76],
		[2560690.86, 8830406.60],
	]], [[	/* 687:330 */
		[2581804.33, 8831678.76],
		[2580560.60, 8852858.76],
		[2601743.98, 8854077.55],
		[2602926.07, 8832889.44],
		[2581804.33, 8831678.76],
	]], [[	/* 687:331 */
		[2602926.07, 8832889.44],
		[2601743.98, 8854077.55],
		[2622935.30, 8855234.36],
		[2624055.68, 8834038.55],
		[2602926.07, 8832889.44],
	]], [[	/* 687:332 */
		[2624055.68, 8834038.55],
		[2622935.30, 8855234.36],
		[2644134.15, 8856329.13],
		[2645192.74, 8835126.03],
		[2624055.68, 8834038.55],
	]], [[	/* 687:333 */
		[2645192.74, 8835126.03],
		[2644134.15, 8856329.13],
		[2665340.11, 8857361.78],
		[2666336.86, 8836151.80],
		[2645192.74, 8835126.03],
	]], [[	/* 687:334 */
		[2666336.86, 8836151.80],
		[2665340.11, 8857361.78],
		[2686552.78, 8858332.24],
		[2687487.61, 8837115.80],
		[2666336.86, 8836151.80],
	]], [[	/* 687:335 */
		[2687487.61, 8837115.80],
		[2686552.78, 8858332.24],
		[2707771.74, 8859240.46],
		[2708644.59, 8838017.97],
		[2687487.61, 8837115.80],
	]], [[	/* 687:336 */
		[2708644.59, 8838017.97],
		[2707771.74, 8859240.46],
		[2728996.58, 8860086.38],
		[2729807.39, 8838858.24],
		[2708644.59, 8838017.97],
	]], [[	/* 687:337 */
		[2729807.39, 8838858.24],
		[2728996.58, 8860086.38],
		[2750226.86, 8860869.94],
		[2750975.60, 8839636.58],
		[2729807.39, 8838858.24],
	]], [[	/* 687:338 */
		[2750975.60, 8839636.58],
		[2750226.86, 8860869.94],
		[2771462.19, 8861591.09],
		[2772148.80, 8840352.92],
		[2750975.60, 8839636.58],
	]], [[	/* 687:339 */
		[2772148.80, 8840352.92],
		[2771462.19, 8861591.09],
		[2792702.15, 8862249.79],
		[2793326.58, 8841007.23],
		[2772148.80, 8840352.92],
	]], [[	/* 687:340 */
		[2793326.58, 8841007.23],
		[2792702.15, 8862249.79],
		[2813946.31, 8862846.00],
		[2814508.53, 8841599.45],
		[2793326.58, 8841007.23],
	]], [[	/* 687:341 */
		[2814508.53, 8841599.45],
		[2813946.31, 8862846.00],
		[2835194.25, 8863379.67],
		[2835694.22, 8842129.56],
		[2814508.53, 8841599.45],
	]], [[	/* 687:342 */
		[2835694.22, 8842129.56],
		[2835194.25, 8863379.67],
		[2856445.57, 8863850.77],
		[2856883.25, 8842597.52],
		[2835694.22, 8842129.56],
	]], [[	/* 687:343 */
		[2856883.25, 8842597.52],
		[2856445.57, 8863850.77],
		[2877699.83, 8864259.27],
		[2878075.21, 8843003.30],
		[2856883.25, 8842597.52],
	]], [[	/* 687:344 */
		[2878075.21, 8843003.30],
		[2877699.83, 8864259.27],
		[2898956.62, 8864605.15],
		[2899269.67, 8843346.87],
		[2878075.21, 8843003.30],
	]], [[	/* 687:345 */
		[2899269.67, 8843346.87],
		[2898956.62, 8864605.15],
		[2920215.52, 8864888.39],
		[2920466.21, 8843628.21],
		[2899269.67, 8843346.87],
	]], [[	/* 687:346 */
		[2920466.21, 8843628.21],
		[2920215.52, 8864888.39],
		[2941476.12, 8865108.96],
		[2941664.43, 8843847.31],
		[2920466.21, 8843628.21],
	]], [[	/* 687:347 */
		[2941664.43, 8843847.31],
		[2941476.12, 8865108.96],
		[2962737.98, 8865266.85],
		[2962863.91, 8844004.14],
		[2941664.43, 8843847.31],
	]], [[	/* 687:348 */
		[2962863.91, 8844004.14],
		[2962737.98, 8865266.85],
		[2984000.68, 8865362.05],
		[2984064.23, 8844098.71],
		[2962863.91, 8844004.14],
	]], [[	/* 687:349 */
		[2984064.23, 8844098.71],
		[2984000.68, 8865362.05],
		[3005263.82, 8865394.55],
		[3005264.97, 8844131.00],
		[2984064.23, 8844098.71],
	]], [[	/* 687:350 */
		[3005264.97, 8844131.00],
		[3005263.82, 8865394.55],
		[3026526.96, 8865364.36],
		[3026465.72, 8844101.01],
		[3005264.97, 8844131.00],
	]], [[	/* 687:351 */
		[3026465.72, 8844101.01],
		[3026526.96, 8865364.36],
		[3047789.69, 8865271.48],
		[3047666.06, 8844008.75],
		[3026465.72, 8844101.01],
	]], [[	/* 687:352 */
		[3047666.06, 8844008.75],
		[3047789.69, 8865271.48],
		[3069051.59, 8865115.90],
		[3068865.57, 8843854.21],
		[3047666.06, 8844008.75],
	]], [[	/* 687:353 */
		[3068865.57, 8843854.21],
		[3069051.59, 8865115.90],
		[3090312.23, 8864897.65],
		[3090063.84, 8843637.42],
		[3068865.57, 8843854.21],
	]], [[	/* 687:354 */
		[3090063.84, 8843637.42],
		[3090312.23, 8864897.65],
		[3111571.19, 8864616.73],
		[3111260.45, 8843358.38],
		[3090063.84, 8843637.42],
	]], [[	/* 687:355 */
		[3111260.45, 8843358.38],
		[3111571.19, 8864616.73],
		[3132828.06, 8864273.16],
		[3132454.99, 8843017.11],
		[3111260.45, 8843358.38],
	]], [[	/* 687:356 */
		[3132454.99, 8843017.11],
		[3132828.06, 8864273.16],
		[3154082.41, 8863866.97],
		[3153647.03, 8842613.63],
		[3132454.99, 8843017.11],
	]], [[	/* 687:357 */
		[3153647.03, 8842613.63],
		[3154082.41, 8863866.97],
		[3175333.83, 8863398.18],
		[3174836.17, 8842147.97],
		[3153647.03, 8842613.63],
	]], [[	/* 687:358 */
		[3174836.17, 8842147.97],
		[3175333.83, 8863398.18],
		[3196581.90, 8862866.82],
		[3196021.98, 8841620.16],
		[3174836.17, 8842147.97],
	]], [[	/* 687:359 */
		[3196021.98, 8841620.16],
		[3196581.90, 8862866.82],
		[3217826.19, 8862272.93],
		[3217204.05, 8841030.23],
		[3196021.98, 8841620.16],
	]], [[	/* 687:360 */
		[3217204.05, 8841030.23],
		[3217826.19, 8862272.93],
		[3239066.29, 8861616.54],
		[3238381.98, 8840378.22],
		[3217204.05, 8841030.23],
	]], [[	/* 687:361 */
		[3238381.98, 8840378.22],
		[3239066.29, 8861616.54],
		[3260301.78, 8860897.69],
		[3259555.34, 8839664.17],
		[3238381.98, 8840378.22],
	]], [[	/* 687:362 */
		[3259555.34, 8839664.17],
		[3260301.78, 8860897.69],
		[3281532.24, 8860116.44],
		[3280723.71, 8838888.12],
		[3259555.34, 8839664.17],
	]], [[	/* 687:363 */
		[3280723.71, 8838888.12],
		[3281532.24, 8860116.44],
		[3302757.26, 8859272.82],
		[3301886.70, 8838050.13],
		[3280723.71, 8838888.12],
	]], [[	/* 687:364 */
		[3301886.70, 8838050.13],
		[3302757.26, 8859272.82],
		[3323976.42, 8858366.91],
		[3323043.88, 8837150.26],
		[3301886.70, 8838050.13],
	]], [[	/* 687:365 */
		[3323043.88, 8837150.26],
		[3323976.42, 8858366.91],
		[3345189.30, 8857398.74],
		[3344194.85, 8836188.54],
		[3323043.88, 8837150.26],
	]], [[	/* 687:366 */
		[3344194.85, 8836188.54],
		[3345189.30, 8857398.74],
		[3366395.50, 8856368.39],
		[3365339.19, 8835165.06],
		[3344194.85, 8836188.54],
	]], [[	/* 687:367 */
		[3365339.19, 8835165.06],
		[3366395.50, 8856368.39],
		[3387594.59, 8855275.92],
		[3386476.50, 8834079.86],
		[3365339.19, 8835165.06],
	]], [[	/* 688:319 */
		[2348184.34, 8835386.70],
		[2346255.83, 8856511.37],
		[2367385.94, 8858418.58],
		[2369253.48, 8837281.25],
		[2348184.34, 8835386.70],
	]], [[	/* 688:320 */
		[2369253.48, 8837281.25],
		[2367385.94, 8858418.58],
		[2388528.55, 8860264.47],
		[2390335.03, 8839114.88],
		[2369253.48, 8837281.25],
	]], [[	/* 688:321 */
		[2390335.03, 8839114.88],
		[2388528.55, 8860264.47],
		[2409683.29, 8862048.94],
		[2411428.57, 8840887.49],
		[2390335.03, 8839114.88],
	]], [[	/* 688:322 */
		[2411428.57, 8840887.49],
		[2409683.29, 8862048.94],
		[2430849.73, 8863771.87],
		[2432533.71, 8842598.96],
		[2411428.57, 8840887.49],
	]], [[	/* 688:323 */
		[2432533.71, 8842598.96],
		[2430849.73, 8863771.87],
		[2452027.48, 8865433.14],
		[2453650.05, 8844249.18],
		[2432533.71, 8842598.96],
	]], [[	/* 688:324 */
		[2453650.05, 8844249.18],
		[2452027.48, 8865433.14],
		[2473216.13, 8867032.66],
		[2474777.18, 8845838.05],
		[2453650.05, 8844249.18],
	]], [[	/* 688:325 */
		[2474777.18, 8845838.05],
		[2473216.13, 8867032.66],
		[2494415.26, 8868570.32],
		[2495914.71, 8847365.47],
		[2474777.18, 8845838.05],
	]], [[	/* 688:326 */
		[2495914.71, 8847365.47],
		[2494415.26, 8868570.32],
		[2515624.48, 8870046.02],
		[2517062.22, 8848831.34],
		[2495914.71, 8847365.47],
	]], [[	/* 688:327 */
		[2517062.22, 8848831.34],
		[2515624.48, 8870046.02],
		[2536843.37, 8871459.67],
		[2538219.31, 8850235.57],
		[2517062.22, 8848831.34],
	]], [[	/* 688:328 */
		[2538219.31, 8850235.57],
		[2536843.37, 8871459.67],
		[2558071.52, 8872811.18],
		[2559385.57, 8851578.07],
		[2538219.31, 8850235.57],
	]], [[	/* 688:329 */
		[2559385.57, 8851578.07],
		[2558071.52, 8872811.18],
		[2579308.52, 8874100.47],
		[2580560.60, 8852858.76],
		[2559385.57, 8851578.07],
	]], [[	/* 688:330 */
		[2580560.60, 8852858.76],
		[2579308.52, 8874100.47],
		[2600553.94, 8875327.44],
		[2601743.98, 8854077.55],
		[2580560.60, 8852858.76],
	]], [[	/* 688:331 */
		[2601743.98, 8854077.55],
		[2600553.94, 8875327.44],
		[2621807.39, 8876492.03],
		[2622935.30, 8855234.36],
		[2601743.98, 8854077.55],
	]], [[	/* 688:332 */
		[2622935.30, 8855234.36],
		[2621807.39, 8876492.03],
		[2643068.44, 8877594.16],
		[2644134.15, 8856329.13],
		[2622935.30, 8855234.36],
	]], [[	/* 688:333 */
		[2644134.15, 8856329.13],
		[2643068.44, 8877594.16],
		[2664336.67, 8878633.75],
		[2665340.11, 8857361.78],
		[2644134.15, 8856329.13],
	]], [[	/* 688:334 */
		[2665340.11, 8857361.78],
		[2664336.67, 8878633.75],
		[2685611.67, 8879610.75],
		[2686552.78, 8858332.24],
		[2665340.11, 8857361.78],
	]], [[	/* 688:335 */
		[2686552.78, 8858332.24],
		[2685611.67, 8879610.75],
		[2706893.02, 8880525.08],
		[2707771.74, 8859240.46],
		[2686552.78, 8858332.24],
	]], [[	/* 688:336 */
		[2707771.74, 8859240.46],
		[2706893.02, 8880525.08],
		[2728180.30, 8881376.69],
		[2728996.58, 8860086.38],
		[2707771.74, 8859240.46],
	]], [[	/* 688:337 */
		[2728996.58, 8860086.38],
		[2728180.30, 8881376.69],
		[2749473.09, 8882165.53],
		[2750226.86, 8860869.94],
		[2728996.58, 8860086.38],
	]], [[	/* 688:338 */
		[2750226.86, 8860869.94],
		[2749473.09, 8882165.53],
		[2770770.96, 8882891.53],
		[2771462.19, 8861591.09],
		[2750226.86, 8860869.94],
	]], [[	/* 688:339 */
		[2771462.19, 8861591.09],
		[2770770.96, 8882891.53],
		[2792073.51, 8883554.67],
		[2792702.15, 8862249.79],
		[2771462.19, 8861591.09],
	]], [[	/* 688:340 */
		[2792702.15, 8862249.79],
		[2792073.51, 8883554.67],
		[2813380.30, 8884154.89],
		[2813946.31, 8862846.00],
		[2792702.15, 8862249.79],
	]], [[	/* 688:341 */
		[2813946.31, 8862846.00],
		[2813380.30, 8884154.89],
		[2834690.92, 8884692.16],
		[2835194.25, 8863379.67],
		[2813946.31, 8862846.00],
	]], [[	/* 688:342 */
		[2835194.25, 8863379.67],
		[2834690.92, 8884692.16],
		[2856004.93, 8885166.43],
		[2856445.57, 8863850.77],
		[2835194.25, 8863379.67],
	]], [[	/* 688:343 */
		[2856445.57, 8863850.77],
		[2856004.93, 8885166.43],
		[2877321.92, 8885577.69],
		[2877699.83, 8864259.27],
		[2856445.57, 8863850.77],
	]], [[	/* 688:344 */
		[2877699.83, 8864259.27],
		[2877321.92, 8885577.69],
		[2898641.47, 8885925.90],
		[2898956.62, 8864605.15],
		[2877699.83, 8864259.27],
	]], [[	/* 688:345 */
		[2898956.62, 8864605.15],
		[2898641.47, 8885925.90],
		[2919963.15, 8886211.04],
		[2920215.52, 8864888.39],
		[2898956.62, 8864605.15],
	]], [[	/* 688:346 */
		[2920215.52, 8864888.39],
		[2919963.15, 8886211.04],
		[2941286.53, 8886433.10],
		[2941476.12, 8865108.96],
		[2920215.52, 8864888.39],
	]], [[	/* 688:347 */
		[2941476.12, 8865108.96],
		[2941286.53, 8886433.10],
		[2962611.19, 8886592.05],
		[2962737.98, 8865266.85],
		[2941476.12, 8865108.96],
	]], [[	/* 688:348 */
		[2962737.98, 8865266.85],
		[2962611.19, 8886592.05],
		[2983936.71, 8886687.90],
		[2984000.68, 8865362.05],
		[2962737.98, 8865266.85],
	]], [[	/* 688:349 */
		[2984000.68, 8865362.05],
		[2983936.71, 8886687.90],
		[3005262.66, 8886720.62],
		[3005263.82, 8865394.55],
		[2984000.68, 8865362.05],
	]], [[	/* 688:350 */
		[3005263.82, 8865394.55],
		[3005262.66, 8886720.62],
		[3026588.62, 8886690.23],
		[3026526.96, 8865364.36],
		[3005263.82, 8865394.55],
	]], [[	/* 688:351 */
		[3026526.96, 8865364.36],
		[3026588.62, 8886690.23],
		[3047914.16, 8886596.71],
		[3047789.69, 8865271.48],
		[3026526.96, 8865364.36],
	]], [[	/* 688:352 */
		[3047789.69, 8865271.48],
		[3047914.16, 8886596.71],
		[3069238.86, 8886440.09],
		[3069051.59, 8865115.90],
		[3047789.69, 8865271.48],
	]], [[	/* 688:353 */
		[3069051.59, 8865115.90],
		[3069238.86, 8886440.09],
		[3090562.29, 8886220.36],
		[3090312.23, 8864897.65],
		[3069051.59, 8865115.90],
	]], [[	/* 688:354 */
		[3090312.23, 8864897.65],
		[3090562.29, 8886220.36],
		[3111884.03, 8885937.55],
		[3111571.19, 8864616.73],
		[3090312.23, 8864897.65],
	]], [[	/* 688:355 */
		[3111571.19, 8864616.73],
		[3111884.03, 8885937.55],
		[3133203.65, 8885591.66],
		[3132828.06, 8864273.16],
		[3111571.19, 8864616.73],
	]], [[	/* 688:356 */
		[3132828.06, 8864273.16],
		[3133203.65, 8885591.66],
		[3154520.73, 8885182.73],
		[3154082.41, 8863866.97],
		[3132828.06, 8864273.16],
	]], [[	/* 688:357 */
		[3154082.41, 8863866.97],
		[3154520.73, 8885182.73],
		[3175834.85, 8884710.78],
		[3175333.83, 8863398.18],
		[3154082.41, 8863866.97],
	]], [[	/* 688:358 */
		[3175333.83, 8863398.18],
		[3175834.85, 8884710.78],
		[3197145.59, 8884175.84],
		[3196581.90, 8862866.82],
		[3175333.83, 8863398.18],
	]], [[	/* 688:359 */
		[3196581.90, 8862866.82],
		[3197145.59, 8884175.84],
		[3218452.51, 8883577.95],
		[3217826.19, 8862272.93],
		[3196581.90, 8862866.82],
	]], [[	/* 688:360 */
		[3217826.19, 8862272.93],
		[3218452.51, 8883577.95],
		[3239755.21, 8882917.13],
		[3239066.29, 8861616.54],
		[3217826.19, 8862272.93],
	]], [[	/* 688:361 */
		[3239066.29, 8861616.54],
		[3239755.21, 8882917.13],
		[3261053.24, 8882193.44],
		[3260301.78, 8860897.69],
		[3239066.29, 8861616.54],
	]], [[	/* 688:362 */
		[3260301.78, 8860897.69],
		[3261053.24, 8882193.44],
		[3282346.21, 8881406.93],
		[3281532.24, 8860116.44],
		[3260301.78, 8860897.69],
	]], [[	/* 688:363 */
		[3281532.24, 8860116.44],
		[3282346.21, 8881406.93],
		[3303633.68, 8880557.63],
		[3302757.26, 8859272.82],
		[3281532.24, 8860116.44],
	]], [[	/* 688:364 */
		[3302757.26, 8859272.82],
		[3303633.68, 8880557.63],
		[3324915.23, 8879645.62],
		[3323976.42, 8858366.91],
		[3302757.26, 8859272.82],
	]], [[	/* 688:365 */
		[3323976.42, 8858366.91],
		[3324915.23, 8879645.62],
		[3346190.44, 8878670.94],
		[3345189.30, 8857398.74],
		[3323976.42, 8858366.91],
	]], [[	/* 688:366 */
		[3345189.30, 8857398.74],
		[3346190.44, 8878670.94],
		[3367458.91, 8877633.66],
		[3366395.50, 8856368.39],
		[3345189.30, 8857398.74],
	]], [[	/* 688:367 */
		[3366395.50, 8856368.39],
		[3367458.91, 8877633.66],
		[3388720.20, 8876533.84],
		[3387594.59, 8855275.92],
		[3366395.50, 8856368.39],
	]], [[	/* 688:368 */
		[3387594.59, 8855275.92],
		[3388720.20, 8876533.84],
		[3409973.90, 8875371.56],
		[3408786.17, 8854121.40],
		[3387594.59, 8855275.92],
	]], [[	/* 689:319 */
		[2346255.83, 8856511.37],
		[2344314.41, 8877697.05],
		[2365505.87, 8879617.04],
		[2367385.94, 8858418.58],
		[2346255.83, 8856511.37],
	]], [[	/* 689:320 */
		[2367385.94, 8858418.58],
		[2365505.87, 8879617.04],
		[2386709.97, 8881475.31],
		[2388528.55, 8860264.47],
		[2367385.94, 8858418.58],
	]], [[	/* 689:321 */
		[2388528.55, 8860264.47],
		[2386709.97, 8881475.31],
		[2407926.30, 8883271.75],
		[2409683.29, 8862048.94],
		[2388528.55, 8860264.47],
	]], [[	/* 689:322 */
		[2409683.29, 8862048.94],
		[2407926.30, 8883271.75],
		[2429154.45, 8885006.24],
		[2430849.73, 8863771.87],
		[2409683.29, 8862048.94],
	]], [[	/* 689:323 */
		[2430849.73, 8863771.87],
		[2429154.45, 8885006.24],
		[2450394.01, 8886678.67],
		[2452027.48, 8865433.14],
		[2430849.73, 8863771.87],
	]], [[	/* 689:324 */
		[2452027.48, 8865433.14],
		[2450394.01, 8886678.67],
		[2471644.58, 8888288.94],
		[2473216.13, 8867032.66],
		[2452027.48, 8865433.14],
	]], [[	/* 689:325 */
		[2473216.13, 8867032.66],
		[2471644.58, 8888288.94],
		[2492905.74, 8889836.93],
		[2494415.26, 8868570.32],
		[2473216.13, 8867032.66],
	]], [[	/* 689:326 */
		[2494415.26, 8868570.32],
		[2492905.74, 8889836.93],
		[2514177.08, 8891322.56],
		[2515624.48, 8870046.02],
		[2494415.26, 8868570.32],
	]], [[	/* 689:327 */
		[2515624.48, 8870046.02],
		[2514177.08, 8891322.56],
		[2535458.17, 8892745.72],
		[2536843.37, 8871459.67],
		[2515624.48, 8870046.02],
	]], [[	/* 689:328 */
		[2536843.37, 8871459.67],
		[2535458.17, 8892745.72],
		[2556748.62, 8894106.33],
		[2558071.52, 8872811.18],
		[2536843.37, 8871459.67],
	]], [[	/* 689:329 */
		[2558071.52, 8872811.18],
		[2556748.62, 8894106.33],
		[2578048.00, 8895404.30],
		[2579308.52, 8874100.47],
		[2558071.52, 8872811.18],
	]], [[	/* 689:330 */
		[2579308.52, 8874100.47],
		[2578048.00, 8895404.30],
		[2599355.89, 8896639.54],
		[2600553.94, 8875327.44],
		[2579308.52, 8874100.47],
	]], [[	/* 689:331 */
		[2600553.94, 8875327.44],
		[2599355.89, 8896639.54],
		[2620671.88, 8897811.98],
		[2621807.39, 8876492.03],
		[2600553.94, 8875327.44],
	]], [[	/* 689:332 */
		[2621807.39, 8876492.03],
		[2620671.88, 8897811.98],
		[2641995.54, 8898921.54],
		[2643068.44, 8877594.16],
		[2621807.39, 8876492.03],
	]], [[	/* 689:333 */
		[2643068.44, 8877594.16],
		[2641995.54, 8898921.54],
		[2663326.46, 8899968.14],
		[2664336.67, 8878633.75],
		[2643068.44, 8877594.16],
	]], [[	/* 689:334 */
		[2664336.67, 8878633.75],
		[2663326.46, 8899968.14],
		[2684664.21, 8900951.73],
		[2685611.67, 8879610.75],
		[2664336.67, 8878633.75],
	]], [[	/* 689:335 */
		[2685611.67, 8879610.75],
		[2684664.21, 8900951.73],
		[2706008.37, 8901872.23],
		[2706893.02, 8880525.08],
		[2685611.67, 8879610.75],
	]], [[	/* 689:336 */
		[2706893.02, 8880525.08],
		[2706008.37, 8901872.23],
		[2727358.51, 8902729.59],
		[2728180.30, 8881376.69],
		[2706893.02, 8880525.08],
	]], [[	/* 689:337 */
		[2728180.30, 8881376.69],
		[2727358.51, 8902729.59],
		[2748714.22, 8903523.75],
		[2749473.09, 8882165.53],
		[2728180.30, 8881376.69],
	]], [[	/* 689:338 */
		[2749473.09, 8882165.53],
		[2748714.22, 8903523.75],
		[2770075.07, 8904254.66],
		[2770770.96, 8882891.53],
		[2749473.09, 8882165.53],
	]], [[	/* 689:339 */
		[2770770.96, 8882891.53],
		[2770075.07, 8904254.66],
		[2791440.63, 8904922.28],
		[2792073.51, 8883554.67],
		[2770770.96, 8882891.53],
	]], [[	/* 689:340 */
		[2792073.51, 8883554.67],
		[2791440.63, 8904922.28],
		[2812810.47, 8905526.55],
		[2813380.30, 8884154.89],
		[2792073.51, 8883554.67],
	]], [[	/* 689:341 */
		[2813380.30, 8884154.89],
		[2812810.47, 8905526.55],
		[2834184.18, 8906067.45],
		[2834690.92, 8884692.16],
		[2813380.30, 8884154.89],
	]], [[	/* 689:342 */
		[2834690.92, 8884692.16],
		[2834184.18, 8906067.45],
		[2855561.32, 8906544.93],
		[2856004.93, 8885166.43],
		[2834690.92, 8884692.16],
	]], [[	/* 689:343 */
		[2856004.93, 8885166.43],
		[2855561.32, 8906544.93],
		[2876941.46, 8906958.97],
		[2877321.92, 8885577.69],
		[2856004.93, 8885166.43],
	]], [[	/* 689:344 */
		[2877321.92, 8885577.69],
		[2876941.46, 8906958.97],
		[2898324.19, 8907309.53],
		[2898641.47, 8885925.90],
		[2877321.92, 8885577.69],
	]], [[	/* 689:345 */
		[2898641.47, 8885925.90],
		[2898324.19, 8907309.53],
		[2919709.06, 8907596.60],
		[2919963.15, 8886211.04],
		[2898641.47, 8885925.90],
	]], [[	/* 689:346 */
		[2919963.15, 8886211.04],
		[2919709.06, 8907596.60],
		[2941095.66, 8907820.16],
		[2941286.53, 8886433.10],
		[2919963.15, 8886211.04],
	]], [[	/* 689:347 */
		[2941286.53, 8886433.10],
		[2941095.66, 8907820.16],
		[2962483.55, 8907980.18],
		[2962611.19, 8886592.05],
		[2941286.53, 8886433.10],
	]], [[	/* 689:348 */
		[2962611.19, 8886592.05],
		[2962483.55, 8907980.18],
		[2983872.30, 8908076.67],
		[2983936.71, 8886687.90],
		[2962611.19, 8886592.05],
	]], [[	/* 689:349 */
		[2983936.71, 8886687.90],
		[2983872.30, 8908076.67],
		[3005261.49, 8908109.62],
		[3005262.66, 8886720.62],
		[2983936.71, 8886687.90],
	]], [[	/* 689:350 */
		[3005262.66, 8886720.62],
		[3005261.49, 8908109.62],
		[3026650.69, 8908079.02],
		[3026588.62, 8886690.23],
		[3005262.66, 8886720.62],
	]], [[	/* 689:351 */
		[3026588.62, 8886690.23],
		[3026650.69, 8908079.02],
		[3048039.47, 8907984.87],
		[3047914.16, 8886596.71],
		[3026588.62, 8886690.23],
	]], [[	/* 689:352 */
		[3047914.16, 8886596.71],
		[3048039.47, 8907984.87],
		[3069427.39, 8907827.19],
		[3069238.86, 8886440.09],
		[3047914.16, 8886596.71],
	]], [[	/* 689:353 */
		[3069238.86, 8886440.09],
		[3069427.39, 8907827.19],
		[3090814.04, 8907605.97],
		[3090562.29, 8886220.36],
		[3069238.86, 8886440.09],
	]], [[	/* 689:354 */
		[3090562.29, 8886220.36],
		[3090814.04, 8907605.97],
		[3112198.98, 8907321.25],
		[3111884.03, 8885937.55],
		[3090562.29, 8886220.36],
	]], [[	/* 689:355 */
		[3111884.03, 8885937.55],
		[3112198.98, 8907321.25],
		[3133581.78, 8906973.03],
		[3133203.65, 8885591.66],
		[3111884.03, 8885937.55],
	]], [[	/* 689:356 */
		[3133203.65, 8885591.66],
		[3133581.78, 8906973.03],
		[3154962.02, 8906561.33],
		[3154520.73, 8885182.73],
		[3133203.65, 8885591.66],
	]], [[	/* 689:357 */
		[3154520.73, 8885182.73],
		[3154962.02, 8906561.33],
		[3176339.26, 8906086.19],
		[3175834.85, 8884710.78],
		[3154520.73, 8885182.73],
	]], [[	/* 689:358 */
		[3175834.85, 8884710.78],
		[3176339.26, 8906086.19],
		[3197713.09, 8905547.63],
		[3197145.59, 8884175.84],
		[3175834.85, 8884710.78],
	]], [[	/* 689:359 */
		[3197145.59, 8884175.84],
		[3197713.09, 8905547.63],
		[3219083.07, 8904945.69],
		[3218452.51, 8883577.95],
		[3197145.59, 8884175.84],
	]], [[	/* 689:360 */
		[3218452.51, 8883577.95],
		[3219083.07, 8904945.69],
		[3240448.78, 8904280.42],
		[3239755.21, 8882917.13],
		[3218452.51, 8883577.95],
	]], [[	/* 689:361 */
		[3239755.21, 8882917.13],
		[3240448.78, 8904280.42],
		[3261809.79, 8903551.84],
		[3261053.24, 8882193.44],
		[3239755.21, 8882917.13],
	]], [[	/* 689:362 */
		[3261053.24, 8882193.44],
		[3261809.79, 8903551.84],
		[3283165.67, 8902760.01],
		[3282346.21, 8881406.93],
		[3261053.24, 8882193.44],
	]], [[	/* 689:363 */
		[3282346.21, 8881406.93],
		[3283165.67, 8902760.01],
		[3304516.01, 8901904.98],
		[3303633.68, 8880557.63],
		[3282346.21, 8881406.93],
	]], [[	/* 689:364 */
		[3303633.68, 8880557.63],
		[3304516.01, 8901904.98],
		[3325860.37, 8900986.81],
		[3324915.23, 8879645.62],
		[3303633.68, 8880557.63],
	]], [[	/* 689:365 */
		[3324915.23, 8879645.62],
		[3325860.37, 8900986.81],
		[3347198.34, 8900005.55],
		[3346190.44, 8878670.94],
		[3324915.23, 8879645.62],
	]], [[	/* 689:366 */
		[3346190.44, 8878670.94],
		[3347198.34, 8900005.55],
		[3368529.49, 8898961.27],
		[3367458.91, 8877633.66],
		[3346190.44, 8878670.94],
	]], [[	/* 689:367 */
		[3367458.91, 8877633.66],
		[3368529.49, 8898961.27],
		[3389853.40, 8897854.04],
		[3388720.20, 8876533.84],
		[3367458.91, 8877633.66],
	]], [[	/* 689:368 */
		[3388720.20, 8876533.84],
		[3389853.40, 8897854.04],
		[3411169.65, 8896683.92],
		[3409973.90, 8875371.56],
		[3388720.20, 8876533.84],
	]], [[	/* 690:320 */
		[2365505.87, 8879617.04],
		[2363613.17, 8900877.03],
		[2384879.15, 8902747.80],
		[2386709.97, 8881475.31],
		[2365505.87, 8879617.04],
	]], [[	/* 690:321 */
		[2386709.97, 8881475.31],
		[2384879.15, 8902747.80],
		[2406157.49, 8904556.32],
		[2407926.30, 8883271.75],
		[2386709.97, 8881475.31],
	]], [[	/* 690:322 */
		[2407926.30, 8883271.75],
		[2406157.49, 8904556.32],
		[2427447.75, 8906302.49],
		[2429154.45, 8885006.24],
		[2407926.30, 8883271.75],
	]], [[	/* 690:323 */
		[2429154.45, 8885006.24],
		[2427447.75, 8906302.49],
		[2448749.55, 8907986.18],
		[2450394.01, 8886678.67],
		[2429154.45, 8885006.24],
	]], [[	/* 690:324 */
		[2450394.01, 8886678.67],
		[2448749.55, 8907986.18],
		[2470062.44, 8909607.30],
		[2471644.58, 8888288.94],
		[2450394.01, 8886678.67],
	]], [[	/* 690:325 */
		[2471644.58, 8888288.94],
		[2470062.44, 8909607.30],
		[2491386.04, 8911165.73],
		[2492905.74, 8889836.93],
		[2471644.58, 8888288.94],
	]], [[	/* 690:326 */
		[2492905.74, 8889836.93],
		[2491386.04, 8911165.73],
		[2512719.90, 8912661.38],
		[2514177.08, 8891322.56],
		[2492905.74, 8889836.93],
	]], [[	/* 690:327 */
		[2514177.08, 8891322.56],
		[2512719.90, 8912661.38],
		[2534063.63, 8914094.15],
		[2535458.17, 8892745.72],
		[2514177.08, 8891322.56],
	]], [[	/* 690:328 */
		[2535458.17, 8892745.72],
		[2534063.63, 8914094.15],
		[2555416.79, 8915463.94],
		[2556748.62, 8894106.33],
		[2535458.17, 8892745.72],
	]], [[	/* 690:329 */
		[2556748.62, 8894106.33],
		[2555416.79, 8915463.94],
		[2576778.97, 8916770.67],
		[2578048.00, 8895404.30],
		[2556748.62, 8894106.33],
	]], [[	/* 690:330 */
		[2578048.00, 8895404.30],
		[2576778.97, 8916770.67],
		[2598149.75, 8918014.26],
		[2599355.89, 8896639.54],
		[2578048.00, 8895404.30],
	]], [[	/* 690:331 */
		[2599355.89, 8896639.54],
		[2598149.75, 8918014.26],
		[2619528.70, 8919194.62],
		[2620671.88, 8897811.98],
		[2599355.89, 8896639.54],
	]], [[	/* 690:332 */
		[2620671.88, 8897811.98],
		[2619528.70, 8919194.62],
		[2640915.39, 8920311.68],
		[2641995.54, 8898921.54],
		[2620671.88, 8897811.98],
	]], [[	/* 690:333 */
		[2641995.54, 8898921.54],
		[2640915.39, 8920311.68],
		[2662309.41, 8921365.37],
		[2663326.46, 8899968.14],
		[2641995.54, 8898921.54],
	]], [[	/* 690:334 */
		[2663326.46, 8899968.14],
		[2662309.41, 8921365.37],
		[2683710.33, 8922355.61],
		[2684664.21, 8900951.73],
		[2663326.46, 8899968.14],
	]], [[	/* 690:335 */
		[2684664.21, 8900951.73],
		[2683710.33, 8922355.61],
		[2705117.73, 8923282.34],
		[2706008.37, 8901872.23],
		[2684664.21, 8900951.73],
	]], [[	/* 690:336 */
		[2706008.37, 8901872.23],
		[2705117.73, 8923282.34],
		[2726531.16, 8924145.50],
		[2727358.51, 8902729.59],
		[2706008.37, 8901872.23],
	]], [[	/* 690:337 */
		[2727358.51, 8902729.59],
		[2726531.16, 8924145.50],
		[2747950.22, 8924945.04],
		[2748714.22, 8903523.75],
		[2727358.51, 8902729.59],
	]], [[	/* 690:338 */
		[2748714.22, 8903523.75],
		[2747950.22, 8924945.04],
		[2769374.46, 8925680.90],
		[2770075.07, 8904254.66],
		[2748714.22, 8903523.75],
	]], [[	/* 690:339 */
		[2770075.07, 8904254.66],
		[2769374.46, 8925680.90],
		[2790803.45, 8926353.04],
		[2791440.63, 8904922.28],
		[2770075.07, 8904254.66],
	]], [[	/* 690:340 */
		[2791440.63, 8904922.28],
		[2790803.45, 8926353.04],
		[2812236.78, 8926961.41],
		[2812810.47, 8905526.55],
		[2791440.63, 8904922.28],
	]], [[	/* 690:341 */
		[2812810.47, 8905526.55],
		[2812236.78, 8926961.41],
		[2833674.01, 8927505.97],
		[2834184.18, 8906067.45],
		[2812810.47, 8905526.55],
	]], [[	/* 690:342 */
		[2834184.18, 8906067.45],
		[2833674.01, 8927505.97],
		[2855114.70, 8927986.69],
		[2855561.32, 8906544.93],
		[2834184.18, 8906067.45],
	]], [[	/* 690:343 */
		[2855561.32, 8906544.93],
		[2855114.70, 8927986.69],
		[2876558.43, 8928403.53],
		[2876941.46, 8906958.97],
		[2855561.32, 8906544.93],
	]], [[	/* 690:344 */
		[2876941.46, 8906958.97],
		[2876558.43, 8928403.53],
		[2898004.76, 8928756.47],
		[2898324.19, 8907309.53],
		[2876941.46, 8906958.97],
	]], [[	/* 690:345 */
		[2898324.19, 8907309.53],
		[2898004.76, 8928756.47],
		[2919453.26, 8929045.49],
		[2919709.06, 8907596.60],
		[2898324.19, 8907309.53],
	]], [[	/* 690:346 */
		[2919709.06, 8907596.60],
		[2919453.26, 8929045.49],
		[2940903.50, 8929270.56],
		[2941095.66, 8907820.16],
		[2919709.06, 8907596.60],
	]], [[	/* 690:347 */
		[2941095.66, 8907820.16],
		[2940903.50, 8929270.56],
		[2962355.04, 8929431.67],
		[2962483.55, 8907980.18],
		[2941095.66, 8907820.16],
	]], [[	/* 690:348 */
		[2962483.55, 8907980.18],
		[2962355.04, 8929431.67],
		[2983807.46, 8929528.81],
		[2983872.30, 8908076.67],
		[2962483.55, 8907980.18],
	]], [[	/* 690:349 */
		[2983872.30, 8908076.67],
		[2983807.46, 8929528.81],
		[3005260.32, 8929561.98],
		[3005261.49, 8908109.62],
		[2983872.30, 8908076.67],
	]], [[	/* 690:350 */
		[3005261.49, 8908109.62],
		[3005260.32, 8929561.98],
		[3026713.19, 8929531.17],
		[3026650.69, 8908079.02],
		[3005261.49, 8908109.62],
	]], [[	/* 690:351 */
		[3026650.69, 8908079.02],
		[3026713.19, 8929531.17],
		[3048165.63, 8929436.39],
		[3048039.47, 8907984.87],
		[3026650.69, 8908079.02],
	]], [[	/* 690:352 */
		[3048039.47, 8907984.87],
		[3048165.63, 8929436.39],
		[3069617.21, 8929277.63],
		[3069427.39, 8907827.19],
		[3048039.47, 8907984.87],
	]], [[	/* 690:353 */
		[3069427.39, 8907827.19],
		[3069617.21, 8929277.63],
		[3091067.50, 8929054.92],
		[3090814.04, 8907605.97],
		[3069427.39, 8907827.19],
	]], [[	/* 690:354 */
		[3090814.04, 8907605.97],
		[3091067.50, 8929054.92],
		[3112516.06, 8928768.26],
		[3112198.98, 8907321.25],
		[3090814.04, 8907605.97],
	]], [[	/* 690:355 */
		[3112198.98, 8907321.25],
		[3112516.06, 8928768.26],
		[3133962.47, 8928417.67],
		[3133581.78, 8906973.03],
		[3112198.98, 8907321.25],
	]], [[	/* 690:356 */
		[3133581.78, 8906973.03],
		[3133962.47, 8928417.67],
		[3155406.29, 8928003.19],
		[3154962.02, 8906561.33],
		[3133581.78, 8906973.03],
	]], [[	/* 690:357 */
		[3154962.02, 8906561.33],
		[3155406.29, 8928003.19],
		[3176847.09, 8927524.82],
		[3176339.26, 8906086.19],
		[3154962.02, 8906561.33],
	]], [[	/* 690:358 */
		[3176339.26, 8906086.19],
		[3176847.09, 8927524.82],
		[3198284.44, 8926982.62],
		[3197713.09, 8905547.63],
		[3176339.26, 8906086.19],
	]], [[	/* 690:359 */
		[3197713.09, 8905547.63],
		[3198284.44, 8926982.62],
		[3219717.90, 8926376.60],
		[3219083.07, 8904945.69],
		[3197713.09, 8905547.63],
	]], [[	/* 690:360 */
		[3219083.07, 8904945.69],
		[3219717.90, 8926376.60],
		[3241147.05, 8925706.81],
		[3240448.78, 8904280.42],
		[3219083.07, 8904945.69],
	]], [[	/* 690:361 */
		[3240448.78, 8904280.42],
		[3241147.05, 8925706.81],
		[3262571.45, 8924973.30],
		[3261809.79, 8903551.84],
		[3240448.78, 8904280.42],
	]], [[	/* 690:362 */
		[3261809.79, 8903551.84],
		[3262571.45, 8924973.30],
		[3283990.69, 8924176.11],
		[3283165.67, 8902760.01],
		[3261809.79, 8903551.84],
	]], [[	/* 690:363 */
		[3283165.67, 8902760.01],
		[3283990.69, 8924176.11],
		[3305404.31, 8923315.29],
		[3304516.01, 8901904.98],
		[3283165.67, 8902760.01],
	]], [[	/* 690:364 */
		[3304516.01, 8901904.98],
		[3305404.31, 8923315.29],
		[3326811.91, 8922390.90],
		[3325860.37, 8900986.81],
		[3304516.01, 8901904.98],
	]], [[	/* 690:365 */
		[3325860.37, 8900986.81],
		[3326811.91, 8922390.90],
		[3348213.05, 8921403.00],
		[3347198.34, 8900005.55],
		[3325860.37, 8900986.81],
	]], [[	/* 690:366 */
		[3347198.34, 8900005.55],
		[3348213.05, 8921403.00],
		[3369607.31, 8920351.66],
		[3368529.49, 8898961.27],
		[3347198.34, 8900005.55],
	]], [[	/* 690:367 */
		[3368529.49, 8898961.27],
		[3369607.31, 8920351.66],
		[3390994.26, 8919236.94],
		[3389853.40, 8897854.04],
		[3368529.49, 8898961.27],
	]], [[	/* 690:368 */
		[3389853.40, 8897854.04],
		[3390994.26, 8919236.94],
		[3412373.47, 8918058.91],
		[3411169.65, 8896683.92],
		[3389853.40, 8897854.04],
	]], [[	/* 690:369 */
		[3411169.65, 8896683.92],
		[3412373.47, 8918058.91],
		[3433744.52, 8916817.65],
		[3432477.81, 8895451.00],
		[3411169.65, 8896683.92],
	]], [[	/* 691:320 */
		[2363613.17, 8900877.03],
		[2361707.71, 8922198.96],
		[2383035.99, 8924082.34],
		[2384879.15, 8902747.80],
		[2363613.17, 8900877.03],
	]], [[	/* 691:321 */
		[2384879.15, 8902747.80],
		[2383035.99, 8924082.34],
		[2404376.74, 8925903.07],
		[2406157.49, 8904556.32],
		[2384879.15, 8902747.80],
	]], [[	/* 691:322 */
		[2406157.49, 8904556.32],
		[2404376.74, 8925903.07],
		[2425729.54, 8927661.02],
		[2427447.75, 8906302.49],
		[2406157.49, 8904556.32],
	]], [[	/* 691:323 */
		[2427447.75, 8906302.49],
		[2425729.54, 8927661.02],
		[2447093.97, 8929356.09],
		[2448749.55, 8907986.18],
		[2427447.75, 8906302.49],
	]], [[	/* 691:324 */
		[2448749.55, 8907986.18],
		[2447093.97, 8929356.09],
		[2468469.62, 8930988.16],
		[2470062.44, 8909607.30],
		[2448749.55, 8907986.18],
	]], [[	/* 691:325 */
		[2470062.44, 8909607.30],
		[2468469.62, 8930988.16],
		[2489856.06, 8932557.13],
		[2491386.04, 8911165.73],
		[2470062.44, 8909607.30],
	]], [[	/* 691:326 */
		[2491386.04, 8911165.73],
		[2489856.06, 8932557.13],
		[2511252.88, 8934062.89],
		[2512719.90, 8912661.38],
		[2491386.04, 8911165.73],
	]], [[	/* 691:327 */
		[2512719.90, 8912661.38],
		[2511252.88, 8934062.89],
		[2532659.65, 8935505.35],
		[2534063.63, 8914094.15],
		[2512719.90, 8912661.38],
	]], [[	/* 691:328 */
		[2534063.63, 8914094.15],
		[2532659.65, 8935505.35],
		[2554075.94, 8936884.42],
		[2555416.79, 8915463.94],
		[2534063.63, 8914094.15],
	]], [[	/* 691:329 */
		[2555416.79, 8915463.94],
		[2554075.94, 8936884.42],
		[2575501.35, 8938200.01],
		[2576778.97, 8916770.67],
		[2555416.79, 8915463.94],
	]], [[	/* 691:330 */
		[2576778.97, 8916770.67],
		[2575501.35, 8938200.01],
		[2596935.43, 8939452.02],
		[2598149.75, 8918014.26],
		[2576778.97, 8916770.67],
	]], [[	/* 691:331 */
		[2598149.75, 8918014.26],
		[2596935.43, 8939452.02],
		[2618377.76, 8940640.39],
		[2619528.70, 8919194.62],
		[2598149.75, 8918014.26],
	]], [[	/* 691:332 */
		[2619528.70, 8919194.62],
		[2618377.76, 8940640.39],
		[2639827.92, 8941765.02],
		[2640915.39, 8920311.68],
		[2619528.70, 8919194.62],
	]], [[	/* 691:333 */
		[2640915.39, 8920311.68],
		[2639827.92, 8941765.02],
		[2661285.47, 8942825.85],
		[2662309.41, 8921365.37],
		[2640915.39, 8920311.68],
	]], [[	/* 691:334 */
		[2662309.41, 8921365.37],
		[2661285.47, 8942825.85],
		[2682749.99, 8943822.81],
		[2683710.33, 8922355.61],
		[2662309.41, 8921365.37],
	]], [[	/* 691:335 */
		[2683710.33, 8922355.61],
		[2682749.99, 8943822.81],
		[2704221.04, 8944755.83],
		[2705117.73, 8923282.34],
		[2683710.33, 8922355.61],
	]], [[	/* 691:336 */
		[2705117.73, 8923282.34],
		[2704221.04, 8944755.83],
		[2725698.20, 8945624.85],
		[2726531.16, 8924145.50],
		[2705117.73, 8923282.34],
	]], [[	/* 691:337 */
		[2726531.16, 8924145.50],
		[2725698.20, 8945624.85],
		[2747181.02, 8946429.82],
		[2747950.22, 8924945.04],
		[2726531.16, 8924145.50],
	]], [[	/* 691:338 */
		[2747950.22, 8924945.04],
		[2747181.02, 8946429.82],
		[2768669.09, 8947170.68],
		[2769374.46, 8925680.90],
		[2747950.22, 8924945.04],
	]], [[	/* 691:339 */
		[2769374.46, 8925680.90],
		[2768669.09, 8947170.68],
		[2790161.96, 8947847.38],
		[2790803.45, 8926353.04],
		[2769374.46, 8925680.90],
	]], [[	/* 691:340 */
		[2790803.45, 8926353.04],
		[2790161.96, 8947847.38],
		[2811659.19, 8948459.89],
		[2812236.78, 8926961.41],
		[2790803.45, 8926353.04],
	]], [[	/* 691:341 */
		[2812236.78, 8926961.41],
		[2811659.19, 8948459.89],
		[2833160.37, 8949008.15],
		[2833674.01, 8927505.97],
		[2812236.78, 8926961.41],
	]], [[	/* 691:342 */
		[2833674.01, 8927505.97],
		[2833160.37, 8949008.15],
		[2854665.04, 8949492.13],
		[2855114.70, 8927986.69],
		[2833674.01, 8927505.97],
	]], [[	/* 691:343 */
		[2855114.70, 8927986.69],
		[2854665.04, 8949492.13],
		[2876172.78, 8949911.81],
		[2876558.43, 8928403.53],
		[2855114.70, 8927986.69],
	]], [[	/* 691:344 */
		[2876558.43, 8928403.53],
		[2876172.78, 8949911.81],
		[2897683.15, 8950267.15],
		[2898004.76, 8928756.47],
		[2876558.43, 8928403.53],
	]], [[	/* 691:345 */
		[2898004.76, 8928756.47],
		[2897683.15, 8950267.15],
		[2919195.71, 8950558.13],
		[2919453.26, 8929045.49],
		[2898004.76, 8928756.47],
	]], [[	/* 691:346 */
		[2919453.26, 8929045.49],
		[2919195.71, 8950558.13],
		[2940710.03, 8950784.73],
		[2940903.50, 8929270.56],
		[2919453.26, 8929045.49],
	]], [[	/* 691:347 */
		[2940903.50, 8929270.56],
		[2940710.03, 8950784.73],
		[2962225.66, 8950946.94],
		[2962355.04, 8929431.67],
		[2940903.50, 8929270.56],
	]], [[	/* 691:348 */
		[2962355.04, 8929431.67],
		[2962225.66, 8950946.94],
		[2983742.18, 8951044.74],
		[2983807.46, 8929528.81],
		[2962355.04, 8929431.67],
	]], [[	/* 691:349 */
		[2983807.46, 8929528.81],
		[2983742.18, 8951044.74],
		[3005259.14, 8951078.13],
		[3005260.32, 8929561.98],
		[2983807.46, 8929528.81],
	]], [[	/* 691:350 */
		[3005260.32, 8929561.98],
		[3005259.14, 8951078.13],
		[3026776.11, 8951047.11],
		[3026713.19, 8929531.17],
		[3005260.32, 8929561.98],
	]], [[	/* 691:351 */
		[3026713.19, 8929531.17],
		[3026776.11, 8951047.11],
		[3048292.64, 8950951.68],
		[3048165.63, 8929436.39],
		[3026713.19, 8929531.17],
	]], [[	/* 691:352 */
		[3048165.63, 8929436.39],
		[3048292.64, 8950951.68],
		[3069808.31, 8950791.85],
		[3069617.21, 8929277.63],
		[3048165.63, 8929436.39],
	]], [[	/* 691:353 */
		[3069617.21, 8929277.63],
		[3069808.31, 8950791.85],
		[3091322.68, 8950567.62],
		[3091067.50, 8929054.92],
		[3069617.21, 8929277.63],
	]], [[	/* 691:354 */
		[3091067.50, 8929054.92],
		[3091322.68, 8950567.62],
		[3112835.31, 8950279.01],
		[3112516.06, 8928768.26],
		[3091067.50, 8929054.92],
	]], [[	/* 691:355 */
		[3112516.06, 8928768.26],
		[3112835.31, 8950279.01],
		[3134345.75, 8949926.04],
		[3133962.47, 8928417.67],
		[3112516.06, 8928768.26],
	]], [[	/* 691:356 */
		[3133962.47, 8928417.67],
		[3134345.75, 8949926.04],
		[3155853.59, 8949508.73],
		[3155406.29, 8928003.19],
		[3133962.47, 8928417.67],
	]], [[	/* 691:357 */
		[3155406.29, 8928003.19],
		[3155853.59, 8949508.73],
		[3177358.37, 8949027.12],
		[3176847.09, 8927524.82],
		[3155406.29, 8928003.19],
	]], [[	/* 691:358 */
		[3176847.09, 8927524.82],
		[3177358.37, 8949027.12],
		[3198859.67, 8948481.22],
		[3198284.44, 8926982.62],
		[3176847.09, 8927524.82],
	]], [[	/* 691:359 */
		[3198284.44, 8926982.62],
		[3198859.67, 8948481.22],
		[3220357.04, 8947871.09],
		[3219717.90, 8926376.60],
		[3198284.44, 8926982.62],
	]], [[	/* 691:360 */
		[3219717.90, 8926376.60],
		[3220357.04, 8947871.09],
		[3241850.06, 8947196.75],
		[3241147.05, 8925706.81],
		[3219717.90, 8926376.60],
	]], [[	/* 691:361 */
		[3241147.05, 8925706.81],
		[3241850.06, 8947196.75],
		[3263338.30, 8946458.25],
		[3262571.45, 8924973.30],
		[3241147.05, 8925706.81],
	]], [[	/* 691:362 */
		[3262571.45, 8924973.30],
		[3263338.30, 8946458.25],
		[3284821.30, 8945655.64],
		[3283990.69, 8924176.11],
		[3262571.45, 8924973.30],
	]], [[	/* 691:363 */
		[3283990.69, 8924176.11],
		[3284821.30, 8945655.64],
		[3306298.65, 8944788.98],
		[3305404.31, 8923315.29],
		[3283990.69, 8924176.11],
	]], [[	/* 691:364 */
		[3305404.31, 8923315.29],
		[3306298.65, 8944788.98],
		[3327769.91, 8943858.32],
		[3326811.91, 8922390.90],
		[3305404.31, 8923315.29],
	]], [[	/* 691:365 */
		[3326811.91, 8922390.90],
		[3327769.91, 8943858.32],
		[3349234.65, 8942863.72],
		[3348213.05, 8921403.00],
		[3326811.91, 8922390.90],
	]], [[	/* 691:366 */
		[3348213.05, 8921403.00],
		[3349234.65, 8942863.72],
		[3370692.44, 8941805.24],
		[3369607.31, 8920351.66],
		[3348213.05, 8921403.00],
	]], [[	/* 691:367 */
		[3369607.31, 8920351.66],
		[3370692.44, 8941805.24],
		[3392142.85, 8940682.96],
		[3390994.26, 8919236.94],
		[3369607.31, 8920351.66],
	]], [[	/* 691:368 */
		[3390994.26, 8919236.94],
		[3392142.85, 8940682.96],
		[3413585.45, 8939496.94],
		[3412373.47, 8918058.91],
		[3390994.26, 8919236.94],
	]], [[	/* 691:369 */
		[3412373.47, 8918058.91],
		[3413585.45, 8939496.94],
		[3435019.81, 8938247.27],
		[3433744.52, 8916817.65],
		[3412373.47, 8918058.91],
	]], [[	/* 691:370 */
		[3433744.52, 8916817.65],
		[3435019.81, 8938247.27],
		[3456445.51, 8936934.03],
		[3455106.99, 8915513.25],
		[3433744.52, 8916817.65],
	]], [[	/* 692:319 */
		[2340392.30, 8920253.04],
		[2338411.38, 8941624.17],
		[2359789.37, 8943583.24],
		[2361707.71, 8922198.96],
		[2340392.30, 8920253.04],
	]], [[	/* 692:320 */
		[2361707.71, 8922198.96],
		[2359789.37, 8943583.24],
		[2381180.36, 8945479.35],
		[2383035.99, 8924082.34],
		[2361707.71, 8922198.96],
	]], [[	/* 692:321 */
		[2383035.99, 8924082.34],
		[2381180.36, 8945479.35],
		[2402583.94, 8947312.40],
		[2404376.74, 8925903.07],
		[2383035.99, 8924082.34],
	]], [[	/* 692:322 */
		[2404376.74, 8925903.07],
		[2402583.94, 8947312.40],
		[2423999.69, 8949082.25],
		[2425729.54, 8927661.02],
		[2404376.74, 8925903.07],
	]], [[	/* 692:323 */
		[2425729.54, 8927661.02],
		[2423999.69, 8949082.25],
		[2445427.18, 8950788.80],
		[2447093.97, 8929356.09],
		[2425729.54, 8927661.02],
	]], [[	/* 692:324 */
		[2447093.97, 8929356.09],
		[2445427.18, 8950788.80],
		[2466865.99, 8952431.93],
		[2468469.62, 8930988.16],
		[2447093.97, 8929356.09],
	]], [[	/* 692:325 */
		[2468469.62, 8930988.16],
		[2466865.99, 8952431.93],
		[2488315.71, 8954011.54],
		[2489856.06, 8932557.13],
		[2468469.62, 8930988.16],
	]], [[	/* 692:326 */
		[2489856.06, 8932557.13],
		[2488315.71, 8954011.54],
		[2509775.89, 8955527.52],
		[2511252.88, 8934062.89],
		[2489856.06, 8932557.13],
	]], [[	/* 692:327 */
		[2511252.88, 8934062.89],
		[2509775.89, 8955527.52],
		[2531246.13, 8956979.77],
		[2532659.65, 8935505.35],
		[2511252.88, 8934062.89],
	]], [[	/* 692:328 */
		[2532659.65, 8935505.35],
		[2531246.13, 8956979.77],
		[2552725.99, 8958368.21],
		[2554075.94, 8936884.42],
		[2532659.65, 8935505.35],
	]], [[	/* 692:329 */
		[2554075.94, 8936884.42],
		[2552725.99, 8958368.21],
		[2574215.04, 8959692.73],
		[2575501.35, 8938200.01],
		[2554075.94, 8936884.42],
	]], [[	/* 692:330 */
		[2575501.35, 8938200.01],
		[2574215.04, 8959692.73],
		[2595712.86, 8960953.25],
		[2596935.43, 8939452.02],
		[2575501.35, 8938200.01],
	]], [[	/* 692:331 */
		[2596935.43, 8939452.02],
		[2595712.86, 8960953.25],
		[2617219.00, 8962149.69],
		[2618377.76, 8940640.39],
		[2596935.43, 8939452.02],
	]], [[	/* 692:332 */
		[2618377.76, 8940640.39],
		[2617219.00, 8962149.69],
		[2638733.05, 8963281.97],
		[2639827.92, 8941765.02],
		[2618377.76, 8940640.39],
	]], [[	/* 692:333 */
		[2639827.92, 8941765.02],
		[2638733.05, 8963281.97],
		[2660254.56, 8964350.02],
		[2661285.47, 8942825.85],
		[2639827.92, 8941765.02],
	]], [[	/* 692:334 */
		[2661285.47, 8942825.85],
		[2660254.56, 8964350.02],
		[2681783.11, 8965353.76],
		[2682749.99, 8943822.81],
		[2661285.47, 8942825.85],
	]], [[	/* 692:335 */
		[2682749.99, 8943822.81],
		[2681783.11, 8965353.76],
		[2703318.25, 8966293.13],
		[2704221.04, 8944755.83],
		[2682749.99, 8943822.81],
	]], [[	/* 692:336 */
		[2704221.04, 8944755.83],
		[2703318.25, 8966293.13],
		[2724859.56, 8967168.07],
		[2725698.20, 8945624.85],
		[2704221.04, 8944755.83],
	]], [[	/* 692:337 */
		[2725698.20, 8945624.85],
		[2724859.56, 8967168.07],
		[2746406.59, 8967978.52],
		[2747181.02, 8946429.82],
		[2725698.20, 8945624.85],
	]], [[	/* 692:338 */
		[2747181.02, 8946429.82],
		[2746406.59, 8967978.52],
		[2767958.91, 8968724.43],
		[2768669.09, 8947170.68],
		[2747181.02, 8946429.82],
	]], [[	/* 692:339 */
		[2768669.09, 8947170.68],
		[2767958.91, 8968724.43],
		[2789516.09, 8969405.74],
		[2790161.96, 8947847.38],
		[2768669.09, 8947170.68],
	]], [[	/* 692:340 */
		[2790161.96, 8947847.38],
		[2789516.09, 8969405.74],
		[2811077.67, 8970022.42],
		[2811659.19, 8948459.89],
		[2790161.96, 8947847.38],
	]], [[	/* 692:341 */
		[2811659.19, 8948459.89],
		[2811077.67, 8970022.42],
		[2832643.23, 8970574.42],
		[2833160.37, 8949008.15],
		[2811659.19, 8948459.89],
	]], [[	/* 692:342 */
		[2833160.37, 8949008.15],
		[2832643.23, 8970574.42],
		[2854212.32, 8971061.70],
		[2854665.04, 8949492.13],
		[2833160.37, 8949008.15],
	]], [[	/* 692:343 */
		[2854665.04, 8949492.13],
		[2854212.32, 8971061.70],
		[2875784.51, 8971484.24],
		[2876172.78, 8949911.81],
		[2854665.04, 8949492.13],
	]], [[	/* 692:344 */
		[2876172.78, 8949911.81],
		[2875784.51, 8971484.24],
		[2897359.36, 8971842.00],
		[2897683.15, 8950267.15],
		[2876172.78, 8949911.81],
	]], [[	/* 692:345 */
		[2897683.15, 8950267.15],
		[2897359.36, 8971842.00],
		[2918936.41, 8972134.96],
		[2919195.71, 8950558.13],
		[2897683.15, 8950267.15],
	]], [[	/* 692:346 */
		[2919195.71, 8950558.13],
		[2918936.41, 8972134.96],
		[2940515.24, 8972363.11],
		[2940710.03, 8950784.73],
		[2919195.71, 8950558.13],
	]], [[	/* 692:347 */
		[2940710.03, 8950784.73],
		[2940515.24, 8972363.11],
		[2962095.40, 8972526.42],
		[2962225.66, 8950946.94],
		[2940710.03, 8950784.73],
	]], [[	/* 692:348 */
		[2962225.66, 8950946.94],
		[2962095.40, 8972526.42],
		[2983676.45, 8972624.89],
		[2983742.18, 8951044.74],
		[2962225.66, 8950946.94],
	]], [[	/* 692:349 */
		[2983742.18, 8951044.74],
		[2983676.45, 8972624.89],
		[3005257.95, 8972658.51],
		[3005259.14, 8951078.13],
		[2983742.18, 8951044.74],
	]], [[	/* 692:350 */
		[3005259.14, 8951078.13],
		[3005257.95, 8972658.51],
		[3026839.46, 8972627.28],
		[3026776.11, 8951047.11],
		[3005259.14, 8951078.13],
	]], [[	/* 692:351 */
		[3026776.11, 8951047.11],
		[3026839.46, 8972627.28],
		[3048420.53, 8972531.20],
		[3048292.64, 8950951.68],
		[3026776.11, 8951047.11],
	]], [[	/* 692:352 */
		[3048292.64, 8950951.68],
		[3048420.53, 8972531.20],
		[3070000.73, 8972370.27],
		[3069808.31, 8950791.85],
		[3048292.64, 8950951.68],
	]], [[	/* 692:353 */
		[3069808.31, 8950791.85],
		[3070000.73, 8972370.27],
		[3091579.61, 8972144.51],
		[3091322.68, 8950567.62],
		[3069808.31, 8950791.85],
	]], [[	/* 692:354 */
		[3091322.68, 8950567.62],
		[3091579.61, 8972144.51],
		[3113156.73, 8971853.93],
		[3112835.31, 8950279.01],
		[3091322.68, 8950567.62],
	]], [[	/* 692:355 */
		[3112835.31, 8950279.01],
		[3113156.73, 8971853.93],
		[3134731.65, 8971498.56],
		[3134345.75, 8949926.04],
		[3112835.31, 8950279.01],
	]], [[	/* 692:356 */
		[3134345.75, 8949926.04],
		[3134731.65, 8971498.56],
		[3156303.93, 8971078.40],
		[3155853.59, 8949508.73],
		[3134345.75, 8949926.04],
	]], [[	/* 692:357 */
		[3155853.59, 8949508.73],
		[3156303.93, 8971078.40],
		[3177873.14, 8970593.50],
		[3177358.37, 8949027.12],
		[3155853.59, 8949508.73],
	]], [[	/* 692:358 */
		[3177358.37, 8949027.12],
		[3177873.14, 8970593.50],
		[3199438.82, 8970043.89],
		[3198859.67, 8948481.22],
		[3177358.37, 8949027.12],
	]], [[	/* 692:359 */
		[3198859.67, 8948481.22],
		[3199438.82, 8970043.89],
		[3221000.54, 8969429.59],
		[3220357.04, 8947871.09],
		[3198859.67, 8948481.22],
	]], [[	/* 692:360 */
		[3220357.04, 8947871.09],
		[3221000.54, 8969429.59],
		[3242557.87, 8968750.66],
		[3241850.06, 8947196.75],
		[3220357.04, 8947871.09],
	]], [[	/* 692:361 */
		[3241850.06, 8947196.75],
		[3242557.87, 8968750.66],
		[3264110.36, 8968007.13],
		[3263338.30, 8946458.25],
		[3241850.06, 8947196.75],
	]], [[	/* 692:362 */
		[3263338.30, 8946458.25],
		[3264110.36, 8968007.13],
		[3285657.57, 8967199.05],
		[3284821.30, 8945655.64],
		[3263338.30, 8946458.25],
	]], [[	/* 692:363 */
		[3284821.30, 8945655.64],
		[3285657.57, 8967199.05],
		[3307199.08, 8966326.49],
		[3306298.65, 8944788.98],
		[3284821.30, 8945655.64],
	]], [[	/* 692:364 */
		[3306298.65, 8944788.98],
		[3307199.08, 8966326.49],
		[3328734.43, 8965389.49],
		[3327769.91, 8943858.32],
		[3306298.65, 8944788.98],
	]], [[	/* 692:365 */
		[3327769.91, 8943858.32],
		[3328734.43, 8965389.49],
		[3350263.20, 8964388.12],
		[3349234.65, 8942863.72],
		[3327769.91, 8943858.32],
	]], [[	/* 692:366 */
		[3349234.65, 8942863.72],
		[3350263.20, 8964388.12],
		[3371784.96, 8963322.44],
		[3370692.44, 8941805.24],
		[3349234.65, 8942863.72],
	]], [[	/* 692:367 */
		[3370692.44, 8941805.24],
		[3371784.96, 8963322.44],
		[3393299.26, 8962192.52],
		[3392142.85, 8940682.96],
		[3370692.44, 8941805.24],
	]], [[	/* 692:368 */
		[3392142.85, 8940682.96],
		[3393299.26, 8962192.52],
		[3414805.67, 8960998.44],
		[3413585.45, 8939496.94],
		[3392142.85, 8940682.96],
	]], [[	/* 692:369 */
		[3413585.45, 8939496.94],
		[3414805.67, 8960998.44],
		[3436303.77, 8959740.28],
		[3435019.81, 8938247.27],
		[3413585.45, 8939496.94],
	]], [[	/* 692:370 */
		[3435019.81, 8938247.27],
		[3436303.77, 8959740.28],
		[3457793.12, 8958418.12],
		[3456445.51, 8936934.03],
		[3435019.81, 8938247.27],
	]], [[	/* 692:371 */
		[3456445.51, 8936934.03],
		[3457793.12, 8958418.12],
		[3479273.29, 8957032.04],
		[3477862.12, 8935557.30],
		[3456445.51, 8936934.03],
	]], [[	/* 693:319 */
		[2338411.38, 8941624.17],
		[2336417.03, 8963057.93],
		[2357858.03, 8965030.28],
		[2359789.37, 8943583.24],
		[2338411.38, 8941624.17],
	]], [[	/* 693:320 */
		[2359789.37, 8943583.24],
		[2357858.03, 8965030.28],
		[2379312.15, 8966939.25],
		[2381180.36, 8945479.35],
		[2359789.37, 8943583.24],
	]], [[	/* 693:321 */
		[2381180.36, 8945479.35],
		[2379312.15, 8966939.25],
		[2400778.98, 8968784.74],
		[2402583.94, 8947312.40],
		[2381180.36, 8945479.35],
	]], [[	/* 693:322 */
		[2402583.94, 8947312.40],
		[2400778.98, 8968784.74],
		[2422258.09, 8970566.61],
		[2423999.69, 8949082.25],
		[2402583.94, 8947312.40],
	]], [[	/* 693:323 */
		[2423999.69, 8949082.25],
		[2422258.09, 8970566.61],
		[2443749.06, 8972284.75],
		[2445427.18, 8950788.80],
		[2423999.69, 8949082.25],
	]], [[	/* 693:324 */
		[2445427.18, 8950788.80],
		[2443749.06, 8972284.75],
		[2465251.47, 8973939.05],
		[2466865.99, 8952431.93],
		[2445427.18, 8950788.80],
	]], [[	/* 693:325 */
		[2466865.99, 8952431.93],
		[2465251.47, 8973939.05],
		[2486764.88, 8975529.40],
		[2488315.71, 8954011.54],
		[2466865.99, 8952431.93],
	]], [[	/* 693:326 */
		[2488315.71, 8954011.54],
		[2486764.88, 8975529.40],
		[2508288.86, 8977055.69],
		[2509775.89, 8955527.52],
		[2488315.71, 8954011.54],
	]], [[	/* 693:327 */
		[2509775.89, 8955527.52],
		[2508288.86, 8977055.69],
		[2529823.00, 8978517.83],
		[2531246.13, 8956979.77],
		[2509775.89, 8955527.52],
	]], [[	/* 693:328 */
		[2531246.13, 8956979.77],
		[2529823.00, 8978517.83],
		[2551366.85, 8979915.71],
		[2552725.99, 8958368.21],
		[2531246.13, 8956979.77],
	]], [[	/* 693:329 */
		[2552725.99, 8958368.21],
		[2551366.85, 8979915.71],
		[2572919.98, 8981249.26],
		[2574215.04, 8959692.73],
		[2552725.99, 8958368.21],
	]], [[	/* 693:330 */
		[2574215.04, 8959692.73],
		[2572919.98, 8981249.26],
		[2594481.95, 8982518.37],
		[2595712.86, 8960953.25],
		[2574215.04, 8959692.73],
	]], [[	/* 693:331 */
		[2595712.86, 8960953.25],
		[2594481.95, 8982518.37],
		[2616052.35, 8983722.97],
		[2617219.00, 8962149.69],
		[2595712.86, 8960953.25],
	]], [[	/* 693:332 */
		[2617219.00, 8962149.69],
		[2616052.35, 8983722.97],
		[2637630.71, 8984862.97],
		[2638733.05, 8963281.97],
		[2617219.00, 8962149.69],
	]], [[	/* 693:333 */
		[2638733.05, 8963281.97],
		[2637630.71, 8984862.97],
		[2659216.62, 8985938.30],
		[2660254.56, 8964350.02],
		[2638733.05, 8963281.97],
	]], [[	/* 693:334 */
		[2660254.56, 8964350.02],
		[2659216.62, 8985938.30],
		[2680809.63, 8986948.90],
		[2681783.11, 8965353.76],
		[2660254.56, 8964350.02],
	]], [[	/* 693:335 */
		[2681783.11, 8965353.76],
		[2680809.63, 8986948.90],
		[2702409.30, 8987894.68],
		[2703318.25, 8966293.13],
		[2681783.11, 8965353.76],
	]], [[	/* 693:336 */
		[2703318.25, 8966293.13],
		[2702409.30, 8987894.68],
		[2724015.20, 8988775.60],
		[2724859.56, 8967168.07],
		[2703318.25, 8966293.13],
	]], [[	/* 693:337 */
		[2724859.56, 8967168.07],
		[2724015.20, 8988775.60],
		[2745626.87, 8989591.58],
		[2746406.59, 8967978.52],
		[2724859.56, 8967168.07],
	]], [[	/* 693:338 */
		[2746406.59, 8967978.52],
		[2745626.87, 8989591.58],
		[2767243.89, 8990342.58],
		[2767958.91, 8968724.43],
		[2746406.59, 8967978.52],
	]], [[	/* 693:339 */
		[2767958.91, 8968724.43],
		[2767243.89, 8990342.58],
		[2788865.80, 8991028.55],
		[2789516.09, 8969405.74],
		[2767958.91, 8968724.43],
	]], [[	/* 693:340 */
		[2789516.09, 8969405.74],
		[2788865.80, 8991028.55],
		[2810492.17, 8991649.44],
		[2811077.67, 8970022.42],
		[2789516.09, 8969405.74],
	]], [[	/* 693:341 */
		[2811077.67, 8970022.42],
		[2810492.17, 8991649.44],
		[2832122.56, 8992205.22],
		[2832643.23, 8970574.42],
		[2811077.67, 8970022.42],
	]], [[	/* 693:342 */
		[2832643.23, 8970574.42],
		[2832122.56, 8992205.22],
		[2853756.51, 8992695.83],
		[2854212.32, 8971061.70],
		[2832643.23, 8970574.42],
	]], [[	/* 693:343 */
		[2854212.32, 8971061.70],
		[2853756.51, 8992695.83],
		[2875393.59, 8993121.26],
		[2875784.51, 8971484.24],
		[2854212.32, 8971061.70],
	]], [[	/* 693:344 */
		[2875784.51, 8971484.24],
		[2875393.59, 8993121.26],
		[2897033.35, 8993481.47],
		[2897359.36, 8971842.00],
		[2875784.51, 8971484.24],
	]], [[	/* 693:345 */
		[2897359.36, 8971842.00],
		[2897033.35, 8993481.47],
		[2918675.34, 8993776.43],
		[2918936.41, 8972134.96],
		[2897359.36, 8971842.00],
	]], [[	/* 693:346 */
		[2918936.41, 8972134.96],
		[2918675.34, 8993776.43],
		[2940319.12, 8994006.14],
		[2940515.24, 8972363.11],
		[2918936.41, 8972134.96],
	]], [[	/* 693:347 */
		[2940515.24, 8972363.11],
		[2940319.12, 8994006.14],
		[2961964.25, 8994170.57],
		[2962095.40, 8972526.42],
		[2940515.24, 8972363.11],
	]], [[	/* 693:348 */
		[2962095.40, 8972526.42],
		[2961964.25, 8994170.57],
		[2983610.28, 8994269.71],
		[2983676.45, 8972624.89],
		[2962095.40, 8972526.42],
	]], [[	/* 693:349 */
		[2983676.45, 8972624.89],
		[2983610.28, 8994269.71],
		[3005256.75, 8994303.56],
		[3005257.95, 8972658.51],
		[2983676.45, 8972624.89],
	]], [[	/* 693:350 */
		[3005257.95, 8972658.51],
		[3005256.75, 8994303.56],
		[3026903.24, 8994272.11],
		[3026839.46, 8972627.28],
		[3005257.95, 8972658.51],
	]], [[	/* 693:351 */
		[3026839.46, 8972627.28],
		[3026903.24, 8994272.11],
		[3048549.29, 8994175.37],
		[3048420.53, 8972531.20],
		[3026839.46, 8972627.28],
	]], [[	/* 693:352 */
		[3048420.53, 8972531.20],
		[3048549.29, 8994175.37],
		[3070194.45, 8994013.34],
		[3070000.73, 8972370.27],
		[3048420.53, 8972531.20],
	]], [[	/* 693:353 */
		[3070000.73, 8972370.27],
		[3070194.45, 8994013.34],
		[3091838.29, 8993786.04],
		[3091579.61, 8972144.51],
		[3070000.73, 8972370.27],
	]], [[	/* 693:354 */
		[3091579.61, 8972144.51],
		[3091838.29, 8993786.04],
		[3113480.35, 8993493.47],
		[3113156.73, 8971853.93],
		[3091579.61, 8972144.51],
	]], [[	/* 693:355 */
		[3113156.73, 8971853.93],
		[3113480.35, 8993493.47],
		[3135120.19, 8993135.66],
		[3134731.65, 8971498.56],
		[3113156.73, 8971853.93],
	]], [[	/* 693:356 */
		[3134731.65, 8971498.56],
		[3135120.19, 8993135.66],
		[3156757.36, 8992712.64],
		[3156303.93, 8971078.40],
		[3134731.65, 8971498.56],
	]], [[	/* 693:357 */
		[3156303.93, 8971078.40],
		[3156757.36, 8992712.64],
		[3178391.42, 8992224.42],
		[3177873.14, 8970593.50],
		[3156303.93, 8971078.40],
	]], [[	/* 693:358 */
		[3177873.14, 8970593.50],
		[3178391.42, 8992224.42],
		[3200021.93, 8991671.04],
		[3199438.82, 8970043.89],
		[3177873.14, 8970593.50],
	]], [[	/* 693:359 */
		[3199438.82, 8970043.89],
		[3200021.93, 8991671.04],
		[3221648.44, 8991052.55],
		[3221000.54, 8969429.59],
		[3199438.82, 8970043.89],
	]], [[	/* 693:360 */
		[3221000.54, 8969429.59],
		[3221648.44, 8991052.55],
		[3243270.51, 8990368.97],
		[3242557.87, 8968750.66],
		[3221000.54, 8969429.59],
	]], [[	/* 693:361 */
		[3242557.87, 8968750.66],
		[3243270.51, 8990368.97],
		[3264887.70, 8989620.36],
		[3264110.36, 8968007.13],
		[3242557.87, 8968750.66],
	]], [[	/* 693:362 */
		[3264110.36, 8968007.13],
		[3264887.70, 8989620.36],
		[3286499.56, 8988806.77],
		[3285657.57, 8967199.05],
		[3264110.36, 8968007.13],
	]], [[	/* 693:363 */
		[3285657.57, 8967199.05],
		[3286499.56, 8988806.77],
		[3308105.65, 8987928.24],
		[3307199.08, 8966326.49],
		[3285657.57, 8967199.05],
	]], [[	/* 693:364 */
		[3307199.08, 8966326.49],
		[3308105.65, 8987928.24],
		[3329705.54, 8986984.84],
		[3328734.43, 8965389.49],
		[3307199.08, 8966326.49],
	]], [[	/* 693:365 */
		[3328734.43, 8965389.49],
		[3329705.54, 8986984.84],
		[3351298.77, 8985976.64],
		[3350263.20, 8964388.12],
		[3328734.43, 8965389.49],
	]], [[	/* 693:366 */
		[3350263.20, 8964388.12],
		[3351298.77, 8985976.64],
		[3372884.92, 8984903.68],
		[3371784.96, 8963322.44],
		[3350263.20, 8964388.12],
	]], [[	/* 693:367 */
		[3371784.96, 8963322.44],
		[3372884.92, 8984903.68],
		[3394463.55, 8983766.06],
		[3393299.26, 8962192.52],
		[3371784.96, 8963322.44],
	]], [[	/* 693:368 */
		[3393299.26, 8962192.52],
		[3394463.55, 8983766.06],
		[3416034.21, 8982563.84],
		[3414805.67, 8960998.44],
		[3393299.26, 8962192.52],
	]], [[	/* 693:369 */
		[3414805.67, 8960998.44],
		[3416034.21, 8982563.84],
		[3437596.47, 8981297.10],
		[3436303.77, 8959740.28],
		[3414805.67, 8960998.44],
	]], [[	/* 693:370 */
		[3436303.77, 8959740.28],
		[3437596.47, 8981297.10],
		[3459149.90, 8979965.93],
		[3457793.12, 8958418.12],
		[3436303.77, 8959740.28],
	]], [[	/* 693:371 */
		[3457793.12, 8958418.12],
		[3459149.90, 8979965.93],
		[3480694.06, 8978570.41],
		[3479273.29, 8957032.04],
		[3457793.12, 8958418.12],
	]], [[	/* 694:319 */
		[2336417.03, 8963057.93],
		[2334409.14, 8984554.75],
		[2355913.55, 8986540.50],
		[2357858.03, 8965030.28],
		[2336417.03, 8963057.93],
	]], [[	/* 694:320 */
		[2357858.03, 8965030.28],
		[2355913.55, 8986540.50],
		[2377431.23, 8988462.46],
		[2379312.15, 8966939.25],
		[2357858.03, 8965030.28],
	]], [[	/* 694:321 */
		[2379312.15, 8966939.25],
		[2377431.23, 8988462.46],
		[2398961.73, 8990320.50],
		[2400778.98, 8968784.74],
		[2379312.15, 8966939.25],
	]], [[	/* 694:322 */
		[2400778.98, 8968784.74],
		[2398961.73, 8990320.50],
		[2420504.63, 8992114.51],
		[2422258.09, 8970566.61],
		[2400778.98, 8968784.74],
	]], [[	/* 694:323 */
		[2422258.09, 8970566.61],
		[2420504.63, 8992114.51],
		[2442059.51, 8993844.35],
		[2443749.06, 8972284.75],
		[2422258.09, 8970566.61],
	]], [[	/* 694:324 */
		[2443749.06, 8972284.75],
		[2442059.51, 8993844.35],
		[2463625.94, 8995509.93],
		[2465251.47, 8973939.05],
		[2443749.06, 8972284.75],
	]], [[	/* 694:325 */
		[2465251.47, 8973939.05],
		[2463625.94, 8995509.93],
		[2485203.47, 8997111.12],
		[2486764.88, 8975529.40],
		[2465251.47, 8973939.05],
	]], [[	/* 694:326 */
		[2486764.88, 8975529.40],
		[2485203.47, 8997111.12],
		[2506791.69, 8998647.83],
		[2508288.86, 8977055.69],
		[2486764.88, 8975529.40],
	]], [[	/* 694:327 */
		[2508288.86, 8977055.69],
		[2506791.69, 8998647.83],
		[2528390.15, 9000119.95],
		[2529823.00, 8978517.83],
		[2508288.86, 8977055.69],
	]], [[	/* 694:328 */
		[2529823.00, 8978517.83],
		[2528390.15, 9000119.95],
		[2549998.42, 9001527.38],
		[2551366.85, 8979915.71],
		[2529823.00, 8978517.83],
	]], [[	/* 694:329 */
		[2551366.85, 8979915.71],
		[2549998.42, 9001527.38],
		[2571616.06, 9002870.03],
		[2572919.98, 8981249.26],
		[2551366.85, 8979915.71],
	]], [[	/* 694:330 */
		[2572919.98, 8981249.26],
		[2571616.06, 9002870.03],
		[2593242.64, 9004147.82],
		[2594481.95, 8982518.37],
		[2572919.98, 8981249.26],
	]], [[	/* 694:331 */
		[2594481.95, 8982518.37],
		[2593242.64, 9004147.82],
		[2614877.71, 9005360.65],
		[2616052.35, 8983722.97],
		[2594481.95, 8982518.37],
	]], [[	/* 694:332 */
		[2616052.35, 8983722.97],
		[2614877.71, 9005360.65],
		[2636520.84, 9006508.46],
		[2637630.71, 8984862.97],
		[2616052.35, 8983722.97],
	]], [[	/* 694:333 */
		[2637630.71, 8984862.97],
		[2636520.84, 9006508.46],
		[2658171.58, 9007591.15],
		[2659216.62, 8985938.30],
		[2637630.71, 8984862.97],
	]], [[	/* 694:334 */
		[2659216.62, 8985938.30],
		[2658171.58, 9007591.15],
		[2679829.49, 9008608.66],
		[2680809.63, 8986948.90],
		[2659216.62, 8985938.30],
	]], [[	/* 694:335 */
		[2680809.63, 8986948.90],
		[2679829.49, 9008608.66],
		[2701494.13, 9009560.92],
		[2702409.30, 8987894.68],
		[2680809.63, 8986948.90],
	]], [[	/* 694:336 */
		[2702409.30, 8987894.68],
		[2701494.13, 9009560.92],
		[2723165.05, 9010447.86],
		[2724015.20, 8988775.60],
		[2702409.30, 8987894.68],
	]], [[	/* 694:337 */
		[2724015.20, 8988775.60],
		[2723165.05, 9010447.86],
		[2744841.81, 9011269.44],
		[2745626.87, 8989591.58],
		[2724015.20, 8988775.60],
	]], [[	/* 694:338 */
		[2745626.87, 8989591.58],
		[2744841.81, 9011269.44],
		[2766523.96, 9012025.59],
		[2767243.89, 8990342.58],
		[2745626.87, 8989591.58],
	]], [[	/* 694:339 */
		[2767243.89, 8990342.58],
		[2766523.96, 9012025.59],
		[2788211.07, 9012716.26],
		[2788865.80, 8991028.55],
		[2767243.89, 8990342.58],
	]], [[	/* 694:340 */
		[2788865.80, 8991028.55],
		[2788211.07, 9012716.26],
		[2809902.66, 9013341.40],
		[2810492.17, 8991649.44],
		[2788865.80, 8991028.55],
	]], [[	/* 694:341 */
		[2810492.17, 8991649.44],
		[2809902.66, 9013341.40],
		[2831598.32, 9013900.98],
		[2832122.56, 8992205.22],
		[2810492.17, 8991649.44],
	]], [[	/* 694:342 */
		[2832122.56, 8992205.22],
		[2831598.32, 9013900.98],
		[2853297.57, 9014394.96],
		[2853756.51, 8992695.83],
		[2832122.56, 8992205.22],
	]], [[	/* 694:343 */
		[2853756.51, 8992695.83],
		[2853297.57, 9014394.96],
		[2874999.98, 9014823.31],
		[2875393.59, 8993121.26],
		[2853756.51, 8992695.83],
	]], [[	/* 694:344 */
		[2875393.59, 8993121.26],
		[2874999.98, 9014823.31],
		[2896705.10, 9015185.99],
		[2897033.35, 8993481.47],
		[2875393.59, 8993121.26],
	]], [[	/* 694:345 */
		[2897033.35, 8993481.47],
		[2896705.10, 9015185.99],
		[2918412.48, 9015482.98],
		[2918675.34, 8993776.43],
		[2897033.35, 8993481.47],
	]], [[	/* 694:346 */
		[2918675.34, 8993776.43],
		[2918412.48, 9015482.98],
		[2940121.66, 9015714.26],
		[2940319.12, 8994006.14],
		[2918675.34, 8993776.43],
	]], [[	/* 694:347 */
		[2940319.12, 8994006.14],
		[2940121.66, 9015714.26],
		[2961832.20, 9015879.81],
		[2961964.25, 8994170.57],
		[2940319.12, 8994006.14],
	]], [[	/* 694:348 */
		[2961964.25, 8994170.57],
		[2961832.20, 9015879.81],
		[2983543.65, 9015979.64],
		[2983610.28, 8994269.71],
		[2961964.25, 8994170.57],
	]], [[	/* 694:349 */
		[2983610.28, 8994269.71],
		[2983543.65, 9015979.64],
		[3005255.55, 9016013.72],
		[3005256.75, 8994303.56],
		[2983610.28, 8994269.71],
	]], [[	/* 694:350 */
		[3005256.75, 8994303.56],
		[3005255.55, 9016013.72],
		[3026967.46, 9015982.05],
		[3026903.24, 8994272.11],
		[3005256.75, 8994303.56],
	]], [[	/* 694:351 */
		[3026903.24, 8994272.11],
		[3026967.46, 9015982.05],
		[3048678.94, 9015884.65],
		[3048549.29, 8994175.37],
		[3026903.24, 8994272.11],
	]], [[	/* 694:352 */
		[3048549.29, 8994175.37],
		[3048678.94, 9015884.65],
		[3070389.51, 9015721.51],
		[3070194.45, 8994013.34],
		[3048549.29, 8994175.37],
	]], [[	/* 694:353 */
		[3070194.45, 8994013.34],
		[3070389.51, 9015721.51],
		[3092098.75, 9015492.64],
		[3091838.29, 8993786.04],
		[3070194.45, 8994013.34],
	]], [[	/* 694:354 */
		[3091838.29, 8993786.04],
		[3092098.75, 9015492.64],
		[3113806.19, 9015198.07],
		[3113480.35, 8993493.47],
		[3091838.29, 8993786.04],
	]], [[	/* 694:355 */
		[3113480.35, 8993493.47],
		[3113806.19, 9015198.07],
		[3135511.39, 9014837.80],
		[3135120.19, 8993135.66],
		[3113480.35, 8993493.47],
	]], [[	/* 694:356 */
		[3135120.19, 8993135.66],
		[3135511.39, 9014837.80],
		[3157213.90, 9014411.87],
		[3156757.36, 8992712.64],
		[3135120.19, 8993135.66],
	]], [[	/* 694:357 */
		[3156757.36, 8992712.64],
		[3157213.90, 9014411.87],
		[3178913.26, 9013920.31],
		[3178391.42, 8992224.42],
		[3156757.36, 8992712.64],
	]], [[	/* 694:358 */
		[3178391.42, 8992224.42],
		[3178913.26, 9013920.31],
		[3200609.04, 9013363.14],
		[3200021.93, 8991671.04],
		[3178391.42, 8992224.42],
	]], [[	/* 694:359 */
		[3200021.93, 8991671.04],
		[3200609.04, 9013363.14],
		[3222300.78, 9012740.40],
		[3221648.44, 8991052.55],
		[3200021.93, 8991671.04],
	]], [[	/* 694:360 */
		[3221648.44, 8991052.55],
		[3222300.78, 9012740.40],
		[3243988.04, 9012052.14],
		[3243270.51, 8990368.97],
		[3221648.44, 8991052.55],
	]], [[	/* 694:361 */
		[3243270.51, 8990368.97],
		[3243988.04, 9012052.14],
		[3265670.36, 9011298.40],
		[3264887.70, 8989620.36],
		[3243270.51, 8990368.97],
	]], [[	/* 694:362 */
		[3264887.70, 8989620.36],
		[3265670.36, 9011298.40],
		[3287347.31, 9010479.23],
		[3286499.56, 8988806.77],
		[3264887.70, 8989620.36],
	]], [[	/* 694:363 */
		[3286499.56, 8988806.77],
		[3287347.31, 9010479.23],
		[3309018.43, 9009594.68],
		[3308105.65, 8987928.24],
		[3286499.56, 8988806.77],
	]], [[	/* 694:364 */
		[3308105.65, 8987928.24],
		[3309018.43, 9009594.68],
		[3330683.29, 9008644.82],
		[3329705.54, 8986984.84],
		[3308105.65, 8987928.24],
	]], [[	/* 694:365 */
		[3329705.54, 8986984.84],
		[3330683.29, 9008644.82],
		[3352341.43, 9007629.71],
		[3351298.77, 8985976.64],
		[3329705.54, 8986984.84],
	]], [[	/* 694:366 */
		[3351298.77, 8985976.64],
		[3352341.43, 9007629.71],
		[3373992.41, 9006549.42],
		[3372884.92, 8984903.68],
		[3351298.77, 8985976.64],
	]], [[	/* 694:367 */
		[3372884.92, 8984903.68],
		[3373992.41, 9006549.42],
		[3395635.80, 9005404.01],
		[3394463.55, 8983766.06],
		[3372884.92, 8984903.68],
	]], [[	/* 694:368 */
		[3394463.55, 8983766.06],
		[3395635.80, 9005404.01],
		[3417271.14, 9004193.57],
		[3416034.21, 8982563.84],
		[3394463.55, 8983766.06],
	]], [[	/* 694:369 */
		[3416034.21, 8982563.84],
		[3417271.14, 9004193.57],
		[3438898.01, 9002918.17],
		[3437596.47, 8981297.10],
		[3416034.21, 8982563.84],
	]], [[	/* 694:370 */
		[3437596.47, 8981297.10],
		[3438898.01, 9002918.17],
		[3460515.96, 9001577.91],
		[3459149.90, 8979965.93],
		[3437596.47, 8981297.10],
	]], [[	/* 694:371 */
		[3459149.90, 8979965.93],
		[3460515.96, 9001577.91],
		[3482124.54, 9000172.86],
		[3480694.06, 8978570.41],
		[3459149.90, 8979965.93],
	]], [[	/* 694:372 */
		[3480694.06, 8978570.41],
		[3482124.54, 9000172.86],
		[3503723.34, 8998703.12],
		[3502228.53, 8977110.64],
		[3480694.06, 8978570.41],
	]], [[	/* 695:319 */
		[2334409.14, 8984554.75],
		[2332387.56, 9006115.05],
		[2353955.83, 9008114.33],
		[2355913.55, 8986540.50],
		[2334409.14, 8984554.75],
	]], [[	/* 695:320 */
		[2355913.55, 8986540.50],
		[2353955.83, 9008114.33],
		[2375537.47, 9010049.40],
		[2377431.23, 8988462.46],
		[2355913.55, 8986540.50],
	]], [[	/* 695:321 */
		[2377431.23, 8988462.46],
		[2375537.47, 9010049.40],
		[2397132.07, 9011920.12],
		[2398961.73, 8990320.50],
		[2377431.23, 8988462.46],
	]], [[	/* 695:322 */
		[2398961.73, 8990320.50],
		[2397132.07, 9011920.12],
		[2418739.20, 9013726.38],
		[2420504.63, 8992114.51],
		[2398961.73, 8990320.50],
	]], [[	/* 695:323 */
		[2420504.63, 8992114.51],
		[2418739.20, 9013726.38],
		[2440358.42, 9015468.04],
		[2442059.51, 8993844.35],
		[2420504.63, 8992114.51],
	]], [[	/* 695:324 */
		[2442059.51, 8993844.35],
		[2440358.42, 9015468.04],
		[2461989.29, 9017145.00],
		[2463625.94, 8995509.93],
		[2442059.51, 8993844.35],
	]], [[	/* 695:325 */
		[2463625.94, 8995509.93],
		[2461989.29, 9017145.00],
		[2483631.39, 9018757.15],
		[2485203.47, 8997111.12],
		[2463625.94, 8995509.93],
	]], [[	/* 695:326 */
		[2485203.47, 8997111.12],
		[2483631.39, 9018757.15],
		[2505284.27, 9020304.37],
		[2506791.69, 8998647.83],
		[2485203.47, 8997111.12],
	]], [[	/* 695:327 */
		[2506791.69, 8998647.83],
		[2505284.27, 9020304.37],
		[2526947.49, 9021786.57],
		[2528390.15, 9000119.95],
		[2506791.69, 8998647.83],
	]], [[	/* 695:328 */
		[2528390.15, 9000119.95],
		[2526947.49, 9021786.57],
		[2548620.62, 9023203.64],
		[2549998.42, 9001527.38],
		[2528390.15, 9000119.95],
	]], [[	/* 695:329 */
		[2549998.42, 9001527.38],
		[2548620.62, 9023203.64],
		[2570303.21, 9024555.49],
		[2571616.06, 9002870.03],
		[2549998.42, 9001527.38],
	]], [[	/* 695:330 */
		[2571616.06, 9002870.03],
		[2570303.21, 9024555.49],
		[2591994.83, 9025842.04],
		[2593242.64, 9004147.82],
		[2571616.06, 9002870.03],
	]], [[	/* 695:331 */
		[2593242.64, 9004147.82],
		[2591994.83, 9025842.04],
		[2613695.02, 9027063.19],
		[2614877.71, 9005360.65],
		[2593242.64, 9004147.82],
	]], [[	/* 695:332 */
		[2614877.71, 9005360.65],
		[2613695.02, 9027063.19],
		[2635403.35, 9028218.86],
		[2636520.84, 9006508.46],
		[2614877.71, 9005360.65],
	]], [[	/* 695:333 */
		[2636520.84, 9006508.46],
		[2635403.35, 9028218.86],
		[2657119.36, 9029308.98],
		[2658171.58, 9007591.15],
		[2636520.84, 9006508.46],
	]], [[	/* 695:334 */
		[2658171.58, 9007591.15],
		[2657119.36, 9029308.98],
		[2678842.62, 9030333.48],
		[2679829.49, 9008608.66],
		[2658171.58, 9007591.15],
	]], [[	/* 695:335 */
		[2679829.49, 9008608.66],
		[2678842.62, 9030333.48],
		[2700572.67, 9031292.28],
		[2701494.13, 9009560.92],
		[2679829.49, 9008608.66],
	]], [[	/* 695:336 */
		[2701494.13, 9009560.92],
		[2700572.67, 9031292.28],
		[2722309.07, 9032185.32],
		[2723165.05, 9010447.86],
		[2701494.13, 9009560.92],
	]], [[	/* 695:337 */
		[2723165.05, 9010447.86],
		[2722309.07, 9032185.32],
		[2744051.36, 9033012.53],
		[2744841.81, 9011269.44],
		[2723165.05, 9010447.86],
	]], [[	/* 695:338 */
		[2744841.81, 9011269.44],
		[2744051.36, 9033012.53],
		[2765799.09, 9033773.88],
		[2766523.96, 9012025.59],
		[2744841.81, 9011269.44],
	]], [[	/* 695:339 */
		[2766523.96, 9012025.59],
		[2765799.09, 9033773.88],
		[2787551.83, 9034469.30],
		[2788211.07, 9012716.26],
		[2766523.96, 9012025.59],
	]], [[	/* 695:340 */
		[2788211.07, 9012716.26],
		[2787551.83, 9034469.30],
		[2809309.10, 9035098.74],
		[2809902.66, 9013341.40],
		[2788211.07, 9012716.26],
	]], [[	/* 695:341 */
		[2809902.66, 9013341.40],
		[2809309.10, 9035098.74],
		[2831070.47, 9035662.17],
		[2831598.32, 9013900.98],
		[2809902.66, 9013341.40],
	]], [[	/* 695:342 */
		[2831598.32, 9013900.98],
		[2831070.47, 9035662.17],
		[2852835.48, 9036159.55],
		[2853297.57, 9014394.96],
		[2831598.32, 9013900.98],
	]], [[	/* 695:343 */
		[2853297.57, 9014394.96],
		[2852835.48, 9036159.55],
		[2874603.67, 9036590.84],
		[2874999.98, 9014823.31],
		[2853297.57, 9014394.96],
	]], [[	/* 695:344 */
		[2874999.98, 9014823.31],
		[2874603.67, 9036590.84],
		[2896374.60, 9036956.01],
		[2896705.10, 9015185.99],
		[2874999.98, 9014823.31],
	]], [[	/* 695:345 */
		[2896705.10, 9015185.99],
		[2896374.60, 9036956.01],
		[2918147.81, 9037255.04],
		[2918412.48, 9015482.98],
		[2896705.10, 9015185.99],
	]], [[	/* 695:346 */
		[2918412.48, 9015482.98],
		[2918147.81, 9037255.04],
		[2939922.84, 9037487.91],
		[2940121.66, 9015714.26],
		[2918412.48, 9015482.98],
	]], [[	/* 695:347 */
		[2940121.66, 9015714.26],
		[2939922.84, 9037487.91],
		[2961699.24, 9037654.61],
		[2961832.20, 9015879.81],
		[2940121.66, 9015714.26],
	]], [[	/* 695:348 */
		[2961832.20, 9015879.81],
		[2961699.24, 9037654.61],
		[2983476.56, 9037755.12],
		[2983543.65, 9015979.64],
		[2961832.20, 9015879.81],
	]], [[	/* 695:349 */
		[2983543.65, 9015979.64],
		[2983476.56, 9037755.12],
		[3005254.34, 9037789.43],
		[3005255.55, 9016013.72],
		[2983543.65, 9015979.64],
	]], [[	/* 695:350 */
		[3005255.55, 9016013.72],
		[3005254.34, 9037789.43],
		[3027032.13, 9037757.55],
		[3026967.46, 9015982.05],
		[3005255.55, 9016013.72],
	]], [[	/* 695:351 */
		[3026967.46, 9015982.05],
		[3027032.13, 9037757.55],
		[3048809.47, 9037659.47],
		[3048678.94, 9015884.65],
		[3026967.46, 9015982.05],
	]], [[	/* 695:352 */
		[3048678.94, 9015884.65],
		[3048809.47, 9037659.47],
		[3070585.91, 9037495.21],
		[3070389.51, 9015721.51],
		[3048678.94, 9015884.65],
	]], [[	/* 695:353 */
		[3070389.51, 9015721.51],
		[3070585.91, 9037495.21],
		[3092361.00, 9037264.77],
		[3092098.75, 9015492.64],
		[3070389.51, 9015721.51],
	]], [[	/* 695:354 */
		[3092098.75, 9015492.64],
		[3092361.00, 9037264.77],
		[3114134.27, 9036968.16],
		[3113806.19, 9015198.07],
		[3092098.75, 9015492.64],
	]], [[	/* 695:355 */
		[3113806.19, 9015198.07],
		[3114134.27, 9036968.16],
		[3135905.28, 9036605.42],
		[3135511.39, 9014837.80],
		[3113806.19, 9015198.07],
	]], [[	/* 695:356 */
		[3135511.39, 9014837.80],
		[3135905.28, 9036605.42],
		[3157673.57, 9036176.56],
		[3157213.90, 9014411.87],
		[3135511.39, 9014837.80],
	]], [[	/* 695:357 */
		[3157213.90, 9014411.87],
		[3157673.57, 9036176.56],
		[3179438.69, 9035681.61],
		[3178913.26, 9013920.31],
		[3157213.90, 9014411.87],
	]], [[	/* 695:358 */
		[3178913.26, 9013920.31],
		[3179438.69, 9035681.61],
		[3201200.19, 9035120.61],
		[3200609.04, 9013363.14],
		[3178913.26, 9013920.31],
	]], [[	/* 695:359 */
		[3200609.04, 9013363.14],
		[3201200.19, 9035120.61],
		[3222957.61, 9034493.59],
		[3222300.78, 9012740.40],
		[3200609.04, 9013363.14],
	]], [[	/* 695:360 */
		[3222300.78, 9012740.40],
		[3222957.61, 9034493.59],
		[3244710.50, 9033800.59],
		[3243988.04, 9012052.14],
		[3222300.78, 9012740.40],
	]], [[	/* 695:361 */
		[3243988.04, 9012052.14],
		[3244710.50, 9033800.59],
		[3266458.41, 9033041.67],
		[3265670.36, 9011298.40],
		[3243988.04, 9012052.14],
	]], [[	/* 695:362 */
		[3265670.36, 9011298.40],
		[3266458.41, 9033041.67],
		[3288200.89, 9032216.87],
		[3287347.31, 9010479.23],
		[3265670.36, 9011298.40],
	]], [[	/* 695:363 */
		[3287347.31, 9010479.23],
		[3288200.89, 9032216.87],
		[3309937.48, 9031326.25],
		[3309018.43, 9009594.68],
		[3287347.31, 9010479.23],
	]], [[	/* 695:364 */
		[3309018.43, 9009594.68],
		[3309937.48, 9031326.25],
		[3331667.75, 9030369.87],
		[3330683.29, 9008644.82],
		[3309018.43, 9009594.68],
	]], [[	/* 695:365 */
		[3330683.29, 9008644.82],
		[3331667.75, 9030369.87],
		[3353391.24, 9029347.79],
		[3352341.43, 9007629.71],
		[3330683.29, 9008644.82],
	]], [[	/* 695:366 */
		[3352341.43, 9007629.71],
		[3353391.24, 9029347.79],
		[3375107.50, 9028260.08],
		[3373992.41, 9006549.42],
		[3352341.43, 9007629.71],
	]], [[	/* 695:367 */
		[3373992.41, 9006549.42],
		[3375107.50, 9028260.08],
		[3396816.09, 9027106.82],
		[3395635.80, 9005404.01],
		[3373992.41, 9006549.42],
	]], [[	/* 695:368 */
		[3395635.80, 9005404.01],
		[3396816.09, 9027106.82],
		[3418516.56, 9025888.07],
		[3417271.14, 9004193.57],
		[3395635.80, 9005404.01],
	]], [[	/* 695:369 */
		[3417271.14, 9004193.57],
		[3418516.56, 9025888.07],
		[3440208.47, 9024603.93],
		[3438898.01, 9002918.17],
		[3417271.14, 9004193.57],
	]], [[	/* 695:370 */
		[3438898.01, 9002918.17],
		[3440208.47, 9024603.93],
		[3461891.37, 9023254.48],
		[3460515.96, 9001577.91],
		[3438898.01, 9002918.17],
	]], [[	/* 695:371 */
		[3460515.96, 9001577.91],
		[3461891.37, 9023254.48],
		[3483564.82, 9021839.80],
		[3482124.54, 9000172.86],
		[3460515.96, 9001577.91],
	]], [[	/* 695:372 */
		[3482124.54, 9000172.86],
		[3483564.82, 9021839.80],
		[3505228.38, 9020360.00],
		[3503723.34, 8998703.12],
		[3482124.54, 9000172.86],
	]], [[	/* 696:319 */
		[2332387.56, 9006115.05],
		[2330352.18, 9027739.24],
		[2351984.71, 9029752.20],
		[2353955.83, 9008114.33],
		[2332387.56, 9006115.05],
	]], [[	/* 696:320 */
		[2353955.83, 9008114.33],
		[2351984.71, 9029752.20],
		[2373630.76, 9031700.50],
		[2375537.47, 9010049.40],
		[2353955.83, 9008114.33],
	]], [[	/* 696:321 */
		[2375537.47, 9010049.40],
		[2373630.76, 9031700.50],
		[2395289.90, 9033584.03],
		[2397132.07, 9011920.12],
		[2375537.47, 9010049.40],
	]], [[	/* 696:322 */
		[2397132.07, 9011920.12],
		[2395289.90, 9033584.03],
		[2416961.68, 9035402.65],
		[2418739.20, 9013726.38],
		[2397132.07, 9011920.12],
	]], [[	/* 696:323 */
		[2418739.20, 9013726.38],
		[2416961.68, 9035402.65],
		[2438645.67, 9037156.25],
		[2440358.42, 9015468.04],
		[2418739.20, 9013726.38],
	]], [[	/* 696:324 */
		[2440358.42, 9015468.04],
		[2438645.67, 9037156.25],
		[2460341.43, 9038844.71],
		[2461989.29, 9017145.00],
		[2440358.42, 9015468.04],
	]], [[	/* 696:325 */
		[2461989.29, 9017145.00],
		[2460341.43, 9038844.71],
		[2482048.52, 9040467.91],
		[2483631.39, 9018757.15],
		[2461989.29, 9017145.00],
	]], [[	/* 696:326 */
		[2483631.39, 9018757.15],
		[2482048.52, 9040467.91],
		[2503766.50, 9042025.75],
		[2505284.27, 9020304.37],
		[2483631.39, 9018757.15],
	]], [[	/* 696:327 */
		[2505284.27, 9020304.37],
		[2503766.50, 9042025.75],
		[2525494.93, 9043518.12],
		[2526947.49, 9021786.57],
		[2505284.27, 9020304.37],
	]], [[	/* 696:328 */
		[2526947.49, 9021786.57],
		[2525494.93, 9043518.12],
		[2547233.35, 9044944.93],
		[2548620.62, 9023203.64],
		[2526947.49, 9021786.57],
	]], [[	/* 696:329 */
		[2548620.62, 9023203.64],
		[2547233.35, 9044944.93],
		[2568981.34, 9046306.07],
		[2570303.21, 9024555.49],
		[2548620.62, 9023203.64],
	]], [[	/* 696:330 */
		[2570303.21, 9024555.49],
		[2568981.34, 9046306.07],
		[2590738.44, 9047601.46],
		[2591994.83, 9025842.04],
		[2570303.21, 9024555.49],
	]], [[	/* 696:331 */
		[2591994.83, 9025842.04],
		[2590738.44, 9047601.46],
		[2612504.20, 9048831.01],
		[2613695.02, 9027063.19],
		[2591994.83, 9025842.04],
	]], [[	/* 696:332 */
		[2613695.02, 9027063.19],
		[2612504.20, 9048831.01],
		[2634278.17, 9049994.64],
		[2635403.35, 9028218.86],
		[2613695.02, 9027063.19],
	]], [[	/* 696:333 */
		[2635403.35, 9028218.86],
		[2634278.17, 9049994.64],
		[2656059.91, 9051092.26],
		[2657119.36, 9029308.98],
		[2635403.35, 9028218.86],
	]], [[	/* 696:334 */
		[2657119.36, 9029308.98],
		[2656059.91, 9051092.26],
		[2677848.96, 9052123.81],
		[2678842.62, 9030333.48],
		[2657119.36, 9029308.98],
	]], [[	/* 696:335 */
		[2678842.62, 9030333.48],
		[2677848.96, 9052123.81],
		[2699644.87, 9053089.21],
		[2700572.67, 9031292.28],
		[2678842.62, 9030333.48],
	]], [[	/* 696:336 */
		[2700572.67, 9031292.28],
		[2699644.87, 9053089.21],
		[2721447.19, 9053988.40],
		[2722309.07, 9032185.32],
		[2700572.67, 9031292.28],
	]], [[	/* 696:337 */
		[2722309.07, 9032185.32],
		[2721447.19, 9053988.40],
		[2743255.46, 9054821.32],
		[2744051.36, 9033012.53],
		[2722309.07, 9032185.32],
	]], [[	/* 696:338 */
		[2744051.36, 9033012.53],
		[2743255.46, 9054821.32],
		[2765069.23, 9055587.91],
		[2765799.09, 9033773.88],
		[2744051.36, 9033012.53],
	]], [[	/* 696:339 */
		[2765799.09, 9033773.88],
		[2765069.23, 9055587.91],
		[2786888.04, 9056288.12],
		[2787551.83, 9034469.30],
		[2765799.09, 9033773.88],
	]], [[	/* 696:340 */
		[2787551.83, 9034469.30],
		[2786888.04, 9056288.12],
		[2808711.45, 9056921.91],
		[2809309.10, 9035098.74],
		[2787551.83, 9034469.30],
	]], [[	/* 696:341 */
		[2809309.10, 9035098.74],
		[2808711.45, 9056921.91],
		[2830538.99, 9057489.22],
		[2831070.47, 9035662.17],
		[2809309.10, 9035098.74],
	]], [[	/* 696:342 */
		[2831070.47, 9035662.17],
		[2830538.99, 9057489.22],
		[2852370.20, 9057990.03],
		[2852835.48, 9036159.55],
		[2831070.47, 9035662.17],
	]], [[	/* 696:343 */
		[2852835.48, 9036159.55],
		[2852370.20, 9057990.03],
		[2874204.63, 9058424.29],
		[2874603.67, 9036590.84],
		[2852835.48, 9036159.55],
	]], [[	/* 696:344 */
		[2874603.67, 9036590.84],
		[2874204.63, 9058424.29],
		[2896041.82, 9058791.99],
		[2896374.60, 9036956.01],
		[2874603.67, 9036590.84],
	]], [[	/* 696:345 */
		[2896374.60, 9036956.01],
		[2896041.82, 9058791.99],
		[2917881.31, 9059093.08],
		[2918147.81, 9037255.04],
		[2896374.60, 9036956.01],
	]], [[	/* 696:346 */
		[2918147.81, 9037255.04],
		[2917881.31, 9059093.08],
		[2939722.65, 9059327.56],
		[2939922.84, 9037487.91],
		[2918147.81, 9037255.04],
	]], [[	/* 696:347 */
		[2939922.84, 9037487.91],
		[2939722.65, 9059327.56],
		[2961565.37, 9059495.41],
		[2961699.24, 9037654.61],
		[2939922.84, 9037487.91],
	]], [[	/* 696:348 */
		[2961699.24, 9037654.61],
		[2961565.37, 9059495.41],
		[2983409.01, 9059596.61],
		[2983476.56, 9037755.12],
		[2961699.24, 9037654.61],
	]], [[	/* 696:349 */
		[2983476.56, 9037755.12],
		[2983409.01, 9059596.61],
		[3005253.12, 9059631.16],
		[3005254.34, 9037789.43],
		[2983476.56, 9037755.12],
	]], [[	/* 696:350 */
		[3005254.34, 9037789.43],
		[3005253.12, 9059631.16],
		[3027097.24, 9059599.05],
		[3027032.13, 9037757.55],
		[3005254.34, 9037789.43],
	]], [[	/* 696:351 */
		[3027032.13, 9037757.55],
		[3027097.24, 9059599.05],
		[3048940.91, 9059500.30],
		[3048809.47, 9037659.47],
		[3027032.13, 9037757.55],
	]], [[	/* 696:352 */
		[3048809.47, 9037659.47],
		[3048940.91, 9059500.30],
		[3070783.67, 9059334.90],
		[3070585.91, 9037495.21],
		[3048809.47, 9037659.47],
	]], [[	/* 696:353 */
		[3070585.91, 9037495.21],
		[3070783.67, 9059334.90],
		[3092625.06, 9059102.87],
		[3092361.00, 9037264.77],
		[3070585.91, 9037495.21],
	]], [[	/* 696:354 */
		[3092361.00, 9037264.77],
		[3092625.06, 9059102.87],
		[3114464.62, 9058804.22],
		[3114134.27, 9036968.16],
		[3092361.00, 9037264.77],
	]], [[	/* 696:355 */
		[3114134.27, 9036968.16],
		[3114464.62, 9058804.22],
		[3136301.89, 9058438.97],
		[3135905.28, 9036605.42],
		[3114134.27, 9036968.16],
	]], [[	/* 696:356 */
		[3135905.28, 9036605.42],
		[3136301.89, 9058438.97],
		[3158136.42, 9058007.15],
		[3157673.57, 9036176.56],
		[3135905.28, 9036605.42],
	]], [[	/* 696:357 */
		[3157673.57, 9036176.56],
		[3158136.42, 9058007.15],
		[3179967.75, 9057508.78],
		[3179438.69, 9035681.61],
		[3157673.57, 9036176.56],
	]], [[	/* 696:358 */
		[3179438.69, 9035681.61],
		[3179967.75, 9057508.78],
		[3201795.41, 9056943.91],
		[3201200.19, 9035120.61],
		[3179438.69, 9035681.61],
	]], [[	/* 696:359 */
		[3201200.19, 9035120.61],
		[3201795.41, 9056943.91],
		[3223618.96, 9056312.57],
		[3222957.61, 9034493.59],
		[3201200.19, 9035120.61],
	]], [[	/* 696:360 */
		[3222957.61, 9034493.59],
		[3223618.96, 9056312.57],
		[3245437.94, 9055614.79],
		[3244710.50, 9033800.59],
		[3222957.61, 9034493.59],
	]], [[	/* 696:361 */
		[3244710.50, 9033800.59],
		[3245437.94, 9055614.79],
		[3267251.88, 9054850.64],
		[3266458.41, 9033041.67],
		[3244710.50, 9033800.59],
	]], [[	/* 696:362 */
		[3266458.41, 9033041.67],
		[3267251.88, 9054850.64],
		[3289060.34, 9054020.15],
		[3288200.89, 9032216.87],
		[3266458.41, 9033041.67],
	]], [[	/* 696:363 */
		[3288200.89, 9032216.87],
		[3289060.34, 9054020.15],
		[3310862.87, 9053123.40],
		[3309937.48, 9031326.25],
		[3288200.89, 9032216.87],
	]], [[	/* 696:364 */
		[3309937.48, 9031326.25],
		[3310862.87, 9053123.40],
		[3332659.00, 9052160.43],
		[3331667.75, 9030369.87],
		[3309937.48, 9031326.25],
	]], [[	/* 696:365 */
		[3331667.75, 9030369.87],
		[3332659.00, 9052160.43],
		[3354448.28, 9051131.31],
		[3353391.24, 9029347.79],
		[3331667.75, 9030369.87],
	]], [[	/* 696:366 */
		[3353391.24, 9029347.79],
		[3354448.28, 9051131.31],
		[3376230.27, 9050036.11],
		[3375107.50, 9028260.08],
		[3353391.24, 9029347.79],
	]], [[	/* 696:367 */
		[3375107.50, 9028260.08],
		[3376230.27, 9050036.11],
		[3398004.50, 9048874.91],
		[3396816.09, 9027106.82],
		[3375107.50, 9028260.08],
	]], [[	/* 696:368 */
		[3396816.09, 9027106.82],
		[3398004.50, 9048874.91],
		[3419770.54, 9047647.78],
		[3418516.56, 9025888.07],
		[3396816.09, 9027106.82],
	]], [[	/* 696:369 */
		[3418516.56, 9025888.07],
		[3419770.54, 9047647.78],
		[3441527.93, 9046354.81],
		[3440208.47, 9024603.93],
		[3418516.56, 9025888.07],
	]], [[	/* 696:370 */
		[3440208.47, 9024603.93],
		[3441527.93, 9046354.81],
		[3463276.23, 9044996.08],
		[3461891.37, 9023254.48],
		[3440208.47, 9024603.93],
	]], [[	/* 696:371 */
		[3461891.37, 9023254.48],
		[3463276.23, 9044996.08],
		[3485014.98, 9043571.69],
		[3483564.82, 9021839.80],
		[3461891.37, 9023254.48],
	]], [[	/* 696:372 */
		[3483564.82, 9021839.80],
		[3485014.98, 9043571.69],
		[3506743.75, 9042081.72],
		[3505228.38, 9020360.00],
		[3483564.82, 9021839.80],
	]], [[	/* 697:319 */
		[2330352.18, 9027739.24],
		[2328302.84, 9049427.77],
		[2350000.08, 9051454.52],
		[2351984.71, 9029752.20],
		[2330352.18, 9027739.24],
	]], [[	/* 697:320 */
		[2351984.71, 9029752.20],
		[2350000.08, 9051454.52],
		[2371710.97, 9053416.19],
		[2373630.76, 9031700.50],
		[2351984.71, 9029752.20],
	]], [[	/* 697:321 */
		[2373630.76, 9031700.50],
		[2371710.97, 9053416.19],
		[2393435.07, 9055312.65],
		[2395289.90, 9033584.03],
		[2373630.76, 9031700.50],
	]], [[	/* 697:322 */
		[2395289.90, 9033584.03],
		[2393435.07, 9055312.65],
		[2415171.94, 9057143.76],
		[2416961.68, 9035402.65],
		[2395289.90, 9033584.03],
	]], [[	/* 697:323 */
		[2416961.68, 9035402.65],
		[2415171.94, 9057143.76],
		[2436921.14, 9058909.41],
		[2438645.67, 9037156.25],
		[2416961.68, 9035402.65],
	]], [[	/* 697:324 */
		[2438645.67, 9037156.25],
		[2436921.14, 9058909.41],
		[2458682.23, 9060609.48],
		[2460341.43, 9038844.71],
		[2438645.67, 9037156.25],
	]], [[	/* 697:325 */
		[2460341.43, 9038844.71],
		[2458682.23, 9060609.48],
		[2480454.76, 9062243.85],
		[2482048.52, 9040467.91],
		[2460341.43, 9038844.71],
	]], [[	/* 697:326 */
		[2482048.52, 9040467.91],
		[2480454.76, 9062243.85],
		[2502238.28, 9063812.41],
		[2503766.50, 9042025.75],
		[2482048.52, 9040467.91],
	]], [[	/* 697:327 */
		[2503766.50, 9042025.75],
		[2502238.28, 9063812.41],
		[2524032.36, 9065315.06],
		[2525494.93, 9043518.12],
		[2503766.50, 9042025.75],
	]], [[	/* 697:328 */
		[2525494.93, 9043518.12],
		[2524032.36, 9065315.06],
		[2545836.53, 9066751.70],
		[2547233.35, 9044944.93],
		[2525494.93, 9043518.12],
	]], [[	/* 697:329 */
		[2547233.35, 9044944.93],
		[2545836.53, 9066751.70],
		[2567650.36, 9068122.22],
		[2568981.34, 9046306.07],
		[2547233.35, 9044944.93],
	]], [[	/* 697:330 */
		[2568981.34, 9046306.07],
		[2567650.36, 9068122.22],
		[2589473.39, 9069426.55],
		[2590738.44, 9047601.46],
		[2568981.34, 9046306.07],
	]], [[	/* 697:331 */
		[2590738.44, 9047601.46],
		[2589473.39, 9069426.55],
		[2611305.16, 9070664.58],
		[2612504.20, 9048831.01],
		[2590738.44, 9047601.46],
	]], [[	/* 697:332 */
		[2612504.20, 9048831.01],
		[2611305.16, 9070664.58],
		[2633145.23, 9071836.23],
		[2634278.17, 9049994.64],
		[2612504.20, 9048831.01],
	]], [[	/* 697:333 */
		[2634278.17, 9049994.64],
		[2633145.23, 9071836.23],
		[2654993.14, 9072941.43],
		[2656059.91, 9051092.26],
		[2634278.17, 9049994.64],
	]], [[	/* 697:334 */
		[2656059.91, 9051092.26],
		[2654993.14, 9072941.43],
		[2676848.43, 9073980.10],
		[2677848.96, 9052123.81],
		[2656059.91, 9051092.26],
	]], [[	/* 697:335 */
		[2677848.96, 9052123.81],
		[2676848.43, 9073980.10],
		[2698710.66, 9074952.17],
		[2699644.87, 9053089.21],
		[2677848.96, 9052123.81],
	]], [[	/* 697:336 */
		[2699644.87, 9053089.21],
		[2698710.66, 9074952.17],
		[2720579.35, 9075857.57],
		[2721447.19, 9053988.40],
		[2699644.87, 9053089.21],
	]], [[	/* 697:337 */
		[2721447.19, 9053988.40],
		[2720579.35, 9075857.57],
		[2742454.06, 9076696.25],
		[2743255.46, 9054821.32],
		[2721447.19, 9053988.40],
	]], [[	/* 697:338 */
		[2743255.46, 9054821.32],
		[2742454.06, 9076696.25],
		[2764334.32, 9077468.14],
		[2765069.23, 9055587.91],
		[2743255.46, 9054821.32],
	]], [[	/* 697:339 */
		[2765069.23, 9055587.91],
		[2764334.32, 9077468.14],
		[2786219.67, 9078173.19],
		[2786888.04, 9056288.12],
		[2765069.23, 9055587.91],
	]], [[	/* 697:340 */
		[2786888.04, 9056288.12],
		[2786219.67, 9078173.19],
		[2808109.66, 9078811.36],
		[2808711.45, 9056921.91],
		[2786888.04, 9056288.12],
	]], [[	/* 697:341 */
		[2808711.45, 9056921.91],
		[2808109.66, 9078811.36],
		[2830003.83, 9079382.60],
		[2830538.99, 9057489.22],
		[2808711.45, 9056921.91],
	]], [[	/* 697:342 */
		[2830538.99, 9057489.22],
		[2830003.83, 9079382.60],
		[2851901.70, 9079886.87],
		[2852370.20, 9057990.03],
		[2830538.99, 9057489.22],
	]], [[	/* 697:343 */
		[2852370.20, 9057990.03],
		[2851901.70, 9079886.87],
		[2873802.82, 9080324.14],
		[2874204.63, 9058424.29],
		[2852370.20, 9057990.03],
	]], [[	/* 697:344 */
		[2874204.63, 9058424.29],
		[2873802.82, 9080324.14],
		[2895706.73, 9080694.37],
		[2896041.82, 9058791.99],
		[2874204.63, 9058424.29],
	]], [[	/* 697:345 */
		[2896041.82, 9058791.99],
		[2895706.73, 9080694.37],
		[2917612.97, 9080997.55],
		[2917881.31, 9059093.08],
		[2896041.82, 9058791.99],
	]], [[	/* 697:346 */
		[2917881.31, 9059093.08],
		[2917612.97, 9080997.55],
		[2939521.07, 9081233.65],
		[2939722.65, 9059327.56],
		[2917881.31, 9059093.08],
	]], [[	/* 697:347 */
		[2939722.65, 9059327.56],
		[2939521.07, 9081233.65],
		[2961430.56, 9081402.66],
		[2961565.37, 9059495.41],
		[2939722.65, 9059327.56],
	]], [[	/* 697:348 */
		[2961565.37, 9059495.41],
		[2961430.56, 9081402.66],
		[2983341.00, 9081504.56],
		[2983409.01, 9059596.61],
		[2961565.37, 9059495.41],
	]], [[	/* 697:349 */
		[2983409.01, 9059596.61],
		[2983341.00, 9081504.56],
		[3005251.90, 9081539.35],
		[3005253.12, 9059631.16],
		[2983409.01, 9059596.61],
	]], [[	/* 697:350 */
		[3005253.12, 9059631.16],
		[3005251.90, 9081539.35],
		[3027162.81, 9081507.02],
		[3027097.24, 9059599.05],
		[3005253.12, 9059631.16],
	]], [[	/* 697:351 */
		[3027097.24, 9059599.05],
		[3027162.81, 9081507.02],
		[3049073.26, 9081407.58],
		[3048940.91, 9059500.30],
		[3027097.24, 9059599.05],
	]], [[	/* 697:352 */
		[3048940.91, 9059500.30],
		[3049073.26, 9081407.58],
		[3070982.80, 9081241.04],
		[3070783.67, 9059334.90],
		[3048940.91, 9059500.30],
	]], [[	/* 697:353 */
		[3070783.67, 9059334.90],
		[3070982.80, 9081241.04],
		[3092890.95, 9081007.40],
		[3092625.06, 9059102.87],
		[3070783.67, 9059334.90],
	]], [[	/* 697:354 */
		[3092625.06, 9059102.87],
		[3092890.95, 9081007.40],
		[3114797.25, 9080706.68],
		[3114464.62, 9058804.22],
		[3092625.06, 9059102.87],
	]], [[	/* 697:355 */
		[3114464.62, 9058804.22],
		[3114797.25, 9080706.68],
		[3136701.25, 9080338.90],
		[3136301.89, 9058438.97],
		[3114464.62, 9058804.22],
	]], [[	/* 697:356 */
		[3136301.89, 9058438.97],
		[3136701.25, 9080338.90],
		[3158602.47, 9079904.09],
		[3158136.42, 9058007.15],
		[3136301.89, 9058438.97],
	]], [[	/* 697:357 */
		[3158136.42, 9058007.15],
		[3158602.47, 9079904.09],
		[3180500.46, 9079402.28],
		[3179967.75, 9057508.78],
		[3158136.42, 9058007.15],
	]], [[	/* 697:358 */
		[3179967.75, 9057508.78],
		[3180500.46, 9079402.28],
		[3202394.75, 9078833.50],
		[3201795.41, 9056943.91],
		[3179967.75, 9057508.78],
	]], [[	/* 697:359 */
		[3201795.41, 9056943.91],
		[3202394.75, 9078833.50],
		[3224284.89, 9078197.79],
		[3223618.96, 9056312.57],
		[3201795.41, 9056943.91],
	]], [[	/* 697:360 */
		[3223618.96, 9056312.57],
		[3224284.89, 9078197.79],
		[3246170.41, 9077495.19],
		[3245437.94, 9055614.79],
		[3223618.96, 9056312.57],
	]], [[	/* 697:361 */
		[3245437.94, 9055614.79],
		[3246170.41, 9077495.19],
		[3268050.84, 9076725.75],
		[3267251.88, 9054850.64],
		[3245437.94, 9055614.79],
	]], [[	/* 697:362 */
		[3267251.88, 9054850.64],
		[3268050.84, 9076725.75],
		[3289925.74, 9075889.52],
		[3289060.34, 9054020.15],
		[3267251.88, 9054850.64],
	]], [[	/* 697:363 */
		[3289060.34, 9054020.15],
		[3289925.74, 9075889.52],
		[3311794.64, 9074986.57],
		[3310862.87, 9053123.40],
		[3289060.34, 9054020.15],
	]], [[	/* 697:364 */
		[3310862.87, 9053123.40],
		[3311794.64, 9074986.57],
		[3333657.08, 9074016.95],
		[3332659.00, 9052160.43],
		[3310862.87, 9053123.40],
	]], [[	/* 697:365 */
		[3332659.00, 9052160.43],
		[3333657.08, 9074016.95],
		[3355512.62, 9072980.72],
		[3354448.28, 9051131.31],
		[3332659.00, 9052160.43],
	]], [[	/* 697:366 */
		[3354448.28, 9051131.31],
		[3355512.62, 9072980.72],
		[3377360.78, 9071877.96],
		[3376230.27, 9050036.11],
		[3354448.28, 9051131.31],
	]], [[	/* 697:367 */
		[3376230.27, 9050036.11],
		[3377360.78, 9071877.96],
		[3399201.11, 9070708.75],
		[3398004.50, 9048874.91],
		[3376230.27, 9050036.11],
	]], [[	/* 697:368 */
		[3398004.50, 9048874.91],
		[3399201.11, 9070708.75],
		[3421033.17, 9069473.15],
		[3419770.54, 9047647.78],
		[3398004.50, 9048874.91],
	]], [[	/* 697:369 */
		[3419770.54, 9047647.78],
		[3421033.17, 9069473.15],
		[3442856.49, 9068171.26],
		[3441527.93, 9046354.81],
		[3419770.54, 9047647.78],
	]], [[	/* 697:370 */
		[3441527.93, 9046354.81],
		[3442856.49, 9068171.26],
		[3464670.63, 9066803.17],
		[3463276.23, 9044996.08],
		[3441527.93, 9046354.81],
	]], [[	/* 697:371 */
		[3463276.23, 9044996.08],
		[3464670.63, 9066803.17],
		[3486475.13, 9065368.96],
		[3485014.98, 9043571.69],
		[3463276.23, 9044996.08],
	]], [[	/* 697:372 */
		[3485014.98, 9043571.69],
		[3486475.13, 9065368.96],
		[3508269.55, 9063868.73],
		[3506743.75, 9042081.72],
		[3485014.98, 9043571.69],
	]], [[	/* 697:373 */
		[3506743.75, 9042081.72],
		[3508269.55, 9063868.73],
		[3530053.43, 9062302.59],
		[3528462.08, 9040526.29],
		[3506743.75, 9042081.72],
	]], [[	/* 698:319 */
		[2328302.84, 9049427.77],
		[2326239.42, 9071181.05],
		[2348001.81, 9073221.74],
		[2350000.08, 9051454.52],
		[2328302.84, 9049427.77],
	]], [[	/* 698:320 */
		[2350000.08, 9051454.52],
		[2348001.81, 9073221.74],
		[2369777.97, 9075196.91],
		[2371710.97, 9053416.19],
		[2350000.08, 9051454.52],
	]], [[	/* 698:321 */
		[2371710.97, 9053416.19],
		[2369777.97, 9075196.91],
		[2391567.48, 9077106.42],
		[2393435.07, 9055312.65],
		[2371710.97, 9053416.19],
	]], [[	/* 698:322 */
		[2393435.07, 9055312.65],
		[2391567.48, 9077106.42],
		[2413369.88, 9078950.15],
		[2415171.94, 9057143.76],
		[2393435.07, 9055312.65],
	]], [[	/* 698:323 */
		[2415171.94, 9057143.76],
		[2413369.88, 9078950.15],
		[2435184.74, 9080727.97],
		[2436921.14, 9058909.41],
		[2415171.94, 9057143.76],
	]], [[	/* 698:324 */
		[2436921.14, 9058909.41],
		[2435184.74, 9080727.97],
		[2457011.59, 9082439.76],
		[2458682.23, 9060609.48],
		[2436921.14, 9058909.41],
	]], [[	/* 698:325 */
		[2458682.23, 9060609.48],
		[2457011.59, 9082439.76],
		[2478850.00, 9084085.41],
		[2480454.76, 9062243.85],
		[2458682.23, 9060609.48],
	]], [[	/* 698:326 */
		[2480454.76, 9062243.85],
		[2478850.00, 9084085.41],
		[2500699.52, 9085664.80],
		[2502238.28, 9063812.41],
		[2480454.76, 9062243.85],
	]], [[	/* 698:327 */
		[2502238.28, 9063812.41],
		[2500699.52, 9085664.80],
		[2522559.69, 9087177.83],
		[2524032.36, 9065315.06],
		[2502238.28, 9063812.41],
	]], [[	/* 698:328 */
		[2524032.36, 9065315.06],
		[2522559.69, 9087177.83],
		[2544430.06, 9088624.39],
		[2545836.53, 9066751.70],
		[2524032.36, 9065315.06],
	]], [[	/* 698:329 */
		[2545836.53, 9066751.70],
		[2544430.06, 9088624.39],
		[2566310.18, 9090004.39],
		[2567650.36, 9068122.22],
		[2545836.53, 9066751.70],
	]], [[	/* 698:330 */
		[2567650.36, 9068122.22],
		[2566310.18, 9090004.39],
		[2588199.59, 9091317.73],
		[2589473.39, 9069426.55],
		[2567650.36, 9068122.22],
	]], [[	/* 698:331 */
		[2589473.39, 9069426.55],
		[2588199.59, 9091317.73],
		[2610097.83, 9092564.33],
		[2611305.16, 9070664.58],
		[2589473.39, 9069426.55],
	]], [[	/* 698:332 */
		[2611305.16, 9070664.58],
		[2610097.83, 9092564.33],
		[2632004.45, 9093744.09],
		[2633145.23, 9071836.23],
		[2611305.16, 9070664.58],
	]], [[	/* 698:333 */
		[2633145.23, 9071836.23],
		[2632004.45, 9093744.09],
		[2653918.99, 9094856.94],
		[2654993.14, 9072941.43],
		[2633145.23, 9071836.23],
	]], [[	/* 698:334 */
		[2654993.14, 9072941.43],
		[2653918.99, 9094856.94],
		[2675840.98, 9095902.80],
		[2676848.43, 9073980.10],
		[2654993.14, 9072941.43],
	]], [[	/* 698:335 */
		[2676848.43, 9073980.10],
		[2675840.98, 9095902.80],
		[2697769.98, 9096881.61],
		[2698710.66, 9074952.17],
		[2676848.43, 9073980.10],
	]], [[	/* 698:336 */
		[2698710.66, 9074952.17],
		[2697769.98, 9096881.61],
		[2719705.50, 9097793.28],
		[2720579.35, 9075857.57],
		[2698710.66, 9074952.17],
	]], [[	/* 698:337 */
		[2720579.35, 9075857.57],
		[2719705.50, 9097793.28],
		[2741647.10, 9098637.77],
		[2742454.06, 9076696.25],
		[2720579.35, 9075857.57],
	]], [[	/* 698:338 */
		[2742454.06, 9076696.25],
		[2741647.10, 9098637.77],
		[2763594.31, 9099415.02],
		[2764334.32, 9077468.14],
		[2742454.06, 9076696.25],
	]], [[	/* 698:339 */
		[2764334.32, 9077468.14],
		[2763594.31, 9099415.02],
		[2785546.67, 9100124.96],
		[2786219.67, 9078173.19],
		[2764334.32, 9077468.14],
	]], [[	/* 698:340 */
		[2786219.67, 9078173.19],
		[2785546.67, 9100124.96],
		[2807503.70, 9100767.55],
		[2808109.66, 9078811.36],
		[2786219.67, 9078173.19],
	]], [[	/* 698:341 */
		[2808109.66, 9078811.36],
		[2807503.70, 9100767.55],
		[2829464.95, 9101342.75],
		[2830003.83, 9079382.60],
		[2808109.66, 9078811.36],
	]], [[	/* 698:342 */
		[2830003.83, 9079382.60],
		[2829464.95, 9101342.75],
		[2851429.95, 9101850.52],
		[2851901.70, 9079886.87],
		[2830003.83, 9079382.60],
	]], [[	/* 698:343 */
		[2851901.70, 9079886.87],
		[2851429.95, 9101850.52],
		[2873398.23, 9102290.82],
		[2873802.82, 9080324.14],
		[2851901.70, 9079886.87],
	]], [[	/* 698:344 */
		[2873802.82, 9080324.14],
		[2873398.23, 9102290.82],
		[2895369.33, 9102663.63],
		[2895706.73, 9080694.37],
		[2873802.82, 9080324.14],
	]], [[	/* 698:345 */
		[2895706.73, 9080694.37],
		[2895369.33, 9102663.63],
		[2917342.77, 9102968.91],
		[2917612.97, 9080997.55],
		[2895706.73, 9080694.37],
	]], [[	/* 698:346 */
		[2917612.97, 9080997.55],
		[2917342.77, 9102968.91],
		[2939318.09, 9103206.65],
		[2939521.07, 9081233.65],
		[2917612.97, 9080997.55],
	]], [[	/* 698:347 */
		[2939521.07, 9081233.65],
		[2939318.09, 9103206.65],
		[2961294.83, 9103376.83],
		[2961430.56, 9081402.66],
		[2939521.07, 9081233.65],
	]], [[	/* 698:348 */
		[2961430.56, 9081402.66],
		[2961294.83, 9103376.83],
		[2983272.51, 9103479.44],
		[2983341.00, 9081504.56],
		[2961430.56, 9081402.66],
	]], [[	/* 698:349 */
		[2983341.00, 9081504.56],
		[2983272.51, 9103479.44],
		[3005250.66, 9103514.47],
		[3005251.90, 9081539.35],
		[2983341.00, 9081504.56],
	]], [[	/* 698:350 */
		[3005251.90, 9081539.35],
		[3005250.66, 9103514.47],
		[3027228.83, 9103481.92],
		[3027162.81, 9081507.02],
		[3005251.90, 9081539.35],
	]], [[	/* 698:351 */
		[3027162.81, 9081507.02],
		[3027228.83, 9103481.92],
		[3049206.53, 9103381.79],
		[3049073.26, 9081407.58],
		[3027162.81, 9081507.02],
	]], [[	/* 698:352 */
		[3049073.26, 9081407.58],
		[3049206.53, 9103381.79],
		[3071183.31, 9103214.08],
		[3070982.80, 9081241.04],
		[3049073.26, 9081407.58],
	]], [[	/* 698:353 */
		[3070982.80, 9081241.04],
		[3071183.31, 9103214.08],
		[3093158.68, 9102978.82],
		[3092890.95, 9081007.40],
		[3070982.80, 9081241.04],
	]], [[	/* 698:354 */
		[3092890.95, 9081007.40],
		[3093158.68, 9102978.82],
		[3115132.20, 9102676.01],
		[3114797.25, 9080706.68],
		[3092890.95, 9081007.40],
	]], [[	/* 698:355 */
		[3114797.25, 9080706.68],
		[3115132.20, 9102676.01],
		[3137103.38, 9102305.68],
		[3136701.25, 9080338.90],
		[3114797.25, 9080706.68],
	]], [[	/* 698:356 */
		[3136701.25, 9080338.90],
		[3137103.38, 9102305.68],
		[3159071.76, 9101867.86],
		[3158602.47, 9079904.09],
		[3136701.25, 9080338.90],
	]], [[	/* 698:357 */
		[3158602.47, 9079904.09],
		[3159071.76, 9101867.86],
		[3181036.87, 9101362.56],
		[3180500.46, 9079402.28],
		[3158602.47, 9079904.09],
	]], [[	/* 698:358 */
		[3180500.46, 9079402.28],
		[3181036.87, 9101362.56],
		[3202998.25, 9100789.83],
		[3202394.75, 9078833.50],
		[3180500.46, 9079402.28],
	]], [[	/* 698:359 */
		[3202394.75, 9078833.50],
		[3202998.25, 9100789.83],
		[3224955.44, 9100149.71],
		[3224284.89, 9078197.79],
		[3202394.75, 9078833.50],
	]], [[	/* 698:360 */
		[3224284.89, 9078197.79],
		[3224955.44, 9100149.71],
		[3246907.95, 9099442.23],
		[3246170.41, 9077495.19],
		[3224284.89, 9078197.79],
	]], [[	/* 698:361 */
		[3246170.41, 9077495.19],
		[3246907.95, 9099442.23],
		[3268855.34, 9098667.46],
		[3268050.84, 9076725.75],
		[3246170.41, 9077495.19],
	]], [[	/* 698:362 */
		[3268050.84, 9076725.75],
		[3268855.34, 9098667.46],
		[3290797.13, 9097825.44],
		[3289925.74, 9075889.52],
		[3268050.84, 9076725.75],
	]], [[	/* 698:363 */
		[3289925.74, 9075889.52],
		[3290797.13, 9097825.44],
		[3312732.87, 9096916.22],
		[3311794.64, 9074986.57],
		[3289925.74, 9075889.52],
	]], [[	/* 698:364 */
		[3311794.64, 9074986.57],
		[3312732.87, 9096916.22],
		[3334662.09, 9095939.88],
		[3333657.08, 9074016.95],
		[3311794.64, 9074986.57],
	]], [[	/* 698:365 */
		[3333657.08, 9074016.95],
		[3334662.09, 9095939.88],
		[3356584.32, 9094896.48],
		[3355512.62, 9072980.72],
		[3333657.08, 9074016.95],
	]], [[	/* 698:366 */
		[3355512.62, 9072980.72],
		[3356584.32, 9094896.48],
		[3378499.11, 9093786.08],
		[3377360.78, 9071877.96],
		[3355512.62, 9072980.72],
	]], [[	/* 698:367 */
		[3377360.78, 9071877.96],
		[3378499.11, 9093786.08],
		[3400406.00, 9092608.77],
		[3399201.11, 9070708.75],
		[3377360.78, 9071877.96],
	]], [[	/* 698:368 */
		[3399201.11, 9070708.75],
		[3400406.00, 9092608.77],
		[3422304.53, 9091364.63],
		[3421033.17, 9069473.15],
		[3399201.11, 9070708.75],
	]], [[	/* 698:369 */
		[3421033.17, 9069473.15],
		[3422304.53, 9091364.63],
		[3444194.24, 9090053.73],
		[3442856.49, 9068171.26],
		[3421033.17, 9069473.15],
	]], [[	/* 698:370 */
		[3442856.49, 9068171.26],
		[3444194.24, 9090053.73],
		[3466074.67, 9088676.18],
		[3464670.63, 9066803.17],
		[3442856.49, 9068171.26],
	]], [[	/* 698:371 */
		[3464670.63, 9066803.17],
		[3466074.67, 9088676.18],
		[3487945.37, 9087232.06],
		[3486475.13, 9065368.96],
		[3464670.63, 9066803.17],
	]], [[	/* 698:372 */
		[3486475.13, 9065368.96],
		[3487945.37, 9087232.06],
		[3509805.89, 9085721.47],
		[3508269.55, 9063868.73],
		[3486475.13, 9065368.96],
	]], [[	/* 698:373 */
		[3508269.55, 9063868.73],
		[3509805.89, 9085721.47],
		[3531655.76, 9084144.51],
		[3530053.43, 9062302.59],
		[3508269.55, 9063868.73],
	]], [[	/* 699:318 */
		[2304491.26, 9069074.98],
		[2302348.17, 9090878.95],
		[2324161.78, 9092999.54],
		[2326239.42, 9071181.05],
		[2304491.26, 9069074.98],
	]], [[	/* 699:319 */
		[2326239.42, 9071181.05],
		[2324161.78, 9092999.54],
		[2345989.75, 9095054.30],
		[2348001.81, 9073221.74],
		[2326239.42, 9071181.05],
	]], [[	/* 699:320 */
		[2348001.81, 9073221.74],
		[2345989.75, 9095054.30],
		[2367831.63, 9097043.10],
		[2369777.97, 9075196.91],
		[2348001.81, 9073221.74],
	]], [[	/* 699:321 */
		[2369777.97, 9075196.91],
		[2367831.63, 9097043.10],
		[2389686.99, 9098965.80],
		[2391567.48, 9077106.42],
		[2369777.97, 9075196.91],
	]], [[	/* 699:322 */
		[2391567.48, 9077106.42],
		[2389686.99, 9098965.80],
		[2411555.37, 9100822.26],
		[2413369.88, 9078950.15],
		[2391567.48, 9077106.42],
	]], [[	/* 699:323 */
		[2413369.88, 9078950.15],
		[2411555.37, 9100822.26],
		[2433436.32, 9102612.37],
		[2435184.74, 9080727.97],
		[2413369.88, 9078950.15],
	]], [[	/* 699:324 */
		[2435184.74, 9080727.97],
		[2433436.32, 9102612.37],
		[2455329.40, 9104336.00],
		[2457011.59, 9082439.76],
		[2435184.74, 9080727.97],
	]], [[	/* 699:325 */
		[2457011.59, 9082439.76],
		[2455329.40, 9104336.00],
		[2477234.14, 9105993.04],
		[2478850.00, 9084085.41],
		[2457011.59, 9082439.76],
	]], [[	/* 699:326 */
		[2478850.00, 9084085.41],
		[2477234.14, 9105993.04],
		[2499150.10, 9107583.36],
		[2500699.52, 9085664.80],
		[2478850.00, 9084085.41],
	]], [[	/* 699:327 */
		[2500699.52, 9085664.80],
		[2499150.10, 9107583.36],
		[2521076.82, 9109106.87],
		[2522559.69, 9087177.83],
		[2500699.52, 9085664.80],
	]], [[	/* 699:328 */
		[2522559.69, 9087177.83],
		[2521076.82, 9109106.87],
		[2543013.84, 9110563.46],
		[2544430.06, 9088624.39],
		[2522559.69, 9087177.83],
	]], [[	/* 699:329 */
		[2544430.06, 9088624.39],
		[2543013.84, 9110563.46],
		[2564960.70, 9111953.03],
		[2566310.18, 9090004.39],
		[2544430.06, 9088624.39],
	]], [[	/* 699:330 */
		[2566310.18, 9090004.39],
		[2564960.70, 9111953.03],
		[2586916.95, 9113275.48],
		[2588199.59, 9091317.73],
		[2566310.18, 9090004.39],
	]], [[	/* 699:331 */
		[2588199.59, 9091317.73],
		[2586916.95, 9113275.48],
		[2608882.12, 9114530.72],
		[2610097.83, 9092564.33],
		[2588199.59, 9091317.73],
	]], [[	/* 699:332 */
		[2610097.83, 9092564.33],
		[2608882.12, 9114530.72],
		[2630855.75, 9115718.67],
		[2632004.45, 9093744.09],
		[2610097.83, 9092564.33],
	]], [[	/* 699:333 */
		[2632004.45, 9093744.09],
		[2630855.75, 9115718.67],
		[2652837.38, 9116839.25],
		[2653918.99, 9094856.94],
		[2632004.45, 9093744.09],
	]], [[	/* 699:334 */
		[2653918.99, 9094856.94],
		[2652837.38, 9116839.25],
		[2674826.53, 9117892.38],
		[2675840.98, 9095902.80],
		[2653918.99, 9094856.94],
	]], [[	/* 699:335 */
		[2675840.98, 9095902.80],
		[2674826.53, 9117892.38],
		[2696822.76, 9118877.99],
		[2697769.98, 9096881.61],
		[2675840.98, 9095902.80],
	]], [[	/* 699:336 */
		[2697769.98, 9096881.61],
		[2696822.76, 9118877.99],
		[2718825.58, 9119796.00],
		[2719705.50, 9097793.28],
		[2697769.98, 9096881.61],
	]], [[	/* 699:337 */
		[2719705.50, 9097793.28],
		[2718825.58, 9119796.00],
		[2740834.54, 9120646.36],
		[2741647.10, 9098637.77],
		[2719705.50, 9097793.28],
	]], [[	/* 699:338 */
		[2741647.10, 9098637.77],
		[2740834.54, 9120646.36],
		[2762849.16, 9121429.01],
		[2763594.31, 9099415.02],
		[2741647.10, 9098637.77],
	]], [[	/* 699:339 */
		[2763594.31, 9099415.02],
		[2762849.16, 9121429.01],
		[2784868.98, 9122143.89],
		[2785546.67, 9100124.96],
		[2763594.31, 9099415.02],
	]], [[	/* 699:340 */
		[2785546.67, 9100124.96],
		[2784868.98, 9122143.89],
		[2806893.53, 9122790.95],
		[2807503.70, 9100767.55],
		[2785546.67, 9100124.96],
	]], [[	/* 699:341 */
		[2807503.70, 9100767.55],
		[2806893.53, 9122790.95],
		[2828922.33, 9123370.15],
		[2829464.95, 9101342.75],
		[2807503.70, 9100767.55],
	]], [[	/* 699:342 */
		[2829464.95, 9101342.75],
		[2828922.33, 9123370.15],
		[2850954.92, 9123881.46],
		[2851429.95, 9101850.52],
		[2829464.95, 9101342.75],
	]], [[	/* 699:343 */
		[2851429.95, 9101850.52],
		[2850954.92, 9123881.46],
		[2872990.82, 9124324.82],
		[2873398.23, 9102290.82],
		[2851429.95, 9101850.52],
	]], [[	/* 699:344 */
		[2873398.23, 9102290.82],
		[2872990.82, 9124324.82],
		[2895029.57, 9124700.22],
		[2895369.33, 9102663.63],
		[2873398.23, 9102290.82],
	]], [[	/* 699:345 */
		[2895369.33, 9102663.63],
		[2895029.57, 9124700.22],
		[2917070.69, 9125007.63],
		[2917342.77, 9102968.91],
		[2895369.33, 9102663.63],
	]], [[	/* 699:346 */
		[2917342.77, 9102968.91],
		[2917070.69, 9125007.63],
		[2939113.71, 9125247.02],
		[2939318.09, 9103206.65],
		[2917342.77, 9102968.91],
	]], [[	/* 699:347 */
		[2939318.09, 9103206.65],
		[2939113.71, 9125247.02],
		[2961158.15, 9125418.39],
		[2961294.83, 9103376.83],
		[2939318.09, 9103206.65],
	]], [[	/* 699:348 */
		[2961294.83, 9103376.83],
		[2961158.15, 9125418.39],
		[2983203.55, 9125521.71],
		[2983272.51, 9103479.44],
		[2961294.83, 9103376.83],
	]], [[	/* 699:349 */
		[2983272.51, 9103479.44],
		[2983203.55, 9125521.71],
		[3005249.42, 9125556.98],
		[3005250.66, 9103514.47],
		[2983272.51, 9103479.44],
	]], [[	/* 699:350 */
		[3005250.66, 9103514.47],
		[3005249.42, 9125556.98],
		[3027295.31, 9125524.20],
		[3027228.83, 9103481.92],
		[3005250.66, 9103514.47],
	]], [[	/* 699:351 */
		[3027228.83, 9103481.92],
		[3027295.31, 9125524.20],
		[3049340.73, 9125423.37],
		[3049206.53, 9103381.79],
		[3027228.83, 9103481.92],
	]], [[	/* 699:352 */
		[3049206.53, 9103381.79],
		[3049340.73, 9125423.37],
		[3071385.21, 9125254.50],
		[3071183.31, 9103214.08],
		[3049206.53, 9103381.79],
	]], [[	/* 699:353 */
		[3071183.31, 9103214.08],
		[3071385.21, 9125254.50],
		[3093428.28, 9125017.60],
		[3093158.68, 9102978.82],
		[3071183.31, 9103214.08],
	]], [[	/* 699:354 */
		[3093158.68, 9102978.82],
		[3093428.28, 9125017.60],
		[3115469.47, 9124712.68],
		[3115132.20, 9102676.01],
		[3093158.68, 9102978.82],
	]], [[	/* 699:355 */
		[3115132.20, 9102676.01],
		[3115469.47, 9124712.68],
		[3137508.31, 9124339.78],
		[3137103.38, 9102305.68],
		[3115132.20, 9102676.01],
	]], [[	/* 699:356 */
		[3137103.38, 9102305.68],
		[3137508.31, 9124339.78],
		[3159544.31, 9123898.90],
		[3159071.76, 9101867.86],
		[3137103.38, 9102305.68],
	]], [[	/* 699:357 */
		[3159071.76, 9101867.86],
		[3159544.31, 9123898.90],
		[3181577.02, 9123390.08],
		[3181036.87, 9101362.56],
		[3159071.76, 9101867.86],
	]], [[	/* 699:358 */
		[3181036.87, 9101362.56],
		[3181577.02, 9123390.08],
		[3203605.95, 9122813.37],
		[3202998.25, 9100789.83],
		[3181036.87, 9101362.56],
	]], [[	/* 699:359 */
		[3202998.25, 9100789.83],
		[3203605.95, 9122813.37],
		[3225630.65, 9122168.79],
		[3224955.44, 9100149.71],
		[3202998.25, 9100789.83],
	]], [[	/* 699:360 */
		[3224955.44, 9100149.71],
		[3225630.65, 9122168.79],
		[3247650.63, 9121456.40],
		[3246907.95, 9099442.23],
		[3224955.44, 9100149.71],
	]], [[	/* 699:361 */
		[3246907.95, 9099442.23],
		[3247650.63, 9121456.40],
		[3269665.43, 9120676.23],
		[3268855.34, 9098667.46],
		[3246907.95, 9099442.23],
	]], [[	/* 699:362 */
		[3268855.34, 9098667.46],
		[3269665.43, 9120676.23],
		[3291674.59, 9119828.35],
		[3290797.13, 9097825.44],
		[3268855.34, 9098667.46],
	]], [[	/* 699:363 */
		[3290797.13, 9097825.44],
		[3291674.59, 9119828.35],
		[3313677.62, 9118912.82],
		[3312732.87, 9096916.22],
		[3290797.13, 9097825.44],
	]], [[	/* 699:364 */
		[3312732.87, 9096916.22],
		[3313677.62, 9118912.82],
		[3335674.07, 9117929.69],
		[3334662.09, 9095939.88],
		[3312732.87, 9096916.22],
	]], [[	/* 699:365 */
		[3334662.09, 9095939.88],
		[3335674.07, 9117929.69],
		[3357663.47, 9116879.04],
		[3356584.32, 9094896.48],
		[3334662.09, 9095939.88],
	]], [[	/* 699:366 */
		[3356584.32, 9094896.48],
		[3357663.47, 9116879.04],
		[3379645.35, 9115760.93],
		[3378499.11, 9093786.08],
		[3356584.32, 9094896.48],
	]], [[	/* 699:367 */
		[3378499.11, 9093786.08],
		[3379645.35, 9115760.93],
		[3401619.26, 9114575.45],
		[3400406.00, 9092608.77],
		[3378499.11, 9093786.08],
	]], [[	/* 699:368 */
		[3400406.00, 9092608.77],
		[3401619.26, 9114575.45],
		[3423584.71, 9113322.67],
		[3422304.53, 9091364.63],
		[3400406.00, 9092608.77],
	]], [[	/* 699:369 */
		[3422304.53, 9091364.63],
		[3423584.71, 9113322.67],
		[3445541.26, 9112002.68],
		[3444194.24, 9090053.73],
		[3422304.53, 9091364.63],
	]], [[	/* 699:370 */
		[3444194.24, 9090053.73],
		[3445541.26, 9112002.68],
		[3467488.44, 9110615.57],
		[3466074.67, 9088676.18],
		[3444194.24, 9090053.73],
	]], [[	/* 699:371 */
		[3466074.67, 9088676.18],
		[3467488.44, 9110615.57],
		[3489425.80, 9109161.44],
		[3487945.37, 9087232.06],
		[3466074.67, 9088676.18],
	]], [[	/* 699:372 */
		[3487945.37, 9087232.06],
		[3489425.80, 9109161.44],
		[3511352.86, 9107640.39],
		[3509805.89, 9085721.47],
		[3487945.37, 9087232.06],
	]], [[	/* 699:373 */
		[3509805.89, 9085721.47],
		[3511352.86, 9107640.39],
		[3533269.19, 9106052.51],
		[3531655.76, 9084144.51],
		[3509805.89, 9085721.47],
	]], [[	/* 700:318 */
		[2302348.17, 9090878.95],
		[2300190.28, 9112748.42],
		[2322069.78, 9114883.67],
		[2324161.78, 9092999.54],
		[2302348.17, 9090878.95],
	]], [[	/* 700:319 */
		[2324161.78, 9092999.54],
		[2322069.78, 9114883.67],
		[2343963.77, 9116952.64],
		[2345989.75, 9095054.30],
		[2324161.78, 9092999.54],
	]], [[	/* 700:320 */
		[2345989.75, 9095054.30],
		[2343963.77, 9116952.64],
		[2365871.82, 9118955.20],
		[2367831.63, 9097043.10],
		[2345989.75, 9095054.30],
	]], [[	/* 700:321 */
		[2367831.63, 9097043.10],
		[2365871.82, 9118955.20],
		[2387793.48, 9120891.22],
		[2389686.99, 9098965.80],
		[2367831.63, 9097043.10],
	]], [[	/* 700:322 */
		[2389686.99, 9098965.80],
		[2387793.48, 9120891.22],
		[2409728.28, 9122760.54],
		[2411555.37, 9100822.26],
		[2389686.99, 9098965.80],
	]], [[	/* 700:323 */
		[2411555.37, 9100822.26],
		[2409728.28, 9122760.54],
		[2431675.79, 9124563.06],
		[2433436.32, 9102612.37],
		[2411555.37, 9100822.26],
	]], [[	/* 700:324 */
		[2433436.32, 9102612.37],
		[2431675.79, 9124563.06],
		[2453635.53, 9126298.65],
		[2455329.40, 9104336.00],
		[2433436.32, 9102612.37],
	]], [[	/* 700:325 */
		[2455329.40, 9104336.00],
		[2453635.53, 9126298.65],
		[2475607.07, 9127967.19],
		[2477234.14, 9105993.04],
		[2455329.40, 9104336.00],
	]], [[	/* 700:326 */
		[2477234.14, 9105993.04],
		[2475607.07, 9127967.19],
		[2497589.92, 9129568.56],
		[2499150.10, 9107583.36],
		[2477234.14, 9105993.04],
	]], [[	/* 700:327 */
		[2499150.10, 9107583.36],
		[2497589.92, 9129568.56],
		[2519583.65, 9131102.65],
		[2521076.82, 9109106.87],
		[2499150.10, 9107583.36],
	]], [[	/* 700:328 */
		[2521076.82, 9109106.87],
		[2519583.65, 9131102.65],
		[2541587.78, 9132569.36],
		[2543013.84, 9110563.46],
		[2521076.82, 9109106.87],
	]], [[	/* 700:329 */
		[2543013.84, 9110563.46],
		[2541587.78, 9132569.36],
		[2563601.85, 9133968.59],
		[2564960.70, 9111953.03],
		[2543013.84, 9110563.46],
	]], [[	/* 700:330 */
		[2564960.70, 9111953.03],
		[2563601.85, 9133968.59],
		[2585625.39, 9135300.24],
		[2586916.95, 9113275.48],
		[2564960.70, 9111953.03],
	]], [[	/* 700:331 */
		[2586916.95, 9113275.48],
		[2585625.39, 9135300.24],
		[2607657.95, 9136564.22],
		[2608882.12, 9114530.72],
		[2586916.95, 9113275.48],
	]], [[	/* 700:332 */
		[2608882.12, 9114530.72],
		[2607657.95, 9136564.22],
		[2629699.05, 9137760.45],
		[2630855.75, 9115718.67],
		[2608882.12, 9114530.72],
	]], [[	/* 700:333 */
		[2630855.75, 9115718.67],
		[2629699.05, 9137760.45],
		[2651748.23, 9138888.83],
		[2652837.38, 9116839.25],
		[2630855.75, 9115718.67],
	]], [[	/* 700:334 */
		[2652837.38, 9116839.25],
		[2651748.23, 9138888.83],
		[2673805.02, 9139949.29],
		[2674826.53, 9117892.38],
		[2652837.38, 9116839.25],
	]], [[	/* 700:335 */
		[2674826.53, 9117892.38],
		[2673805.02, 9139949.29],
		[2695868.94, 9140941.77],
		[2696822.76, 9118877.99],
		[2674826.53, 9117892.38],
	]], [[	/* 700:336 */
		[2696822.76, 9118877.99],
		[2695868.94, 9140941.77],
		[2717939.53, 9141866.18],
		[2718825.58, 9119796.00],
		[2696822.76, 9118877.99],
	]], [[	/* 700:337 */
		[2718825.58, 9119796.00],
		[2717939.53, 9141866.18],
		[2740016.31, 9142722.47],
		[2740834.54, 9120646.36],
		[2718825.58, 9119796.00],
	]], [[	/* 700:338 */
		[2740834.54, 9120646.36],
		[2740016.31, 9142722.47],
		[2762098.82, 9143510.58],
		[2762849.16, 9121429.01],
		[2740834.54, 9120646.36],
	]], [[	/* 700:339 */
		[2762849.16, 9121429.01],
		[2762098.82, 9143510.58],
		[2784186.57, 9144230.44],
		[2784868.98, 9122143.89],
		[2762849.16, 9121429.01],
	]], [[	/* 700:340 */
		[2784868.98, 9122143.89],
		[2784186.57, 9144230.44],
		[2806279.10, 9144882.02],
		[2806893.53, 9122790.95],
		[2784868.98, 9122143.89],
	]], [[	/* 700:341 */
		[2806893.53, 9122790.95],
		[2806279.10, 9144882.02],
		[2828375.92, 9145465.27],
		[2828922.33, 9123370.15],
		[2806893.53, 9122790.95],
	]], [[	/* 700:342 */
		[2828922.33, 9123370.15],
		[2828375.92, 9145465.27],
		[2850476.58, 9145980.14],
		[2850954.92, 9123881.46],
		[2828922.33, 9123370.15],
	]], [[	/* 700:343 */
		[2850954.92, 9123881.46],
		[2850476.58, 9145980.14],
		[2872580.57, 9146426.60],
		[2872990.82, 9124324.82],
		[2850954.92, 9123881.46],
	]], [[	/* 700:344 */
		[2872990.82, 9124324.82],
		[2872580.57, 9146426.60],
		[2894687.44, 9146804.62],
		[2895029.57, 9124700.22],
		[2872990.82, 9124324.82],
	]], [[	/* 700:345 */
		[2895029.57, 9124700.22],
		[2894687.44, 9146804.62],
		[2916796.71, 9147114.18],
		[2917070.69, 9125007.63],
		[2895029.57, 9124700.22],
	]], [[	/* 700:346 */
		[2917070.69, 9125007.63],
		[2916796.71, 9147114.18],
		[2938907.89, 9147355.24],
		[2939113.71, 9125247.02],
		[2917070.69, 9125007.63],
	]], [[	/* 700:347 */
		[2939113.71, 9125247.02],
		[2938907.89, 9147355.24],
		[2961020.52, 9147527.80],
		[2961158.15, 9125418.39],
		[2939113.71, 9125247.02],
	]], [[	/* 700:348 */
		[2961158.15, 9125418.39],
		[2961020.52, 9147527.80],
		[2983134.10, 9147631.84],
		[2983203.55, 9125521.71],
		[2961158.15, 9125418.39],
	]], [[	/* 700:349 */
		[2983203.55, 9125521.71],
		[2983134.10, 9147631.84],
		[3005248.18, 9147667.36],
		[3005249.42, 9125556.98],
		[2983203.55, 9125521.71],
	]], [[	/* 700:350 */
		[3005249.42, 9125556.98],
		[3005248.18, 9147667.36],
		[3027362.26, 9147634.35],
		[3027295.31, 9125524.20],
		[3005249.42, 9125556.98],
	]], [[	/* 700:351 */
		[3027295.31, 9125524.20],
		[3027362.26, 9147634.35],
		[3049475.87, 9147532.82],
		[3049340.73, 9125423.37],
		[3027295.31, 9125524.20],
	]], [[	/* 700:352 */
		[3049340.73, 9125423.37],
		[3049475.87, 9147532.82],
		[3071588.53, 9147362.77],
		[3071385.21, 9125254.50],
		[3049340.73, 9125423.37],
	]], [[	/* 700:353 */
		[3071385.21, 9125254.50],
		[3071588.53, 9147362.77],
		[3093699.77, 9147124.21],
		[3093428.28, 9125017.60],
		[3071385.21, 9125254.50],
	]], [[	/* 700:354 */
		[3093428.28, 9125017.60],
		[3093699.77, 9147124.21],
		[3115809.10, 9146817.16],
		[3115469.47, 9124712.68],
		[3093428.28, 9125017.60],
	]], [[	/* 700:355 */
		[3115469.47, 9124712.68],
		[3115809.10, 9146817.16],
		[3137916.06, 9146441.65],
		[3137508.31, 9124339.78],
		[3115469.47, 9124712.68],
	]], [[	/* 700:356 */
		[3137508.31, 9124339.78],
		[3137916.06, 9146441.65],
		[3160020.16, 9145997.69],
		[3159544.31, 9123898.90],
		[3137508.31, 9124339.78],
	]], [[	/* 700:357 */
		[3159544.31, 9123898.90],
		[3160020.16, 9145997.69],
		[3182120.93, 9145485.32],
		[3181577.02, 9123390.08],
		[3159544.31, 9123898.90],
	]], [[	/* 700:358 */
		[3181577.02, 9123390.08],
		[3182120.93, 9145485.32],
		[3204217.89, 9144904.58],
		[3203605.95, 9122813.37],
		[3181577.02, 9123390.08],
	]], [[	/* 700:359 */
		[3203605.95, 9122813.37],
		[3204217.89, 9144904.58],
		[3226310.57, 9144255.51],
		[3225630.65, 9122168.79],
		[3203605.95, 9122813.37],
	]], [[	/* 700:360 */
		[3225630.65, 9122168.79],
		[3226310.57, 9144255.51],
		[3248398.49, 9143538.14],
		[3247650.63, 9121456.40],
		[3225630.65, 9122168.79],
	]], [[	/* 700:361 */
		[3247650.63, 9121456.40],
		[3248398.49, 9143538.14],
		[3270481.17, 9142752.53],
		[3269665.43, 9120676.23],
		[3247650.63, 9121456.40],
	]], [[	/* 700:362 */
		[3269665.43, 9120676.23],
		[3270481.17, 9142752.53],
		[3292558.16, 9141898.74],
		[3291674.59, 9119828.35],
		[3269665.43, 9120676.23],
	]], [[	/* 700:363 */
		[3291674.59, 9119828.35],
		[3292558.16, 9141898.74],
		[3314628.96, 9140976.82],
		[3313677.62, 9118912.82],
		[3291674.59, 9119828.35],
	]], [[	/* 700:364 */
		[3313677.62, 9118912.82],
		[3314628.96, 9140976.82],
		[3336693.11, 9139986.84],
		[3335674.07, 9117929.69],
		[3313677.62, 9118912.82],
	]], [[	/* 700:365 */
		[3335674.07, 9117929.69],
		[3336693.11, 9139986.84],
		[3358750.14, 9138928.86],
		[3357663.47, 9116879.04],
		[3335674.07, 9117929.69],
	]], [[	/* 700:366 */
		[3357663.47, 9116879.04],
		[3358750.14, 9138928.86],
		[3380799.58, 9137802.97],
		[3379645.35, 9115760.93],
		[3357663.47, 9116879.04],
	]], [[	/* 700:367 */
		[3379645.35, 9115760.93],
		[3380799.58, 9137802.97],
		[3402840.95, 9136609.23],
		[3401619.26, 9114575.45],
		[3379645.35, 9115760.93],
	]], [[	/* 700:368 */
		[3401619.26, 9114575.45],
		[3402840.95, 9136609.23],
		[3424873.80, 9135347.73],
		[3423584.71, 9113322.67],
		[3401619.26, 9114575.45],
	]], [[	/* 700:369 */
		[3423584.71, 9113322.67],
		[3424873.80, 9135347.73],
		[3446897.65, 9134018.56],
		[3445541.26, 9112002.68],
		[3423584.71, 9113322.67],
	]], [[	/* 700:370 */
		[3445541.26, 9112002.68],
		[3446897.65, 9134018.56],
		[3468912.04, 9132621.80],
		[3467488.44, 9110615.57],
		[3445541.26, 9112002.68],
	]], [[	/* 700:371 */
		[3467488.44, 9110615.57],
		[3468912.04, 9132621.80],
		[3490916.51, 9131157.56],
		[3489425.80, 9109161.44],
		[3467488.44, 9110615.57],
	]], [[	/* 700:372 */
		[3489425.80, 9109161.44],
		[3490916.51, 9131157.56],
		[3512910.59, 9129625.94],
		[3511352.86, 9107640.39],
		[3489425.80, 9109161.44],
	]], [[	/* 701:318 */
		[2300190.28, 9112748.42],
		[2298017.44, 9134683.83],
		[2319963.27, 9136833.88],
		[2322069.78, 9114883.67],
		[2300190.28, 9112748.42],
	]], [[	/* 701:319 */
		[2322069.78, 9114883.67],
		[2319963.27, 9136833.88],
		[2341923.74, 9138917.21],
		[2343963.77, 9116952.64],
		[2322069.78, 9114883.67],
	]], [[	/* 701:320 */
		[2343963.77, 9116952.64],
		[2341923.74, 9138917.21],
		[2363898.41, 9140933.67],
		[2365871.82, 9118955.20],
		[2343963.77, 9116952.64],
	]], [[	/* 701:321 */
		[2365871.82, 9118955.20],
		[2363898.41, 9140933.67],
		[2385886.81, 9142883.13],
		[2387793.48, 9120891.22],
		[2365871.82, 9118955.20],
	]], [[	/* 701:322 */
		[2387793.48, 9120891.22],
		[2385886.81, 9142883.13],
		[2407888.50, 9144765.45],
		[2409728.28, 9122760.54],
		[2387793.48, 9120891.22],
	]], [[	/* 701:323 */
		[2409728.28, 9122760.54],
		[2407888.50, 9144765.45],
		[2429903.01, 9146580.50],
		[2431675.79, 9124563.06],
		[2409728.28, 9122760.54],
	]], [[	/* 701:324 */
		[2431675.79, 9124563.06],
		[2429903.01, 9146580.50],
		[2451929.89, 9148328.17],
		[2453635.53, 9126298.65],
		[2431675.79, 9124563.06],
	]], [[	/* 701:325 */
		[2453635.53, 9126298.65],
		[2451929.89, 9148328.17],
		[2473968.66, 9150008.32],
		[2475607.07, 9127967.19],
		[2453635.53, 9126298.65],
	]], [[	/* 701:326 */
		[2475607.07, 9127967.19],
		[2473968.66, 9150008.32],
		[2496018.88, 9151620.84],
		[2497589.92, 9129568.56],
		[2475607.07, 9127967.19],
	]], [[	/* 701:327 */
		[2497589.92, 9129568.56],
		[2496018.88, 9151620.84],
		[2518080.07, 9153165.62],
		[2519583.65, 9131102.65],
		[2497589.92, 9129568.56],
	]], [[	/* 701:328 */
		[2519583.65, 9131102.65],
		[2518080.07, 9153165.62],
		[2540151.77, 9154642.56],
		[2541587.78, 9132569.36],
		[2519583.65, 9131102.65],
	]], [[	/* 701:329 */
		[2541587.78, 9132569.36],
		[2540151.77, 9154642.56],
		[2562233.51, 9156051.55],
		[2563601.85, 9133968.59],
		[2541587.78, 9132569.36],
	]], [[	/* 701:330 */
		[2563601.85, 9133968.59],
		[2562233.51, 9156051.55],
		[2584324.83, 9157392.49],
		[2585625.39, 9135300.24],
		[2563601.85, 9133968.59],
	]], [[	/* 701:331 */
		[2585625.39, 9135300.24],
		[2584324.83, 9157392.49],
		[2606425.24, 9158665.30],
		[2607657.95, 9136564.22],
		[2585625.39, 9135300.24],
	]], [[	/* 701:332 */
		[2607657.95, 9136564.22],
		[2606425.24, 9158665.30],
		[2628534.28, 9159869.87],
		[2629699.05, 9137760.45],
		[2607657.95, 9136564.22],
	]], [[	/* 701:333 */
		[2629699.05, 9137760.45],
		[2628534.28, 9159869.87],
		[2650651.48, 9161006.14],
		[2651748.23, 9138888.83],
		[2629699.05, 9137760.45],
	]], [[	/* 701:334 */
		[2651748.23, 9138888.83],
		[2650651.48, 9161006.14],
		[2672776.36, 9162074.01],
		[2673805.02, 9139949.29],
		[2651748.23, 9138888.83],
	]], [[	/* 701:335 */
		[2673805.02, 9139949.29],
		[2672776.36, 9162074.01],
		[2694908.46, 9163073.42],
		[2695868.94, 9140941.77],
		[2673805.02, 9139949.29],
	]], [[	/* 701:336 */
		[2695868.94, 9140941.77],
		[2694908.46, 9163073.42],
		[2717047.28, 9164004.30],
		[2717939.53, 9141866.18],
		[2695868.94, 9140941.77],
	]], [[	/* 701:337 */
		[2717939.53, 9141866.18],
		[2717047.28, 9164004.30],
		[2739192.36, 9164866.58],
		[2740016.31, 9142722.47],
		[2717939.53, 9141866.18],
	]], [[	/* 701:338 */
		[2740016.31, 9142722.47],
		[2739192.36, 9164866.58],
		[2761343.22, 9165660.20],
		[2762098.82, 9143510.58],
		[2740016.31, 9142722.47],
	]], [[	/* 701:339 */
		[2762098.82, 9143510.58],
		[2761343.22, 9165660.20],
		[2783499.38, 9166385.10],
		[2784186.57, 9144230.44],
		[2762098.82, 9143510.58],
	]], [[	/* 701:340 */
		[2784186.57, 9144230.44],
		[2783499.38, 9166385.10],
		[2805660.37, 9167041.24],
		[2806279.10, 9144882.02],
		[2784186.57, 9144230.44],
	]], [[	/* 701:341 */
		[2806279.10, 9144882.02],
		[2805660.37, 9167041.24],
		[2827825.69, 9167628.57],
		[2828375.92, 9145465.27],
		[2806279.10, 9144882.02],
	]], [[	/* 701:342 */
		[2828375.92, 9145465.27],
		[2827825.69, 9167628.57],
		[2849994.88, 9168147.04],
		[2850476.58, 9145980.14],
		[2828375.92, 9145465.27],
	]], [[	/* 701:343 */
		[2850476.58, 9145980.14],
		[2849994.88, 9168147.04],
		[2872167.45, 9168596.63],
		[2872580.57, 9146426.60],
		[2850476.58, 9145980.14],
	]], [[	/* 701:344 */
		[2872580.57, 9146426.60],
		[2872167.45, 9168596.63],
		[2894342.92, 9168977.30],
		[2894687.44, 9146804.62],
		[2872580.57, 9146426.60],
	]], [[	/* 701:345 */
		[2894687.44, 9146804.62],
		[2894342.92, 9168977.30],
		[2916520.81, 9169289.02],
		[2916796.71, 9147114.18],
		[2894687.44, 9146804.62],
	]], [[	/* 701:346 */
		[2916796.71, 9147114.18],
		[2916520.81, 9169289.02],
		[2938700.64, 9169531.77],
		[2938907.89, 9147355.24],
		[2916796.71, 9147114.18],
	]], [[	/* 701:347 */
		[2938907.89, 9147355.24],
		[2938700.64, 9169531.77],
		[2960881.92, 9169705.54],
		[2961020.52, 9147527.80],
		[2938907.89, 9147355.24],
	]], [[	/* 701:348 */
		[2961020.52, 9147527.80],
		[2960881.92, 9169705.54],
		[2983064.17, 9169810.31],
		[2983134.10, 9147631.84],
		[2961020.52, 9147527.80],
	]], [[	/* 701:349 */
		[2983134.10, 9147631.84],
		[2983064.17, 9169810.31],
		[3005246.92, 9169846.08],
		[3005248.18, 9147667.36],
		[2983134.10, 9147631.84],
	]], [[	/* 701:350 */
		[3005248.18, 9147667.36],
		[3005246.92, 9169846.08],
		[3027429.67, 9169812.84],
		[3027362.26, 9147634.35],
		[3005248.18, 9147667.36],
	]], [[	/* 701:351 */
		[3027362.26, 9147634.35],
		[3027429.67, 9169812.84],
		[3049611.95, 9169710.59],
		[3049475.87, 9147532.82],
		[3027362.26, 9147634.35],
	]], [[	/* 701:352 */
		[3049475.87, 9147532.82],
		[3049611.95, 9169710.59],
		[3071793.27, 9169539.35],
		[3071588.53, 9147362.77],
		[3049475.87, 9147532.82],
	]], [[	/* 701:353 */
		[3071588.53, 9147362.77],
		[3071793.27, 9169539.35],
		[3093973.15, 9169299.12],
		[3093699.77, 9147124.21],
		[3071588.53, 9147362.77],
	]], [[	/* 701:354 */
		[3093699.77, 9147124.21],
		[3093973.15, 9169299.12],
		[3116151.11, 9168989.92],
		[3115809.10, 9146817.16],
		[3093699.77, 9147124.21],
	]], [[	/* 701:355 */
		[3115809.10, 9146817.16],
		[3116151.11, 9168989.92],
		[3138326.67, 9168611.78],
		[3137916.06, 9146441.65],
		[3115809.10, 9146817.16],
	]], [[	/* 701:356 */
		[3137916.06, 9146441.65],
		[3138326.67, 9168611.78],
		[3160499.35, 9168164.71],
		[3160020.16, 9145997.69],
		[3137916.06, 9146441.65],
	]], [[	/* 701:357 */
		[3160020.16, 9145997.69],
		[3160499.35, 9168164.71],
		[3182668.65, 9167648.75],
		[3182120.93, 9145485.32],
		[3160020.16, 9145997.69],
	]], [[	/* 701:358 */
		[3182120.93, 9145485.32],
		[3182668.65, 9167648.75],
		[3204834.12, 9167063.94],
		[3204217.89, 9144904.58],
		[3182120.93, 9145485.32],
	]], [[	/* 701:359 */
		[3204217.89, 9144904.58],
		[3204834.12, 9167063.94],
		[3226995.25, 9166410.32],
		[3226310.57, 9144255.51],
		[3204217.89, 9144904.58],
	]], [[	/* 701:360 */
		[3226310.57, 9144255.51],
		[3226995.25, 9166410.32],
		[3249151.58, 9165687.93],
		[3248398.49, 9143538.14],
		[3226310.57, 9144255.51],
	]], [[	/* 701:361 */
		[3248398.49, 9143538.14],
		[3249151.58, 9165687.93],
		[3271302.62, 9164896.83],
		[3270481.17, 9142752.53],
		[3248398.49, 9143538.14],
	]], [[	/* 701:362 */
		[3270481.17, 9142752.53],
		[3271302.62, 9164896.83],
		[3293447.90, 9164037.06],
		[3292558.16, 9141898.74],
		[3270481.17, 9142752.53],
	]], [[	/* 701:363 */
		[3292558.16, 9141898.74],
		[3293447.90, 9164037.06],
		[3315586.94, 9163108.70],
		[3314628.96, 9140976.82],
		[3292558.16, 9141898.74],
	]], [[	/* 701:364 */
		[3314628.96, 9140976.82],
		[3315586.94, 9163108.70],
		[3337719.27, 9162111.79],
		[3336693.11, 9139986.84],
		[3314628.96, 9140976.82],
	]], [[	/* 701:365 */
		[3336693.11, 9139986.84],
		[3337719.27, 9162111.79],
		[3359844.40, 9161046.42],
		[3358750.14, 9138928.86],
		[3336693.11, 9139986.84],
	]], [[	/* 701:366 */
		[3358750.14, 9138928.86],
		[3359844.40, 9161046.42],
		[3381961.86, 9159912.66],
		[3380799.58, 9137802.97],
		[3358750.14, 9138928.86],
	]], [[	/* 701:367 */
		[3380799.58, 9137802.97],
		[3381961.86, 9159912.66],
		[3404071.18, 9158710.59],
		[3402840.95, 9136609.23],
		[3380799.58, 9137802.97],
	]], [[	/* 701:368 */
		[3402840.95, 9136609.23],
		[3404071.18, 9158710.59],
		[3426171.88, 9157440.28],
		[3424873.80, 9135347.73],
		[3402840.95, 9136609.23],
	]], [[	/* 701:369 */
		[3424873.80, 9135347.73],
		[3426171.88, 9157440.28],
		[3448263.51, 9156101.83],
		[3446897.65, 9134018.56],
		[3424873.80, 9135347.73],
	]], [[	/* 701:370 */
		[3446897.65, 9134018.56],
		[3448263.51, 9156101.83],
		[3470345.57, 9154695.33],
		[3468912.04, 9132621.80],
		[3446897.65, 9134018.56],
	]], [[	/* 701:371 */
		[3468912.04, 9132621.80],
		[3470345.57, 9154695.33],
		[3492417.61, 9153220.88],
		[3490916.51, 9131157.56],
		[3468912.04, 9132621.80],
	]], [[	/* 702:318 */
		[2298017.44, 9134683.83],
		[2295829.51, 9156685.63],
		[2317842.11, 9158850.63],
		[2319963.27, 9136833.88],
		[2298017.44, 9134683.83],
	]], [[	/* 702:319 */
		[2319963.27, 9136833.88],
		[2317842.11, 9158850.63],
		[2339869.51, 9160948.45],
		[2341923.74, 9138917.21],
		[2319963.27, 9136833.88],
	]], [[	/* 702:320 */
		[2341923.74, 9138917.21],
		[2339869.51, 9160948.45],
		[2361911.25, 9162978.95],
		[2363898.41, 9140933.67],
		[2341923.74, 9138917.21],
	]], [[	/* 702:321 */
		[2363898.41, 9140933.67],
		[2361911.25, 9162978.95],
		[2383966.86, 9164941.99],
		[2385886.81, 9142883.13],
		[2363898.41, 9140933.67],
	]], [[	/* 702:322 */
		[2385886.81, 9142883.13],
		[2383966.86, 9164941.99],
		[2406035.89, 9166837.44],
		[2407888.50, 9144765.45],
		[2385886.81, 9142883.13],
	]], [[	/* 702:323 */
		[2407888.50, 9144765.45],
		[2406035.89, 9166837.44],
		[2428117.87, 9168665.15],
		[2429903.01, 9146580.50],
		[2407888.50, 9144765.45],
	]], [[	/* 702:324 */
		[2429903.01, 9146580.50],
		[2428117.87, 9168665.15],
		[2450212.33, 9170425.01],
		[2451929.89, 9148328.17],
		[2429903.01, 9146580.50],
	]], [[	/* 702:325 */
		[2451929.89, 9148328.17],
		[2450212.33, 9170425.01],
		[2472318.82, 9172116.89],
		[2473968.66, 9150008.32],
		[2451929.89, 9148328.17],
	]], [[	/* 702:326 */
		[2473968.66, 9150008.32],
		[2472318.82, 9172116.89],
		[2494436.86, 9173740.68],
		[2496018.88, 9151620.84],
		[2473968.66, 9150008.32],
	]], [[	/* 702:327 */
		[2496018.88, 9151620.84],
		[2494436.86, 9173740.68],
		[2516565.99, 9175296.26],
		[2518080.07, 9153165.62],
		[2496018.88, 9151620.84],
	]], [[	/* 702:328 */
		[2518080.07, 9153165.62],
		[2516565.99, 9175296.26],
		[2538705.73, 9176783.52],
		[2540151.77, 9154642.56],
		[2518080.07, 9153165.62],
	]], [[	/* 702:329 */
		[2540151.77, 9154642.56],
		[2538705.73, 9176783.52],
		[2560855.61, 9178202.37],
		[2562233.51, 9156051.55],
		[2540151.77, 9154642.56],
	]], [[	/* 702:330 */
		[2562233.51, 9156051.55],
		[2560855.61, 9178202.37],
		[2583015.16, 9179552.69],
		[2584324.83, 9157392.49],
		[2562233.51, 9156051.55],
	]], [[	/* 702:331 */
		[2584324.83, 9157392.49],
		[2583015.16, 9179552.69],
		[2605183.89, 9180834.41],
		[2606425.24, 9158665.30],
		[2584324.83, 9157392.49],
	]], [[	/* 702:332 */
		[2606425.24, 9158665.30],
		[2605183.89, 9180834.41],
		[2627361.35, 9182047.42],
		[2628534.28, 9159869.87],
		[2606425.24, 9158665.30],
	]], [[	/* 702:333 */
		[2628534.28, 9159869.87],
		[2627361.35, 9182047.42],
		[2649547.05, 9183191.65],
		[2650651.48, 9161006.14],
		[2628534.28, 9159869.87],
	]], [[	/* 702:334 */
		[2650651.48, 9161006.14],
		[2649547.05, 9183191.65],
		[2671740.50, 9184267.01],
		[2672776.36, 9162074.01],
		[2650651.48, 9161006.14],
	]], [[	/* 702:335 */
		[2672776.36, 9162074.01],
		[2671740.50, 9184267.01],
		[2693941.24, 9185273.43],
		[2694908.46, 9163073.42],
		[2672776.36, 9162074.01],
	]], [[	/* 702:336 */
		[2694908.46, 9163073.42],
		[2693941.24, 9185273.43],
		[2716148.78, 9186210.83],
		[2717047.28, 9164004.30],
		[2694908.46, 9163073.42],
	]], [[	/* 702:337 */
		[2717047.28, 9164004.30],
		[2716148.78, 9186210.83],
		[2738362.63, 9187079.16],
		[2739192.36, 9164866.58],
		[2717047.28, 9164004.30],
	]], [[	/* 702:338 */
		[2739192.36, 9164866.58],
		[2738362.63, 9187079.16],
		[2760582.33, 9187878.35],
		[2761343.22, 9165660.20],
		[2739192.36, 9164866.58],
	]], [[	/* 702:339 */
		[2761343.22, 9165660.20],
		[2760582.33, 9187878.35],
		[2782807.38, 9188608.34],
		[2783499.38, 9166385.10],
		[2761343.22, 9165660.20],
	]], [[	/* 702:340 */
		[2783499.38, 9166385.10],
		[2782807.38, 9188608.34],
		[2805037.30, 9189269.08],
		[2805660.37, 9167041.24],
		[2783499.38, 9166385.10],
	]], [[	/* 702:341 */
		[2805660.37, 9167041.24],
		[2805037.30, 9189269.08],
		[2827271.60, 9189860.53],
		[2827825.69, 9167628.57],
		[2805660.37, 9167041.24],
	]], [[	/* 702:342 */
		[2827825.69, 9167628.57],
		[2827271.60, 9189860.53],
		[2849509.81, 9190382.65],
		[2849994.88, 9168147.04],
		[2827825.69, 9167628.57],
	]], [[	/* 702:343 */
		[2849994.88, 9168147.04],
		[2849509.81, 9190382.65],
		[2871751.43, 9190835.40],
		[2872167.45, 9168596.63],
		[2849994.88, 9168147.04],
	]], [[	/* 702:344 */
		[2872167.45, 9168596.63],
		[2871751.43, 9190835.40],
		[2893995.98, 9191218.74],
		[2894342.92, 9168977.30],
		[2872167.45, 9168596.63],
	]], [[	/* 702:345 */
		[2894342.92, 9168977.30],
		[2893995.98, 9191218.74],
		[2916242.98, 9191532.65],
		[2916520.81, 9169289.02],
		[2894342.92, 9168977.30],
	]], [[	/* 702:346 */
		[2916520.81, 9169289.02],
		[2916242.98, 9191532.65],
		[2938491.93, 9191777.11],
		[2938700.64, 9169531.77],
		[2916520.81, 9169289.02],
	]], [[	/* 702:347 */
		[2938700.64, 9169531.77],
		[2938491.93, 9191777.11],
		[2960742.35, 9191952.10],
		[2960881.92, 9169705.54],
		[2938700.64, 9169531.77],
	]], [[	/* 702:348 */
		[2960881.92, 9169705.54],
		[2960742.35, 9191952.10],
		[2982993.75, 9192057.60],
		[2983064.17, 9169810.31],
		[2960881.92, 9169705.54],
	]], [[	/* 702:349 */
		[2983064.17, 9169810.31],
		[2982993.75, 9192057.60],
		[3005245.65, 9192093.62],
		[3005246.92, 9169846.08],
		[2983064.17, 9169810.31],
	]], [[	/* 702:350 */
		[3005246.92, 9169846.08],
		[3005245.65, 9192093.62],
		[3027497.56, 9192060.14],
		[3027429.67, 9169812.84],
		[3005246.92, 9169846.08],
	]], [[	/* 702:351 */
		[3027429.67, 9169812.84],
		[3027497.56, 9192060.14],
		[3049748.99, 9191957.18],
		[3049611.95, 9169710.59],
		[3027429.67, 9169812.84],
	]], [[	/* 702:352 */
		[3049611.95, 9169710.59],
		[3049748.99, 9191957.18],
		[3071999.45, 9191784.73],
		[3071793.27, 9169539.35],
		[3049611.95, 9169710.59],
	]], [[	/* 702:353 */
		[3071793.27, 9169539.35],
		[3071999.45, 9191784.73],
		[3094248.46, 9191542.81],
		[3093973.15, 9169299.12],
		[3071793.27, 9169539.35],
	]], [[	/* 702:354 */
		[3093973.15, 9169299.12],
		[3094248.46, 9191542.81],
		[3116495.53, 9191231.44],
		[3116151.11, 9168989.92],
		[3093973.15, 9169299.12],
	]], [[	/* 702:355 */
		[3116151.11, 9168989.92],
		[3116495.53, 9191231.44],
		[3138740.17, 9190850.64],
		[3138326.67, 9168611.78],
		[3116151.11, 9168989.92],
	]], [[	/* 702:356 */
		[3138326.67, 9168611.78],
		[3138740.17, 9190850.64],
		[3160981.90, 9190400.43],
		[3160499.35, 9168164.71],
		[3138326.67, 9168611.78],
	]], [[	/* 702:357 */
		[3160499.35, 9168164.71],
		[3160981.90, 9190400.43],
		[3183220.22, 9189880.85],
		[3182668.65, 9167648.75],
		[3160499.35, 9168164.71],
	]], [[	/* 702:358 */
		[3182668.65, 9167648.75],
		[3183220.22, 9189880.85],
		[3205454.67, 9189291.93],
		[3204834.12, 9167063.94],
		[3182668.65, 9167648.75],
	]], [[	/* 702:359 */
		[3204834.12, 9167063.94],
		[3205454.67, 9189291.93],
		[3227684.74, 9188633.72],
		[3226995.25, 9166410.32],
		[3204834.12, 9167063.94],
	]], [[	/* 702:360 */
		[3226995.25, 9166410.32],
		[3227684.74, 9188633.72],
		[3249909.96, 9187906.26],
		[3249151.58, 9165687.93],
		[3226995.25, 9166410.32],
	]], [[	/* 702:361 */
		[3249151.58, 9165687.93],
		[3249909.96, 9187906.26],
		[3272129.83, 9187109.60],
		[3271302.62, 9164896.83],
		[3249151.58, 9165687.93],
	]], [[	/* 702:362 */
		[3271302.62, 9164896.83],
		[3272129.83, 9187109.60],
		[3294343.89, 9186243.80],
		[3293447.90, 9164037.06],
		[3271302.62, 9164896.83],
	]], [[	/* 702:363 */
		[3293447.90, 9164037.06],
		[3294343.89, 9186243.80],
		[3316551.65, 9185308.92],
		[3315586.94, 9163108.70],
		[3293447.90, 9164037.06],
	]], [[	/* 702:364 */
		[3315586.94, 9163108.70],
		[3316551.65, 9185308.92],
		[3338752.62, 9184305.03],
		[3337719.27, 9162111.79],
		[3315586.94, 9163108.70],
	]], [[	/* 702:365 */
		[3337719.27, 9162111.79],
		[3338752.62, 9184305.03],
		[3360946.32, 9183232.19],
		[3359844.40, 9161046.42],
		[3337719.27, 9162111.79],
	]], [[	/* 702:366 */
		[3359844.40, 9161046.42],
		[3360946.32, 9183232.19],
		[3383132.28, 9182090.48],
		[3381961.86, 9159912.66],
		[3359844.40, 9161046.42],
	]], [[	/* 702:367 */
		[3381961.86, 9159912.66],
		[3383132.28, 9182090.48],
		[3405310.02, 9180879.99],
		[3404071.18, 9158710.59],
		[3381961.86, 9159912.66],
	]], [[	/* 702:368 */
		[3404071.18, 9158710.59],
		[3405310.02, 9180879.99],
		[3427479.05, 9179600.78],
		[3426171.88, 9157440.28],
		[3404071.18, 9158710.59],
	]], [[	/* 702:369 */
		[3426171.88, 9157440.28],
		[3427479.05, 9179600.78],
		[3449638.91, 9178252.97],
		[3448263.51, 9156101.83],
		[3426171.88, 9157440.28],
	]], [[	/* 702:370 */
		[3448263.51, 9156101.83],
		[3449638.91, 9178252.97],
		[3471789.12, 9176836.63],
		[3470345.57, 9154695.33],
		[3448263.51, 9156101.83],
	]], [[	/* 702:371 */
		[3470345.57, 9154695.33],
		[3471789.12, 9176836.63],
		[3493929.20, 9175351.87],
		[3492417.61, 9153220.88],
		[3470345.57, 9154695.33],
	]], [[	/* 703:317 */
		[2273832.15, 9154453.60],
		[2271561.87, 9176506.69],
		[2293626.32, 9178754.27],
		[2295829.51, 9156685.63],
		[2273832.15, 9154453.60],
	]], [[	/* 703:318 */
		[2295829.51, 9156685.63],
		[2293626.32, 9178754.27],
		[2315706.16, 9180934.37],
		[2317842.11, 9158850.63],
		[2295829.51, 9156685.63],
	]], [[	/* 703:319 */
		[2317842.11, 9158850.63],
		[2315706.16, 9180934.37],
		[2337800.95, 9183046.83],
		[2339869.51, 9160948.45],
		[2317842.11, 9158850.63],
	]], [[	/* 703:320 */
		[2339869.51, 9160948.45],
		[2337800.95, 9183046.83],
		[2359910.22, 9185091.51],
		[2361911.25, 9162978.95],
		[2339869.51, 9160948.45],
	]], [[	/* 703:321 */
		[2361911.25, 9162978.95],
		[2359910.22, 9185091.51],
		[2382033.50, 9187068.27],
		[2383966.86, 9164941.99],
		[2361911.25, 9162978.95],
	]], [[	/* 703:322 */
		[2383966.86, 9164941.99],
		[2382033.50, 9187068.27],
		[2404170.33, 9188976.96],
		[2406035.89, 9166837.44],
		[2383966.86, 9164941.99],
	]], [[	/* 703:323 */
		[2406035.89, 9166837.44],
		[2404170.33, 9188976.96],
		[2426320.24, 9190817.46],
		[2428117.87, 9168665.15],
		[2406035.89, 9166837.44],
	]], [[	/* 703:324 */
		[2428117.87, 9168665.15],
		[2426320.24, 9190817.46],
		[2448482.76, 9192589.64],
		[2450212.33, 9170425.01],
		[2428117.87, 9168665.15],
	]], [[	/* 703:325 */
		[2450212.33, 9170425.01],
		[2448482.76, 9192589.64],
		[2470657.43, 9194293.37],
		[2472318.82, 9172116.89],
		[2450212.33, 9170425.01],
	]], [[	/* 703:326 */
		[2472318.82, 9172116.89],
		[2470657.43, 9194293.37],
		[2492843.76, 9195928.53],
		[2494436.86, 9173740.68],
		[2472318.82, 9172116.89],
	]], [[	/* 703:327 */
		[2494436.86, 9173740.68],
		[2492843.76, 9195928.53],
		[2515041.29, 9197495.02],
		[2516565.99, 9175296.26],
		[2494436.86, 9173740.68],
	]], [[	/* 703:328 */
		[2516565.99, 9175296.26],
		[2515041.29, 9197495.02],
		[2537249.54, 9198992.71],
		[2538705.73, 9176783.52],
		[2516565.99, 9175296.26],
	]], [[	/* 703:329 */
		[2538705.73, 9176783.52],
		[2537249.54, 9198992.71],
		[2559468.03, 9200421.51],
		[2560855.61, 9178202.37],
		[2538705.73, 9176783.52],
	]], [[	/* 703:330 */
		[2560855.61, 9178202.37],
		[2559468.03, 9200421.51],
		[2581696.29, 9201781.32],
		[2583015.16, 9179552.69],
		[2560855.61, 9178202.37],
	]], [[	/* 703:331 */
		[2583015.16, 9179552.69],
		[2581696.29, 9201781.32],
		[2603933.83, 9203072.04],
		[2605183.89, 9180834.41],
		[2583015.16, 9179552.69],
	]], [[	/* 703:332 */
		[2605183.89, 9180834.41],
		[2603933.83, 9203072.04],
		[2626180.18, 9204293.57],
		[2627361.35, 9182047.42],
		[2605183.89, 9180834.41],
	]], [[	/* 703:333 */
		[2627361.35, 9182047.42],
		[2626180.18, 9204293.57],
		[2648434.85, 9205445.84],
		[2649547.05, 9183191.65],
		[2627361.35, 9182047.42],
	]], [[	/* 703:334 */
		[2649547.05, 9183191.65],
		[2648434.85, 9205445.84],
		[2670697.36, 9206528.76],
		[2671740.50, 9184267.01],
		[2649547.05, 9183191.65],
	]], [[	/* 703:335 */
		[2671740.50, 9184267.01],
		[2670697.36, 9206528.76],
		[2692967.22, 9207542.25],
		[2693941.24, 9185273.43],
		[2671740.50, 9184267.01],
	]], [[	/* 703:336 */
		[2693941.24, 9185273.43],
		[2692967.22, 9207542.25],
		[2715243.95, 9208486.25],
		[2716148.78, 9186210.83],
		[2693941.24, 9185273.43],
	]], [[	/* 703:337 */
		[2716148.78, 9186210.83],
		[2715243.95, 9208486.25],
		[2737527.07, 9209360.69],
		[2738362.63, 9187079.16],
		[2716148.78, 9186210.83],
	]], [[	/* 703:338 */
		[2738362.63, 9187079.16],
		[2737527.07, 9209360.69],
		[2759816.08, 9210165.50],
		[2760582.33, 9187878.35],
		[2738362.63, 9187079.16],
	]], [[	/* 703:339 */
		[2760582.33, 9187878.35],
		[2759816.08, 9210165.50],
		[2782110.50, 9210900.63],
		[2782807.38, 9188608.34],
		[2760582.33, 9187878.35],
	]], [[	/* 703:340 */
		[2782807.38, 9188608.34],
		[2782110.50, 9210900.63],
		[2804409.84, 9211566.03],
		[2805037.30, 9189269.08],
		[2782807.38, 9188608.34],
	]], [[	/* 703:341 */
		[2805037.30, 9189269.08],
		[2804409.84, 9211566.03],
		[2826713.61, 9212161.65],
		[2827271.60, 9189860.53],
		[2805037.30, 9189269.08],
	]], [[	/* 703:342 */
		[2827271.60, 9189860.53],
		[2826713.61, 9212161.65],
		[2849021.32, 9212687.44],
		[2849509.81, 9190382.65],
		[2827271.60, 9189860.53],
	]], [[	/* 703:343 */
		[2849509.81, 9190382.65],
		[2849021.32, 9212687.44],
		[2871332.48, 9213143.38],
		[2871751.43, 9190835.40],
		[2849509.81, 9190382.65],
	]], [[	/* 703:344 */
		[2871751.43, 9190835.40],
		[2871332.48, 9213143.38],
		[2893646.60, 9213529.42],
		[2893995.98, 9191218.74],
		[2871751.43, 9190835.40],
	]], [[	/* 703:345 */
		[2893995.98, 9191218.74],
		[2893646.60, 9213529.42],
		[2915963.18, 9213845.54],
		[2916242.98, 9191532.65],
		[2893995.98, 9191218.74],
	]], [[	/* 703:346 */
		[2916242.98, 9191532.65],
		[2915963.18, 9213845.54],
		[2938281.75, 9214091.72],
		[2938491.93, 9191777.11],
		[2916242.98, 9191532.65],
	]], [[	/* 703:347 */
		[2938491.93, 9191777.11],
		[2938281.75, 9214091.72],
		[2960601.80, 9214267.94],
		[2960742.35, 9191952.10],
		[2938491.93, 9191777.11],
	]], [[	/* 703:348 */
		[2960742.35, 9191952.10],
		[2960601.80, 9214267.94],
		[2982922.84, 9214374.19],
		[2982993.75, 9192057.60],
		[2960742.35, 9191952.10],
	]], [[	/* 703:349 */
		[2982993.75, 9192057.60],
		[2982922.84, 9214374.19],
		[3005244.38, 9214410.46],
		[3005245.65, 9192093.62],
		[2982993.75, 9192057.60],
	]], [[	/* 703:350 */
		[3005245.65, 9192093.62],
		[3005244.38, 9214410.46],
		[3027565.93, 9214376.75],
		[3027497.56, 9192060.14],
		[3005245.65, 9192093.62],
	]], [[	/* 703:351 */
		[3027497.56, 9192060.14],
		[3027565.93, 9214376.75],
		[3049887.00, 9214273.06],
		[3049748.99, 9191957.18],
		[3027497.56, 9192060.14],
	]], [[	/* 703:352 */
		[3049748.99, 9191957.18],
		[3049887.00, 9214273.06],
		[3072207.09, 9214099.39],
		[3071999.45, 9191784.73],
		[3049748.99, 9191957.18],
	]], [[	/* 703:353 */
		[3071999.45, 9191784.73],
		[3072207.09, 9214099.39],
		[3094525.71, 9213855.77],
		[3094248.46, 9191542.81],
		[3071999.45, 9191784.73],
	]], [[	/* 703:354 */
		[3094248.46, 9191542.81],
		[3094525.71, 9213855.77],
		[3116842.37, 9213542.20],
		[3116495.53, 9191231.44],
		[3094248.46, 9191542.81],
	]], [[	/* 703:355 */
		[3116495.53, 9191231.44],
		[3116842.37, 9213542.20],
		[3139156.58, 9213158.71],
		[3138740.17, 9190850.64],
		[3116495.53, 9191231.44],
	]], [[	/* 703:356 */
		[3138740.17, 9190850.64],
		[3139156.58, 9213158.71],
		[3161467.85, 9212705.33],
		[3160981.90, 9190400.43],
		[3138740.17, 9190850.64],
	]], [[	/* 703:357 */
		[3160981.90, 9190400.43],
		[3161467.85, 9212705.33],
		[3183775.68, 9212182.09],
		[3183220.22, 9189880.85],
		[3160981.90, 9190400.43],
	]], [[	/* 703:358 */
		[3183220.22, 9189880.85],
		[3183775.68, 9212182.09],
		[3206079.59, 9211589.02],
		[3205454.67, 9189291.93],
		[3183220.22, 9189880.85],
	]], [[	/* 703:359 */
		[3205454.67, 9189291.93],
		[3206079.59, 9211589.02],
		[3228379.08, 9210926.18],
		[3227684.74, 9188633.72],
		[3205454.67, 9189291.93],
	]], [[	/* 703:360 */
		[3227684.74, 9188633.72],
		[3228379.08, 9210926.18],
		[3250673.67, 9210193.59],
		[3249909.96, 9187906.26],
		[3227684.74, 9188633.72],
	]], [[	/* 703:361 */
		[3249909.96, 9187906.26],
		[3250673.67, 9210193.59],
		[3272962.87, 9209391.33],
		[3272129.83, 9187109.60],
		[3249909.96, 9187906.26],
	]], [[	/* 703:362 */
		[3272129.83, 9187109.60],
		[3272962.87, 9209391.33],
		[3295246.19, 9208519.44],
		[3294343.89, 9186243.80],
		[3272129.83, 9187109.60],
	]], [[	/* 703:363 */
		[3294343.89, 9186243.80],
		[3295246.19, 9208519.44],
		[3317523.14, 9207577.98],
		[3316551.65, 9185308.92],
		[3294343.89, 9186243.80],
	]], [[	/* 703:364 */
		[3316551.65, 9185308.92],
		[3317523.14, 9207577.98],
		[3339793.23, 9206567.02],
		[3338752.62, 9184305.03],
		[3316551.65, 9185308.92],
	]], [[	/* 703:365 */
		[3338752.62, 9184305.03],
		[3339793.23, 9206567.02],
		[3362055.99, 9205486.64],
		[3360946.32, 9183232.19],
		[3338752.62, 9184305.03],
	]], [[	/* 703:366 */
		[3360946.32, 9183232.19],
		[3362055.99, 9205486.64],
		[3384310.93, 9204336.91],
		[3383132.28, 9182090.48],
		[3360946.32, 9183232.19],
	]], [[	/* 703:367 */
		[3383132.28, 9182090.48],
		[3384310.93, 9204336.91],
		[3406557.56, 9203117.90],
		[3405310.02, 9180879.99],
		[3383132.28, 9182090.48],
	]], [[	/* 703:368 */
		[3405310.02, 9180879.99],
		[3406557.56, 9203117.90],
		[3428795.40, 9201829.71],
		[3427479.05, 9179600.78],
		[3405310.02, 9180879.99],
	]], [[	/* 703:369 */
		[3427479.05, 9179600.78],
		[3428795.40, 9201829.71],
		[3451023.97, 9200472.43],
		[3449638.91, 9178252.97],
		[3427479.05, 9179600.78],
	]], [[	/* 704:318 */
		[2293626.32, 9178754.27],
		[2291407.73, 9200890.22],
		[2313555.28, 9203085.56],
		[2315706.16, 9180934.37],
		[2293626.32, 9178754.27],
	]], [[	/* 704:319 */
		[2315706.16, 9180934.37],
		[2313555.28, 9203085.56],
		[2335717.91, 9205212.81],
		[2337800.95, 9183046.83],
		[2315706.16, 9180934.37],
	]], [[	/* 704:320 */
		[2337800.95, 9183046.83],
		[2335717.91, 9205212.81],
		[2357895.17, 9207271.81],
		[2359910.22, 9185091.51],
		[2337800.95, 9183046.83],
	]], [[	/* 704:321 */
		[2359910.22, 9185091.51],
		[2357895.17, 9207271.81],
		[2380086.58, 9209262.42],
		[2382033.50, 9187068.27],
		[2359910.22, 9185091.51],
	]], [[	/* 704:322 */
		[2382033.50, 9187068.27],
		[2380086.58, 9209262.42],
		[2402291.68, 9211184.50],
		[2404170.33, 9188976.96],
		[2382033.50, 9187068.27],
	]], [[	/* 704:323 */
		[2404170.33, 9188976.96],
		[2402291.68, 9211184.50],
		[2424509.99, 9213037.91],
		[2426320.24, 9190817.46],
		[2404170.33, 9188976.96],
	]], [[	/* 704:324 */
		[2426320.24, 9190817.46],
		[2424509.99, 9213037.91],
		[2446741.05, 9214822.53],
		[2448482.76, 9192589.64],
		[2426320.24, 9190817.46],
	]], [[	/* 704:325 */
		[2448482.76, 9192589.64],
		[2446741.05, 9214822.53],
		[2468984.36, 9216538.22],
		[2470657.43, 9194293.37],
		[2448482.76, 9192589.64],
	]], [[	/* 704:326 */
		[2470657.43, 9194293.37],
		[2468984.36, 9216538.22],
		[2491239.46, 9218184.88],
		[2492843.76, 9195928.53],
		[2470657.43, 9194293.37],
	]], [[	/* 704:327 */
		[2492843.76, 9195928.53],
		[2491239.46, 9218184.88],
		[2513505.87, 9219762.38],
		[2515041.29, 9197495.02],
		[2492843.76, 9195928.53],
	]], [[	/* 704:328 */
		[2515041.29, 9197495.02],
		[2513505.87, 9219762.38],
		[2535783.11, 9221270.61],
		[2537249.54, 9198992.71],
		[2515041.29, 9197495.02],
	]], [[	/* 704:329 */
		[2537249.54, 9198992.71],
		[2535783.11, 9221270.61],
		[2558070.70, 9222709.47],
		[2559468.03, 9200421.51],
		[2537249.54, 9198992.71],
	]], [[	/* 704:330 */
		[2559468.03, 9200421.51],
		[2558070.70, 9222709.47],
		[2580368.14, 9224078.85],
		[2581696.29, 9201781.32],
		[2559468.03, 9200421.51],
	]], [[	/* 704:331 */
		[2581696.29, 9201781.32],
		[2580368.14, 9224078.85],
		[2602674.97, 9225378.66],
		[2603933.83, 9203072.04],
		[2581696.29, 9201781.32],
	]], [[	/* 704:332 */
		[2603933.83, 9203072.04],
		[2602674.97, 9225378.66],
		[2624990.69, 9226608.80],
		[2626180.18, 9204293.57],
		[2603933.83, 9203072.04],
	]], [[	/* 704:333 */
		[2626180.18, 9204293.57],
		[2624990.69, 9226608.80],
		[2647314.82, 9227769.19],
		[2648434.85, 9205445.84],
		[2626180.18, 9204293.57],
	]], [[	/* 704:334 */
		[2648434.85, 9205445.84],
		[2647314.82, 9227769.19],
		[2669646.86, 9228859.75],
		[2670697.36, 9206528.76],
		[2648434.85, 9205445.84],
	]], [[	/* 704:335 */
		[2670697.36, 9206528.76],
		[2669646.86, 9228859.75],
		[2691986.33, 9229880.39],
		[2692967.22, 9207542.25],
		[2670697.36, 9206528.76],
	]], [[	/* 704:336 */
		[2692967.22, 9207542.25],
		[2691986.33, 9229880.39],
		[2714332.74, 9230831.05],
		[2715243.95, 9208486.25],
		[2692967.22, 9207542.25],
	]], [[	/* 704:337 */
		[2715243.95, 9208486.25],
		[2714332.74, 9230831.05],
		[2736685.60, 9231711.66],
		[2737527.07, 9209360.69],
		[2715243.95, 9208486.25],
	]], [[	/* 704:338 */
		[2737527.07, 9209360.69],
		[2736685.60, 9231711.66],
		[2759044.42, 9232522.15],
		[2759816.08, 9210165.50],
		[2737527.07, 9209360.69],
	]], [[	/* 704:339 */
		[2759816.08, 9210165.50],
		[2759044.42, 9232522.15],
		[2781408.70, 9233262.48],
		[2782110.50, 9210900.63],
		[2759816.08, 9210165.50],
	]], [[	/* 704:340 */
		[2782110.50, 9210900.63],
		[2781408.70, 9233262.48],
		[2803777.95, 9233932.57],
		[2804409.84, 9211566.03],
		[2782110.50, 9210900.63],
	]], [[	/* 704:341 */
		[2804409.84, 9211566.03],
		[2803777.95, 9233932.57],
		[2826151.67, 9234532.40],
		[2826713.61, 9212161.65],
		[2804409.84, 9211566.03],
	]], [[	/* 704:342 */
		[2826713.61, 9212161.65],
		[2826151.67, 9234532.40],
		[2848529.37, 9235061.91],
		[2849021.32, 9212687.44],
		[2826713.61, 9212161.65],
	]], [[	/* 704:343 */
		[2849021.32, 9212687.44],
		[2848529.37, 9235061.91],
		[2870910.56, 9235521.06],
		[2871332.48, 9213143.38],
		[2849021.32, 9212687.44],
	]], [[	/* 704:344 */
		[2871332.48, 9213143.38],
		[2870910.56, 9235521.06],
		[2893294.74, 9235909.83],
		[2893646.60, 9213529.42],
		[2871332.48, 9213143.38],
	]], [[	/* 704:345 */
		[2893646.60, 9213529.42],
		[2893294.74, 9235909.83],
		[2915681.42, 9236228.19],
		[2915963.18, 9213845.54],
		[2893646.60, 9213529.42],
	]], [[	/* 704:346 */
		[2915963.18, 9213845.54],
		[2915681.42, 9236228.19],
		[2938070.08, 9236476.11],
		[2938281.75, 9214091.72],
		[2915963.18, 9213845.54],
	]], [[	/* 704:347 */
		[2938281.75, 9214091.72],
		[2938070.08, 9236476.11],
		[2960460.25, 9236653.58],
		[2960601.80, 9214267.94],
		[2938281.75, 9214091.72],
	]], [[	/* 704:348 */
		[2960601.80, 9214267.94],
		[2960460.25, 9236653.58],
		[2982851.42, 9236760.58],
		[2982922.84, 9214374.19],
		[2960601.80, 9214267.94],
	]], [[	/* 704:349 */
		[2982922.84, 9214374.19],
		[2982851.42, 9236760.58],
		[3005243.10, 9236797.10],
		[3005244.38, 9214410.46],
		[2982922.84, 9214374.19],
	]], [[	/* 704:350 */
		[3005244.38, 9214410.46],
		[3005243.10, 9236797.10],
		[3027634.79, 9236763.15],
		[3027565.93, 9214376.75],
		[3005244.38, 9214410.46],
	]], [[	/* 704:351 */
		[3027565.93, 9214376.75],
		[3027634.79, 9236763.15],
		[3050025.98, 9236658.72],
		[3049887.00, 9214273.06],
		[3027565.93, 9214376.75],
	]], [[	/* 704:352 */
		[3049887.00, 9214273.06],
		[3050025.98, 9236658.72],
		[3072416.19, 9236483.83],
		[3072207.09, 9214099.39],
		[3049887.00, 9214273.06],
	]], [[	/* 704:353 */
		[3072207.09, 9214099.39],
		[3072416.19, 9236483.83],
		[3094804.92, 9236238.48],
		[3094525.71, 9213855.77],
		[3072207.09, 9214099.39],
	]], [[	/* 704:354 */
		[3094525.71, 9213855.77],
		[3094804.92, 9236238.48],
		[3117191.66, 9235922.70],
		[3116842.37, 9213542.20],
		[3094525.71, 9213855.77],
	]], [[	/* 704:355 */
		[3116842.37, 9213542.20],
		[3117191.66, 9235922.70],
		[3139575.93, 9235536.50],
		[3139156.58, 9213158.71],
		[3116842.37, 9213542.20],
	]], [[	/* 704:356 */
		[3139156.58, 9213158.71],
		[3139575.93, 9235536.50],
		[3161957.23, 9235079.91],
		[3161467.85, 9212705.33],
		[3139156.58, 9213158.71],
	]], [[	/* 704:357 */
		[3161467.85, 9212705.33],
		[3161957.23, 9235079.91],
		[3184335.06, 9234552.97],
		[3183775.68, 9212182.09],
		[3161467.85, 9212705.33],
	]], [[	/* 704:358 */
		[3183775.68, 9212182.09],
		[3184335.06, 9234552.97],
		[3206708.92, 9233955.71],
		[3206079.59, 9211589.02],
		[3183775.68, 9212182.09],
	]], [[	/* 704:359 */
		[3206079.59, 9211589.02],
		[3206708.92, 9233955.71],
		[3229078.32, 9233288.18],
		[3228379.08, 9210926.18],
		[3206079.59, 9211589.02],
	]], [[	/* 704:360 */
		[3228379.08, 9210926.18],
		[3229078.32, 9233288.18],
		[3251442.78, 9232550.42],
		[3250673.67, 9210193.59],
		[3228379.08, 9210926.18],
	]], [[	/* 704:361 */
		[3250673.67, 9210193.59],
		[3251442.78, 9232550.42],
		[3273801.78, 9231742.49],
		[3272962.87, 9209391.33],
		[3250673.67, 9210193.59],
	]], [[	/* 704:362 */
		[3272962.87, 9209391.33],
		[3273801.78, 9231742.49],
		[3296154.85, 9230864.45],
		[3295246.19, 9208519.44],
		[3272962.87, 9209391.33],
	]], [[	/* 704:363 */
		[3295246.19, 9208519.44],
		[3296154.85, 9230864.45],
		[3318501.48, 9229916.34],
		[3317523.14, 9207577.98],
		[3295246.19, 9208519.44],
	]], [[	/* 704:364 */
		[3317523.14, 9207577.98],
		[3318501.48, 9229916.34],
		[3340841.19, 9228898.25],
		[3339793.23, 9206567.02],
		[3317523.14, 9207577.98],
	]], [[	/* 704:365 */
		[3339793.23, 9206567.02],
		[3340841.19, 9228898.25],
		[3363173.49, 9227810.25],
		[3362055.99, 9205486.64],
		[3339793.23, 9206567.02],
	]], [[	/* 704:366 */
		[3362055.99, 9205486.64],
		[3363173.49, 9227810.25],
		[3385497.88, 9226652.41],
		[3384310.93, 9204336.91],
		[3362055.99, 9205486.64],
	]], [[	/* 704:367 */
		[3384310.93, 9204336.91],
		[3385497.88, 9226652.41],
		[3407813.89, 9225424.82],
		[3406557.56, 9203117.90],
		[3384310.93, 9204336.91],
	]], [[	/* 704:368 */
		[3406557.56, 9203117.90],
		[3407813.89, 9225424.82],
		[3430121.02, 9224127.55],
		[3428795.40, 9201829.71],
		[3406557.56, 9203117.90],
	]], [[	/* 705:319 */
		[2313555.28, 9203085.56],
		[2311389.30, 9225304.67],
		[2333620.25, 9227446.85],
		[2335717.91, 9205212.81],
		[2313555.28, 9203085.56],
	]], [[	/* 705:320 */
		[2335717.91, 9205212.81],
		[2333620.25, 9227446.85],
		[2355865.97, 9229520.31],
		[2357895.17, 9207271.81],
		[2335717.91, 9205212.81],
	]], [[	/* 705:323 */
		[2402291.68, 9211184.50],
		[2400399.82, 9233460.51],
		[2422687.01, 9235326.96],
		[2424509.99, 9213037.91],
		[2402291.68, 9211184.50],
	]], [[	/* 705:324 */
		[2424509.99, 9213037.91],
		[2422687.01, 9235326.96],
		[2444987.07, 9237124.15],
		[2446741.05, 9214822.53],
		[2424509.99, 9213037.91],
	]], [[	/* 705:325 */
		[2446741.05, 9214822.53],
		[2444987.07, 9237124.15],
		[2467299.51, 9238851.93],
		[2468984.36, 9216538.22],
		[2446741.05, 9214822.53],
	]], [[	/* 705:326 */
		[2468984.36, 9216538.22],
		[2467299.51, 9238851.93],
		[2489623.86, 9240510.20],
		[2491239.46, 9218184.88],
		[2468984.36, 9216538.22],
	]], [[	/* 705:327 */
		[2491239.46, 9218184.88],
		[2489623.86, 9240510.20],
		[2511959.63, 9242098.82],
		[2513505.87, 9219762.38],
		[2491239.46, 9218184.88],
	]], [[	/* 705:328 */
		[2513505.87, 9219762.38],
		[2511959.63, 9242098.82],
		[2534306.34, 9243617.70],
		[2535783.11, 9221270.61],
		[2513505.87, 9219762.38],
	]], [[	/* 705:329 */
		[2535783.11, 9221270.61],
		[2534306.34, 9243617.70],
		[2556663.50, 9245066.71],
		[2558070.70, 9222709.47],
		[2535783.11, 9221270.61],
	]], [[	/* 705:330 */
		[2558070.70, 9222709.47],
		[2556663.50, 9245066.71],
		[2579030.62, 9246445.76],
		[2580368.14, 9224078.85],
		[2558070.70, 9222709.47],
	]], [[	/* 705:331 */
		[2580368.14, 9224078.85],
		[2579030.62, 9246445.76],
		[2601407.21, 9247754.75],
		[2602674.97, 9225378.66],
		[2580368.14, 9224078.85],
	]], [[	/* 705:332 */
		[2602674.97, 9225378.66],
		[2601407.21, 9247754.75],
		[2623792.79, 9248993.59],
		[2624990.69, 9226608.80],
		[2602674.97, 9225378.66],
	]], [[	/* 705:333 */
		[2624990.69, 9226608.80],
		[2623792.79, 9248993.59],
		[2646186.86, 9250162.19],
		[2647314.82, 9227769.19],
		[2624990.69, 9226608.80],
	]], [[	/* 705:334 */
		[2647314.82, 9227769.19],
		[2646186.86, 9250162.19],
		[2668588.93, 9251260.46],
		[2669646.86, 9228859.75],
		[2647314.82, 9227769.19],
	]], [[	/* 705:335 */
		[2669646.86, 9228859.75],
		[2668588.93, 9251260.46],
		[2690998.51, 9252288.32],
		[2691986.33, 9229880.39],
		[2669646.86, 9228859.75],
	]], [[	/* 705:336 */
		[2691986.33, 9229880.39],
		[2690998.51, 9252288.32],
		[2713415.09, 9253245.71],
		[2714332.74, 9230831.05],
		[2691986.33, 9229880.39],
	]], [[	/* 705:337 */
		[2714332.74, 9230831.05],
		[2713415.09, 9253245.71],
		[2735838.19, 9254132.56],
		[2736685.60, 9231711.66],
		[2714332.74, 9230831.05],
	]], [[	/* 705:338 */
		[2736685.60, 9231711.66],
		[2735838.19, 9254132.56],
		[2758267.30, 9254948.79],
		[2759044.42, 9232522.15],
		[2736685.60, 9231711.66],
	]], [[	/* 705:339 */
		[2759044.42, 9232522.15],
		[2758267.30, 9254948.79],
		[2780701.93, 9255694.36],
		[2781408.70, 9233262.48],
		[2759044.42, 9232522.15],
	]], [[	/* 705:340 */
		[2781408.70, 9233262.48],
		[2780701.93, 9255694.36],
		[2803141.58, 9256369.20],
		[2803777.95, 9233932.57],
		[2781408.70, 9233262.48],
	]], [[	/* 705:341 */
		[2803777.95, 9233932.57],
		[2803141.58, 9256369.20],
		[2825585.75, 9256973.27],
		[2826151.67, 9234532.40],
		[2803777.95, 9233932.57],
	]], [[	/* 705:342 */
		[2826151.67, 9234532.40],
		[2825585.75, 9256973.27],
		[2848033.95, 9257506.54],
		[2848529.37, 9235061.91],
		[2826151.67, 9234532.40],
	]], [[	/* 705:343 */
		[2848529.37, 9235061.91],
		[2848033.95, 9257506.54],
		[2870485.66, 9257968.95],
		[2870910.56, 9235521.06],
		[2848529.37, 9235061.91],
	]], [[	/* 705:344 */
		[2870910.56, 9235521.06],
		[2870485.66, 9257968.95],
		[2892940.40, 9258360.47],
		[2893294.74, 9235909.83],
		[2870910.56, 9235521.06],
	]], [[	/* 705:345 */
		[2893294.74, 9235909.83],
		[2892940.40, 9258360.47],
		[2915397.65, 9258681.09],
		[2915681.42, 9236228.19],
		[2893294.74, 9235909.83],
	]], [[	/* 705:346 */
		[2915681.42, 9236228.19],
		[2915397.65, 9258681.09],
		[2937856.92, 9258930.76],
		[2938070.08, 9236476.11],
		[2915681.42, 9236228.19],
	]], [[	/* 705:347 */
		[2938070.08, 9236476.11],
		[2937856.92, 9258930.76],
		[2960317.70, 9259109.49],
		[2960460.25, 9236653.58],
		[2938070.08, 9236476.11],
	]], [[	/* 705:348 */
		[2960460.25, 9236653.58],
		[2960317.70, 9259109.49],
		[2982779.50, 9259217.24],
		[2982851.42, 9236760.58],
		[2960460.25, 9236653.58],
	]], [[	/* 705:349 */
		[2982851.42, 9236760.58],
		[2982779.50, 9259217.24],
		[3005241.81, 9259254.03],
		[3005243.10, 9236797.10],
		[2982851.42, 9236760.58],
	]], [[	/* 705:350 */
		[3005243.10, 9236797.10],
		[3005241.81, 9259254.03],
		[3027704.13, 9259219.83],
		[3027634.79, 9236763.15],
		[3005243.10, 9236797.10],
	]], [[	/* 705:351 */
		[3027634.79, 9236763.15],
		[3027704.13, 9259219.83],
		[3050165.95, 9259114.67],
		[3050025.98, 9236658.72],
		[3027634.79, 9236763.15],
	]], [[	/* 705:352 */
		[3050025.98, 9236658.72],
		[3050165.95, 9259114.67],
		[3072626.78, 9258938.53],
		[3072416.19, 9236483.83],
		[3050025.98, 9236658.72],
	]], [[	/* 705:353 */
		[3072416.19, 9236483.83],
		[3072626.78, 9258938.53],
		[3095086.11, 9258691.44],
		[3094804.92, 9236238.48],
		[3072416.19, 9236483.83],
	]], [[	/* 705:354 */
		[3094804.92, 9236238.48],
		[3095086.11, 9258691.44],
		[3117543.43, 9258373.42],
		[3117191.66, 9235922.70],
		[3094804.92, 9236238.48],
	]], [[	/* 705:355 */
		[3117191.66, 9235922.70],
		[3117543.43, 9258373.42],
		[3139998.26, 9257984.48],
		[3139575.93, 9235536.50],
		[3117191.66, 9235922.70],
	]], [[	/* 705:356 */
		[3139575.93, 9235536.50],
		[3139998.26, 9257984.48],
		[3162450.08, 9257524.66],
		[3161957.23, 9235079.91],
		[3139575.93, 9235536.50],
	]], [[	/* 705:357 */
		[3161957.23, 9235079.91],
		[3162450.08, 9257524.66],
		[3184898.40, 9256993.98],
		[3184335.06, 9234552.97],
		[3161957.23, 9235079.91],
	]], [[	/* 705:358 */
		[3184335.06, 9234552.97],
		[3184898.40, 9256993.98],
		[3207342.71, 9256392.49],
		[3206708.92, 9233955.71],
		[3184335.06, 9234552.97],
	]], [[	/* 705:359 */
		[3206708.92, 9233955.71],
		[3207342.71, 9256392.49],
		[3229782.52, 9255720.23],
		[3229078.32, 9233288.18],
		[3206708.92, 9233955.71],
	]], [[	/* 705:360 */
		[3229078.32, 9233288.18],
		[3229782.52, 9255720.23],
		[3252217.33, 9254977.24],
		[3251442.78, 9232550.42],
		[3229078.32, 9233288.18],
	]], [[	/* 705:361 */
		[3251442.78, 9232550.42],
		[3252217.33, 9254977.24],
		[3274646.63, 9254163.59],
		[3273801.78, 9231742.49],
		[3251442.78, 9232550.42],
	]], [[	/* 705:362 */
		[3273801.78, 9231742.49],
		[3274646.63, 9254163.59],
		[3297069.94, 9253279.32],
		[3296154.85, 9230864.45],
		[3273801.78, 9231742.49],
	]], [[	/* 705:363 */
		[3296154.85, 9230864.45],
		[3297069.94, 9253279.32],
		[3319486.74, 9252324.51],
		[3318501.48, 9229916.34],
		[3296154.85, 9230864.45],
	]], [[	/* 705:364 */
		[3318501.48, 9229916.34],
		[3319486.74, 9252324.51],
		[3341896.56, 9251299.21],
		[3340841.19, 9228898.25],
		[3318501.48, 9229916.34],
	]], [[	/* 705:365 */
		[3340841.19, 9228898.25],
		[3341896.56, 9251299.21],
		[3364298.88, 9250203.51],
		[3363173.49, 9227810.25],
		[3340841.19, 9228898.25],
	]], [[	/* 705:366 */
		[3363173.49, 9227810.25],
		[3364298.88, 9250203.51],
		[3386693.23, 9249037.48],
		[3385497.88, 9226652.41],
		[3363173.49, 9227810.25],
	]], [[	/* 705:367 */
		[3385497.88, 9226652.41],
		[3386693.23, 9249037.48],
		[3409079.09, 9247801.21],
		[3407813.89, 9225424.82],
		[3385497.88, 9226652.41],
	]], [[	/* 706:326 */
		[2467299.51, 9238851.93],
		[2465602.75, 9261234.98],
		[2487996.83, 9262904.97],
		[2489623.86, 9240510.20],
		[2467299.51, 9238851.93],
	]], [[	/* 706:327 */
		[2489623.86, 9240510.20],
		[2487996.83, 9262904.97],
		[2510402.44, 9264504.83],
		[2511959.63, 9242098.82],
		[2489623.86, 9240510.20],
	]], [[	/* 706:328 */
		[2511959.63, 9242098.82],
		[2510402.44, 9264504.83],
		[2532819.11, 9266034.46],
		[2534306.34, 9243617.70],
		[2511959.63, 9242098.82],
	]], [[	/* 706:329 */
		[2534306.34, 9243617.70],
		[2532819.11, 9266034.46],
		[2555246.33, 9267493.73],
		[2556663.50, 9245066.71],
		[2534306.34, 9243617.70],
	]], [[	/* 706:330 */
		[2556663.50, 9245066.71],
		[2555246.33, 9267493.73],
		[2577683.62, 9268882.55],
		[2579030.62, 9246445.76],
		[2556663.50, 9245066.71],
	]], [[	/* 706:331 */
		[2579030.62, 9246445.76],
		[2577683.62, 9268882.55],
		[2600130.47, 9270200.82],
		[2601407.21, 9247754.75],
		[2579030.62, 9246445.76],
	]], [[	/* 706:332 */
		[2601407.21, 9247754.75],
		[2600130.47, 9270200.82],
		[2622586.40, 9271448.44],
		[2623792.79, 9248993.59],
		[2601407.21, 9247754.75],
	]], [[	/* 706:333 */
		[2623792.79, 9248993.59],
		[2622586.40, 9271448.44],
		[2645050.91, 9272625.32],
		[2646186.86, 9250162.19],
		[2623792.79, 9248993.59],
	]], [[	/* 706:334 */
		[2646186.86, 9250162.19],
		[2645050.91, 9272625.32],
		[2667523.50, 9273731.39],
		[2668588.93, 9251260.46],
		[2646186.86, 9250162.19],
	]], [[	/* 706:335 */
		[2668588.93, 9251260.46],
		[2667523.50, 9273731.39],
		[2690003.67, 9274766.55],
		[2690998.51, 9252288.32],
		[2668588.93, 9251260.46],
	]], [[	/* 706:336 */
		[2690998.51, 9252288.32],
		[2690003.67, 9274766.55],
		[2712490.92, 9275730.73],
		[2713415.09, 9253245.71],
		[2690998.51, 9252288.32],
	]], [[	/* 706:337 */
		[2713415.09, 9253245.71],
		[2712490.92, 9275730.73],
		[2734984.75, 9276623.87],
		[2735838.19, 9254132.56],
		[2713415.09, 9253245.71],
	]], [[	/* 706:338 */
		[2735838.19, 9254132.56],
		[2734984.75, 9276623.87],
		[2757484.66, 9277445.91],
		[2758267.30, 9254948.79],
		[2735838.19, 9254132.56],
	]], [[	/* 706:339 */
		[2758267.30, 9254948.79],
		[2757484.66, 9277445.91],
		[2779990.14, 9278196.77],
		[2780701.93, 9255694.36],
		[2758267.30, 9254948.79],
	]], [[	/* 706:340 */
		[2780701.93, 9255694.36],
		[2779990.14, 9278196.77],
		[2802500.70, 9278876.41],
		[2803141.58, 9256369.20],
		[2780701.93, 9255694.36],
	]], [[	/* 706:341 */
		[2803141.58, 9256369.20],
		[2802500.70, 9278876.41],
		[2825015.82, 9279484.78],
		[2825585.75, 9256973.27],
		[2803141.58, 9256369.20],
	]], [[	/* 706:342 */
		[2825585.75, 9256973.27],
		[2825015.82, 9279484.78],
		[2847535.00, 9280021.83],
		[2848033.95, 9257506.54],
		[2825585.75, 9256973.27],
	]], [[	/* 706:343 */
		[2848033.95, 9257506.54],
		[2847535.00, 9280021.83],
		[2870057.74, 9280487.53],
		[2870485.66, 9257968.95],
		[2848033.95, 9257506.54],
	]], [[	/* 706:344 */
		[2870485.66, 9257968.95],
		[2870057.74, 9280487.53],
		[2892583.53, 9280881.84],
		[2892940.40, 9258360.47],
		[2870485.66, 9257968.95],
	]], [[	/* 706:345 */
		[2892940.40, 9258360.47],
		[2892583.53, 9280881.84],
		[2915111.87, 9281204.73],
		[2915397.65, 9258681.09],
		[2892940.40, 9258360.47],
	]], [[	/* 706:346 */
		[2915397.65, 9258681.09],
		[2915111.87, 9281204.73],
		[2937642.24, 9281456.18],
		[2937856.92, 9258930.76],
		[2915397.65, 9258681.09],
	]], [[	/* 706:347 */
		[2937856.92, 9258930.76],
		[2937642.24, 9281456.18],
		[2960174.14, 9281636.18],
		[2960317.70, 9259109.49],
		[2937856.92, 9258930.76],
	]], [[	/* 706:348 */
		[2960317.70, 9259109.49],
		[2960174.14, 9281636.18],
		[2982707.07, 9281744.70],
		[2982779.50, 9259217.24],
		[2960317.70, 9259109.49],
	]], [[	/* 706:349 */
		[2982779.50, 9259217.24],
		[2982707.07, 9281744.70],
		[3005240.51, 9281781.74],
		[3005241.81, 9259254.03],
		[2982779.50, 9259217.24],
	]], [[	/* 706:350 */
		[3005241.81, 9259254.03],
		[3005240.51, 9281781.74],
		[3027773.96, 9281747.31],
		[3027704.13, 9259219.83],
		[3005241.81, 9259254.03],
	]], [[	/* 706:351 */
		[3027704.13, 9259219.83],
		[3027773.96, 9281747.31],
		[3050306.92, 9281641.39],
		[3050165.95, 9259114.67],
		[3027704.13, 9259219.83],
	]], [[	/* 706:352 */
		[3050165.95, 9259114.67],
		[3050306.92, 9281641.39],
		[3072838.86, 9281464.00],
		[3072626.78, 9258938.53],
		[3050165.95, 9259114.67],
	]], [[	/* 706:353 */
		[3072626.78, 9258938.53],
		[3072838.86, 9281464.00],
		[3095369.29, 9281215.15],
		[3095086.11, 9258691.44],
		[3072626.78, 9258938.53],
	]], [[	/* 706:354 */
		[3095086.11, 9258691.44],
		[3095369.29, 9281215.15],
		[3117897.71, 9280894.87],
		[3117543.43, 9258373.42],
		[3095086.11, 9258691.44],
	]], [[	/* 706:355 */
		[3117543.43, 9258373.42],
		[3117897.71, 9280894.87],
		[3140423.59, 9280503.16],
		[3139998.26, 9257984.48],
		[3117543.43, 9258373.42],
	]], [[	/* 706:356 */
		[3139998.26, 9257984.48],
		[3140423.59, 9280503.16],
		[3162946.44, 9280040.07],
		[3162450.08, 9257524.66],
		[3139998.26, 9257984.48],
	]], [[	/* 706:357 */
		[3162450.08, 9257524.66],
		[3162946.44, 9280040.07],
		[3185465.75, 9279505.62],
		[3184898.40, 9256993.98],
		[3162450.08, 9257524.66],
	]], [[	/* 706:358 */
		[3184898.40, 9256993.98],
		[3185465.75, 9279505.62],
		[3207981.01, 9278899.85],
		[3207342.71, 9256392.49],
		[3184898.40, 9256993.98],
	]], [[	/* 706:359 */
		[3207342.71, 9256392.49],
		[3207981.01, 9278899.85],
		[3230491.73, 9278222.81],
		[3229782.52, 9255720.23],
		[3207342.71, 9256392.49],
	]], [[	/* 706:360 */
		[3229782.52, 9255720.23],
		[3230491.73, 9278222.81],
		[3252997.39, 9277474.54],
		[3252217.33, 9254977.24],
		[3229782.52, 9255720.23],
	]], [[	/* 706:361 */
		[3252217.33, 9254977.24],
		[3252997.39, 9277474.54],
		[3275497.49, 9276655.11],
		[3274646.63, 9254163.59],
		[3252217.33, 9254977.24],
	]], [[	/* 706:362 */
		[3274646.63, 9254163.59],
		[3275497.49, 9276655.11],
		[3297991.53, 9275764.56],
		[3297069.94, 9253279.32],
		[3274646.63, 9254163.59],
	]], [[	/* 706:363 */
		[3297069.94, 9253279.32],
		[3297991.53, 9275764.56],
		[3320479.00, 9274802.96],
		[3319486.74, 9252324.51],
		[3297069.94, 9253279.32],
	]], [[	/* 706:364 */
		[3319486.74, 9252324.51],
		[3320479.00, 9274802.96],
		[3342959.41, 9273770.39],
		[3341896.56, 9251299.21],
		[3319486.74, 9252324.51],
	]], [[	/* 706:365 */
		[3341896.56, 9251299.21],
		[3342959.41, 9273770.39],
		[3365432.26, 9272666.91],
		[3364298.88, 9250203.51],
		[3341896.56, 9251299.21],
	]], [[	/* 706:366 */
		[3364298.88, 9250203.51],
		[3365432.26, 9272666.91],
		[3387897.05, 9271492.61],
		[3386693.23, 9249037.48],
		[3364298.88, 9250203.51],
	]], [[	/* 707:327 */
		[2487996.83, 9262904.97],
		[2486358.26, 9285369.68],
		[2508834.21, 9286980.89],
		[2510402.44, 9264504.83],
		[2487996.83, 9262904.97],
	]], [[	/* 707:328 */
		[2510402.44, 9264504.83],
		[2508834.21, 9286980.89],
		[2531321.32, 9288521.37],
		[2532819.11, 9266034.46],
		[2510402.44, 9264504.83],
	]], [[	/* 707:329 */
		[2532819.11, 9266034.46],
		[2531321.32, 9288521.37],
		[2553819.10, 9289991.01],
		[2555246.33, 9267493.73],
		[2532819.11, 9266034.46],
	]], [[	/* 707:330 */
		[2555246.33, 9267493.73],
		[2553819.10, 9289991.01],
		[2576327.04, 9291389.70],
		[2577683.62, 9268882.55],
		[2555246.33, 9267493.73],
	]], [[	/* 707:331 */
		[2577683.62, 9268882.55],
		[2576327.04, 9291389.70],
		[2598844.66, 9292717.34],
		[2600130.47, 9270200.82],
		[2577683.62, 9268882.55],
	]], [[	/* 707:332 */
		[2600130.47, 9270200.82],
		[2598844.66, 9292717.34],
		[2621371.44, 9293973.84],
		[2622586.40, 9271448.44],
		[2600130.47, 9270200.82],
	]], [[	/* 707:333 */
		[2622586.40, 9271448.44],
		[2621371.44, 9293973.84],
		[2643906.88, 9295159.09],
		[2645050.91, 9272625.32],
		[2622586.40, 9271448.44],
	]], [[	/* 707:334 */
		[2645050.91, 9272625.32],
		[2643906.88, 9295159.09],
		[2666450.49, 9296273.03],
		[2667523.50, 9273731.39],
		[2645050.91, 9272625.32],
	]], [[	/* 707:335 */
		[2667523.50, 9273731.39],
		[2666450.49, 9296273.03],
		[2689001.75, 9297315.56],
		[2690003.67, 9274766.55],
		[2667523.50, 9273731.39],
	]], [[	/* 707:336 */
		[2690003.67, 9274766.55],
		[2689001.75, 9297315.56],
		[2711560.17, 9298286.61],
		[2712490.92, 9275730.73],
		[2690003.67, 9274766.55],
	]], [[	/* 707:337 */
		[2712490.92, 9275730.73],
		[2711560.17, 9298286.61],
		[2734125.24, 9299186.11],
		[2734984.75, 9276623.87],
		[2712490.92, 9275730.73],
	]], [[	/* 707:338 */
		[2734984.75, 9276623.87],
		[2734125.24, 9299186.11],
		[2756696.44, 9300014.00],
		[2757484.66, 9277445.91],
		[2734984.75, 9276623.87],
	]], [[	/* 707:339 */
		[2757484.66, 9277445.91],
		[2756696.44, 9300014.00],
		[2779273.28, 9300770.22],
		[2779990.14, 9278196.77],
		[2757484.66, 9277445.91],
	]], [[	/* 707:340 */
		[2779990.14, 9278196.77],
		[2779273.28, 9300770.22],
		[2801855.24, 9301454.70],
		[2802500.70, 9278876.41],
		[2779990.14, 9278196.77],
	]], [[	/* 707:341 */
		[2802500.70, 9278876.41],
		[2801855.24, 9301454.70],
		[2824441.82, 9302067.41],
		[2825015.82, 9279484.78],
		[2802500.70, 9278876.41],
	]], [[	/* 707:342 */
		[2825015.82, 9279484.78],
		[2824441.82, 9302067.41],
		[2847032.50, 9302608.29],
		[2847535.00, 9280021.83],
		[2825015.82, 9279484.78],
	]], [[	/* 707:343 */
		[2847535.00, 9280021.83],
		[2847032.50, 9302608.29],
		[2869626.77, 9303077.31],
		[2870057.74, 9280487.53],
		[2847535.00, 9280021.83],
	]], [[	/* 707:344 */
		[2870057.74, 9280487.53],
		[2869626.77, 9303077.31],
		[2892224.12, 9303474.43],
		[2892583.53, 9280881.84],
		[2870057.74, 9280487.53],
	]], [[	/* 707:345 */
		[2892583.53, 9280881.84],
		[2892224.12, 9303474.43],
		[2914824.05, 9303799.63],
		[2915111.87, 9281204.73],
		[2892583.53, 9280881.84],
	]], [[	/* 707:346 */
		[2915111.87, 9281204.73],
		[2914824.05, 9303799.63],
		[2937426.03, 9304052.87],
		[2937642.24, 9281456.18],
		[2915111.87, 9281204.73],
	]], [[	/* 707:347 */
		[2937642.24, 9281456.18],
		[2937426.03, 9304052.87],
		[2960029.56, 9304234.15],
		[2960174.14, 9281636.18],
		[2937642.24, 9281456.18],
	]], [[	/* 707:348 */
		[2960174.14, 9281636.18],
		[2960029.56, 9304234.15],
		[2982634.12, 9304343.45],
		[2982707.07, 9281744.70],
		[2960174.14, 9281636.18],
	]], [[	/* 707:349 */
		[2982707.07, 9281744.70],
		[2982634.12, 9304343.45],
		[3005239.21, 9304380.76],
		[3005240.51, 9281781.74],
		[2982707.07, 9281744.70],
	]], [[	/* 707:350 */
		[3005240.51, 9281781.74],
		[3005239.21, 9304380.76],
		[3027844.30, 9304346.07],
		[3027773.96, 9281747.31],
		[3005240.51, 9281781.74],
	]], [[	/* 707:351 */
		[3027773.96, 9281747.31],
		[3027844.30, 9304346.07],
		[3050448.89, 9304239.40],
		[3050306.92, 9281641.39],
		[3027773.96, 9281747.31],
	]], [[	/* 707:352 */
		[3050306.92, 9281641.39],
		[3050448.89, 9304239.40],
		[3073052.46, 9304060.74],
		[3072838.86, 9281464.00],
		[3050306.92, 9281641.39],
	]], [[	/* 707:353 */
		[3072838.86, 9281464.00],
		[3073052.46, 9304060.74],
		[3095654.50, 9303810.12],
		[3095369.29, 9281215.15],
		[3072838.86, 9281464.00],
	]], [[	/* 707:354 */
		[3095369.29, 9281215.15],
		[3095654.50, 9303810.12],
		[3118254.51, 9303487.54],
		[3117897.71, 9280894.87],
		[3095369.29, 9281215.15],
	]], [[	/* 707:355 */
		[3117897.71, 9280894.87],
		[3118254.51, 9303487.54],
		[3140851.95, 9303093.04],
		[3140423.59, 9280503.16],
		[3117897.71, 9280894.87],
	]], [[	/* 707:356 */
		[3140423.59, 9280503.16],
		[3140851.95, 9303093.04],
		[3163446.34, 9302626.64],
		[3162946.44, 9280040.07],
		[3140423.59, 9280503.16],
	]], [[	/* 707:357 */
		[3162946.44, 9280040.07],
		[3163446.34, 9302626.64],
		[3186037.14, 9302088.38],
		[3185465.75, 9279505.62],
		[3162946.44, 9280040.07],
	]], [[	/* 707:358 */
		[3185465.75, 9279505.62],
		[3186037.14, 9302088.38],
		[3208623.86, 9301478.29],
		[3207981.01, 9278899.85],
		[3185465.75, 9279505.62],
	]], [[	/* 707:359 */
		[3207981.01, 9278899.85],
		[3208623.86, 9301478.29],
		[3231205.98, 9300796.42],
		[3230491.73, 9278222.81],
		[3207981.01, 9278899.85],
	]], [[	/* 707:360 */
		[3230491.73, 9278222.81],
		[3231205.98, 9300796.42],
		[3253783.00, 9300042.82],
		[3252997.39, 9277474.54],
		[3230491.73, 9278222.81],
	]], [[	/* 707:361 */
		[3252997.39, 9277474.54],
		[3253783.00, 9300042.82],
		[3276354.40, 9299217.55],
		[3275497.49, 9276655.11],
		[3252997.39, 9277474.54],
	]], [[	/* 707:362 */
		[3275497.49, 9276655.11],
		[3276354.40, 9299217.55],
		[3298919.68, 9298320.65],
		[3297991.53, 9275764.56],
		[3275497.49, 9276655.11],
	]], [[	/* 707:363 */
		[3297991.53, 9275764.56],
		[3298919.68, 9298320.65],
		[3321478.32, 9297352.21],
		[3320479.00, 9274802.96],
		[3297991.53, 9275764.56],
	]], [[	/* 707:364 */
		[3320479.00, 9274802.96],
		[3321478.32, 9297352.21],
		[3344029.83, 9296312.28],
		[3342959.41, 9273770.39],
		[3320479.00, 9274802.96],
	]], [[	/* 707:365 */
		[3342959.41, 9273770.39],
		[3344029.83, 9296312.28],
		[3366573.70, 9295200.95],
		[3365432.26, 9272666.91],
		[3342959.41, 9273770.39],
	]], [[	/* 708:327 */
		[2486358.26, 9285369.68],
		[2484708.04, 9307904.81],
		[2507254.82, 9309527.50],
		[2508834.21, 9286980.89],
		[2486358.26, 9285369.68],
	]], [[	/* 708:328 */
		[2508834.21, 9286980.89],
		[2507254.82, 9309527.50],
		[2529812.87, 9311078.95],
		[2531321.32, 9288521.37],
		[2508834.21, 9286980.89],
	]], [[	/* 708:329 */
		[2531321.32, 9288521.37],
		[2529812.87, 9311078.95],
		[2552381.70, 9312559.06],
		[2553819.10, 9289991.01],
		[2531321.32, 9288521.37],
	]], [[	/* 708:330 */
		[2553819.10, 9289991.01],
		[2552381.70, 9312559.06],
		[2574960.81, 9313967.72],
		[2576327.04, 9291389.70],
		[2553819.10, 9289991.01],
	]], [[	/* 708:331 */
		[2576327.04, 9291389.70],
		[2574960.81, 9313967.72],
		[2597549.67, 9315304.83],
		[2598844.66, 9292717.34],
		[2576327.04, 9291389.70],
	]], [[	/* 708:332 */
		[2598844.66, 9292717.34],
		[2597549.67, 9315304.83],
		[2620147.80, 9316570.28],
		[2621371.44, 9293973.84],
		[2598844.66, 9292717.34],
	]], [[	/* 708:333 */
		[2621371.44, 9293973.84],
		[2620147.80, 9316570.28],
		[2642754.69, 9317764.00],
		[2643906.88, 9295159.09],
		[2621371.44, 9293973.84],
	]], [[	/* 708:334 */
		[2643906.88, 9295159.09],
		[2642754.69, 9317764.00],
		[2665369.81, 9318885.89],
		[2666450.49, 9296273.03],
		[2643906.88, 9295159.09],
	]], [[	/* 708:335 */
		[2666450.49, 9296273.03],
		[2665369.81, 9318885.89],
		[2687992.68, 9319935.86],
		[2689001.75, 9297315.56],
		[2666450.49, 9296273.03],
	]], [[	/* 708:336 */
		[2689001.75, 9297315.56],
		[2687992.68, 9319935.86],
		[2710622.77, 9320913.85],
		[2711560.17, 9298286.61],
		[2689001.75, 9297315.56],
	]], [[	/* 708:337 */
		[2711560.17, 9298286.61],
		[2710622.77, 9320913.85],
		[2733259.58, 9321819.78],
		[2734125.24, 9299186.11],
		[2711560.17, 9298286.61],
	]], [[	/* 708:338 */
		[2734125.24, 9299186.11],
		[2733259.58, 9321819.78],
		[2755902.59, 9322653.59],
		[2756696.44, 9300014.00],
		[2734125.24, 9299186.11],
	]], [[	/* 708:339 */
		[2756696.44, 9300014.00],
		[2755902.59, 9322653.59],
		[2778551.30, 9323415.21],
		[2779273.28, 9300770.22],
		[2756696.44, 9300014.00],
	]], [[	/* 708:340 */
		[2779273.28, 9300770.22],
		[2778551.30, 9323415.21],
		[2801205.17, 9324104.59],
		[2801855.24, 9301454.70],
		[2779273.28, 9300770.22],
	]], [[	/* 708:341 */
		[2801855.24, 9301454.70],
		[2801205.17, 9324104.59],
		[2823863.71, 9324721.67],
		[2824441.82, 9302067.41],
		[2801855.24, 9301454.70],
	]], [[	/* 708:342 */
		[2824441.82, 9302067.41],
		[2823863.71, 9324721.67],
		[2846526.40, 9325266.42],
		[2847032.50, 9302608.29],
		[2824441.82, 9302067.41],
	]], [[	/* 708:343 */
		[2847032.50, 9302608.29],
		[2846526.40, 9325266.42],
		[2869192.71, 9325738.80],
		[2869626.77, 9303077.31],
		[2847032.50, 9302608.29],
	]], [[	/* 708:344 */
		[2869626.77, 9303077.31],
		[2869192.71, 9325738.80],
		[2891862.14, 9326138.76],
		[2892224.12, 9303474.43],
		[2869626.77, 9303077.31],
	]], [[	/* 708:345 */
		[2892224.12, 9303474.43],
		[2891862.14, 9326138.76],
		[2914534.17, 9326466.28],
		[2914824.05, 9303799.63],
		[2892224.12, 9303474.43],
	]], [[	/* 708:346 */
		[2914824.05, 9303799.63],
		[2914534.17, 9326466.28],
		[2937208.27, 9326721.34],
		[2937426.03, 9304052.87],
		[2914824.05, 9303799.63],
	]], [[	/* 708:347 */
		[2937426.03, 9304052.87],
		[2937208.27, 9326721.34],
		[2959883.94, 9326903.92],
		[2960029.56, 9304234.15],
		[2937426.03, 9304052.87],
	]], [[	/* 708:348 */
		[2960029.56, 9304234.15],
		[2959883.94, 9326903.92],
		[2982560.65, 9327014.00],
		[2982634.12, 9304343.45],
		[2960029.56, 9304234.15],
	]], [[	/* 708:349 */
		[2982634.12, 9304343.45],
		[2982560.65, 9327014.00],
		[3005237.89, 9327051.57],
		[3005239.21, 9304380.76],
		[2982634.12, 9304343.45],
	]], [[	/* 708:350 */
		[3005239.21, 9304380.76],
		[3005237.89, 9327051.57],
		[3027915.14, 9327016.64],
		[3027844.30, 9304346.07],
		[3005239.21, 9304380.76],
	]], [[	/* 708:351 */
		[3027844.30, 9304346.07],
		[3027915.14, 9327016.64],
		[3050591.88, 9326909.20],
		[3050448.89, 9304239.40],
		[3027844.30, 9304346.07],
	]], [[	/* 708:352 */
		[3050448.89, 9304239.40],
		[3050591.88, 9326909.20],
		[3073267.59, 9326729.26],
		[3073052.46, 9304060.74],
		[3050448.89, 9304239.40],
	]], [[	/* 708:353 */
		[3073052.46, 9304060.74],
		[3073267.59, 9326729.26],
		[3095941.76, 9326476.84],
		[3095654.50, 9303810.12],
		[3073052.46, 9304060.74],
	]], [[	/* 708:354 */
		[3095654.50, 9303810.12],
		[3095941.76, 9326476.84],
		[3118613.86, 9326151.96],
		[3118254.51, 9303487.54],
		[3095654.50, 9303810.12],
	]], [[	/* 708:355 */
		[3118254.51, 9303487.54],
		[3118613.86, 9326151.96],
		[3141283.38, 9325754.64],
		[3140851.95, 9303093.04],
		[3118254.51, 9303487.54],
	]], [[	/* 708:356 */
		[3140851.95, 9303093.04],
		[3141283.38, 9325754.64],
		[3163949.81, 9325284.90],
		[3163446.34, 9302626.64],
		[3140851.95, 9303093.04],
	]], [[	/* 708:357 */
		[3163446.34, 9302626.64],
		[3163949.81, 9325284.90],
		[3186612.62, 9324742.78],
		[3186037.14, 9302088.38],
		[3163446.34, 9302626.64],
	]], [[	/* 708:358 */
		[3186037.14, 9302088.38],
		[3186612.62, 9324742.78],
		[3209271.31, 9324128.33],
		[3208623.86, 9301478.29],
		[3186037.14, 9302088.38],
	]], [[	/* 708:359 */
		[3208623.86, 9301478.29],
		[3209271.31, 9324128.33],
		[3231925.35, 9323441.58],
		[3231205.98, 9300796.42],
		[3208623.86, 9301478.29],
	]], [[	/* 708:360 */
		[3231205.98, 9300796.42],
		[3231925.35, 9323441.58],
		[3254574.23, 9322682.59],
		[3253783.00, 9300042.82],
		[3231205.98, 9300796.42],
	]], [[	/* 708:361 */
		[3253783.00, 9300042.82],
		[3254574.23, 9322682.59],
		[3277217.44, 9321851.42],
		[3276354.40, 9299217.55],
		[3253783.00, 9300042.82],
	]], [[	/* 708:362 */
		[3276354.40, 9299217.55],
		[3277217.44, 9321851.42],
		[3299854.46, 9320948.11],
		[3298919.68, 9298320.65],
		[3276354.40, 9299217.55],
	]], [[	/* 708:363 */
		[3298919.68, 9298320.65],
		[3299854.46, 9320948.11],
		[3322484.78, 9319972.75],
		[3321478.32, 9297352.21],
		[3298919.68, 9298320.65],
	]], [[	/* 708:364 */
		[3321478.32, 9297352.21],
		[3322484.78, 9319972.75],
		[3345107.90, 9318925.40],
		[3344029.83, 9296312.28],
		[3321478.32, 9297352.21],
	]], [[	/* 708:365 */
		[3344029.83, 9296312.28],
		[3345107.90, 9318925.40],
		[3367723.29, 9317806.13],
		[3366573.70, 9295200.95],
		[3344029.83, 9296312.28],
	]], [[	/* 708:366 */
		[3366573.70, 9295200.95],
		[3367723.29, 9317806.13],
		[3390330.46, 9316615.03],
		[3389109.43, 9294018.30],
		[3366573.70, 9295200.95],
	]], [[	/* 709:328 */
		[2507254.82, 9309527.50],
		[2505664.15, 9332145.14],
		[2528293.65, 9333707.68],
		[2529812.87, 9311078.95],
		[2507254.82, 9309527.50],
	]], [[	/* 709:329 */
		[2529812.87, 9311078.95],
		[2528293.65, 9333707.68],
		[2550934.04, 9335198.37],
		[2552381.70, 9312559.06],
		[2529812.87, 9311078.95],
	]], [[	/* 709:330 */
		[2552381.70, 9312559.06],
		[2550934.04, 9335198.37],
		[2573584.80, 9336617.10],
		[2574960.81, 9313967.72],
		[2552381.70, 9312559.06],
	]], [[	/* 709:331 */
		[2574960.81, 9313967.72],
		[2573584.80, 9336617.10],
		[2596245.43, 9337963.77],
		[2597549.67, 9315304.83],
		[2574960.81, 9313967.72],
	]], [[	/* 709:332 */
		[2597549.67, 9315304.83],
		[2596245.43, 9337963.77],
		[2618915.41, 9339238.28],
		[2620147.80, 9316570.28],
		[2597549.67, 9315304.83],
	]], [[	/* 709:333 */
		[2620147.80, 9316570.28],
		[2618915.41, 9339238.28],
		[2641594.24, 9340440.54],
		[2642754.69, 9317764.00],
		[2620147.80, 9316570.28],
	]], [[	/* 709:334 */
		[2642754.69, 9317764.00],
		[2641594.24, 9340440.54],
		[2664281.41, 9341570.46],
		[2665369.81, 9318885.89],
		[2642754.69, 9317764.00],
	]], [[	/* 709:335 */
		[2665369.81, 9318885.89],
		[2664281.41, 9341570.46],
		[2686976.38, 9342627.96],
		[2687992.68, 9319935.86],
		[2665369.81, 9318885.89],
	]], [[	/* 709:336 */
		[2687992.68, 9319935.86],
		[2686976.38, 9342627.96],
		[2709678.66, 9343612.96],
		[2710622.77, 9320913.85],
		[2687992.68, 9319935.86],
	]], [[	/* 709:337 */
		[2710622.77, 9320913.85],
		[2709678.66, 9343612.96],
		[2732387.73, 9344525.38],
		[2733259.58, 9321819.78],
		[2710622.77, 9320913.85],
	]], [[	/* 709:338 */
		[2733259.58, 9321819.78],
		[2732387.73, 9344525.38],
		[2755103.06, 9345365.17],
		[2755902.59, 9322653.59],
		[2733259.58, 9321819.78],
	]], [[	/* 709:339 */
		[2755902.59, 9322653.59],
		[2755103.06, 9345365.17],
		[2777824.14, 9346132.25],
		[2778551.30, 9323415.21],
		[2755902.59, 9322653.59],
	]], [[	/* 709:340 */
		[2778551.30, 9323415.21],
		[2777824.14, 9346132.25],
		[2800550.45, 9346826.57],
		[2801205.17, 9324104.59],
		[2778551.30, 9323415.21],
	]], [[	/* 709:341 */
		[2801205.17, 9324104.59],
		[2800550.45, 9346826.57],
		[2823281.46, 9347448.09],
		[2823863.71, 9324721.67],
		[2801205.17, 9324104.59],
	]], [[	/* 709:342 */
		[2823863.71, 9324721.67],
		[2823281.46, 9347448.09],
		[2846016.67, 9347996.75],
		[2846526.40, 9325266.42],
		[2823863.71, 9324721.67],
	]], [[	/* 709:343 */
		[2846526.40, 9325266.42],
		[2846016.67, 9347996.75],
		[2868755.55, 9348472.51],
		[2869192.71, 9325738.80],
		[2846526.40, 9325266.42],
	]], [[	/* 709:344 */
		[2869192.71, 9325738.80],
		[2868755.55, 9348472.51],
		[2891497.57, 9348875.34],
		[2891862.14, 9326138.76],
		[2869192.71, 9325738.80],
	]], [[	/* 709:345 */
		[2891862.14, 9326138.76],
		[2891497.57, 9348875.34],
		[2914242.21, 9349205.22],
		[2914534.17, 9326466.28],
		[2891862.14, 9326138.76],
	]], [[	/* 709:346 */
		[2914534.17, 9326466.28],
		[2914242.21, 9349205.22],
		[2936988.96, 9349462.11],
		[2937208.27, 9326721.34],
		[2914534.17, 9326466.28],
	]], [[	/* 709:347 */
		[2937208.27, 9326721.34],
		[2936988.96, 9349462.11],
		[2959737.28, 9349645.99],
		[2959883.94, 9326903.92],
		[2937208.27, 9326721.34],
	]], [[	/* 709:348 */
		[2959883.94, 9326903.92],
		[2959737.28, 9349645.99],
		[2982486.66, 9349756.86],
		[2982560.65, 9327014.00],
		[2959883.94, 9326903.92],
	]], [[	/* 709:349 */
		[2982560.65, 9327014.00],
		[2982486.66, 9349756.86],
		[3005236.57, 9349794.70],
		[3005237.89, 9327051.57],
		[2982560.65, 9327014.00],
	]], [[	/* 709:350 */
		[3005237.89, 9327051.57],
		[3005236.57, 9349794.70],
		[3027986.49, 9349759.52],
		[3027915.14, 9327016.64],
		[3005237.89, 9327051.57],
	]], [[	/* 709:351 */
		[3027915.14, 9327016.64],
		[3027986.49, 9349759.52],
		[3050735.90, 9349651.31],
		[3050591.88, 9326909.20],
		[3027915.14, 9327016.64],
	]], [[	/* 709:352 */
		[3050591.88, 9326909.20],
		[3050735.90, 9349651.31],
		[3073484.26, 9349470.08],
		[3073267.59, 9326729.26],
		[3050591.88, 9326909.20],
	]], [[	/* 709:353 */
		[3073267.59, 9326729.26],
		[3073484.26, 9349470.08],
		[3096231.07, 9349215.85],
		[3095941.76, 9326476.84],
		[3073267.59, 9326729.26],
	]], [[	/* 709:354 */
		[3095941.76, 9326476.84],
		[3096231.07, 9349215.85],
		[3118975.79, 9348888.63],
		[3118613.86, 9326151.96],
		[3095941.76, 9326476.84],
	]], [[	/* 709:355 */
		[3118613.86, 9326151.96],
		[3118975.79, 9348888.63],
		[3141717.91, 9348488.45],
		[3141283.38, 9325754.64],
		[3118613.86, 9326151.96],
	]], [[	/* 709:356 */
		[3141283.38, 9325754.64],
		[3141717.91, 9348488.45],
		[3164456.89, 9348015.34],
		[3163949.81, 9325284.90],
		[3141283.38, 9325754.64],
	]], [[	/* 709:357 */
		[3163949.81, 9325284.90],
		[3164456.89, 9348015.34],
		[3187192.23, 9347469.34],
		[3186612.62, 9324742.78],
		[3163949.81, 9325284.90],
	]], [[	/* 709:358 */
		[3186612.62, 9324742.78],
		[3187192.23, 9347469.34],
		[3209923.40, 9346850.47],
		[3209271.31, 9324128.33],
		[3186612.62, 9324742.78],
	]], [[	/* 709:359 */
		[3209271.31, 9324128.33],
		[3209923.40, 9346850.47],
		[3232649.87, 9346158.80],
		[3231925.35, 9323441.58],
		[3209271.31, 9324128.33],
	]], [[	/* 709:360 */
		[3231925.35, 9323441.58],
		[3232649.87, 9346158.80],
		[3255371.13, 9345394.36],
		[3254574.23, 9322682.59],
		[3231925.35, 9323441.58],
	]], [[	/* 709:361 */
		[3254574.23, 9322682.59],
		[3255371.13, 9345394.36],
		[3278086.66, 9344557.23],
		[3277217.44, 9321851.42],
		[3254574.23, 9322682.59],
	]], [[	/* 709:362 */
		[3277217.44, 9321851.42],
		[3278086.66, 9344557.23],
		[3300795.94, 9343647.45],
		[3299854.46, 9320948.11],
		[3277217.44, 9321851.42],
	]], [[	/* 709:363 */
		[3299854.46, 9320948.11],
		[3300795.94, 9343647.45],
		[3323498.45, 9342665.09],
		[3322484.78, 9319972.75],
		[3299854.46, 9320948.11],
	]], [[	/* 709:364 */
		[3322484.78, 9319972.75],
		[3323498.45, 9342665.09],
		[3346193.68, 9341610.23],
		[3345107.90, 9318925.40],
		[3322484.78, 9319972.75],
	]], [[	/* 709:365 */
		[3345107.90, 9318925.40],
		[3346193.68, 9341610.23],
		[3368881.11, 9340482.95],
		[3367723.29, 9317806.13],
		[3345107.90, 9318925.40],
	]], [[	/* 709:366 */
		[3367723.29, 9317806.13],
		[3368881.11, 9340482.95],
		[3391560.22, 9339283.32],
		[3390330.46, 9316615.03],
		[3367723.29, 9317806.13],
	]], [[	/* 710:329 */
		[2528293.65, 9333707.68],
		[2526763.54, 9356408.07],
		[2549475.99, 9357909.45],
		[2550934.04, 9335198.37],
		[2528293.65, 9333707.68],
	]], [[	/* 710:330 */
		[2550934.04, 9335198.37],
		[2549475.99, 9357909.45],
		[2572198.93, 9359338.35],
		[2573584.80, 9336617.10],
		[2550934.04, 9335198.37],
	]], [[	/* 710:331 */
		[2573584.80, 9336617.10],
		[2572198.93, 9359338.35],
		[2594931.83, 9360694.69],
		[2596245.43, 9337963.77],
		[2573584.80, 9336617.10],
	]], [[	/* 710:332 */
		[2596245.43, 9337963.77],
		[2594931.83, 9360694.69],
		[2617674.18, 9361978.35],
		[2618915.41, 9339238.28],
		[2596245.43, 9337963.77],
	]], [[	/* 710:333 */
		[2618915.41, 9339238.28],
		[2617674.18, 9361978.35],
		[2640425.47, 9363189.24],
		[2641594.24, 9340440.54],
		[2618915.41, 9339238.28],
	]], [[	/* 710:334 */
		[2641594.24, 9340440.54],
		[2640425.47, 9363189.24],
		[2663185.18, 9364327.28],
		[2664281.41, 9341570.46],
		[2641594.24, 9340440.54],
	]], [[	/* 710:335 */
		[2664281.41, 9341570.46],
		[2663185.18, 9364327.28],
		[2685952.78, 9365392.38],
		[2686976.38, 9342627.96],
		[2664281.41, 9341570.46],
	]], [[	/* 710:336 */
		[2686976.38, 9342627.96],
		[2685952.78, 9365392.38],
		[2708727.77, 9366384.45],
		[2709678.66, 9343612.96],
		[2686976.38, 9342627.96],
	]], [[	/* 710:337 */
		[2709678.66, 9343612.96],
		[2708727.77, 9366384.45],
		[2731509.60, 9367303.44],
		[2732387.73, 9344525.38],
		[2709678.66, 9343612.96],
	]], [[	/* 710:338 */
		[2732387.73, 9344525.38],
		[2731509.60, 9367303.44],
		[2754297.77, 9368149.26],
		[2755103.06, 9345365.17],
		[2732387.73, 9344525.38],
	]], [[	/* 710:339 */
		[2755103.06, 9345365.17],
		[2754297.77, 9368149.26],
		[2777091.75, 9368921.86],
		[2777824.14, 9346132.25],
		[2755103.06, 9345365.17],
	]], [[	/* 710:340 */
		[2777824.14, 9346132.25],
		[2777091.75, 9368921.86],
		[2799891.01, 9369621.18],
		[2800550.45, 9346826.57],
		[2777824.14, 9346132.25],
	]], [[	/* 710:341 */
		[2800550.45, 9346826.57],
		[2799891.01, 9369621.18],
		[2822695.02, 9370247.17],
		[2823281.46, 9347448.09],
		[2800550.45, 9346826.57],
	]], [[	/* 710:342 */
		[2823281.46, 9347448.09],
		[2822695.02, 9370247.17],
		[2845503.28, 9370799.78],
		[2846016.67, 9347996.75],
		[2823281.46, 9347448.09],
	]], [[	/* 710:343 */
		[2846016.67, 9347996.75],
		[2845503.28, 9370799.78],
		[2868315.23, 9371278.97],
		[2868755.55, 9348472.51],
		[2846016.67, 9347996.75],
	]], [[	/* 710:344 */
		[2868755.55, 9348472.51],
		[2868315.23, 9371278.97],
		[2891130.37, 9371684.70],
		[2891497.57, 9348875.34],
		[2868755.55, 9348472.51],
	]], [[	/* 710:345 */
		[2891497.57, 9348875.34],
		[2891130.37, 9371684.70],
		[2913948.15, 9372016.95],
		[2914242.21, 9349205.22],
		[2891497.57, 9348875.34],
	]], [[	/* 710:346 */
		[2914242.21, 9349205.22],
		[2913948.15, 9372016.95],
		[2936768.06, 9372275.69],
		[2936988.96, 9349462.11],
		[2914242.21, 9349205.22],
	]], [[	/* 710:347 */
		[2936988.96, 9349462.11],
		[2936768.06, 9372275.69],
		[2959589.56, 9372460.90],
		[2959737.28, 9349645.99],
		[2936988.96, 9349462.11],
	]], [[	/* 710:348 */
		[2959737.28, 9349645.99],
		[2959589.56, 9372460.90],
		[2982412.13, 9372572.56],
		[2982486.66, 9349756.86],
		[2959737.28, 9349645.99],
	]], [[	/* 710:349 */
		[2982486.66, 9349756.86],
		[2982412.13, 9372572.56],
		[3005235.24, 9372610.68],
		[3005236.57, 9349794.70],
		[2982486.66, 9349756.86],
	]], [[	/* 710:350 */
		[3005236.57, 9349794.70],
		[3005235.24, 9372610.68],
		[3028058.35, 9372575.24],
		[3027986.49, 9349759.52],
		[3005236.57, 9349794.70],
	]], [[	/* 710:351 */
		[3027986.49, 9349759.52],
		[3028058.35, 9372575.24],
		[3050880.95, 9372466.25],
		[3050735.90, 9349651.31],
		[3027986.49, 9349759.52],
	]], [[	/* 710:352 */
		[3050735.90, 9349651.31],
		[3050880.95, 9372466.25],
		[3073702.50, 9372283.71],
		[3073484.26, 9349470.08],
		[3050735.90, 9349651.31],
	]], [[	/* 710:353 */
		[3073484.26, 9349470.08],
		[3073702.50, 9372283.71],
		[3096522.47, 9372027.65],
		[3096231.07, 9349215.85],
		[3073484.26, 9349470.08],
	]], [[	/* 710:354 */
		[3096231.07, 9349215.85],
		[3096522.47, 9372027.65],
		[3119340.33, 9371698.07],
		[3118975.79, 9348888.63],
		[3096231.07, 9349215.85],
	]], [[	/* 710:355 */
		[3118975.79, 9348888.63],
		[3119340.33, 9371698.07],
		[3142155.56, 9371295.01],
		[3141717.91, 9348488.45],
		[3118975.79, 9348888.63],
	]], [[	/* 710:356 */
		[3141717.91, 9348488.45],
		[3142155.56, 9371295.01],
		[3164967.63, 9370818.49],
		[3164456.89, 9348015.34],
		[3141717.91, 9348488.45],
	]], [[	/* 710:357 */
		[3164456.89, 9348015.34],
		[3164967.63, 9370818.49],
		[3187776.01, 9370268.56],
		[3187192.23, 9347469.34],
		[3164456.89, 9348015.34],
	]], [[	/* 710:358 */
		[3187192.23, 9347469.34],
		[3187776.01, 9370268.56],
		[3210580.18, 9369645.24],
		[3209923.40, 9346850.47],
		[3187192.23, 9347469.34],
	]], [[	/* 710:359 */
		[3209923.40, 9346850.47],
		[3210580.18, 9369645.24],
		[3233379.61, 9368948.58],
		[3232649.87, 9346158.80],
		[3209923.40, 9346850.47],
	]], [[	/* 710:360 */
		[3232649.87, 9346158.80],
		[3233379.61, 9368948.58],
		[3256173.77, 9368178.65],
		[3255371.13, 9345394.36],
		[3232649.87, 9346158.80],
	]], [[	/* 710:361 */
		[3255371.13, 9345394.36],
		[3256173.77, 9368178.65],
		[3278962.13, 9367335.49],
		[3278086.66, 9344557.23],
		[3255371.13, 9345394.36],
	]], [[	/* 710:362 */
		[3278086.66, 9344557.23],
		[3278962.13, 9367335.49],
		[3301744.19, 9366419.17],
		[3300795.94, 9343647.45],
		[3278086.66, 9344557.23],
	]], [[	/* 710:363 */
		[3300795.94, 9343647.45],
		[3301744.19, 9366419.17],
		[3324519.41, 9365429.75],
		[3323498.45, 9342665.09],
		[3300795.94, 9343647.45],
	]], [[	/* 710:364 */
		[3323498.45, 9342665.09],
		[3324519.41, 9365429.75],
		[3347287.26, 9364367.31],
		[3346193.68, 9341610.23],
		[3323498.45, 9342665.09],
	]], [[	/* 710:365 */
		[3346193.68, 9341610.23],
		[3347287.26, 9364367.31],
		[3370047.24, 9363231.92],
		[3368881.11, 9340482.95],
		[3346193.68, 9341610.23],
	]], [[	/* 710:366 */
		[3368881.11, 9340482.95],
		[3370047.24, 9363231.92],
		[3392798.82, 9362023.68],
		[3391560.22, 9339283.32],
		[3368881.11, 9340482.95],
	]], [[	/* 710:367 */
		[3391560.22, 9339283.32],
		[3392798.82, 9362023.68],
		[3415541.48, 9360742.67],
		[3414230.51, 9338011.44],
		[3391560.22, 9339283.32],
	]], [[	/* 711:332 */
		[2594931.83, 9360694.69],
		[2593608.77, 9383498.09],
		[2616424.01, 9384790.99],
		[2617674.18, 9361978.35],
		[2594931.83, 9360694.69],
	]], [[	/* 711:333 */
		[2617674.18, 9361978.35],
		[2616424.01, 9384790.99],
		[2639248.28, 9386010.61],
		[2640425.47, 9363189.24],
		[2617674.18, 9361978.35],
	]], [[	/* 711:334 */
		[2640425.47, 9363189.24],
		[2639248.28, 9386010.61],
		[2662081.06, 9387156.85],
		[2663185.18, 9364327.28],
		[2640425.47, 9363189.24],
	]], [[	/* 711:335 */
		[2663185.18, 9364327.28],
		[2662081.06, 9387156.85],
		[2684921.81, 9388229.62],
		[2685952.78, 9365392.38],
		[2663185.18, 9364327.28],
	]], [[	/* 711:336 */
		[2685952.78, 9365392.38],
		[2684921.81, 9388229.62],
		[2707770.01, 9389228.85],
		[2708727.77, 9366384.45],
		[2685952.78, 9365392.38],
	]], [[	/* 711:337 */
		[2708727.77, 9366384.45],
		[2707770.01, 9389228.85],
		[2730625.15, 9390154.46],
		[2731509.60, 9367303.44],
		[2708727.77, 9366384.45],
	]], [[	/* 711:338 */
		[2731509.60, 9367303.44],
		[2730625.15, 9390154.46],
		[2753486.68, 9391006.39],
		[2754297.77, 9368149.26],
		[2731509.60, 9367303.44],
	]], [[	/* 711:339 */
		[2754297.77, 9368149.26],
		[2753486.68, 9391006.39],
		[2776354.07, 9391784.57],
		[2777091.75, 9368921.86],
		[2754297.77, 9368149.26],
	]], [[	/* 711:340 */
		[2777091.75, 9368921.86],
		[2776354.07, 9391784.57],
		[2799226.81, 9392488.93],
		[2799891.01, 9369621.18],
		[2777091.75, 9368921.86],
	]], [[	/* 711:341 */
		[2799891.01, 9369621.18],
		[2799226.81, 9392488.93],
		[2822104.35, 9393119.44],
		[2822695.02, 9370247.17],
		[2799891.01, 9369621.18],
	]], [[	/* 711:342 */
		[2822695.02, 9370247.17],
		[2822104.35, 9393119.44],
		[2844986.17, 9393676.04],
		[2845503.28, 9370799.78],
		[2822695.02, 9370247.17],
	]], [[	/* 711:343 */
		[2845503.28, 9370799.78],
		[2844986.17, 9393676.04],
		[2867871.74, 9394158.69],
		[2868315.23, 9371278.97],
		[2845503.28, 9370799.78],
	]], [[	/* 711:344 */
		[2868315.23, 9371278.97],
		[2867871.74, 9394158.69],
		[2890760.51, 9394567.35],
		[2891130.37, 9371684.70],
		[2868315.23, 9371278.97],
	]], [[	/* 711:345 */
		[2891130.37, 9371684.70],
		[2890760.51, 9394567.35],
		[2913651.97, 9394902.00],
		[2913948.15, 9372016.95],
		[2891130.37, 9371684.70],
	]], [[	/* 711:346 */
		[2913948.15, 9372016.95],
		[2913651.97, 9394902.00],
		[2936545.57, 9395162.61],
		[2936768.06, 9372275.69],
		[2913948.15, 9372016.95],
	]], [[	/* 711:347 */
		[2936768.06, 9372275.69],
		[2936545.57, 9395162.61],
		[2959440.78, 9395349.15],
		[2959589.56, 9372460.90],
		[2936768.06, 9372275.69],
	]], [[	/* 711:348 */
		[2959589.56, 9372460.90],
		[2959440.78, 9395349.15],
		[2982337.07, 9395461.63],
		[2982412.13, 9372572.56],
		[2959589.56, 9372460.90],
	]], [[	/* 711:349 */
		[2982412.13, 9372572.56],
		[2982337.07, 9395461.63],
		[3005233.90, 9395500.02],
		[3005235.24, 9372610.68],
		[2982412.13, 9372572.56],
	]], [[	/* 711:350 */
		[3005235.24, 9372610.68],
		[3005233.90, 9395500.02],
		[3028130.74, 9395464.32],
		[3028058.35, 9372575.24],
		[3005235.24, 9372610.68],
	]], [[	/* 711:351 */
		[3028058.35, 9372575.24],
		[3028130.74, 9395464.32],
		[3051027.05, 9395354.54],
		[3050880.95, 9372466.25],
		[3028058.35, 9372575.24],
	]], [[	/* 711:352 */
		[3050880.95, 9372466.25],
		[3051027.05, 9395354.54],
		[3073922.31, 9395170.69],
		[3073702.50, 9372283.71],
		[3050880.95, 9372466.25],
	]], [[	/* 711:353 */
		[3073702.50, 9372283.71],
		[3073922.31, 9395170.69],
		[3096815.97, 9394912.77],
		[3096522.47, 9372027.65],
		[3073702.50, 9372283.71],
	]], [[	/* 711:354 */
		[3096522.47, 9372027.65],
		[3096815.97, 9394912.77],
		[3119707.50, 9394580.81],
		[3119340.33, 9371698.07],
		[3096522.47, 9372027.65],
	]], [[	/* 711:355 */
		[3119340.33, 9371698.07],
		[3119707.50, 9394580.81],
		[3142596.38, 9394174.84],
		[3142155.56, 9371295.01],
		[3119340.33, 9371698.07],
	]], [[	/* 711:356 */
		[3142155.56, 9371295.01],
		[3142596.38, 9394174.84],
		[3165482.06, 9393694.88],
		[3164967.63, 9370818.49],
		[3142155.56, 9371295.01],
	]], [[	/* 711:357 */
		[3164967.63, 9370818.49],
		[3165482.06, 9393694.88],
		[3188364.01, 9393140.97],
		[3187776.01, 9370268.56],
		[3164967.63, 9370818.49],
	]], [[	/* 711:358 */
		[3187776.01, 9370268.56],
		[3188364.01, 9393140.97],
		[3211241.70, 9392513.15],
		[3210580.18, 9369645.24],
		[3187776.01, 9370268.56],
	]], [[	/* 711:359 */
		[3210580.18, 9369645.24],
		[3211241.70, 9392513.15],
		[3234114.61, 9391811.46],
		[3233379.61, 9368948.58],
		[3210580.18, 9369645.24],
	]], [[	/* 711:360 */
		[3233379.61, 9368948.58],
		[3234114.61, 9391811.46],
		[3256982.19, 9391035.97],
		[3256173.77, 9368178.65],
		[3233379.61, 9368948.58],
	]], [[	/* 711:361 */
		[3256173.77, 9368178.65],
		[3256982.19, 9391035.97],
		[3279843.92, 9390186.73],
		[3278962.13, 9367335.49],
		[3256173.77, 9368178.65],
	]], [[	/* 711:362 */
		[3278962.13, 9367335.49],
		[3279843.92, 9390186.73],
		[3302699.28, 9389263.79],
		[3301744.19, 9366419.17],
		[3278962.13, 9367335.49],
	]], [[	/* 711:363 */
		[3301744.19, 9366419.17],
		[3302699.28, 9389263.79],
		[3325547.72, 9388267.24],
		[3324519.41, 9365429.75],
		[3301744.19, 9366419.17],
	]], [[	/* 711:364 */
		[3324519.41, 9365429.75],
		[3325547.72, 9388267.24],
		[3348388.73, 9387197.14],
		[3347287.26, 9364367.31],
		[3324519.41, 9365429.75],
	]], [[	/* 711:365 */
		[3347287.26, 9364367.31],
		[3348388.73, 9387197.14],
		[3371221.77, 9386053.57],
		[3370047.24, 9363231.92],
		[3347287.26, 9364367.31],
	]], [[	/* 711:366 */
		[3370047.24, 9363231.92],
		[3371221.77, 9386053.57],
		[3394046.33, 9384836.62],
		[3392798.82, 9362023.68],
		[3370047.24, 9363231.92],
	]], [[	/* 711:367 */
		[3392798.82, 9362023.68],
		[3394046.33, 9384836.62],
		[3416861.88, 9383546.38],
		[3415541.48, 9360742.67],
		[3392798.82, 9362023.68],
	]], [[	/* 712:333 */
		[2616424.01, 9384790.99],
		[2615164.82, 9407676.73],
		[2638062.59, 9408905.16],
		[2639248.28, 9386010.61],
		[2616424.01, 9384790.99],
	]], [[	/* 712:334 */
		[2639248.28, 9386010.61],
		[2638062.59, 9408905.16],
		[2660968.95, 9410059.69],
		[2662081.06, 9387156.85],
		[2639248.28, 9386010.61],
	]], [[	/* 712:335 */
		[2662081.06, 9387156.85],
		[2660968.95, 9410059.69],
		[2683883.38, 9411140.22],
		[2684921.81, 9388229.62],
		[2662081.06, 9387156.85],
	]], [[	/* 712:336 */
		[2684921.81, 9388229.62],
		[2683883.38, 9411140.22],
		[2706805.34, 9412146.68],
		[2707770.01, 9389228.85],
		[2684921.81, 9388229.62],
	]], [[	/* 712:337 */
		[2707770.01, 9389228.85],
		[2706805.34, 9412146.68],
		[2729734.29, 9413078.99],
		[2730625.15, 9390154.46],
		[2707770.01, 9389228.85],
	]], [[	/* 712:338 */
		[2730625.15, 9390154.46],
		[2729734.29, 9413078.99],
		[2752669.71, 9413937.08],
		[2753486.68, 9391006.39],
		[2730625.15, 9390154.46],
	]], [[	/* 712:339 */
		[2753486.68, 9391006.39],
		[2752669.71, 9413937.08],
		[2775611.06, 9414720.89],
		[2776354.07, 9391784.57],
		[2753486.68, 9391006.39],
	]], [[	/* 712:340 */
		[2776354.07, 9391784.57],
		[2775611.06, 9414720.89],
		[2798557.81, 9415430.36],
		[2799226.81, 9392488.93],
		[2776354.07, 9391784.57],
	]], [[	/* 712:341 */
		[2799226.81, 9392488.93],
		[2798557.81, 9415430.36],
		[2821509.41, 9416065.43],
		[2822104.35, 9393119.44],
		[2799226.81, 9392488.93],
	]], [[	/* 712:342 */
		[2822104.35, 9393119.44],
		[2821509.41, 9416065.43],
		[2844465.33, 9416626.06],
		[2844986.17, 9393676.04],
		[2822104.35, 9393119.44],
	]], [[	/* 712:343 */
		[2844986.17, 9393676.04],
		[2844465.33, 9416626.06],
		[2867425.03, 9417112.21],
		[2867871.74, 9394158.69],
		[2844986.17, 9393676.04],
	]], [[	/* 712:344 */
		[2867871.74, 9394158.69],
		[2867425.03, 9417112.21],
		[2890387.98, 9417523.83],
		[2890760.51, 9394567.35],
		[2867871.74, 9394158.69],
	]], [[	/* 712:345 */
		[2890760.51, 9394567.35],
		[2890387.98, 9417523.83],
		[2913353.64, 9417860.91],
		[2913651.97, 9394902.00],
		[2890760.51, 9394567.35],
	]], [[	/* 712:346 */
		[2913651.97, 9394902.00],
		[2913353.64, 9417860.91],
		[2936321.47, 9418123.40],
		[2936545.57, 9395162.61],
		[2913651.97, 9394902.00],
	]], [[	/* 712:347 */
		[2936545.57, 9395162.61],
		[2936321.47, 9418123.40],
		[2959290.92, 9418311.30],
		[2959440.78, 9395349.15],
		[2936545.57, 9395162.61],
	]], [[	/* 712:348 */
		[2959440.78, 9395349.15],
		[2959290.92, 9418311.30],
		[2982261.46, 9418424.59],
		[2982337.07, 9395461.63],
		[2959440.78, 9395349.15],
	]], [[	/* 712:349 */
		[2982337.07, 9395461.63],
		[2982261.46, 9418424.59],
		[3005232.55, 9418463.25],
		[3005233.90, 9395500.02],
		[2982337.07, 9395461.63],
	]], [[	/* 712:350 */
		[3005233.90, 9395500.02],
		[3005232.55, 9418463.25],
		[3028203.65, 9418427.30],
		[3028130.74, 9395464.32],
		[3005233.90, 9395500.02],
	]], [[	/* 712:351 */
		[3028130.74, 9395464.32],
		[3028203.65, 9418427.30],
		[3051174.22, 9418316.72],
		[3051027.05, 9395354.54],
		[3028130.74, 9395464.32],
	]], [[	/* 712:352 */
		[3051027.05, 9395354.54],
		[3051174.22, 9418316.72],
		[3074143.71, 9418131.53],
		[3073922.31, 9395170.69],
		[3051027.05, 9395354.54],
	]], [[	/* 712:353 */
		[3073922.31, 9395170.69],
		[3074143.71, 9418131.53],
		[3097111.60, 9417871.75],
		[3096815.97, 9394912.77],
		[3073922.31, 9395170.69],
	]], [[	/* 712:354 */
		[3096815.97, 9394912.77],
		[3097111.60, 9417871.75],
		[3120077.34, 9417537.38],
		[3119707.50, 9394580.81],
		[3096815.97, 9394912.77],
	]], [[	/* 712:355 */
		[3119707.50, 9394580.81],
		[3120077.34, 9417537.38],
		[3143040.39, 9417128.47],
		[3142596.38, 9394174.84],
		[3119707.50, 9394580.81],
	]], [[	/* 712:356 */
		[3142596.38, 9394174.84],
		[3143040.39, 9417128.47],
		[3166000.21, 9416645.03],
		[3165482.06, 9393694.88],
		[3142596.38, 9394174.84],
	]], [[	/* 712:357 */
		[3165482.06, 9393694.88],
		[3166000.21, 9416645.03],
		[3188956.26, 9416087.10],
		[3188364.01, 9393140.97],
		[3165482.06, 9393694.88],
	]], [[	/* 712:358 */
		[3188364.01, 9393140.97],
		[3188956.26, 9416087.10],
		[3211908.02, 9415454.73],
		[3211241.70, 9392513.15],
		[3188364.01, 9393140.97],
	]], [[	/* 712:359 */
		[3211241.70, 9392513.15],
		[3211908.02, 9415454.73],
		[3234854.93, 9414747.97],
		[3234114.61, 9391811.46],
		[3211241.70, 9392513.15],
	]], [[	/* 712:360 */
		[3234114.61, 9391811.46],
		[3234854.93, 9414747.97],
		[3257796.47, 9413966.86],
		[3256982.19, 9391035.97],
		[3234114.61, 9391811.46],
	]], [[	/* 712:361 */
		[3256982.19, 9391035.97],
		[3257796.47, 9413966.86],
		[3280732.09, 9413111.46],
		[3279843.92, 9390186.73],
		[3256982.19, 9391035.97],
	]], [[	/* 712:362 */
		[3279843.92, 9390186.73],
		[3280732.09, 9413111.46],
		[3303661.27, 9412181.85],
		[3302699.28, 9389263.79],
		[3279843.92, 9390186.73],
	]], [[	/* 712:363 */
		[3302699.28, 9389263.79],
		[3303661.27, 9412181.85],
		[3326583.47, 9411178.09],
		[3325547.72, 9388267.24],
		[3302699.28, 9389263.79],
	]], [[	/* 712:364 */
		[3325547.72, 9388267.24],
		[3326583.47, 9411178.09],
		[3349498.15, 9410100.25],
		[3348388.73, 9387197.14],
		[3325547.72, 9388267.24],
	]], [[	/* 712:365 */
		[3348388.73, 9387197.14],
		[3349498.15, 9410100.25],
		[3372404.79, 9408948.41],
		[3371221.77, 9386053.57],
		[3348388.73, 9387197.14],
	]], [[	/* 712:366 */
		[3371221.77, 9386053.57],
		[3372404.79, 9408948.41],
		[3395302.86, 9407722.67],
		[3394046.33, 9384836.62],
		[3371221.77, 9386053.57],
	]], [[	/* 712:367 */
		[3394046.33, 9384836.62],
		[3395302.86, 9407722.67],
		[3418191.82, 9406423.10],
		[3416861.88, 9383546.38],
		[3394046.33, 9384836.62],
	]], [[	/* 713:333 */
		[2615164.82, 9407676.73],
		[2613896.50, 9430636.10],
		[2636868.30, 9431873.44],
		[2638062.59, 9408905.16],
		[2615164.82, 9407676.73],
	]], [[	/* 713:334 */
		[2638062.59, 9408905.16],
		[2636868.30, 9431873.44],
		[2659848.79, 9433036.33],
		[2660968.95, 9410059.69],
		[2638062.59, 9408905.16],
	]], [[	/* 713:335 */
		[2660968.95, 9410059.69],
		[2659848.79, 9433036.33],
		[2682837.42, 9434124.70],
		[2683883.38, 9411140.22],
		[2660968.95, 9410059.69],
	]], [[	/* 713:336 */
		[2683883.38, 9411140.22],
		[2682837.42, 9434124.70],
		[2705833.66, 9435138.47],
		[2706805.34, 9412146.68],
		[2683883.38, 9411140.22],
	]], [[	/* 713:337 */
		[2706805.34, 9412146.68],
		[2705833.66, 9435138.47],
		[2728836.97, 9436077.54],
		[2729734.29, 9413078.99],
		[2706805.34, 9412146.68],
	]], [[	/* 713:338 */
		[2729734.29, 9413078.99],
		[2728836.97, 9436077.54],
		[2751846.82, 9436941.87],
		[2752669.71, 9413937.08],
		[2729734.29, 9413078.99],
	]], [[	/* 713:339 */
		[2752669.71, 9413937.08],
		[2751846.82, 9436941.87],
		[2774862.66, 9437731.37],
		[2775611.06, 9414720.89],
		[2752669.71, 9413937.08],
	]], [[	/* 713:340 */
		[2775611.06, 9414720.89],
		[2774862.66, 9437731.37],
		[2797883.94, 9438445.99],
		[2798557.81, 9415430.36],
		[2775611.06, 9414720.89],
	]], [[	/* 713:341 */
		[2798557.81, 9415430.36],
		[2797883.94, 9438445.99],
		[2820910.14, 9439085.68],
		[2821509.41, 9416065.43],
		[2798557.81, 9415430.36],
	]], [[	/* 713:342 */
		[2821509.41, 9416065.43],
		[2820910.14, 9439085.68],
		[2843940.70, 9439650.38],
		[2844465.33, 9416626.06],
		[2821509.41, 9416065.43],
	]], [[	/* 713:343 */
		[2844465.33, 9416626.06],
		[2843940.70, 9439650.38],
		[2866975.08, 9440140.06],
		[2867425.03, 9417112.21],
		[2844465.33, 9416626.06],
	]], [[	/* 713:344 */
		[2867425.03, 9417112.21],
		[2866975.08, 9440140.06],
		[2890012.75, 9440554.68],
		[2890387.98, 9417523.83],
		[2867425.03, 9417112.21],
	]], [[	/* 713:345 */
		[2890387.98, 9417523.83],
		[2890012.75, 9440554.68],
		[2913053.15, 9440894.20],
		[2913353.64, 9417860.91],
		[2890387.98, 9417523.83],
	]], [[	/* 713:346 */
		[2913353.64, 9417860.91],
		[2913053.15, 9440894.20],
		[2936095.74, 9441158.60],
		[2936321.47, 9418123.40],
		[2913353.64, 9417860.91],
	]], [[	/* 713:347 */
		[2936321.47, 9418123.40],
		[2936095.74, 9441158.60],
		[2959139.97, 9441347.87],
		[2959290.92, 9418311.30],
		[2936321.47, 9418123.40],
	]], [[	/* 713:348 */
		[2959290.92, 9418311.30],
		[2959139.97, 9441347.87],
		[2982185.30, 9441461.98],
		[2982261.46, 9418424.59],
		[2959290.92, 9418311.30],
	]], [[	/* 713:349 */
		[2982261.46, 9418424.59],
		[2982185.30, 9441461.98],
		[3005231.19, 9441500.92],
		[3005232.55, 9418463.25],
		[2982261.46, 9418424.59],
	]], [[	/* 713:350 */
		[3005232.55, 9418463.25],
		[3005231.19, 9441500.92],
		[3028277.09, 9441464.70],
		[3028203.65, 9418427.30],
		[3005232.55, 9418463.25],
	]], [[	/* 713:351 */
		[3028203.65, 9418427.30],
		[3028277.09, 9441464.70],
		[3051322.45, 9441353.32],
		[3051174.22, 9418316.72],
		[3028203.65, 9418427.30],
	]], [[	/* 713:352 */
		[3051174.22, 9418316.72],
		[3051322.45, 9441353.32],
		[3074366.73, 9441166.79],
		[3074143.71, 9418131.53],
		[3051174.22, 9418316.72],
	]], [[	/* 713:353 */
		[3074143.71, 9418131.53],
		[3074366.73, 9441166.79],
		[3097409.38, 9440905.11],
		[3097111.60, 9417871.75],
		[3074143.71, 9418131.53],
	]], [[	/* 713:354 */
		[3097111.60, 9417871.75],
		[3097409.38, 9440905.11],
		[3120449.86, 9440568.32],
		[3120077.34, 9417537.38],
		[3097111.60, 9417871.75],
	]], [[	/* 713:355 */
		[3120077.34, 9417537.38],
		[3120449.86, 9440568.32],
		[3143487.62, 9440156.43],
		[3143040.39, 9417128.47],
		[3120077.34, 9417537.38],
	]], [[	/* 713:356 */
		[3143040.39, 9417128.47],
		[3143487.62, 9440156.43],
		[3166522.12, 9439669.47],
		[3166000.21, 9416645.03],
		[3143040.39, 9417128.47],
	]], [[	/* 713:357 */
		[3166000.21, 9416645.03],
		[3166522.12, 9439669.47],
		[3189552.82, 9439107.49],
		[3188956.26, 9416087.10],
		[3166000.21, 9416645.03],
	]], [[	/* 713:358 */
		[3188956.26, 9416087.10],
		[3189552.82, 9439107.49],
		[3212579.17, 9438470.52],
		[3211908.02, 9415454.73],
		[3188956.26, 9416087.10],
	]], [[	/* 713:359 */
		[3211908.02, 9415454.73],
		[3212579.17, 9438470.52],
		[3235600.63, 9437758.62],
		[3234854.93, 9414747.97],
		[3211908.02, 9415454.73],
	]], [[	/* 713:360 */
		[3234854.93, 9414747.97],
		[3235600.63, 9437758.62],
		[3258616.66, 9436971.84],
		[3257796.47, 9413966.86],
		[3234854.93, 9414747.97],
	]], [[	/* 713:361 */
		[3257796.47, 9413966.86],
		[3258616.66, 9436971.84],
		[3281626.71, 9436110.23],
		[3280732.09, 9413111.46],
		[3257796.47, 9413966.86],
	]], [[	/* 713:362 */
		[3280732.09, 9413111.46],
		[3281626.71, 9436110.23],
		[3304630.25, 9435173.87],
		[3303661.27, 9412181.85],
		[3280732.09, 9413111.46],
	]], [[	/* 713:363 */
		[3303661.27, 9412181.85],
		[3304630.25, 9435173.87],
		[3327626.73, 9434162.82],
		[3326583.47, 9411178.09],
		[3303661.27, 9412181.85],
	]], [[	/* 713:364 */
		[3326583.47, 9411178.09],
		[3327626.73, 9434162.82],
		[3350615.62, 9433077.16],
		[3349498.15, 9410100.25],
		[3326583.47, 9411178.09],
	]], [[	/* 713:365 */
		[3349498.15, 9410100.25],
		[3350615.62, 9433077.16],
		[3373596.39, 9431916.97],
		[3372404.79, 9408948.41],
		[3349498.15, 9410100.25],
	]], [[	/* 713:366 */
		[3372404.79, 9408948.41],
		[3373596.39, 9431916.97],
		[3396568.49, 9430682.34],
		[3395302.86, 9407722.67],
		[3372404.79, 9408948.41],
	]], [[	/* 713:367 */
		[3395302.86, 9407722.67],
		[3396568.49, 9430682.34],
		[3419531.39, 9429373.36],
		[3418191.82, 9406423.10],
		[3395302.86, 9407722.67],
	]], [[	/* 714:332 */
		[2590933.91, 9429324.42],
		[2589581.91, 9452348.41],
		[2612618.96, 9453669.63],
		[2613896.50, 9430636.10],
		[2590933.91, 9429324.42],
	]], [[	/* 714:333 */
		[2613896.50, 9430636.10],
		[2612618.96, 9453669.63],
		[2635665.33, 9454915.96],
		[2636868.30, 9431873.44],
		[2613896.50, 9430636.10],
	]], [[	/* 714:335 */
		[2659848.79, 9433036.33],
		[2658720.47, 9456087.32],
		[2681783.85, 9457183.61],
		[2682837.42, 9434124.70],
		[2659848.79, 9433036.33],
	]], [[	/* 714:336 */
		[2682837.42, 9434124.70],
		[2681783.85, 9457183.61],
		[2704854.91, 9458204.75],
		[2705833.66, 9435138.47],
		[2682837.42, 9434124.70],
	]], [[	/* 714:337 */
		[2705833.66, 9435138.47],
		[2704854.91, 9458204.75],
		[2727933.12, 9459150.66],
		[2728836.97, 9436077.54],
		[2705833.66, 9435138.47],
	]], [[	/* 714:338 */
		[2728836.97, 9436077.54],
		[2727933.12, 9459150.66],
		[2751017.93, 9460021.28],
		[2751846.82, 9436941.87],
		[2728836.97, 9436077.54],
	]], [[	/* 714:339 */
		[2751846.82, 9436941.87],
		[2751017.93, 9460021.28],
		[2774108.80, 9460816.54],
		[2774862.66, 9437731.37],
		[2751846.82, 9436941.87],
	]], [[	/* 714:340 */
		[2774862.66, 9437731.37],
		[2774108.80, 9460816.54],
		[2797205.17, 9461536.36],
		[2797883.94, 9438445.99],
		[2774862.66, 9437731.37],
	]], [[	/* 714:341 */
		[2797883.94, 9438445.99],
		[2797205.17, 9461536.36],
		[2820306.50, 9462180.71],
		[2820910.14, 9439085.68],
		[2797883.94, 9438445.99],
	]], [[	/* 714:342 */
		[2820910.14, 9439085.68],
		[2820306.50, 9462180.71],
		[2843412.25, 9462749.54],
		[2843940.70, 9439650.38],
		[2820910.14, 9439085.68],
	]], [[	/* 714:343 */
		[2843940.70, 9439650.38],
		[2843412.25, 9462749.54],
		[2866521.86, 9463242.78],
		[2866975.08, 9440140.06],
		[2843940.70, 9439650.38],
	]], [[	/* 714:344 */
		[2866975.08, 9440140.06],
		[2866521.86, 9463242.78],
		[2889634.78, 9463660.42],
		[2890012.75, 9440554.68],
		[2866975.08, 9440140.06],
	]], [[	/* 714:345 */
		[2890012.75, 9440554.68],
		[2889634.78, 9463660.42],
		[2912750.46, 9464002.42],
		[2913053.15, 9440894.20],
		[2890012.75, 9440554.68],
	]], [[	/* 714:346 */
		[2913053.15, 9440894.20],
		[2912750.46, 9464002.42],
		[2935868.36, 9464268.75],
		[2936095.74, 9441158.60],
		[2913053.15, 9440894.20],
	]], [[	/* 714:347 */
		[2936095.74, 9441158.60],
		[2935868.36, 9464268.75],
		[2958987.92, 9464459.40],
		[2959139.97, 9441347.87],
		[2936095.74, 9441158.60],
	]], [[	/* 714:348 */
		[2959139.97, 9441347.87],
		[2958987.92, 9464459.40],
		[2982108.59, 9464574.34],
		[2982185.30, 9441461.98],
		[2959139.97, 9441347.87],
	]], [[	/* 714:349 */
		[2982185.30, 9441461.98],
		[2982108.59, 9464574.34],
		[3005229.82, 9464613.57],
		[3005231.19, 9441500.92],
		[2982185.30, 9441461.98],
	]], [[	/* 714:350 */
		[3005231.19, 9441500.92],
		[3005229.82, 9464613.57],
		[3028351.07, 9464577.09],
		[3028277.09, 9441464.70],
		[3005231.19, 9441500.92],
	]], [[	/* 714:351 */
		[3028277.09, 9441464.70],
		[3028351.07, 9464577.09],
		[3051471.76, 9464464.89],
		[3051322.45, 9441353.32],
		[3028277.09, 9441464.70],
	]], [[	/* 714:352 */
		[3051322.45, 9441353.32],
		[3051471.76, 9464464.89],
		[3074591.37, 9464276.99],
		[3074366.73, 9441166.79],
		[3051322.45, 9441353.32],
	]], [[	/* 714:353 */
		[3074366.73, 9441166.79],
		[3074591.37, 9464276.99],
		[3097709.33, 9464013.41],
		[3097409.38, 9440905.11],
		[3074366.73, 9441166.79],
	]], [[	/* 714:354 */
		[3097409.38, 9440905.11],
		[3097709.33, 9464013.41],
		[3120825.10, 9463674.16],
		[3120449.86, 9440568.32],
		[3097409.38, 9440905.11],
	]], [[	/* 714:355 */
		[3120449.86, 9440568.32],
		[3120825.10, 9463674.16],
		[3143938.12, 9463259.26],
		[3143487.62, 9440156.43],
		[3120449.86, 9440568.32],
	]], [[	/* 714:356 */
		[3143487.62, 9440156.43],
		[3143938.12, 9463259.26],
		[3167047.85, 9462768.75],
		[3166522.12, 9439669.47],
		[3143487.62, 9440156.43],
	]], [[	/* 714:357 */
		[3166522.12, 9439669.47],
		[3167047.85, 9462768.75],
		[3190153.73, 9462202.67],
		[3189552.82, 9439107.49],
		[3166522.12, 9439669.47],
	]], [[	/* 714:358 */
		[3189552.82, 9439107.49],
		[3190153.73, 9462202.67],
		[3213255.22, 9461561.06],
		[3212579.17, 9438470.52],
		[3189552.82, 9439107.49],
	]], [[	/* 714:359 */
		[3212579.17, 9438470.52],
		[3213255.22, 9461561.06],
		[3236351.76, 9460843.97],
		[3235600.63, 9437758.62],
		[3212579.17, 9438470.52],
	]], [[	/* 714:360 */
		[3235600.63, 9437758.62],
		[3236351.76, 9460843.97],
		[3259442.82, 9460051.46],
		[3258616.66, 9436971.84],
		[3235600.63, 9437758.62],
	]], [[	/* 714:361 */
		[3258616.66, 9436971.84],
		[3259442.82, 9460051.46],
		[3282527.84, 9459183.57],
		[3281626.71, 9436110.23],
		[3258616.66, 9436971.84],
	]], [[	/* 714:362 */
		[3281626.71, 9436110.23],
		[3282527.84, 9459183.57],
		[3305606.27, 9458240.39],
		[3304630.25, 9435173.87],
		[3281626.71, 9436110.23],
	]], [[	/* 714:363 */
		[3304630.25, 9435173.87],
		[3305606.27, 9458240.39],
		[3328677.58, 9457221.98],
		[3327626.73, 9434162.82],
		[3304630.25, 9435173.87],
	]], [[	/* 714:364 */
		[3327626.73, 9434162.82],
		[3328677.58, 9457221.98],
		[3351741.22, 9456128.41],
		[3350615.62, 9433077.16],
		[3327626.73, 9434162.82],
	]], [[	/* 714:365 */
		[3350615.62, 9433077.16],
		[3351741.22, 9456128.41],
		[3374796.65, 9454959.78],
		[3373596.39, 9431916.97],
		[3350615.62, 9433077.16],
	]], [[	/* 715:335 */
		[2658720.47, 9456087.32],
		[2657583.93, 9479213.18],
		[2680722.59, 9480317.47],
		[2681783.85, 9457183.61],
		[2658720.47, 9456087.32],
	]], [[	/* 715:336 */
		[2681783.85, 9457183.61],
		[2680722.59, 9480317.47],
		[2703869.02, 9481346.07],
		[2704854.91, 9458204.75],
		[2681783.85, 9457183.61],
	]], [[	/* 715:337 */
		[2704854.91, 9458204.75],
		[2703869.02, 9481346.07],
		[2727022.67, 9482298.89],
		[2727933.12, 9459150.66],
		[2704854.91, 9458204.75],
	]], [[	/* 715:338 */
		[2727933.12, 9459150.66],
		[2727022.67, 9482298.89],
		[2750182.99, 9483175.87],
		[2751017.93, 9460021.28],
		[2727933.12, 9459150.66],
	]], [[	/* 715:339 */
		[2751017.93, 9460021.28],
		[2750182.99, 9483175.87],
		[2773349.43, 9483976.94],
		[2774108.80, 9460816.54],
		[2751017.93, 9460021.28],
	]], [[	/* 715:340 */
		[2774108.80, 9460816.54],
		[2773349.43, 9483976.94],
		[2796521.44, 9484702.03],
		[2797205.17, 9461536.36],
		[2774108.80, 9460816.54],
	]], [[	/* 715:341 */
		[2797205.17, 9461536.36],
		[2796521.44, 9484702.03],
		[2819698.46, 9485351.09],
		[2820306.50, 9462180.71],
		[2797205.17, 9461536.36],
	]], [[	/* 715:342 */
		[2820306.50, 9462180.71],
		[2819698.46, 9485351.09],
		[2842879.93, 9485924.07],
		[2843412.25, 9462749.54],
		[2820306.50, 9462180.71],
	]], [[	/* 715:343 */
		[2843412.25, 9462749.54],
		[2842879.93, 9485924.07],
		[2866065.31, 9486420.93],
		[2866521.86, 9463242.78],
		[2843412.25, 9462749.54],
	]], [[	/* 715:344 */
		[2866521.86, 9463242.78],
		[2866065.31, 9486420.93],
		[2889254.04, 9486841.63],
		[2889634.78, 9463660.42],
		[2866521.86, 9463242.78],
	]], [[	/* 715:345 */
		[2889634.78, 9463660.42],
		[2889254.04, 9486841.63],
		[2912445.56, 9487186.13],
		[2912750.46, 9464002.42],
		[2889634.78, 9463660.42],
	]], [[	/* 715:346 */
		[2912750.46, 9464002.42],
		[2912445.56, 9487186.13],
		[2935639.32, 9487454.41],
		[2935868.36, 9464268.75],
		[2912750.46, 9464002.42],
	]], [[	/* 715:347 */
		[2935868.36, 9464268.75],
		[2935639.32, 9487454.41],
		[2958834.76, 9487646.44],
		[2958987.92, 9464459.40],
		[2935868.36, 9464268.75],
	]], [[	/* 715:348 */
		[2958987.92, 9464459.40],
		[2958834.76, 9487646.44],
		[2982031.32, 9487762.23],
		[2982108.59, 9464574.34],
		[2958987.92, 9464459.40],
	]], [[	/* 715:349 */
		[2982108.59, 9464574.34],
		[2982031.32, 9487762.23],
		[3005228.45, 9487801.74],
		[3005229.82, 9464613.57],
		[2982108.59, 9464574.34],
	]], [[	/* 715:350 */
		[3005229.82, 9464613.57],
		[3005228.45, 9487801.74],
		[3028425.58, 9487764.99],
		[3028351.07, 9464577.09],
		[3005229.82, 9464613.57],
	]], [[	/* 715:351 */
		[3028351.07, 9464577.09],
		[3028425.58, 9487764.99],
		[3051622.17, 9487651.97],
		[3051471.76, 9464464.89],
		[3028351.07, 9464577.09],
	]], [[	/* 715:352 */
		[3051471.76, 9464464.89],
		[3051622.17, 9487651.97],
		[3074817.66, 9487462.70],
		[3074591.37, 9464276.99],
		[3051471.76, 9464464.89],
	]], [[	/* 715:353 */
		[3074591.37, 9464276.99],
		[3074817.66, 9487462.70],
		[3098011.48, 9487197.19],
		[3097709.33, 9464013.41],
		[3074591.37, 9464276.99],
	]], [[	/* 715:354 */
		[3097709.33, 9464013.41],
		[3098011.48, 9487197.19],
		[3121203.08, 9486855.45],
		[3120825.10, 9463674.16],
		[3097709.33, 9464013.41],
	]], [[	/* 715:355 */
		[3120825.10, 9463674.16],
		[3121203.08, 9486855.45],
		[3144391.91, 9486437.52],
		[3143938.12, 9463259.26],
		[3120825.10, 9463674.16],
	]], [[	/* 715:356 */
		[3143938.12, 9463259.26],
		[3144391.91, 9486437.52],
		[3167577.41, 9485943.42],
		[3167047.85, 9462768.75],
		[3143938.12, 9463259.26],
	]], [[	/* 715:357 */
		[3167047.85, 9462768.75],
		[3167577.41, 9485943.42],
		[3190759.03, 9485373.20],
		[3190153.73, 9462202.67],
		[3167047.85, 9462768.75],
	]], [[	/* 715:358 */
		[3190153.73, 9462202.67],
		[3190759.03, 9485373.20],
		[3213936.20, 9484726.90],
		[3213255.22, 9461561.06],
		[3190153.73, 9462202.67],
	]], [[	/* 715:359 */
		[3213255.22, 9461561.06],
		[3213936.20, 9484726.90],
		[3237108.38, 9484004.56],
		[3236351.76, 9460843.97],
		[3213255.22, 9461561.06],
	]], [[	/* 715:360 */
		[3236351.76, 9460843.97],
		[3237108.38, 9484004.56],
		[3260275.02, 9483206.25],
		[3259442.82, 9460051.46],
		[3236351.76, 9460843.97],
	]], [[	/* 715:361 */
		[3259442.82, 9460051.46],
		[3260275.02, 9483206.25],
		[3283435.55, 9482332.02],
		[3282527.84, 9459183.57],
		[3259442.82, 9460051.46],
	]], [[	/* 715:362 */
		[3282527.84, 9459183.57],
		[3283435.55, 9482332.02],
		[3306589.43, 9481381.95],
		[3305606.27, 9458240.39],
		[3282527.84, 9459183.57],
	]], [[	/* 715:363 */
		[3305606.27, 9458240.39],
		[3306589.43, 9481381.95],
		[3329736.11, 9480356.10],
		[3328677.58, 9457221.98],
		[3305606.27, 9458240.39],
	]], [[	/* 715:364 */
		[3328677.58, 9457221.98],
		[3329736.11, 9480356.10],
		[3352875.04, 9479254.55],
		[3351741.22, 9456128.41],
		[3328677.58, 9457221.98],
	]], [[	/* 716:336 */
		[2680722.59, 9480317.47],
		[2679653.56, 9503526.84],
		[2702875.91, 9504562.97],
		[2703869.02, 9481346.07],
		[2680722.59, 9480317.47],
	]], [[	/* 716:337 */
		[2703869.02, 9481346.07],
		[2702875.91, 9504562.97],
		[2726105.55, 9505522.78],
		[2727022.67, 9482298.89],
		[2703869.02, 9481346.07],
	]], [[	/* 716:338 */
		[2727022.67, 9482298.89],
		[2726105.55, 9505522.78],
		[2749341.94, 9506406.19],
		[2750182.99, 9483175.87],
		[2727022.67, 9482298.89],
	]], [[	/* 716:339 */
		[2750182.99, 9483175.87],
		[2749341.94, 9506406.19],
		[2772584.50, 9507213.13],
		[2773349.43, 9483976.94],
		[2750182.99, 9483175.87],
	]], [[	/* 716:340 */
		[2773349.43, 9483976.94],
		[2772584.50, 9507213.13],
		[2795832.69, 9507943.54],
		[2796521.44, 9484702.03],
		[2773349.43, 9483976.94],
	]], [[	/* 716:341 */
		[2796521.44, 9484702.03],
		[2795832.69, 9507943.54],
		[2819085.95, 9508597.36],
		[2819698.46, 9485351.09],
		[2796521.44, 9484702.03],
	]], [[	/* 716:342 */
		[2819698.46, 9485351.09],
		[2819085.95, 9508597.36],
		[2842343.71, 9509174.55],
		[2842879.93, 9485924.07],
		[2819698.46, 9485351.09],
	]], [[	/* 716:343 */
		[2842879.93, 9485924.07],
		[2842343.71, 9509174.55],
		[2865605.42, 9509675.05],
		[2866065.31, 9486420.93],
		[2842879.93, 9485924.07],
	]], [[	/* 716:344 */
		[2866065.31, 9486420.93],
		[2865605.42, 9509675.05],
		[2888870.51, 9510098.83],
		[2889254.04, 9486841.63],
		[2866065.31, 9486420.93],
	]], [[	/* 716:345 */
		[2889254.04, 9486841.63],
		[2888870.51, 9510098.83],
		[2912138.43, 9510445.86],
		[2912445.56, 9487186.13],
		[2889254.04, 9486841.63],
	]], [[	/* 716:346 */
		[2912445.56, 9487186.13],
		[2912138.43, 9510445.86],
		[2935408.60, 9510716.11],
		[2935639.32, 9487454.41],
		[2912445.56, 9487186.13],
	]], [[	/* 716:347 */
		[2935639.32, 9487454.41],
		[2935408.60, 9510716.11],
		[2958680.47, 9510909.56],
		[2958834.76, 9487646.44],
		[2935639.32, 9487454.41],
	]], [[	/* 716:348 */
		[2958834.76, 9487646.44],
		[2958680.47, 9510909.56],
		[2981953.48, 9511026.19],
		[2982031.32, 9487762.23],
		[2958834.76, 9487646.44],
	]], [[	/* 716:349 */
		[2982031.32, 9487762.23],
		[2981953.48, 9511026.19],
		[3005227.06, 9511065.99],
		[3005228.45, 9487801.74],
		[2982031.32, 9487762.23],
	]], [[	/* 716:350 */
		[3005228.45, 9487801.74],
		[3005227.06, 9511065.99],
		[3028500.65, 9511028.97],
		[3028425.58, 9487764.99],
		[3005228.45, 9487801.74],
	]], [[	/* 716:351 */
		[3028425.58, 9487764.99],
		[3028500.65, 9511028.97],
		[3051773.69, 9510915.12],
		[3051622.17, 9487651.97],
		[3028425.58, 9487764.99],
	]], [[	/* 716:352 */
		[3051622.17, 9487651.97],
		[3051773.69, 9510915.12],
		[3075045.60, 9510724.46],
		[3074817.66, 9487462.70],
		[3051622.17, 9487651.97],
	]], [[	/* 716:353 */
		[3074817.66, 9487462.70],
		[3075045.60, 9510724.46],
		[3098315.84, 9510456.99],
		[3098011.48, 9487197.19],
		[3074817.66, 9487462.70],
	]], [[	/* 716:354 */
		[3098011.48, 9487197.19],
		[3098315.84, 9510456.99],
		[3121583.84, 9510112.75],
		[3121203.08, 9486855.45],
		[3098011.48, 9487197.19],
	]], [[	/* 716:355 */
		[3121203.08, 9486855.45],
		[3121583.84, 9510112.75],
		[3144849.04, 9509691.75],
		[3144391.91, 9486437.52],
		[3121203.08, 9486855.45],
	]], [[	/* 716:356 */
		[3144391.91, 9486437.52],
		[3144849.04, 9509691.75],
		[3168110.87, 9509194.02],
		[3167577.41, 9485943.42],
		[3144391.91, 9486437.52],
	]], [[	/* 716:357 */
		[3167577.41, 9485943.42],
		[3168110.87, 9509194.02],
		[3191368.77, 9508619.62],
		[3190759.03, 9485373.20],
		[3167577.41, 9485943.42],
	]], [[	/* 716:358 */
		[3190759.03, 9485373.20],
		[3191368.77, 9508619.62],
		[3214622.18, 9507968.57],
		[3213936.20, 9484726.90],
		[3190759.03, 9485373.20],
	]], [[	/* 716:359 */
		[3213936.20, 9484726.90],
		[3214622.18, 9507968.57],
		[3237870.55, 9507240.94],
		[3237108.38, 9484004.56],
		[3213936.20, 9484726.90],
	]], [[	/* 716:360 */
		[3237108.38, 9484004.56],
		[3237870.55, 9507240.94],
		[3261113.32, 9506436.77],
		[3260275.02, 9483206.25],
		[3237108.38, 9484004.56],
	]], [[	/* 716:361 */
		[3260275.02, 9483206.25],
		[3261113.32, 9506436.77],
		[3284349.91, 9505556.13],
		[3283435.55, 9482332.02],
		[3260275.02, 9483206.25],
	]], [[	/* 716:362 */
		[3283435.55, 9482332.02],
		[3284349.91, 9505556.13],
		[3307579.79, 9504599.09],
		[3306589.43, 9481381.95],
		[3283435.55, 9482332.02],
	]], [[	/* 716:363 */
		[3306589.43, 9481381.95],
		[3307579.79, 9504599.09],
		[3330802.39, 9503565.72],
		[3329736.11, 9480356.10],
		[3306589.43, 9481381.95],
	]], [[	/* 716:364 */
		[3329736.11, 9480356.10],
		[3330802.39, 9503565.72],
		[3354017.15, 9502456.10],
		[3352875.04, 9479254.55],
		[3329736.11, 9480356.10],
	]], [[	/* 717:337 */
		[2702875.91, 9504562.97],
		[2701875.50, 9527856.02],
		[2725181.69, 9528822.88],
		[2726105.55, 9505522.78],
		[2702875.91, 9504562.97],
	]], [[	/* 717:338 */
		[2726105.55, 9505522.78],
		[2725181.69, 9528822.88],
		[2748494.69, 9529712.79],
		[2749341.94, 9506406.19],
		[2726105.55, 9505522.78],
	]], [[	/* 717:339 */
		[2749341.94, 9506406.19],
		[2748494.69, 9529712.79],
		[2771813.95, 9530525.66],
		[2772584.50, 9507213.13],
		[2749341.94, 9506406.19],
	]], [[	/* 717:340 */
		[2772584.50, 9507213.13],
		[2771813.95, 9530525.66],
		[2795138.88, 9531261.45],
		[2795832.69, 9507943.54],
		[2772584.50, 9507213.13],
	]], [[	/* 717:341 */
		[2795832.69, 9507943.54],
		[2795138.88, 9531261.45],
		[2818468.94, 9531920.08],
		[2819085.95, 9508597.36],
		[2795832.69, 9507943.54],
	]], [[	/* 717:342 */
		[2819085.95, 9508597.36],
		[2818468.94, 9531920.08],
		[2841803.55, 9532501.51],
		[2842343.71, 9509174.55],
		[2819085.95, 9508597.36],
	]], [[	/* 717:343 */
		[2842343.71, 9509174.55],
		[2841803.55, 9532501.51],
		[2865142.15, 9533005.70],
		[2865605.42, 9509675.05],
		[2842343.71, 9509174.55],
	]], [[	/* 717:344 */
		[2865605.42, 9509675.05],
		[2865142.15, 9533005.70],
		[2888484.16, 9533432.60],
		[2888870.51, 9510098.83],
		[2865605.42, 9509675.05],
	]], [[	/* 717:345 */
		[2888870.51, 9510098.83],
		[2888484.16, 9533432.60],
		[2911829.03, 9533782.19],
		[2912138.43, 9510445.86],
		[2888870.51, 9510098.83],
	]], [[	/* 717:346 */
		[2912138.43, 9510445.86],
		[2911829.03, 9533782.19],
		[2935176.19, 9534054.42],
		[2935408.60, 9510716.11],
		[2912138.43, 9510445.86],
	]], [[	/* 717:347 */
		[2935408.60, 9510716.11],
		[2935176.19, 9534054.42],
		[2958525.06, 9534249.30],
		[2958680.47, 9510909.56],
		[2935408.60, 9510716.11],
	]], [[	/* 717:348 */
		[2958680.47, 9510909.56],
		[2958525.06, 9534249.30],
		[2981875.07, 9534366.79],
		[2981953.48, 9511026.19],
		[2958680.47, 9510909.56],
	]], [[	/* 717:349 */
		[2981953.48, 9511026.19],
		[2981875.07, 9534366.79],
		[3005225.67, 9534406.88],
		[3005227.06, 9511065.99],
		[2981953.48, 9511026.19],
	]], [[	/* 717:350 */
		[3005227.06, 9511065.99],
		[3005225.67, 9534406.88],
		[3028576.27, 9534369.59],
		[3028500.65, 9511028.97],
		[3005227.06, 9511065.99],
	]], [[	/* 717:351 */
		[3028500.65, 9511028.97],
		[3028576.27, 9534369.59],
		[3051926.32, 9534254.90],
		[3051773.69, 9510915.12],
		[3028500.65, 9511028.97],
	]], [[	/* 717:352 */
		[3051773.69, 9510915.12],
		[3051926.32, 9534254.90],
		[3075275.23, 9534062.83],
		[3075045.60, 9510724.46],
		[3051773.69, 9510915.12],
	]], [[	/* 717:353 */
		[3075045.60, 9510724.46],
		[3075275.23, 9534062.83],
		[3098622.45, 9533793.40],
		[3098315.84, 9510456.99],
		[3075045.60, 9510724.46],
	]], [[	/* 717:354 */
		[3098315.84, 9510456.99],
		[3098622.45, 9533793.40],
		[3121967.41, 9533446.61],
		[3121583.84, 9510112.75],
		[3098315.84, 9510456.99],
	]], [[	/* 717:355 */
		[3121583.84, 9510112.75],
		[3121967.41, 9533446.61],
		[3145309.53, 9533022.51],
		[3144849.04, 9509691.75],
		[3121583.84, 9510112.75],
	]], [[	/* 717:356 */
		[3144849.04, 9509691.75],
		[3145309.53, 9533022.51],
		[3168648.25, 9532521.12],
		[3168110.87, 9509194.02],
		[3144849.04, 9509691.75],
	]], [[	/* 717:357 */
		[3168110.87, 9509194.02],
		[3168648.25, 9532521.12],
		[3191983.00, 9531942.48],
		[3191368.77, 9508619.62],
		[3168110.87, 9509194.02],
	]], [[	/* 717:358 */
		[3191368.77, 9508619.62],
		[3191983.00, 9531942.48],
		[3215313.21, 9531286.65],
		[3214622.18, 9507968.57],
		[3191368.77, 9508619.62],
	]], [[	/* 717:359 */
		[3214622.18, 9507968.57],
		[3215313.21, 9531286.65],
		[3238638.33, 9530553.66],
		[3237870.55, 9507240.94],
		[3214622.18, 9507968.57],
	]], [[	/* 717:360 */
		[3237870.55, 9507240.94],
		[3238638.33, 9530553.66],
		[3261957.78, 9529743.57],
		[3261113.32, 9506436.77],
		[3237870.55, 9507240.94],
	]], [[	/* 717:361 */
		[3261113.32, 9506436.77],
		[3261957.78, 9529743.57],
		[3285271.00, 9528856.46],
		[3284349.91, 9505556.13],
		[3261113.32, 9506436.77],
	]], [[	/* 717:362 */
		[3284349.91, 9505556.13],
		[3285271.00, 9528856.46],
		[3308577.43, 9527892.38],
		[3307579.79, 9504599.09],
		[3284349.91, 9505556.13],
	]], [[	/* 717:363 */
		[3307579.79, 9504599.09],
		[3308577.43, 9527892.38],
		[3331876.50, 9526851.41],
		[3330802.39, 9503565.72],
		[3307579.79, 9504599.09],
	]], [[	/* 717:364 */
		[3330802.39, 9503565.72],
		[3331876.50, 9526851.41],
		[3355167.65, 9525733.64],
		[3354017.15, 9502456.10],
		[3330802.39, 9503565.72],
	]], [[	/* 718:337 */
		[2701875.50, 9527856.02],
		[2700867.71, 9551225.75],
		[2724251.02, 9552199.75],
		[2725181.69, 9528822.88],
		[2701875.50, 9527856.02],
	]], [[	/* 718:338 */
		[2725181.69, 9528822.88],
		[2724251.02, 9552199.75],
		[2747641.20, 9553096.22],
		[2748494.69, 9529712.79],
		[2725181.69, 9528822.88],
	]], [[	/* 718:339 */
		[2748494.69, 9529712.79],
		[2747641.20, 9553096.22],
		[2771037.71, 9553915.10],
		[2771813.95, 9530525.66],
		[2748494.69, 9529712.79],
	]], [[	/* 718:340 */
		[2771813.95, 9530525.66],
		[2771037.71, 9553915.10],
		[2794439.95, 9554656.31],
		[2795138.88, 9531261.45],
		[2771813.95, 9530525.66],
	]], [[	/* 718:341 */
		[2795138.88, 9531261.45],
		[2794439.95, 9554656.31],
		[2817847.38, 9555319.81],
		[2818468.94, 9531920.08],
		[2795138.88, 9531261.45],
	]], [[	/* 718:342 */
		[2818468.94, 9531920.08],
		[2817847.38, 9555319.81],
		[2841259.40, 9555905.54],
		[2841803.55, 9532501.51],
		[2818468.94, 9531920.08],
	]], [[	/* 718:343 */
		[2841803.55, 9532501.51],
		[2841259.40, 9555905.54],
		[2864675.45, 9556413.45],
		[2865142.15, 9533005.70],
		[2841803.55, 9532501.51],
	]], [[	/* 718:344 */
		[2865142.15, 9533005.70],
		[2864675.45, 9556413.45],
		[2888094.96, 9556843.50],
		[2888484.16, 9533432.60],
		[2865142.15, 9533005.70],
	]], [[	/* 718:345 */
		[2888484.16, 9533432.60],
		[2888094.96, 9556843.50],
		[2911517.35, 9557195.67],
		[2911829.03, 9533782.19],
		[2888484.16, 9533432.60],
	]], [[	/* 718:346 */
		[2911829.03, 9533782.19],
		[2911517.35, 9557195.67],
		[2934942.05, 9557469.92],
		[2935176.19, 9534054.42],
		[2911829.03, 9533782.19],
	]], [[	/* 718:347 */
		[2935176.19, 9534054.42],
		[2934942.05, 9557469.92],
		[2958368.49, 9557666.23],
		[2958525.06, 9534249.30],
		[2935176.19, 9534054.42],
	]], [[	/* 718:348 */
		[2958525.06, 9534249.30],
		[2958368.49, 9557666.23],
		[2981796.08, 9557784.59],
		[2981875.07, 9534366.79],
		[2958525.06, 9534249.30],
	]], [[	/* 718:349 */
		[2981875.07, 9534366.79],
		[2981796.08, 9557784.59],
		[3005224.26, 9557824.98],
		[3005225.67, 9534406.88],
		[2981875.07, 9534366.79],
	]], [[	/* 718:350 */
		[3005225.67, 9534406.88],
		[3005224.26, 9557824.98],
		[3028652.45, 9557787.41],
		[3028576.27, 9534369.59],
		[3005225.67, 9534406.88],
	]], [[	/* 718:351 */
		[3028576.27, 9534369.59],
		[3028652.45, 9557787.41],
		[3052080.07, 9557671.87],
		[3051926.32, 9534254.90],
		[3028576.27, 9534369.59],
	]], [[	/* 718:352 */
		[3051926.32, 9534254.90],
		[3052080.07, 9557671.87],
		[3075506.56, 9557478.38],
		[3075275.23, 9534062.83],
		[3051926.32, 9534254.90],
	]], [[	/* 718:353 */
		[3075275.23, 9534062.83],
		[3075506.56, 9557478.38],
		[3098931.32, 9557206.95],
		[3098622.45, 9533793.40],
		[3075275.23, 9534062.83],
	]], [[	/* 718:354 */
		[3098622.45, 9533793.40],
		[3098931.32, 9557206.95],
		[3122353.80, 9556857.61],
		[3121967.41, 9533446.61],
		[3098622.45, 9533793.40],
	]], [[	/* 718:355 */
		[3121967.41, 9533446.61],
		[3122353.80, 9556857.61],
		[3145773.42, 9556430.37],
		[3145309.53, 9533022.51],
		[3121967.41, 9533446.61],
	]], [[	/* 718:356 */
		[3145309.53, 9533022.51],
		[3145773.42, 9556430.37],
		[3169189.59, 9555925.28],
		[3168648.25, 9532521.12],
		[3145309.53, 9533022.51],
	]], [[	/* 718:357 */
		[3168648.25, 9532521.12],
		[3169189.59, 9555925.28],
		[3192601.76, 9555342.37],
		[3191983.00, 9531942.48],
		[3168648.25, 9532521.12],
	]], [[	/* 718:358 */
		[3191983.00, 9531942.48],
		[3192601.76, 9555342.37],
		[3216009.34, 9554681.68],
		[3215313.21, 9531286.65],
		[3191983.00, 9531942.48],
	]], [[	/* 718:359 */
		[3215313.21, 9531286.65],
		[3216009.34, 9554681.68],
		[3239411.77, 9553943.28],
		[3238638.33, 9530553.66],
		[3215313.21, 9531286.65],
	]], [[	/* 718:360 */
		[3238638.33, 9530553.66],
		[3239411.77, 9553943.28],
		[3262808.47, 9553127.22],
		[3261957.78, 9529743.57],
		[3238638.33, 9530553.66],
	]], [[	/* 718:361 */
		[3261957.78, 9529743.57],
		[3262808.47, 9553127.22],
		[3286198.88, 9552233.55],
		[3285271.00, 9528856.46],
		[3261957.78, 9529743.57],
	]], [[	/* 718:362 */
		[3285271.00, 9528856.46],
		[3286198.88, 9552233.55],
		[3309582.42, 9551262.36],
		[3308577.43, 9527892.38],
		[3285271.00, 9528856.46],
	]], [[	/* 718:363 */
		[3308577.43, 9527892.38],
		[3309582.42, 9551262.36],
		[3332958.53, 9550213.72],
		[3331876.50, 9526851.41],
		[3308577.43, 9527892.38],
	]], [[	/* 718:364 */
		[3331876.50, 9526851.41],
		[3332958.53, 9550213.72],
		[3356326.63, 9549087.70],
		[3355167.65, 9525733.64],
		[3331876.50, 9526851.41],
	]], [[	/* 719:338 */
		[2724251.02, 9552199.75],
		[2723313.46, 9575653.96],
		[2746781.40, 9576557.07],
		[2747641.20, 9553096.22],
		[2724251.02, 9552199.75],
	]], [[	/* 719:339 */
		[2747641.20, 9553096.22],
		[2746781.40, 9576557.07],
		[2770255.72, 9577382.00],
		[2771037.71, 9553915.10],
		[2747641.20, 9553096.22],
	]], [[	/* 719:340 */
		[2771037.71, 9553915.10],
		[2770255.72, 9577382.00],
		[2793735.85, 9578128.71],
		[2794439.95, 9554656.31],
		[2771037.71, 9553915.10],
	]], [[	/* 719:341 */
		[2794439.95, 9554656.31],
		[2793735.85, 9578128.71],
		[2817221.21, 9578797.12],
		[2817847.38, 9555319.81],
		[2794439.95, 9554656.31],
	]], [[	/* 719:342 */
		[2817847.38, 9555319.81],
		[2817221.21, 9578797.12],
		[2840711.22, 9579387.19],
		[2841259.40, 9555905.54],
		[2817847.38, 9555319.81],
	]], [[	/* 719:343 */
		[2841259.40, 9555905.54],
		[2840711.22, 9579387.19],
		[2864205.30, 9579898.86],
		[2864675.45, 9556413.45],
		[2841259.40, 9555905.54],
	]], [[	/* 719:344 */
		[2864675.45, 9556413.45],
		[2864205.30, 9579898.86],
		[2887702.88, 9580332.10],
		[2888094.96, 9556843.50],
		[2864675.45, 9556413.45],
	]], [[	/* 719:345 */
		[2888094.96, 9556843.50],
		[2887702.88, 9580332.10],
		[2911203.37, 9580686.88],
		[2911517.35, 9557195.67],
		[2888094.96, 9556843.50],
	]], [[	/* 719:346 */
		[2911517.35, 9557195.67],
		[2911203.37, 9580686.88],
		[2934706.19, 9580963.16],
		[2934942.05, 9557469.92],
		[2911517.35, 9557195.67],
	]], [[	/* 719:347 */
		[2934942.05, 9557469.92],
		[2934706.19, 9580963.16],
		[2958210.76, 9581160.93],
		[2958368.49, 9557666.23],
		[2934942.05, 9557469.92],
	]], [[	/* 719:348 */
		[2958368.49, 9557666.23],
		[2958210.76, 9581160.93],
		[2981716.51, 9581280.16],
		[2981796.08, 9557784.59],
		[2958368.49, 9557666.23],
	]], [[	/* 719:349 */
		[2981796.08, 9557784.59],
		[2981716.51, 9581280.16],
		[3005222.85, 9581320.85],
		[3005224.26, 9557824.98],
		[2981796.08, 9557784.59],
	]], [[	/* 719:350 */
		[3005224.26, 9557824.98],
		[3005222.85, 9581320.85],
		[3028729.20, 9581283.00],
		[3028652.45, 9557787.41],
		[3005224.26, 9557824.98],
	]], [[	/* 719:351 */
		[3028652.45, 9557787.41],
		[3028729.20, 9581283.00],
		[3052234.97, 9581166.61],
		[3052080.07, 9557671.87],
		[3028652.45, 9557787.41],
	]], [[	/* 719:352 */
		[3052080.07, 9557671.87],
		[3052234.97, 9581166.61],
		[3075739.60, 9580971.68],
		[3075506.56, 9557478.38],
		[3052080.07, 9557671.87],
	]], [[	/* 719:353 */
		[3075506.56, 9557478.38],
		[3075739.60, 9580971.68],
		[3099242.49, 9580698.24],
		[3098931.32, 9557206.95],
		[3075506.56, 9557478.38],
	]], [[	/* 719:354 */
		[3098931.32, 9557206.95],
		[3099242.49, 9580698.24],
		[3122743.06, 9580346.30],
		[3122353.80, 9556857.61],
		[3098931.32, 9557206.95],
	]], [[	/* 719:355 */
		[3122353.80, 9556857.61],
		[3122743.06, 9580346.30],
		[3146240.74, 9579915.90],
		[3145773.42, 9556430.37],
		[3122353.80, 9556857.61],
	]], [[	/* 719:356 */
		[3145773.42, 9556430.37],
		[3146240.74, 9579915.90],
		[3169734.95, 9579407.06],
		[3169189.59, 9555925.28],
		[3145773.42, 9556430.37],
	]], [[	/* 719:357 */
		[3169189.59, 9555925.28],
		[3169734.95, 9579407.06],
		[3193225.10, 9578819.83],
		[3192601.76, 9555342.37],
		[3169189.59, 9555925.28],
	]], [[	/* 719:358 */
		[3192601.76, 9555342.37],
		[3193225.10, 9578819.83],
		[3216710.63, 9578154.25],
		[3216009.34, 9554681.68],
		[3192601.76, 9555342.37],
	]], [[	/* 719:359 */
		[3216009.34, 9554681.68],
		[3216710.63, 9578154.25],
		[3240190.94, 9577410.38],
		[3239411.77, 9553943.28],
		[3216009.34, 9554681.68],
	]], [[	/* 719:360 */
		[3239411.77, 9553943.28],
		[3240190.94, 9577410.38],
		[3263665.46, 9576588.27],
		[3262808.47, 9553127.22],
		[3239411.77, 9553943.28],
	]], [[	/* 719:361 */
		[3262808.47, 9553127.22],
		[3263665.46, 9576588.27],
		[3287133.62, 9575687.99],
		[3286198.88, 9552233.55],
		[3262808.47, 9553127.22],
	]], [[	/* 719:362 */
		[3286198.88, 9552233.55],
		[3287133.62, 9575687.99],
		[3310594.85, 9574709.61],
		[3309582.42, 9551262.36],
		[3286198.88, 9552233.55],
	]], [[	/* 719:363 */
		[3309582.42, 9551262.36],
		[3310594.85, 9574709.61],
		[3334048.56, 9573653.20],
		[3332958.53, 9550213.72],
		[3309582.42, 9551262.36],
	]], [[	/* 719:364 */
		[3332958.53, 9550213.72],
		[3334048.56, 9573653.20],
		[3357494.18, 9572518.86],
		[3356326.63, 9549087.70],
		[3332958.53, 9550213.72],
	]], [[	/* 720:338 */
		[2723313.46, 9575653.96],
		[2722368.94, 9599186.07],
		[2745915.21, 9600095.89],
		[2746781.40, 9576557.07],
		[2723313.46, 9575653.96],
	]], [[	/* 720:339 */
		[2746781.40, 9576557.07],
		[2745915.21, 9600095.89],
		[2769467.93, 9600926.95],
		[2770255.72, 9577382.00],
		[2746781.40, 9576557.07],
	]], [[	/* 720:340 */
		[2770255.72, 9577382.00],
		[2769467.93, 9600926.95],
		[2793026.52, 9601679.21],
		[2793735.85, 9578128.71],
		[2770255.72, 9577382.00],
	]], [[	/* 720:341 */
		[2793735.85, 9578128.71],
		[2793026.52, 9601679.21],
		[2816590.39, 9602352.59],
		[2817221.21, 9578797.12],
		[2793735.85, 9578128.71],
	]], [[	/* 720:342 */
		[2817221.21, 9578797.12],
		[2816590.39, 9602352.59],
		[2840158.96, 9602947.04],
		[2840711.22, 9579387.19],
		[2817221.21, 9578797.12],
	]], [[	/* 720:343 */
		[2840711.22, 9579387.19],
		[2840158.96, 9602947.04],
		[2863731.66, 9603462.52],
		[2864205.30, 9579898.86],
		[2840711.22, 9579387.19],
	]], [[	/* 720:344 */
		[2864205.30, 9579898.86],
		[2863731.66, 9603462.52],
		[2887307.88, 9603898.98],
		[2887702.88, 9580332.10],
		[2864205.30, 9579898.86],
	]], [[	/* 720:345 */
		[2887702.88, 9580332.10],
		[2887307.88, 9603898.98],
		[2910887.04, 9604256.39],
		[2911203.37, 9580686.88],
		[2887702.88, 9580332.10],
	]], [[	/* 720:346 */
		[2911203.37, 9580686.88],
		[2910887.04, 9604256.39],
		[2934468.57, 9604534.73],
		[2934706.19, 9580963.16],
		[2911203.37, 9580686.88],
	]], [[	/* 720:347 */
		[2934706.19, 9580963.16],
		[2934468.57, 9604534.73],
		[2958051.87, 9604733.96],
		[2958210.76, 9581160.93],
		[2934706.19, 9580963.16],
	]], [[	/* 720:348 */
		[2958210.76, 9581160.93],
		[2958051.87, 9604733.96],
		[2981636.35, 9604854.08],
		[2981716.51, 9581280.16],
		[2958210.76, 9581160.93],
	]], [[	/* 720:349 */
		[2981716.51, 9581280.16],
		[2981636.35, 9604854.08],
		[3005221.43, 9604895.08],
		[3005222.85, 9581320.85],
		[2981716.51, 9581280.16],
	]], [[	/* 720:350 */
		[3005222.85, 9581320.85],
		[3005221.43, 9604895.08],
		[3028806.51, 9604856.94],
		[3028729.20, 9581283.00],
		[3005222.85, 9581320.85],
	]], [[	/* 720:351 */
		[3028729.20, 9581283.00],
		[3028806.51, 9604856.94],
		[3052391.02, 9604739.68],
		[3052234.97, 9581166.61],
		[3028729.20, 9581283.00],
	]], [[	/* 720:352 */
		[3052234.97, 9581166.61],
		[3052391.02, 9604739.68],
		[3075974.37, 9604543.31],
		[3075739.60, 9580971.68],
		[3052234.97, 9581166.61],
	]], [[	/* 720:353 */
		[3075739.60, 9580971.68],
		[3075974.37, 9604543.31],
		[3099555.96, 9604267.83],
		[3099242.49, 9580698.24],
		[3075739.60, 9580971.68],
	]], [[	/* 720:354 */
		[3099242.49, 9580698.24],
		[3099555.96, 9604267.83],
		[3123135.22, 9603913.28],
		[3122743.06, 9580346.30],
		[3099242.49, 9580698.24],
	]], [[	/* 720:355 */
		[3122743.06, 9580346.30],
		[3123135.22, 9603913.28],
		[3146711.54, 9603479.67],
		[3146240.74, 9579915.90],
		[3122743.06, 9580346.30],
	]], [[	/* 720:356 */
		[3146240.74, 9579915.90],
		[3146711.54, 9603479.67],
		[3170284.36, 9602967.05],
		[3169734.95, 9579407.06],
		[3146240.74, 9579915.90],
	]], [[	/* 720:357 */
		[3169734.95, 9579407.06],
		[3170284.36, 9602967.05],
		[3193853.08, 9602375.45],
		[3193225.10, 9578819.83],
		[3169734.95, 9579407.06],
	]], [[	/* 720:358 */
		[3193225.10, 9578819.83],
		[3193853.08, 9602375.45],
		[3217417.12, 9601704.92],
		[3216710.63, 9578154.25],
		[3193225.10, 9578819.83],
	]], [[	/* 720:359 */
		[3216710.63, 9578154.25],
		[3217417.12, 9601704.92],
		[3240975.89, 9600955.52],
		[3240190.94, 9577410.38],
		[3216710.63, 9578154.25],
	]], [[	/* 720:360 */
		[3240190.94, 9577410.38],
		[3240975.89, 9600955.52],
		[3264528.82, 9600127.30],
		[3263665.46, 9576588.27],
		[3240190.94, 9577410.38],
	]], [[	/* 720:361 */
		[3263665.46, 9576588.27],
		[3264528.82, 9600127.30],
		[3288075.31, 9599220.34],
		[3287133.62, 9575687.99],
		[3263665.46, 9576588.27],
	]], [[	/* 720:362 */
		[3287133.62, 9575687.99],
		[3288075.31, 9599220.34],
		[3311614.79, 9598234.69],
		[3310594.85, 9574709.61],
		[3287133.62, 9575687.99],
	]], [[	/* 721:338 */
		[2722368.94, 9599186.07],
		[2721417.39, 9622796.67],
		[2745042.57, 9623713.27],
		[2745915.21, 9600095.89],
		[2722368.94, 9599186.07],
	]], [[	/* 721:339 */
		[2745915.21, 9600095.89],
		[2745042.57, 9623713.27],
		[2768674.27, 9624550.53],
		[2769467.93, 9600926.95],
		[2745915.21, 9600095.89],
	]], [[	/* 721:340 */
		[2769467.93, 9600926.95],
		[2768674.27, 9624550.53],
		[2792311.90, 9625308.39],
		[2793026.52, 9601679.21],
		[2769467.93, 9600926.95],
	]], [[	/* 721:341 */
		[2793026.52, 9601679.21],
		[2792311.90, 9625308.39],
		[2815954.87, 9625986.79],
		[2816590.39, 9602352.59],
		[2793026.52, 9601679.21],
	]], [[	/* 721:342 */
		[2816590.39, 9602352.59],
		[2815954.87, 9625986.79],
		[2839602.59, 9626585.67],
		[2840158.96, 9602947.04],
		[2816590.39, 9602352.59],
	]], [[	/* 721:343 */
		[2840158.96, 9602947.04],
		[2839602.59, 9626585.67],
		[2863254.48, 9627105.00],
		[2863731.66, 9603462.52],
		[2840158.96, 9602947.04],
	]], [[	/* 721:344 */
		[2863731.66, 9603462.52],
		[2863254.48, 9627105.00],
		[2886909.93, 9627544.72],
		[2887307.88, 9603898.98],
		[2863731.66, 9603462.52],
	]], [[	/* 721:345 */
		[2887307.88, 9603898.98],
		[2886909.93, 9627544.72],
		[2910568.36, 9627904.80],
		[2910887.04, 9604256.39],
		[2887307.88, 9603898.98],
	]], [[	/* 721:346 */
		[2910887.04, 9604256.39],
		[2910568.36, 9627904.80],
		[2934229.18, 9628185.21],
		[2934468.57, 9604534.73],
		[2910887.04, 9604256.39],
	]], [[	/* 721:347 */
		[2934468.57, 9604534.73],
		[2934229.18, 9628185.21],
		[2957891.78, 9628385.93],
		[2958051.87, 9604733.96],
		[2934468.57, 9604534.73],
	]], [[	/* 721:348 */
		[2958051.87, 9604733.96],
		[2957891.78, 9628385.93],
		[2981555.59, 9628506.95],
		[2981636.35, 9604854.08],
		[2958051.87, 9604733.96],
	]], [[	/* 721:349 */
		[2981636.35, 9604854.08],
		[2981555.59, 9628506.95],
		[3005219.99, 9628548.25],
		[3005221.43, 9604895.08],
		[2981636.35, 9604854.08],
	]], [[	/* 721:350 */
		[3005221.43, 9604895.08],
		[3005219.99, 9628548.25],
		[3028884.41, 9628509.83],
		[3028806.51, 9604856.94],
		[3005221.43, 9604895.08],
	]], [[	/* 721:351 */
		[3028806.51, 9604856.94],
		[3028884.41, 9628509.83],
		[3052548.24, 9628391.69],
		[3052391.02, 9604739.68],
		[3028806.51, 9604856.94],
	]], [[	/* 721:352 */
		[3052391.02, 9604739.68],
		[3052548.24, 9628391.69],
		[3076210.89, 9628193.85],
		[3075974.37, 9604543.31],
		[3052391.02, 9604739.68],
	]], [[	/* 721:353 */
		[3075974.37, 9604543.31],
		[3076210.89, 9628193.85],
		[3099871.78, 9627916.31],
		[3099555.96, 9604267.83],
		[3075974.37, 9604543.31],
	]], [[	/* 721:354 */
		[3099555.96, 9604267.83],
		[3099871.78, 9627916.31],
		[3123530.30, 9627559.11],
		[3123135.22, 9603913.28],
		[3099555.96, 9604267.83],
	]], [[	/* 721:355 */
		[3123135.22, 9603913.28],
		[3123530.30, 9627559.11],
		[3147185.86, 9627122.27],
		[3146711.54, 9603479.67],
		[3123135.22, 9603913.28],
	]], [[	/* 721:356 */
		[3146711.54, 9603479.67],
		[3147185.86, 9627122.27],
		[3170837.87, 9626605.82],
		[3170284.36, 9602967.05],
		[3146711.54, 9603479.67],
	]], [[	/* 721:357 */
		[3170284.36, 9602967.05],
		[3170837.87, 9626605.82],
		[3194485.74, 9626009.81],
		[3193853.08, 9602375.45],
		[3170284.36, 9602967.05],
	]], [[	/* 721:358 */
		[3193853.08, 9602375.45],
		[3194485.74, 9626009.81],
		[3218128.88, 9625334.28],
		[3217417.12, 9601704.92],
		[3193853.08, 9602375.45],
	]], [[	/* 721:359 */
		[3217417.12, 9601704.92],
		[3218128.88, 9625334.28],
		[3241766.70, 9624579.29],
		[3240975.89, 9600955.52],
		[3217417.12, 9601704.92],
	]], [[	/* 721:360 */
		[3240975.89, 9600955.52],
		[3241766.70, 9624579.29],
		[3265398.60, 9623744.90],
		[3264528.82, 9600127.30],
		[3240975.89, 9600955.52],
	]], [[	/* 721:361 */
		[3264528.82, 9600127.30],
		[3265398.60, 9623744.90],
		[3289024.01, 9622831.17],
		[3288075.31, 9599220.34],
		[3264528.82, 9600127.30],
	]], [[	/* 721:362 */
		[3288075.31, 9599220.34],
		[3289024.01, 9622831.17],
		[3312642.32, 9621838.18],
		[3311614.79, 9598234.69],
		[3288075.31, 9599220.34],
	]], [[	/* 722:338 */
		[2721417.39, 9622796.67],
		[2720458.73, 9646486.35],
		[2744163.41, 9647409.79],
		[2745042.57, 9623713.27],
		[2721417.39, 9622796.67],
	]], [[	/* 722:339 */
		[2745042.57, 9623713.27],
		[2744163.41, 9647409.79],
		[2767874.68, 9648253.31],
		[2768674.27, 9624550.53],
		[2745042.57, 9623713.27],
	]], [[	/* 722:340 */
		[2768674.27, 9624550.53],
		[2767874.68, 9648253.31],
		[2791591.94, 9649016.84],
		[2792311.90, 9625308.39],
		[2768674.27, 9624550.53],
	]], [[	/* 722:341 */
		[2792311.90, 9625308.39],
		[2791591.94, 9649016.84],
		[2815314.60, 9649700.32],
		[2815954.87, 9625986.79],
		[2792311.90, 9625308.39],
	]], [[	/* 722:342 */
		[2815954.87, 9625986.79],
		[2815314.60, 9649700.32],
		[2839042.06, 9650303.68],
		[2839602.59, 9626585.67],
		[2815954.87, 9625986.79],
	]], [[	/* 722:343 */
		[2839602.59, 9626585.67],
		[2839042.06, 9650303.68],
		[2862773.73, 9650826.89],
		[2863254.48, 9627105.00],
		[2839602.59, 9626585.67],
	]], [[	/* 722:344 */
		[2863254.48, 9627105.00],
		[2862773.73, 9650826.89],
		[2886509.01, 9651269.90],
		[2886909.93, 9627544.72],
		[2863254.48, 9627105.00],
	]], [[	/* 722:345 */
		[2886909.93, 9627544.72],
		[2886509.01, 9651269.90],
		[2910247.30, 9651632.68],
		[2910568.36, 9627904.80],
		[2886909.93, 9627544.72],
	]], [[	/* 722:346 */
		[2910568.36, 9627904.80],
		[2910247.30, 9651632.68],
		[2933988.00, 9651915.19],
		[2934229.18, 9628185.21],
		[2910568.36, 9627904.80],
	]], [[	/* 722:347 */
		[2934229.18, 9628185.21],
		[2933988.00, 9651915.19],
		[2957730.50, 9652117.41],
		[2957891.78, 9628385.93],
		[2934229.18, 9628185.21],
	]], [[	/* 722:348 */
		[2957891.78, 9628385.93],
		[2957730.50, 9652117.41],
		[2981474.22, 9652239.33],
		[2981555.59, 9628506.95],
		[2957891.78, 9628385.93],
	]], [[	/* 722:349 */
		[2981555.59, 9628506.95],
		[2981474.22, 9652239.33],
		[3005218.55, 9652280.94],
		[3005219.99, 9628548.25],
		[2981555.59, 9628506.95],
	]], [[	/* 722:350 */
		[3005219.99, 9628548.25],
		[3005218.55, 9652280.94],
		[3028962.89, 9652242.23],
		[3028884.41, 9628509.83],
		[3005219.99, 9628548.25],
	]], [[	/* 722:351 */
		[3028884.41, 9628509.83],
		[3028962.89, 9652242.23],
		[3052706.63, 9652123.21],
		[3052548.24, 9628391.69],
		[3028884.41, 9628509.83],
	]], [[	/* 722:352 */
		[3052548.24, 9628391.69],
		[3052706.63, 9652123.21],
		[3076449.19, 9651923.89],
		[3076210.89, 9628193.85],
		[3052548.24, 9628391.69],
	]], [[	/* 722:353 */
		[3076210.89, 9628193.85],
		[3076449.19, 9651923.89],
		[3100189.96, 9651644.27],
		[3099871.78, 9627916.31],
		[3076210.89, 9628193.85],
	]], [[	/* 722:354 */
		[3099871.78, 9627916.31],
		[3100189.96, 9651644.27],
		[3123928.33, 9651284.40],
		[3123530.30, 9627559.11],
		[3099871.78, 9627916.31],
	]], [[	/* 722:355 */
		[3123530.30, 9627559.11],
		[3123928.33, 9651284.40],
		[3147663.72, 9650844.28],
		[3147185.86, 9627122.27],
		[3123530.30, 9627559.11],
	]], [[	/* 722:356 */
		[3147185.86, 9627122.27],
		[3147663.72, 9650844.28],
		[3171395.52, 9650323.97],
		[3170837.87, 9626605.82],
		[3147185.86, 9627122.27],
	]], [[	/* 722:357 */
		[3170837.87, 9626605.82],
		[3171395.52, 9650323.97],
		[3195123.13, 9649723.49],
		[3194485.74, 9626009.81],
		[3170837.87, 9626605.82],
	]], [[	/* 722:358 */
		[3194485.74, 9626009.81],
		[3195123.13, 9649723.49],
		[3218845.97, 9649042.91],
		[3218128.88, 9625334.28],
		[3194485.74, 9626009.81],
	]], [[	/* 722:359 */
		[3218128.88, 9625334.28],
		[3218845.97, 9649042.91],
		[3242563.42, 9648282.27],
		[3241766.70, 9624579.29],
		[3218128.88, 9625334.28],
	]], [[	/* 722:360 */
		[3241766.70, 9624579.29],
		[3242563.42, 9648282.27],
		[3266274.89, 9647441.64],
		[3265398.60, 9623744.90],
		[3241766.70, 9624579.29],
	]], [[	/* 722:361 */
		[3265398.60, 9623744.90],
		[3266274.89, 9647441.64],
		[3289979.79, 9646521.08],
		[3289024.01, 9622831.17],
		[3265398.60, 9623744.90],
	]], [[	/* 722:362 */
		[3289024.01, 9622831.17],
		[3289979.79, 9646521.08],
		[3313677.53, 9645520.67],
		[3312642.32, 9621838.18],
		[3289024.01, 9622831.17],
	]], [[	/* 722:363 */
		[3312642.32, 9621838.18],
		[3313677.53, 9645520.67],
		[3337367.51, 9644440.48],
		[3336252.96, 9620766.01],
		[3312642.32, 9621838.18],
	]], [[	/* 723:340 */
		[2767874.68, 9648253.31],
		[2767069.09, 9672035.90],
		[2790866.58, 9672805.16],
		[2791591.94, 9649016.84],
		[2767874.68, 9648253.31],
	]], [[	/* 723:341 */
		[2791591.94, 9649016.84],
		[2790866.58, 9672805.16],
		[2814669.52, 9673493.76],
		[2815314.60, 9649700.32],
		[2791591.94, 9649016.84],
	]], [[	/* 723:342 */
		[2815314.60, 9649700.32],
		[2814669.52, 9673493.76],
		[2838477.33, 9674101.66],
		[2839042.06, 9650303.68],
		[2815314.60, 9649700.32],
	]], [[	/* 723:343 */
		[2839042.06, 9650303.68],
		[2838477.33, 9674101.66],
		[2862289.38, 9674628.80],
		[2862773.73, 9650826.89],
		[2839042.06, 9650303.68],
	]], [[	/* 723:344 */
		[2862773.73, 9650826.89],
		[2862289.38, 9674628.80],
		[2886105.08, 9675075.13],
		[2886509.01, 9651269.90],
		[2862773.73, 9650826.89],
	]], [[	/* 723:345 */
		[2886509.01, 9651269.90],
		[2886105.08, 9675075.13],
		[2909923.83, 9675440.63],
		[2910247.30, 9651632.68],
		[2886509.01, 9651269.90],
	]], [[	/* 723:346 */
		[2910247.30, 9651632.68],
		[2909923.83, 9675440.63],
		[2933745.01, 9675725.26],
		[2933988.00, 9651915.19],
		[2910247.30, 9651632.68],
	]], [[	/* 723:347 */
		[2933988.00, 9651915.19],
		[2933745.01, 9675725.26],
		[2957568.01, 9675929.01],
		[2957730.50, 9652117.41],
		[2933988.00, 9651915.19],
	]], [[	/* 723:348 */
		[2957730.50, 9652117.41],
		[2957568.01, 9675929.01],
		[2981392.25, 9676051.84],
		[2981474.22, 9652239.33],
		[2957730.50, 9652117.41],
	]], [[	/* 723:349 */
		[2981474.22, 9652239.33],
		[2981392.25, 9676051.84],
		[3005217.10, 9676093.76],
		[3005218.55, 9652280.94],
		[2981474.22, 9652239.33],
	]], [[	/* 723:350 */
		[3005218.55, 9652280.94],
		[3005217.10, 9676093.76],
		[3029041.95, 9676054.76],
		[3028962.89, 9652242.23],
		[3005218.55, 9652280.94],
	]], [[	/* 723:351 */
		[3028962.89, 9652242.23],
		[3029041.95, 9676054.76],
		[3052866.22, 9675934.85],
		[3052706.63, 9652123.21],
		[3028962.89, 9652242.23],
	]], [[	/* 723:352 */
		[3052706.63, 9652123.21],
		[3052866.22, 9675934.85],
		[3076689.28, 9675734.02],
		[3076449.19, 9651923.89],
		[3052706.63, 9652123.21],
	]], [[	/* 723:353 */
		[3076449.19, 9651923.89],
		[3076689.28, 9675734.02],
		[3100510.52, 9675452.31],
		[3100189.96, 9651644.27],
		[3076449.19, 9651923.89],
	]], [[	/* 723:354 */
		[3100189.96, 9651644.27],
		[3100510.52, 9675452.31],
		[3124329.36, 9675089.73],
		[3123928.33, 9651284.40],
		[3100189.96, 9651644.27],
	]], [[	/* 723:355 */
		[3123928.33, 9651284.40],
		[3124329.36, 9675089.73],
		[3148145.17, 9674646.31],
		[3147663.72, 9650844.28],
		[3123928.33, 9651284.40],
	]], [[	/* 723:356 */
		[3147663.72, 9650844.28],
		[3148145.17, 9674646.31],
		[3171957.36, 9674122.08],
		[3171395.52, 9650323.97],
		[3147663.72, 9650844.28],
	]], [[	/* 723:357 */
		[3171395.52, 9650323.97],
		[3171957.36, 9674122.08],
		[3195765.31, 9673517.10],
		[3195123.13, 9649723.49],
		[3171395.52, 9650323.97],
	]], [[	/* 723:358 */
		[3195123.13, 9649723.49],
		[3195765.31, 9673517.10],
		[3219568.43, 9672831.41],
		[3218845.97, 9649042.91],
		[3195123.13, 9649723.49],
	]], [[	/* 723:359 */
		[3218845.97, 9649042.91],
		[3219568.43, 9672831.41],
		[3243366.11, 9672065.06],
		[3242563.42, 9648282.27],
		[3218845.97, 9649042.91],
	]], [[	/* 723:360 */
		[3242563.42, 9648282.27],
		[3243366.11, 9672065.06],
		[3267157.75, 9671218.12],
		[3266274.89, 9647441.64],
		[3242563.42, 9648282.27],
	]], [[	/* 723:361 */
		[3266274.89, 9647441.64],
		[3267157.75, 9671218.12],
		[3290942.75, 9670290.65],
		[3289979.79, 9646521.08],
		[3266274.89, 9647441.64],
	]], [[	/* 723:362 */
		[3289979.79, 9646521.08],
		[3290942.75, 9670290.65],
		[3314720.50, 9669282.74],
		[3313677.53, 9645520.67],
		[3289979.79, 9646521.08],
	]], [[	/* 723:363 */
		[3313677.53, 9645520.67],
		[3314720.50, 9669282.74],
		[3338490.41, 9668194.45],
		[3337367.51, 9644440.48],
		[3313677.53, 9645520.67],
	]], [[	/* 724:339 */
		[2743277.66, 9671186.05],
		[2742385.24, 9695042.64],
		[2766257.44, 9695898.89],
		[2767069.09, 9672035.90],
		[2743277.66, 9671186.05],
	]], [[	/* 724:340 */
		[2767069.09, 9672035.90],
		[2766257.44, 9695898.89],
		[2790135.76, 9696673.94],
		[2790866.58, 9672805.16],
		[2767069.09, 9672035.90],
	]], [[	/* 724:341 */
		[2790866.58, 9672805.16],
		[2790135.76, 9696673.94],
		[2814019.59, 9697367.73],
		[2814669.52, 9673493.76],
		[2790866.58, 9672805.16],
	]], [[	/* 724:342 */
		[2814669.52, 9673493.76],
		[2814019.59, 9697367.73],
		[2837908.34, 9697980.20],
		[2838477.33, 9674101.66],
		[2814669.52, 9673493.76],
	]], [[	/* 724:343 */
		[2838477.33, 9674101.66],
		[2837908.34, 9697980.20],
		[2861801.38, 9698511.31],
		[2862289.38, 9674628.80],
		[2838477.33, 9674101.66],
	]], [[	/* 724:344 */
		[2862289.38, 9674628.80],
		[2861801.38, 9698511.31],
		[2885698.11, 9698961.01],
		[2886105.08, 9675075.13],
		[2862289.38, 9674628.80],
	]], [[	/* 724:345 */
		[2886105.08, 9675075.13],
		[2885698.11, 9698961.01],
		[2909597.92, 9699329.26],
		[2909923.83, 9675440.63],
		[2886105.08, 9675075.13],
	]], [[	/* 724:346 */
		[2909923.83, 9675440.63],
		[2909597.92, 9699329.26],
		[2933500.19, 9699616.04],
		[2933745.01, 9675725.26],
		[2909923.83, 9675440.63],
	]], [[	/* 724:347 */
		[2933745.01, 9675725.26],
		[2933500.19, 9699616.04],
		[2957404.30, 9699821.32],
		[2957568.01, 9675929.01],
		[2933745.01, 9675725.26],
	]], [[	/* 724:348 */
		[2957568.01, 9675929.01],
		[2957404.30, 9699821.32],
		[2981309.66, 9699945.08],
		[2981392.25, 9676051.84],
		[2957568.01, 9675929.01],
	]], [[	/* 724:349 */
		[2981392.25, 9676051.84],
		[2981309.66, 9699945.08],
		[3005215.63, 9699987.31],
		[3005217.10, 9676093.76],
		[2981392.25, 9676051.84],
	]], [[	/* 724:350 */
		[3005217.10, 9676093.76],
		[3005215.63, 9699987.31],
		[3029121.62, 9699948.02],
		[3029041.95, 9676054.76],
		[3005217.10, 9676093.76],
	]], [[	/* 724:351 */
		[3029041.95, 9676054.76],
		[3029121.62, 9699948.02],
		[3053027.00, 9699827.20],
		[3052866.22, 9675934.85],
		[3029041.95, 9676054.76],
	]], [[	/* 724:352 */
		[3052866.22, 9675934.85],
		[3053027.00, 9699827.20],
		[3076931.17, 9699624.86],
		[3076689.28, 9675734.02],
		[3052866.22, 9675934.85],
	]], [[	/* 724:353 */
		[3076689.28, 9675734.02],
		[3076931.17, 9699624.86],
		[3100833.51, 9699341.02],
		[3100510.52, 9675452.31],
		[3076689.28, 9675734.02],
	]], [[	/* 724:354 */
		[3100510.52, 9675452.31],
		[3100833.51, 9699341.02],
		[3124733.41, 9698975.71],
		[3124329.36, 9675089.73],
		[3100510.52, 9675452.31],
	]], [[	/* 724:355 */
		[3124329.36, 9675089.73],
		[3124733.41, 9698975.71],
		[3148630.25, 9698528.94],
		[3148145.17, 9674646.31],
		[3124329.36, 9675089.73],
	]], [[	/* 724:356 */
		[3148145.17, 9674646.31],
		[3148630.25, 9698528.94],
		[3172523.42, 9698000.77],
		[3171957.36, 9674122.08],
		[3148145.17, 9674646.31],
	]], [[	/* 724:357 */
		[3171957.36, 9674122.08],
		[3172523.42, 9698000.77],
		[3196412.32, 9697391.23],
		[3195765.31, 9673517.10],
		[3171957.36, 9674122.08],
	]], [[	/* 724:358 */
		[3195765.31, 9673517.10],
		[3196412.32, 9697391.23],
		[3220296.33, 9696700.37],
		[3219568.43, 9672831.41],
		[3195765.31, 9673517.10],
	]], [[	/* 724:359 */
		[3219568.43, 9672831.41],
		[3220296.33, 9696700.37],
		[3244174.84, 9695928.25],
		[3243366.11, 9672065.06],
		[3219568.43, 9672831.41],
	]], [[	/* 724:360 */
		[3243366.11, 9672065.06],
		[3244174.84, 9695928.25],
		[3268047.25, 9695074.93],
		[3267157.75, 9671218.12],
		[3243366.11, 9672065.06],
	]], [[	/* 724:361 */
		[3267157.75, 9671218.12],
		[3268047.25, 9695074.93],
		[3291912.94, 9694140.48],
		[3290942.75, 9670290.65],
		[3267157.75, 9671218.12],
	]], [[	/* 724:362 */
		[3290942.75, 9670290.65],
		[3291912.94, 9694140.48],
		[3315771.31, 9693124.98],
		[3314720.50, 9669282.74],
		[3290942.75, 9670290.65],
	]], [[	/* 725:339 */
		[2742385.24, 9695042.64],
		[2741486.09, 9718980.17],
		[2765439.66, 9719842.88],
		[2766257.44, 9695898.89],
		[2742385.24, 9695042.64],
	]], [[	/* 725:340 */
		[2766257.44, 9695898.89],
		[2765439.66, 9719842.88],
		[2789399.42, 9720623.79],
		[2790135.76, 9696673.94],
		[2766257.44, 9695898.89],
	]], [[	/* 725:341 */
		[2790135.76, 9696673.94],
		[2789399.42, 9720623.79],
		[2813364.75, 9721322.82],
		[2814019.59, 9697367.73],
		[2790135.76, 9696673.94],
	]], [[	/* 725:342 */
		[2814019.59, 9697367.73],
		[2813364.75, 9721322.82],
		[2837335.05, 9721939.92],
		[2837908.34, 9697980.20],
		[2814019.59, 9697367.73],
	]], [[	/* 725:343 */
		[2837908.34, 9697980.20],
		[2837335.05, 9721939.92],
		[2861309.70, 9722475.05],
		[2861801.38, 9698511.31],
		[2837908.34, 9697980.20],
	]], [[	/* 725:344 */
		[2861801.38, 9698511.31],
		[2861309.70, 9722475.05],
		[2885288.07, 9722928.14],
		[2885698.11, 9698961.01],
		[2861801.38, 9698511.31],
	]], [[	/* 725:345 */
		[2885698.11, 9698961.01],
		[2885288.07, 9722928.14],
		[2909269.55, 9723299.18],
		[2909597.92, 9699329.26],
		[2885698.11, 9698961.01],
	]], [[	/* 725:346 */
		[2909597.92, 9699329.26],
		[2909269.55, 9723299.18],
		[2933253.51, 9723588.13],
		[2933500.19, 9699616.04],
		[2909597.92, 9699329.26],
	]], [[	/* 725:347 */
		[2933500.19, 9699616.04],
		[2933253.51, 9723588.13],
		[2957239.35, 9723794.96],
		[2957404.30, 9699821.32],
		[2933500.19, 9699616.04],
	]], [[	/* 725:348 */
		[2957404.30, 9699821.32],
		[2957239.35, 9723794.96],
		[2981226.44, 9723919.65],
		[2981309.66, 9699945.08],
		[2957404.30, 9699821.32],
	]], [[	/* 725:349 */
		[2981309.66, 9699945.08],
		[2981226.44, 9723919.65],
		[3005214.16, 9723962.21],
		[3005215.63, 9699987.31],
		[2981309.66, 9699945.08],
	]], [[	/* 725:350 */
		[3005215.63, 9699987.31],
		[3005214.16, 9723962.21],
		[3029201.89, 9723922.61],
		[3029121.62, 9699948.02],
		[3005215.63, 9699987.31],
	]], [[	/* 725:351 */
		[3029121.62, 9699948.02],
		[3029201.89, 9723922.61],
		[3053189.01, 9723800.88],
		[3053027.00, 9699827.20],
		[3029121.62, 9699948.02],
	]], [[	/* 725:352 */
		[3053027.00, 9699827.20],
		[3053189.01, 9723800.88],
		[3077174.90, 9723597.01],
		[3076931.17, 9699624.86],
		[3053027.00, 9699827.20],
	]], [[	/* 725:353 */
		[3076931.17, 9699624.86],
		[3077174.90, 9723597.01],
		[3101158.94, 9723311.02],
		[3100833.51, 9699341.02],
		[3076931.17, 9699624.86],
	]], [[	/* 725:354 */
		[3100833.51, 9699341.02],
		[3101158.94, 9723311.02],
		[3125140.51, 9722942.94],
		[3124733.41, 9698975.71],
		[3100833.51, 9699341.02],
	]], [[	/* 725:355 */
		[3124733.41, 9698975.71],
		[3125140.51, 9722942.94],
		[3149118.99, 9722492.80],
		[3148630.25, 9698528.94],
		[3124733.41, 9698975.71],
	]], [[	/* 725:356 */
		[3148630.25, 9698528.94],
		[3149118.99, 9722492.80],
		[3173093.77, 9721960.63],
		[3172523.42, 9698000.77],
		[3148630.25, 9698528.94],
	]], [[	/* 725:357 */
		[3172523.42, 9698000.77],
		[3173093.77, 9721960.63],
		[3197064.22, 9721346.48],
		[3196412.32, 9697391.23],
		[3172523.42, 9698000.77],
	]], [[	/* 725:358 */
		[3196412.32, 9697391.23],
		[3197064.22, 9721346.48],
		[3221029.73, 9720650.40],
		[3220296.33, 9696700.37],
		[3196412.32, 9697391.23],
	]], [[	/* 725:359 */
		[3220296.33, 9696700.37],
		[3221029.73, 9720650.40],
		[3244989.69, 9719872.45],
		[3244174.84, 9695928.25],
		[3220296.33, 9696700.37],
	]], [[	/* 725:360 */
		[3244174.84, 9695928.25],
		[3244989.69, 9719872.45],
		[3268943.47, 9719012.68],
		[3268047.25, 9695074.93],
		[3244174.84, 9695928.25],
	]], [[	/* 725:361 */
		[3268047.25, 9695074.93],
		[3268943.47, 9719012.68],
		[3292890.46, 9718071.18],
		[3291912.94, 9694140.48],
		[3268047.25, 9695074.93],
	]], [[	/* 725:362 */
		[3291912.94, 9694140.48],
		[3292890.46, 9718071.18],
		[3316830.05, 9717048.01],
		[3315771.31, 9693124.98],
		[3291912.94, 9694140.48],
	]], [[	/* 726:339 */
		[2741486.09, 9718980.17],
		[2740580.14, 9742999.24],
		[2764615.69, 9743868.49],
		[2765439.66, 9719842.88],
		[2741486.09, 9718980.17],
	]], [[	/* 726:340 */
		[2765439.66, 9719842.88],
		[2764615.69, 9743868.49],
		[2788657.50, 9744655.32],
		[2789399.42, 9720623.79],
		[2765439.66, 9719842.88],
	]], [[	/* 726:341 */
		[2789399.42, 9720623.79],
		[2788657.50, 9744655.32],
		[2812704.95, 9745359.65],
		[2813364.75, 9721322.82],
		[2789399.42, 9720623.79],
	]], [[	/* 726:342 */
		[2813364.75, 9721322.82],
		[2812704.95, 9745359.65],
		[2836757.42, 9745981.43],
		[2837335.05, 9721939.92],
		[2813364.75, 9721322.82],
	]], [[	/* 726:343 */
		[2837335.05, 9721939.92],
		[2836757.42, 9745981.43],
		[2860814.28, 9746520.61],
		[2861309.70, 9722475.05],
		[2837335.05, 9721939.92],
	]], [[	/* 726:344 */
		[2861309.70, 9722475.05],
		[2860814.28, 9746520.61],
		[2884874.91, 9746977.15],
		[2885288.07, 9722928.14],
		[2861309.70, 9722475.05],
	]], [[	/* 726:345 */
		[2885288.07, 9722928.14],
		[2884874.91, 9746977.15],
		[2908938.69, 9747351.00],
		[2909269.55, 9723299.18],
		[2885288.07, 9722928.14],
	]], [[	/* 726:346 */
		[2909269.55, 9723299.18],
		[2908938.69, 9747351.00],
		[2933004.97, 9747642.14],
		[2933253.51, 9723588.13],
		[2909269.55, 9723299.18],
	]], [[	/* 726:347 */
		[2933253.51, 9723588.13],
		[2933004.97, 9747642.14],
		[2957073.15, 9747850.54],
		[2957239.35, 9723794.96],
		[2933253.51, 9723588.13],
	]], [[	/* 726:348 */
		[2957239.35, 9723794.96],
		[2957073.15, 9747850.54],
		[2981142.60, 9747976.18],
		[2981226.44, 9723919.65],
		[2957239.35, 9723794.96],
	]], [[	/* 726:349 */
		[2981226.44, 9723919.65],
		[2981142.60, 9747976.18],
		[3005212.68, 9748019.05],
		[3005214.16, 9723962.21],
		[2981226.44, 9723919.65],
	]], [[	/* 726:350 */
		[3005214.16, 9723962.21],
		[3005212.68, 9748019.05],
		[3029282.77, 9747979.16],
		[3029201.89, 9723922.61],
		[3005214.16, 9723962.21],
	]], [[	/* 726:351 */
		[3029201.89, 9723922.61],
		[3029282.77, 9747979.16],
		[3053352.24, 9747856.50],
		[3053189.01, 9723800.88],
		[3029201.89, 9723922.61],
	]], [[	/* 726:352 */
		[3053189.01, 9723800.88],
		[3053352.24, 9747856.50],
		[3077420.47, 9747651.08],
		[3077174.90, 9723597.01],
		[3053189.01, 9723800.88],
	]], [[	/* 726:353 */
		[3077174.90, 9723597.01],
		[3077420.47, 9747651.08],
		[3101486.83, 9747362.92],
		[3101158.94, 9723311.02],
		[3077174.90, 9723597.01],
	]], [[	/* 726:354 */
		[3101158.94, 9723311.02],
		[3101486.83, 9747362.92],
		[3125550.70, 9746992.05],
		[3125140.51, 9722942.94],
		[3101158.94, 9723311.02],
	]], [[	/* 726:355 */
		[3125140.51, 9722942.94],
		[3125550.70, 9746992.05],
		[3149611.44, 9746538.49],
		[3149118.99, 9722492.80],
		[3125140.51, 9722942.94],
	]], [[	/* 726:356 */
		[3149118.99, 9722492.80],
		[3149611.44, 9746538.49],
		[3173668.44, 9746002.29],
		[3173093.77, 9721960.63],
		[3149118.99, 9722492.80],
	]], [[	/* 726:357 */
		[3173093.77, 9721960.63],
		[3173668.44, 9746002.29],
		[3197721.06, 9745383.48],
		[3197064.22, 9721346.48],
		[3173093.77, 9721960.63],
	]], [[	/* 726:358 */
		[3197064.22, 9721346.48],
		[3197721.06, 9745383.48],
		[3221768.69, 9744682.12],
		[3221029.73, 9720650.40],
		[3197064.22, 9721346.48],
	]], [[	/* 726:359 */
		[3221029.73, 9720650.40],
		[3221768.69, 9744682.12],
		[3245810.70, 9743898.26],
		[3244989.69, 9719872.45],
		[3221029.73, 9720650.40],
	]], [[	/* 726:360 */
		[3244989.69, 9719872.45],
		[3245810.70, 9743898.26],
		[3269846.47, 9743031.98],
		[3268943.47, 9719012.68],
		[3244989.69, 9719872.45],
	]], [[	/* 726:361 */
		[3268943.47, 9719012.68],
		[3269846.47, 9743031.98],
		[3293875.38, 9742083.34],
		[3292890.46, 9718071.18],
		[3268943.47, 9719012.68],
	]], [[	/* 726:362 */
		[3292890.46, 9718071.18],
		[3293875.38, 9742083.34],
		[3317896.80, 9741052.42],
		[3316830.05, 9717048.01],
		[3292890.46, 9718071.18],
	]], [[	/* 727:337 */
		[2692530.30, 9741013.75],
		[2691452.48, 9765099.90],
		[2715556.09, 9766141.64],
		[2716551.47, 9742047.64],
		[2692530.30, 9741013.75],
	]], [[	/* 727:339 */
		[2740580.14, 9742999.24],
		[2739667.29, 9767100.48],
		[2763785.45, 9767976.34],
		[2764615.69, 9743868.49],
		[2740580.14, 9742999.24],
	]], [[	/* 727:340 */
		[2764615.69, 9743868.49],
		[2763785.45, 9767976.34],
		[2787909.94, 9768769.15],
		[2788657.50, 9744655.32],
		[2764615.69, 9743868.49],
	]], [[	/* 727:341 */
		[2788657.50, 9744655.32],
		[2787909.94, 9768769.15],
		[2812040.14, 9769478.84],
		[2812704.95, 9745359.65],
		[2788657.50, 9744655.32],
	]], [[	/* 727:342 */
		[2812704.95, 9745359.65],
		[2812040.14, 9769478.84],
		[2836175.40, 9770105.35],
		[2836757.42, 9745981.43],
		[2812704.95, 9745359.65],
	]], [[	/* 727:343 */
		[2836757.42, 9745981.43],
		[2836175.40, 9770105.35],
		[2860315.10, 9770648.64],
		[2860814.28, 9746520.61],
		[2836757.42, 9745981.43],
	]], [[	/* 727:344 */
		[2860814.28, 9746520.61],
		[2860315.10, 9770648.64],
		[2884458.62, 9771108.65],
		[2884874.91, 9746977.15],
		[2860814.28, 9746520.61],
	]], [[	/* 727:345 */
		[2884874.91, 9746977.15],
		[2884458.62, 9771108.65],
		[2908605.31, 9771485.35],
		[2908938.69, 9747351.00],
		[2884874.91, 9746977.15],
	]], [[	/* 727:346 */
		[2908938.69, 9747351.00],
		[2908605.31, 9771485.35],
		[2932754.54, 9771778.70],
		[2933004.97, 9747642.14],
		[2908938.69, 9747351.00],
	]], [[	/* 727:347 */
		[2933004.97, 9747642.14],
		[2932754.54, 9771778.70],
		[2956905.69, 9771988.68],
		[2957073.15, 9747850.54],
		[2933004.97, 9747642.14],
	]], [[	/* 727:348 */
		[2957073.15, 9747850.54],
		[2956905.69, 9771988.68],
		[2981058.11, 9772115.28],
		[2981142.60, 9747976.18],
		[2957073.15, 9747850.54],
	]], [[	/* 727:349 */
		[2981142.60, 9747976.18],
		[2981058.11, 9772115.28],
		[3005211.18, 9772158.48],
		[3005212.68, 9748019.05],
		[2981142.60, 9747976.18],
	]], [[	/* 727:350 */
		[3005212.68, 9748019.05],
		[3005211.18, 9772158.48],
		[3029364.26, 9772118.28],
		[3029282.77, 9747979.16],
		[3005212.68, 9748019.05],
	]], [[	/* 727:351 */
		[3029282.77, 9747979.16],
		[3029364.26, 9772118.28],
		[3053516.72, 9771994.69],
		[3053352.24, 9747856.50],
		[3029282.77, 9747979.16],
	]], [[	/* 727:352 */
		[3053352.24, 9747856.50],
		[3053516.72, 9771994.69],
		[3077667.92, 9771787.70],
		[3077420.47, 9747651.08],
		[3053352.24, 9747856.50],
	]], [[	/* 727:353 */
		[3077420.47, 9747651.08],
		[3077667.92, 9771787.70],
		[3101817.22, 9771497.35],
		[3101486.83, 9747362.92],
		[3077420.47, 9747651.08],
	]], [[	/* 727:354 */
		[3101486.83, 9747362.92],
		[3101817.22, 9771497.35],
		[3125964.01, 9771123.65],
		[3125550.70, 9746992.05],
		[3101486.83, 9747362.92],
	]], [[	/* 727:355 */
		[3125550.70, 9746992.05],
		[3125964.01, 9771123.65],
		[3150107.64, 9770666.64],
		[3149611.44, 9746538.49],
		[3125550.70, 9746992.05],
	]], [[	/* 727:356 */
		[3149611.44, 9746538.49],
		[3150107.64, 9770666.64],
		[3174247.48, 9770126.35],
		[3173668.44, 9746002.29],
		[3149611.44, 9746538.49],
	]], [[	/* 727:357 */
		[3173668.44, 9746002.29],
		[3174247.48, 9770126.35],
		[3198382.90, 9769502.84],
		[3197721.06, 9745383.48],
		[3173668.44, 9746002.29],
	]], [[	/* 727:358 */
		[3197721.06, 9745383.48],
		[3198382.90, 9769502.84],
		[3222513.27, 9768796.14],
		[3221768.69, 9744682.12],
		[3197721.06, 9745383.48],
	]], [[	/* 727:359 */
		[3221768.69, 9744682.12],
		[3222513.27, 9768796.14],
		[3246637.96, 9768006.32],
		[3245810.70, 9743898.26],
		[3221768.69, 9744682.12],
	]], [[	/* 727:360 */
		[3245810.70, 9743898.26],
		[3246637.96, 9768006.32],
		[3270756.34, 9767133.45],
		[3269846.47, 9743031.98],
		[3245810.70, 9743898.26],
	]], [[	/* 727:361 */
		[3269846.47, 9743031.98],
		[3270756.34, 9767133.45],
		[3294867.78, 9766177.60],
		[3293875.38, 9742083.34],
		[3269846.47, 9743031.98],
	]], [[	/* 727:362 */
		[3293875.38, 9742083.34],
		[3294867.78, 9766177.60],
		[3318971.66, 9765138.84],
		[3317896.80, 9741052.42],
		[3293875.38, 9742083.34],
	]], [[	/* 727:363 */
		[3317896.80, 9741052.42],
		[3318971.66, 9765138.84],
		[3343067.34, 9764017.27],
		[3341910.12, 9739939.31],
		[3317896.80, 9741052.42],
	]], [[	/* 728:336 */
		[2667357.08, 9763975.35],
		[2666188.06, 9788135.55],
		[2690366.44, 9789268.67],
		[2691452.48, 9765099.90],
		[2667357.08, 9763975.35],
	]], [[	/* 728:337 */
		[2691452.48, 9765099.90],
		[2690366.44, 9789268.67],
		[2714553.13, 9790318.35],
		[2715556.09, 9766141.64],
		[2691452.48, 9765099.90],
	]], [[	/* 728:338 */
		[2715556.09, 9766141.64],
		[2714553.13, 9790318.35],
		[2738747.49, 9791284.51],
		[2739667.29, 9767100.48],
		[2715556.09, 9766141.64],
	]], [[	/* 728:339 */
		[2739667.29, 9767100.48],
		[2738747.49, 9791284.51],
		[2762948.89, 9792167.05],
		[2763785.45, 9767976.34],
		[2739667.29, 9767100.48],
	]], [[	/* 728:340 */
		[2763785.45, 9767976.34],
		[2762948.89, 9792167.05],
		[2787156.69, 9792965.91],
		[2787909.94, 9768769.15],
		[2763785.45, 9767976.34],
	]], [[	/* 728:341 */
		[2787909.94, 9768769.15],
		[2787156.69, 9792965.91],
		[2811370.25, 9793681.02],
		[2812040.14, 9769478.84],
		[2787909.94, 9768769.15],
	]], [[	/* 728:342 */
		[2812040.14, 9769478.84],
		[2811370.25, 9793681.02],
		[2835588.93, 9794312.31],
		[2836175.40, 9770105.35],
		[2812040.14, 9769478.84],
	]], [[	/* 728:343 */
		[2836175.40, 9770105.35],
		[2835588.93, 9794312.31],
		[2859812.11, 9794859.75],
		[2860315.10, 9770648.64],
		[2836175.40, 9770105.35],
	]], [[	/* 728:344 */
		[2860315.10, 9770648.64],
		[2859812.11, 9794859.75],
		[2884039.14, 9795323.27],
		[2884458.62, 9771108.65],
		[2860315.10, 9770648.64],
	]], [[	/* 728:345 */
		[2884458.62, 9771108.65],
		[2884039.14, 9795323.27],
		[2908269.39, 9795702.84],
		[2908605.31, 9771485.35],
		[2884458.62, 9771108.65],
	]], [[	/* 728:346 */
		[2908605.31, 9771485.35],
		[2908269.39, 9795702.84],
		[2932502.20, 9795998.44],
		[2932754.54, 9771778.70],
		[2908605.31, 9771485.35],
	]], [[	/* 728:347 */
		[2932754.54, 9771778.70],
		[2932502.20, 9795998.44],
		[2956736.95, 9796210.03],
		[2956905.69, 9771988.68],
		[2932754.54, 9771778.70],
	]], [[	/* 728:348 */
		[2956905.69, 9771988.68],
		[2956736.95, 9796210.03],
		[2980972.99, 9796337.59],
		[2981058.11, 9772115.28],
		[2956905.69, 9771988.68],
	]], [[	/* 728:349 */
		[2981058.11, 9772115.28],
		[2980972.99, 9796337.59],
		[3005209.68, 9796381.12],
		[3005211.18, 9772158.48],
		[2981058.11, 9772115.28],
	]], [[	/* 728:350 */
		[3005211.18, 9772158.48],
		[3005209.68, 9796381.12],
		[3029446.38, 9796340.61],
		[3029364.26, 9772118.28],
		[3005211.18, 9772158.48],
	]], [[	/* 728:351 */
		[3029364.26, 9772118.28],
		[3029446.38, 9796340.61],
		[3053682.45, 9796216.07],
		[3053516.72, 9771994.69],
		[3029364.26, 9772118.28],
	]], [[	/* 728:352 */
		[3053516.72, 9771994.69],
		[3053682.45, 9796216.07],
		[3077917.25, 9796007.51],
		[3077667.92, 9771787.70],
		[3053516.72, 9771994.69],
	]], [[	/* 728:353 */
		[3077667.92, 9771787.70],
		[3077917.25, 9796007.51],
		[3102150.14, 9795714.93],
		[3101817.22, 9771497.35],
		[3077667.92, 9771787.70],
	]], [[	/* 728:354 */
		[3101817.22, 9771497.35],
		[3102150.14, 9795714.93],
		[3126380.48, 9795338.38],
		[3125964.01, 9771123.65],
		[3101817.22, 9771497.35],
	]], [[	/* 728:355 */
		[3125964.01, 9771123.65],
		[3126380.48, 9795338.38],
		[3150607.62, 9794877.88],
		[3150107.64, 9770666.64],
		[3125964.01, 9771123.65],
	]], [[	/* 728:356 */
		[3150107.64, 9770666.64],
		[3150607.62, 9794877.88],
		[3174830.94, 9794333.46],
		[3174247.48, 9770126.35],
		[3150107.64, 9770666.64],
	]], [[	/* 728:357 */
		[3174247.48, 9770126.35],
		[3174830.94, 9794333.46],
		[3199049.79, 9793705.18],
		[3198382.90, 9769502.84],
		[3174247.48, 9770126.35],
	]], [[	/* 728:358 */
		[3198382.90, 9769502.84],
		[3199049.79, 9793705.18],
		[3223263.53, 9792993.09],
		[3222513.27, 9768796.14],
		[3198382.90, 9769502.84],
	]], [[	/* 728:359 */
		[3222513.27, 9768796.14],
		[3223263.53, 9792993.09],
		[3247471.53, 9792197.24],
		[3246637.96, 9768006.32],
		[3222513.27, 9768796.14],
	]], [[	/* 728:360 */
		[3246637.96, 9768006.32],
		[3247471.53, 9792197.24],
		[3271673.14, 9791317.71],
		[3270756.34, 9767133.45],
		[3246637.96, 9768006.32],
	]], [[	/* 728:361 */
		[3270756.34, 9767133.45],
		[3271673.14, 9791317.71],
		[3295867.75, 9790354.56],
		[3294867.78, 9766177.60],
		[3270756.34, 9767133.45],
	]], [[	/* 728:362 */
		[3294867.78, 9766177.60],
		[3295867.75, 9790354.56],
		[3320054.70, 9789307.89],
		[3318971.66, 9765138.84],
		[3294867.78, 9766177.60],
	]], [[	/* 728:363 */
		[3318971.66, 9765138.84],
		[3320054.70, 9789307.89],
		[3344233.37, 9788177.76],
		[3343067.34, 9764017.27],
		[3318971.66, 9765138.84],
	]], [[	/* 728:364 */
		[3343067.34, 9764017.27],
		[3344233.37, 9788177.76],
		[3368403.14, 9786964.29],
		[3367154.21, 9762812.98],
		[3343067.34, 9764017.27],
	]], [[	/* 729:336 */
		[2666188.06, 9788135.55],
		[2665010.10, 9812378.90],
		[2689272.11, 9813520.69],
		[2690366.44, 9789268.67],
		[2666188.06, 9788135.55],
	]], [[	/* 729:337 */
		[2690366.44, 9789268.67],
		[2689272.11, 9813520.69],
		[2713542.50, 9814578.41],
		[2714553.13, 9790318.35],
		[2690366.44, 9789268.67],
	]], [[	/* 729:338 */
		[2714553.13, 9790318.35],
		[2713542.50, 9814578.41],
		[2737820.66, 9815551.95],
		[2738747.49, 9791284.51],
		[2714553.13, 9790318.35],
	]], [[	/* 729:339 */
		[2738747.49, 9791284.51],
		[2737820.66, 9815551.95],
		[2762105.92, 9816441.25],
		[2762948.89, 9792167.05],
		[2738747.49, 9791284.51],
	]], [[	/* 729:340 */
		[2762948.89, 9792167.05],
		[2762105.92, 9816441.25],
		[2786397.66, 9817246.23],
		[2787156.69, 9792965.91],
		[2762948.89, 9792167.05],
	]], [[	/* 729:341 */
		[2787156.69, 9792965.91],
		[2786397.66, 9817246.23],
		[2810695.23, 9817966.81],
		[2811370.25, 9793681.02],
		[2787156.69, 9792965.91],
	]], [[	/* 729:342 */
		[2811370.25, 9793681.02],
		[2810695.23, 9817966.81],
		[2834997.98, 9818602.95],
		[2835588.93, 9794312.31],
		[2811370.25, 9793681.02],
	]], [[	/* 729:343 */
		[2835588.93, 9794312.31],
		[2834997.98, 9818602.95],
		[2859305.27, 9819154.57],
		[2859812.11, 9794859.75],
		[2835588.93, 9794312.31],
	]], [[	/* 729:344 */
		[2859812.11, 9794859.75],
		[2859305.27, 9819154.57],
		[2883616.46, 9819621.65],
		[2884039.14, 9795323.27],
		[2859812.11, 9794859.75],
	]], [[	/* 729:345 */
		[2884039.14, 9795323.27],
		[2883616.46, 9819621.65],
		[2907930.89, 9820004.13],
		[2908269.39, 9795702.84],
		[2884039.14, 9795323.27],
	]], [[	/* 729:346 */
		[2908269.39, 9795702.84],
		[2907930.89, 9820004.13],
		[2932247.92, 9820301.99],
		[2932502.20, 9795998.44],
		[2908269.39, 9795702.84],
	]], [[	/* 729:347 */
		[2932502.20, 9795998.44],
		[2932247.92, 9820301.99],
		[2956566.91, 9820515.20],
		[2956736.95, 9796210.03],
		[2932502.20, 9795998.44],
	]], [[	/* 729:348 */
		[2956736.95, 9796210.03],
		[2956566.91, 9820515.20],
		[2980887.21, 9820643.74],
		[2980972.99, 9796337.59],
		[2956736.95, 9796210.03],
	]], [[	/* 729:349 */
		[2980972.99, 9796337.59],
		[2980887.21, 9820643.74],
		[3005208.16, 9820687.61],
		[3005209.68, 9796381.12],
		[2980972.99, 9796337.59],
	]], [[	/* 729:350 */
		[3005209.68, 9796381.12],
		[3005208.16, 9820687.61],
		[3029529.13, 9820646.79],
		[3029446.38, 9796340.61],
		[3005209.68, 9796381.12],
	]], [[	/* 729:351 */
		[3029446.38, 9796340.61],
		[3029529.13, 9820646.79],
		[3053849.45, 9820521.29],
		[3053682.45, 9796216.07],
		[3029446.38, 9796340.61],
	]], [[	/* 729:352 */
		[3053682.45, 9796216.07],
		[3053849.45, 9820521.29],
		[3078168.50, 9820311.12],
		[3077917.25, 9796007.51],
		[3053682.45, 9796216.07],
	]], [[	/* 729:353 */
		[3077917.25, 9796007.51],
		[3078168.50, 9820311.12],
		[3102485.61, 9820016.31],
		[3102150.14, 9795714.93],
		[3077917.25, 9796007.51],
	]], [[	/* 729:354 */
		[3102150.14, 9795714.93],
		[3102485.61, 9820016.31],
		[3126800.14, 9819636.87],
		[3126380.48, 9795338.38],
		[3102150.14, 9795714.93],
	]], [[	/* 729:355 */
		[3126380.48, 9795338.38],
		[3126800.14, 9819636.87],
		[3151111.44, 9819172.83],
		[3150607.62, 9794877.88],
		[3126380.48, 9795338.38],
	]], [[	/* 729:356 */
		[3150607.62, 9794877.88],
		[3151111.44, 9819172.83],
		[3175418.87, 9818624.24],
		[3174830.94, 9794333.46],
		[3150607.62, 9794877.88],
	]], [[	/* 729:357 */
		[3174830.94, 9794333.46],
		[3175418.87, 9818624.24],
		[3199721.78, 9817991.15],
		[3199049.79, 9793705.18],
		[3174830.94, 9794333.46],
	]], [[	/* 729:358 */
		[3199049.79, 9793705.18],
		[3199721.78, 9817991.15],
		[3224019.53, 9817273.60],
		[3223263.53, 9792993.09],
		[3199049.79, 9793705.18],
	]], [[	/* 729:359 */
		[3223263.53, 9792993.09],
		[3224019.53, 9817273.60],
		[3248311.47, 9816471.66],
		[3247471.53, 9792197.24],
		[3223263.53, 9792993.09],
	]], [[	/* 729:360 */
		[3247471.53, 9792197.24],
		[3248311.47, 9816471.66],
		[3272596.97, 9815585.39],
		[3271673.14, 9791317.71],
		[3247471.53, 9792197.24],
	]], [[	/* 729:361 */
		[3271673.14, 9791317.71],
		[3272596.97, 9815585.39],
		[3296875.36, 9814614.87],
		[3295867.75, 9790354.56],
		[3271673.14, 9791317.71],
	]], [[	/* 729:362 */
		[3295867.75, 9790354.56],
		[3296875.36, 9814614.87],
		[3321146.03, 9813560.18],
		[3320054.70, 9789307.89],
		[3295867.75, 9790354.56],
	]], [[	/* 729:363 */
		[3320054.70, 9789307.89],
		[3321146.03, 9813560.18],
		[3345408.32, 9812421.42],
		[3344233.37, 9788177.76],
		[3320054.70, 9789307.89],
	]], [[	/* 729:364 */
		[3344233.37, 9788177.76],
		[3345408.32, 9812421.42],
		[3369661.60, 9811198.67],
		[3368403.14, 9786964.29],
		[3344233.37, 9788177.76],
	]], [[	/* 730:336 */
		[2665010.10, 9812378.90],
		[2663823.12, 9836706.05],
		[2688169.37, 9837856.60],
		[2689272.11, 9813520.69],
		[2665010.10, 9812378.90],
	]], [[	/* 730:337 */
		[2689272.11, 9813520.69],
		[2688169.37, 9837856.60],
		[2712524.12, 9838922.43],
		[2713542.50, 9814578.41],
		[2689272.11, 9813520.69],
	]], [[	/* 730:338 */
		[2713542.50, 9814578.41],
		[2712524.12, 9838922.43],
		[2736886.71, 9839903.46],
		[2737820.66, 9815551.95],
		[2713542.50, 9814578.41],
	]], [[	/* 730:339 */
		[2737820.66, 9815551.95],
		[2736886.71, 9839903.46],
		[2761256.49, 9840799.59],
		[2762105.92, 9816441.25],
		[2737820.66, 9815551.95],
	]], [[	/* 730:340 */
		[2762105.92, 9816441.25],
		[2761256.49, 9840799.59],
		[2785632.81, 9841610.75],
		[2786397.66, 9817246.23],
		[2762105.92, 9816441.25],
	]], [[	/* 730:341 */
		[2786397.66, 9817246.23],
		[2785632.81, 9841610.75],
		[2810015.03, 9842336.87],
		[2810695.23, 9817966.81],
		[2786397.66, 9817246.23],
	]], [[	/* 730:342 */
		[2810695.23, 9817966.81],
		[2810015.03, 9842336.87],
		[2834402.49, 9842977.90],
		[2834997.98, 9818602.95],
		[2810695.23, 9817966.81],
	]], [[	/* 730:343 */
		[2834997.98, 9818602.95],
		[2834402.49, 9842977.90],
		[2858794.54, 9843533.76],
		[2859305.27, 9819154.57],
		[2834997.98, 9818602.95],
	]], [[	/* 730:344 */
		[2859305.27, 9819154.57],
		[2858794.54, 9843533.76],
		[2883190.52, 9844004.43],
		[2883616.46, 9819621.65],
		[2859305.27, 9819154.57],
	]], [[	/* 730:345 */
		[2883616.46, 9819621.65],
		[2883190.52, 9844004.43],
		[2907589.79, 9844389.85],
		[2907930.89, 9820004.13],
		[2883616.46, 9819621.65],
	]], [[	/* 730:346 */
		[2907930.89, 9820004.13],
		[2907589.79, 9844389.85],
		[2931991.70, 9844690.00],
		[2932247.92, 9820301.99],
		[2907930.89, 9820004.13],
	]], [[	/* 730:347 */
		[2932247.92, 9820301.99],
		[2931991.70, 9844690.00],
		[2956395.57, 9844904.85],
		[2956566.91, 9820515.20],
		[2932247.92, 9820301.99],
	]], [[	/* 730:348 */
		[2956566.91, 9820515.20],
		[2956395.57, 9844904.85],
		[2980800.77, 9845034.38],
		[2980887.21, 9820643.74],
		[2956566.91, 9820515.20],
	]], [[	/* 730:349 */
		[2980887.21, 9820643.74],
		[2980800.77, 9845034.38],
		[3005206.64, 9845078.58],
		[3005208.16, 9820687.61],
		[2980887.21, 9820643.74],
	]], [[	/* 730:350 */
		[3005208.16, 9820687.61],
		[3005206.64, 9845078.58],
		[3029612.51, 9845037.45],
		[3029529.13, 9820646.79],
		[3005208.16, 9820687.61],
	]], [[	/* 730:351 */
		[3029529.13, 9820646.79],
		[3029612.51, 9845037.45],
		[3054017.74, 9844910.98],
		[3053849.45, 9820521.29],
		[3029529.13, 9820646.79],
	]], [[	/* 730:352 */
		[3053849.45, 9820521.29],
		[3054017.74, 9844910.98],
		[3078421.67, 9844699.20],
		[3078168.50, 9820311.12],
		[3053849.45, 9820521.29],
	]], [[	/* 730:353 */
		[3078168.50, 9820311.12],
		[3078421.67, 9844699.20],
		[3102823.65, 9844402.12],
		[3102485.61, 9820016.31],
		[3078168.50, 9820311.12],
	]], [[	/* 730:354 */
		[3102485.61, 9820016.31],
		[3102823.65, 9844402.12],
		[3127223.02, 9844019.76],
		[3126800.14, 9819636.87],
		[3102485.61, 9820016.31],
	]], [[	/* 730:355 */
		[3126800.14, 9819636.87],
		[3127223.02, 9844019.76],
		[3151619.13, 9843552.15],
		[3151111.44, 9819172.83],
		[3126800.14, 9819636.87],
	]], [[	/* 730:356 */
		[3151111.44, 9819172.83],
		[3151619.13, 9843552.15],
		[3176011.32, 9842999.34],
		[3175418.87, 9818624.24],
		[3151111.44, 9819172.83],
	]], [[	/* 730:357 */
		[3175418.87, 9818624.24],
		[3176011.32, 9842999.34],
		[3200398.94, 9842361.38],
		[3199721.78, 9817991.15],
		[3175418.87, 9818624.24],
	]], [[	/* 730:358 */
		[3199721.78, 9817991.15],
		[3200398.94, 9842361.38],
		[3224781.34, 9841638.31],
		[3224019.53, 9817273.60],
		[3199721.78, 9817991.15],
	]], [[	/* 730:359 */
		[3224019.53, 9817273.60],
		[3224781.34, 9841638.31],
		[3249157.87, 9840830.21],
		[3248311.47, 9816471.66],
		[3224019.53, 9817273.60],
	]], [[	/* 730:360 */
		[3248311.47, 9816471.66],
		[3249157.87, 9840830.21],
		[3273527.88, 9839937.13],
		[3272596.97, 9815585.39],
		[3248311.47, 9816471.66],
	]], [[	/* 730:361 */
		[3272596.97, 9815585.39],
		[3273527.88, 9839937.13],
		[3297890.71, 9838959.16],
		[3296875.36, 9814614.87],
		[3272596.97, 9815585.39],
	]], [[	/* 730:362 */
		[3296875.36, 9814614.87],
		[3297890.71, 9838959.16],
		[3322245.73, 9837896.37],
		[3321146.03, 9813560.18],
		[3296875.36, 9814614.87],
	]], [[	/* 730:363 */
		[3321146.03, 9813560.18],
		[3322245.73, 9837896.37],
		[3346592.28, 9836748.86],
		[3345408.32, 9812421.42],
		[3321146.03, 9813560.18],
	]], [[	/* 730:364 */
		[3345408.32, 9812421.42],
		[3346592.28, 9836748.86],
		[3370929.72, 9835516.73],
		[3369661.60, 9811198.67],
		[3345408.32, 9812421.42],
	]], [[	/* 731:336 */
		[2663823.12, 9836706.05],
		[2662627.00, 9861117.62],
		[2687058.15, 9862277.04],
		[2688169.37, 9837856.60],
		[2663823.12, 9836706.05],
	]], [[	/* 731:337 */
		[2688169.37, 9837856.60],
		[2687058.15, 9862277.04],
		[2711497.89, 9863351.08],
		[2712524.12, 9838922.43],
		[2688169.37, 9837856.60],
	]], [[	/* 731:338 */
		[2712524.12, 9838922.43],
		[2711497.89, 9863351.08],
		[2735945.56, 9864339.66],
		[2736886.71, 9839903.46],
		[2712524.12, 9838922.43],
	]], [[	/* 731:339 */
		[2736886.71, 9839903.46],
		[2735945.56, 9864339.66],
		[2760400.50, 9865242.70],
		[2761256.49, 9840799.59],
		[2736886.71, 9839903.46],
	]], [[	/* 731:340 */
		[2761256.49, 9840799.59],
		[2760400.50, 9865242.70],
		[2784862.06, 9866060.12],
		[2785632.81, 9841610.75],
		[2761256.49, 9840799.59],
	]], [[	/* 731:341 */
		[2785632.81, 9841610.75],
		[2784862.06, 9866060.12],
		[2809329.58, 9866791.84],
		[2810015.03, 9842336.87],
		[2785632.81, 9841610.75],
	]], [[	/* 731:342 */
		[2810015.03, 9842336.87],
		[2809329.58, 9866791.84],
		[2833802.40, 9867437.81],
		[2834402.49, 9842977.90],
		[2810015.03, 9842336.87],
	]], [[	/* 731:343 */
		[2834402.49, 9842977.90],
		[2833802.40, 9867437.81],
		[2858279.86, 9867997.96],
		[2858794.54, 9843533.76],
		[2834402.49, 9842977.90],
	]], [[	/* 731:344 */
		[2858794.54, 9843533.76],
		[2858279.86, 9867997.96],
		[2882761.30, 9868472.26],
		[2883190.52, 9844004.43],
		[2858794.54, 9843533.76],
	]], [[	/* 731:345 */
		[2883190.52, 9844004.43],
		[2882761.30, 9868472.26],
		[2907246.07, 9868860.66],
		[2907589.79, 9844389.85],
		[2883190.52, 9844004.43],
	]], [[	/* 731:346 */
		[2907589.79, 9844389.85],
		[2907246.07, 9868860.66],
		[2931733.49, 9869163.13],
		[2931991.70, 9844690.00],
		[2907589.79, 9844389.85],
	]], [[	/* 731:347 */
		[2931991.70, 9844690.00],
		[2931733.49, 9869163.13],
		[2956222.91, 9869379.63],
		[2956395.57, 9844904.85],
		[2931991.70, 9844690.00],
	]], [[	/* 731:348 */
		[2956395.57, 9844904.85],
		[2956222.91, 9869379.63],
		[2980713.67, 9869510.16],
		[2980800.77, 9845034.38],
		[2956395.57, 9844904.85],
	]], [[	/* 731:349 */
		[2980800.77, 9845034.38],
		[2980713.67, 9869510.16],
		[3005205.10, 9869554.70],
		[3005206.64, 9845078.58],
		[2980800.77, 9845034.38],
	]], [[	/* 731:350 */
		[3005206.64, 9845078.58],
		[3005205.10, 9869554.70],
		[3029696.54, 9869513.25],
		[3029612.51, 9845037.45],
		[3005206.64, 9845078.58],
	]], [[	/* 731:351 */
		[3029612.51, 9845037.45],
		[3029696.54, 9869513.25],
		[3054187.33, 9869385.81],
		[3054017.74, 9844910.98],
		[3029612.51, 9845037.45],
	]], [[	/* 731:352 */
		[3054017.74, 9844910.98],
		[3054187.33, 9869385.81],
		[3078676.81, 9869172.39],
		[3078421.67, 9844699.20],
		[3054017.74, 9844910.98],
	]], [[	/* 731:353 */
		[3078421.67, 9844699.20],
		[3078676.81, 9869172.39],
		[3103164.31, 9868873.01],
		[3102823.65, 9844402.12],
		[3078421.67, 9844699.20],
	]], [[	/* 731:354 */
		[3102823.65, 9844402.12],
		[3103164.31, 9868873.01],
		[3127649.17, 9868487.70],
		[3127223.02, 9844019.76],
		[3102823.65, 9844402.12],
	]], [[	/* 731:355 */
		[3127223.02, 9844019.76],
		[3127649.17, 9868487.70],
		[3152130.73, 9868016.48],
		[3151619.13, 9843552.15],
		[3127223.02, 9844019.76],
	]], [[	/* 731:356 */
		[3151619.13, 9843552.15],
		[3152130.73, 9868016.48],
		[3176608.34, 9867459.41],
		[3176011.32, 9842999.34],
		[3151619.13, 9843552.15],
	]], [[	/* 731:357 */
		[3176011.32, 9842999.34],
		[3176608.34, 9867459.41],
		[3201081.32, 9866816.52],
		[3200398.94, 9842361.38],
		[3176011.32, 9842999.34],
	]], [[	/* 731:358 */
		[3200398.94, 9842361.38],
		[3201081.32, 9866816.52],
		[3225549.02, 9866087.88],
		[3224781.34, 9841638.31],
		[3200398.94, 9842361.38],
	]], [[	/* 731:359 */
		[3224781.34, 9841638.31],
		[3225549.02, 9866087.88],
		[3250010.79, 9865273.54],
		[3249157.87, 9840830.21],
		[3224781.34, 9841638.31],
	]], [[	/* 731:360 */
		[3249157.87, 9840830.21],
		[3250010.79, 9865273.54],
		[3274465.96, 9864373.58],
		[3273527.88, 9839937.13],
		[3249157.87, 9840830.21],
	]], [[	/* 731:361 */
		[3273527.88, 9839937.13],
		[3274465.96, 9864373.58],
		[3298913.88, 9863388.06],
		[3297890.71, 9838959.16],
		[3273527.88, 9839937.13],
	]], [[	/* 731:362 */
		[3297890.71, 9838959.16],
		[3298913.88, 9863388.06],
		[3323353.90, 9862317.09],
		[3322245.73, 9837896.37],
		[3297890.71, 9838959.16],
	]], [[	/* 731:363 */
		[3322245.73, 9837896.37],
		[3323353.90, 9862317.09],
		[3347785.35, 9861160.74],
		[3346592.28, 9836748.86],
		[3322245.73, 9837896.37],
	]], [[	/* 731:364 */
		[3346592.28, 9836748.86],
		[3347785.35, 9861160.74],
		[3372207.59, 9859919.12],
		[3370929.72, 9835516.73],
		[3346592.28, 9836748.86],
	]], [[	/* 732:336 */
		[2662627.00, 9861117.62],
		[2661421.64, 9885614.28],
		[2685938.35, 9886782.65],
		[2687058.15, 9862277.04],
		[2662627.00, 9861117.62],
	]], [[	/* 732:337 */
		[2687058.15, 9862277.04],
		[2685938.35, 9886782.65],
		[2710463.74, 9887865.00],
		[2711497.89, 9863351.08],
		[2687058.15, 9862277.04],
	]], [[	/* 732:338 */
		[2711497.89, 9863351.08],
		[2710463.74, 9887865.00],
		[2734997.14, 9888861.22],
		[2735945.56, 9864339.66],
		[2711497.89, 9863351.08],
	]], [[	/* 732:339 */
		[2735945.56, 9864339.66],
		[2734997.14, 9888861.22],
		[2759537.91, 9889771.25],
		[2760400.50, 9865242.70],
		[2735945.56, 9864339.66],
	]], [[	/* 732:340 */
		[2760400.50, 9865242.70],
		[2759537.91, 9889771.25],
		[2784085.36, 9890594.99],
		[2784862.06, 9866060.12],
		[2760400.50, 9865242.70],
	]], [[	/* 732:341 */
		[2784862.06, 9866060.12],
		[2784085.36, 9890594.99],
		[2808638.83, 9891332.37],
		[2809329.58, 9866791.84],
		[2784862.06, 9866060.12],
	]], [[	/* 732:342 */
		[2809329.58, 9866791.84],
		[2808638.83, 9891332.37],
		[2833197.67, 9891983.34],
		[2833802.40, 9867437.81],
		[2809329.58, 9866791.84],
	]], [[	/* 732:343 */
		[2833802.40, 9867437.81],
		[2833197.67, 9891983.34],
		[2857761.21, 9892547.83],
		[2858279.86, 9867997.96],
		[2833802.40, 9867437.81],
	]], [[	/* 732:344 */
		[2858279.86, 9867997.96],
		[2857761.21, 9892547.83],
		[2882328.77, 9893025.80],
		[2882761.30, 9868472.26],
		[2858279.86, 9867997.96],
	]], [[	/* 732:345 */
		[2882761.30, 9868472.26],
		[2882328.77, 9893025.80],
		[2906899.68, 9893417.21],
		[2907246.07, 9868860.66],
		[2882761.30, 9868472.26],
	]], [[	/* 732:346 */
		[2907246.07, 9868860.66],
		[2906899.68, 9893417.21],
		[2931473.29, 9893722.02],
		[2931733.49, 9869163.13],
		[2907246.07, 9868860.66],
	]], [[	/* 732:347 */
		[2931733.49, 9869163.13],
		[2931473.29, 9893722.02],
		[2956048.92, 9893940.20],
		[2956222.91, 9869379.63],
		[2931733.49, 9869163.13],
	]], [[	/* 732:348 */
		[2956222.91, 9869379.63],
		[2956048.92, 9893940.20],
		[2980625.89, 9894071.74],
		[2980713.67, 9869510.16],
		[2956222.91, 9869379.63],
	]], [[	/* 732:349 */
		[2980713.67, 9869510.16],
		[2980625.89, 9894071.74],
		[3005203.55, 9894116.62],
		[3005205.10, 9869554.70],
		[2980713.67, 9869510.16],
	]], [[	/* 732:350 */
		[3005205.10, 9869554.70],
		[3005203.55, 9894116.62],
		[3029781.22, 9894074.85],
		[3029696.54, 9869513.25],
		[3005205.10, 9869554.70],
	]], [[	/* 732:351 */
		[3029696.54, 9869513.25],
		[3029781.22, 9894074.85],
		[3054358.23, 9893946.42],
		[3054187.33, 9869385.81],
		[3029696.54, 9869513.25],
	]], [[	/* 732:352 */
		[3054187.33, 9869385.81],
		[3054358.23, 9893946.42],
		[3078933.91, 9893731.35],
		[3078676.81, 9869172.39],
		[3054187.33, 9869385.81],
	]], [[	/* 732:353 */
		[3078676.81, 9869172.39],
		[3078933.91, 9893731.35],
		[3103507.60, 9893429.65],
		[3103164.31, 9868873.01],
		[3078676.81, 9869172.39],
	]], [[	/* 732:354 */
		[3103164.31, 9868873.01],
		[3103507.60, 9893429.65],
		[3128078.62, 9893041.35],
		[3127649.17, 9868487.70],
		[3103164.31, 9868873.01],
	]], [[	/* 732:355 */
		[3127649.17, 9868487.70],
		[3128078.62, 9893041.35],
		[3152646.30, 9892566.48],
		[3152130.73, 9868016.48],
		[3127649.17, 9868487.70],
	]], [[	/* 732:356 */
		[3152130.73, 9868016.48],
		[3152646.30, 9892566.48],
		[3177209.97, 9892005.10],
		[3176608.34, 9867459.41],
		[3152130.73, 9868016.48],
	]], [[	/* 732:357 */
		[3176608.34, 9867459.41],
		[3177209.97, 9892005.10],
		[3201768.98, 9891357.23],
		[3201081.32, 9866816.52],
		[3176608.34, 9867459.41],
	]], [[	/* 732:358 */
		[3201081.32, 9866816.52],
		[3201768.98, 9891357.23],
		[3226322.65, 9890622.95],
		[3225549.02, 9866087.88],
		[3201081.32, 9866816.52],
	]], [[	/* 732:359 */
		[3225549.02, 9866087.88],
		[3226322.65, 9890622.95],
		[3250870.31, 9889802.31],
		[3250010.79, 9865273.54],
		[3225549.02, 9866087.88],
	]], [[	/* 732:360 */
		[3250010.79, 9865273.54],
		[3250870.31, 9889802.31],
		[3275411.30, 9888895.38],
		[3274465.96, 9864373.58],
		[3250010.79, 9865273.54],
	]], [[	/* 732:361 */
		[3274465.96, 9864373.58],
		[3275411.30, 9888895.38],
		[3299944.96, 9887902.24],
		[3298913.88, 9863388.06],
		[3274465.96, 9864373.58],
	]], [[	/* 732:362 */
		[3298913.88, 9863388.06],
		[3299944.96, 9887902.24],
		[3324470.63, 9886822.99],
		[3323353.90, 9862317.09],
		[3298913.88, 9863388.06],
	]], [[	/* 732:363 */
		[3323353.90, 9862317.09],
		[3324470.63, 9886822.99],
		[3348987.63, 9885657.70],
		[3347785.35, 9861160.74],
		[3323353.90, 9862317.09],
	]], [[	/* 733:336 */
		[2661421.64, 9885614.28],
		[2660206.95, 9910196.67],
		[2684809.87, 9911374.10],
		[2685938.35, 9886782.65],
		[2661421.64, 9885614.28],
	]], [[	/* 733:337 */
		[2685938.35, 9886782.65],
		[2684809.87, 9911374.10],
		[2709421.57, 9912464.84],
		[2710463.74, 9887865.00],
		[2685938.35, 9886782.65],
	]], [[	/* 733:338 */
		[2710463.74, 9887865.00],
		[2709421.57, 9912464.84],
		[2734041.37, 9913468.80],
		[2734997.14, 9888861.22],
		[2710463.74, 9887865.00],
	]], [[	/* 733:339 */
		[2734997.14, 9888861.22],
		[2734041.37, 9913468.80],
		[2758668.62, 9914385.89],
		[2759537.91, 9889771.25],
		[2734997.14, 9888861.22],
	]], [[	/* 733:340 */
		[2759537.91, 9889771.25],
		[2758668.62, 9914385.89],
		[2783302.62, 9915216.02],
		[2784085.36, 9890594.99],
		[2759537.91, 9889771.25],
	]], [[	/* 733:341 */
		[2784085.36, 9890594.99],
		[2783302.62, 9915216.02],
		[2807942.73, 9915959.13],
		[2808638.83, 9891332.37],
		[2784085.36, 9890594.99],
	]], [[	/* 733:342 */
		[2808638.83, 9891332.37],
		[2807942.73, 9915959.13],
		[2832588.25, 9916615.16],
		[2833197.67, 9891983.34],
		[2808638.83, 9891332.37],
	]], [[	/* 733:343 */
		[2833197.67, 9891983.34],
		[2832588.25, 9916615.16],
		[2857238.52, 9917184.03],
		[2857761.21, 9892547.83],
		[2833197.67, 9891983.34],
	]], [[	/* 733:344 */
		[2857761.21, 9892547.83],
		[2857238.52, 9917184.03],
		[2881892.87, 9917665.72],
		[2882328.77, 9893025.80],
		[2857761.21, 9892547.83],
	]], [[	/* 733:345 */
		[2882328.77, 9893025.80],
		[2881892.87, 9917665.72],
		[2906550.61, 9918060.16],
		[2906899.68, 9893417.21],
		[2882328.77, 9893025.80],
	]], [[	/* 733:346 */
		[2906899.68, 9893417.21],
		[2906550.61, 9918060.16],
		[2931211.07, 9918367.34],
		[2931473.29, 9893722.02],
		[2906899.68, 9893417.21],
	]], [[	/* 733:347 */
		[2931473.29, 9893722.02],
		[2931211.07, 9918367.34],
		[2955873.57, 9918587.22],
		[2956048.92, 9893940.20],
		[2931473.29, 9893722.02],
	]], [[	/* 733:348 */
		[2956048.92, 9893940.20],
		[2955873.57, 9918587.22],
		[2980537.44, 9918719.78],
		[2980625.89, 9894071.74],
		[2956048.92, 9893940.20],
	]], [[	/* 733:349 */
		[2980625.89, 9894071.74],
		[2980537.44, 9918719.78],
		[3005201.99, 9918765.01],
		[3005203.55, 9894116.62],
		[2980625.89, 9894071.74],
	]], [[	/* 733:350 */
		[3005203.55, 9894116.62],
		[3005201.99, 9918765.01],
		[3029866.56, 9918722.91],
		[3029781.22, 9894074.85],
		[3005203.55, 9894116.62],
	]], [[	/* 733:351 */
		[3029781.22, 9894074.85],
		[3029866.56, 9918722.91],
		[3054530.46, 9918593.48],
		[3054358.23, 9893946.42],
		[3029781.22, 9894074.85],
	]], [[	/* 733:352 */
		[3054358.23, 9893946.42],
		[3054530.46, 9918593.48],
		[3079193.02, 9918376.74],
		[3078933.91, 9893731.35],
		[3054358.23, 9893946.42],
	]], [[	/* 733:353 */
		[3078933.91, 9893731.35],
		[3079193.02, 9918376.74],
		[3103853.56, 9918072.69],
		[3103507.60, 9893429.65],
		[3078933.91, 9893731.35],
	]], [[	/* 733:354 */
		[3103507.60, 9893429.65],
		[3103853.56, 9918072.69],
		[3128511.40, 9917681.37],
		[3128078.62, 9893041.35],
		[3103507.60, 9893429.65],
	]], [[	/* 733:355 */
		[3128078.62, 9893041.35],
		[3128511.40, 9917681.37],
		[3153165.87, 9917202.82],
		[3152646.30, 9892566.48],
		[3128078.62, 9893041.35],
	]], [[	/* 733:356 */
		[3152646.30, 9892566.48],
		[3153165.87, 9917202.82],
		[3177816.28, 9916637.07],
		[3177209.97, 9892005.10],
		[3152646.30, 9892566.48],
	]], [[	/* 733:357 */
		[3177209.97, 9892005.10],
		[3177816.28, 9916637.07],
		[3202461.98, 9915984.17],
		[3201768.98, 9891357.23],
		[3177209.97, 9892005.10],
	]], [[	/* 733:358 */
		[3201768.98, 9891357.23],
		[3202461.98, 9915984.17],
		[3227102.27, 9915244.18],
		[3226322.65, 9890622.95],
		[3201768.98, 9891357.23],
	]], [[	/* 733:359 */
		[3226322.65, 9890622.95],
		[3227102.27, 9915244.18],
		[3251736.49, 9914417.17],
		[3250870.31, 9889802.31],
		[3226322.65, 9890622.95],
	]], [[	/* 733:360 */
		[3250870.31, 9889802.31],
		[3251736.49, 9914417.17],
		[3276363.97, 9913503.20],
		[3275411.30, 9888895.38],
		[3250870.31, 9889802.31],
	]], [[	/* 733:361 */
		[3275411.30, 9888895.38],
		[3276363.97, 9913503.20],
		[3300984.03, 9912502.36],
		[3299944.96, 9887902.24],
		[3275411.30, 9888895.38],
	]], [[	/* 733:362 */
		[3299944.96, 9887902.24],
		[3300984.03, 9912502.36],
		[3325596.01, 9911414.73],
		[3324470.63, 9886822.99],
		[3299944.96, 9887902.24],
	]], [[	/* 733:363 */
		[3324470.63, 9886822.99],
		[3325596.01, 9911414.73],
		[3350199.23, 9910240.40],
		[3348987.63, 9885657.70],
		[3324470.63, 9886822.99],
	]], [[	/* 734:335 */
		[2635613.47, 9908932.65],
		[2634302.56, 9933591.60],
		[2658982.81, 9934865.45],
		[2660206.95, 9910196.67],
		[2635613.47, 9908932.65],
	]], [[	/* 734:336 */
		[2660206.95, 9910196.67],
		[2658982.81, 9934865.45],
		[2683672.61, 9936052.05],
		[2684809.87, 9911374.10],
		[2660206.95, 9910196.67],
	]], [[	/* 734:337 */
		[2684809.87, 9911374.10],
		[2683672.61, 9936052.05],
		[2708371.29, 9937151.28],
		[2709421.57, 9912464.84],
		[2684809.87, 9911374.10],
	]], [[	/* 734:338 */
		[2709421.57, 9912464.84],
		[2708371.29, 9937151.28],
		[2733078.16, 9938163.05],
		[2734041.37, 9913468.80],
		[2709421.57, 9912464.84],
	]], [[	/* 734:339 */
		[2734041.37, 9913468.80],
		[2733078.16, 9938163.05],
		[2757792.56, 9939087.28],
		[2758668.62, 9914385.89],
		[2734041.37, 9913468.80],
	]], [[	/* 734:340 */
		[2758668.62, 9914385.89],
		[2757792.56, 9939087.28],
		[2782513.80, 9939923.89],
		[2783302.62, 9915216.02],
		[2758668.62, 9914385.89],
	]], [[	/* 734:341 */
		[2783302.62, 9915216.02],
		[2782513.80, 9939923.89],
		[2807241.20, 9940672.79],
		[2807942.73, 9915959.13],
		[2783302.62, 9915216.02],
	]], [[	/* 734:342 */
		[2807942.73, 9915959.13],
		[2807241.20, 9940672.79],
		[2831974.09, 9941333.93],
		[2832588.25, 9916615.16],
		[2807942.73, 9915959.13],
	]], [[	/* 734:343 */
		[2832588.25, 9916615.16],
		[2831974.09, 9941333.93],
		[2856711.77, 9941907.24],
		[2857238.52, 9917184.03],
		[2832588.25, 9916615.16],
	]], [[	/* 734:344 */
		[2857238.52, 9917184.03],
		[2856711.77, 9941907.24],
		[2881453.57, 9942392.68],
		[2881892.87, 9917665.72],
		[2857238.52, 9917184.03],
	]], [[	/* 734:345 */
		[2881892.87, 9917665.72],
		[2881453.57, 9942392.68],
		[2906198.81, 9942790.20],
		[2906550.61, 9918060.16],
		[2881892.87, 9917665.72],
	]], [[	/* 734:346 */
		[2906550.61, 9918060.16],
		[2906198.81, 9942790.20],
		[2930946.80, 9943099.77],
		[2931211.07, 9918367.34],
		[2906550.61, 9918060.16],
	]], [[	/* 734:347 */
		[2931211.07, 9918367.34],
		[2930946.80, 9943099.77],
		[2955696.85, 9943321.36],
		[2955873.57, 9918587.22],
		[2931211.07, 9918367.34],
	]], [[	/* 734:348 */
		[2955873.57, 9918587.22],
		[2955696.85, 9943321.36],
		[2980448.29, 9943454.96],
		[2980537.44, 9918719.78],
		[2955873.57, 9918587.22],
	]], [[	/* 734:349 */
		[2980537.44, 9918719.78],
		[2980448.29, 9943454.96],
		[3005200.42, 9943500.54],
		[3005201.99, 9918765.01],
		[2980537.44, 9918719.78],
	]], [[	/* 734:350 */
		[3005201.99, 9918765.01],
		[3005200.42, 9943500.54],
		[3029952.57, 9943458.11],
		[3029866.56, 9918722.91],
		[3005201.99, 9918765.01],
	]], [[	/* 734:351 */
		[3029866.56, 9918722.91],
		[3029952.57, 9943458.11],
		[3054704.04, 9943327.67],
		[3054530.46, 9918593.48],
		[3029866.56, 9918722.91],
	]], [[	/* 734:352 */
		[3054530.46, 9918593.48],
		[3054704.04, 9943327.67],
		[3079454.15, 9943109.23],
		[3079193.02, 9918376.74],
		[3054530.46, 9918593.48],
	]], [[	/* 734:353 */
		[3079193.02, 9918376.74],
		[3079454.15, 9943109.23],
		[3104202.22, 9942802.82],
		[3103853.56, 9918072.69],
		[3079193.02, 9918376.74],
	]], [[	/* 734:354 */
		[3103853.56, 9918072.69],
		[3104202.22, 9942802.82],
		[3128947.56, 9942408.45],
		[3128511.40, 9917681.37],
		[3103853.56, 9918072.69],
	]], [[	/* 734:355 */
		[3128511.40, 9917681.37],
		[3128947.56, 9942408.45],
		[3153689.48, 9941926.16],
		[3153165.87, 9917202.82],
		[3128511.40, 9917681.37],
	]], [[	/* 734:356 */
		[3153165.87, 9917202.82],
		[3153689.48, 9941926.16],
		[3178427.32, 9941356.00],
		[3177816.28, 9916637.07],
		[3153165.87, 9917202.82],
	]], [[	/* 734:357 */
		[3177816.28, 9916637.07],
		[3178427.32, 9941356.00],
		[3203160.37, 9940698.01],
		[3202461.98, 9915984.17],
		[3177816.28, 9916637.07],
	]], [[	/* 734:358 */
		[3202461.98, 9915984.17],
		[3203160.37, 9940698.01],
		[3227887.97, 9939952.25],
		[3227102.27, 9915244.18],
		[3202461.98, 9915984.17],
	]], [[	/* 734:359 */
		[3227102.27, 9915244.18],
		[3227887.97, 9939952.25],
		[3252609.42, 9939118.79],
		[3251736.49, 9914417.17],
		[3227102.27, 9915244.18],
	]], [[	/* 734:360 */
		[3251736.49, 9914417.17],
		[3252609.42, 9939118.79],
		[3277324.06, 9938197.70],
		[3276363.97, 9913503.20],
		[3251736.49, 9914417.17],
	]], [[	/* 734:361 */
		[3276363.97, 9913503.20],
		[3277324.06, 9938197.70],
		[3302031.19, 9937189.06],
		[3300984.03, 9912502.36],
		[3276363.97, 9913503.20],
	]], [[	/* 734:362 */
		[3300984.03, 9912502.36],
		[3302031.19, 9937189.06],
		[3326730.15, 9936092.97],
		[3325596.01, 9911414.73],
		[3300984.03, 9912502.36],
	]], [[	/* 734:363 */
		[3325596.01, 9911414.73],
		[3326730.15, 9936092.97],
		[3351420.26, 9934909.50],
		[3350199.23, 9910240.40],
		[3325596.01, 9911414.73],
	]], [[	/* 735:335 */
		[2634302.56, 9933591.60],
		[2632981.43, 9958337.51],
		[2657749.12, 9959621.30],
		[2658982.81, 9934865.45],
		[2634302.56, 9933591.60],
	]], [[	/* 735:336 */
		[2658982.81, 9934865.45],
		[2657749.12, 9959621.30],
		[2682526.48, 9960817.16],
		[2683672.61, 9936052.05],
		[2658982.81, 9934865.45],
	]], [[	/* 735:337 */
		[2683672.61, 9936052.05],
		[2682526.48, 9960817.16],
		[2707312.81, 9961924.98],
		[2708371.29, 9937151.28],
		[2683672.61, 9936052.05],
	]], [[	/* 735:338 */
		[2708371.29, 9937151.28],
		[2707312.81, 9961924.98],
		[2732107.43, 9962944.66],
		[2733078.16, 9938163.05],
		[2708371.29, 9937151.28],
	]], [[	/* 735:339 */
		[2733078.16, 9938163.05],
		[2732107.43, 9962944.66],
		[2756909.66, 9963876.12],
		[2757792.56, 9939087.28],
		[2733078.16, 9938163.05],
	]], [[	/* 735:340 */
		[2757792.56, 9939087.28],
		[2756909.66, 9963876.12],
		[2781718.81, 9964719.26],
		[2782513.80, 9939923.89],
		[2757792.56, 9939087.28],
	]], [[	/* 735:341 */
		[2782513.80, 9939923.89],
		[2781718.81, 9964719.26],
		[2806534.19, 9965474.02],
		[2807241.20, 9940672.79],
		[2782513.80, 9939923.89],
	]], [[	/* 735:342 */
		[2807241.20, 9940672.79],
		[2806534.19, 9965474.02],
		[2831355.12, 9966140.33],
		[2831974.09, 9941333.93],
		[2807241.20, 9940672.79],
	]], [[	/* 735:343 */
		[2831974.09, 9941333.93],
		[2831355.12, 9966140.33],
		[2856180.90, 9966718.13],
		[2856711.77, 9941907.24],
		[2831974.09, 9941333.93],
	]], [[	/* 735:344 */
		[2856711.77, 9941907.24],
		[2856180.90, 9966718.13],
		[2881010.85, 9967207.36],
		[2881453.57, 9942392.68],
		[2856711.77, 9941907.24],
	]], [[	/* 735:345 */
		[2881453.57, 9942392.68],
		[2881010.85, 9967207.36],
		[2905844.27, 9967608.00],
		[2906198.81, 9942790.20],
		[2881453.57, 9942392.68],
	]], [[	/* 735:346 */
		[2906198.81, 9942790.20],
		[2905844.27, 9967608.00],
		[2930680.47, 9967919.99],
		[2930946.80, 9943099.77],
		[2906198.81, 9942790.20],
	]], [[	/* 735:347 */
		[2930946.80, 9943099.77],
		[2930680.47, 9967919.99],
		[2955518.76, 9968143.31],
		[2955696.85, 9943321.36],
		[2930946.80, 9943099.77],
	]], [[	/* 735:348 */
		[2955696.85, 9943321.36],
		[2955518.76, 9968143.31],
		[2980358.45, 9968277.95],
		[2980448.29, 9943454.96],
		[2955696.85, 9943321.36],
	]], [[	/* 735:349 */
		[2980448.29, 9943454.96],
		[2980358.45, 9968277.95],
		[3005198.84, 9968323.89],
		[3005200.42, 9943500.54],
		[2980448.29, 9943454.96],
	]], [[	/* 735:350 */
		[3005200.42, 9943500.54],
		[3005198.84, 9968323.89],
		[3030039.25, 9968281.13],
		[3029952.57, 9943458.11],
		[3005200.42, 9943500.54],
	]], [[	/* 735:351 */
		[3029952.57, 9943458.11],
		[3030039.25, 9968281.13],
		[3054878.97, 9968149.67],
		[3054704.04, 9943327.67],
		[3029952.57, 9943458.11],
	]], [[	/* 735:352 */
		[3054704.04, 9943327.67],
		[3054878.97, 9968149.67],
		[3079717.32, 9967929.52],
		[3079454.15, 9943109.23],
		[3054704.04, 9943327.67],
	]], [[	/* 735:353 */
		[3079454.15, 9943109.23],
		[3079717.32, 9967929.52],
		[3104553.60, 9967620.70],
		[3104202.22, 9942802.82],
		[3079454.15, 9943109.23],
	]], [[	/* 735:354 */
		[3104202.22, 9942802.82],
		[3104553.60, 9967620.70],
		[3129387.12, 9967223.25],
		[3128947.56, 9942408.45],
		[3104202.22, 9942802.82],
	]], [[	/* 735:355 */
		[3128947.56, 9942408.45],
		[3129387.12, 9967223.25],
		[3154217.20, 9966737.18],
		[3153689.48, 9941926.16],
		[3128947.56, 9942408.45],
	]], [[	/* 735:356 */
		[3153689.48, 9941926.16],
		[3154217.20, 9966737.18],
		[3179043.13, 9966162.56],
		[3178427.32, 9941356.00],
		[3153689.48, 9941926.16],
	]], [[	/* 735:357 */
		[3178427.32, 9941356.00],
		[3179043.13, 9966162.56],
		[3203864.23, 9965499.42],
		[3203160.37, 9940698.01],
		[3178427.32, 9941356.00],
	]], [[	/* 735:358 */
		[3203160.37, 9940698.01],
		[3203864.23, 9965499.42],
		[3228679.81, 9964747.83],
		[3227887.97, 9939952.25],
		[3203160.37, 9940698.01],
	]], [[	/* 735:359 */
		[3227887.97, 9939952.25],
		[3228679.81, 9964747.83],
		[3253489.17, 9963907.85],
		[3252609.42, 9939118.79],
		[3227887.97, 9939952.25],
	]], [[	/* 735:360 */
		[3252609.42, 9939118.79],
		[3253489.17, 9963907.85],
		[3278291.64, 9962979.56],
		[3277324.06, 9938197.70],
		[3252609.42, 9939118.79],
	]], [[	/* 735:361 */
		[3277324.06, 9938197.70],
		[3278291.64, 9962979.56],
		[3303086.53, 9961963.04],
		[3302031.19, 9937189.06],
		[3277324.06, 9938197.70],
	]], [[	/* 735:362 */
		[3302031.19, 9937189.06],
		[3303086.53, 9961963.04],
		[3327873.14, 9960858.38],
		[3326730.15, 9936092.97],
		[3302031.19, 9937189.06],
	]], [[	/* 736:335 */
		[2632981.43, 9958337.51],
		[2631649.96, 9983171.05],
		[2656505.78, 9984464.90],
		[2657749.12, 9959621.30],
		[2632981.43, 9958337.51],
	]], [[	/* 736:336 */
		[2657749.12, 9959621.30],
		[2656505.78, 9984464.90],
		[2681371.37, 9985670.13],
		[2682526.48, 9960817.16],
		[2657749.12, 9959621.30],
	]], [[	/* 736:337 */
		[2682526.48, 9960817.16],
		[2681371.37, 9985670.13],
		[2706246.04, 9986786.63],
		[2707312.81, 9961924.98],
		[2682526.48, 9960817.16],
	]], [[	/* 736:338 */
		[2707312.81, 9961924.98],
		[2706246.04, 9986786.63],
		[2731129.09, 9987814.31],
		[2732107.43, 9962944.66],
		[2707312.81, 9961924.98],
	]], [[	/* 736:339 */
		[2732107.43, 9962944.66],
		[2731129.09, 9987814.31],
		[2756019.84, 9988753.07],
		[2756909.66, 9963876.12],
		[2732107.43, 9962944.66],
	]], [[	/* 736:340 */
		[2756909.66, 9963876.12],
		[2756019.84, 9988753.07],
		[2780917.58, 9989602.83],
		[2781718.81, 9964719.26],
		[2756909.66, 9963876.12],
	]], [[	/* 736:341 */
		[2781718.81, 9964719.26],
		[2780917.58, 9989602.83],
		[2805821.63, 9990363.51],
		[2806534.19, 9965474.02],
		[2781718.81, 9964719.26],
	]], [[	/* 736:342 */
		[2806534.19, 9965474.02],
		[2805821.63, 9990363.51],
		[2830731.29, 9991035.05],
		[2831355.12, 9966140.33],
		[2806534.19, 9965474.02],
	]], [[	/* 736:343 */
		[2831355.12, 9966140.33],
		[2830731.29, 9991035.05],
		[2855645.86, 9991617.38],
		[2856180.90, 9966718.13],
		[2831355.12, 9966140.33],
	]], [[	/* 736:344 */
		[2856180.90, 9966718.13],
		[2855645.86, 9991617.38],
		[2880564.64, 9992110.46],
		[2881010.85, 9967207.36],
		[2856180.90, 9966718.13],
	]], [[	/* 736:345 */
		[2881010.85, 9967207.36],
		[2880564.64, 9992110.46],
		[2905486.94, 9992514.24],
		[2905844.27, 9967608.00],
		[2881010.85, 9967207.36],
	]], [[	/* 736:346 */
		[2905844.27, 9967608.00],
		[2905486.94, 9992514.24],
		[2930412.05, 9992828.68],
		[2930680.47, 9967919.99],
		[2905844.27, 9967608.00],
	]], [[	/* 736:347 */
		[2930680.47, 9967919.99],
		[2930412.05, 9992828.68],
		[2955339.27, 9993053.76],
		[2955518.76, 9968143.31],
		[2930680.47, 9967919.99],
	]], [[	/* 736:348 */
		[2955518.76, 9968143.31],
		[2955339.27, 9993053.76],
		[2980267.90, 9993189.46],
		[2980358.45, 9968277.95],
		[2955518.76, 9968143.31],
	]], [[	/* 736:349 */
		[2980358.45, 9968277.95],
		[2980267.90, 9993189.46],
		[3005197.25, 9993235.76],
		[3005198.84, 9968323.89],
		[2980358.45, 9968277.95],
	]], [[	/* 736:350 */
		[3005198.84, 9968323.89],
		[3005197.25, 9993235.76],
		[3030126.61, 9993192.66],
		[3030039.25, 9968281.13],
		[3005198.84, 9968323.89],
	]], [[	/* 736:351 */
		[3030039.25, 9968281.13],
		[3030126.61, 9993192.66],
		[3055055.28, 9993060.16],
		[3054878.97, 9968149.67],
		[3030039.25, 9968281.13],
	]], [[	/* 736:352 */
		[3054878.97, 9968149.67],
		[3055055.28, 9993060.16],
		[3079982.56, 9992838.28],
		[3079717.32, 9967929.52],
		[3054878.97, 9968149.67],
	]], [[	/* 736:353 */
		[3079717.32, 9967929.52],
		[3079982.56, 9992838.28],
		[3104907.74, 9992527.04],
		[3104553.60, 9967620.70],
		[3079717.32, 9967929.52],
	]], [[	/* 736:354 */
		[3104553.60, 9967620.70],
		[3104907.74, 9992527.04],
		[3129830.14, 9992126.46],
		[3129387.12, 9967223.25],
		[3104553.60, 9967620.70],
	]], [[	/* 736:355 */
		[3129387.12, 9967223.25],
		[3129830.14, 9992126.46],
		[3154749.05, 9991636.58],
		[3154217.20, 9966737.18],
		[3129387.12, 9967223.25],
	]], [[	/* 736:356 */
		[3154217.20, 9966737.18],
		[3154749.05, 9991636.58],
		[3179663.77, 9991057.44],
		[3179043.13, 9966162.56],
		[3154217.20, 9966737.18],
	]], [[	/* 736:357 */
		[3179043.13, 9966162.56],
		[3179663.77, 9991057.44],
		[3204573.61, 9990389.10],
		[3203864.23, 9965499.42],
		[3179043.13, 9966162.56],
	]], [[	/* 736:358 */
		[3203864.23, 9965499.42],
		[3204573.61, 9990389.10],
		[3229477.85, 9989631.61],
		[3228679.81, 9964747.83],
		[3203864.23, 9965499.42],
	]], [[	/* 736:359 */
		[3228679.81, 9964747.83],
		[3229477.85, 9989631.61],
		[3254375.82, 9988785.04],
		[3253489.17, 9963907.85],
		[3228679.81, 9964747.83],
	]], [[	/* 736:360 */
		[3253489.17, 9963907.85],
		[3254375.82, 9988785.04],
		[3279266.81, 9987849.46],
		[3278291.64, 9962979.56],
		[3253489.17, 9963907.85],
	]], [[	/* 736:361 */
		[3278291.64, 9962979.56],
		[3279266.81, 9987849.46],
		[3304150.13, 9986824.97],
		[3303086.53, 9961963.04],
		[3278291.64, 9962979.56],
	]], [[	/* 737:335 */
		[2631649.96, 9983171.05],
		[2630308.03, 10008092.90],
		[2655252.67, 10009396.92],
		[2656505.78, 9984464.90],
		[2631649.96, 9983171.05],
	]], [[	/* 737:336 */
		[2656505.78, 9984464.90],
		[2655252.67, 10009396.92],
		[2680207.18, 10010611.63],
		[2681371.37, 9985670.13],
		[2656505.78, 9984464.90],
	]], [[	/* 737:337 */
		[2681371.37, 9985670.13],
		[2680207.18, 10010611.63],
		[2705170.88, 10011736.92],
		[2706246.04, 9986786.63],
		[2681371.37, 9985670.13],
	]], [[	/* 737:338 */
		[2706246.04, 9986786.63],
		[2705170.88, 10011736.92],
		[2730143.06, 10012772.68],
		[2731129.09, 9987814.31],
		[2706246.04, 9986786.63],
	]], [[	/* 737:339 */
		[2731129.09, 9987814.31],
		[2730143.06, 10012772.68],
		[2755123.02, 10013718.83],
		[2756019.84, 9988753.07],
		[2731129.09, 9987814.31],
	]], [[	/* 737:340 */
		[2756019.84, 9988753.07],
		[2755123.02, 10013718.83],
		[2780110.06, 10014575.28],
		[2780917.58, 9989602.83],
		[2756019.84, 9988753.07],
	]], [[	/* 737:341 */
		[2780917.58, 9989602.83],
		[2780110.06, 10014575.28],
		[2805103.47, 10015341.95],
		[2805821.63, 9990363.51],
		[2780917.58, 9989602.83],
	]], [[	/* 737:342 */
		[2805821.63, 9990363.51],
		[2805103.47, 10015341.95],
		[2830102.56, 10016018.78],
		[2830731.29, 9991035.05],
		[2805821.63, 9990363.51],
	]], [[	/* 737:343 */
		[2830731.29, 9991035.05],
		[2830102.56, 10016018.78],
		[2855106.61, 10016605.70],
		[2855645.86, 9991617.38],
		[2830731.29, 9991035.05],
	]], [[	/* 737:344 */
		[2855645.86, 9991617.38],
		[2855106.61, 10016605.70],
		[2880114.93, 10017102.67],
		[2880564.64, 9992110.46],
		[2855645.86, 9991617.38],
	]], [[	/* 737:345 */
		[2880564.64, 9992110.46],
		[2880114.93, 10017102.67],
		[2905126.80, 10017509.63],
		[2905486.94, 9992514.24],
		[2880564.64, 9992110.46],
	]], [[	/* 737:346 */
		[2905486.94, 9992514.24],
		[2905126.80, 10017509.63],
		[2930141.51, 10017826.55],
		[2930412.05, 9992828.68],
		[2905486.94, 9992514.24],
	]], [[	/* 737:347 */
		[2930412.05, 9992828.68],
		[2930141.51, 10017826.55],
		[2955158.36, 10018053.40],
		[2955339.27, 9993053.76],
		[2930412.05, 9992828.68],
	]], [[	/* 737:348 */
		[2955339.27, 9993053.76],
		[2955158.36, 10018053.40],
		[2980176.64, 10018190.17],
		[2980267.90, 9993189.46],
		[2955339.27, 9993053.76],
	]], [[	/* 737:349 */
		[2980267.90, 9993189.46],
		[2980176.64, 10018190.17],
		[3005195.64, 10018236.83],
		[3005197.25, 9993235.76],
		[2980267.90, 9993189.46],
	]], [[	/* 737:350 */
		[3005197.25, 9993235.76],
		[3005195.64, 10018236.83],
		[3030214.66, 10018193.39],
		[3030126.61, 9993192.66],
		[3005197.25, 9993235.76],
	]], [[	/* 737:351 */
		[3030126.61, 9993192.66],
		[3030214.66, 10018193.39],
		[3055232.97, 10018059.85],
		[3055055.28, 9993060.16],
		[3030126.61, 9993192.66],
	]], [[	/* 737:352 */
		[3055055.28, 9993060.16],
		[3055232.97, 10018059.85],
		[3080249.88, 10017836.22],
		[3079982.56, 9992838.28],
		[3055055.28, 9993060.16],
	]], [[	/* 737:353 */
		[3079982.56, 9992838.28],
		[3080249.88, 10017836.22],
		[3105264.68, 10017522.52],
		[3104907.74, 9992527.04],
		[3079982.56, 9992838.28],
	]], [[	/* 737:354 */
		[3104907.74, 9992527.04],
		[3105264.68, 10017522.52],
		[3130276.65, 10017118.78],
		[3129830.14, 9992126.46],
		[3104907.74, 9992527.04],
	]], [[	/* 737:355 */
		[3129830.14, 9992126.46],
		[3130276.65, 10017118.78],
		[3155285.10, 10016625.04],
		[3154749.05, 9991636.58],
		[3129830.14, 9992126.46],
	]], [[	/* 737:356 */
		[3154749.05, 9991636.58],
		[3155285.10, 10016625.04],
		[3180289.30, 10016041.34],
		[3179663.77, 9991057.44],
		[3154749.05, 9991636.58],
	]], [[	/* 737:357 */
		[3179663.77, 9991057.44],
		[3180289.30, 10016041.34],
		[3205288.57, 10015367.73],
		[3204573.61, 9990389.10],
		[3179663.77, 9991057.44],
	]], [[	/* 737:358 */
		[3204573.61, 9990389.10],
		[3205288.57, 10015367.73],
		[3230282.18, 10014604.27],
		[3229477.85, 9989631.61],
		[3204573.61, 9990389.10],
	]], [[	/* 737:359 */
		[3229477.85, 9989631.61],
		[3230282.18, 10014604.27],
		[3255269.45, 10013751.03],
		[3254375.82, 9988785.04],
		[3229477.85, 9989631.61],
	]], [[	/* 737:360 */
		[3254375.82, 9988785.04],
		[3255269.45, 10013751.03],
		[3280249.65, 10012808.09],
		[3279266.81, 9987849.46],
		[3254375.82, 9988785.04],
	]], [[	/* 737:361 */
		[3279266.81, 9987849.46],
		[3280249.65, 10012808.09],
		[3305222.10, 10011775.53],
		[3304150.13, 9986824.97],
		[3279266.81, 9987849.46],
	]], [[	/* 738:335 */
		[2630308.03, 10008092.90],
		[2628955.53, 10033103.76],
		[2653989.67, 10034418.07],
		[2655252.67, 10009396.92],
		[2630308.03, 10008092.90],
	]], [[	/* 738:336 */
		[2655252.67, 10009396.92],
		[2653989.67, 10034418.07],
		[2679033.81, 10035642.37],
		[2680207.18, 10010611.63],
		[2655252.67, 10009396.92],
	]], [[	/* 738:337 */
		[2680207.18, 10010611.63],
		[2679033.81, 10035642.37],
		[2704087.24, 10036776.54],
		[2705170.88, 10011736.92],
		[2680207.18, 10010611.63],
	]], [[	/* 738:338 */
		[2705170.88, 10011736.92],
		[2704087.24, 10036776.54],
		[2729149.24, 10037820.48],
		[2730143.06, 10012772.68],
		[2705170.88, 10011736.92],
	]], [[	/* 738:339 */
		[2730143.06, 10012772.68],
		[2729149.24, 10037820.48],
		[2754219.12, 10038774.10],
		[2755123.02, 10013718.83],
		[2730143.06, 10012772.68],
	]], [[	/* 738:340 */
		[2755123.02, 10013718.83],
		[2754219.12, 10038774.10],
		[2779296.15, 10039637.32],
		[2780110.06, 10014575.28],
		[2755123.02, 10013718.83],
	]], [[	/* 738:341 */
		[2780110.06, 10014575.28],
		[2779296.15, 10039637.32],
		[2804379.64, 10040410.05],
		[2805103.47, 10015341.95],
		[2780110.06, 10014575.28],
	]], [[	/* 738:342 */
		[2805103.47, 10015341.95],
		[2804379.64, 10040410.05],
		[2829468.86, 10041092.23],
		[2830102.56, 10016018.78],
		[2805103.47, 10015341.95],
	]], [[	/* 738:343 */
		[2830102.56, 10016018.78],
		[2829468.86, 10041092.23],
		[2854563.10, 10041683.79],
		[2855106.61, 10016605.70],
		[2830102.56, 10016018.78],
	]], [[	/* 738:344 */
		[2855106.61, 10016605.70],
		[2854563.10, 10041683.79],
		[2879661.66, 10042184.68],
		[2880114.93, 10017102.67],
		[2855106.61, 10016605.70],
	]], [[	/* 738:345 */
		[2880114.93, 10017102.67],
		[2879661.66, 10042184.68],
		[2904763.81, 10042594.86],
		[2905126.80, 10017509.63],
		[2880114.93, 10017102.67],
	]], [[	/* 738:346 */
		[2905126.80, 10017509.63],
		[2904763.81, 10042594.86],
		[2929868.84, 10042914.29],
		[2930141.51, 10017826.55],
		[2905126.80, 10017509.63],
	]], [[	/* 738:347 */
		[2930141.51, 10017826.55],
		[2929868.84, 10042914.29],
		[2954976.03, 10043142.94],
		[2955158.36, 10018053.40],
		[2930141.51, 10017826.55],
	]], [[	/* 738:348 */
		[2955158.36, 10018053.40],
		[2954976.03, 10043142.94],
		[2980084.66, 10043280.78],
		[2980176.64, 10018190.17],
		[2955158.36, 10018053.40],
	]], [[	/* 738:349 */
		[2980176.64, 10018190.17],
		[2980084.66, 10043280.78],
		[3005194.03, 10043327.82],
		[3005195.64, 10018236.83],
		[2980176.64, 10018190.17],
	]], [[	/* 738:350 */
		[3005195.64, 10018236.83],
		[3005194.03, 10043327.82],
		[3030303.40, 10043284.03],
		[3030214.66, 10018193.39],
		[3005195.64, 10018236.83],
	]], [[	/* 738:351 */
		[3030214.66, 10018193.39],
		[3030303.40, 10043284.03],
		[3055412.08, 10043149.43],
		[3055232.97, 10018059.85],
		[3030214.66, 10018193.39],
	]], [[	/* 738:352 */
		[3055232.97, 10018059.85],
		[3055412.08, 10043149.43],
		[3080519.32, 10042924.03],
		[3080249.88, 10017836.22],
		[3055232.97, 10018059.85],
	]], [[	/* 738:353 */
		[3080249.88, 10017836.22],
		[3080519.32, 10042924.03],
		[3105624.44, 10042607.85],
		[3105264.68, 10017522.52],
		[3080249.88, 10017836.22],
	]], [[	/* 738:354 */
		[3105264.68, 10017522.52],
		[3105624.44, 10042607.85],
		[3130726.69, 10042200.92],
		[3130276.65, 10017118.78],
		[3105264.68, 10017522.52],
	]], [[	/* 738:355 */
		[3130276.65, 10017118.78],
		[3130726.69, 10042200.92],
		[3155825.38, 10041703.27],
		[3155285.10, 10016625.04],
		[3130276.65, 10017118.78],
	]], [[	/* 738:356 */
		[3155285.10, 10016625.04],
		[3155825.38, 10041703.27],
		[3180919.78, 10041114.95],
		[3180289.30, 10016041.34],
		[3155285.10, 10016625.04],
	]], [[	/* 738:357 */
		[3180289.30, 10016041.34],
		[3180919.78, 10041114.95],
		[3206009.18, 10040436.01],
		[3205288.57, 10015367.73],
		[3180289.30, 10016041.34],
	]], [[	/* 738:358 */
		[3205288.57, 10015367.73],
		[3206009.18, 10040436.01],
		[3231092.87, 10039666.52],
		[3230282.18, 10014604.27],
		[3205288.57, 10015367.73],
	]], [[	/* 738:359 */
		[3230282.18, 10014604.27],
		[3231092.87, 10039666.52],
		[3256170.13, 10038806.54],
		[3255269.45, 10013751.03],
		[3230282.18, 10014604.27],
	]], [[	/* 738:360 */
		[3255269.45, 10013751.03],
		[3256170.13, 10038806.54],
		[3281240.25, 10037856.15],
		[3280249.65, 10012808.09],
		[3255269.45, 10013751.03],
	]], [[	/* 738:361 */
		[3280249.65, 10012808.09],
		[3281240.25, 10037856.15],
		[3306302.53, 10036815.43],
		[3305222.10, 10011775.53],
		[3280249.65, 10012808.09],
	]], [[	/* 739:336 */
		[2653989.67, 10034418.07],
		[2652716.69, 10059529.04],
		[2677851.16, 10060763.03],
		[2679033.81, 10035642.37],
		[2653989.67, 10034418.07],
	]], [[	/* 739:337 */
		[2679033.81, 10035642.37],
		[2677851.16, 10060763.03],
		[2702995.02, 10061906.19],
		[2704087.24, 10036776.54],
		[2679033.81, 10035642.37],
	]], [[	/* 739:338 */
		[2704087.24, 10036776.54],
		[2702995.02, 10061906.19],
		[2728147.55, 10062958.41],
		[2729149.24, 10037820.48],
		[2704087.24, 10036776.54],
	]], [[	/* 739:339 */
		[2729149.24, 10037820.48],
		[2728147.55, 10062958.41],
		[2753308.05, 10063919.59],
		[2754219.12, 10038774.10],
		[2729149.24, 10037820.48],
	]], [[	/* 739:340 */
		[2754219.12, 10038774.10],
		[2753308.05, 10063919.59],
		[2778475.80, 10064789.65],
		[2779296.15, 10039637.32],
		[2754219.12, 10038774.10],
	]], [[	/* 739:341 */
		[2779296.15, 10039637.32],
		[2778475.80, 10064789.65],
		[2803650.06, 10065568.51],
		[2804379.64, 10040410.05],
		[2779296.15, 10039637.32],
	]], [[	/* 739:342 */
		[2804379.64, 10040410.05],
		[2803650.06, 10065568.51],
		[2828830.13, 10066256.10],
		[2829468.86, 10041092.23],
		[2804379.64, 10040410.05],
	]], [[	/* 739:343 */
		[2829468.86, 10041092.23],
		[2828830.13, 10066256.10],
		[2854015.29, 10066852.36],
		[2854563.10, 10041683.79],
		[2829468.86, 10041092.23],
	]], [[	/* 739:344 */
		[2854563.10, 10041683.79],
		[2854015.29, 10066852.36],
		[2879204.80, 10067357.22],
		[2879661.66, 10042184.68],
		[2854563.10, 10041683.79],
	]], [[	/* 739:345 */
		[2879661.66, 10042184.68],
		[2879204.80, 10067357.22],
		[2904397.94, 10067770.66],
		[2904763.81, 10042594.86],
		[2879661.66, 10042184.68],
	]], [[	/* 739:346 */
		[2904763.81, 10042594.86],
		[2904397.94, 10067770.66],
		[2929594.00, 10068092.62],
		[2929868.84, 10042914.29],
		[2904763.81, 10042594.86],
	]], [[	/* 739:347 */
		[2929868.84, 10042914.29],
		[2929594.00, 10068092.62],
		[2954792.25, 10068323.08],
		[2954976.03, 10043142.94],
		[2929868.84, 10042914.29],
	]], [[	/* 739:348 */
		[2954976.03, 10043142.94],
		[2954792.25, 10068323.08],
		[2979991.95, 10068462.02],
		[2980084.66, 10043280.78],
		[2954976.03, 10043142.94],
	]], [[	/* 739:349 */
		[2980084.66, 10043280.78],
		[2979991.95, 10068462.02],
		[3005192.40, 10068509.43],
		[3005194.03, 10043327.82],
		[2980084.66, 10043280.78],
	]], [[	/* 739:350 */
		[3005194.03, 10043327.82],
		[3005192.40, 10068509.43],
		[3030392.86, 10068465.29],
		[3030303.40, 10043284.03],
		[3005194.03, 10043327.82],
	]], [[	/* 739:351 */
		[3030303.40, 10043284.03],
		[3030392.86, 10068465.29],
		[3055592.60, 10068329.63],
		[3055412.08, 10043149.43],
		[3030303.40, 10043284.03],
	]], [[	/* 739:352 */
		[3055412.08, 10043149.43],
		[3055592.60, 10068329.63],
		[3080790.91, 10068102.44],
		[3080519.32, 10042924.03],
		[3055412.08, 10043149.43],
	]], [[	/* 739:353 */
		[3080519.32, 10042924.03],
		[3080790.91, 10068102.44],
		[3105987.05, 10067783.74],
		[3105624.44, 10042607.85],
		[3080519.32, 10042924.03],
	]], [[	/* 739:354 */
		[3105624.44, 10042607.85],
		[3105987.05, 10067783.74],
		[3131180.30, 10067373.58],
		[3130726.69, 10042200.92],
		[3105624.44, 10042607.85],
	]], [[	/* 739:355 */
		[3130726.69, 10042200.92],
		[3131180.30, 10067373.58],
		[3156369.95, 10066871.98],
		[3155825.38, 10041703.27],
		[3130726.69, 10042200.92],
	]], [[	/* 739:356 */
		[3155825.38, 10041703.27],
		[3156369.95, 10066871.98],
		[3181555.25, 10066278.99],
		[3180919.78, 10041114.95],
		[3155825.38, 10041703.27],
	]], [[	/* 739:357 */
		[3180919.78, 10041114.95],
		[3181555.25, 10066278.99],
		[3206735.50, 10065594.66],
		[3206009.18, 10040436.01],
		[3180919.78, 10041114.95],
	]], [[	/* 739:358 */
		[3206009.18, 10040436.01],
		[3206735.50, 10065594.66],
		[3231909.97, 10064819.06],
		[3231092.87, 10039666.52],
		[3206009.18, 10040436.01],
	]], [[	/* 739:359 */
		[3231092.87, 10039666.52],
		[3231909.97, 10064819.06],
		[3257077.95, 10063952.26],
		[3256170.13, 10038806.54],
		[3231092.87, 10039666.52],
	]], [[	/* 739:360 */
		[3256170.13, 10038806.54],
		[3257077.95, 10063952.26],
		[3282238.70, 10062994.34],
		[3281240.25, 10037856.15],
		[3256170.13, 10038806.54],
	]], [[	/* 740:336 */
		[2652716.69, 10059529.04],
		[2651433.60, 10084730.54],
		[2676659.11, 10085974.34],
		[2677851.16, 10060763.03],
		[2652716.69, 10059529.04],
	]], [[	/* 740:337 */
		[2677851.16, 10060763.03],
		[2676659.11, 10085974.34],
		[2701894.12, 10087126.59],
		[2702995.02, 10061906.19],
		[2677851.16, 10060763.03],
	]], [[	/* 740:338 */
		[2702995.02, 10061906.19],
		[2701894.12, 10087126.59],
		[2727137.91, 10088187.17],
		[2728147.55, 10062958.41],
		[2702995.02, 10061906.19],
	]], [[	/* 740:339 */
		[2728147.55, 10062958.41],
		[2727137.91, 10088187.17],
		[2752389.75, 10089156.00],
		[2753308.05, 10063919.59],
		[2728147.55, 10062958.41],
	]], [[	/* 740:340 */
		[2753308.05, 10063919.59],
		[2752389.75, 10089156.00],
		[2777648.92, 10090032.99],
		[2778475.80, 10064789.65],
		[2753308.05, 10063919.59],
	]], [[	/* 740:341 */
		[2778475.80, 10064789.65],
		[2777648.92, 10090032.99],
		[2802914.69, 10090818.05],
		[2803650.06, 10065568.51],
		[2778475.80, 10064789.65],
	]], [[	/* 740:342 */
		[2803650.06, 10065568.51],
		[2802914.69, 10090818.05],
		[2828186.33, 10091511.11],
		[2828830.13, 10066256.10],
		[2803650.06, 10065568.51],
	]], [[	/* 740:343 */
		[2828830.13, 10066256.10],
		[2828186.33, 10091511.11],
		[2853463.11, 10092112.12],
		[2854015.29, 10066852.36],
		[2828830.13, 10066256.10],
	]], [[	/* 740:344 */
		[2854015.29, 10066852.36],
		[2853463.11, 10092112.12],
		[2878744.30, 10092621.01],
		[2879204.80, 10067357.22],
		[2854015.29, 10066852.36],
	]], [[	/* 740:345 */
		[2879204.80, 10067357.22],
		[2878744.30, 10092621.01],
		[2904029.16, 10093037.73],
		[2904397.94, 10067770.66],
		[2879204.80, 10067357.22],
	]], [[	/* 740:346 */
		[2904397.94, 10067770.66],
		[2904029.16, 10093037.73],
		[2929316.98, 10093362.26],
		[2929594.00, 10068092.62],
		[2904397.94, 10067770.66],
	]], [[	/* 740:347 */
		[2929594.00, 10068092.62],
		[2929316.98, 10093362.26],
		[2954607.00, 10093594.56],
		[2954792.25, 10068323.08],
		[2929594.00, 10068092.62],
	]], [[	/* 740:348 */
		[2954792.25, 10068323.08],
		[2954607.00, 10093594.56],
		[2979898.51, 10093734.60],
		[2979991.95, 10068462.02],
		[2954792.25, 10068323.08],
	]], [[	/* 740:349 */
		[2979991.95, 10068462.02],
		[2979898.51, 10093734.60],
		[3005190.76, 10093782.39],
		[3005192.40, 10068509.43],
		[2979991.95, 10068462.02],
	]], [[	/* 740:350 */
		[3005192.40, 10068509.43],
		[3005190.76, 10093782.39],
		[3030483.02, 10093737.90],
		[3030392.86, 10068465.29],
		[3005192.40, 10068509.43],
	]], [[	/* 740:351 */
		[3030392.86, 10068465.29],
		[3030483.02, 10093737.90],
		[3055774.56, 10093601.15],
		[3055592.60, 10068329.63],
		[3030392.86, 10068465.29],
	]], [[	/* 740:352 */
		[3055592.60, 10068329.63],
		[3055774.56, 10093601.15],
		[3081064.65, 10093372.15],
		[3080790.91, 10068102.44],
		[3055592.60, 10068329.63],
	]], [[	/* 740:353 */
		[3080790.91, 10068102.44],
		[3081064.65, 10093372.15],
		[3106352.55, 10093050.92],
		[3105987.05, 10067783.74],
		[3080790.91, 10068102.44],
	]], [[	/* 740:354 */
		[3105987.05, 10067783.74],
		[3106352.55, 10093050.92],
		[3131637.52, 10092637.48],
		[3131180.30, 10067373.58],
		[3105987.05, 10067783.74],
	]], [[	/* 740:355 */
		[3131180.30, 10067373.58],
		[3131637.52, 10092637.48],
		[3156918.85, 10092131.88],
		[3156369.95, 10066871.98],
		[3131180.30, 10067373.58],
	]], [[	/* 740:356 */
		[3156369.95, 10066871.98],
		[3156918.85, 10092131.88],
		[3182195.79, 10091534.17],
		[3181555.25, 10066278.99],
		[3156369.95, 10066871.98],
	]], [[	/* 740:357 */
		[3181555.25, 10066278.99],
		[3182195.79, 10091534.17],
		[3207467.61, 10090844.39],
		[3206735.50, 10065594.66],
		[3181555.25, 10066278.99],
	]], [[	/* 740:358 */
		[3206735.50, 10065594.66],
		[3207467.61, 10090844.39],
		[3232733.58, 10090062.62],
		[3231909.97, 10064819.06],
		[3206735.50, 10065594.66],
	]], [[	/* 740:359 */
		[3231909.97, 10064819.06],
		[3232733.58, 10090062.62],
		[3257992.98, 10089188.92],
		[3257077.95, 10063952.26],
		[3231909.97, 10064819.06],
	]], [[	/* 740:360 */
		[3257077.95, 10063952.26],
		[3257992.98, 10089188.92],
		[3283245.08, 10088223.37],
		[3282238.70, 10062994.34],
		[3257077.95, 10063952.26],
	]], [[	/* 741:336 */
		[2651433.60, 10084730.54],
		[2650140.28, 10110023.30],
		[2675457.55, 10111277.01],
		[2676659.11, 10085974.34],
		[2651433.60, 10084730.54],
	]], [[	/* 741:337 */
		[2676659.11, 10085974.34],
		[2675457.55, 10111277.01],
		[2700784.44, 10112438.45],
		[2701894.12, 10087126.59],
		[2676659.11, 10085974.34],
	]], [[	/* 741:338 */
		[2701894.12, 10087126.59],
		[2700784.44, 10112438.45],
		[2726120.20, 10113507.50],
		[2727137.91, 10088187.17],
		[2701894.12, 10087126.59],
	]], [[	/* 741:339 */
		[2727137.91, 10088187.17],
		[2726120.20, 10113507.50],
		[2751464.12, 10114484.07],
		[2752389.75, 10089156.00],
		[2727137.91, 10088187.17],
	]], [[	/* 741:340 */
		[2752389.75, 10089156.00],
		[2751464.12, 10114484.07],
		[2776815.44, 10115368.06],
		[2777648.92, 10090032.99],
		[2752389.75, 10089156.00],
	]], [[	/* 741:341 */
		[2777648.92, 10090032.99],
		[2776815.44, 10115368.06],
		[2802173.44, 10116159.39],
		[2802914.69, 10090818.05],
		[2777648.92, 10090032.99],
	]], [[	/* 741:342 */
		[2802914.69, 10090818.05],
		[2802173.44, 10116159.39],
		[2827537.38, 10116857.99],
		[2828186.33, 10091511.11],
		[2802914.69, 10090818.05],
	]], [[	/* 741:343 */
		[2828186.33, 10091511.11],
		[2827537.38, 10116857.99],
		[2852906.52, 10117463.80],
		[2853463.11, 10092112.12],
		[2828186.33, 10091511.11],
	]], [[	/* 741:344 */
		[2853463.11, 10092112.12],
		[2852906.52, 10117463.80],
		[2878280.12, 10117976.76],
		[2878744.30, 10092621.01],
		[2853463.11, 10092112.12],
	]], [[	/* 741:345 */
		[2878744.30, 10092621.01],
		[2878280.12, 10117976.76],
		[2903657.44, 10118396.82],
		[2904029.16, 10093037.73],
		[2878744.30, 10092621.01],
	]], [[	/* 741:346 */
		[2904029.16, 10093037.73],
		[2903657.44, 10118396.82],
		[2929037.74, 10118723.94],
		[2929316.98, 10093362.26],
		[2904029.16, 10093037.73],
	]], [[	/* 741:347 */
		[2929316.98, 10093362.26],
		[2929037.74, 10118723.94],
		[2954420.28, 10118958.09],
		[2954607.00, 10093594.56],
		[2929316.98, 10093362.26],
	]], [[	/* 741:348 */
		[2954607.00, 10093594.56],
		[2954420.28, 10118958.09],
		[2979804.32, 10119099.26],
		[2979898.51, 10093734.60],
		[2954607.00, 10093594.56],
	]], [[	/* 741:349 */
		[2979898.51, 10093734.60],
		[2979804.32, 10119099.26],
		[3005189.11, 10119147.42],
		[3005190.76, 10093782.39],
		[2979898.51, 10093734.60],
	]], [[	/* 741:350 */
		[3005190.76, 10093782.39],
		[3005189.11, 10119147.42],
		[3030573.91, 10119102.58],
		[3030483.02, 10093737.90],
		[3005190.76, 10093782.39],
	]], [[	/* 741:351 */
		[3030483.02, 10093737.90],
		[3030573.91, 10119102.58],
		[3055957.98, 10118964.73],
		[3055774.56, 10093601.15],
		[3030483.02, 10093737.90],
	]], [[	/* 741:352 */
		[3055774.56, 10093601.15],
		[3055957.98, 10118964.73],
		[3081340.58, 10118733.90],
		[3081064.65, 10093372.15],
		[3055774.56, 10093601.15],
	]], [[	/* 741:353 */
		[3081064.65, 10093372.15],
		[3081340.58, 10118733.90],
		[3106720.97, 10118410.10],
		[3106352.55, 10093050.92],
		[3081064.65, 10093372.15],
	]], [[	/* 741:354 */
		[3106352.55, 10093050.92],
		[3106720.97, 10118410.10],
		[3132098.40, 10117993.36],
		[3131637.52, 10092637.48],
		[3106352.55, 10093050.92],
	]], [[	/* 741:355 */
		[3131637.52, 10092637.48],
		[3132098.40, 10117993.36],
		[3157472.13, 10117483.72],
		[3156918.85, 10092131.88],
		[3131637.52, 10092637.48],
	]], [[	/* 741:356 */
		[3156918.85, 10092131.88],
		[3157472.13, 10117483.72],
		[3182841.43, 10116881.22],
		[3182195.79, 10091534.17],
		[3156918.85, 10092131.88],
	]], [[	/* 741:357 */
		[3182195.79, 10091534.17],
		[3182841.43, 10116881.22],
		[3208205.56, 10116185.93],
		[3207467.61, 10090844.39],
		[3182195.79, 10091534.17],
	]], [[	/* 741:358 */
		[3207467.61, 10090844.39],
		[3208205.56, 10116185.93],
		[3233563.77, 10115397.91],
		[3232733.58, 10090062.62],
		[3207467.61, 10090844.39],
	]], [[	/* 741:359 */
		[3232733.58, 10090062.62],
		[3233563.77, 10115397.91],
		[3258915.33, 10114517.23],
		[3257992.98, 10089188.92],
		[3232733.58, 10090062.62],
	]], [[	/* 742:336 */
		[2650140.28, 10110023.30],
		[2648836.62, 10135408.02],
		[2674246.39, 10136671.77],
		[2675457.55, 10111277.01],
		[2650140.28, 10110023.30],
	]], [[	/* 742:337 */
		[2675457.55, 10111277.01],
		[2674246.39, 10136671.77],
		[2699665.88, 10137842.51],
		[2700784.44, 10112438.45],
		[2675457.55, 10111277.01],
	]], [[	/* 742:338 */
		[2700784.44, 10112438.45],
		[2699665.88, 10137842.51],
		[2725094.35, 10138920.13],
		[2726120.20, 10113507.50],
		[2700784.44, 10112438.45],
	]], [[	/* 742:339 */
		[2726120.20, 10113507.50],
		[2725094.35, 10138920.13],
		[2750531.07, 10139904.52],
		[2751464.12, 10114484.07],
		[2726120.20, 10113507.50],
	]], [[	/* 742:340 */
		[2751464.12, 10114484.07],
		[2750531.07, 10139904.52],
		[2775975.29, 10140795.60],
		[2776815.44, 10115368.06],
		[2751464.12, 10114484.07],
	]], [[	/* 742:341 */
		[2776815.44, 10115368.06],
		[2775975.29, 10140795.60],
		[2801426.26, 10141593.27],
		[2802173.44, 10116159.39],
		[2776815.44, 10115368.06],
	]], [[	/* 742:342 */
		[2802173.44, 10116159.39],
		[2801426.26, 10141593.27],
		[2826883.23, 10142297.48],
		[2827537.38, 10116857.99],
		[2802173.44, 10116159.39],
	]], [[	/* 742:343 */
		[2827537.38, 10116857.99],
		[2826883.23, 10142297.48],
		[2852345.47, 10142908.15],
		[2852906.52, 10117463.80],
		[2827537.38, 10116857.99],
	]], [[	/* 742:344 */
		[2852906.52, 10117463.80],
		[2852345.47, 10142908.15],
		[2877812.22, 10143425.22],
		[2878280.12, 10117976.76],
		[2852906.52, 10117463.80],
	]], [[	/* 742:345 */
		[2878280.12, 10117976.76],
		[2877812.22, 10143425.22],
		[2903282.74, 10143848.65],
		[2903657.44, 10118396.82],
		[2878280.12, 10117976.76],
	]], [[	/* 742:346 */
		[2903657.44, 10118396.82],
		[2903282.74, 10143848.65],
		[2928756.27, 10144178.39],
		[2929037.74, 10118723.94],
		[2903657.44, 10118396.82],
	]], [[	/* 742:347 */
		[2929037.74, 10118723.94],
		[2928756.27, 10144178.39],
		[2954232.06, 10144414.42],
		[2954420.28, 10118958.09],
		[2929037.74, 10118723.94],
	]], [[	/* 742:348 */
		[2954420.28, 10118958.09],
		[2954232.06, 10144414.42],
		[2979709.37, 10144556.72],
		[2979804.32, 10119099.26],
		[2954420.28, 10118958.09],
	]], [[	/* 742:349 */
		[2979804.32, 10119099.26],
		[2979709.37, 10144556.72],
		[3005187.44, 10144605.27],
		[3005189.11, 10119147.42],
		[2979804.32, 10119099.26],
	]], [[	/* 742:350 */
		[3005189.11, 10119147.42],
		[3005187.44, 10144605.27],
		[3030665.53, 10144560.07],
		[3030573.91, 10119102.58],
		[3005189.11, 10119147.42],
	]], [[	/* 742:351 */
		[3030573.91, 10119102.58],
		[3030665.53, 10144560.07],
		[3056142.87, 10144421.11],
		[3055957.98, 10118964.73],
		[3030573.91, 10119102.58],
	]], [[	/* 742:352 */
		[3055957.98, 10118964.73],
		[3056142.87, 10144421.11],
		[3081618.73, 10144188.43],
		[3081340.58, 10118733.90],
		[3055957.98, 10118964.73],
	]], [[	/* 742:353 */
		[3081340.58, 10118733.90],
		[3081618.73, 10144188.43],
		[3107092.34, 10143862.02],
		[3106720.97, 10118410.10],
		[3081340.58, 10118733.90],
	]], [[	/* 742:354 */
		[3106720.97, 10118410.10],
		[3107092.34, 10143862.02],
		[3132562.97, 10143441.94],
		[3132098.40, 10117993.36],
		[3106720.97, 10118410.10],
	]], [[	/* 742:355 */
		[3132098.40, 10117993.36],
		[3132562.97, 10143441.94],
		[3158029.86, 10142928.21],
		[3157472.13, 10117483.72],
		[3132098.40, 10117993.36],
	]], [[	/* 742:356 */
		[3157472.13, 10117483.72],
		[3158029.86, 10142928.21],
		[3183492.26, 10142320.88],
		[3182841.43, 10116881.22],
		[3157472.13, 10117483.72],
	]], [[	/* 742:357 */
		[3182841.43, 10116881.22],
		[3183492.26, 10142320.88],
		[3208949.42, 10141620.01],
		[3208205.56, 10116185.93],
		[3182841.43, 10116881.22],
	]], [[	/* 742:358 */
		[3208205.56, 10116185.93],
		[3208949.42, 10141620.01],
		[3234400.60, 10140825.67],
		[3233563.77, 10115397.91],
		[3208205.56, 10116185.93],
	]], [[	/* 742:359 */
		[3233563.77, 10115397.91],
		[3234400.60, 10140825.67],
		[3259845.06, 10139937.93],
		[3258915.33, 10114517.23],
		[3233563.77, 10115397.91],
	]], [[	/* 743:335 */
		[2623437.32, 10134051.36],
		[2622030.08, 10159517.90],
		[2647522.50, 10160885.45],
		[2648836.62, 10135408.02],
		[2623437.32, 10134051.36],
	]], [[	/* 743:336 */
		[2648836.62, 10135408.02],
		[2647522.50, 10160885.45],
		[2673025.50, 10162159.36],
		[2674246.39, 10136671.77],
		[2648836.62, 10135408.02],
	]], [[	/* 743:337 */
		[2674246.39, 10136671.77],
		[2673025.50, 10162159.36],
		[2698538.34, 10163339.51],
		[2699665.88, 10137842.51],
		[2674246.39, 10136671.77],
	]], [[	/* 743:338 */
		[2699665.88, 10137842.51],
		[2698538.34, 10163339.51],
		[2724060.26, 10164425.79],
		[2725094.35, 10138920.13],
		[2699665.88, 10137842.51],
	]], [[	/* 743:339 */
		[2725094.35, 10138920.13],
		[2724060.26, 10164425.79],
		[2749590.53, 10165418.10],
		[2750531.07, 10139904.52],
		[2725094.35, 10138920.13],
	]], [[	/* 743:340 */
		[2750531.07, 10139904.52],
		[2749590.53, 10165418.10],
		[2775128.38, 10166316.34],
		[2775975.29, 10140795.60],
		[2750531.07, 10139904.52],
	]], [[	/* 743:341 */
		[2775975.29, 10140795.60],
		[2775128.38, 10166316.34],
		[2800673.06, 10167120.44],
		[2801426.26, 10141593.27],
		[2775975.29, 10140795.60],
	]], [[	/* 743:342 */
		[2801426.26, 10141593.27],
		[2800673.06, 10167120.44],
		[2826223.83, 10167830.31],
		[2826883.23, 10142297.48],
		[2801426.26, 10141593.27],
	]], [[	/* 743:343 */
		[2826883.23, 10142297.48],
		[2826223.83, 10167830.31],
		[2851779.91, 10168445.89],
		[2852345.47, 10142908.15],
		[2826883.23, 10142297.48],
	]], [[	/* 743:344 */
		[2852345.47, 10142908.15],
		[2851779.91, 10168445.89],
		[2877340.56, 10168967.13],
		[2877812.22, 10143425.22],
		[2852345.47, 10142908.15],
	]], [[	/* 743:345 */
		[2877812.22, 10143425.22],
		[2877340.56, 10168967.13],
		[2902905.02, 10169393.96],
		[2903282.74, 10143848.65],
		[2877812.22, 10143425.22],
	]], [[	/* 743:346 */
		[2903282.74, 10143848.65],
		[2902905.02, 10169393.96],
		[2928472.53, 10169726.37],
		[2928756.27, 10144178.39],
		[2903282.74, 10143848.65],
	]], [[	/* 743:347 */
		[2928756.27, 10144178.39],
		[2928472.53, 10169726.37],
		[2954042.33, 10169964.30],
		[2954232.06, 10144414.42],
		[2928756.27, 10144178.39],
	]], [[	/* 743:348 */
		[2954232.06, 10144414.42],
		[2954042.33, 10169964.30],
		[2979613.66, 10170107.74],
		[2979709.37, 10144556.72],
		[2954232.06, 10144414.42],
	]], [[	/* 743:349 */
		[2979709.37, 10144556.72],
		[2979613.66, 10170107.74],
		[3005185.76, 10170156.68],
		[3005187.44, 10144605.27],
		[2979709.37, 10144556.72],
	]], [[	/* 743:350 */
		[3005187.44, 10144605.27],
		[3005185.76, 10170156.68],
		[3030757.88, 10170111.11],
		[3030665.53, 10144560.07],
		[3005187.44, 10144605.27],
	]], [[	/* 743:351 */
		[3030665.53, 10144560.07],
		[3030757.88, 10170111.11],
		[3056329.25, 10169971.04],
		[3056142.87, 10144421.11],
		[3030665.53, 10144560.07],
	]], [[	/* 743:352 */
		[3056142.87, 10144421.11],
		[3056329.25, 10169971.04],
		[3081899.11, 10169736.48],
		[3081618.73, 10144188.43],
		[3056142.87, 10144421.11],
	]], [[	/* 743:353 */
		[3081618.73, 10144188.43],
		[3081899.11, 10169736.48],
		[3107466.71, 10169407.44],
		[3107092.34, 10143862.02],
		[3081618.73, 10144188.43],
	]], [[	/* 743:354 */
		[3107092.34, 10143862.02],
		[3107466.71, 10169407.44],
		[3133031.28, 10168983.97],
		[3132562.97, 10143441.94],
		[3107092.34, 10143862.02],
	]], [[	/* 743:355 */
		[3132562.97, 10143441.94],
		[3133031.28, 10168983.97],
		[3158592.07, 10168466.10],
		[3158029.86, 10142928.21],
		[3132562.97, 10143441.94],
	]], [[	/* 743:356 */
		[3158029.86, 10142928.21],
		[3158592.07, 10168466.10],
		[3184148.32, 10167853.89],
		[3183492.26, 10142320.88],
		[3158029.86, 10142928.21],
	]], [[	/* 743:357 */
		[3183492.26, 10142320.88],
		[3184148.32, 10167853.89],
		[3209699.27, 10167147.38],
		[3208949.42, 10141620.01],
		[3183492.26, 10142320.88],
	]], [[	/* 743:358 */
		[3208949.42, 10141620.01],
		[3209699.27, 10167147.38],
		[3235244.17, 10166346.64],
		[3234400.60, 10140825.67],
		[3208949.42, 10141620.01],
	]], [[	/* 743:359 */
		[3234400.60, 10140825.67],
		[3235244.17, 10166346.64],
		[3260782.26, 10165451.75],
		[3259845.06, 10139937.93],
		[3234400.60, 10140825.67],
	]], [[	/* 744:335 */
		[2622030.08, 10159517.90],
		[2620611.52, 10185077.76],
		[2646197.79, 10186456.33],
		[2647522.50, 10160885.45],
		[2622030.08, 10159517.90],
	]], [[	/* 744:336 */
		[2647522.50, 10160885.45],
		[2646197.79, 10186456.33],
		[2671794.77, 10187740.51],
		[2673025.50, 10162159.36],
		[2647522.50, 10160885.45],
	]], [[	/* 744:337 */
		[2673025.50, 10162159.36],
		[2671794.77, 10187740.51],
		[2697401.70, 10188930.18],
		[2698538.34, 10163339.51],
		[2673025.50, 10162159.36],
	]], [[	/* 744:338 */
		[2698538.34, 10163339.51],
		[2697401.70, 10188930.18],
		[2723017.83, 10190025.22],
		[2724060.26, 10164425.79],
		[2698538.34, 10163339.51],
	]], [[	/* 744:339 */
		[2724060.26, 10164425.79],
		[2723017.83, 10190025.22],
		[2748642.40, 10191025.54],
		[2749590.53, 10165418.10],
		[2724060.26, 10164425.79],
	]], [[	/* 744:340 */
		[2749590.53, 10165418.10],
		[2748642.40, 10191025.54],
		[2774274.64, 10191931.04],
		[2775128.38, 10166316.34],
		[2749590.53, 10165418.10],
	]], [[	/* 744:341 */
		[2775128.38, 10166316.34],
		[2774274.64, 10191931.04],
		[2799913.79, 10192741.63],
		[2800673.06, 10167120.44],
		[2775128.38, 10166316.34],
	]], [[	/* 744:342 */
		[2800673.06, 10167120.44],
		[2799913.79, 10192741.63],
		[2825559.10, 10193457.24],
		[2826223.83, 10167830.31],
		[2800673.06, 10167120.44],
	]], [[	/* 744:343 */
		[2826223.83, 10167830.31],
		[2825559.10, 10193457.24],
		[2851209.78, 10194077.79],
		[2851779.91, 10168445.89],
		[2826223.83, 10167830.31],
	]], [[	/* 744:344 */
		[2851779.91, 10168445.89],
		[2851209.78, 10194077.79],
		[2876865.09, 10194603.24],
		[2877340.56, 10168967.13],
		[2851779.91, 10168445.89],
	]], [[	/* 744:345 */
		[2877340.56, 10168967.13],
		[2876865.09, 10194603.24],
		[2902524.25, 10195033.53],
		[2902905.02, 10169393.96],
		[2877340.56, 10168967.13],
	]], [[	/* 744:346 */
		[2902905.02, 10169393.96],
		[2902524.25, 10195033.53],
		[2928186.50, 10195368.61],
		[2928472.53, 10169726.37],
		[2902905.02, 10169393.96],
	]], [[	/* 744:347 */
		[2928472.53, 10169726.37],
		[2928186.50, 10195368.61],
		[2953851.06, 10195608.47],
		[2954042.33, 10169964.30],
		[2928472.53, 10169726.37],
	]], [[	/* 744:348 */
		[2954042.33, 10169964.30],
		[2953851.06, 10195608.47],
		[2979517.18, 10195753.07],
		[2979613.66, 10170107.74],
		[2954042.33, 10169964.30],
	]], [[	/* 744:349 */
		[2979613.66, 10170107.74],
		[2979517.18, 10195753.07],
		[3005184.07, 10195802.41],
		[3005185.76, 10170156.68],
		[2979613.66, 10170107.74],
	]], [[	/* 744:350 */
		[3005185.76, 10170156.68],
		[3005184.07, 10195802.41],
		[3030850.98, 10195756.47],
		[3030757.88, 10170111.11],
		[3005185.76, 10170156.68],
	]], [[	/* 744:351 */
		[3030757.88, 10170111.11],
		[3030850.98, 10195756.47],
		[3056517.14, 10195615.26],
		[3056329.25, 10169971.04],
		[3030757.88, 10170111.11],
	]], [[	/* 744:352 */
		[3056329.25, 10169971.04],
		[3056517.14, 10195615.26],
		[3082181.76, 10195378.80],
		[3081899.11, 10169736.48],
		[3056329.25, 10169971.04],
	]], [[	/* 744:353 */
		[3081899.11, 10169736.48],
		[3082181.76, 10195378.80],
		[3107844.10, 10195047.11],
		[3107466.71, 10169407.44],
		[3081899.11, 10169736.48],
	]], [[	/* 744:354 */
		[3107466.71, 10169407.44],
		[3107844.10, 10195047.11],
		[3133503.38, 10194620.21],
		[3133031.28, 10168983.97],
		[3107466.71, 10169407.44],
	]], [[	/* 744:355 */
		[3133031.28, 10168983.97],
		[3133503.38, 10194620.21],
		[3159158.82, 10194098.16],
		[3158592.07, 10168466.10],
		[3133031.28, 10168983.97],
	]], [[	/* 744:356 */
		[3158592.07, 10168466.10],
		[3159158.82, 10194098.16],
		[3184809.68, 10193480.99],
		[3184148.32, 10167853.89],
		[3158592.07, 10168466.10],
	]], [[	/* 744:357 */
		[3184148.32, 10167853.89],
		[3184809.68, 10193480.99],
		[3210455.17, 10192768.77],
		[3209699.27, 10167147.38],
		[3184148.32, 10167853.89],
	]], [[	/* 744:358 */
		[3209699.27, 10167147.38],
		[3210455.17, 10192768.77],
		[3236094.54, 10191961.57],
		[3235244.17, 10166346.64],
		[3209699.27, 10167147.38],
	]], [[	/* 744:359 */
		[3235244.17, 10166346.64],
		[3236094.54, 10191961.57],
		[3261727.02, 10191059.45],
		[3260782.26, 10165451.75],
		[3235244.17, 10166346.64],
	]], [[	/* 745:335 */
		[2620611.52, 10185077.76],
		[2619181.50, 10210731.68],
		[2644862.38, 10212121.41],
		[2646197.79, 10186456.33],
		[2620611.52, 10185077.76],
	]], [[	/* 745:336 */
		[2646197.79, 10186456.33],
		[2644862.38, 10212121.41],
		[2670554.09, 10213415.98],
		[2671794.77, 10187740.51],
		[2646197.79, 10186456.33],
	]], [[	/* 745:337 */
		[2671794.77, 10187740.51],
		[2670554.09, 10213415.98],
		[2696255.88, 10214615.28],
		[2697401.70, 10188930.18],
		[2671794.77, 10187740.51],
	]], [[	/* 745:338 */
		[2697401.70, 10188930.18],
		[2696255.88, 10214615.28],
		[2721966.97, 10215719.20],
		[2723017.83, 10190025.22],
		[2697401.70, 10188930.18],
	]], [[	/* 745:339 */
		[2723017.83, 10190025.22],
		[2721966.97, 10215719.20],
		[2747686.59, 10216727.62],
		[2748642.40, 10191025.54],
		[2723017.83, 10190025.22],
	]], [[	/* 745:340 */
		[2748642.40, 10191025.54],
		[2747686.59, 10216727.62],
		[2773413.98, 10217640.45],
		[2774274.64, 10191931.04],
		[2748642.40, 10191025.54],
	]], [[	/* 745:341 */
		[2774274.64, 10191931.04],
		[2773413.98, 10217640.45],
		[2799148.37, 10218457.61],
		[2799913.79, 10192741.63],
		[2774274.64, 10191931.04],
	]], [[	/* 745:342 */
		[2799913.79, 10192741.63],
		[2799148.37, 10218457.61],
		[2824888.98, 10219179.02],
		[2825559.10, 10193457.24],
		[2799913.79, 10192741.63],
	]], [[	/* 745:343 */
		[2825559.10, 10193457.24],
		[2824888.98, 10219179.02],
		[2850635.04, 10219804.61],
		[2851209.78, 10194077.79],
		[2825559.10, 10193457.24],
	]], [[	/* 745:344 */
		[2851209.78, 10194077.79],
		[2850635.04, 10219804.61],
		[2876385.77, 10220334.32],
		[2876865.09, 10194603.24],
		[2851209.78, 10194077.79],
	]], [[	/* 745:345 */
		[2876865.09, 10194603.24],
		[2876385.77, 10220334.32],
		[2902140.40, 10220768.10],
		[2902524.25, 10195033.53],
		[2876865.09, 10194603.24],
	]], [[	/* 745:346 */
		[2902524.25, 10195033.53],
		[2902140.40, 10220768.10],
		[2927898.15, 10221105.90],
		[2928186.50, 10195368.61],
		[2902524.25, 10195033.53],
	]], [[	/* 745:347 */
		[2928186.50, 10195368.61],
		[2927898.15, 10221105.90],
		[2953658.25, 10221347.71],
		[2953851.06, 10195608.47],
		[2928186.50, 10195368.61],
	]], [[	/* 745:348 */
		[2953851.06, 10195608.47],
		[2953658.25, 10221347.71],
		[2979419.91, 10221493.48],
		[2979517.18, 10195753.07],
		[2953851.06, 10195608.47],
	]], [[	/* 745:349 */
		[2979517.18, 10195753.07],
		[2979419.91, 10221493.48],
		[3005182.37, 10221543.21],
		[3005184.07, 10195802.41],
		[2979517.18, 10195753.07],
	]], [[	/* 745:350 */
		[3005184.07, 10195802.41],
		[3005182.37, 10221543.21],
		[3030944.84, 10221496.90],
		[3030850.98, 10195756.47],
		[3005184.07, 10195802.41],
	]], [[	/* 745:351 */
		[3030850.98, 10195756.47],
		[3030944.84, 10221496.90],
		[3056706.55, 10221354.55],
		[3056517.14, 10195615.26],
		[3030850.98, 10195756.47],
	]], [[	/* 745:352 */
		[3056517.14, 10195615.26],
		[3056706.55, 10221354.55],
		[3082466.71, 10221116.17],
		[3082181.76, 10195378.80],
		[3056517.14, 10195615.26],
	]], [[	/* 745:353 */
		[3082181.76, 10195378.80],
		[3082466.71, 10221116.17],
		[3108224.55, 10220781.78],
		[3107844.10, 10195047.11],
		[3082181.76, 10195378.80],
	]], [[	/* 745:354 */
		[3107844.10, 10195047.11],
		[3108224.55, 10220781.78],
		[3133979.30, 10220351.42],
		[3133503.38, 10194620.21],
		[3107844.10, 10195047.11],
	]], [[	/* 745:355 */
		[3133503.38, 10194620.21],
		[3133979.30, 10220351.42],
		[3159730.17, 10219825.13],
		[3159158.82, 10194098.16],
		[3133503.38, 10194620.21],
	]], [[	/* 745:356 */
		[3159158.82, 10194098.16],
		[3159730.17, 10219825.13],
		[3185476.40, 10219202.96],
		[3184809.68, 10193480.99],
		[3159158.82, 10194098.16],
	]], [[	/* 745:357 */
		[3184809.68, 10193480.99],
		[3185476.40, 10219202.96],
		[3211217.20, 10218484.96],
		[3210455.17, 10192768.77],
		[3184809.68, 10193480.99],
	]], [[	/* 745:358 */
		[3210455.17, 10192768.77],
		[3211217.20, 10218484.96],
		[3236951.80, 10217671.21],
		[3236094.54, 10191961.57],
		[3210455.17, 10192768.77],
	]], [[	/* 745:359 */
		[3236094.54, 10191961.57],
		[3236951.80, 10217671.21],
		[3262679.44, 10216761.78],
		[3261727.02, 10191059.45],
		[3236094.54, 10191961.57],
	]], [[	/* 745:360 */
		[3261727.02, 10191059.45],
		[3262679.44, 10216761.78],
		[3288399.34, 10215756.77],
		[3287351.86, 10190062.51],
		[3261727.02, 10191059.45],
	]], [[	/* 746:335 */
		[2619181.50, 10210731.68],
		[2617739.87, 10236480.43],
		[2643516.12, 10237881.44],
		[2644862.38, 10212121.41],
		[2619181.50, 10210731.68],
	]], [[	/* 746:336 */
		[2644862.38, 10212121.41],
		[2643516.12, 10237881.44],
		[2669303.34, 10239186.53],
		[2670554.09, 10213415.98],
		[2644862.38, 10212121.41],
	]], [[	/* 746:337 */
		[2670554.09, 10213415.98],
		[2669303.34, 10239186.53],
		[2695100.74, 10240395.58],
		[2696255.88, 10214615.28],
		[2670554.09, 10213415.98],
	]], [[	/* 746:338 */
		[2696255.88, 10214615.28],
		[2695100.74, 10240395.58],
		[2720907.56, 10241508.47],
		[2721966.97, 10215719.20],
		[2696255.88, 10214615.28],
	]], [[	/* 746:339 */
		[2721966.97, 10215719.20],
		[2720907.56, 10241508.47],
		[2746723.02, 10242525.09],
		[2747686.59, 10216727.62],
		[2721966.97, 10215719.20],
	]], [[	/* 746:340 */
		[2747686.59, 10216727.62],
		[2746723.02, 10242525.09],
		[2772546.33, 10243445.35],
		[2773413.98, 10217640.45],
		[2747686.59, 10216727.62],
	]], [[	/* 746:341 */
		[2773413.98, 10217640.45],
		[2772546.33, 10243445.35],
		[2798376.73, 10244269.16],
		[2799148.37, 10218457.61],
		[2773413.98, 10217640.45],
	]], [[	/* 746:342 */
		[2799148.37, 10218457.61],
		[2798376.73, 10244269.16],
		[2824213.41, 10244996.44],
		[2824888.98, 10219179.02],
		[2799148.37, 10218457.61],
	]], [[	/* 746:343 */
		[2824888.98, 10219179.02],
		[2824213.41, 10244996.44],
		[2850055.62, 10245627.12],
		[2850635.04, 10219804.61],
		[2824888.98, 10219179.02],
	]], [[	/* 746:344 */
		[2850635.04, 10219804.61],
		[2850055.62, 10245627.12],
		[2875902.55, 10246161.14],
		[2876385.77, 10220334.32],
		[2850635.04, 10219804.61],
	]], [[	/* 746:345 */
		[2876385.77, 10220334.32],
		[2875902.55, 10246161.14],
		[2901753.42, 10246598.45],
		[2902140.40, 10220768.10],
		[2876385.77, 10220334.32],
	]], [[	/* 746:346 */
		[2902140.40, 10220768.10],
		[2901753.42, 10246598.45],
		[2927607.46, 10246939.00],
		[2927898.15, 10221105.90],
		[2902140.40, 10220768.10],
	]], [[	/* 746:347 */
		[2927898.15, 10221105.90],
		[2927607.46, 10246939.00],
		[2953463.87, 10247182.77],
		[2953658.25, 10221347.71],
		[2927898.15, 10221105.90],
	]], [[	/* 746:348 */
		[2953658.25, 10221347.71],
		[2953463.87, 10247182.77],
		[2979321.86, 10247329.74],
		[2979419.91, 10221493.48],
		[2953658.25, 10221347.71],
	]], [[	/* 746:349 */
		[2979419.91, 10221493.48],
		[2979321.86, 10247329.74],
		[3005180.66, 10247379.87],
		[3005182.37, 10221543.21],
		[2979419.91, 10221493.48],
	]], [[	/* 746:350 */
		[3005182.37, 10221543.21],
		[3005180.66, 10247379.87],
		[3031039.46, 10247333.18],
		[3030944.84, 10221496.90],
		[3005182.37, 10221543.21],
	]], [[	/* 746:351 */
		[3030944.84, 10221496.90],
		[3031039.46, 10247333.18],
		[3056897.50, 10247189.67],
		[3056706.55, 10221354.55],
		[3030944.84, 10221496.90],
	]], [[	/* 746:352 */
		[3056706.55, 10221354.55],
		[3056897.50, 10247189.67],
		[3082753.97, 10246949.35],
		[3082466.71, 10221116.17],
		[3056706.55, 10221354.55],
	]], [[	/* 746:353 */
		[3082466.71, 10221116.17],
		[3082753.97, 10246949.35],
		[3108608.10, 10246612.24],
		[3108224.55, 10220781.78],
		[3082466.71, 10221116.17],
	]], [[	/* 746:354 */
		[3108224.55, 10220781.78],
		[3108608.10, 10246612.24],
		[3134459.09, 10246178.37],
		[3133979.30, 10220351.42],
		[3108224.55, 10220781.78],
	]], [[	/* 746:355 */
		[3133979.30, 10220351.42],
		[3134459.09, 10246178.37],
		[3160306.17, 10245647.79],
		[3159730.17, 10219825.13],
		[3133979.30, 10220351.42],
	]], [[	/* 746:356 */
		[3159730.17, 10219825.13],
		[3160306.17, 10245647.79],
		[3186148.54, 10245020.55],
		[3185476.40, 10219202.96],
		[3159730.17, 10219825.13],
	]], [[	/* 746:357 */
		[3185476.40, 10219202.96],
		[3186148.54, 10245020.55],
		[3211985.42, 10244296.71],
		[3211217.20, 10218484.96],
		[3185476.40, 10219202.96],
	]], [[	/* 746:358 */
		[3211217.20, 10218484.96],
		[3211985.42, 10244296.71],
		[3237816.03, 10243476.34],
		[3236951.80, 10217671.21],
		[3211217.20, 10218484.96],
	]], [[	/* 746:359 */
		[3236951.80, 10217671.21],
		[3237816.03, 10243476.34],
		[3263639.60, 10242559.51],
		[3262679.44, 10216761.78],
		[3236951.80, 10217671.21],
	]], [[	/* 746:360 */
		[3262679.44, 10216761.78],
		[3263639.60, 10242559.51],
		[3289455.33, 10241546.32],
		[3288399.34, 10215756.77],
		[3262679.44, 10216761.78],
	]], [[	/* 747:335 */
		[2617739.87, 10236480.43],
		[2616286.51, 10262324.78],
		[2642158.91, 10263737.20],
		[2643516.12, 10237881.44],
		[2617739.87, 10236480.43],
	]], [[	/* 747:336 */
		[2643516.12, 10237881.44],
		[2642158.91, 10263737.20],
		[2668042.40, 10265052.93],
		[2669303.34, 10239186.53],
		[2643516.12, 10237881.44],
	]], [[	/* 747:337 */
		[2669303.34, 10239186.53],
		[2668042.40, 10265052.93],
		[2693936.20, 10266271.84],
		[2695100.74, 10240395.58],
		[2669303.34, 10239186.53],
	]], [[	/* 747:338 */
		[2695100.74, 10240395.58],
		[2693936.20, 10266271.84],
		[2719839.52, 10267393.81],
		[2720907.56, 10241508.47],
		[2695100.74, 10240395.58],
	]], [[	/* 747:339 */
		[2720907.56, 10241508.47],
		[2719839.52, 10267393.81],
		[2745751.59, 10268418.73],
		[2746723.02, 10242525.09],
		[2720907.56, 10241508.47],
	]], [[	/* 747:340 */
		[2746723.02, 10242525.09],
		[2745751.59, 10268418.73],
		[2771671.61, 10269346.50],
		[2772546.33, 10243445.35],
		[2746723.02, 10242525.09],
	]], [[	/* 747:341 */
		[2772546.33, 10243445.35],
		[2771671.61, 10269346.50],
		[2797598.79, 10270177.04],
		[2798376.73, 10244269.16],
		[2772546.33, 10243445.35],
	]], [[	/* 747:342 */
		[2798376.73, 10244269.16],
		[2797598.79, 10270177.04],
		[2823532.34, 10270910.26],
		[2824213.41, 10244996.44],
		[2798376.73, 10244269.16],
	]], [[	/* 747:343 */
		[2824213.41, 10244996.44],
		[2823532.34, 10270910.26],
		[2849471.47, 10271546.09],
		[2850055.62, 10245627.12],
		[2824213.41, 10244996.44],
	]], [[	/* 747:344 */
		[2850055.62, 10245627.12],
		[2849471.47, 10271546.09],
		[2875415.38, 10272084.48],
		[2875902.55, 10246161.14],
		[2850055.62, 10245627.12],
	]], [[	/* 747:345 */
		[2875902.55, 10246161.14],
		[2875415.38, 10272084.48],
		[2901363.29, 10272525.36],
		[2901753.42, 10246598.45],
		[2875902.55, 10246161.14],
	]], [[	/* 747:346 */
		[2901753.42, 10246598.45],
		[2901363.29, 10272525.36],
		[2927314.39, 10272868.70],
		[2927607.46, 10246939.00],
		[2901753.42, 10246598.45],
	]], [[	/* 747:347 */
		[2927607.46, 10246939.00],
		[2927314.39, 10272868.70],
		[2953267.90, 10273114.46],
		[2953463.87, 10247182.77],
		[2927607.46, 10246939.00],
	]], [[	/* 747:348 */
		[2953463.87, 10247182.77],
		[2953267.90, 10273114.46],
		[2979223.01, 10273262.62],
		[2979321.86, 10247329.74],
		[2953463.87, 10247182.77],
	]], [[	/* 747:349 */
		[2979321.86, 10247329.74],
		[2979223.01, 10273262.62],
		[3005178.93, 10273313.17],
		[3005180.66, 10247379.87],
		[2979321.86, 10247329.74],
	]], [[	/* 747:350 */
		[3005180.66, 10247379.87],
		[3005178.93, 10273313.17],
		[3031134.86, 10273266.10],
		[3031039.46, 10247333.18],
		[3005180.66, 10247379.87],
	]], [[	/* 747:351 */
		[3031039.46, 10247333.18],
		[3031134.86, 10273266.10],
		[3057090.01, 10273121.41],
		[3056897.50, 10247189.67],
		[3031039.46, 10247333.18],
	]], [[	/* 747:352 */
		[3056897.50, 10247189.67],
		[3057090.01, 10273121.41],
		[3083043.58, 10272879.12],
		[3082753.97, 10246949.35],
		[3056897.50, 10247189.67],
	]], [[	/* 747:353 */
		[3082753.97, 10246949.35],
		[3083043.58, 10272879.12],
		[3108994.78, 10272539.25],
		[3108608.10, 10246612.24],
		[3082753.97, 10246949.35],
	]], [[	/* 747:354 */
		[3108608.10, 10246612.24],
		[3108994.78, 10272539.25],
		[3134942.80, 10272101.84],
		[3134459.09, 10246178.37],
		[3108608.10, 10246612.24],
	]], [[	/* 747:355 */
		[3134459.09, 10246178.37],
		[3134942.80, 10272101.84],
		[3160886.86, 10271566.92],
		[3160306.17, 10245647.79],
		[3134459.09, 10246178.37],
	]], [[	/* 747:356 */
		[3160306.17, 10245647.79],
		[3160886.86, 10271566.92],
		[3186826.17, 10270934.56],
		[3186148.54, 10245020.55],
		[3160306.17, 10245647.79],
	]], [[	/* 747:357 */
		[3186148.54, 10245020.55],
		[3186826.17, 10270934.56],
		[3212759.91, 10270204.80],
		[3211985.42, 10244296.71],
		[3186148.54, 10245020.55],
	]], [[	/* 747:358 */
		[3211985.42, 10244296.71],
		[3212759.91, 10270204.80],
		[3238687.32, 10269377.73],
		[3237816.03, 10243476.34],
		[3211985.42, 10244296.71],
	]], [[	/* 747:359 */
		[3237816.03, 10243476.34],
		[3238687.32, 10269377.73],
		[3264607.58, 10268453.42],
		[3263639.60, 10242559.51],
		[3237816.03, 10243476.34],
	]], [[	/* 747:360 */
		[3263639.60, 10242559.51],
		[3264607.58, 10268453.42],
		[3290519.93, 10267431.95],
		[3289455.33, 10241546.32],
		[3263639.60, 10242559.51],
	]], [[	/* 747:361 */
		[3289455.33, 10241546.32],
		[3290519.93, 10267431.95],
		[3316423.56, 10266313.44],
		[3315262.44, 10240436.86],
		[3289455.33, 10241546.32],
	]], [[	/* 748:334 */
		[2590425.99, 10260815.79],
		[2588863.97, 10286744.17],
		[2614821.28, 10288265.49],
		[2616286.51, 10262324.78],
		[2590425.99, 10260815.79],
	]], [[	/* 748:335 */
		[2616286.51, 10262324.78],
		[2614821.28, 10288265.49],
		[2640790.60, 10289689.47],
		[2642158.91, 10263737.20],
		[2616286.51, 10262324.78],
	]], [[	/* 748:336 */
		[2642158.91, 10263737.20],
		[2640790.60, 10289689.47],
		[2666771.14, 10291015.97],
		[2668042.40, 10265052.93],
		[2642158.91, 10263737.20],
	]], [[	/* 748:337 */
		[2668042.40, 10265052.93],
		[2666771.14, 10291015.97],
		[2692762.12, 10292244.85],
		[2693936.20, 10266271.84],
		[2668042.40, 10265052.93],
	]], [[	/* 748:338 */
		[2693936.20, 10266271.84],
		[2692762.12, 10292244.85],
		[2718762.74, 10293376.01],
		[2719839.52, 10267393.81],
		[2693936.20, 10266271.84],
	]], [[	/* 748:339 */
		[2719839.52, 10267393.81],
		[2718762.74, 10293376.01],
		[2744772.21, 10294409.33],
		[2745751.59, 10268418.73],
		[2719839.52, 10267393.81],
	]], [[	/* 748:340 */
		[2745751.59, 10268418.73],
		[2744772.21, 10294409.33],
		[2770789.72, 10295344.70],
		[2771671.61, 10269346.50],
		[2745751.59, 10268418.73],
	]], [[	/* 748:341 */
		[2771671.61, 10269346.50],
		[2770789.72, 10295344.70],
		[2796814.47, 10296182.04],
		[2797598.79, 10270177.04],
		[2771671.61, 10269346.50],
	]], [[	/* 748:342 */
		[2797598.79, 10270177.04],
		[2796814.47, 10296182.04],
		[2822845.68, 10296921.28],
		[2823532.34, 10270910.26],
		[2797598.79, 10270177.04],
	]], [[	/* 748:343 */
		[2823532.34, 10270910.26],
		[2822845.68, 10296921.28],
		[2848882.53, 10297562.32],
		[2849471.47, 10271546.09],
		[2823532.34, 10270910.26],
	]], [[	/* 748:344 */
		[2849471.47, 10271546.09],
		[2848882.53, 10297562.32],
		[2874924.22, 10298105.12],
		[2875415.38, 10272084.48],
		[2849471.47, 10271546.09],
	]], [[	/* 748:345 */
		[2875415.38, 10272084.48],
		[2874924.22, 10298105.12],
		[2900969.95, 10298549.62],
		[2901363.29, 10272525.36],
		[2875415.38, 10272084.48],
	]], [[	/* 748:346 */
		[2901363.29, 10272525.36],
		[2900969.95, 10298549.62],
		[2927018.92, 10298895.78],
		[2927314.39, 10272868.70],
		[2901363.29, 10272525.36],
	]], [[	/* 748:347 */
		[2927314.39, 10272868.70],
		[2927018.92, 10298895.78],
		[2953070.32, 10299143.55],
		[2953267.90, 10273114.46],
		[2927314.39, 10272868.70],
	]], [[	/* 748:348 */
		[2953267.90, 10273114.46],
		[2953070.32, 10299143.55],
		[2979123.34, 10299292.93],
		[2979223.01, 10273262.62],
		[2953267.90, 10273114.46],
	]], [[	/* 748:349 */
		[2979223.01, 10273262.62],
		[2979123.34, 10299292.93],
		[3005177.19, 10299343.89],
		[3005178.93, 10273313.17],
		[2979223.01, 10273262.62],
	]], [[	/* 748:350 */
		[3005178.93, 10273313.17],
		[3005177.19, 10299343.89],
		[3031231.04, 10299296.43],
		[3031134.86, 10273266.10],
		[3005178.93, 10273313.17],
	]], [[	/* 748:351 */
		[3031134.86, 10273266.10],
		[3031231.04, 10299296.43],
		[3057284.10, 10299150.55],
		[3057090.01, 10273121.41],
		[3031134.86, 10273266.10],
	]], [[	/* 748:352 */
		[3057090.01, 10273121.41],
		[3057284.10, 10299150.55],
		[3083335.57, 10298906.28],
		[3083043.58, 10272879.12],
		[3057090.01, 10273121.41],
	]], [[	/* 748:353 */
		[3083043.58, 10272879.12],
		[3083335.57, 10298906.28],
		[3109384.63, 10298563.62],
		[3108994.78, 10272539.25],
		[3083043.58, 10272879.12],
	]], [[	/* 748:354 */
		[3108994.78, 10272539.25],
		[3109384.63, 10298563.62],
		[3135430.48, 10298122.62],
		[3134942.80, 10272101.84],
		[3108994.78, 10272539.25],
	]], [[	/* 748:355 */
		[3134942.80, 10272101.84],
		[3135430.48, 10298122.62],
		[3161472.32, 10297583.31],
		[3160886.86, 10271566.92],
		[3134942.80, 10272101.84],
	]], [[	/* 748:356 */
		[3160886.86, 10271566.92],
		[3161472.32, 10297583.31],
		[3187509.35, 10296945.76],
		[3186826.17, 10270934.56],
		[3160886.86, 10271566.92],
	]], [[	/* 748:357 */
		[3186826.17, 10270934.56],
		[3187509.35, 10296945.76],
		[3213540.75, 10296210.02],
		[3212759.91, 10270204.80],
		[3186826.17, 10270934.56],
	]], [[	/* 748:358 */
		[3212759.91, 10270204.80],
		[3213540.75, 10296210.02],
		[3239565.74, 10295376.17],
		[3238687.32, 10269377.73],
		[3212759.91, 10270204.80],
	]], [[	/* 748:359 */
		[3238687.32, 10269377.73],
		[3239565.74, 10295376.17],
		[3265583.50, 10294444.28],
		[3264607.58, 10268453.42],
		[3238687.32, 10269377.73],
	]], [[	/* 748:360 */
		[3264607.58, 10268453.42],
		[3265583.50, 10294444.28],
		[3291593.24, 10293414.44],
		[3290519.93, 10267431.95],
		[3264607.58, 10268453.42],
	]], [[	/* 748:361 */
		[3290519.93, 10267431.95],
		[3291593.24, 10293414.44],
		[3317594.17, 10292286.77],
		[3316423.56, 10266313.44],
		[3290519.93, 10267431.95],
	]], [[	/* 748:362 */
		[3316423.56, 10266313.44],
		[3317594.17, 10292286.77],
		[3343585.48, 10291061.36],
		[3342317.69, 10265097.98],
		[3316423.56, 10266313.44],
	]], [[	/* 749:334 */
		[2588863.97, 10286744.17],
		[2587289.15, 10312769.55],
		[2613344.03, 10314303.36],
		[2614821.28, 10288265.49],
		[2588863.97, 10286744.17],
	]], [[	/* 749:335 */
		[2614821.28, 10288265.49],
		[2613344.03, 10314303.36],
		[2639411.06, 10315739.03],
		[2640790.60, 10289689.47],
		[2614821.28, 10288265.49],
	]], [[	/* 749:336 */
		[2640790.60, 10289689.47],
		[2639411.06, 10315739.03],
		[2665489.46, 10317076.42],
		[2666771.14, 10291015.97],
		[2640790.60, 10289689.47],
	]], [[	/* 749:337 */
		[2666771.14, 10291015.97],
		[2665489.46, 10317076.42],
		[2691578.41, 10318315.40],
		[2692762.12, 10292244.85],
		[2666771.14, 10291015.97],
	]], [[	/* 749:338 */
		[2692762.12, 10292244.85],
		[2691578.41, 10318315.40],
		[2717677.12, 10319455.86],
		[2718762.74, 10293376.01],
		[2692762.12, 10292244.85],
	]], [[	/* 749:339 */
		[2718762.74, 10293376.01],
		[2717677.12, 10319455.86],
		[2743784.78, 10320497.67],
		[2744772.21, 10294409.33],
		[2718762.74, 10293376.01],
	]], [[	/* 749:340 */
		[2744772.21, 10294409.33],
		[2743784.78, 10320497.67],
		[2769900.58, 10321440.74],
		[2770789.72, 10295344.70],
		[2744772.21, 10294409.33],
	]], [[	/* 749:341 */
		[2770789.72, 10295344.70],
		[2769900.58, 10321440.74],
		[2796023.72, 10322284.97],
		[2796814.47, 10296182.04],
		[2770789.72, 10295344.70],
	]], [[	/* 749:342 */
		[2796814.47, 10296182.04],
		[2796023.72, 10322284.97],
		[2822153.38, 10323030.28],
		[2822845.68, 10296921.28],
		[2796814.47, 10296182.04],
	]], [[	/* 749:343 */
		[2822845.68, 10296921.28],
		[2822153.38, 10323030.28],
		[2848288.75, 10323676.61],
		[2848882.53, 10297562.32],
		[2822845.68, 10296921.28],
	]], [[	/* 749:344 */
		[2848882.53, 10297562.32],
		[2848288.75, 10323676.61],
		[2874429.02, 10324223.87],
		[2874924.22, 10298105.12],
		[2848882.53, 10297562.32],
	]], [[	/* 749:345 */
		[2874924.22, 10298105.12],
		[2874429.02, 10324223.87],
		[2900573.39, 10324672.03],
		[2900969.95, 10298549.62],
		[2874924.22, 10298105.12],
	]], [[	/* 749:346 */
		[2900969.95, 10298549.62],
		[2900573.39, 10324672.03],
		[2926721.02, 10325021.04],
		[2927018.92, 10298895.78],
		[2900969.95, 10298549.62],
	]], [[	/* 749:347 */
		[2927018.92, 10298895.78],
		[2926721.02, 10325021.04],
		[2952871.12, 10325270.86],
		[2953070.32, 10299143.55],
		[2927018.92, 10298895.78],
	]], [[	/* 749:348 */
		[2953070.32, 10299143.55],
		[2952871.12, 10325270.86],
		[2979022.86, 10325421.46],
		[2979123.34, 10299292.93],
		[2953070.32, 10299143.55],
	]], [[	/* 749:349 */
		[2979123.34, 10299292.93],
		[2979022.86, 10325421.46],
		[3005175.43, 10325472.84],
		[3005177.19, 10299343.89],
		[2979123.34, 10299292.93],
	]], [[	/* 749:350 */
		[3005177.19, 10299343.89],
		[3005175.43, 10325472.84],
		[3031328.01, 10325424.99],
		[3031231.04, 10299296.43],
		[3005177.19, 10299343.89],
	]], [[	/* 749:351 */
		[3031231.04, 10299296.43],
		[3031328.01, 10325424.99],
		[3057479.79, 10325277.91],
		[3057284.10, 10299150.55],
		[3031231.04, 10299296.43],
	]], [[	/* 749:352 */
		[3057284.10, 10299150.55],
		[3057479.79, 10325277.91],
		[3083629.96, 10325031.62],
		[3083335.57, 10298906.28],
		[3057284.10, 10299150.55],
	]], [[	/* 749:353 */
		[3083335.57, 10298906.28],
		[3083629.96, 10325031.62],
		[3109777.69, 10324686.14],
		[3109384.63, 10298563.62],
		[3083335.57, 10298906.28],
	]], [[	/* 749:354 */
		[3109384.63, 10298563.62],
		[3109777.69, 10324686.14],
		[3135922.17, 10324241.51],
		[3135430.48, 10298122.62],
		[3109384.63, 10298563.62],
	]], [[	/* 749:355 */
		[3135430.48, 10298122.62],
		[3135922.17, 10324241.51],
		[3162062.60, 10323697.76],
		[3161472.32, 10297583.31],
		[3135430.48, 10298122.62],
	]], [[	/* 749:356 */
		[3161472.32, 10297583.31],
		[3162062.60, 10323697.76],
		[3188198.15, 10323054.96],
		[3187509.35, 10296945.76],
		[3161472.32, 10297583.31],
	]], [[	/* 749:357 */
		[3187509.35, 10296945.76],
		[3188198.15, 10323054.96],
		[3214328.01, 10322313.16],
		[3213540.75, 10296210.02],
		[3187509.35, 10296945.76],
	]], [[	/* 749:358 */
		[3213540.75, 10296210.02],
		[3214328.01, 10322313.16],
		[3240451.38, 10321472.44],
		[3239565.74, 10295376.17],
		[3213540.75, 10296210.02],
	]], [[	/* 749:359 */
		[3239565.74, 10295376.17],
		[3240451.38, 10321472.44],
		[3266567.43, 10320532.89],
		[3265583.50, 10294444.28],
		[3239565.74, 10295376.17],
	]], [[	/* 749:360 */
		[3265583.50, 10294444.28],
		[3266567.43, 10320532.89],
		[3292675.38, 10319494.59],
		[3291593.24, 10293414.44],
		[3265583.50, 10294444.28],
	]], [[	/* 749:361 */
		[3291593.24, 10293414.44],
		[3292675.38, 10319494.59],
		[3318774.39, 10318357.64],
		[3317594.17, 10292286.77],
		[3291593.24, 10293414.44],
	]], [[	/* 749:362 */
		[3317594.17, 10292286.77],
		[3318774.39, 10318357.64],
		[3344863.69, 10317122.16],
		[3343585.48, 10291061.36],
		[3317594.17, 10292286.77],
	]], [[	/* 750:334 */
		[2587289.15, 10312769.55],
		[2585701.37, 10338892.72],
		[2611854.62, 10340439.17],
		[2613344.03, 10314303.36],
		[2587289.15, 10312769.55],
	]], [[	/* 750:335 */
		[2613344.03, 10314303.36],
		[2611854.62, 10340439.17],
		[2638020.17, 10341886.67],
		[2639411.06, 10315739.03],
		[2613344.03, 10314303.36],
	]], [[	/* 750:336 */
		[2639411.06, 10315739.03],
		[2638020.17, 10341886.67],
		[2664197.21, 10343235.09],
		[2665489.46, 10317076.42],
		[2639411.06, 10315739.03],
	]], [[	/* 750:337 */
		[2665489.46, 10317076.42],
		[2664197.21, 10343235.09],
		[2690384.94, 10344484.29],
		[2691578.41, 10318315.40],
		[2665489.46, 10317076.42],
	]], [[	/* 750:338 */
		[2691578.41, 10318315.40],
		[2690384.94, 10344484.29],
		[2716582.55, 10345634.15],
		[2717677.12, 10319455.86],
		[2691578.41, 10318315.40],
	]], [[	/* 750:339 */
		[2717677.12, 10319455.86],
		[2716582.55, 10345634.15],
		[2742789.21, 10346684.56],
		[2743784.78, 10320497.67],
		[2717677.12, 10319455.86],
	]], [[	/* 750:340 */
		[2743784.78, 10320497.67],
		[2742789.21, 10346684.56],
		[2769004.11, 10347635.42],
		[2769900.58, 10321440.74],
		[2743784.78, 10320497.67],
	]], [[	/* 750:341 */
		[2769900.58, 10321440.74],
		[2769004.11, 10347635.42],
		[2795226.43, 10348486.62],
		[2796023.72, 10322284.97],
		[2769900.58, 10321440.74],
	]], [[	/* 750:342 */
		[2796023.72, 10322284.97],
		[2795226.43, 10348486.62],
		[2821455.36, 10349238.09],
		[2822153.38, 10323030.28],
		[2796023.72, 10322284.97],
	]], [[	/* 750:343 */
		[2822153.38, 10323030.28],
		[2821455.36, 10349238.09],
		[2847690.07, 10349889.75],
		[2848288.75, 10323676.61],
		[2822153.38, 10323030.28],
	]], [[	/* 750:344 */
		[2848288.75, 10323676.61],
		[2847690.07, 10349889.75],
		[2873929.74, 10350441.54],
		[2874429.02, 10324223.87],
		[2848288.75, 10323676.61],
	]], [[	/* 750:345 */
		[2874429.02, 10324223.87],
		[2873929.74, 10350441.54],
		[2900173.55, 10350893.41],
		[2900573.39, 10324672.03],
		[2874429.02, 10324223.87],
	]], [[	/* 750:346 */
		[2900573.39, 10324672.03],
		[2900173.55, 10350893.41],
		[2926420.67, 10351245.30],
		[2926721.02, 10325021.04],
		[2900573.39, 10324672.03],
	]], [[	/* 750:347 */
		[2926721.02, 10325021.04],
		[2926420.67, 10351245.30],
		[2952670.28, 10351497.18],
		[2952871.12, 10325270.86],
		[2926721.02, 10325021.04],
	]], [[	/* 750:348 */
		[2952871.12, 10325270.86],
		[2952670.28, 10351497.18],
		[2978921.55, 10351649.03],
		[2979022.86, 10325421.46],
		[2952871.12, 10325270.86],
	]], [[	/* 750:349 */
		[2979022.86, 10325421.46],
		[2978921.55, 10351649.03],
		[3005173.66, 10351700.83],
		[3005175.43, 10325472.84],
		[2979022.86, 10325421.46],
	]], [[	/* 750:350 */
		[3005175.43, 10325472.84],
		[3005173.66, 10351700.83],
		[3031425.79, 10351652.58],
		[3031328.01, 10325424.99],
		[3005175.43, 10325472.84],
	]], [[	/* 750:351 */
		[3031328.01, 10325424.99],
		[3031425.79, 10351652.58],
		[3057677.10, 10351504.29],
		[3057479.79, 10325277.91],
		[3031328.01, 10325424.99],
	]], [[	/* 750:352 */
		[3057479.79, 10325277.91],
		[3057677.10, 10351504.29],
		[3083926.78, 10351255.96],
		[3083629.96, 10325031.62],
		[3057479.79, 10325277.91],
	]], [[	/* 750:353 */
		[3083629.96, 10325031.62],
		[3083926.78, 10351255.96],
		[3110174.00, 10350907.62],
		[3109777.69, 10324686.14],
		[3083629.96, 10325031.62],
	]], [[	/* 750:354 */
		[3109777.69, 10324686.14],
		[3110174.00, 10350907.62],
		[3136417.93, 10350459.31],
		[3135922.17, 10324241.51],
		[3109777.69, 10324686.14],
	]], [[	/* 750:355 */
		[3135922.17, 10324241.51],
		[3136417.93, 10350459.31],
		[3162657.75, 10349911.07],
		[3162062.60, 10323697.76],
		[3135922.17, 10324241.51],
	]], [[	/* 750:356 */
		[3162062.60, 10323697.76],
		[3162657.75, 10349911.07],
		[3188892.63, 10349262.96],
		[3188198.15, 10323054.96],
		[3162062.60, 10323697.76],
	]], [[	/* 750:357 */
		[3188198.15, 10323054.96],
		[3188892.63, 10349262.96],
		[3215121.77, 10348515.03],
		[3214328.01, 10322313.16],
		[3188198.15, 10323054.96],
	]], [[	/* 750:358 */
		[3214328.01, 10322313.16],
		[3215121.77, 10348515.03],
		[3241344.32, 10347667.37],
		[3240451.38, 10321472.44],
		[3214328.01, 10322313.16],
	]], [[	/* 750:359 */
		[3240451.38, 10321472.44],
		[3241344.32, 10347667.37],
		[3267559.48, 10346720.05],
		[3266567.43, 10320532.89],
		[3240451.38, 10321472.44],
	]], [[	/* 750:360 */
		[3266567.43, 10320532.89],
		[3267559.48, 10346720.05],
		[3293766.43, 10345673.18],
		[3292675.38, 10319494.59],
		[3266567.43, 10320532.89],
	]], [[	/* 750:361 */
		[3292675.38, 10319494.59],
		[3293766.43, 10345673.18],
		[3319964.35, 10344526.85],
		[3318774.39, 10318357.64],
		[3292675.38, 10319494.59],
	]], [[	/* 750:362 */
		[3318774.39, 10318357.64],
		[3319964.35, 10344526.85],
		[3346152.42, 10343281.18],
		[3344863.69, 10317122.16],
		[3318774.39, 10318357.64],
	]], [[	/* 751:335 */
		[2611854.62, 10340439.17],
		[2610352.90, 10366673.72],
		[2636617.77, 10368133.20],
		[2638020.17, 10341886.67],
		[2611854.62, 10340439.17],
	]], [[	/* 751:336 */
		[2638020.17, 10341886.67],
		[2636617.77, 10368133.20],
		[2662894.28, 10369492.78],
		[2664197.21, 10343235.09],
		[2638020.17, 10341886.67],
	]], [[	/* 751:337 */
		[2664197.21, 10343235.09],
		[2662894.28, 10369492.78],
		[2689181.60, 10370752.32],
		[2690384.94, 10344484.29],
		[2664197.21, 10343235.09],
	]], [[	/* 751:338 */
		[2690384.94, 10344484.29],
		[2689181.60, 10370752.32],
		[2715478.91, 10371911.71],
		[2716582.55, 10345634.15],
		[2690384.94, 10344484.29],
	]], [[	/* 751:339 */
		[2716582.55, 10345634.15],
		[2715478.91, 10371911.71],
		[2741785.39, 10372970.82],
		[2742789.21, 10346684.56],
		[2716582.55, 10345634.15],
	]], [[	/* 751:340 */
		[2742789.21, 10346684.56],
		[2741785.39, 10372970.82],
		[2768100.21, 10373929.55],
		[2769004.11, 10347635.42],
		[2742789.21, 10346684.56],
	]], [[	/* 751:341 */
		[2769004.11, 10347635.42],
		[2768100.21, 10373929.55],
		[2794422.55, 10374787.81],
		[2795226.43, 10348486.62],
		[2769004.11, 10347635.42],
	]], [[	/* 751:342 */
		[2795226.43, 10348486.62],
		[2794422.55, 10374787.81],
		[2820751.56, 10375545.52],
		[2821455.36, 10349238.09],
		[2795226.43, 10348486.62],
	]], [[	/* 751:343 */
		[2821455.36, 10349238.09],
		[2820751.56, 10375545.52],
		[2847086.43, 10376202.58],
		[2847690.07, 10349889.75],
		[2821455.36, 10349238.09],
	]], [[	/* 751:344 */
		[2847690.07, 10349889.75],
		[2847086.43, 10376202.58],
		[2873426.32, 10376758.95],
		[2873929.74, 10350441.54],
		[2847690.07, 10349889.75],
	]], [[	/* 751:345 */
		[2873929.74, 10350441.54],
		[2873426.32, 10376758.95],
		[2899770.39, 10377214.56],
		[2900173.55, 10350893.41],
		[2873929.74, 10350441.54],
	]], [[	/* 751:346 */
		[2900173.55, 10350893.41],
		[2899770.39, 10377214.56],
		[2926117.82, 10377569.37],
		[2926420.67, 10351245.30],
		[2900173.55, 10350893.41],
	]], [[	/* 751:347 */
		[2926420.67, 10351245.30],
		[2926117.82, 10377569.37],
		[2952467.77, 10377823.34],
		[2952670.28, 10351497.18],
		[2926420.67, 10351245.30],
	]], [[	/* 751:348 */
		[2952670.28, 10351497.18],
		[2952467.77, 10377823.34],
		[2978819.40, 10377976.45],
		[2978921.55, 10351649.03],
		[2952670.28, 10351497.18],
	]], [[	/* 751:349 */
		[2978921.55, 10351649.03],
		[2978819.40, 10377976.45],
		[3005171.88, 10378028.68],
		[3005173.66, 10351700.83],
		[2978921.55, 10351649.03],
	]], [[	/* 751:350 */
		[3005173.66, 10351700.83],
		[3005171.88, 10378028.68],
		[3031524.37, 10377980.03],
		[3031425.79, 10351652.58],
		[3005173.66, 10351700.83],
	]], [[	/* 751:351 */
		[3031425.79, 10351652.58],
		[3031524.37, 10377980.03],
		[3057876.05, 10377830.50],
		[3057677.10, 10351504.29],
		[3031425.79, 10351652.58],
	]], [[	/* 751:352 */
		[3057677.10, 10351504.29],
		[3057876.05, 10377830.50],
		[3084226.06, 10377580.11],
		[3083926.78, 10351255.96],
		[3057677.10, 10351504.29],
	]], [[	/* 751:353 */
		[3083926.78, 10351255.96],
		[3084226.06, 10377580.11],
		[3110573.59, 10377228.88],
		[3110174.00, 10350907.62],
		[3083926.78, 10351255.96],
	]], [[	/* 751:354 */
		[3110174.00, 10350907.62],
		[3110573.59, 10377228.88],
		[3136917.79, 10376776.85],
		[3136417.93, 10350459.31],
		[3110174.00, 10350907.62],
	]], [[	/* 751:355 */
		[3136417.93, 10350459.31],
		[3136917.79, 10376776.85],
		[3163257.83, 10376224.06],
		[3162657.75, 10349911.07],
		[3136417.93, 10350459.31],
	]], [[	/* 751:356 */
		[3162657.75, 10349911.07],
		[3163257.83, 10376224.06],
		[3189592.88, 10375570.57],
		[3188892.63, 10349262.96],
		[3162657.75, 10349911.07],
	]], [[	/* 751:357 */
		[3188892.63, 10349262.96],
		[3189592.88, 10375570.57],
		[3215922.10, 10374816.44],
		[3215121.77, 10348515.03],
		[3188892.63, 10349262.96],
	]], [[	/* 751:358 */
		[3215121.77, 10348515.03],
		[3215922.10, 10374816.44],
		[3242244.67, 10373961.75],
		[3241344.32, 10347667.37],
		[3215121.77, 10348515.03],
	]], [[	/* 751:359 */
		[3241344.32, 10347667.37],
		[3242244.67, 10373961.75],
		[3268559.75, 10373006.59],
		[3267559.48, 10346720.05],
		[3241344.32, 10347667.37],
	]], [[	/* 751:360 */
		[3267559.48, 10346720.05],
		[3268559.75, 10373006.59],
		[3294866.52, 10371951.04],
		[3293766.43, 10345673.18],
		[3267559.48, 10346720.05],
	]], [[	/* 751:361 */
		[3293766.43, 10345673.18],
		[3294866.52, 10371951.04],
		[3321164.15, 10370795.21],
		[3319964.35, 10344526.85],
		[3293766.43, 10345673.18],
	]], [[	/* 751:362 */
		[3319964.35, 10344526.85],
		[3321164.15, 10370795.21],
		[3347451.81, 10369539.22],
		[3346152.42, 10343281.18],
		[3319964.35, 10344526.85],
	]], [[	/* 752:335 */
		[2610352.90, 10366673.72],
		[2608838.73, 10393007.84],
		[2635203.75, 10394479.43],
		[2636617.77, 10368133.20],
		[2610352.90, 10366673.72],
	]], [[	/* 752:336 */
		[2636617.77, 10368133.20],
		[2635203.75, 10394479.43],
		[2661580.54, 10395850.31],
		[2662894.28, 10369492.78],
		[2636617.77, 10368133.20],
	]], [[	/* 752:337 */
		[2662894.28, 10369492.78],
		[2661580.54, 10395850.31],
		[2687968.27, 10397120.32],
		[2689181.60, 10370752.32],
		[2662894.28, 10369492.78],
	]], [[	/* 752:338 */
		[2689181.60, 10370752.32],
		[2687968.27, 10397120.32],
		[2714366.12, 10398289.34],
		[2715478.91, 10371911.71],
		[2689181.60, 10370752.32],
	]], [[	/* 752:339 */
		[2715478.91, 10371911.71],
		[2714366.12, 10398289.34],
		[2740773.24, 10399357.26],
		[2741785.39, 10372970.82],
		[2715478.91, 10371911.71],
	]], [[	/* 752:340 */
		[2741785.39, 10372970.82],
		[2740773.24, 10399357.26],
		[2767188.81, 10400323.97],
		[2768100.21, 10373929.55],
		[2741785.39, 10372970.82],
	]], [[	/* 752:341 */
		[2768100.21, 10373929.55],
		[2767188.81, 10400323.97],
		[2793611.98, 10401189.37],
		[2794422.55, 10374787.81],
		[2768100.21, 10373929.55],
	]], [[	/* 752:342 */
		[2794422.55, 10374787.81],
		[2793611.98, 10401189.37],
		[2820041.91, 10401953.38],
		[2820751.56, 10375545.52],
		[2794422.55, 10374787.81],
	]], [[	/* 752:343 */
		[2820751.56, 10375545.52],
		[2820041.91, 10401953.38],
		[2846477.77, 10402615.92],
		[2847086.43, 10376202.58],
		[2820751.56, 10375545.52],
	]], [[	/* 752:344 */
		[2847086.43, 10376202.58],
		[2846477.77, 10402615.92],
		[2872918.70, 10403176.92],
		[2873426.32, 10376758.95],
		[2847086.43, 10376202.58],
	]], [[	/* 752:345 */
		[2873426.32, 10376758.95],
		[2872918.70, 10403176.92],
		[2899363.88, 10403636.32],
		[2899770.39, 10377214.56],
		[2873426.32, 10376758.95],
	]], [[	/* 752:346 */
		[2899770.39, 10377214.56],
		[2899363.88, 10403636.32],
		[2925812.45, 10403994.08],
		[2926117.82, 10377569.37],
		[2899770.39, 10377214.56],
	]], [[	/* 752:347 */
		[2926117.82, 10377569.37],
		[2925812.45, 10403994.08],
		[2952263.57, 10404250.17],
		[2952467.77, 10377823.34],
		[2926117.82, 10377569.37],
	]], [[	/* 752:348 */
		[2952467.77, 10377823.34],
		[2952263.57, 10404250.17],
		[2978716.40, 10404404.55],
		[2978819.40, 10377976.45],
		[2952467.77, 10377823.34],
	]], [[	/* 752:349 */
		[2978819.40, 10377976.45],
		[2978716.40, 10404404.55],
		[3005170.08, 10404457.22],
		[3005171.88, 10378028.68],
		[2978819.40, 10377976.45],
	]], [[	/* 752:350 */
		[3005171.88, 10378028.68],
		[3005170.08, 10404457.22],
		[3031623.78, 10404408.16],
		[3031524.37, 10377980.03],
		[3005171.88, 10378028.68],
	]], [[	/* 752:351 */
		[3031524.37, 10377980.03],
		[3031623.78, 10404408.16],
		[3058076.65, 10404257.39],
		[3057876.05, 10377830.50],
		[3031524.37, 10377980.03],
	]], [[	/* 752:352 */
		[3057876.05, 10377830.50],
		[3058076.65, 10404257.39],
		[3084527.84, 10404004.91],
		[3084226.06, 10377580.11],
		[3057876.05, 10377830.50],
	]], [[	/* 752:353 */
		[3084226.06, 10377580.11],
		[3084527.84, 10404004.91],
		[3110976.51, 10403650.76],
		[3110573.59, 10377228.88],
		[3084226.06, 10377580.11],
	]], [[	/* 752:354 */
		[3110573.59, 10377228.88],
		[3110976.51, 10403650.76],
		[3137421.81, 10403194.96],
		[3136917.79, 10376776.85],
		[3110573.59, 10377228.88],
	]], [[	/* 752:355 */
		[3136917.79, 10376776.85],
		[3137421.81, 10403194.96],
		[3163862.90, 10402637.57],
		[3163257.83, 10376224.06],
		[3136917.79, 10376776.85],
	]], [[	/* 752:356 */
		[3163257.83, 10376224.06],
		[3163862.90, 10402637.57],
		[3190298.94, 10401978.63],
		[3189592.88, 10375570.57],
		[3163257.83, 10376224.06],
	]], [[	/* 752:357 */
		[3189592.88, 10375570.57],
		[3190298.94, 10401978.63],
		[3216729.09, 10401218.23],
		[3215922.10, 10374816.44],
		[3189592.88, 10375570.57],
	]], [[	/* 752:358 */
		[3215922.10, 10374816.44],
		[3216729.09, 10401218.23],
		[3243152.49, 10400356.42],
		[3242244.67, 10373961.75],
		[3215922.10, 10374816.44],
	]], [[	/* 752:359 */
		[3242244.67, 10373961.75],
		[3243152.49, 10400356.42],
		[3269568.33, 10399393.31],
		[3268559.75, 10373006.59],
		[3242244.67, 10373961.75],
	]], [[	/* 752:360 */
		[3268559.75, 10373006.59],
		[3269568.33, 10399393.31],
		[3295975.74, 10398328.98],
		[3294866.52, 10371951.04],
		[3268559.75, 10373006.59],
	]], [[	/* 752:361 */
		[3294866.52, 10371951.04],
		[3295975.74, 10398328.98],
		[3322373.91, 10397163.54],
		[3321164.15, 10370795.21],
		[3294866.52, 10371951.04],
	]], [[	/* 753:335 */
		[2608838.73, 10393007.84],
		[2607311.96, 10419442.34],
		[2633777.94, 10420926.20],
		[2635203.75, 10394479.43],
		[2608838.73, 10393007.84],
	]], [[	/* 753:336 */
		[2635203.75, 10394479.43],
		[2633777.94, 10420926.20],
		[2660255.84, 10422308.50],
		[2661580.54, 10395850.31],
		[2635203.75, 10394479.43],
	]], [[	/* 753:337 */
		[2661580.54, 10395850.31],
		[2660255.84, 10422308.50],
		[2686744.82, 10423589.11],
		[2687968.27, 10397120.32],
		[2661580.54, 10395850.31],
	]], [[	/* 753:338 */
		[2687968.27, 10397120.32],
		[2686744.82, 10423589.11],
		[2713244.04, 10424767.89],
		[2714366.12, 10398289.34],
		[2687968.27, 10397120.32],
	]], [[	/* 753:339 */
		[2714366.12, 10398289.34],
		[2713244.04, 10424767.89],
		[2739752.64, 10425844.72],
		[2740773.24, 10399357.26],
		[2714366.12, 10398289.34],
	]], [[	/* 753:340 */
		[2740773.24, 10399357.26],
		[2739752.64, 10425844.72],
		[2766269.80, 10426819.50],
		[2767188.81, 10400323.97],
		[2740773.24, 10399357.26],
	]], [[	/* 753:341 */
		[2767188.81, 10400323.97],
		[2766269.80, 10426819.50],
		[2792794.64, 10427692.13],
		[2793611.98, 10401189.37],
		[2767188.81, 10400323.97],
	]], [[	/* 753:342 */
		[2793611.98, 10401189.37],
		[2792794.64, 10427692.13],
		[2819326.33, 10428462.52],
		[2820041.91, 10401953.38],
		[2793611.98, 10401189.37],
	]], [[	/* 753:343 */
		[2820041.91, 10401953.38],
		[2819326.33, 10428462.52],
		[2845864.02, 10429130.60],
		[2846477.77, 10402615.92],
		[2820041.91, 10401953.38],
	]], [[	/* 753:344 */
		[2846477.77, 10402615.92],
		[2845864.02, 10429130.60],
		[2872406.86, 10429696.28],
		[2872918.70, 10403176.92],
		[2846477.77, 10402615.92],
	]], [[	/* 753:345 */
		[2872918.70, 10403176.92],
		[2872406.86, 10429696.28],
		[2898953.98, 10430159.53],
		[2899363.88, 10403636.32],
		[2872918.70, 10403176.92],
	]], [[	/* 753:346 */
		[2899363.88, 10403636.32],
		[2898953.98, 10430159.53],
		[2925504.53, 10430520.28],
		[2925812.45, 10403994.08],
		[2899363.88, 10403636.32],
	]], [[	/* 753:347 */
		[2925812.45, 10403994.08],
		[2925504.53, 10430520.28],
		[2952057.67, 10430778.51],
		[2952263.57, 10404250.17],
		[2925812.45, 10403994.08],
	]], [[	/* 753:348 */
		[2952263.57, 10404250.17],
		[2952057.67, 10430778.51],
		[2978612.54, 10430934.18],
		[2978716.40, 10404404.55],
		[2952263.57, 10404250.17],
	]], [[	/* 753:349 */
		[2978716.40, 10404404.55],
		[2978612.54, 10430934.18],
		[3005168.27, 10430987.29],
		[3005170.08, 10404457.22],
		[2978716.40, 10404404.55],
	]], [[	/* 753:350 */
		[3005170.08, 10404457.22],
		[3005168.27, 10430987.29],
		[3031724.02, 10430937.82],
		[3031623.78, 10404408.16],
		[3005170.08, 10404457.22],
	]], [[	/* 753:351 */
		[3031623.78, 10404408.16],
		[3031724.02, 10430937.82],
		[3058278.93, 10430785.78],
		[3058076.65, 10404257.39],
		[3031623.78, 10404408.16],
	]], [[	/* 753:352 */
		[3058076.65, 10404257.39],
		[3058278.93, 10430785.78],
		[3084832.14, 10430531.19],
		[3084527.84, 10404004.91],
		[3058076.65, 10404257.39],
	]], [[	/* 753:353 */
		[3084527.84, 10404004.91],
		[3084832.14, 10430531.19],
		[3111382.79, 10430174.08],
		[3110976.51, 10403650.76],
		[3084527.84, 10404004.91],
	]], [[	/* 753:354 */
		[3110976.51, 10403650.76],
		[3111382.79, 10430174.08],
		[3137930.04, 10429714.47],
		[3137421.81, 10403194.96],
		[3110976.51, 10403650.76],
	]], [[	/* 753:355 */
		[3137421.81, 10403194.96],
		[3137930.04, 10429714.47],
		[3164473.03, 10429152.41],
		[3163862.90, 10402637.57],
		[3137421.81, 10403194.96],
	]], [[	/* 753:356 */
		[3163862.90, 10402637.57],
		[3164473.03, 10429152.41],
		[3191010.91, 10428487.97],
		[3190298.94, 10401978.63],
		[3163862.90, 10402637.57],
	]], [[	/* 753:357 */
		[3190298.94, 10401978.63],
		[3191010.91, 10428487.97],
		[3217542.81, 10427721.21],
		[3216729.09, 10401218.23],
		[3190298.94, 10401978.63],
	]], [[	/* 753:358 */
		[3216729.09, 10401218.23],
		[3217542.81, 10427721.21],
		[3244067.90, 10426852.21],
		[3243152.49, 10400356.42],
		[3216729.09, 10401218.23],
	]], [[	/* 753:359 */
		[3243152.49, 10400356.42],
		[3244067.90, 10426852.21],
		[3270585.32, 10425881.05],
		[3269568.33, 10399393.31],
		[3243152.49, 10400356.42],
	]], [[	/* 753:360 */
		[3269568.33, 10399393.31],
		[3270585.32, 10425881.05],
		[3297094.22, 10424807.83],
		[3295975.74, 10398328.98],
		[3269568.33, 10399393.31],
	]], [[	/* 753:361 */
		[3295975.74, 10398328.98],
		[3297094.22, 10424807.83],
		[3323593.76, 10423632.67],
		[3322373.91, 10397163.54],
		[3295975.74, 10398328.98],
	]], [[	/* 754:335 */
		[2607311.96, 10419442.34],
		[2605772.43, 10445978.06],
		[2632340.22, 10447474.33],
		[2633777.94, 10420926.20],
		[2607311.96, 10419442.34],
	]], [[	/* 754:336 */
		[2633777.94, 10420926.20],
		[2632340.22, 10447474.33],
		[2658920.07, 10448868.20],
		[2660255.84, 10422308.50],
		[2633777.94, 10420926.20],
	]], [[	/* 754:337 */
		[2660255.84, 10422308.50],
		[2658920.07, 10448868.20],
		[2685511.14, 10450159.53],
		[2686744.82, 10423589.11],
		[2660255.84, 10422308.50],
	]], [[	/* 754:338 */
		[2686744.82, 10423589.11],
		[2685511.14, 10450159.53],
		[2712112.57, 10451348.18],
		[2713244.04, 10424767.89],
		[2686744.82, 10423589.11],
	]], [[	/* 754:339 */
		[2713244.04, 10424767.89],
		[2712112.57, 10451348.18],
		[2738723.50, 10452434.04],
		[2739752.64, 10425844.72],
		[2713244.04, 10424767.89],
	]], [[	/* 754:340 */
		[2739752.64, 10425844.72],
		[2738723.50, 10452434.04],
		[2765343.09, 10453416.99],
		[2766269.80, 10426819.50],
		[2739752.64, 10425844.72],
	]], [[	/* 754:341 */
		[2766269.80, 10426819.50],
		[2765343.09, 10453416.99],
		[2791970.46, 10454296.94],
		[2792794.64, 10427692.13],
		[2766269.80, 10426819.50],
	]], [[	/* 754:342 */
		[2792794.64, 10427692.13],
		[2791970.46, 10454296.94],
		[2818604.76, 10455073.79],
		[2819326.33, 10428462.52],
		[2792794.64, 10427692.13],
	]], [[	/* 754:343 */
		[2819326.33, 10428462.52],
		[2818604.76, 10455073.79],
		[2845245.14, 10455747.47],
		[2845864.02, 10429130.60],
		[2819326.33, 10428462.52],
	]], [[	/* 754:344 */
		[2845864.02, 10429130.60],
		[2845245.14, 10455747.47],
		[2871890.72, 10456317.90],
		[2872406.86, 10429696.28],
		[2845864.02, 10429130.60],
	]], [[	/* 754:345 */
		[2872406.86, 10429696.28],
		[2871890.72, 10456317.90],
		[2898540.64, 10456785.03],
		[2898953.98, 10430159.53],
		[2872406.86, 10429696.28],
	]], [[	/* 754:346 */
		[2898953.98, 10430159.53],
		[2898540.64, 10456785.03],
		[2925194.04, 10457148.81],
		[2925504.53, 10430520.28],
		[2898953.98, 10430159.53],
	]], [[	/* 754:347 */
		[2925504.53, 10430520.28],
		[2925194.04, 10457148.81],
		[2951850.05, 10457409.21],
		[2952057.67, 10430778.51],
		[2925504.53, 10430520.28],
	]], [[	/* 754:348 */
		[2952057.67, 10430778.51],
		[2951850.05, 10457409.21],
		[2978507.81, 10457566.19],
		[2978612.54, 10430934.18],
		[2952057.67, 10430778.51],
	]], [[	/* 754:349 */
		[2978612.54, 10430934.18],
		[2978507.81, 10457566.19],
		[3005166.45, 10457619.74],
		[3005168.27, 10430987.29],
		[2978612.54, 10430934.18],
	]], [[	/* 754:350 */
		[3005168.27, 10430987.29],
		[3005166.45, 10457619.74],
		[3031825.10, 10457569.85],
		[3031724.02, 10430937.82],
		[3005168.27, 10430987.29],
	]], [[	/* 754:351 */
		[3031724.02, 10430937.82],
		[3031825.10, 10457569.85],
		[3058482.90, 10457416.54],
		[3058278.93, 10430785.78],
		[3031724.02, 10430937.82],
	]], [[	/* 754:352 */
		[3058278.93, 10430785.78],
		[3058482.90, 10457416.54],
		[3085138.99, 10457159.81],
		[3084832.14, 10430531.19],
		[3058278.93, 10430785.78],
	]], [[	/* 754:353 */
		[3084832.14, 10430531.19],
		[3085138.99, 10457159.81],
		[3111792.49, 10456799.70],
		[3111382.79, 10430174.08],
		[3084832.14, 10430531.19],
	]], [[	/* 754:354 */
		[3111382.79, 10430174.08],
		[3111792.49, 10456799.70],
		[3138442.54, 10456336.23],
		[3137930.04, 10429714.47],
		[3111382.79, 10430174.08],
	]], [[	/* 754:355 */
		[3137930.04, 10429714.47],
		[3138442.54, 10456336.23],
		[3165088.28, 10455769.46],
		[3164473.03, 10429152.41],
		[3137930.04, 10429714.47],
	]], [[	/* 754:356 */
		[3164473.03, 10429152.41],
		[3165088.28, 10455769.46],
		[3191728.83, 10455099.44],
		[3191010.91, 10428487.97],
		[3164473.03, 10429152.41],
	]], [[	/* 754:357 */
		[3191010.91, 10428487.97],
		[3191728.83, 10455099.44],
		[3218363.35, 10454326.25],
		[3217542.81, 10427721.21],
		[3191010.91, 10428487.97],
	]], [[	/* 754:358 */
		[3217542.81, 10427721.21],
		[3218363.35, 10454326.25],
		[3244990.97, 10453449.95],
		[3244067.90, 10426852.21],
		[3217542.81, 10427721.21],
	]], [[	/* 754:359 */
		[3244067.90, 10426852.21],
		[3244990.97, 10453449.95],
		[3271610.83, 10452470.65],
		[3270585.32, 10425881.05],
		[3244067.90, 10426852.21],
	]], [[	/* 754:360 */
		[3270585.32, 10425881.05],
		[3271610.83, 10452470.65],
		[3298222.06, 10451388.44],
		[3297094.22, 10424807.83],
		[3270585.32, 10425881.05],
	]], [[	/* 755:334 */
		[2579217.56, 10444379.54],
		[2577562.62, 10471003.89],
		[2604219.99, 10472615.83],
		[2605772.43, 10445978.06],
		[2579217.56, 10444379.54],
	]], [[	/* 755:335 */
		[2605772.43, 10445978.06],
		[2604219.99, 10472615.83],
		[2630890.43, 10474124.67],
		[2632340.22, 10447474.33],
		[2605772.43, 10445978.06],
	]], [[	/* 755:336 */
		[2632340.22, 10447474.33],
		[2630890.43, 10474124.67],
		[2657573.09, 10475530.25],
		[2658920.07, 10448868.20],
		[2632340.22, 10447474.33],
	]], [[	/* 755:337 */
		[2658920.07, 10448868.20],
		[2657573.09, 10475530.25],
		[2684267.10, 10476832.43],
		[2685511.14, 10450159.53],
		[2658920.07, 10448868.20],
	]], [[	/* 755:338 */
		[2685511.14, 10450159.53],
		[2684267.10, 10476832.43],
		[2710971.60, 10478031.08],
		[2712112.57, 10451348.18],
		[2685511.14, 10450159.53],
	]], [[	/* 755:339 */
		[2712112.57, 10451348.18],
		[2710971.60, 10478031.08],
		[2737685.71, 10479126.07],
		[2738723.50, 10452434.04],
		[2712112.57, 10451348.18],
	]], [[	/* 755:340 */
		[2738723.50, 10452434.04],
		[2737685.71, 10479126.07],
		[2764408.59, 10480117.30],
		[2765343.09, 10453416.99],
		[2738723.50, 10452434.04],
	]], [[	/* 755:341 */
		[2765343.09, 10453416.99],
		[2764408.59, 10480117.30],
		[2791139.35, 10481004.65],
		[2791970.46, 10454296.94],
		[2765343.09, 10453416.99],
	]], [[	/* 755:342 */
		[2791970.46, 10454296.94],
		[2791139.35, 10481004.65],
		[2817877.13, 10481788.04],
		[2818604.76, 10455073.79],
		[2791970.46, 10454296.94],
	]], [[	/* 755:343 */
		[2818604.76, 10455073.79],
		[2817877.13, 10481788.04],
		[2844621.04, 10482467.39],
		[2845245.14, 10455747.47],
		[2818604.76, 10455073.79],
	]], [[	/* 755:344 */
		[2845245.14, 10455747.47],
		[2844621.04, 10482467.39],
		[2871370.23, 10483042.63],
		[2871890.72, 10456317.90],
		[2845245.14, 10455747.47],
	]], [[	/* 755:345 */
		[2871890.72, 10456317.90],
		[2871370.23, 10483042.63],
		[2898123.82, 10483513.69],
		[2898540.64, 10456785.03],
		[2871890.72, 10456317.90],
	]], [[	/* 755:346 */
		[2898540.64, 10456785.03],
		[2898123.82, 10483513.69],
		[2924880.93, 10483880.54],
		[2925194.04, 10457148.81],
		[2898540.64, 10456785.03],
	]], [[	/* 755:347 */
		[2925194.04, 10457148.81],
		[2924880.93, 10483880.54],
		[2951640.68, 10484143.13],
		[2951850.05, 10457409.21],
		[2925194.04, 10457148.81],
	]], [[	/* 755:348 */
		[2951850.05, 10457409.21],
		[2951640.68, 10484143.13],
		[2978402.20, 10484301.43],
		[2978507.81, 10457566.19],
		[2951850.05, 10457409.21],
	]], [[	/* 755:349 */
		[2978507.81, 10457566.19],
		[2978402.20, 10484301.43],
		[3005164.61, 10484355.43],
		[3005166.45, 10457619.74],
		[2978507.81, 10457566.19],
	]], [[	/* 755:350 */
		[3005166.45, 10457619.74],
		[3005164.61, 10484355.43],
		[3031927.03, 10484305.12],
		[3031825.10, 10457569.85],
		[3005166.45, 10457619.74],
	]], [[	/* 755:351 */
		[3031825.10, 10457569.85],
		[3031927.03, 10484305.12],
		[3058688.60, 10484150.52],
		[3058482.90, 10457416.54],
		[3031825.10, 10457569.85],
	]], [[	/* 755:352 */
		[3058482.90, 10457416.54],
		[3058688.60, 10484150.52],
		[3085448.42, 10483891.62],
		[3085138.99, 10457159.81],
		[3058482.90, 10457416.54],
	]], [[	/* 755:353 */
		[3085138.99, 10457159.81],
		[3085448.42, 10483891.62],
		[3112205.63, 10483528.47],
		[3111792.49, 10456799.70],
		[3085138.99, 10457159.81],
	]], [[	/* 755:354 */
		[3111792.49, 10456799.70],
		[3112205.63, 10483528.47],
		[3138959.35, 10483061.10],
		[3138442.54, 10456336.23],
		[3111792.49, 10456799.70],
	]], [[	/* 755:355 */
		[3138442.54, 10456336.23],
		[3138959.35, 10483061.10],
		[3165708.70, 10482489.55],
		[3165088.28, 10455769.46],
		[3138442.54, 10456336.23],
	]], [[	/* 755:356 */
		[3165088.28, 10455769.46],
		[3165708.70, 10482489.55],
		[3192452.80, 10481813.89],
		[3191728.83, 10455099.44],
		[3165088.28, 10455769.46],
	]], [[	/* 755:357 */
		[3191728.83, 10455099.44],
		[3192452.80, 10481813.89],
		[3219190.80, 10481034.19],
		[3218363.35, 10454326.25],
		[3191728.83, 10455099.44],
	]], [[	/* 755:358 */
		[3218363.35, 10454326.25],
		[3219190.80, 10481034.19],
		[3245921.81, 10480150.52],
		[3244990.97, 10453449.95],
		[3218363.35, 10454326.25],
	]], [[	/* 755:359 */
		[3244990.97, 10453449.95],
		[3245921.81, 10480150.52],
		[3272644.96, 10479162.97],
		[3271610.83, 10452470.65],
		[3244990.97, 10453449.95],
	]], [[	/* 755:360 */
		[3271610.83, 10452470.65],
		[3272644.96, 10479162.97],
		[3299359.38, 10478071.66],
		[3298222.06, 10451388.44],
		[3271610.83, 10452470.65],
	]], [[	/* 756:333 */
		[2550919.17, 10469289.01],
		[2549147.12, 10496001.67],
		[2575893.75, 10497730.99],
		[2577562.62, 10471003.89],
		[2550919.17, 10469289.01],
	]], [[	/* 756:334 */
		[2577562.62, 10471003.89],
		[2575893.75, 10497730.99],
		[2602654.47, 10499356.51],
		[2604219.99, 10472615.83],
		[2577562.62, 10471003.89],
	]], [[	/* 756:335 */
		[2604219.99, 10472615.83],
		[2602654.47, 10499356.51],
		[2629428.43, 10500878.07],
		[2630890.43, 10474124.67],
		[2604219.99, 10472615.83],
	]], [[	/* 756:336 */
		[2630890.43, 10474124.67],
		[2629428.43, 10500878.07],
		[2656214.76, 10502295.50],
		[2657573.09, 10475530.25],
		[2630890.43, 10474124.67],
	]], [[	/* 756:337 */
		[2657573.09, 10475530.25],
		[2656214.76, 10502295.50],
		[2683012.57, 10503608.67],
		[2684267.10, 10476832.43],
		[2657573.09, 10475530.25],
	]], [[	/* 756:338 */
		[2684267.10, 10476832.43],
		[2683012.57, 10503608.67],
		[2709821.00, 10504817.44],
		[2710971.60, 10478031.08],
		[2684267.10, 10476832.43],
	]], [[	/* 756:339 */
		[2710971.60, 10478031.08],
		[2709821.00, 10504817.44],
		[2736639.17, 10505921.68],
		[2737685.71, 10479126.07],
		[2710971.60, 10478031.08],
	]], [[	/* 756:340 */
		[2737685.71, 10479126.07],
		[2736639.17, 10505921.68],
		[2763466.20, 10506921.28],
		[2764408.59, 10480117.30],
		[2737685.71, 10479126.07],
	]], [[	/* 756:341 */
		[2764408.59, 10480117.30],
		[2763466.20, 10506921.28],
		[2790301.22, 10507816.13],
		[2791139.35, 10481004.65],
		[2764408.59, 10480117.30],
	]], [[	/* 756:342 */
		[2791139.35, 10481004.65],
		[2790301.22, 10507816.13],
		[2817143.34, 10508606.14],
		[2817877.13, 10481788.04],
		[2791139.35, 10481004.65],
	]], [[	/* 756:343 */
		[2817877.13, 10481788.04],
		[2817143.34, 10508606.14],
		[2843991.68, 10509291.23],
		[2844621.04, 10482467.39],
		[2817877.13, 10481788.04],
	]], [[	/* 756:344 */
		[2844621.04, 10482467.39],
		[2843991.68, 10509291.23],
		[2870845.36, 10509871.33],
		[2871370.23, 10483042.63],
		[2844621.04, 10482467.39],
	]], [[	/* 756:345 */
		[2871370.23, 10483042.63],
		[2870845.36, 10509871.33],
		[2897703.48, 10510346.38],
		[2898123.82, 10483513.69],
		[2871370.23, 10483042.63],
	]], [[	/* 756:346 */
		[2898123.82, 10483513.69],
		[2897703.48, 10510346.38],
		[2924565.17, 10510716.33],
		[2924880.93, 10483880.54],
		[2898123.82, 10483513.69],
	]], [[	/* 756:347 */
		[2924880.93, 10483880.54],
		[2924565.17, 10510716.33],
		[2951429.54, 10510981.14],
		[2951640.68, 10484143.13],
		[2924880.93, 10483880.54],
	]], [[	/* 756:348 */
		[2951640.68, 10484143.13],
		[2951429.54, 10510981.14],
		[2978295.70, 10511140.78],
		[2978402.20, 10484301.43],
		[2951640.68, 10484143.13],
	]], [[	/* 756:349 */
		[2978402.20, 10484301.43],
		[2978295.70, 10511140.78],
		[3005162.75, 10511195.23],
		[3005164.61, 10484355.43],
		[2978402.20, 10484301.43],
	]], [[	/* 756:350 */
		[3005164.61, 10484355.43],
		[3005162.75, 10511195.23],
		[3032029.83, 10511144.50],
		[3031927.03, 10484305.12],
		[3005164.61, 10484355.43],
	]], [[	/* 756:351 */
		[3031927.03, 10484305.12],
		[3032029.83, 10511144.50],
		[3058896.03, 10510988.59],
		[3058688.60, 10484150.52],
		[3031927.03, 10484305.12],
	]], [[	/* 756:352 */
		[3058688.60, 10484150.52],
		[3058896.03, 10510988.59],
		[3085760.47, 10510727.50],
		[3085448.42, 10483891.62],
		[3058688.60, 10484150.52],
	]], [[	/* 756:353 */
		[3085448.42, 10483891.62],
		[3085760.47, 10510727.50],
		[3112622.26, 10510361.28],
		[3112205.63, 10483528.47],
		[3085448.42, 10483891.62],
	]], [[	/* 756:354 */
		[3112205.63, 10483528.47],
		[3112622.26, 10510361.28],
		[3139480.52, 10509889.95],
		[3138959.35, 10483061.10],
		[3112205.63, 10483528.47],
	]], [[	/* 756:355 */
		[3138959.35, 10483061.10],
		[3139480.52, 10509889.95],
		[3166334.36, 10509313.57],
		[3165708.70, 10482489.55],
		[3138959.35, 10483061.10],
	]], [[	/* 756:356 */
		[3165708.70, 10482489.55],
		[3166334.36, 10509313.57],
		[3193182.89, 10508632.20],
		[3192452.80, 10481813.89],
		[3165708.70, 10482489.55],
	]], [[	/* 756:357 */
		[3192452.80, 10481813.89],
		[3193182.89, 10508632.20],
		[3220025.23, 10507845.90],
		[3219190.80, 10481034.19],
		[3192452.80, 10481813.89],
	]], [[	/* 756:358 */
		[3219190.80, 10481034.19],
		[3220025.23, 10507845.90],
		[3246860.50, 10506954.76],
		[3245921.81, 10480150.52],
		[3219190.80, 10481034.19],
	]], [[	/* 757:333 */
		[2549147.12, 10496001.67],
		[2547360.10, 10522817.75],
		[2574210.78, 10524561.69],
		[2575893.75, 10497730.99],
		[2549147.12, 10496001.67],
	]], [[	/* 757:334 */
		[2575893.75, 10497730.99],
		[2574210.78, 10524561.69],
		[2601075.73, 10526200.96],
		[2602654.47, 10499356.51],
		[2575893.75, 10497730.99],
	]], [[	/* 757:335 */
		[2602654.47, 10499356.51],
		[2601075.73, 10526200.96],
		[2627954.07, 10527735.40],
		[2629428.43, 10500878.07],
		[2602654.47, 10499356.51],
	]], [[	/* 757:336 */
		[2629428.43, 10500878.07],
		[2627954.07, 10527735.40],
		[2654844.93, 10529164.83],
		[2656214.76, 10502295.50],
		[2629428.43, 10500878.07],
	]], [[	/* 757:337 */
		[2656214.76, 10502295.50],
		[2654844.93, 10529164.83],
		[2681747.42, 10530489.13],
		[2683012.57, 10503608.67],
		[2656214.76, 10502295.50],
	]], [[	/* 757:338 */
		[2683012.57, 10503608.67],
		[2681747.42, 10530489.13],
		[2708660.66, 10531708.14],
		[2709821.00, 10504817.44],
		[2683012.57, 10503608.67],
	]], [[	/* 757:339 */
		[2709821.00, 10504817.44],
		[2708660.66, 10531708.14],
		[2735583.76, 10532821.74],
		[2736639.17, 10505921.68],
		[2709821.00, 10504817.44],
	]], [[	/* 757:340 */
		[2736639.17, 10505921.68],
		[2735583.76, 10532821.74],
		[2762515.83, 10533829.81],
		[2763466.20, 10506921.28],
		[2736639.17, 10505921.68],
	]], [[	/* 757:341 */
		[2763466.20, 10506921.28],
		[2762515.83, 10533829.81],
		[2789455.99, 10534732.25],
		[2790301.22, 10507816.13],
		[2763466.20, 10506921.28],
	]], [[	/* 757:342 */
		[2790301.22, 10507816.13],
		[2789455.99, 10534732.25],
		[2816403.34, 10535528.97],
		[2817143.34, 10508606.14],
		[2790301.22, 10507816.13],
	]], [[	/* 757:343 */
		[2817143.34, 10508606.14],
		[2816403.34, 10535528.97],
		[2843356.98, 10536219.87],
		[2843991.68, 10509291.23],
		[2817143.34, 10508606.14],
	]], [[	/* 757:344 */
		[2843991.68, 10509291.23],
		[2843356.98, 10536219.87],
		[2870316.03, 10536804.90],
		[2870845.36, 10509871.33],
		[2843991.68, 10509291.23],
	]], [[	/* 757:345 */
		[2870845.36, 10509871.33],
		[2870316.03, 10536804.90],
		[2897279.58, 10537283.98],
		[2897703.48, 10510346.38],
		[2870845.36, 10509871.33],
	]], [[	/* 757:346 */
		[2897703.48, 10510346.38],
		[2897279.58, 10537283.98],
		[2924246.74, 10537657.06],
		[2924565.17, 10510716.33],
		[2897703.48, 10510346.38],
	]], [[	/* 757:347 */
		[2924565.17, 10510716.33],
		[2924246.74, 10537657.06],
		[2951216.61, 10537924.12],
		[2951429.54, 10510981.14],
		[2924565.17, 10510716.33],
	]], [[	/* 757:348 */
		[2951429.54, 10510981.14],
		[2951216.61, 10537924.12],
		[2978188.29, 10538085.12],
		[2978295.70, 10511140.78],
		[2951429.54, 10510981.14],
	]], [[	/* 757:349 */
		[2978295.70, 10511140.78],
		[2978188.29, 10538085.12],
		[3005160.89, 10538140.03],
		[3005162.75, 10511195.23],
		[2978295.70, 10511140.78],
	]], [[	/* 757:350 */
		[3005162.75, 10511195.23],
		[3005160.89, 10538140.03],
		[3032133.50, 10538088.87],
		[3032029.83, 10511144.50],
		[3005162.75, 10511195.23],
	]], [[	/* 757:351 */
		[3032029.83, 10511144.50],
		[3032133.50, 10538088.87],
		[3059105.22, 10537931.63],
		[3058896.03, 10510988.59],
		[3032029.83, 10511144.50],
	]], [[	/* 757:352 */
		[3058896.03, 10510988.59],
		[3059105.22, 10537931.63],
		[3086075.17, 10537668.33],
		[3085760.47, 10510727.50],
		[3058896.03, 10510988.59],
	]], [[	/* 757:353 */
		[3085760.47, 10510727.50],
		[3086075.17, 10537668.33],
		[3113042.43, 10537298.99],
		[3112622.26, 10510361.28],
		[3085760.47, 10510727.50],
	]], [[	/* 757:354 */
		[3112622.26, 10510361.28],
		[3113042.43, 10537298.99],
		[3140006.12, 10536823.66],
		[3139480.52, 10509889.95],
		[3112622.26, 10510361.28],
	]], [[	/* 757:355 */
		[3139480.52, 10509889.95],
		[3140006.12, 10536823.66],
		[3166965.33, 10536242.39],
		[3166334.36, 10509313.57],
		[3139480.52, 10509889.95],
	]], [[	/* 757:356 */
		[3166334.36, 10509313.57],
		[3166965.33, 10536242.39],
		[3193919.16, 10535555.23],
		[3193182.89, 10508632.20],
		[3166334.36, 10509313.57],
	]], [[	/* 758:333 */
		[2547360.10, 10522817.75],
		[2545557.95, 10549738.12],
		[2572513.54, 10551496.86],
		[2574210.78, 10524561.69],
		[2547360.10, 10522817.75],
	]], [[	/* 758:334 */
		[2574210.78, 10524561.69],
		[2572513.54, 10551496.86],
		[2599483.59, 10553150.05],
		[2601075.73, 10526200.96],
		[2574210.78, 10524561.69],
	]], [[	/* 758:335 */
		[2601075.73, 10526200.96],
		[2599483.59, 10553150.05],
		[2626467.19, 10554697.53],
		[2627954.07, 10527735.40],
		[2601075.73, 10526200.96],
	]], [[	/* 758:336 */
		[2627954.07, 10527735.40],
		[2626467.19, 10554697.53],
		[2653463.47, 10556139.12],
		[2654844.93, 10529164.83],
		[2627954.07, 10527735.40],
	]], [[	/* 758:337 */
		[2654844.93, 10529164.83],
		[2653463.47, 10556139.12],
		[2680471.52, 10557474.67],
		[2681747.42, 10530489.13],
		[2654844.93, 10529164.83],
	]], [[	/* 758:338 */
		[2681747.42, 10530489.13],
		[2680471.52, 10557474.67],
		[2707490.46, 10558704.05],
		[2708660.66, 10531708.14],
		[2681747.42, 10530489.13],
	]], [[	/* 758:339 */
		[2708660.66, 10531708.14],
		[2707490.46, 10558704.05],
		[2734519.38, 10559827.13],
		[2735583.76, 10532821.74],
		[2708660.66, 10531708.14],
	]], [[	/* 758:340 */
		[2735583.76, 10532821.74],
		[2734519.38, 10559827.13],
		[2761557.38, 10560843.78],
		[2762515.83, 10533829.81],
		[2735583.76, 10532821.74],
	]], [[	/* 758:341 */
		[2762515.83, 10533829.81],
		[2761557.38, 10560843.78],
		[2788603.57, 10561753.91],
		[2789455.99, 10534732.25],
		[2762515.83, 10533829.81],
	]], [[	/* 758:342 */
		[2789455.99, 10534732.25],
		[2788603.57, 10561753.91],
		[2815657.04, 10562557.41],
		[2816403.34, 10535528.97],
		[2789455.99, 10534732.25],
	]], [[	/* 758:343 */
		[2816403.34, 10535528.97],
		[2815657.04, 10562557.41],
		[2842716.88, 10563254.20],
		[2843356.98, 10536219.87],
		[2816403.34, 10535528.97],
	]], [[	/* 758:344 */
		[2843356.98, 10536219.87],
		[2842716.88, 10563254.20],
		[2869782.19, 10563844.21],
		[2870316.03, 10536804.90],
		[2843356.98, 10536219.87],
	]], [[	/* 758:345 */
		[2870316.03, 10536804.90],
		[2869782.19, 10563844.21],
		[2896852.07, 10564327.37],
		[2897279.58, 10537283.98],
		[2870316.03, 10536804.90],
	]], [[	/* 758:346 */
		[2897279.58, 10537283.98],
		[2896852.07, 10564327.37],
		[2923925.59, 10564703.64],
		[2924246.74, 10537657.06],
		[2897279.58, 10537283.98],
	]], [[	/* 758:347 */
		[2924246.74, 10537657.06],
		[2923925.59, 10564703.64],
		[2951001.87, 10564972.97],
		[2951216.61, 10537924.12],
		[2924246.74, 10537657.06],
	]], [[	/* 758:348 */
		[2951216.61, 10537924.12],
		[2951001.87, 10564972.97],
		[2978079.97, 10565135.34],
		[2978188.29, 10538085.12],
		[2951216.61, 10537924.12],
	]], [[	/* 758:349 */
		[2978188.29, 10538085.12],
		[2978079.97, 10565135.34],
		[3005159.00, 10565190.72],
		[3005160.89, 10538140.03],
		[2978188.29, 10538085.12],
	]], [[	/* 758:350 */
		[3005160.89, 10538140.03],
		[3005159.00, 10565190.72],
		[3032238.05, 10565139.12],
		[3032133.50, 10538088.87],
		[3005160.89, 10538140.03],
	]], [[	/* 758:351 */
		[3032133.50, 10538088.87],
		[3032238.05, 10565139.12],
		[3059316.20, 10564980.54],
		[3059105.22, 10537931.63],
		[3032133.50, 10538088.87],
	]], [[	/* 758:352 */
		[3059105.22, 10537931.63],
		[3059316.20, 10564980.54],
		[3086392.55, 10564714.99],
		[3086075.17, 10537668.33],
		[3059105.22, 10537931.63],
	]], [[	/* 758:353 */
		[3086075.17, 10537668.33],
		[3086392.55, 10564714.99],
		[3113466.18, 10564342.51],
		[3113042.43, 10537298.99],
		[3086075.17, 10537668.33],
	]], [[	/* 758:354 */
		[3113042.43, 10537298.99],
		[3113466.18, 10564342.51],
		[3140536.19, 10563863.13],
		[3140006.12, 10536823.66],
		[3113042.43, 10537298.99],
	]], [[	/* 758:355 */
		[3140006.12, 10536823.66],
		[3140536.19, 10563863.13],
		[3167601.67, 10563276.90],
		[3166965.33, 10536242.39],
		[3140006.12, 10536823.66],
	]], [[	/* 758:356 */
		[3166965.33, 10536242.39],
		[3167601.67, 10563276.90],
		[3194661.71, 10562583.88],
		[3193919.16, 10535555.23],
		[3166965.33, 10536242.39],
	]], [[	/* 759:331 */
		[2491693.64, 10545904.73],
		[2489665.12, 10572897.64],
		[2516694.58, 10574883.68],
		[2518617.68, 10547874.01],
		[2491693.64, 10545904.73],
	]], [[	/* 759:332 */
		[2518617.68, 10547874.01],
		[2516694.58, 10574883.68],
		[2543740.45, 10576763.66],
		[2545557.95, 10549738.12],
		[2518617.68, 10547874.01],
	]], [[	/* 759:333 */
		[2545557.95, 10549738.12],
		[2543740.45, 10576763.66],
		[2570801.85, 10578537.39],
		[2572513.54, 10551496.86],
		[2545557.95, 10549738.12],
	]], [[	/* 759:334 */
		[2572513.54, 10551496.86],
		[2570801.85, 10578537.39],
		[2597877.88, 10580204.68],
		[2599483.59, 10553150.05],
		[2572513.54, 10551496.86],
	]], [[	/* 759:335 */
		[2599483.59, 10553150.05],
		[2597877.88, 10580204.68],
		[2624967.64, 10581765.35],
		[2626467.19, 10554697.53],
		[2599483.59, 10553150.05],
	]], [[	/* 759:336 */
		[2626467.19, 10554697.53],
		[2624967.64, 10581765.35],
		[2652070.23, 10583219.24],
		[2653463.47, 10556139.12],
		[2626467.19, 10554697.53],
	]], [[	/* 759:337 */
		[2653463.47, 10556139.12],
		[2652070.23, 10583219.24],
		[2679184.74, 10584566.19],
		[2680471.52, 10557474.67],
		[2653463.47, 10556139.12],
	]], [[	/* 759:338 */
		[2680471.52, 10557474.67],
		[2679184.74, 10584566.19],
		[2706310.27, 10585806.07],
		[2707490.46, 10558704.05],
		[2680471.52, 10557474.67],
	]], [[	/* 759:339 */
		[2707490.46, 10558704.05],
		[2706310.27, 10585806.07],
		[2733445.91, 10586938.75],
		[2734519.38, 10559827.13],
		[2707490.46, 10558704.05],
	]], [[	/* 759:340 */
		[2734519.38, 10559827.13],
		[2733445.91, 10586938.75],
		[2760590.75, 10587964.09],
		[2761557.38, 10560843.78],
		[2734519.38, 10559827.13],
	]], [[	/* 759:341 */
		[2761557.38, 10560843.78],
		[2760590.75, 10587964.09],
		[2787743.87, 10588881.99],
		[2788603.57, 10561753.91],
		[2761557.38, 10560843.78],
	]], [[	/* 759:342 */
		[2788603.57, 10561753.91],
		[2787743.87, 10588881.99],
		[2814904.36, 10589692.37],
		[2815657.04, 10562557.41],
		[2788603.57, 10561753.91],
	]], [[	/* 759:343 */
		[2815657.04, 10562557.41],
		[2814904.36, 10589692.37],
		[2842071.31, 10590395.12],
		[2842716.88, 10563254.20],
		[2815657.04, 10562557.41],
	]], [[	/* 759:344 */
		[2842716.88, 10563254.20],
		[2842071.31, 10590395.12],
		[2869243.80, 10590990.17],
		[2869782.19, 10563844.21],
		[2842716.88, 10563254.20],
	]], [[	/* 759:345 */
		[2869782.19, 10563844.21],
		[2869243.80, 10590990.17],
		[2896420.90, 10591477.47],
		[2896852.07, 10564327.37],
		[2869782.19, 10563844.21],
	]], [[	/* 759:346 */
		[2896852.07, 10564327.37],
		[2896420.90, 10591477.47],
		[2923601.71, 10591856.96],
		[2923925.59, 10564703.64],
		[2896852.07, 10564327.37],
	]], [[	/* 759:347 */
		[2923925.59, 10564703.64],
		[2923601.71, 10591856.96],
		[2950785.29, 10592128.59],
		[2951001.87, 10564972.97],
		[2923925.59, 10564703.64],
	]], [[	/* 759:348 */
		[2951001.87, 10564972.97],
		[2950785.29, 10592128.59],
		[2977970.73, 10592292.35],
		[2978079.97, 10565135.34],
		[2951001.87, 10564972.97],
	]], [[	/* 759:349 */
		[2978079.97, 10565135.34],
		[2977970.73, 10592292.35],
		[3005157.10, 10592348.21],
		[3005159.00, 10565190.72],
		[2978079.97, 10565135.34],
	]], [[	/* 759:350 */
		[3005159.00, 10565190.72],
		[3005157.10, 10592348.21],
		[3032343.50, 10592296.16],
		[3032238.05, 10565139.12],
		[3005159.00, 10565190.72],
	]], [[	/* 759:351 */
		[3032238.05, 10565139.12],
		[3032343.50, 10592296.16],
		[3059528.98, 10592136.22],
		[3059316.20, 10564980.54],
		[3032238.05, 10565139.12],
	]], [[	/* 759:352 */
		[3059316.20, 10564980.54],
		[3059528.98, 10592136.22],
		[3086712.64, 10591868.40],
		[3086392.55, 10564714.99],
		[3059316.20, 10564980.54],
	]], [[	/* 759:353 */
		[3086392.55, 10564714.99],
		[3086712.64, 10591868.40],
		[3113893.55, 10591492.73],
		[3113466.18, 10564342.51],
		[3086392.55, 10564714.99],
	]], [[	/* 759:354 */
		[3113466.18, 10564342.51],
		[3113893.55, 10591492.73],
		[3141070.79, 10591009.24],
		[3140536.19, 10563863.13],
		[3113466.18, 10564342.51],
	]], [[	/* 759:355 */
		[3140536.19, 10563863.13],
		[3141070.79, 10591009.24],
		[3168243.45, 10590418.00],
		[3167601.67, 10563276.90],
		[3140536.19, 10563863.13],
	]], [[	/* 759:356 */
		[3167601.67, 10563276.90],
		[3168243.45, 10590418.00],
		[3195410.59, 10589719.05],
		[3194661.71, 10562583.88],
		[3167601.67, 10563276.90],
	]], [[	/* 760:329 */
		[2435659.00, 10568608.25],
		[2433401.23, 10595670.20],
		[2460501.05, 10597886.46],
		[2462652.96, 10570805.76],
		[2435659.00, 10568608.25],
	]], [[	/* 760:330 */
		[2462652.96, 10570805.76],
		[2460501.05, 10597886.46],
		[2487619.29, 10599996.21],
		[2489665.12, 10572897.64],
		[2462652.96, 10570805.76],
	]], [[	/* 760:331 */
		[2489665.12, 10572897.64],
		[2487619.29, 10599996.21],
		[2514755.05, 10601999.21],
		[2516694.58, 10574883.68],
		[2489665.12, 10572897.64],
	]], [[	/* 760:332 */
		[2516694.58, 10574883.68],
		[2514755.05, 10601999.21],
		[2541907.43, 10603895.27],
		[2543740.45, 10576763.66],
		[2516694.58, 10574883.68],
	]], [[	/* 760:333 */
		[2543740.45, 10576763.66],
		[2541907.43, 10603895.27],
		[2569075.53, 10605684.16],
		[2570801.85, 10578537.39],
		[2543740.45, 10576763.66],
	]], [[	/* 760:334 */
		[2570801.85, 10578537.39],
		[2569075.53, 10605684.16],
		[2596258.45, 10607365.72],
		[2597877.88, 10580204.68],
		[2570801.85, 10578537.39],
	]], [[	/* 760:335 */
		[2597877.88, 10580204.68],
		[2596258.45, 10607365.72],
		[2623455.26, 10608939.76],
		[2624967.64, 10581765.35],
		[2597877.88, 10580204.68],
	]], [[	/* 760:336 */
		[2624967.64, 10581765.35],
		[2623455.26, 10608939.76],
		[2650665.07, 10610406.10],
		[2652070.23, 10583219.24],
		[2624967.64, 10581765.35],
	]], [[	/* 760:337 */
		[2652070.23, 10583219.24],
		[2650665.07, 10610406.10],
		[2677886.94, 10611764.60],
		[2679184.74, 10584566.19],
		[2652070.23, 10583219.24],
	]], [[	/* 760:338 */
		[2679184.74, 10584566.19],
		[2677886.94, 10611764.60],
		[2705119.98, 10613015.11],
		[2706310.27, 10585806.07],
		[2679184.74, 10584566.19],
	]], [[	/* 760:339 */
		[2706310.27, 10585806.07],
		[2705119.98, 10613015.11],
		[2732363.25, 10614157.50],
		[2733445.91, 10586938.75],
		[2706310.27, 10585806.07],
	]], [[	/* 760:340 */
		[2733445.91, 10586938.75],
		[2732363.25, 10614157.50],
		[2759615.83, 10615191.64],
		[2760590.75, 10587964.09],
		[2733445.91, 10586938.75],
	]], [[	/* 760:341 */
		[2760590.75, 10587964.09],
		[2759615.83, 10615191.64],
		[2786876.80, 10616117.42],
		[2787743.87, 10588881.99],
		[2760590.75, 10587964.09],
	]], [[	/* 760:342 */
		[2787743.87, 10588881.99],
		[2786876.80, 10616117.42],
		[2814145.24, 10616934.75],
		[2814904.36, 10589692.37],
		[2787743.87, 10588881.99],
	]], [[	/* 760:343 */
		[2814904.36, 10589692.37],
		[2814145.24, 10616934.75],
		[2841420.21, 10617643.53],
		[2842071.31, 10590395.12],
		[2814904.36, 10589692.37],
	]], [[	/* 760:344 */
		[2842071.31, 10590395.12],
		[2841420.21, 10617643.53],
		[2868700.78, 10618243.70],
		[2869243.80, 10590990.17],
		[2842071.31, 10590395.12],
	]], [[	/* 760:345 */
		[2869243.80, 10590990.17],
		[2868700.78, 10618243.70],
		[2895986.04, 10618735.18],
		[2896420.90, 10591477.47],
		[2869243.80, 10590990.17],
	]], [[	/* 760:346 */
		[2896420.90, 10591477.47],
		[2895986.04, 10618735.18],
		[2923275.04, 10619117.93],
		[2923601.71, 10591856.96],
		[2896420.90, 10591477.47],
	]], [[	/* 760:347 */
		[2923601.71, 10591856.96],
		[2923275.04, 10619117.93],
		[2950566.85, 10619391.90],
		[2950785.29, 10592128.59],
		[2923601.71, 10591856.96],
	]], [[	/* 760:348 */
		[2950785.29, 10592128.59],
		[2950566.85, 10619391.90],
		[2977860.55, 10619557.06],
		[2977970.73, 10592292.35],
		[2950785.29, 10592128.59],
	]], [[	/* 760:349 */
		[2977970.73, 10592292.35],
		[2977860.55, 10619557.06],
		[3005155.19, 10619613.40],
		[3005157.10, 10592348.21],
		[2977970.73, 10592292.35],
	]], [[	/* 760:350 */
		[3005157.10, 10592348.21],
		[3005155.19, 10619613.40],
		[3032449.85, 10619560.91],
		[3032343.50, 10592296.16],
		[3005157.10, 10592348.21],
	]], [[	/* 760:351 */
		[3032343.50, 10592296.16],
		[3032449.85, 10619560.91],
		[3059743.59, 10619399.59],
		[3059528.98, 10592136.22],
		[3032343.50, 10592296.16],
	]], [[	/* 760:352 */
		[3059528.98, 10592136.22],
		[3059743.59, 10619399.59],
		[3087035.48, 10619129.47],
		[3086712.64, 10591868.40],
		[3059528.98, 10592136.22],
	]], [[	/* 760:353 */
		[3086712.64, 10591868.40],
		[3087035.48, 10619129.47],
		[3114324.59, 10618750.56],
		[3113893.55, 10591492.73],
		[3086712.64, 10591868.40],
	]], [[	/* 760:354 */
		[3113893.55, 10591492.73],
		[3114324.59, 10618750.56],
		[3141609.99, 10618262.92],
		[3141070.79, 10591009.24],
		[3113893.55, 10591492.73],
	]], [[	/* 760:355 */
		[3141070.79, 10591009.24],
		[3141609.99, 10618262.92],
		[3168890.73, 10617666.60],
		[3168243.45, 10590418.00],
		[3141070.79, 10591009.24],
	]], [[	/* 760:356 */
		[3168243.45, 10590418.00],
		[3168890.73, 10617666.60],
		[3196165.91, 10616961.65],
		[3195410.59, 10589719.05],
		[3168243.45, 10590418.00],
	]], [[	/* 761:329 */
		[2433401.23, 10595670.20],
		[2431124.14, 10622838.24],
		[2458330.72, 10625073.49],
		[2460501.05, 10597886.46],
		[2433401.23, 10595670.20],
	]], [[	/* 761:330 */
		[2460501.05, 10597886.46],
		[2458330.72, 10625073.49],
		[2485555.94, 10627201.32],
		[2487619.29, 10599996.21],
		[2460501.05, 10597886.46],
	]], [[	/* 761:331 */
		[2487619.29, 10599996.21],
		[2485555.94, 10627201.32],
		[2512798.90, 10629221.50],
		[2514755.05, 10601999.21],
		[2487619.29, 10599996.21],
	]], [[	/* 761:332 */
		[2514755.05, 10601999.21],
		[2512798.90, 10629221.50],
		[2540058.70, 10631133.83],
		[2541907.43, 10603895.27],
		[2514755.05, 10601999.21],
	]], [[	/* 761:333 */
		[2541907.43, 10603895.27],
		[2540058.70, 10631133.83],
		[2567334.40, 10632938.09],
		[2569075.53, 10605684.16],
		[2541907.43, 10603895.27],
	]], [[	/* 761:334 */
		[2569075.53, 10605684.16],
		[2567334.40, 10632938.09],
		[2594625.11, 10634634.09],
		[2596258.45, 10607365.72],
		[2569075.53, 10605684.16],
	]], [[	/* 761:335 */
		[2596258.45, 10607365.72],
		[2594625.11, 10634634.09],
		[2621929.89, 10636221.66],
		[2623455.26, 10608939.76],
		[2596258.45, 10607365.72],
	]], [[	/* 761:336 */
		[2623455.26, 10608939.76],
		[2621929.89, 10636221.66],
		[2649247.83, 10637700.62],
		[2650665.07, 10610406.10],
		[2623455.26, 10608939.76],
	]], [[	/* 761:337 */
		[2650665.07, 10610406.10],
		[2649247.83, 10637700.62],
		[2676577.99, 10639070.81],
		[2677886.94, 10611764.60],
		[2650665.07, 10610406.10],
	]], [[	/* 761:338 */
		[2677886.94, 10611764.60],
		[2676577.99, 10639070.81],
		[2703919.44, 10640332.08],
		[2705119.98, 10613015.11],
		[2677886.94, 10611764.60],
	]], [[	/* 761:339 */
		[2705119.98, 10613015.11],
		[2703919.44, 10640332.08],
		[2731271.27, 10641484.30],
		[2732363.25, 10614157.50],
		[2705119.98, 10613015.11],
	]], [[	/* 761:340 */
		[2732363.25, 10614157.50],
		[2731271.27, 10641484.30],
		[2758632.52, 10642527.35],
		[2759615.83, 10615191.64],
		[2732363.25, 10614157.50],
	]], [[	/* 761:341 */
		[2759615.83, 10615191.64],
		[2758632.52, 10642527.35],
		[2786002.27, 10643461.11],
		[2786876.80, 10616117.42],
		[2759615.83, 10615191.64],
	]], [[	/* 761:342 */
		[2786876.80, 10616117.42],
		[2786002.27, 10643461.11],
		[2813379.57, 10644285.48],
		[2814145.24, 10616934.75],
		[2786876.80, 10616117.42],
	]], [[	/* 761:343 */
		[2814145.24, 10616934.75],
		[2813379.57, 10644285.48],
		[2840763.49, 10645000.38],
		[2841420.21, 10617643.53],
		[2814145.24, 10616934.75],
	]], [[	/* 761:344 */
		[2841420.21, 10617643.53],
		[2840763.49, 10645000.38],
		[2868153.09, 10645605.72],
		[2868700.78, 10618243.70],
		[2841420.21, 10617643.53],
	]], [[	/* 761:345 */
		[2868700.78, 10618243.70],
		[2868153.09, 10645605.72],
		[2895547.43, 10646101.44],
		[2895986.04, 10618735.18],
		[2868700.78, 10618243.70],
	]], [[	/* 761:346 */
		[2895986.04, 10618735.18],
		[2895547.43, 10646101.44],
		[2922945.56, 10646487.49],
		[2923275.04, 10619117.93],
		[2895986.04, 10618735.18],
	]], [[	/* 761:347 */
		[2923275.04, 10619117.93],
		[2922945.56, 10646487.49],
		[2950346.54, 10646763.82],
		[2950566.85, 10619391.90],
		[2923275.04, 10619117.93],
	]], [[	/* 761:348 */
		[2950566.85, 10619391.90],
		[2950346.54, 10646763.82],
		[2977749.42, 10646930.40],
		[2977860.55, 10619557.06],
		[2950566.85, 10619391.90],
	]], [[	/* 761:349 */
		[2977860.55, 10619557.06],
		[2977749.42, 10646930.40],
		[3005153.26, 10646987.23],
		[3005155.19, 10619613.40],
		[2977860.55, 10619557.06],
	]], [[	/* 761:350 */
		[3005155.19, 10619613.40],
		[3005153.26, 10646987.23],
		[3032557.12, 10646934.28],
		[3032449.85, 10619560.91],
		[3005155.19, 10619613.40],
	]], [[	/* 761:351 */
		[3032449.85, 10619560.91],
		[3032557.12, 10646934.28],
		[3059960.05, 10646771.57],
		[3059743.59, 10619399.59],
		[3032449.85, 10619560.91],
	]], [[	/* 761:352 */
		[3059743.59, 10619399.59],
		[3059960.05, 10646771.57],
		[3087361.11, 10646499.12],
		[3087035.48, 10619129.47],
		[3059743.59, 10619399.59],
	]], [[	/* 761:353 */
		[3087035.48, 10619129.47],
		[3087361.11, 10646499.12],
		[3114759.35, 10646116.95],
		[3114324.59, 10618750.56],
		[3087035.48, 10619129.47],
	]], [[	/* 761:354 */
		[3114324.59, 10618750.56],
		[3114759.35, 10646116.95],
		[3142153.82, 10645625.10],
		[3141609.99, 10618262.92],
		[3114324.59, 10618750.56],
	]], [[	/* 761:355 */
		[3141609.99, 10618262.92],
		[3142153.82, 10645625.10],
		[3169543.60, 10645023.63],
		[3168890.73, 10617666.60],
		[3141609.99, 10618262.92],
	]], [[	/* 761:356 */
		[3168890.73, 10617666.60],
		[3169543.60, 10645023.63],
		[3196927.72, 10644312.60],
		[3196165.91, 10616961.65],
		[3168890.73, 10617666.60],
	]], [[	/* 762:328 */
		[2403937.12, 10620495.82],
		[2401533.08, 10647750.72],
		[2428827.51, 10650113.27],
		[2431124.14, 10622838.24],
		[2403937.12, 10620495.82],
	]], [[	/* 762:329 */
		[2431124.14, 10622838.24],
		[2428827.51, 10650113.27],
		[2456141.74, 10652367.74],
		[2458330.72, 10625073.49],
		[2431124.14, 10622838.24],
	]], [[	/* 762:330 */
		[2458330.72, 10625073.49],
		[2456141.74, 10652367.74],
		[2483474.85, 10654513.88],
		[2485555.94, 10627201.32],
		[2458330.72, 10625073.49],
	]], [[	/* 762:331 */
		[2485555.94, 10627201.32],
		[2483474.85, 10654513.88],
		[2510825.92, 10656551.46],
		[2512798.90, 10629221.50],
		[2485555.94, 10627201.32],
	]], [[	/* 762:332 */
		[2512798.90, 10629221.50],
		[2510825.92, 10656551.46],
		[2538194.04, 10658480.26],
		[2540058.70, 10631133.83],
		[2512798.90, 10629221.50],
	]], [[	/* 762:333 */
		[2540058.70, 10631133.83],
		[2538194.04, 10658480.26],
		[2565578.28, 10660300.08],
		[2567334.40, 10632938.09],
		[2540058.70, 10631133.83],
	]], [[	/* 762:334 */
		[2567334.40, 10632938.09],
		[2565578.28, 10660300.08],
		[2592977.70, 10662010.71],
		[2594625.11, 10634634.09],
		[2567334.40, 10632938.09],
	]], [[	/* 762:335 */
		[2594625.11, 10634634.09],
		[2592977.70, 10662010.71],
		[2620391.37, 10663611.98],
		[2621929.89, 10636221.66],
		[2594625.11, 10634634.09],
	]], [[	/* 762:336 */
		[2621929.89, 10636221.66],
		[2620391.37, 10663611.98],
		[2647818.36, 10665103.71],
		[2649247.83, 10637700.62],
		[2621929.89, 10636221.66],
	]], [[	/* 762:337 */
		[2649247.83, 10637700.62],
		[2647818.36, 10665103.71],
		[2675257.74, 10666485.73],
		[2676577.99, 10639070.81],
		[2649247.83, 10637700.62],
	]], [[	/* 762:338 */
		[2676577.99, 10639070.81],
		[2675257.74, 10666485.73],
		[2702708.55, 10667757.90],
		[2703919.44, 10640332.08],
		[2676577.99, 10639070.81],
	]], [[	/* 762:339 */
		[2703919.44, 10640332.08],
		[2702708.55, 10667757.90],
		[2730169.86, 10668920.09],
		[2731271.27, 10641484.30],
		[2703919.44, 10640332.08],
	]], [[	/* 762:340 */
		[2731271.27, 10641484.30],
		[2730169.86, 10668920.09],
		[2757640.71, 10669972.16],
		[2758632.52, 10642527.35],
		[2731271.27, 10641484.30],
	]], [[	/* 762:342 */
		[2786002.27, 10643461.11],
		[2785120.17, 10670914.00],
		[2812607.29, 10671745.50],
		[2813379.57, 10644285.48],
		[2786002.27, 10643461.11],
	]], [[	/* 762:343 */
		[2813379.57, 10644285.48],
		[2812607.29, 10671745.50],
		[2840101.10, 10672466.58],
		[2840763.49, 10645000.38],
		[2813379.57, 10644285.48],
	]], [[	/* 762:344 */
		[2840763.49, 10645000.38],
		[2840101.10, 10672466.58],
		[2867600.67, 10673077.16],
		[2868153.09, 10645605.72],
		[2840763.49, 10645000.38],
	]], [[	/* 762:345 */
		[2868153.09, 10645605.72],
		[2867600.67, 10673077.16],
		[2895105.03, 10673577.18],
		[2895547.43, 10646101.44],
		[2868153.09, 10645605.72],
	]], [[	/* 762:346 */
		[2895547.43, 10646101.44],
		[2895105.03, 10673577.18],
		[2922613.23, 10673966.57],
		[2922945.56, 10646487.49],
		[2895547.43, 10646101.44],
	]], [[	/* 762:347 */
		[2922945.56, 10646487.49],
		[2922613.23, 10673966.57],
		[2950124.31, 10674245.29],
		[2950346.54, 10646763.82],
		[2922945.56, 10646487.49],
	]], [[	/* 762:348 */
		[2950346.54, 10646763.82],
		[2950124.31, 10674245.29],
		[2977637.33, 10674413.32],
		[2977749.42, 10646930.40],
		[2950346.54, 10646763.82],
	]], [[	/* 762:349 */
		[2977749.42, 10646930.40],
		[2977637.33, 10674413.32],
		[3005151.32, 10674470.63],
		[3005153.26, 10646987.23],
		[2977749.42, 10646930.40],
	]], [[	/* 762:350 */
		[3005153.26, 10646987.23],
		[3005151.32, 10674470.63],
		[3032665.32, 10674417.23],
		[3032557.12, 10646934.28],
		[3005153.26, 10646987.23],
	]], [[	/* 762:351 */
		[3032557.12, 10646934.28],
		[3032665.32, 10674417.23],
		[3060178.38, 10674253.11],
		[3059960.05, 10646771.57],
		[3032557.12, 10646934.28],
	]], [[	/* 762:352 */
		[3059960.05, 10646771.57],
		[3060178.38, 10674253.11],
		[3087689.55, 10673978.29],
		[3087361.11, 10646499.12],
		[3059960.05, 10646771.57],
	]], [[	/* 762:353 */
		[3087361.11, 10646499.12],
		[3087689.55, 10673978.29],
		[3115197.86, 10673592.81],
		[3114759.35, 10646116.95],
		[3087361.11, 10646499.12],
	]], [[	/* 762:354 */
		[3114759.35, 10646116.95],
		[3115197.86, 10673592.81],
		[3142702.37, 10673096.70],
		[3142153.82, 10645625.10],
		[3114759.35, 10646116.95],
	]], [[	/* 762:355 */
		[3142153.82, 10645625.10],
		[3142702.37, 10673096.70],
		[3170202.11, 10672490.02],
		[3169543.60, 10645023.63],
		[3142153.82, 10645625.10],
	]], [[	/* 762:356 */
		[3169543.60, 10645023.63],
		[3170202.11, 10672490.02],
		[3197696.13, 10671772.84],
		[3196927.72, 10644312.60],
		[3169543.60, 10645023.63],
	]], [[	/* 763:327 */
		[2374259.35, 10645280.33],
		[2371726.53, 10672621.57],
		[2399108.32, 10675113.26],
		[2401533.08, 10647750.72],
		[2374259.35, 10645280.33],
	]], [[	/* 763:328 */
		[2401533.08, 10647750.72],
		[2399108.32, 10675113.26],
		[2426511.07, 10677496.19],
		[2428827.51, 10650113.27],
		[2401533.08, 10647750.72],
	]], [[	/* 763:329 */
		[2428827.51, 10650113.27],
		[2426511.07, 10677496.19],
		[2453933.87, 10679770.12],
		[2456141.74, 10652367.74],
		[2428827.51, 10650113.27],
	]], [[	/* 763:330 */
		[2456141.74, 10652367.74],
		[2453933.87, 10679770.12],
		[2481375.79, 10681934.80],
		[2483474.85, 10654513.88],
		[2456141.74, 10652367.74],
	]], [[	/* 763:331 */
		[2483474.85, 10654513.88],
		[2481375.79, 10681934.80],
		[2508835.90, 10683990.00],
		[2510825.92, 10656551.46],
		[2483474.85, 10654513.88],
	]], [[	/* 763:332 */
		[2510825.92, 10656551.46],
		[2508835.90, 10683990.00],
		[2536313.27, 10685935.49],
		[2538194.04, 10658480.26],
		[2510825.92, 10656551.46],
	]], [[	/* 763:336 */
		[2620391.37, 10663611.98],
		[2618839.53, 10691111.64],
		[2646376.52, 10692616.30],
		[2647818.36, 10665103.71],
		[2620391.37, 10663611.98],
	]], [[	/* 763:337 */
		[2647818.36, 10665103.71],
		[2646376.52, 10692616.30],
		[2673926.05, 10694010.31],
		[2675257.74, 10666485.73],
		[2647818.36, 10665103.71],
	]], [[	/* 763:338 */
		[2675257.74, 10666485.73],
		[2673926.05, 10694010.31],
		[2701487.16, 10695293.53],
		[2702708.55, 10667757.90],
		[2675257.74, 10666485.73],
	]], [[	/* 763:342 */
		[2785120.17, 10670914.00],
		[2784230.43, 10698477.02],
		[2811828.30, 10699315.75],
		[2812607.29, 10671745.50],
		[2785120.17, 10670914.00],
	]], [[	/* 763:343 */
		[2812607.29, 10671745.50],
		[2811828.30, 10699315.75],
		[2839432.96, 10700043.10],
		[2840101.10, 10672466.58],
		[2812607.29, 10671745.50],
	]], [[	/* 763:344 */
		[2840101.10, 10672466.58],
		[2839432.96, 10700043.10],
		[2867043.44, 10700658.98],
		[2867600.67, 10673077.16],
		[2840101.10, 10672466.58],
	]], [[	/* 763:345 */
		[2867600.67, 10673077.16],
		[2867043.44, 10700658.98],
		[2894658.78, 10701163.34],
		[2895105.03, 10673577.18],
		[2867600.67, 10673077.16],
	]], [[	/* 763:346 */
		[2895105.03, 10673577.18],
		[2894658.78, 10701163.34],
		[2922278.01, 10701556.11],
		[2922613.23, 10673966.57],
		[2895105.03, 10673577.18],
	]], [[	/* 763:347 */
		[2922613.23, 10673966.57],
		[2922278.01, 10701556.11],
		[2949900.16, 10701837.26],
		[2950124.31, 10674245.29],
		[2922613.23, 10673966.57],
	]], [[	/* 763:348 */
		[2950124.31, 10674245.29],
		[2949900.16, 10701837.26],
		[2977524.27, 10702006.75],
		[2977637.33, 10674413.32],
		[2950124.31, 10674245.29],
	]], [[	/* 763:349 */
		[2977637.33, 10674413.32],
		[2977524.27, 10702006.75],
		[3005149.36, 10702064.56],
		[3005151.32, 10674470.63],
		[2977637.33, 10674413.32],
	]], [[	/* 763:350 */
		[3005151.32, 10674470.63],
		[3005149.36, 10702064.56],
		[3032774.46, 10702010.69],
		[3032665.32, 10674417.23],
		[3005151.32, 10674470.63],
	]], [[	/* 763:351 */
		[3032665.32, 10674417.23],
		[3032774.46, 10702010.69],
		[3060398.62, 10701845.14],
		[3060178.38, 10674253.11],
		[3032665.32, 10674417.23],
	]], [[	/* 763:352 */
		[3060178.38, 10674253.11],
		[3060398.62, 10701845.14],
		[3088020.85, 10701567.94],
		[3087689.55, 10673978.29],
		[3060178.38, 10674253.11],
	]], [[	/* 763:353 */
		[3087689.55, 10673978.29],
		[3088020.85, 10701567.94],
		[3115640.19, 10701179.10],
		[3115197.86, 10673592.81],
		[3087689.55, 10673978.29],
	]], [[	/* 763:354 */
		[3115197.86, 10673592.81],
		[3115640.19, 10701179.10],
		[3143255.67, 10700678.68],
		[3142702.37, 10673096.70],
		[3115197.86, 10673592.81],
	]], [[	/* 763:355 */
		[3142702.37, 10673096.70],
		[3143255.67, 10700678.68],
		[3170866.33, 10700066.73],
		[3170202.11, 10672490.02],
		[3142702.37, 10673096.70],
	]], [[	/* 763:356 */
		[3170202.11, 10672490.02],
		[3170866.33, 10700066.73],
		[3198471.20, 10699343.31],
		[3197696.13, 10671772.84],
		[3170202.11, 10672490.02],
	]], [[	/* 763:357 */
		[3197696.13, 10671772.84],
		[3198471.20, 10699343.31],
		[3226069.31, 10698508.51],
		[3225183.48, 10670945.23],
		[3197696.13, 10671772.84],
	]], [[	/* 764:326 */
		[2344366.64, 10670021.41],
		[2341703.23, 10697448.45],
		[2369171.83, 10700071.10],
		[2371726.53, 10672621.57],
		[2344366.64, 10670021.41],
	]], [[	/* 764:327 */
		[2371726.53, 10672621.57],
		[2369171.83, 10700071.10],
		[2396662.59, 10702584.35],
		[2399108.32, 10675113.26],
		[2371726.53, 10672621.57],
	]], [[	/* 764:328 */
		[2399108.32, 10675113.26],
		[2396662.59, 10702584.35],
		[2424174.59, 10704987.92],
		[2426511.07, 10677496.19],
		[2399108.32, 10675113.26],
	]], [[	/* 764:329 */
		[2426511.07, 10677496.19],
		[2424174.59, 10704987.92],
		[2451706.88, 10707281.56],
		[2453933.87, 10679770.12],
		[2426511.07, 10677496.19],
	]], [[	/* 764:330 */
		[2453933.87, 10679770.12],
		[2451706.88, 10707281.56],
		[2479258.54, 10709465.02],
		[2481375.79, 10681934.80],
		[2453933.87, 10679770.12],
	]], [[	/* 764:331 */
		[2481375.79, 10681934.80],
		[2479258.54, 10709465.02],
		[2506828.63, 10711538.05],
		[2508835.90, 10683990.00],
		[2481375.79, 10681934.80],
	]], [[	/* 764:336 */
		[2618839.53, 10691111.64],
		[2617274.20, 10718721.60],
		[2644922.14, 10720239.35],
		[2646376.52, 10692616.30],
		[2618839.53, 10691111.64],
	]], [[	/* 764:337 */
		[2646376.52, 10692616.30],
		[2644922.14, 10720239.35],
		[2672582.77, 10721645.50],
		[2673926.05, 10694010.31],
		[2646376.52, 10692616.30],
	]], [[	/* 764:342 */
		[2784230.43, 10698477.02],
		[2783332.93, 10726151.14],
		[2811042.53, 10726997.18],
		[2811828.30, 10699315.75],
		[2784230.43, 10698477.02],
	]], [[	/* 764:343 */
		[2811828.30, 10699315.75],
		[2811042.53, 10726997.18],
		[2838759.00, 10727730.87],
		[2839432.96, 10700043.10],
		[2811828.30, 10699315.75],
	]], [[	/* 764:344 */
		[2839432.96, 10700043.10],
		[2838759.00, 10727730.87],
		[2866481.36, 10728352.14],
		[2867043.44, 10700658.98],
		[2839432.96, 10700043.10],
	]], [[	/* 764:345 */
		[2867043.44, 10700658.98],
		[2866481.36, 10728352.14],
		[2894208.65, 10728860.90],
		[2894658.78, 10701163.34],
		[2867043.44, 10700658.98],
	]], [[	/* 764:346 */
		[2894658.78, 10701163.34],
		[2894208.65, 10728860.90],
		[2921939.87, 10729257.10],
		[2922278.01, 10701556.11],
		[2894658.78, 10701163.34],
	]], [[	/* 764:347 */
		[2922278.01, 10701556.11],
		[2921939.87, 10729257.10],
		[2949674.06, 10729540.70],
		[2949900.16, 10701837.26],
		[2922278.01, 10701556.11],
	]], [[	/* 764:348 */
		[2949900.16, 10701837.26],
		[2949674.06, 10729540.70],
		[2977410.22, 10729711.67],
		[2977524.27, 10702006.75],
		[2949900.16, 10701837.26],
	]], [[	/* 764:349 */
		[2977524.27, 10702006.75],
		[2977410.22, 10729711.67],
		[3005147.38, 10729769.98],
		[3005149.36, 10702064.56],
		[2977524.27, 10702006.75],
	]], [[	/* 764:350 */
		[3005149.36, 10702064.56],
		[3005147.38, 10729769.98],
		[3032884.56, 10729715.64],
		[3032774.46, 10702010.69],
		[3005149.36, 10702064.56],
	]], [[	/* 764:351 */
		[3032774.46, 10702010.69],
		[3032884.56, 10729715.64],
		[3060620.77, 10729548.65],
		[3060398.62, 10701845.14],
		[3032774.46, 10702010.69],
	]], [[	/* 764:352 */
		[3060398.62, 10701845.14],
		[3060620.77, 10729548.65],
		[3088355.03, 10729269.02],
		[3088020.85, 10701567.94],
		[3060398.62, 10701845.14],
	]], [[	/* 764:353 */
		[3088020.85, 10701567.94],
		[3088355.03, 10729269.02],
		[3116086.37, 10728876.79],
		[3115640.19, 10701179.10],
		[3088020.85, 10701567.94],
	]], [[	/* 764:354 */
		[3115640.19, 10701179.10],
		[3116086.37, 10728876.79],
		[3143813.80, 10728371.99],
		[3143255.67, 10700678.68],
		[3115640.19, 10701179.10],
	]], [[	/* 764:355 */
		[3143255.67, 10700678.68],
		[3143813.80, 10728371.99],
		[3171536.35, 10727754.70],
		[3170866.33, 10700066.73],
		[3143255.67, 10700678.68],
	]], [[	/* 764:356 */
		[3170866.33, 10700066.73],
		[3171536.35, 10727754.70],
		[3199253.03, 10727024.97],
		[3198471.20, 10699343.31],
		[3170866.33, 10700066.73],
	]], [[	/* 764:357 */
		[3198471.20, 10699343.31],
		[3199253.03, 10727024.97],
		[3226962.87, 10726182.89],
		[3226069.31, 10698508.51],
		[3198471.20, 10699343.31],
	]], [[	/* 765:325 */
		[2314257.72, 10694716.69],
		[2311461.89, 10722228.96],
		[2339016.74, 10724984.42],
		[2341703.23, 10697448.45],
		[2314257.72, 10694716.69],
	]], [[	/* 765:326 */
		[2341703.23, 10697448.45],
		[2339016.74, 10724984.42],
		[2366594.96, 10727629.83],
		[2369171.83, 10700071.10],
		[2341703.23, 10697448.45],
	]], [[	/* 765:327 */
		[2369171.83, 10700071.10],
		[2366594.96, 10727629.83],
		[2394195.63, 10730164.92],
		[2396662.59, 10702584.35],
		[2369171.83, 10700071.10],
	]], [[	/* 765:328 */
		[2396662.59, 10702584.35],
		[2394195.63, 10730164.92],
		[2421817.80, 10732589.39],
		[2424174.59, 10704987.92],
		[2396662.59, 10702584.35],
	]], [[	/* 765:329 */
		[2424174.59, 10704987.92],
		[2421817.80, 10732589.39],
		[2449460.53, 10734902.99],
		[2451706.88, 10707281.56],
		[2424174.59, 10704987.92],
	]], [[	/* 765:330 */
		[2451706.88, 10707281.56],
		[2449460.53, 10734902.99],
		[2477122.87, 10737105.46],
		[2479258.54, 10709465.02],
		[2451706.88, 10707281.56],
	]], [[	/* 765:331 */
		[2479258.54, 10709465.02],
		[2477122.87, 10737105.46],
		[2504803.87, 10739196.56],
		[2506828.63, 10711538.05],
		[2479258.54, 10709465.02],
	]], [[	/* 765:344 */
		[2838759.00, 10727730.87],
		[2838079.13, 10755530.89],
		[2865914.36, 10756157.60],
		[2866481.36, 10728352.14],
		[2838759.00, 10727730.87],
	]], [[	/* 765:345 */
		[2866481.36, 10728352.14],
		[2865914.36, 10756157.60],
		[2893754.57, 10756670.81],
		[2894208.65, 10728860.90],
		[2866481.36, 10728352.14],
	]], [[	/* 765:346 */
		[2894208.65, 10728860.90],
		[2893754.57, 10756670.81],
		[2921598.77, 10757070.49],
		[2921939.87, 10729257.10],
		[2894208.65, 10728860.90],
	]], [[	/* 765:347 */
		[2921939.87, 10729257.10],
		[2921598.77, 10757070.49],
		[2949445.97, 10757356.57],
		[2949674.06, 10729540.70],
		[2921939.87, 10729257.10],
	]], [[	/* 765:348 */
		[2949674.06, 10729540.70],
		[2949445.97, 10757356.57],
		[2977295.17, 10757529.04],
		[2977410.22, 10729711.67],
		[2949674.06, 10729540.70],
	]], [[	/* 765:349 */
		[2977410.22, 10729711.67],
		[2977295.17, 10757529.04],
		[3005145.39, 10757587.87],
		[3005147.38, 10729769.98],
		[2977410.22, 10729711.67],
	]], [[	/* 765:350 */
		[3005147.38, 10729769.98],
		[3005145.39, 10757587.87],
		[3032995.62, 10757533.05],
		[3032884.56, 10729715.64],
		[3005147.38, 10729769.98],
	]], [[	/* 765:351 */
		[3032884.56, 10729715.64],
		[3032995.62, 10757533.05],
		[3060844.87, 10757364.59],
		[3060620.77, 10729548.65],
		[3032884.56, 10729715.64],
	]], [[	/* 765:352 */
		[3060620.77, 10729548.65],
		[3060844.87, 10757364.59],
		[3088692.15, 10757082.51],
		[3088355.03, 10729269.02],
		[3060620.77, 10729548.65],
	]], [[	/* 765:353 */
		[3088355.03, 10729269.02],
		[3088692.15, 10757082.51],
		[3116536.46, 10756686.83],
		[3116086.37, 10728876.79],
		[3088355.03, 10729269.02],
	]], [[	/* 765:354 */
		[3116086.37, 10728876.79],
		[3116536.46, 10756686.83],
		[3144376.82, 10756177.62],
		[3143813.80, 10728371.99],
		[3116086.37, 10728876.79],
	]], [[	/* 765:355 */
		[3143813.80, 10728371.99],
		[3144376.82, 10756177.62],
		[3172212.23, 10755554.91],
		[3171536.35, 10727754.70],
		[3143813.80, 10728371.99],
	]], [[	/* 765:356 */
		[3171536.35, 10727754.70],
		[3172212.23, 10755554.91],
		[3200041.70, 10754818.79],
		[3199253.03, 10727024.97],
		[3171536.35, 10727754.70],
	]], [[	/* 765:357 */
		[3199253.03, 10727024.97],
		[3200041.70, 10754818.79],
		[3227864.24, 10753969.33],
		[3226962.87, 10726182.89],
		[3199253.03, 10727024.97],
	]], [[	/* 766:325 */
		[2311461.89, 10722228.96],
		[2308641.75, 10749850.77],
		[2336306.86, 10752630.23],
		[2339016.74, 10724984.42],
		[2311461.89, 10722228.96],
	]], [[	/* 766:326 */
		[2339016.74, 10724984.42],
		[2336306.86, 10752630.23],
		[2363995.65, 10755298.71],
		[2366594.96, 10727629.83],
		[2339016.74, 10724984.42],
	]], [[	/* 766:327 */
		[2366594.96, 10727629.83],
		[2363995.65, 10755298.71],
		[2391707.17, 10757855.91],
		[2394195.63, 10730164.92],
		[2366594.96, 10727629.83],
	]], [[	/* 766:328 */
		[2394195.63, 10730164.92],
		[2391707.17, 10757855.91],
		[2419440.46, 10760301.55],
		[2421817.80, 10732589.39],
		[2394195.63, 10730164.92],
	]], [[	/* 766:329 */
		[2421817.80, 10732589.39],
		[2419440.46, 10760301.55],
		[2447194.57, 10762635.36],
		[2449460.53, 10734902.99],
		[2421817.80, 10732589.39],
	]], [[	/* 766:330 */
		[2449460.53, 10734902.99],
		[2447194.57, 10762635.36],
		[2474968.55, 10764857.09],
		[2477122.87, 10737105.46],
		[2449460.53, 10734902.99],
	]], [[	/* 766:344 */
		[2838079.13, 10755530.89],
		[2837393.30, 10783444.13],
		[2865342.38, 10784076.35],
		[2865914.36, 10756157.60],
		[2838079.13, 10755530.89],
	]], [[	/* 766:345 */
		[2865914.36, 10756157.60],
		[2865342.38, 10784076.35],
		[2893296.51, 10784594.08],
		[2893754.57, 10756670.81],
		[2865914.36, 10756157.60],
	]], [[	/* 766:346 */
		[2893754.57, 10756670.81],
		[2893296.51, 10784594.08],
		[2921254.68, 10784997.27],
		[2921598.77, 10757070.49],
		[2893754.57, 10756670.81],
	]], [[	/* 766:347 */
		[2921598.77, 10757070.49],
		[2921254.68, 10784997.27],
		[2949215.88, 10785285.88],
		[2949445.97, 10757356.57],
		[2921598.77, 10757070.49],
	]], [[	/* 766:348 */
		[2949445.97, 10757356.57],
		[2949215.88, 10785285.88],
		[2977179.12, 10785459.86],
		[2977295.17, 10757529.04],
		[2949445.97, 10757356.57],
	]], [[	/* 766:349 */
		[2977295.17, 10757529.04],
		[2977179.12, 10785459.86],
		[3005143.38, 10785519.20],
		[3005145.39, 10757587.87],
		[2977295.17, 10757529.04],
	]], [[	/* 766:350 */
		[3005145.39, 10757587.87],
		[3005143.38, 10785519.20],
		[3033107.65, 10785463.90],
		[3032995.62, 10757533.05],
		[3005145.39, 10757587.87],
	]], [[	/* 766:351 */
		[3032995.62, 10757533.05],
		[3033107.65, 10785463.90],
		[3061070.94, 10785293.95],
		[3060844.87, 10757364.59],
		[3032995.62, 10757533.05],
	]], [[	/* 766:352 */
		[3060844.87, 10757364.59],
		[3061070.94, 10785293.95],
		[3089032.23, 10785009.39],
		[3088692.15, 10757082.51],
		[3060844.87, 10757364.59],
	]], [[	/* 766:353 */
		[3088692.15, 10757082.51],
		[3089032.23, 10785009.39],
		[3116990.51, 10784610.24],
		[3116536.46, 10756686.83],
		[3088692.15, 10757082.51],
	]], [[	/* 766:354 */
		[3116536.46, 10756686.83],
		[3116990.51, 10784610.24],
		[3144944.79, 10784096.54],
		[3144376.82, 10756177.62],
		[3116536.46, 10756686.83],
	]], [[	/* 766:355 */
		[3144376.82, 10756177.62],
		[3144944.79, 10784096.54],
		[3172894.05, 10783468.35],
		[3172212.23, 10755554.91],
		[3144376.82, 10756177.62],
	]], [[	/* 766:356 */
		[3172212.23, 10755554.91],
		[3172894.05, 10783468.35],
		[3200837.30, 10782725.75],
		[3200041.70, 10754818.79],
		[3172212.23, 10755554.91],
	]], [[	/* 766:357 */
		[3200041.70, 10754818.79],
		[3200837.30, 10782725.75],
		[3228773.53, 10781868.82],
		[3227864.24, 10753969.33],
		[3200041.70, 10754818.79],
	]], [[	/* 767:324 */
		[2281001.26, 10746960.64],
		[2278045.61, 10774667.69],
		[2305797.00, 10777583.07],
		[2308641.75, 10749850.77],
		[2281001.26, 10746960.64],
	]], [[	/* 767:325 */
		[2308641.75, 10749850.77],
		[2305797.00, 10777583.07],
		[2333573.31, 10780386.83],
		[2336306.86, 10752630.23],
		[2308641.75, 10749850.77],
	]], [[	/* 767:326 */
		[2336306.86, 10752630.23],
		[2333573.31, 10780386.83],
		[2361373.61, 10783078.66],
		[2363995.65, 10755298.71],
		[2336306.86, 10752630.23],
	]], [[	/* 767:327 */
		[2363995.65, 10755298.71],
		[2361373.61, 10783078.66],
		[2389196.92, 10785658.26],
		[2391707.17, 10757855.91],
		[2363995.65, 10755298.71],
	]], [[	/* 767:328 */
		[2391707.17, 10757855.91],
		[2389196.92, 10785658.26],
		[2417042.29, 10788125.33],
		[2419440.46, 10760301.55],
		[2391707.17, 10757855.91],
	]], [[	/* 767:329 */
		[2419440.46, 10760301.55],
		[2417042.29, 10788125.33],
		[2444908.75, 10790479.62],
		[2447194.57, 10762635.36],
		[2419440.46, 10760301.55],
	]], [[	/* 767:330 */
		[2447194.57, 10762635.36],
		[2444908.75, 10790479.62],
		[2472795.33, 10792720.85],
		[2474968.55, 10764857.09],
		[2447194.57, 10762635.36],
	]], [[	/* 767:344 */
		[2837393.30, 10783444.13],
		[2836701.42, 10811471.59],
		[2864765.35, 10812109.39],
		[2865342.38, 10784076.35],
		[2837393.30, 10783444.13],
	]], [[	/* 767:345 */
		[2865342.38, 10784076.35],
		[2864765.35, 10812109.39],
		[2892834.40, 10812631.70],
		[2893296.51, 10784594.08],
		[2865342.38, 10784076.35],
	]], [[	/* 767:346 */
		[2893296.51, 10784594.08],
		[2892834.40, 10812631.70],
		[2920907.55, 10813038.45],
		[2921254.68, 10784997.27],
		[2893296.51, 10784594.08],
	]], [[	/* 767:347 */
		[2921254.68, 10784997.27],
		[2920907.55, 10813038.45],
		[2948983.76, 10813329.60],
		[2949215.88, 10785285.88],
		[2921254.68, 10784997.27],
	]], [[	/* 767:348 */
		[2949215.88, 10785285.88],
		[2948983.76, 10813329.60],
		[2977062.04, 10813505.12],
		[2977179.12, 10785459.86],
		[2949215.88, 10785285.88],
	]], [[	/* 767:349 */
		[2977179.12, 10785459.86],
		[2977062.04, 10813505.12],
		[3005141.35, 10813564.99],
		[3005143.38, 10785519.20],
		[2977179.12, 10785459.86],
	]], [[	/* 767:350 */
		[3005143.38, 10785519.20],
		[3005141.35, 10813564.99],
		[3033220.68, 10813509.20],
		[3033107.65, 10785463.90],
		[3005143.38, 10785519.20],
	]], [[	/* 767:351 */
		[3033107.65, 10785463.90],
		[3033220.68, 10813509.20],
		[3061299.00, 10813337.75],
		[3061070.94, 10785293.95],
		[3033107.65, 10785463.90],
	]], [[	/* 767:352 */
		[3061070.94, 10785293.95],
		[3061299.00, 10813337.75],
		[3089375.31, 10813050.67],
		[3089032.23, 10785009.39],
		[3061070.94, 10785293.95],
	]], [[	/* 767:353 */
		[3089032.23, 10785009.39],
		[3089375.31, 10813050.67],
		[3117448.57, 10812647.99],
		[3116990.51, 10784610.24],
		[3089032.23, 10785009.39],
	]], [[	/* 767:354 */
		[3116990.51, 10784610.24],
		[3117448.57, 10812647.99],
		[3145517.77, 10812129.75],
		[3144944.79, 10784096.54],
		[3116990.51, 10784610.24],
	]], [[	/* 767:355 */
		[3144944.79, 10784096.54],
		[3145517.77, 10812129.75],
		[3173581.89, 10811496.01],
		[3172894.05, 10783468.35],
		[3144944.79, 10784096.54],
	]], [[	/* 767:356 */
		[3172894.05, 10783468.35],
		[3173581.89, 10811496.01],
		[3201639.92, 10810746.85],
		[3200837.30, 10782725.75],
		[3172894.05, 10783468.35],
	]], [[	/* 767:357 */
		[3200837.30, 10782725.75],
		[3201639.92, 10810746.85],
		[3229690.84, 10809882.35],
		[3228773.53, 10781868.82],
		[3200837.30, 10782725.75],
	]], [[	/* 768:324 */
		[2278045.61, 10774667.69],
		[2275064.08, 10802485.84],
		[2302927.31, 10805426.79],
		[2305797.00, 10777583.07],
		[2278045.61, 10774667.69],
	]], [[	/* 768:325 */
		[2305797.00, 10777583.07],
		[2302927.31, 10805426.79],
		[2330815.78, 10808255.17],
		[2333573.31, 10780386.83],
		[2305797.00, 10777583.07],
	]], [[	/* 768:326 */
		[2333573.31, 10780386.83],
		[2330815.78, 10808255.17],
		[2358728.54, 10810970.65],
		[2361373.61, 10783078.66],
		[2333573.31, 10780386.83],
	]], [[	/* 768:327 */
		[2361373.61, 10783078.66],
		[2358728.54, 10810970.65],
		[2386664.62, 10813572.93],
		[2389196.92, 10785658.26],
		[2361373.61, 10783078.66],
	]], [[	/* 768:328 */
		[2389196.92, 10785658.26],
		[2386664.62, 10813572.93],
		[2414623.04, 10816061.72],
		[2417042.29, 10788125.33],
		[2389196.92, 10785658.26],
	]], [[	/* 768:329 */
		[2417042.29, 10788125.33],
		[2414623.04, 10816061.72],
		[2442602.82, 10818436.74],
		[2444908.75, 10790479.62],
		[2417042.29, 10788125.33],
	]], [[	/* 768:344 */
		[2836701.42, 10811471.59],
		[2836003.40, 10839614.27],
		[2864183.21, 10840257.73],
		[2864765.35, 10812109.39],
		[2836701.42, 10811471.59],
	]], [[	/* 768:345 */
		[2864765.35, 10812109.39],
		[2864183.21, 10840257.73],
		[2892368.20, 10840784.67],
		[2892834.40, 10812631.70],
		[2864765.35, 10812109.39],
	]], [[	/* 768:346 */
		[2892834.40, 10812631.70],
		[2892368.20, 10840784.67],
		[2920557.34, 10841195.03],
		[2920907.55, 10813038.45],
		[2892834.40, 10812631.70],
	]], [[	/* 768:347 */
		[2920907.55, 10813038.45],
		[2920557.34, 10841195.03],
		[2948749.59, 10841488.77],
		[2948983.76, 10813329.60],
		[2920907.55, 10813038.45],
	]], [[	/* 768:348 */
		[2948983.76, 10813329.60],
		[2948749.59, 10841488.77],
		[2976943.92, 10841665.85],
		[2977062.04, 10813505.12],
		[2948983.76, 10813329.60],
	]], [[	/* 768:349 */
		[2977062.04, 10813505.12],
		[2976943.92, 10841665.85],
		[3005139.31, 10841726.24],
		[3005141.35, 10813564.99],
		[2977062.04, 10813505.12],
	]], [[	/* 768:350 */
		[3005141.35, 10813564.99],
		[3005139.31, 10841726.24],
		[3033334.71, 10841669.95],
		[3033220.68, 10813509.20],
		[3005141.35, 10813564.99],
	]], [[	/* 768:351 */
		[3033220.68, 10813509.20],
		[3033334.71, 10841669.95],
		[3061529.09, 10841496.98],
		[3061299.00, 10813337.75],
		[3033220.68, 10813509.20],
	]], [[	/* 768:352 */
		[3061299.00, 10813337.75],
		[3061529.09, 10841496.98],
		[3089721.43, 10841207.35],
		[3089375.31, 10813050.67],
		[3061299.00, 10813337.75],
	]], [[	/* 768:353 */
		[3089375.31, 10813050.67],
		[3089721.43, 10841207.35],
		[3117910.69, 10840801.10],
		[3117448.57, 10812647.99],
		[3089375.31, 10813050.67],
	]], [[	/* 768:354 */
		[3117448.57, 10812647.99],
		[3117910.69, 10840801.10],
		[3146095.83, 10840278.26],
		[3145517.77, 10812129.75],
		[3117448.57, 10812647.99],
	]], [[	/* 768:355 */
		[3145517.77, 10812129.75],
		[3146095.83, 10840278.26],
		[3174275.83, 10839638.90],
		[3173581.89, 10811496.01],
		[3145517.77, 10812129.75],
	]], [[	/* 768:356 */
		[3173581.89, 10811496.01],
		[3174275.83, 10839638.90],
		[3202449.65, 10838883.10],
		[3201639.92, 10810746.85],
		[3173581.89, 10811496.01],
	]], [[	/* 768:357 */
		[3201639.92, 10810746.85],
		[3202449.65, 10838883.10],
		[3230616.28, 10838010.93],
		[3229690.84, 10809882.35],
		[3201639.92, 10810746.85],
	]], [[	/* 769:326 */
		[2330815.78, 10808255.17],
		[2328033.96, 10836236.21],
		[2356060.16, 10838975.64],
		[2358728.54, 10810970.65],
		[2330815.78, 10808255.17],
	]], [[	/* 769:327 */
		[2358728.54, 10810970.65],
		[2356060.16, 10838975.64],
		[2384109.98, 10841600.90],
		[2386664.62, 10813572.93],
		[2358728.54, 10810970.65],
	]], [[	/* 769:328 */
		[2386664.62, 10813572.93],
		[2384109.98, 10841600.90],
		[2412182.42, 10844111.68],
		[2414623.04, 10816061.72],
		[2386664.62, 10813572.93],
	]], [[	/* 769:329 */
		[2414623.04, 10816061.72],
		[2412182.42, 10844111.68],
		[2440276.50, 10846507.71],
		[2442602.82, 10818436.74],
		[2414623.04, 10816061.72],
	]], [[	/* 769:345 */
		[2864183.21, 10840257.73],
		[2863595.90, 10868522.40],
		[2891897.85, 10869054.03],
		[2892368.20, 10840784.67],
		[2864183.21, 10840257.73],
	]], [[	/* 769:346 */
		[2892368.20, 10840784.67],
		[2891897.85, 10869054.03],
		[2920204.01, 10869468.05],
		[2920557.34, 10841195.03],
		[2892368.20, 10840784.67],
	]], [[	/* 769:347 */
		[2920557.34, 10841195.03],
		[2920204.01, 10869468.05],
		[2948513.33, 10869764.40],
		[2948749.59, 10841488.77],
		[2920557.34, 10841195.03],
	]], [[	/* 769:348 */
		[2948749.59, 10841488.77],
		[2948513.33, 10869764.40],
		[2976824.76, 10869943.06],
		[2976943.92, 10841665.85],
		[2948749.59, 10841488.77],
	]], [[	/* 769:349 */
		[2976943.92, 10841665.85],
		[2976824.76, 10869943.06],
		[3005137.25, 10870003.99],
		[3005139.31, 10841726.24],
		[2976943.92, 10841665.85],
	]], [[	/* 769:350 */
		[3005139.31, 10841726.24],
		[3005137.25, 10870003.99],
		[3033449.75, 10869947.20],
		[3033334.71, 10841669.95],
		[3005139.31, 10841726.24],
	]], [[	/* 769:351 */
		[3033334.71, 10841669.95],
		[3033449.75, 10869947.20],
		[3061761.23, 10869772.68],
		[3061529.09, 10841496.98],
		[3033334.71, 10841669.95],
	]], [[	/* 769:352 */
		[3061529.09, 10841496.98],
		[3061761.23, 10869772.68],
		[3090070.63, 10869480.47],
		[3089721.43, 10841207.35],
		[3061529.09, 10841496.98],
	]], [[	/* 769:353 */
		[3089721.43, 10841207.35],
		[3090070.63, 10869480.47],
		[3118376.92, 10869070.60],
		[3117910.69, 10840801.10],
		[3089721.43, 10841207.35],
	]], [[	/* 769:354 */
		[3117910.69, 10840801.10],
		[3118376.92, 10869070.60],
		[3146679.03, 10868543.10],
		[3146095.83, 10840278.26],
		[3117910.69, 10840801.10],
	]], [[	/* 769:355 */
		[3146095.83, 10840278.26],
		[3146679.03, 10868543.10],
		[3174975.93, 10867898.05],
		[3174275.83, 10839638.90],
		[3146095.83, 10840278.26],
	]], [[	/* 769:356 */
		[3174275.83, 10839638.90],
		[3174975.93, 10867898.05],
		[3203266.58, 10867135.51],
		[3202449.65, 10838883.10],
		[3174275.83, 10839638.90],
	]], [[	/* 769:357 */
		[3202449.65, 10838883.10],
		[3203266.58, 10867135.51],
		[3231549.94, 10866255.58],
		[3230616.28, 10838010.93],
		[3202449.65, 10838883.10],
	]], [[	/* 769:358 */
		[3230616.28, 10838010.93],
		[3231549.94, 10866255.58],
		[3259824.95, 10865258.35],
		[3258774.67, 10837022.51],
		[3230616.28, 10838010.93],
	]], [[	/* 770:327 */
		[2356060.16, 10838975.64],
		[2353368.17, 10867094.62],
		[2381532.71, 10869743.15],
		[2384109.98, 10841600.90],
		[2356060.16, 10838975.64],
	]], [[	/* 770:328 */
		[2384109.98, 10841600.90],
		[2381532.71, 10869743.15],
		[2409720.17, 10872276.21],
		[2412182.42, 10844111.68],
		[2384109.98, 10841600.90],
	]], [[	/* 770:345 */
		[2863595.90, 10868522.40],
		[2863003.33, 10896904.43],
		[2891423.31, 10897440.81],
		[2891897.85, 10869054.03],
		[2863595.90, 10868522.40],
	]], [[	/* 770:346 */
		[2891897.85, 10869054.03],
		[2891423.31, 10897440.81],
		[2919847.53, 10897858.53],
		[2920204.01, 10869468.05],
		[2891897.85, 10869054.03],
	]], [[	/* 770:347 */
		[2920204.01, 10869468.05],
		[2919847.53, 10897858.53],
		[2948274.96, 10898157.54],
		[2948513.33, 10869764.40],
		[2920204.01, 10869468.05],
	]], [[	/* 770:348 */
		[2948513.33, 10869764.40],
		[2948274.96, 10898157.54],
		[2976704.53, 10898337.79],
		[2976824.76, 10869943.06],
		[2948513.33, 10869764.40],
	]], [[	/* 770:349 */
		[2976824.76, 10869943.06],
		[2976704.53, 10898337.79],
		[3005135.17, 10898399.27],
		[3005137.25, 10870003.99],
		[2976824.76, 10869943.06],
	]], [[	/* 770:350 */
		[3005137.25, 10870003.99],
		[3005135.17, 10898399.27],
		[3033565.83, 10898341.97],
		[3033449.75, 10869947.20],
		[3005137.25, 10870003.99],
	]], [[	/* 770:351 */
		[3033449.75, 10869947.20],
		[3033565.83, 10898341.97],
		[3061995.45, 10898165.89],
		[3061761.23, 10869772.68],
		[3033449.75, 10869947.20],
	]], [[	/* 770:352 */
		[3061761.23, 10869772.68],
		[3061995.45, 10898165.89],
		[3090422.96, 10897871.06],
		[3090070.63, 10869480.47],
		[3061761.23, 10869772.68],
	]], [[	/* 770:353 */
		[3090070.63, 10869480.47],
		[3090422.96, 10897871.06],
		[3118847.31, 10897457.52],
		[3118376.92, 10869070.60],
		[3090070.63, 10869480.47],
	]], [[	/* 770:354 */
		[3118376.92, 10869070.60],
		[3118847.31, 10897457.52],
		[3147267.44, 10896925.30],
		[3146679.03, 10868543.10],
		[3118376.92, 10869070.60],
	]], [[	/* 770:355 */
		[3146679.03, 10868543.10],
		[3147267.44, 10896925.30],
		[3175682.29, 10896274.48],
		[3174975.93, 10867898.05],
		[3146679.03, 10868543.10],
	]], [[	/* 770:356 */
		[3174975.93, 10867898.05],
		[3175682.29, 10896274.48],
		[3204090.81, 10895505.12],
		[3203266.58, 10867135.51],
		[3174975.93, 10867898.05],
	]], [[	/* 770:357 */
		[3203266.58, 10867135.51],
		[3204090.81, 10895505.12],
		[3232491.93, 10894617.32],
		[3231549.94, 10866255.58],
		[3203266.58, 10867135.51],
	]], [[	/* 770:358 */
		[3231549.94, 10866255.58],
		[3232491.93, 10894617.32],
		[3260884.61, 10893611.18],
		[3259824.95, 10865258.35],
		[3231549.94, 10866255.58],
	]], [[	/* 770:359 */
		[3259824.95, 10865258.35],
		[3260884.61, 10893611.18],
		[3289267.80, 10892486.82],
		[3288090.60, 10864143.95],
		[3259824.95, 10865258.35],
	]], [[	/* 771:345 */
		[2863003.33, 10896904.43],
		[2862405.46, 10925404.86],
		[2890944.50, 10925946.07],
		[2891423.31, 10897440.81],
		[2863003.33, 10896904.43],
	]], [[	/* 771:346 */
		[2891423.31, 10897440.81],
		[2890944.50, 10925946.07],
		[2919487.86, 10926367.54],
		[2919847.53, 10897858.53],
		[2891423.31, 10897440.81],
	]], [[	/* 771:347 */
		[2919847.53, 10897858.53],
		[2919487.86, 10926367.54],
		[2948034.45, 10926669.23],
		[2948274.96, 10898157.54],
		[2919847.53, 10897858.53],
	]], [[	/* 771:348 */
		[2948274.96, 10898157.54],
		[2948034.45, 10926669.23],
		[2976583.22, 10926851.10],
		[2976704.53, 10898337.79],
		[2948274.96, 10898157.54],
	]], [[	/* 771:349 */
		[2976704.53, 10898337.79],
		[2976583.22, 10926851.10],
		[3005133.07, 10926913.13],
		[3005135.17, 10898399.27],
		[2976704.53, 10898337.79],
	]], [[	/* 771:350 */
		[3005135.17, 10898399.27],
		[3005133.07, 10926913.13],
		[3033682.95, 10926855.31],
		[3033565.83, 10898341.97],
		[3005135.17, 10898399.27],
	]], [[	/* 771:351 */
		[3033565.83, 10898341.97],
		[3033682.95, 10926855.31],
		[3062231.76, 10926677.65],
		[3061995.45, 10898165.89],
		[3033565.83, 10898341.97],
	]], [[	/* 771:352 */
		[3061995.45, 10898165.89],
		[3062231.76, 10926677.65],
		[3090778.45, 10926380.18],
		[3090422.96, 10897871.06],
		[3061995.45, 10898165.89],
	]], [[	/* 771:353 */
		[3090422.96, 10897871.06],
		[3090778.45, 10926380.18],
		[3119321.93, 10925962.91],
		[3118847.31, 10897457.52],
		[3090422.96, 10897871.06],
	]], [[	/* 771:354 */
		[3118847.31, 10897457.52],
		[3119321.93, 10925962.91],
		[3147861.14, 10925425.92],
		[3147267.44, 10896925.30],
		[3118847.31, 10897457.52],
	]], [[	/* 771:355 */
		[3147267.44, 10896925.30],
		[3147861.14, 10925425.92],
		[3176394.99, 10924769.25],
		[3175682.29, 10896274.48],
		[3147267.44, 10896925.30],
	]], [[	/* 771:356 */
		[3175682.29, 10896274.48],
		[3176394.99, 10924769.25],
		[3204922.43, 10923992.98],
		[3204090.81, 10895505.12],
		[3175682.29, 10896274.48],
	]], [[	/* 771:357 */
		[3204090.81, 10895505.12],
		[3204922.43, 10923992.98],
		[3233442.38, 10923097.21],
		[3232491.93, 10894617.32],
		[3204090.81, 10895505.12],
	]], [[	/* 771:358 */
		[3232491.93, 10894617.32],
		[3233442.38, 10923097.21],
		[3261953.77, 10922082.04],
		[3260884.61, 10893611.18],
		[3232491.93, 10894617.32],
	]], [[	/* 771:359 */
		[3260884.61, 10893611.18],
		[3261953.77, 10922082.04],
		[3290455.54, 10920947.59],
		[3289267.80, 10892486.82],
		[3260884.61, 10893611.18],
	]], [[	/* 772:345 */
		[2862405.46, 10925404.86],
		[2861802.19, 10954024.78],
		[2890461.38, 10954570.86],
		[2890944.50, 10925946.07],
		[2862405.46, 10925404.86],
	]], [[	/* 772:346 */
		[2890944.50, 10925946.07],
		[2890461.38, 10954570.86],
		[2919124.94, 10954996.14],
		[2919487.86, 10926367.54],
		[2890944.50, 10925946.07],
	]], [[	/* 772:347 */
		[2919487.86, 10926367.54],
		[2919124.94, 10954996.14],
		[2947791.78, 10955300.55],
		[2948034.45, 10926669.23],
		[2919487.86, 10926367.54],
	]], [[	/* 772:348 */
		[2948034.45, 10926669.23],
		[2947791.78, 10955300.55],
		[2976460.82, 10955484.06],
		[2976583.22, 10926851.10],
		[2948034.45, 10926669.23],
	]], [[	/* 772:349 */
		[2976583.22, 10926851.10],
		[2976460.82, 10955484.06],
		[3005130.96, 10955546.65],
		[3005133.07, 10926913.13],
		[2976583.22, 10926851.10],
	]], [[	/* 772:350 */
		[3005133.07, 10926913.13],
		[3005130.96, 10955546.65],
		[3033801.12, 10955488.31],
		[3033682.95, 10926855.31],
		[3005133.07, 10926913.13],
	]], [[	/* 772:351 */
		[3033682.95, 10926855.31],
		[3033801.12, 10955488.31],
		[3062470.21, 10955309.04],
		[3062231.76, 10926677.65],
		[3033682.95, 10926855.31],
	]], [[	/* 772:352 */
		[3062231.76, 10926677.65],
		[3062470.21, 10955309.04],
		[3091137.14, 10955008.88],
		[3090778.45, 10926380.18],
		[3062231.76, 10926677.65],
	]], [[	/* 772:353 */
		[3090778.45, 10926380.18],
		[3091137.14, 10955008.88],
		[3119800.83, 10954587.85],
		[3119321.93, 10925962.91],
		[3090778.45, 10926380.18],
	]], [[	/* 772:354 */
		[3119321.93, 10925962.91],
		[3119800.83, 10954587.85],
		[3148460.18, 10954046.01],
		[3147861.14, 10925425.92],
		[3119321.93, 10925962.91],
	]], [[	/* 772:355 */
		[3147861.14, 10925425.92],
		[3148460.18, 10954046.01],
		[3177114.11, 10953383.41],
		[3176394.99, 10924769.25],
		[3147861.14, 10925425.92],
	]], [[	/* 772:356 */
		[3176394.99, 10924769.25],
		[3177114.11, 10953383.41],
		[3205761.54, 10952600.15],
		[3204922.43, 10923992.98],
		[3176394.99, 10924769.25],
	]], [[	/* 772:357 */
		[3204922.43, 10923992.98],
		[3205761.54, 10952600.15],
		[3234401.38, 10951696.30],
		[3233442.38, 10923097.21],
		[3204922.43, 10923992.98],
	]], [[	/* 772:358 */
		[3233442.38, 10923097.21],
		[3234401.38, 10951696.30],
		[3263032.55, 10950671.98],
		[3261953.77, 10922082.04],
		[3233442.38, 10923097.21],
	]], [[	/* 773:345 */
		[2861802.19, 10954024.78],
		[2861193.47, 10982765.24],
		[2889973.89, 10983316.28],
		[2890461.38, 10954570.86],
		[2861802.19, 10954024.78],
	]], [[	/* 773:346 */
		[2890461.38, 10954570.86],
		[2889973.89, 10983316.28],
		[2918758.74, 10983745.40],
		[2919124.94, 10954996.14],
		[2890461.38, 10954570.86],
	]], [[	/* 773:347 */
		[2919124.94, 10954996.14],
		[2918758.74, 10983745.40],
		[2947546.91, 10984052.57],
		[2947791.78, 10955300.55],
		[2919124.94, 10954996.14],
	]], [[	/* 773:348 */
		[2947791.78, 10955300.55],
		[2947546.91, 10984052.57],
		[2976337.31, 10984237.74],
		[2976460.82, 10955484.06],
		[2947791.78, 10955300.55],
	]], [[	/* 773:349 */
		[2976460.82, 10955484.06],
		[2976337.31, 10984237.74],
		[3005128.83, 10984300.90],
		[3005130.96, 10955546.65],
		[2976460.82, 10955484.06],
	]], [[	/* 773:350 */
		[3005130.96, 10955546.65],
		[3005128.83, 10984300.90],
		[3033920.36, 10984242.03],
		[3033801.12, 10955488.31],
		[3005130.96, 10955546.65],
	]], [[	/* 773:351 */
		[3033801.12, 10955488.31],
		[3033920.36, 10984242.03],
		[3062710.82, 10984061.14],
		[3062470.21, 10955309.04],
		[3033801.12, 10955488.31],
	]], [[	/* 773:352 */
		[3062470.21, 10955309.04],
		[3062710.82, 10984061.14],
		[3091499.08, 10983758.25],
		[3091137.14, 10955008.88],
		[3062470.21, 10955309.04],
	]], [[	/* 773:353 */
		[3091137.14, 10955008.88],
		[3091499.08, 10983758.25],
		[3120284.06, 10983333.41],
		[3119800.83, 10954587.85],
		[3091137.14, 10955008.88],
	]], [[	/* 773:354 */
		[3119800.83, 10954587.85],
		[3120284.06, 10983333.41],
		[3149064.64, 10982786.66],
		[3148460.18, 10954046.01],
		[3119800.83, 10954587.85],
	]], [[	/* 773:355 */
		[3148460.18, 10954046.01],
		[3149064.64, 10982786.66],
		[3177839.73, 10982118.06],
		[3177114.11, 10953383.41],
		[3148460.18, 10954046.01],
	]], [[	/* 773:356 */
		[3177114.11, 10953383.41],
		[3177839.73, 10982118.06],
		[3206608.23, 10981327.70],
		[3205761.54, 10952600.15],
		[3177114.11, 10953383.41],
	]], [[	/* 773:357 */
		[3205761.54, 10952600.15],
		[3206608.23, 10981327.70],
		[3235369.04, 10980415.67],
		[3234401.38, 10951696.30],
		[3205761.54, 10952600.15],
	]], [[	/* 773:358 */
		[3234401.38, 10951696.30],
		[3235369.04, 10980415.67],
		[3264121.07, 10979382.08],
		[3263032.55, 10950671.98],
		[3234401.38, 10951696.30],
	]], [[	/* 774:346 */
		[2889973.89, 10983316.28],
		[2889481.98, 11012183.40],
		[2918389.21, 11012616.43],
		[2918758.74, 10983745.40],
		[2889973.89, 10983316.28],
	]], [[	/* 774:347 */
		[2918758.74, 10983745.40],
		[2918389.21, 11012616.43],
		[2947299.82, 11012926.39],
		[2947546.91, 10984052.57],
		[2918758.74, 10983745.40],
	]], [[	/* 774:348 */
		[2947546.91, 10984052.57],
		[2947299.82, 11012926.39],
		[2976212.68, 11013113.25],
		[2976337.31, 10984237.74],
		[2947546.91, 10984052.57],
	]], [[	/* 774:349 */
		[2976337.31, 10984237.74],
		[2976212.68, 11013113.25],
		[3005126.68, 11013176.98],
		[3005128.83, 10984300.90],
		[2976337.31, 10984237.74],
	]], [[	/* 774:350 */
		[3005128.83, 10984300.90],
		[3005126.68, 11013176.98],
		[3034040.69, 11013117.57],
		[3033920.36, 10984242.03],
		[3005128.83, 10984300.90],
	]], [[	/* 774:351 */
		[3033920.36, 10984242.03],
		[3034040.69, 11013117.57],
		[3062953.61, 11012935.03],
		[3062710.82, 10984061.14],
		[3033920.36, 10984242.03],
	]], [[	/* 774:352 */
		[3062710.82, 10984061.14],
		[3062953.61, 11012935.03],
		[3091864.31, 11012629.39],
		[3091499.08, 10983758.25],
		[3062710.82, 10984061.14],
	]], [[	/* 774:353 */
		[3091499.08, 10983758.25],
		[3091864.31, 11012629.39],
		[3120771.68, 11012200.68],
		[3120284.06, 10983333.41],
		[3091499.08, 10983758.25],
	]], [[	/* 774:354 */
		[3120284.06, 10983333.41],
		[3120771.68, 11012200.68],
		[3149674.59, 11011648.96],
		[3149064.64, 10982786.66],
		[3120284.06, 10983333.41],
	]], [[	/* 774:355 */
		[3149064.64, 10982786.66],
		[3149674.59, 11011648.96],
		[3178571.94, 11010974.28],
		[3177839.73, 10982118.06],
		[3149064.64, 10982786.66],
	]], [[	/* 774:356 */
		[3177839.73, 10982118.06],
		[3178571.94, 11010974.28],
		[3207462.62, 11010176.73],
		[3206608.23, 10981327.70],
		[3177839.73, 10982118.06],
	]], [[	/* 774:357 */
		[3206608.23, 10981327.70],
		[3207462.62, 11010176.73],
		[3236345.50, 11009256.41],
		[3235369.04, 10980415.67],
		[3206608.23, 10981327.70],
	]], [[	/* 775:347 */
		[2918389.21, 11012616.43],
		[2918016.31, 11041610.33],
		[2947050.47, 11041923.12],
		[2947299.82, 11012926.39],
		[2918389.21, 11012616.43],
	]], [[	/* 775:348 */
		[2947299.82, 11012926.39],
		[2947050.47, 11041923.12],
		[2976086.92, 11042111.69],
		[2976212.68, 11013113.25],
		[2947299.82, 11012926.39],
	]], [[	/* 775:349 */
		[2976212.68, 11013113.25],
		[2976086.92, 11042111.69],
		[3005124.51, 11042176.00],
		[3005126.68, 11013176.98],
		[2976212.68, 11013113.25],
	]], [[	/* 775:350 */
		[3005126.68, 11013176.98],
		[3005124.51, 11042176.00],
		[3034162.12, 11042116.04],
		[3034040.69, 11013117.57],
		[3005126.68, 11013176.98],
	]], [[	/* 775:351 */
		[3034040.69, 11013117.57],
		[3034162.12, 11042116.04],
		[3063198.62, 11041931.84],
		[3062953.61, 11012935.03],
		[3034040.69, 11013117.57],
	]], [[	/* 775:352 */
		[3062953.61, 11012935.03],
		[3063198.62, 11041931.84],
		[3092232.87, 11041623.41],
		[3091864.31, 11012629.39],
		[3062953.61, 11012935.03],
	]], [[	/* 775:353 */
		[3091864.31, 11012629.39],
		[3092232.87, 11041623.41],
		[3121263.75, 11041190.78],
		[3120771.68, 11012200.68],
		[3091864.31, 11012629.39],
	]], [[	/* 775:354 */
		[3120771.68, 11012200.68],
		[3121263.75, 11041190.78],
		[3150290.11, 11040634.01],
		[3149674.59, 11011648.96],
		[3120771.68, 11012200.68],
	]], [[	/* 775:355 */
		[3149674.59, 11011648.96],
		[3150290.11, 11040634.01],
		[3179310.84, 11039953.17],
		[3178571.94, 11010974.28],
		[3149674.59, 11011648.96],
	]], [[	/* 776:347 */
		[2918016.31, 11041610.33],
		[2917640.00, 11070728.23],
		[2946798.84, 11071043.89],
		[2947050.47, 11041923.12],
		[2918016.31, 11041610.33],
	]], [[	/* 776:348 */
		[2947050.47, 11041923.12],
		[2946798.84, 11071043.89],
		[2975960.00, 11071234.18],
		[2976086.92, 11042111.69],
		[2947050.47, 11041923.12],
	]], [[	/* 776:349 */
		[2976086.92, 11042111.69],
		[2975960.00, 11071234.18],
		[3005122.32, 11071299.08],
		[3005124.51, 11042176.00],
		[2976086.92, 11042111.69],
	]], [[	/* 776:350 */
		[3005124.51, 11042176.00],
		[3005122.32, 11071299.08],
		[3034284.66, 11071238.58],
		[3034162.12, 11042116.04],
		[3005124.51, 11042176.00],
	]], [[	/* 776:351 */
		[3034162.12, 11042116.04],
		[3034284.66, 11071238.58],
		[3063445.88, 11071052.68],
		[3063198.62, 11041931.84],
		[3034162.12, 11042116.04],
	]], [[	/* 776:352 */
		[3063198.62, 11041931.84],
		[3063445.88, 11071052.68],
		[3092604.81, 11070741.42],
		[3092232.87, 11041623.41],
		[3063198.62, 11041931.84],
	]], [[	/* 776:353 */
		[3092232.87, 11041623.41],
		[3092604.81, 11070741.42],
		[3121760.33, 11070304.82],
		[3121263.75, 11041190.78],
		[3092232.87, 11041623.41],
	]], [[	/* 776:354 */
		[3121263.75, 11041190.78],
		[3121760.33, 11070304.82],
		[3150911.27, 11069742.94],
		[3150290.11, 11040634.01],
		[3121263.75, 11041190.78],
	]], [[	/* 777:351 */
		[3034284.66, 11071238.58],
		[3034408.34, 11100486.31],
		[3063695.41, 11100298.70],
		[3063445.88, 11071052.68],
		[3034284.66, 11071238.58],
	]], [[	/* 777:352 */
		[3063445.88, 11071052.68],
		[3063695.41, 11100298.70],
		[3092980.18, 11099984.57],
		[3092604.81, 11070741.42],
		[3063445.88, 11071052.68],
	]], [[	/* 777:353 */
		[3092604.81, 11070741.42],
		[3092980.18, 11099984.57],
		[3122261.48, 11099543.94],
		[3121760.33, 11070304.82],
		[3092604.81, 11070741.42],
	]], 
];
